export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A type representing a clickstream payload as a JSON string */
  AnalyticsPayload: any;
  /** Built-in java.math.BigDecimal */
  BigDecimal: any;
  /** A type representing a Locale such as en_US or fr_FR */
  Locale: any;
  /** A type representing a full protocol, host and path */
  URL: any;
  /** A type representing a formatted java.util.UUID */
  UUID: any;
}





/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  /** Action to pop auth window */
  AUTHWINDOW = 'AUTHWINDOW',
  /** Action to close a dropdown option */
  CLOSE = 'CLOSE',
  /** Action to copy contents to clipboard */
  COPY = 'COPY',
  /** Action to open the date picker */
  DATEPICKER = 'DATEPICKER',
  /** Action to open an external link off */
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  /** Action to display free lx message */
  FREE_LX = 'FREE_LX',
  /** Action to open a link off */
  OPEN = 'OPEN',
  /** Action to display term and conditions */
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS'
}


export enum ActionType {
  OPENPRICECHANGEALERT = 'OpenPriceChangeAlert',
  DOWNLOADDPREPORT = 'DownloadDPReport'
}

/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN',
  USED = 'USED'
}


/** Provide criteria needed to perform an activities search */
export interface ActivitiySearchCriteriaInput {
  primary: PrimaryActivitySearchCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}












export enum ActivityAvailabilityPriceTextTheme {
  POSITIVE = 'POSITIVE'
}


export enum ActivityBadgeType {
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}


/** Activity banner type */
export enum ActivityBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}




export enum ActivityCancellationType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CANCELLATION = 'NO_CANCELLATION'
}















export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = 'ADULTS_ONLY_SHOWS',
  ADVENTURES = 'ADVENTURES',
  ADVENTURE_OUTDOOR = 'ADVENTURE_OUTDOOR',
  AIRBOAT_TOURS = 'AIRBOAT_TOURS',
  AIRPLANE_RIDES = 'AIRPLANE_RIDES',
  AIRPLANE_TOURS = 'AIRPLANE_TOURS',
  AIRPORT_GROUND_TRANSPORTATION = 'AIRPORT_GROUND_TRANSPORTATION',
  AIRPORT_LOUNGES = 'AIRPORT_LOUNGES',
  AIRPORT_TO_AIRPORT_TRANSFERS = 'AIRPORT_TO_AIRPORT_TRANSFERS',
  AIR_BALLOON_HELICOPTER_TOURS = 'AIR_BALLOON_HELICOPTER_TOURS',
  AIR_HELICOPTER_BALLOON_TOURS = 'AIR_HELICOPTER_BALLOON_TOURS',
  AMUSEMENT_THEME_PARKS = 'AMUSEMENT_THEME_PARKS',
  ARCHITECTURE_TOURS = 'ARCHITECTURE_TOURS',
  ART_CLASSES = 'ART_CLASSES',
  ART_CULTURE_HISTORY_TOURS = 'ART_CULTURE_HISTORY_TOURS',
  ART_MUSIC_LITERARYTOURS = 'ART_MUSIC_LITERARYTOURS',
  ATTRACTIONS = 'ATTRACTIONS',
  ATTRACTION_TICKETS = 'ATTRACTION_TICKETS',
  BALLOON_RIDES = 'BALLOON_RIDES',
  BALLOON_TOURS = 'BALLOON_TOURS',
  BAR_PUB_TOURS = 'BAR_PUB_TOURS',
  BEER_BREWERY_TOURS = 'BEER_BREWERY_TOURS',
  BEYOND_THE_CITY = 'BEYOND_THE_CITY',
  BIKE_MOUNTAIN_BIKE_TOURS = 'BIKE_MOUNTAIN_BIKE_TOURS',
  BIKE_RENTALS = 'BIKE_RENTALS',
  BOAT_RENTAL = 'BOAT_RENTAL',
  BOAT_TOURS = 'BOAT_TOURS',
  BOAT_TOURS_CRUISES = 'BOAT_TOURS_CRUISES',
  BRUNCHC_RUISES = 'BRUNCHC_RUISES',
  BUNGEE_JUMPING_SKYDIVING = 'BUNGEE_JUMPING_SKYDIVING',
  BUS_MINIVAN_TOURS = 'BUS_MINIVAN_TOURS',
  CABARET = 'CABARET',
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  CASTLE_PALACE_TOURS = 'CASTLE_PALACE_TOURS',
  CHAUFFER_SERVICES = 'CHAUFFER_SERVICES',
  CHRISTMAS = 'CHRISTMAS',
  CIRQUE = 'CIRQUE',
  CIRQUE_DU_SOLEIL = 'CIRQUE_DU_SOLEIL',
  CIRQUE_DU_SOLEILSHOWS = 'CIRQUE_DU_SOLEILSHOWS',
  CITY_AND_ATTRACTION_TRANSFERS = 'CITY_AND_ATTRACTION_TRANSFERS',
  CITY_ATTRACTION_TRANSFERS = 'CITY_ATTRACTION_TRANSFERS',
  CITY_TOURS = 'CITY_TOURS',
  CITY_TOURS_PACKAGES = 'CITY_TOURS_PACKAGES',
  CLASSES_WORKSHOPS = 'CLASSES_WORKSHOPS',
  CLUB_AND_PARTY_BUS_TOURS = 'CLUB_AND_PARTY_BUS_TOURS',
  CLUB_PARTY_BUS_TOURS = 'CLUB_PARTY_BUS_TOURS',
  COFFEE_TEA_TOURS = 'COFFEE_TEA_TOURS',
  COMEDY_SHOWS = 'COMEDY_SHOWS',
  CONCERTS_SPECIAL_EVENTS = 'CONCERTS_SPECIAL_EVENTS',
  COOKING_CLASSES = 'COOKING_CLASSES',
  CRUISES_BOAT_TOURS = 'CRUISES_BOAT_TOURS',
  CRUISES_WATER_TOURS = 'CRUISES_WATER_TOURS',
  CULTURAL_HERITAGE_EXPERIENCES = 'CULTURAL_HERITAGE_EXPERIENCES',
  CUSTOM_PRIVATE_TOURS = 'CUSTOM_PRIVATE_TOURS',
  DANCE_CLASSES = 'DANCE_CLASSES',
  DAY_OF_THE_DEAD = 'DAY_OF_THE_DEAD',
  DAY_SPAS = 'DAY_SPAS',
  DAY_TRIPS = 'DAY_TRIPS',
  DAY_TRIPS_EXCURSIONS = 'DAY_TRIPS_EXCURSIONS',
  DINING_EXPERIENCES = 'DINING_EXPERIENCES',
  DINNER_CRUISES = 'DINNER_CRUISES',
  DINNER_THEATER = 'DINNER_THEATER',
  DISNEY = 'DISNEY',
  DISNEY_PARKS = 'DISNEY_PARKS',
  DOLPHIN_WHALE_WATCHING = 'DOLPHIN_WHALE_WATCHING',
  DOSE_OF_CULTURE = 'DOSE_OF_CULTURE',
  DUCK_TOURS = 'DUCK_TOURS',
  EASTER = 'EASTER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FASHION_SHOWS_TOURS = 'FASHION_SHOWS_TOURS',
  FISHING_CHARTERS_TOURS = 'FISHING_CHARTERS_TOURS',
  FISHING_TOURS_AND_CHARTERS = 'FISHING_TOURS_AND_CHARTERS',
  FOOD_DRINK = 'FOOD_DRINK',
  FOOD_DRINK_NIGHTLIFE = 'FOOD_DRINK_NIGHTLIFE',
  FOOD_TOURS = 'FOOD_TOURS',
  FUN_FOR_FOODIES = 'FUN_FOR_FOODIES',
  FUN_ON_THE_WATER = 'FUN_ON_THE_WATER',
  GALLERIES_MUSEUMS = 'GALLERIES_MUSEUMS',
  GAMES_SHOWS_SPECIAL_EVENTS = 'GAMES_SHOWS_SPECIAL_EVENTS',
  GETTING_AROUND = 'GETTING_AROUND',
  GOLF_TEE_TIMES = 'GOLF_TEE_TIMES',
  GOLF_TOURS_TEE_TIMES = 'GOLF_TOURS_TEE_TIMES',
  HALLOWEEN = 'HALLOWEEN',
  HAMMAMS_TURKISH_BATHS = 'HAMMAMS_TURKISH_BATHS',
  HELICOPTER_RIDES = 'HELICOPTER_RIDES',
  HELICOPTER_TOURS = 'HELICOPTER_TOURS',
  HIGH_SPEED_DRIVING = 'HIGH_SPEED_DRIVING',
  HIGH_SPEED_RIDES = 'HIGH_SPEED_RIDES',
  HIKING_CAMPING = 'HIKING_CAMPING',
  HISTORICAL_TOURS = 'HISTORICAL_TOURS',
  HISTORY_CULTURE = 'HISTORY_CULTURE',
  HOLIDAY_SEASONAL_TOURS = 'HOLIDAY_SEASONAL_TOURS',
  HONEYMOON_PACKAGE = 'HONEYMOON_PACKAGE',
  HONEYMOON_PACKAGES = 'HONEYMOON_PACKAGES',
  HOP_ON_HOP_OFF = 'HOP_ON_HOP_OFF',
  HOP_ON_HOP_OFF_TOURS = 'HOP_ON_HOP_OFF_TOURS',
  HORSE_CARRIAGE_RIDES = 'HORSE_CARRIAGE_RIDES',
  HOT_SPRINGS_THERMAL_SPAS = 'HOT_SPRINGS_THERMAL_SPAS',
  INTERESTS = 'INTERESTS',
  KAYAKING_CANOEING = 'KAYAKING_CANOEING',
  LATEST_GREATEST = 'LATEST_GREATEST',
  LIFT_TICKETS = 'LIFT_TICKETS',
  LIKELY_TO_SELL_OUT = 'LIKELY_TO_SELL_OUT',
  LITERARY_ART_MUSIC_TOURS = 'LITERARY_ART_MUSIC_TOURS',
  LOCAL_EXPERT_PICKS = 'LOCAL_EXPERT_PICKS',
  LUNCH_CRUISES = 'LUNCH_CRUISES',
  MOTORCYCLE_SCOOTER_TOURS = 'MOTORCYCLE_SCOOTER_TOURS',
  MOVIE_TV_TOURS = 'MOVIE_TV_TOURS',
  MULTIDAY_CRUISES = 'MULTIDAY_CRUISES',
  MULTI_DAY_EXTENDED_TOURS = 'MULTI_DAY_EXTENDED_TOURS',
  MUSEUM_TICKETS = 'MUSEUM_TICKETS',
  MUSEUM_TICKETS_PASSES = 'MUSEUM_TICKETS_PASSES',
  MUST_SEE_SIGHTS = 'MUST_SEE_SIGHTS',
  NA = 'NA',
  NATIONAL_HOLIDAYS = 'NATIONAL_HOLIDAYS',
  NEW = 'NEW',
  NEWY_EARS = 'NEWY_EARS',
  NIGHTLIFE = 'NIGHTLIFE',
  NIGHTLIFE_PASSES = 'NIGHTLIFE_PASSES',
  NIGHT_CRUISES = 'NIGHT_CRUISES',
  NIGHT_TOURS = 'NIGHT_TOURS',
  ONSENS = 'ONSENS',
  OTHER_ANIMALS_ACTIVITIES = 'OTHER_ANIMALS_ACTIVITIES',
  OTHER_ANIMAL_ACTIVITIES = 'OTHER_ANIMAL_ACTIVITIES',
  OTHER_CLASSES = 'OTHER_CLASSES',
  OTHER_OUTDOOR_ACTIVITIES = 'OTHER_OUTDOOR_ACTIVITIES',
  OTHER_SEASONAL_EVENTS = 'OTHER_SEASONAL_EVENTS',
  OTHER_TOURS = 'OTHER_TOURS',
  OTHER_TRANSFERS = 'OTHER_TRANSFERS',
  OTHER_TRANSPORTATION = 'OTHER_TRANSPORTATION',
  OTHER_WATER_ACTIVITIES = 'OTHER_WATER_ACTIVITIES',
  PHOTOGRAPHY_TOURS = 'PHOTOGRAPHY_TOURS',
  PORT_TRANSFERS = 'PORT_TRANSFERS',
  PRIVATE_CUSTOM_TOURS = 'PRIVATE_CUSTOM_TOURS',
  PRIVATE_DAY_TRIPS = 'PRIVATE_DAY_TRIPS',
  PRIVATE_TOURS = 'PRIVATE_TOURS',
  PRIVATE_TRANSFERS = 'PRIVATE_TRANSFERS',
  PURE_ROMANCE = 'PURE_ROMANCE',
  RELIGIOUS_SPIRITUAL_TOURS = 'RELIGIOUS_SPIRITUAL_TOURS',
  RIVER_HARBOUR_CRUISES = 'RIVER_HARBOUR_CRUISES',
  ROMAN_STAYCATION = 'ROMAN_STAYCATION',
  SAFARIS = 'SAFARIS',
  SAILING_TRIPS = 'SAILING_TRIPS',
  SCOOTER_RENTALS = 'SCOOTER_RENTALS',
  SEGWAY_TOURS = 'SEGWAY_TOURS',
  SHARED_TRANSFERS = 'SHARED_TRANSFERS',
  SHARK_DIVING = 'SHARK_DIVING',
  SHOPPING_FASHION = 'SHOPPING_FASHION',
  SHOPPING_PASSES_OFFERS = 'SHOPPING_PASSES_OFFERS',
  SHOPPING_TOURS = 'SHOPPING_TOURS',
  SHORE_EXCURIONS = 'SHORE_EXCURIONS',
  SHOWS_CONCERTS = 'SHOWS_CONCERTS',
  SHOW_SPORT_TICKETS = 'SHOW_SPORT_TICKETS',
  SIGHTSEEING_ATTRACTION_PASSES = 'SIGHTSEEING_ATTRACTION_PASSES',
  SIGHTSEEING_CITY_PASSES = 'SIGHTSEEING_CITY_PASSES',
  SIGHTSEEING_PASSES = 'SIGHTSEEING_PASSES',
  SKIING_RENTALS = 'SKIING_RENTALS',
  SKIP_THE_LINE_TOURS = 'SKIP_THE_LINE_TOURS',
  SNORKELING_SCUBA_DIVING = 'SNORKELING_SCUBA_DIVING',
  SNOWBOARDING_RENTALS = 'SNOWBOARDING_RENTALS',
  SNOWMOBILE_TOURS = 'SNOWMOBILE_TOURS',
  SNOWSHOEING = 'SNOWSHOEING',
  SPA = 'SPA',
  SPA_WELLNESS = 'SPA_WELLNESS',
  SPEED_BOATS_JET_SKIS = 'SPEED_BOATS_JET_SKIS',
  SPORTING_EVENTS_PACKAGES = 'SPORTING_EVENTS_PACKAGES',
  SPORTS_PACKAGES = 'SPORTS_PACKAGES',
  STAY_ACTIVE = 'STAY_ACTIVE',
  SUBMARINE_TOURS = 'SUBMARINE_TOURS',
  SUNSET_CRUISES = 'SUNSET_CRUISES',
  SUPERNATURAL_TOURS = 'SUPERNATURAL_TOURS',
  SUSTAINABLE_TOURS = 'SUSTAINABLE_TOURS',
  SWIM_WITH_DOLPHINS = 'SWIM_WITH_DOLPHINS',
  THEATER_SHOWS_MUSICALS = 'THEATER_SHOWS_MUSICALS',
  THEME_PARKS = 'THEME_PARKS',
  THEME_PARK_TICKETS_TOURS = 'THEME_PARK_TICKETS_TOURS',
  THE_GREAT_OUTDOORS = 'THE_GREAT_OUTDOORS',
  THRILL_SEEKER = 'THRILL_SEEKER',
  TICKETS = 'TICKETS',
  TOURS_ACTIVITIES = 'TOURS_ACTIVITIES',
  TOURS_SIGHTSEEING = 'TOURS_SIGHTSEEING',
  TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
  TREAT_YOURSELF = 'TREAT_YOURSELF',
  TUBING = 'TUBING',
  UNIVERSAL_THEME_PARKS = 'UNIVERSAL_THEME_PARKS',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WALKING_BIKE_TOURS = 'WALKING_BIKE_TOURS',
  WALKING_TOURS = 'WALKING_TOURS',
  WATERSKIING_WAKEBOARDING = 'WATERSKIING_WAKEBOARDING',
  WATER_ACTIVITIES = 'WATER_ACTIVITIES',
  WATER_PARKS = 'WATER_PARKS',
  WEDDING_CEREMONIES = 'WEDDING_CEREMONIES',
  WEDDING_HONEYMOON = 'WEDDING_HONEYMOON',
  WEDDING_PACKAGES = 'WEDDING_PACKAGES',
  WEDDING_SHONEYMOONS = 'WEDDING_SHONEYMOONS',
  WHAT_TO_DO_WITH_GROUPS = 'WHAT_TO_DO_WITH_GROUPS',
  WHAT_TO_DO_WITH_KIDS = 'WHAT_TO_DO_WITH_KIDS',
  WHITE_WATER_RAFTING = 'WHITE_WATER_RAFTING',
  WILDLIFE_NATURE = 'WILDLIFE_NATURE',
  WINE_TASTING_WINERY_TOURS = 'WINE_TASTING_WINERY_TOURS',
  WINTER_ACTIVITIES = 'WINTER_ACTIVITIES',
  YOGA_CLASS = 'YOGA_CLASS',
  YOGA_CLASSES = 'YOGA_CLASSES',
  ZOO_TICKETS = 'ZOO_TICKETS',
  ZOO_TICKETS_PASSES = 'ZOO_TICKETS_PASSES'
}


export enum ActivityCategoryType {
  ACTIVITIES = 'ACTIVITIES',
  CATEGORIES = 'CATEGORIES',
  DEALS_PROMOTIONS = 'DEALS_PROMOTIONS',
  NA = 'NA',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  TOURS = 'TOURS',
  TRANSPORTATION = 'TRANSPORTATION'
}








export interface ActivityDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}



/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: Maybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: Maybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: Maybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: Maybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: Maybe<Scalars['String']>;
}

/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS'
}






export enum ActivityDiscountType {
  AIR_ATTACH_MIP = 'AIR_ATTACH_MIP',
  AIR_HOTEL_ATTACH_MIP = 'AIR_HOTEL_ATTACH_MIP',
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  FREE_ACTIVITY = 'FREE_ACTIVITY',
  GUEST = 'GUEST',
  HOTEL_ATTACH_MIP = 'HOTEL_ATTACH_MIP',
  MIP = 'MIP',
  MOD = 'MOD',
  STRIKE_OUT = 'STRIKE_OUT'
}















export enum ActivityGroupType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE',
  AVAILABLE_TODAY = 'AVAILABLE_TODAY',
  CATEGORY = 'CATEGORY',
  FILTERED_ACTIVITIES = 'FILTERED_ACTIVITIES',
  INTERESTS = 'INTERESTS',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MORE_ACTIVITIES = 'MORE_ACTIVITIES',
  NEIGHBOURHOOD = 'NEIGHBOURHOOD',
  PINNED_ACTIVITY = 'PINNED_ACTIVITY',
  POI = 'POI',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  SLIM_CATEGORY = 'SLIM_CATEGORY',
  SUB_CATEGORIES = 'SUB_CATEGORIES',
  SUB_CATEGORY = 'SUB_CATEGORY',
  SWP_SORT_SECTION = 'SWP_SORT_SECTION',
  TOP_ACTIVITIES = 'TOP_ACTIVITIES',
  TRIPS_ACTIVITY_LIST = 'TRIPS_ACTIVITY_LIST',
  XSELL_RECOMMENDATIONS = 'XSELL_RECOMMENDATIONS'
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_SPANNED_TILE_LIST = 'ACTIVITY_SPANNED_TILE_LIST',
  ACTIVITY_TILES_CAROUSEL = 'ACTIVITY_TILES_CAROUSEL',
  CATEGORY_TILES_CAROUSEL = 'CATEGORY_TILES_CAROUSEL',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MESSAGE = 'MESSAGE',
  SLIM_CATEGORY_TILES_CAROUSEL = 'SLIM_CATEGORY_TILES_CAROUSEL',
  TEXT = 'TEXT'
}
























export enum ActivityMapGroupType {
  POI = 'POI'
}



/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: Maybe<Scalars['Int']>;
  /** field which identifies sem channel */
  sem?: Maybe<Scalars['String']>;
  /** field which identifies semdtl value */
  semdtl?: Maybe<Scalars['String']>;
}









/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = 'ADDON',
  EARN_2X_REWARD_POINTS = 'EARN_2X_REWARD_POINTS',
  GIFTING_LX_BANNER = 'GIFTING_LX_BANNER',
  LOGIN = 'LOGIN',
  SOURCED_CAMPAIGN = 'SOURCED_CAMPAIGN',
  SUMMER_CAMPAIGN_PRIMARY = 'SUMMER_CAMPAIGN_PRIMARY',
  SUMMER_CAMPAIGN_SECONDARY = 'SUMMER_CAMPAIGN_SECONDARY'
}







/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: Scalars['String'];
  productToken: Scalars['String'];
}











export interface ActivityOfferFilterInput {
  selections?: Maybe<Array<ActivitySelectedValueInput>>;
  tickets?: Maybe<Array<ActivityTicketInput>>;
}







/** Data used to retrieve details about an activity product */
export interface ActivityOfferNaturalKeyInput {
  /** Offer Product Natural Key for offer entity which uniquely determines bookable offer of activity. This includes, site id, Offer id, Offer dates, offer locale, total travelers selected to uniquely identify an offer */
  offerProductNaturalKey: Scalars['String'];
}


















export enum ActivityOfferUdsToken {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}













/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = 'HTTP_EQUIV',
  NAME = 'NAME',
  PROPERTY = 'PROPERTY'
}


/** Activity Page Type - infosite */
export enum ActivityPageType {
  ACTIVITY_INFO = 'ACTIVITY_INFO'
}















/** Activity Price types */
export enum ActivityPriceType {
  GROUP = 'GROUP',
  NORMAL = 'NORMAL',
  VOLUME_BASED = 'VOLUME_BASED'
}








export enum ActivityRedemptionType {
  PRINT = 'PRINT',
  VOUCHER_LESS = 'VOUCHER_LESS'
}









export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST'
}







/** Allow to define a period of time to search for activities */
export interface ActivitySearchCriteriaDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}

/** Region information for an activity search */
export interface ActivitySearchCriteriaLocationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: Maybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: Maybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: Maybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: Maybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: Maybe<Scalars['String']>;
}


/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: Maybe<Scalars['String']>;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: Maybe<Scalars['String']>;
  /**
   * Value selected by the user
   *     E.g.
   *     1. 'sort':'RECOMMENDED'
   *     2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'
   *     4. 'categories': 'ToursSightseeing'
   */
  selections?: Maybe<Array<ActivitySelectedValueInput>>;
}




/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = 'CATEGORY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = 'GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER',
  GIFTING_ACTIVITIES = 'GIFTING_ACTIVITIES',
  GUEST_PROMO = 'GUEST_PROMO',
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER'
}




/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = 'DISTANCE_FROM_HOTEL_TO_ACTIVITY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  NEARBY_ACTIVITIES = 'NEARBY_ACTIVITIES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS',
  TRAVEL_DISTANCE_FROM_HOTEL = 'TRAVEL_DISTANCE_FROM_HOTEL'
}





export interface ActivitySelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}





/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  DISTANCE_FROM_HOTEL = 'DISTANCE_FROM_HOTEL',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}















export enum ActivityTextAlignment {
  CENTRE = 'CENTRE',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}


export enum ActivityTextSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}




export interface ActivityTicketInput {
  code: Scalars['String'];
  count: Scalars['Int'];
}






/** Details of traveler with a specific age. Age will be used to derive the traveler type in package bookings */
export interface ActivityTravelerDetailsInput {
  /** Age of the traveler. Traveler type(adult/infant/youth) can be derived from age */
  age: Scalars['Int'];
  /** Number of travelers with specified age */
  count: Scalars['Int'];
}

/** Container of traveler information */
export interface ActivityTravelerInfoInput {
  /** number of adults from Hotel PDP */
  numberOfAdults: Scalars['Int'];
  /** number of children from Hotel PDP */
  numberOfChildren: Scalars['Int'];
  /** number of infants from Hotel PDP */
  numberOfInfants: Scalars['Int'];
}



export enum ActivityUdsToken {
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  MULTI_SELECT_RANGE = 'MULTI_SELECT_RANGE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT'
}

/** Input to update the activity in the session */
export interface ActivityUpdateInput {
  newActivity: ActivityNaturalKeyInput;
  oldActivity: ActivityNaturalKeyInput;
}



export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: Maybe<Scalars['String']>;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars['String']>;
  /** RegionCode from residency selection of user */
  regionCode?: Maybe<Scalars['String']>;
  /** The user selection for the Insurance product(s) */
  removeInsuranceProductIds?: Maybe<Array<Scalars['String']>>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars['String'];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars['String'];
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: Scalars['String'];
  offerTypeId: Scalars['Int'];
}



export enum AddOnRequested {
  CB1 = 'CB1',
  COB = 'COB',
  SC = 'SC'
}

/** Represents the additional change query params */
export interface AdditionalChangeQueryParamsInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber?: Maybe<Scalars['String']>;
  /** Represents the virtual agent token which is used for exchange of information */
  opaqueToken?: Maybe<Scalars['String']>;
}








export interface AdditionalOnboardingContextInput {
  cmsToken?: Maybe<Scalars['String']>;
  originUrl?: Maybe<Scalars['String']>;
  scenario?: Maybe<Scalars['String']>;
}

export interface AdditionalOnboardingOperationContextInput {
  cmsToken?: Maybe<Scalars['String']>;
  originUrl?: Maybe<Scalars['String']>;
}

export enum AdditionalShoppedAncillaries {
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG'
}

export enum AdditionalShopping {
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG'
}







export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}



export interface AgencyDestinationInput {
  coordinates?: Maybe<CoordinatesInput>;
  pinnedPropertyId?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['String']>;
}





















export interface AgencyPropertySearchFiltersInput {
  guest_rating?: Maybe<Scalars['String']>;
  payment_and_cancellation?: Maybe<Array<Scalars['String']>>;
  point_of_interest?: Maybe<Scalars['String']>;
  price?: Maybe<PriceFilterInput>;
  property_type?: Maybe<Array<Scalars['String']>>;
  star_rating?: Maybe<Array<Scalars['String']>>;
}






export interface AgencyQuoteBuilderPropertyRateCardInput {
  checkIn: DateInput;
  checkOut: DateInput;
  inventoryType: InventoryType;
  packageRate: Scalars['Boolean'];
  pricePerNight: Scalars['String'];
  priceTotal: Scalars['String'];
  propertyDestination: Scalars['String'];
  propertyId: Scalars['String'];
  propertyName: Scalars['String'];
  propertyType: Scalars['String'];
  ratePlanId: Scalars['String'];
  roomTypeDescription: Scalars['String'];
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  starRating?: Maybe<Scalars['Float']>;
}


export interface AgencyQuoteBuilderRateCardInput {
  propertyInput: AgencyQuoteBuilderPropertyRateCardInput;
}

export interface AgencyQuoteBuilderRemoveInput {
  all: Scalars['Boolean'];
  index?: Maybe<Scalars['Int']>;
}


/** Input for deleting quotes */
export interface AgencyQuoteDeleteInput {
  /** List of quote ids to delete */
  quoteIds: Array<Scalars['String']>;
}


/** Status of quotes delete */
export interface AgencyQuoteDeleteStatusInput {
  deletedCount: Scalars['Int'];
  isSuccessful: Scalars['Boolean'];
}










export interface AgencyQuoteListInput {
  /** Status and number of quotes deleted. */
  deleteStatus?: Maybe<AgencyQuoteDeleteStatusInput>;
  /** Page index */
  paginationIndex?: Maybe<Scalars['Int']>;
  /** Search string if we want to filter the agency quote list records */
  searchCriteria?: Maybe<Scalars['String']>;
  /** Information of the tab */
  selectedTab?: Maybe<Scalars['String']>;
  /** Field Id for sort */
  sortContentId?: Maybe<Scalars['String']>;
  /** Sort direction (ascending, descending) */
  sortType?: Maybe<AgencyQuoteListSortType>;
}






/** Parameters for header cells for the records to be sorted in ascending, descending or to be unsorted manner */
export enum AgencyQuoteListSortType {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  NOT_SORTED = 'NOT_SORTED'
}

export interface AgencyQuoteNaturalKeyInput {
  lodgingType: Scalars['String'];
  packageRates?: Maybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}


export interface AgencyQuoteSaveAgencyDetailInput {
  /** Address of the agency, line 1 */
  address1?: Maybe<Scalars['String']>;
  /** Address of the agency line 2 */
  address2?: Maybe<Scalars['String']>;
  /** Email of the agent */
  email: Scalars['String'];
  /** Name of the Agency */
  name?: Maybe<Scalars['String']>;
  /** Phone number associated with the agency */
  phone: Scalars['String'];
}

export interface AgencyQuoteSaveCardInput {
  /** Destination of the travel */
  destination: Scalars['String'];
  /** Indicates state for hiding cancellation policy */
  hideCancellationState: Scalars['Boolean'];
  /** Indicates state for hiding price details */
  hidePriceState: Scalars['Boolean'];
  /** Expedia's line of businesses */
  lob: ExpLineOfBusiness;
  /** Natural key for input validation */
  naturalKey: AgencyQuoteNaturalKeyInput;
  /** Total price for the quote */
  totalPrice?: Maybe<Scalars['String']>;
}


export interface AgencyQuoteSaveInput {
  /** Agency details pulled from database */
  agencyInfo: AgencyQuoteSaveAgencyDetailInput;
  /** Message from the agent, to be added by the agent */
  agentMessage?: Maybe<Scalars['String']>;
  /** Details of the trip on quote, pulled from database */
  quoteCards: Array<AgencyQuoteSaveCardInput>;
  /** Autogenerated Unique Identifier for each quote. Could be Null for saving a quote after Update */
  quoteId?: Maybe<Scalars['String']>;
  /** Name of the quote, to be added by the agent */
  quoteName: Scalars['String'];
  /** Name of the Traveler, to be added by the agent */
  travelerName: Scalars['String'];
}







export interface AgencyShoppingContextInput {
  bookingDate: Scalars['String'];
  checkin: Scalars['String'];
  checkout: Scalars['String'];
  countryCode: Scalars['String'];
  currency: Scalars['String'];
  language: Scalars['String'];
  occupancy: Array<Scalars['String']>;
}












export interface AgentQuoteNaturalKeyInput {
  packageRates?: Maybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}





export interface AgentStateInput {
  agentPresenceUri: Scalars['String'];
  localizedText?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: AgentStateType;
}

export enum AgentStateType {
  NOTREADY = 'NotReady',
  OFFLINE = 'Offline',
  READY = 'Ready'
}







/** Airport location type chosen in flight search. */
export enum AirportLocationType {
  AIRPORT = 'AIRPORT',
  METROCODE = 'METROCODE',
  UNSPECIFIED = 'UNSPECIFIED'
}


export enum Alignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}






/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  /** Localization messages will be replaced with their namespace and loc key. */
  DEBUG = 'DEBUG',
  /** None of the ALTER experiments will be used when resolving localization messages. */
  NONE = 'NONE',
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  PREVIEW = 'PREVIEW',
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  RELEASED = 'RELEASED'
}









export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BARBECUE = 'BARBECUE',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BREAKFAST_INCLUDED = 'BREAKFAST_INCLUDED',
  BREAKFAST_NOT_AVAILABLE = 'BREAKFAST_NOT_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FIRE_PLACE = 'FIRE_PLACE',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCEL = 'FREE_CANCEL',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FREE_WIRED_INTERNET = 'FREE_WIRED_INTERNET',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  INTERNET_NOT_AVAILABLE = 'INTERNET_NOT_AVAILABLE',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  ON_PRIVATE_BEACH = 'ON_PRIVATE_BEACH',
  ON_THE_BEACH = 'ON_THE_BEACH',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESERVE_NOW_PAY_DEPOSIT = 'RESERVE_NOW_PAY_DEPOSIT',
  RESERVE_NOW_PAY_LATER = 'RESERVE_NOW_PAY_LATER',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WASHER = 'WASHER',
  WATERSLIDE = 'WATERSLIDE',
  WIFI_SURCHARGE = 'WIFI_SURCHARGE',
  WIRED_INTERNET_SURCHARGE = 'WIRED_INTERNET_SURCHARGE'
}

export enum AmenityFilter {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  INVALID = 'INVALID',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}

/** represents the bag template analytics keys */
export enum AnalyticsKey {
  /** Represents the analytics key for number of bags per traveller */
  NUMBER_OF_BAGS = 'NUMBER_OF_BAGS',
  /** Represents the analytics key for piece or weight selling model criteria analytics per traveller */
  PIECE_OR_WEIGHT_CONCEPT = 'PIECE_OR_WEIGHT_CONCEPT',
  /** Represents the analytics key for quantity of bags per traveller (NONE/SOME/ALL) */
  QUANTITY_OF_BAGS = 'QUANTITY_OF_BAGS'
}


/** Represents per journey ancillary selection */
export interface AncillaryJourneySelectionsInput {
  /** Represents the journey index for which the selection is applicable */
  journeyIndex: Scalars['Int'];
  /** Represents flight journey status */
  journeyStatus?: Maybe<FlightJourneyStatus>;
  /** Represents the list of per traveller selection */
  travellerAncillarySelections: Array<TravellerAncillarySelectionInput>;
}


export interface ArithmeticOperationsCriteriaInput {
  /** Represents the input numbers to be operated upon */
  inputNumbers: Array<Scalars['Float']>;
  /** The operation to be performed */
  operation: Operation;
}

/** Possible aspect ratios of EGDS images */
export enum AspectRatio {
  /** Aspect ratio 4:3 */
  FOUR_THREE = 'FOUR_THREE',
  /** Aspect ratio 1:1 */
  ONE_ONE = 'ONE_ONE',
  /** Aspect ratio 16:9 */
  SIXTEEN_NINE = 'SIXTEEN_NINE',
  /** Aspect ratio 3:4 */
  THREE_FOUR = 'THREE_FOUR',
  /** Aspect ratio 3:2 */
  THREE_TWO = 'THREE_TWO',
  /** Aspect ratio 21:9 */
  TWENTY_ONE_NINE = 'TWENTY_ONE_NINE'
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED'
}










export enum BadgeIcon {
  ACCESS_TIME = 'ACCESS_TIME',
  ADD = 'ADD',
  BUNDLED_SAVINGS_PLUS = 'BUNDLED_SAVINGS_PLUS',
  EXP29639_ORB = 'EXP29639_ORB',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO_OUTLINE = 'INFO_OUTLINE',
  LOB_DEALS = 'LOB_DEALS',
  LOCAL_OFFER = 'LOCAL_OFFER',
  MOD = 'MOD',
  SMARTPHONE = 'SMARTPHONE'
}

/** Represents the quantity of bags to be sent in analytics none/some/all */
export enum BagsSelectionType {
  ALL = 'ALL',
  NONE = 'NONE',
  SOME = 'SOME'
}

export enum BannerDisplayType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARN = 'WARN'
}


export enum BannerTheme {
  BRAND_PROMO_PRIMARY = 'BRAND_PROMO_PRIMARY',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}














export interface BookingChangeFlightInput {
  /** Represents the air record locator for the flight that needs to be changed */
  airRecordLocator?: Maybe<Scalars['String']>;
  /** Represents the virtual agent domain or Web domain */
  client?: Maybe<BookingServicingClient>;
  /** ConversationId for virtual agent */
  conversationId?: Maybe<Scalars['String']>;
  /** Represents the new flight search criteria */
  flightSearchCriteria?: Maybe<FlightSearchCriteriaInput>;
  /** opaqueId for virtual agent */
  opaqueId?: Maybe<Scalars['String']>;
  /** Represents the old flight and traveler selection that needs to be changed */
  selectedChanges?: Maybe<Array<BookingServicingChangeSelectionInput>>;
  /** Represents the tripId for the flight that needs to be changed */
  tripId: Scalars['String'];
  /** Represents the trip item id for the flight that needs to be changed */
  tripItemId?: Maybe<Scalars['String']>;
  /** Represents the trip view id for the flight that needs to be changed */
  tripViewId?: Maybe<Scalars['String']>;
}










/** Represents the information about the flight and traveler selections that need to be changed  */
export interface BookingServicingChangeCriteriaInput {
  /** Represents the information about the flight  and traveler selections that need to be changed  */
  flightsInput?: Maybe<BookingChangeFlightInput>;
}


export interface BookingServicingChangeLodgingInput {
  orderLineGuid: Scalars['String'];
  orderNumber: Scalars['String'];
  tripId: Scalars['String'];
}




export interface BookingServicingChangeSelectionInput {
  /** Represents the name of the change flight(eg old flight/traveler) */
  name: Scalars['String'];
  /** Represents the value of the change flight(eg old flight/traveler) */
  value: Scalars['String'];
}



export enum BookingServicingClient {
  /** Represents virtual agent domain */
  VIRTUAL_AGENT = 'VIRTUAL_AGENT',
  /** Represents web domain */
  WEB = 'WEB'
}
















/** Target of the Link when clicked */
export enum BookingServicingLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}










export enum BookingServicingQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}












export enum BookingServicingTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT'
}

/** The type of input validation that will be performed on the traveler input */
export enum BookingServicingTravelerValidationType {
  /** Represents the type of validation when a child is traveling alone without an adult */
  CHILD_TRAVELING_ALONE = 'CHILD_TRAVELING_ALONE'
}

export enum BooleanEnum {
  FALSE = 'FALSE',
  TRUE = 'TRUE'
}


/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: Scalars['String'];
  value: Scalars['Boolean'];
}










/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;
  taxesAndFees: MoneyInput;
}




export enum BulletStyle {
  DEFAULT = 'DEFAULT',
  ICON_ALTERNATE = 'ICON_ALTERNATE',
  ICON_STANDARD = 'ICON_STANDARD',
  NO_BULLET = 'NO_BULLET',
  UNRECOGNIZED = 'UNRECOGNIZED'
}


/** Indicate the business model type of a given offer */
export enum BusinessModelType {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}

export interface CdfFeedbackInput {
  context: Array<GraphQlPairInput>;
  formValues: Array<GraphQlPairInput>;
}











export enum CdfPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT'
}













export enum CampaignOfferBadgeType {
  DEFAULT = 'DEFAULT',
  DISCOUNT = 'DISCOUNT'
}


export interface CampaignParametersInput {
  campaignId: Scalars['String'];
  contentPagination?: Maybe<ContentPaginationInput>;
  propertyParameters?: Maybe<CampaignPropertyParametersInput>;
}

export enum CampaignProductType {
  ACTIVITY = 'ACTIVITY',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE'
}

export interface CampaignPropertyParametersInput {
  guestRating?: Maybe<Scalars['Float']>;
  propertyId: Scalars['String'];
  starRating?: Maybe<Scalars['Float']>;
  type?: Maybe<PropertyDetailsPropertyType>;
}


export interface CancellationWaiverDeclineRequestContext {
  bookingItemId: Scalars['String'];
  serviceRequestId: Scalars['String'];
  reason: Scalars['String'];
  message?: Maybe<Scalars['String']>;
}


export enum CarAccessorySelectionState {
  NOT_SELECTED = 'NOT_SELECTED',
  SELECTED = 'SELECTED'
}


export enum CarActionType {
  /** Apply loyalty points to offer */
  APPLY_LOYALTY_POINTS = 'APPLY_LOYALTY_POINTS',
  /** Click map marker */
  CAR_MAP_MARKER = 'CAR_MAP_MARKER',
  /** Change Search */
  CHANGE_SEARCH = 'CHANGE_SEARCH',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Click to filter car sales */
  FILTER_SALE_OFFER = 'FILTER_SALE_OFFER',
  /** Submit content to server */
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  /** Go back to search page to see all cars */
  GO_BACK_TO_SEARCH = 'GO_BACK_TO_SEARCH',
  /** Open cancellation policy link */
  GO_TO_CANCELLATION_POLICY = 'GO_TO_CANCELLATION_POLICY',
  /** Continues to the standalone details page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Open dialog to see cleaning and safety practices */
  GO_TO_CLEANLINESS_DIALOG = 'GO_TO_CLEANLINESS_DIALOG',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Open recommended sort FAQ page */
  GO_TO_RECOMMENDED_SORT_FAQ = 'GO_TO_RECOMMENDED_SORT_FAQ',
  /** Continues to the user sign in page */
  GO_TO_SIGNIN = 'GO_TO_SIGNIN',
  /** Continues to the user sign up page */
  GO_TO_SIGNUP = 'GO_TO_SIGNUP',
  /** Click to sign in and unlock car sales */
  GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES = 'GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES',
  /** Open Walmart plus member trial page */
  GO_TO_WPLUS_MEMBER_TRIAL_LINK = 'GO_TO_WPLUS_MEMBER_TRIAL_LINK',
  /** Load more results to search page */
  LOAD_MORE = 'LOAD_MORE',
  /** Change Search */
  OFF_AIRPORT_CHANGE_SEARCH = 'OFF_AIRPORT_CHANGE_SEARCH',
  /** Opens a dialog */
  OPEN_DIALOG = 'OPEN_DIALOG',
  /** Open merchant rules in iframe */
  OPEN_DOC = 'OPEN_DOC',
  /** Open ground transfers page */
  OPEN_GROUND_TRANSFERS = 'OPEN_GROUND_TRANSFERS',
  /** Opens the inline time wizard */
  OPEN_INLINE_TIME_WIZARD = 'OPEN_INLINE_TIME_WIZARD',
  /** Opens the inline search wizard */
  OPEN_INLINE_WIZARD = 'OPEN_INLINE_WIZARD',
  /** Opens a new tab */
  OPEN_NEW_TAB = 'OPEN_NEW_TAB',
  /** Opens on current tab */
  OPEN_ON_CURRENT_TAB = 'OPEN_ON_CURRENT_TAB',
  /** Open vendor rules from domain rules */
  OPEN_RULE = 'OPEN_RULE',
  /** Used to open Telephone Link */
  OPEN_TEL = 'OPEN_TEL',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Remove loyalty points to offer */
  REMOVE_LOYALTY_POINTS = 'REMOVE_LOYALTY_POINTS',
  /** Click see cars on map marker item card */
  SEE_CARS_AT_MAP_MARKER = 'SEE_CARS_AT_MAP_MARKER',
  /** Open share feedback form */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Show offers with AARP Exclusive benefits */
  SHOW_AARP_EXCLUSIVE_OFFERS = 'SHOW_AARP_EXCLUSIVE_OFFERS',
  /** Show offers with free cancellations */
  SHOW_FREE_CANCELLATION_OFFERS = 'SHOW_FREE_CANCELLATION_OFFERS',
  /** Click to unlock car sales */
  UNLOCK_CAR_SALES = 'UNLOCK_CAR_SALES'
}












export interface CarDetailContextInput {
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars['String']>;
  optionAction?: Maybe<CarAccessorySelectionState>;
  optionToken?: Maybe<Scalars['String']>;
  principalToken?: Maybe<Scalars['String']>;
  rewardPointsSelection?: Maybe<RewardsPointSelectionEnum>;
  selectedAccessories?: Maybe<Array<Scalars['String']>>;
}







export enum CarFormatStyle {
  IFRAME = 'IFRAME',
  LIST = 'LIST'
}














export enum CarMapMarkerType {
  CARMARKER = 'CarMarker',
  PLACEMARKER = 'PlaceMarker'
}





/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: Scalars['String'];
  specialEquipments?: Maybe<Array<SpecialEquipment>>;
}



























/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: Maybe<Scalars['String']>;
  coordinates?: Maybe<CoordinatesInput>;
  isExactLocationSearch?: Maybe<Scalars['Boolean']>;
  regionId?: Maybe<Scalars['String']>;
  searchTerm?: Maybe<Scalars['String']>;
}






export enum CarRouteType {
  ONEWAY = 'ONEWAY',
  ROUNDTRIP = 'ROUNDTRIP'
}


export interface CarRulesAndRestrictionsCriteriaInput {
  carOfferToken?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  useEgtpPath?: Maybe<Scalars['Boolean']>;
}




/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}










/** Represents name and code for each car brand. */
export enum CarSearchFormPreferredBrand {
  AC = 'AC',
  AD = 'AD',
  AL = 'AL',
  EP = 'EP',
  ET = 'ET',
  EY = 'EY',
  FX = 'FX',
  MW = 'MW',
  NU = 'NU',
  RO = 'RO',
  SC = 'SC',
  SV = 'SV',
  SX = 'SX',
  ZA = 'ZA',
  ZD = 'ZD',
  ZE = 'ZE',
  ZI = 'ZI',
  ZL = 'ZL',
  ZR = 'ZR',
  ZT = 'ZT'
}




























export enum CardActions {
  DISMISS = 'DISMISS'
}


export enum CardSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export enum CardTheme {
  GLOBAL_LOYALTY_EXTRAHIGH = 'GLOBAL_LOYALTY_EXTRAHIGH',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_MIDDLE = 'GLOBAL_LOYALTY_MIDDLE',
  GLOBAL_LOYALTY_STANDARD = 'GLOBAL_LOYALTY_STANDARD',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}




/** Enum class to represent the type of carry on bag */
export enum CarryOnBagType {
  CARRY_ON_BAG = 'CARRY_ON_BAG'
}




export enum CarsDialogType {
  LIMITED_RESULTS = 'LIMITED_RESULTS',
  LIMITED_RESULTS_WITHOUT_TURO = 'LIMITED_RESULTS_WITHOUT_TURO',
  LIMITED_RESULTS_WITH_TURO = 'LIMITED_RESULTS_WITH_TURO'
}

export interface CarsDomainRequestContextInput {
  partnerContext: PartnerContextInput;
  principalJWT: Scalars['String'];
}



export enum CarsRichTextStyle {
  BOLD = 'BOLD',
  BULLET = 'BULLET',
  ITALICIZE = 'ITALICIZE'
}






/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}


export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: Scalars['String'];
  /** The list of rooms that user searched for */
  rooms: Array<PropertyRoomInput>;
}


export enum CartTtl {
  FIVE_MINUTES = 'FIVE_MINUTES',
  SEVEN_DAYS = 'SEVEN_DAYS',
  TWELVE_HOURS = 'TWELVE_HOURS'
}







export enum ChannelType {
  VIRTUAL_AGENT = 'VIRTUAL_AGENT'
}

/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  VIEW_BOOKING = 'VIEW_BOOKING'
}

/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = 'FLIGHT'
}

/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = 'CREDIT_REDEMPTION'
}


/** Supported capabilities of chatbot VAC. */
export enum ChatbotCapabilities {
  CLICKSTREAM = 'CLICKSTREAM',
  GLASSBOX = 'GLASSBOX'
}




/** Key-Value pair of intent attributes for chatbot initialization example itineraryNumber, orderLineId */
export interface ChatbotIntentValueInput {
  /** Key to define intent attributes for chatbot initialization example itineraryNumber, orderLineId */
  id: Scalars['String'];
  /** Value for intent attributes for chatbot initialization example of attributes itineraryNumber, orderLineId */
  value: Scalars['String'];
}


/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = 'V1',
  V2 = 'V2'
}


export enum CheckinValidityWithReason {
  /** the associated date is not valid for checkin due to an unknown reason */
  INVALID = 'INVALID',
  /** the associated date is not valid for checkin due to being in the past */
  INVALID_DUE_TO_BEING_IN_PAST = 'INVALID_DUE_TO_BEING_IN_PAST',
  /** the associated date is not valid for checkin because checkin was prohibited on that specific date */
  INVALID_DUE_TO_CHANGEOVER_EXCLUSION = 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
  /** the associated date is not valid for checkin because it is too far in the future */
  INVALID_DUE_TO_MAX_FUTURE_BOOKING = 'INVALID_DUE_TO_MAX_FUTURE_BOOKING',
  /** the associated date is not valid for checkin because checking in on this date would not meet the owner's minimum prior notification requirements */
  INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION = 'INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION',
  /** the associated date is not valid for checkin because checking in on this date does not satisfy the minimum stay duration */
  INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE = 'INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE',
  /** the associated date is not valid for checkin because it falls on a day of the week that checkin is prohibited */
  INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK = 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
  /** the associated date is not valid for checkin because it is not available (ie. the date is already reserved) */
  INVALID_DUE_TO_NOT_AVAILABLE = 'INVALID_DUE_TO_NOT_AVAILABLE',
  /** the associated date is not valid for checkin because there is not an associated checkout date that would allow the stay to satisfy stay constraints */
  INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS = 'INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS',
  /** the associated date is valid for checkin */
  VALID = 'VALID'
}




export interface CheckoutDomainInfoInput {
  name: Scalars['String'];
  refId: Scalars['String'];
}




/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;
  value: Scalars['String'];
}

/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  FENCING_ATTRIBUTES = 'FENCING_ATTRIBUTES',
  HOTEL_BUSINESS_MODEL = 'HOTEL_BUSINESS_MODEL',
  HOTEL_MARKETING_CHANNEL = 'HOTEL_MARKETING_CHANNEL',
  META_DEEPLINK = 'META_DEEPLINK',
  PROPERTY_UPSELL_AMOUNT = 'PROPERTY_UPSELL_AMOUNT',
  RATE_UPSELL = 'RATE_UPSELL',
  RATE_UPSELL_AMOUNT = 'RATE_UPSELL_AMOUNT',
  ROOM_UPSELL = 'ROOM_UPSELL',
  SHOPPING_DEAL_BADGE_PERCENTAGE = 'SHOPPING_DEAL_BADGE_PERCENTAGE',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}




export interface CheckoutSessionInfoInput {
  sessionId: Scalars['UUID'];
  sessionToken: Scalars['UUID'];
}


export enum CheckoutValidityWithReason {
  /** the associated date's is not valid for checkout for an unknown reason */
  INVALID = 'INVALID',
  /** the associated date is not valid for checkout because checkout was prohibited on that specific date */
  INVALID_DUE_TO_CHANGEOVER_EXCLUSION = 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
  /** the associated date is not valid for checkout because it falls on a day of the week that checkout is prohibited */
  INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK = 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
  /** the associated date is valid for checkout */
  VALID = 'VALID'
}


/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}

export enum ChronoUnit {
  CENTURIES = 'CENTURIES',
  DAYS = 'DAYS',
  DECADES = 'DECADES',
  ERAS = 'ERAS',
  FOREVER = 'FOREVER',
  HALFDAYS = 'HALFDAYS',
  HOURS = 'HOURS',
  MICROS = 'MICROS',
  MILLENNIA = 'MILLENNIA',
  MILLIS = 'MILLIS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NANOS = 'NANOS',
  SECONDS = 'SECONDS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = 'ENHANCED_CLEANING'
}





/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: Scalars['String'];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: Maybe<Scalars['String']>;
}


/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: Array<HttpHeaderInput>;
  /** Remote address of HTTP Request */
  remoteAddress: Scalars['String'];
  /** URL of HTTP Request */
  url: Scalars['String'];
}










/** The closed bounding type of the date period. (Boundaries are always included) */
export enum ClosedPeriodBounding {
  LOWER = 'LOWER',
  UPPER = 'UPPER'
}













export enum CoachingTipsView {
  STANDALONE_MINIMAL = 'STANDALONE_MINIMAL',
  STANDALONE_SUGGESTED = 'STANDALONE_SUGGESTED',
  OPPY_HUB = 'OPPY_HUB'
}






/** Context of pagination and max number of elements. If not defined, the default set of elements are provided. */
export interface CollectionPaginationContextInput {
  /** Indicates the maximum number of items to be shown in the module. */
  maxPageSize?: Maybe<Scalars['Int']>;
  /** Indicates the pagination offset. */
  offset?: Maybe<Scalars['Int']>;
  /** Indicates the initial number of items to be shown in the module and how many more items will be fetched by pagination. */
  pageSize?: Maybe<Scalars['Int']>;
}


/** The type of the collection */
export enum CollectionType {
  FLIGHT = 'FLIGHT',
  GEOGRAPHY = 'GEOGRAPHY',
  LODGING = 'LODGING'
}


export enum CommissionTier {
  BASIC = 'BASIC',
  BASIC_PLUS = 'BASIC_PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS'
}








/** Represents the state of message preview */
export enum CommunicationCenterMessagePreviewState {
  /** Represents read state */
  READ = 'READ',
  /** Represents unread state */
  UNREAD = 'UNREAD'
}






/** The display type of the Customer notification message */
export enum CommunicationCenterNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum CommunicationCenterNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}


/** Represents the state of notification or message */
export enum CommunicationCenterNotificationState {
  /** Represents read state */
  READ = 'READ',
  /** Represents seen state - equivalents as unread */
  SEEN = 'SEEN',
  /** Represents invalid state */
  UNKNOWN = 'UNKNOWN',
  /** Represents unseen state - initial state of notification */
  UNSEEN = 'UNSEEN'
}

/** Represents the type of the notification */
export enum CommunicationCenterNotificationType {
  /** Represents coupon notification */
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  /** Represents default type of notification */
  DEFAULT = 'DEFAULT'
}


/** Represents the type of user actions of the notification. */
export enum CommunicationCenterNotificationUserActionType {
  /** Represents the action of deleting a notification */
  DELETE = 'DELETE',
  /** Represents the action of marking a notification as read */
  MARK_AS_READ = 'MARK_AS_READ',
  /** Represents the action of marking a notification as unread */
  MARK_AS_UNREAD = 'MARK_AS_UNREAD'
}


/** Represents the status of query/mutation response */
export enum CommunicationCenterOperationStatus {
  /** Represents the status of failure response for generic or unknown reasons */
  GENERIC_FAILURE = 'GENERIC_FAILURE',
  /** Represents the status of failure response for invalid input */
  INVALID_INPUT = 'INVALID_INPUT',
  /** Represents the status of failure response for service errors */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** Represents the status of successful response */
  SUCCESS = 'SUCCESS'
}


export enum CommunicationChannel {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS'
}








export enum CommunicationPreferencesOptionsType {
  ACCOUNT_SUPPORT = 'ACCOUNT_SUPPORT',
  COMMUNICATION_PREFERENCES_EXPEDIA = 'COMMUNICATION_PREFERENCES_EXPEDIA',
  COMMUNICATION_PREFERENCES_HOTELS = 'COMMUNICATION_PREFERENCES_HOTELS',
  COMMUNICATION_PREFERENCES_VRBO = 'COMMUNICATION_PREFERENCES_VRBO',
  CONFIRMATION_AND_CRITICAL_UPDATES = 'CONFIRMATION_AND_CRITICAL_UPDATES',
  OFFERS_AND_INSPIRATION = 'OFFERS_AND_INSPIRATION',
  ONE_KEY = 'ONE_KEY',
  PARTNERS_OFFERS_WITH_US = 'PARTNERS_OFFERS_WITH_US',
  PERSONALIZED_TRIP_RECOMMENDATIONS = 'PERSONALIZED_TRIP_RECOMMENDATIONS',
  REVIEWS = 'REVIEWS',
  SURVEYS = 'SURVEYS',
  THE_TRAVEL_EDIT = 'THE_TRAVEL_EDIT',
  TRIP_BOARD_ACTIVITY = 'TRIP_BOARD_ACTIVITY',
  TRIP_PLANNING_ASSISTANCE = 'TRIP_PLANNING_ASSISTANCE'
}





export enum CompetitiveSetProductType {
  LODGING = 'LODGING'
}









/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = 'CAP',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  NA = 'NA'
}









export interface ContactUsFormContentInput {
  /** Customer Selected category from dropdown */
  category: Scalars['String'];
  /** Customer selected intent from dropdown */
  intent: Scalars['String'];
  /** Customer Entered Itinerary Number */
  itineraryNumber: Scalars['String'];
  /** Customer Entered Phone Number */
  phoneNumber: Scalars['String'];
}


export enum ContactUsOptionType {
  CALL_BACK_WITH_AGENT = 'CALL_BACK_WITH_AGENT',
  CALL_TO_AGENT = 'CALL_TO_AGENT',
  CHAT_BACK_WITH_AGENT = 'CHAT_BACK_WITH_AGENT',
  CHAT_WITH_AGENT = 'CHAT_WITH_AGENT',
  SEND_EMAIL_AGENT = 'SEND_EMAIL_AGENT'
}




/** Represents Email Us Sheet Request */
export interface ContactUsSendEmailRequestInput {
  /** Email of customer */
  customerEmail: Scalars['String'];
  /** Name of customer */
  customerName: Scalars['String'];
  /** Message of email */
  message: Scalars['String'];
  /** subject of email */
  subject: Scalars['String'];
}









/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = 'DEFAULT',
  IMPORTANT = 'IMPORTANT'
}


export interface ContentPaginationInput {
  pageNumber: Scalars['Int'];
  pageSize?: Maybe<Scalars['Int']>;
}



/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: Maybe<ClientInfoInput>;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: Maybe<Scalars['String']>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: Maybe<DebugContextInput>;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: Maybe<Scalars['Int']>;
  /**
   * DEPRECATED: Optional Client/user information. Used for input only. Please send the DUIAD header instead.
   * We no longer rely on identity for user determination.
   * User determination is now based upon passed headers. Soon this will be made nullable and later removed.
   * Will be replaced by JWTs when available.
   */
  identity?: Maybe<IdentityInput>;
  /** The context locale, e.g. en_US */
  locale: Scalars['Locale'];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars['Int'];
  /** The legacy TravelProductID */
  tpid?: Maybe<Scalars['Int']>;
}


/** Represents any relevant attributes of a conversation */
export interface ConversationAttributesInput {
  /** Represents the URL of the page where the current conversation is taking place */
  currentPageUrl?: Maybe<Scalars['String']>;
}

/** Represents the context of a conversation */
export interface ConversationContextInput {
  /** Represents any relevant attributes of a conversation, such as the current pages's URL */
  attributes?: Maybe<ConversationAttributesInput>;
  /** Represents the conversation ID, used to route messages */
  conversationId?: Maybe<Scalars['String']>;
  /** Represents the participant ID, used to identify the author of a message or the actor of an event */
  participantId?: Maybe<Scalars['String']>;
  /** Represents the partner ID, used to route messages */
  partnerId?: Maybe<Scalars['String']>;
}





/** A latitude/longitude pair */
export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: Scalars['Float'];
  /** The longitude of the point in degrees */
  longitude: Scalars['Float'];
}













export interface CouponIdentifierInput {
  type: CouponIdentifierType;
  value: Scalars['String'];
}

export enum CouponIdentifierType {
  CODE = 'CODE',
  INSTANCE_ID = 'INSTANCE_ID'
}

































export enum CreditCardApplicationFormOperation {
  EQ = 'EQ',
  GE = 'GE',
  GT = 'GT',
  LE = 'LE',
  LT = 'LT',
  NE = 'NE'
}



export interface CreditCardApplicationFormQueryInput {
  /** The deeplink that potentially triggered the Application Form opening. */
  deeplinkUrl?: Maybe<Scalars['String']>;
  /** The page the traveler is instantiating the Application Form from. */
  sourcePage: CreditCardSourcePage;
}












export enum CreditCardApplyButtonActionType {
  EMBEDDED = 'EMBEDDED',
  EXTERNAL = 'EXTERNAL'
}





export enum CreditCardSourcePage {
  /** The traveler initiated the application journey from the Application (A.K.A. Pillar) Page. */
  APPLICATION = 'APPLICATION',
  /** The traveler initiated the application journey from a Checkout Page. */
  CHECKOUT = 'CHECKOUT',
  /** The traveler initiated the application journey from a page external to EG websites, such as a marketing email. */
  EXTERNAL = 'EXTERNAL'
}

/** Enum class to represent the type of credit eligible filter */
export enum CreditEligibleFilterType {
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE'
}














export interface CrossLinksParameterInput {
  name: Scalars['String'];
  value: Scalars['String'];
}








export enum CrossSellProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL'
}




/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: Scalars['String'];
  /** The continent code of User's current location. ex: NA */
  continent: Scalars['String'];
  /** The country code of User's current location. ex: US */
  country: Scalars['String'];
  /** The region or state code of User's current location. ex: CA */
  region: Scalars['String'];
}





export enum CruiseBadgeTheme {
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  VIP = 'VIP'
}











/** A guest over the age of 2 */
export interface CruiseChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}




/** Duration of cruise to perform a cruise search */
export interface CruiseDurationRangeInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}



export enum CruiseFeature {
  LIVE_SHOPPING_USING_MSC_ADAPTER = 'LIVE_SHOPPING_USING_MSC_ADAPTER',
  MEMBER_DEALS = 'MEMBER_DEALS',
  MEMBER_DEALS_FOR_NON_MEMBERS = 'MEMBER_DEALS_FOR_NON_MEMBERS'
}

export enum CruiseFilterType {
  /** cabin experience - eg. Suite  */
  CABIN = 'CABIN',
  /** departure port */
  DEPARTURE = 'DEPARTURE',
  /** use for filtering by the destination */
  DESTINATION = 'DESTINATION',
  /** length of cruise nights 1-2, 3-5, 6-9 , 10-14, 15+ */
  LENGTH = 'LENGTH',
  /** use for filtering by the cruise line name */
  NAME = 'NAME',
  /** default not set value */
  NOT_SET = 'NOT_SET',
  /** ship type */
  SHIP = 'SHIP',
  /** use for ocean cruise */
  THEME_OCEAN = 'THEME_OCEAN',
  /** use for river cruise */
  THEME_RIVER = 'THEME_RIVER'
}



























export interface CruiseOrderSummaryRatesInfoInput {
  /** Offer token */
  offerToken: Scalars['String'];
  /** Price Info */
  price: CruiseOrderSummaryRatesPriceInput;
  /** Promotions Info */
  promotions: Array<CruiseOrderSummaryRatesPromotionInfoInput>;
  /** Update info */
  updateInfo?: Maybe<CruiseOrderSummaryRatesUpdateInfoInput>;
}


export interface CruiseOrderSummaryRatesInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** Cabin type */
  cabinType: Scalars['String'];
  /** children ages */
  childAges?: Maybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Lead in price shown to the user in infosite sidesheet */
  leadInPrice?: Maybe<Scalars['Float']>;
  /** Sailing token */
  sailingToken: Scalars['String'];
}



export interface CruiseOrderSummaryRatesPageDataInput {
  /** Info about rates displayed on the page. */
  ratesInfo: Array<CruiseOrderSummaryRatesInfoInput>;
  /** Index of the rate selected by the user */
  selectedRateIndex: Scalars['Int'];
}


export interface CruiseOrderSummaryRatesPriceChangeMessageInput {
  /** New price */
  newPrice: Scalars['String'];
  /** Old price */
  oldPrice: Scalars['String'];
  /** Type of change, increase/decrease */
  type: Scalars['String'];
}


export interface CruiseOrderSummaryRatesPriceInput {
  /** Base fare Info */
  baseFare?: Maybe<CurrencyTypeInput>;
  /** Cabin category title */
  cabinCategoryTitle: Scalars['String'];
  /** Cruise line code */
  cruiseLineCode?: Maybe<Scalars['String']>;
  /** Sold out rate flag */
  isSoldOut: Scalars['Boolean'];
  /** Member pricing Info */
  memberPricing: MemberPricingInput;
  /** Price Info */
  price?: Maybe<CurrencyAmountTypeInput>;
}


export interface CruiseOrderSummaryRatesPromotionInfoInput {
  /** Full Name of the promotion */
  fullName: Scalars['String'];
}






export interface CruiseOrderSummaryRatesUpdateInfoInput {
  /** Price change message to display on the rate */
  priceChangeMessage?: Maybe<CruiseOrderSummaryRatesPriceChangeMessageInput>;
}











export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: Maybe<Array<CruiseFeature>>;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: Maybe<Scalars['String']>;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: Maybe<Scalars['String']>;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: Maybe<Scalars['Boolean']>;
}




export interface CruiseSailingCabinCategoriesInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** children ages */
  childAges?: Maybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
}

export interface CruiseSailingCriteriaInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** Cabin type */
  cabinType: Scalars['String'];
  /** children ages */
  childAges?: Maybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
}




/** Property criteria needed to perform a cruise search */
export interface CruiseSearchCriteriaInput {
  primary: PrimaryCruiseCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}



export interface CruiseSearchFiltersInput {
  /** 1 or more cruise line codes separated by ',' delimiter  */
  cruiseLines?: Maybe<Scalars['String']>;
  /** 1 or more port codes separated by ',' delimiter  */
  departureLocations?: Maybe<Scalars['String']>;
  /** 1 or more deeplink destination names separated by ',' delimiter  */
  destinationNames?: Maybe<Scalars['String']>;
  /** Earliest departure date */
  earliestDeptDate?: Maybe<Scalars['String']>;
  /** CruiseFilterType enum name to describe the primary function of the SearchFilter */
  filterType: CruiseFilterType;
  /** Latest departure date */
  latestDeptDate?: Maybe<Scalars['String']>;
  /** Max length of sailing */
  maxLength?: Maybe<Scalars['String']>;
  /** Return sailings with member only offer */
  memberOnlyOffer?: Maybe<Scalars['Boolean']>;
  /** Min length of sailing */
  minLength?: Maybe<Scalars['String']>;
  /** 1 or more promotion codes separated by ',' delimiter  */
  promotionCode?: Maybe<Scalars['String']>;
  /** ocean or river */
  sailingVarieties?: Maybe<Scalars['String']>;
  /** 1 or more ship codes separated by ',' delimiter  */
  ships?: Maybe<Scalars['String']>;
  /** Cabin type filter. One of the ANY, INSIDE, OCEAN_VIEW, BALCONY or SUITE */
  superCategoryCode?: Maybe<Scalars['String']>;
}



/**
 * Values : popularity - sorts by Popularity
 * price - sorts by the offer price within all sailings returned
 * length - sorts by the sailing itinerary length, in days
 * departureDate - sorts by sailing departure/embarkation date
 * cruiseLine - sorts by cruise line name
 */
export interface CruiseSearchOptionsInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Limit of how many results will be returned. - Default is 20 */
  limit: Scalars['Int'];
  /** Limit of how many results will be skipped. - Default is 0 */
  offset?: Maybe<Scalars['Int']>;
  /** Field to sort results by - Default is departure-date */
  sortBy?: Maybe<Scalars['String']>;
}












export interface CurrencyAmountTypeInput {
  /** Amount in the currency. */
  amount?: Maybe<Scalars['Float']>;
  /** Currency code. */
  currencyCode?: Maybe<Scalars['String']>;
}




export interface CurrencyTypeInput {
  /** Default currency amount info */
  defaultCurrencyAmount?: Maybe<CurrencyAmountTypeInput>;
  /** Supply currency amount info */
  supplyCurrencyAmount?: Maybe<CurrencyAmountTypeInput>;
}










/** Gender of the customer */
export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN'
}











/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}




/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}



/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

export enum CustomerNotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS'
}


/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars['Boolean']>;
  /** Notification id */
  id?: Maybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is starred */
  star?: Maybe<Scalars['Boolean']>;
}

/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: Maybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: Maybe<Array<CustomerNotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: Maybe<Scalars['URL']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
  /** list of GAIA regionIds */
  regionIds?: Maybe<Array<Scalars['String']>>;
  /** trip folder id */
  tripFolderId?: Maybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: Maybe<DateRangeInput>;
  /** destination information */
  destination?: Maybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: Maybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: Maybe<Scalars['String']>;
  /** property id */
  propertyId?: Maybe<Scalars['String']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
}



/** The style to apply to phrase links */
export enum CustomerNotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}


/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}








export enum CustomerNotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  CLEANLINESS = 'CLEANLINESS',
  GDPR = 'GDPR',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  OSANO = 'OSANO',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY'
}

/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<CustomerNotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}





export enum DamageLiability {
  COF = 'COF',
  RDD = 'RDD'
}

export enum DashboardType {
  DEFERRED_PAYMENT = 'DEFERRED_PAYMENT',
  PERFORMANCE = 'PERFORMANCE'
}

/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 */
export enum DataSourceType {
  CART = 'CART',
  ENTITY = 'ENTITY',
  OFFER = 'OFFER',
  ORDER = 'ORDER'
}


/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars['Int'];
  /** The numeric month, e.g. `1` for January */
  month: Scalars['Int'];
  /** The four-digit year e.g. `1999` */
  year: Scalars['Int'];
}



/** A generic period of date, not tied to a checkin/out status. */
export interface DatePeriodInput {
  /** The bounding type of period, if defined, otherwise interpreted as a degenerate interval */
  bound?: Maybe<ClosedPeriodBounding>;
  /** The length of period */
  length: Scalars['Int'];
  /** The unit of period */
  unit: DatePeriodUnit;
}

/** The unit of date period */
export enum DatePeriodUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND'
}


/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}


/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: Scalars['Int'];
  /** The hour of the datetime */
  hour: Scalars['Int'];
  /** The minute of the hour */
  minute: Scalars['Int'];
  /** The numeric month of the date */
  month: Scalars['Int'];
  /** The second of the minute */
  second: Scalars['Int'];
  /** The four-digit year of the date */
  year: Scalars['Int'];
}




/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: Scalars['String'];
  value: DateInput;
}

export enum DealType {
  AARP = 'AARP',
  POINTS_PROMOTION = 'POINTS_PROMOTION'
}


/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<ExposureInput>;
  /** ALTER mode */
  alterMode?: Maybe<AlterMode>;
}

export enum DeeplinkType {
  HSR = 'HSR',
  PDP = 'PDP'
}
























export interface DestinationHeadingCriteriaInput {
  /** Max number of images for the given destination. */
  imageLimit?: Maybe<Scalars['Int']>;
  /** Id of the destination. */
  placeId: Scalars['String'];
}


export interface DestinationImageDimensionsInput {
  height: Scalars['Int'];
  width: Scalars['Int'];
}


/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: Maybe<CoordinatesInput>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: Maybe<Array<CoordinatesInput>>;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: Maybe<Scalars['String']>;
  /** List of property IDs to return search information for. */
  propertyIds?: Maybe<Array<Scalars['String']>>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: Maybe<Scalars['String']>;
}










/** Inputs for the destinationGroup query */
export interface DestinationRecommendationCriteriaInput {
  /** Max amount of cards to show */
  maxCards?: Maybe<Scalars['Int']>;
  /** Min amount of cards to show */
  minCards?: Maybe<Scalars['Int']>;
  /** Id of the origin destination */
  referencePlaceId: Scalars['String'];
  /** Strategy for place relationship */
  strategy: DestinationRecommendationStrategy;
  /** Type of destinations in the output */
  type: DestinationRecommendationPlaceType;
}





export enum DestinationRecommendationPlaceType {
  CITY = 'CITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI = 'POI'
}

/** Strategy to select the relationship of the output destinations and the origin */
export enum DestinationRecommendationStrategy {
  NEARBY = 'NEARBY',
  SIMILAR = 'SIMILAR',
  TOP = 'TOP'
}





/** Input for travelGuideRecommendation query */
export enum DestinationTravelGuidePolicy {
  PERSONALIZED = 'PERSONALIZED',
  USER_LOCATION = 'USER_LOCATION'
}





/** Device information */
export interface DeviceInput {
  type: DeviceType;
}

/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP'
}


export enum DialogButtonActionType {
  CLOSE_DIALOG = 'CLOSE_DIALOG',
  CREATE_TRACKING_MUTATION = 'CREATE_TRACKING_MUTATION',
  DISABLE_TRACKING_MUTATION = 'DISABLE_TRACKING_MUTATION',
  UPDATE_TRACKING_MUTATION = 'UPDATE_TRACKING_MUTATION'
}



/** Dimensions for a presentation object i.e. image or icon */
export interface DimensionsInput {
  density: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
}
















export enum DirectFeedbackPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT'
}








export interface DirectFeedbackValuesInput {
  context: Array<GraphQlPairInput>;
  formValues: Array<GraphQlPairInput>;
}


/** A reference place or property for which to show directions to */
export interface DirectionsReferenceInput {
  /** The id of the reference place or property. */
  id: Scalars['String'];
  /** The type of reference, e.g. place, property, etc. */
  type: EgdsMapFeatureType;
}





/** Used as input value to let the server knows what data needs to be populated in a card. */
export enum DiscoveryCardContentSize {
  ABBREVIATED = 'ABBREVIATED',
  FOUNDATION = 'FOUNDATION',
  LONG_FORM = 'LONG_FORM',
  SHORT_FORM = 'SHORT_FORM',
  UBER_ABBREVIATED = 'UBER_ABBREVIATED',
  UBER_ABBREVIATED_PRICE = 'UBER_ABBREVIATED_PRICE',
  UBER_ABBREVIATED_RATING = 'UBER_ABBREVIATED_RATING'
}


/** Represent the context for a destination (eg. information in a landing page). */
export interface DiscoveryDestinationContextInput {
  placeId?: Maybe<DiscoveryPlaceIdInput>;
}




/** Represent the context for lodging (eg. information in a PDP) */
export interface DiscoveryLodgingContextInput {
  checkin?: Maybe<DateInput>;
  checkout?: Maybe<DateInput>;
  propertyId?: Maybe<Scalars['String']>;
  rooms?: Maybe<Array<DiscoveryRoomInput>>;
  searchCriteria?: Maybe<ShoppingSearchCriteriaInput>;
}



/** List of all the managed offering types. */
export enum DiscoveryOfferingType {
  DESTINATION = 'DESTINATION',
  PRODUCT = 'PRODUCT'
}

/** Identifier for a destination, it can contains also the type of a destination (neighborhood, city, airport, etc...) */
export interface DiscoveryPlaceIdInput {
  id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
}

export interface DiscoveryRecentActivityContextInput {
  lodging?: Maybe<DiscoveryLodgingContextInput>;
  marketingChannelTypeCode?: Maybe<Scalars['Int']>;
  outputLineOfBusiness: LineOfBusinessDomain;
}

/** Context values a client can/should fill as input of the recommendations. */
export interface DiscoveryRecommendationContextInput {
  destination?: Maybe<DiscoveryDestinationContextInput>;
  lodging?: Maybe<DiscoveryLodgingContextInput>;
  outputLineOfBusiness?: Maybe<LineOfBusinessDomain>;
}

/** Used to select which parameters should be used to run the inference. */
export enum DiscoveryRecommendationInputContext {
  /** Uses the 'destination' section from the context object. */
  DESTINATION = 'DESTINATION',
  /** Uses the 'product' section from the context object. */
  PRODUCT = 'PRODUCT',
  /** Personalize the recommendations using the latest products a user saw. */
  RECENTLY_VIEWED_PRODUCT = 'RECENTLY_VIEWED_PRODUCT',
  /** Personalize the recommenations using the recent searches of the user. */
  RECENT_SEARCHES = 'RECENT_SEARCHES',
  /** Base the recommendations on the user location. */
  USER_LOCATION = 'USER_LOCATION'
}

/** List of all the managed recommendations strategies. */
export enum DiscoveryRecommendationStrategy {
  ALTERNATIVE = 'ALTERNATIVE',
  NEARBY = 'NEARBY',
  POPULAR = 'POPULAR',
  SIMILAR = 'SIMILAR'
}

/** Represent a room for lodging. */
export interface DiscoveryRoomInput {
  adults: Scalars['Int'];
  children?: Maybe<Array<Scalars['Int']>>;
}




/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = 'KILOMETER',
  MILE = 'MILE'
}







/** Different types of duration span input validations. */
export enum DurationSpanValidationType {
  /** Used to validate that a maximum input value is greater than a minimum input value. */
  MAXIMUM_GREATER_THAN_MINIMUM = 'MAXIMUM_GREATER_THAN_MINIMUM',
  /** Used to validate that the user input is less than or equal to some specified value. Example: Maximum 10 nights. */
  MAXIMUM_VALUE = 'MAXIMUM_VALUE',
  /** Used to validate that a minimum input value is less than a maximum input value. */
  MINIMUM_LESS_THAN_MAXIMUM = 'MINIMUM_LESS_THAN_MAXIMUM',
  /** Used to validate that the user input is greater than or equal to some specified value. Example: Minimum 2 nights. */
  MINIMUM_VALUE = 'MINIMUM_VALUE',
  /** Used to validate that the user input has a value. */
  REQUIRED_VALUE = 'REQUIRED_VALUE'
}





































/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export enum EgdsButtonStyle {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}



/**
 * Represents the variations of a card. Can be used with EGDSCard union members.
 * https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=11143%3A833&t=blroVUeSfs4Eqnoj-0
 */
export enum EgdsCardThemes {
  BORDERED = 'BORDERED',
  PADDED = 'PADDED'
}







/** Defines how checkbox state should be displayed on client. */
export enum EgdsCheckBoxState {
  CHECKED = 'CHECKED',
  INDETERMINATE = 'INDETERMINATE',
  UNCHECKED = 'UNCHECKED'
}













/** Represents the label theme for the date range result. */
export enum EgdsDateRangeResultTheme {
  LINK = 'LINK',
  POSITIVE = 'POSITIVE'
}

/** Represents short day name. */
export enum EgdsDayName {
  FRI = 'FRI',
  MON = 'MON',
  SAT = 'SAT',
  SUN = 'SUN',
  THU = 'THU',
  TUE = 'TUE',
  WED = 'WED'
}

/** Represents the type of decorative in the text element. e.g. superscript */
export enum EgdsDecorativeText {
  /** Renders with a line through the text */
  LINE_THROUGH = 'LINE_THROUGH',
  /** Renders as a subscript at the bottom of the text line */
  SUBSCRIPT = 'SUBSCRIPT',
  /** Renders as a superscript at the top of the text line */
  SUPERSCRIPT = 'SUPERSCRIPT',
  /** Renders with a line under the text */
  UNDERLINE = 'UNDERLINE'
}






















/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSHeading or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EgdsHeadingStyle {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  H7 = 'H7',
  H8 = 'H8'
}

/** Represents where the icon should be places in a EGDS Standard Link */
export enum EgdsIconPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}






/** Option for selecting an infant seat on a plane. */
export enum EgdsInfantSeat {
  IN_SEAT = 'IN_SEAT',
  ON_LAP = 'ON_LAP'
}









/** Represents the size of the text in a EGDS Standard Link */
export enum EgdsLinkSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}











/** The type of feature - PLACE OR PROPERTY */
export enum EgdsMapFeatureType {
  PLACE = 'PLACE',
  PROPERTY = 'PROPERTY'
}

/** The initial viewport to use for the map when markers have been pushed and just before they are rendered */
export enum EgdsMapInitialViewport {
  /** To use bounds value as initial viewport */
  BOUNDS = 'BOUNDS',
  /** To compute a bound from a set of options with a specified center */
  CENTERED_COMPUTED_BOUNDS = 'CENTERED_COMPUTED_BOUNDS',
  /** To use zoom and center values as initial viewport */
  CENTER_AND_ZOOM = 'CENTER_AND_ZOOM',
  /** To compute a bound from a set of options */
  COMPUTED_BOUNDS = 'COMPUTED_BOUNDS',
  /** Will center the map to show all markers pushed to the map */
  FIT_MARKERS = 'FIT_MARKERS'
}


/** Marker pin style based on the applied filter and inventory - AVAILABLE, FILTERED, SOLD_OUT or UNKNOWN */
export enum EgdsMapMarkerStatus {
  AVAILABLE = 'AVAILABLE',
  FILTERED = 'FILTERED',
  SOLD_OUT = 'SOLD_OUT',
  UNKNOWN = 'UNKNOWN'
}

/** 'zoomAndCenter' (requires zoom + center) or 'fitBounds' (map will include all rendered markers) */
export enum EgdsMapPositionMode {
  FIT_BOUNDS = 'FIT_BOUNDS',
  ZOOM_AND_CENTER = 'ZOOM_AND_CENTER'
}

/** type of maps that can be used */
export enum EgdsMapProvider {
  GOOGLE = 'GOOGLE',
  MAPBOX = 'MAPBOX',
  MAPKIT = 'MAPKIT'
}

export enum EgdsMark {
  AARP = 'AARP',
  AARP_MEMBER_BENEFITS = 'AARP_MEMBER_BENEFITS',
  ADDON = 'ADDON',
  AIR_NEW_ZEALAND = 'AIR_NEW_ZEALAND',
  APPLE = 'APPLE',
  APPLE_MAPS = 'APPLE_MAPS',
  APP_CTX = 'APP_CTX',
  APP_EBOOK = 'APP_EBOOK',
  APP_EXP = 'APP_EXP',
  APP_HOTWIRE = 'APP_HOTWIRE',
  APP_ORB = 'APP_ORB',
  APP_TVLY = 'APP_TVLY',
  APP_WOTIF = 'APP_WOTIF',
  BONUS_EBOOK = 'BONUS_EBOOK',
  COMMISSION_TIER_FOUR = 'COMMISSION_TIER_FOUR',
  COMMISSION_TIER_ONE = 'COMMISSION_TIER_ONE',
  COMMISSION_TIER_THREE = 'COMMISSION_TIER_THREE',
  COMMISSION_TIER_TWO = 'COMMISSION_TIER_TWO',
  FACEBOOK = 'FACEBOOK',
  FLAGS__AR = 'FLAGS__AR',
  FLAGS__AS = 'FLAGS__AS',
  FLAGS__AT = 'FLAGS__AT',
  FLAGS__AU = 'FLAGS__AU',
  FLAGS__BE = 'FLAGS__BE',
  FLAGS__BO = 'FLAGS__BO',
  FLAGS__BR = 'FLAGS__BR',
  FLAGS__BZ = 'FLAGS__BZ',
  FLAGS__CA = 'FLAGS__CA',
  FLAGS__CH = 'FLAGS__CH',
  FLAGS__CL = 'FLAGS__CL',
  FLAGS__CN = 'FLAGS__CN',
  FLAGS__CO = 'FLAGS__CO',
  FLAGS__CR = 'FLAGS__CR',
  FLAGS__CZ = 'FLAGS__CZ',
  FLAGS__DE = 'FLAGS__DE',
  FLAGS__DK = 'FLAGS__DK',
  FLAGS__EC = 'FLAGS__EC',
  FLAGS__EE = 'FLAGS__EE',
  FLAGS__EG = 'FLAGS__EG',
  FLAGS__ES = 'FLAGS__ES',
  FLAGS__EU = 'FLAGS__EU',
  FLAGS__FI = 'FLAGS__FI',
  FLAGS__FR = 'FLAGS__FR',
  FLAGS__GR = 'FLAGS__GR',
  FLAGS__GT = 'FLAGS__GT',
  FLAGS__GY = 'FLAGS__GY',
  FLAGS__HK = 'FLAGS__HK',
  FLAGS__HN = 'FLAGS__HN',
  FLAGS__HR = 'FLAGS__HR',
  FLAGS__HU = 'FLAGS__HU',
  FLAGS__ID = 'FLAGS__ID',
  FLAGS__IE = 'FLAGS__IE',
  FLAGS__IL = 'FLAGS__IL',
  FLAGS__IN = 'FLAGS__IN',
  FLAGS__IS = 'FLAGS__IS',
  FLAGS__IT = 'FLAGS__IT',
  FLAGS__JP = 'FLAGS__JP',
  FLAGS__KR = 'FLAGS__KR',
  FLAGS__L1 = 'FLAGS__L1',
  FLAGS__LT = 'FLAGS__LT',
  FLAGS__LV = 'FLAGS__LV',
  FLAGS__MX = 'FLAGS__MX',
  FLAGS__MY = 'FLAGS__MY',
  FLAGS__NI = 'FLAGS__NI',
  FLAGS__NL = 'FLAGS__NL',
  FLAGS__NO = 'FLAGS__NO',
  FLAGS__NZ = 'FLAGS__NZ',
  FLAGS__PA = 'FLAGS__PA',
  FLAGS__PE = 'FLAGS__PE',
  FLAGS__PH = 'FLAGS__PH',
  FLAGS__PL = 'FLAGS__PL',
  FLAGS__PT = 'FLAGS__PT',
  FLAGS__PY = 'FLAGS__PY',
  FLAGS__RU = 'FLAGS__RU',
  FLAGS__SA = 'FLAGS__SA',
  FLAGS__SE = 'FLAGS__SE',
  FLAGS__SG = 'FLAGS__SG',
  FLAGS__SK = 'FLAGS__SK',
  FLAGS__SR = 'FLAGS__SR',
  FLAGS__SV = 'FLAGS__SV',
  FLAGS__TH = 'FLAGS__TH',
  FLAGS__TR = 'FLAGS__TR',
  FLAGS__TW = 'FLAGS__TW',
  FLAGS__UA = 'FLAGS__UA',
  FLAGS__UAE = 'FLAGS__UAE',
  FLAGS__UK = 'FLAGS__UK',
  FLAGS__US = 'FLAGS__US',
  FLAGS__UY = 'FLAGS__UY',
  FLAGS__VE = 'FLAGS__VE',
  FLAGS__VN = 'FLAGS__VN',
  FLAGS__WW = 'FLAGS__WW',
  FLAGS__ZA = 'FLAGS__ZA',
  GOOGLE = 'GOOGLE',
  GOOGLE_LOGO = 'GOOGLE_LOGO',
  GOOGLE_MAP = 'GOOGLE_MAP',
  GOOGLE_TRANSLATED = 'GOOGLE_TRANSLATED',
  HAWAIIAN = 'HAWAIIAN',
  HOTWIRE_HOTRATE_CIRCLE = 'HOTWIRE_HOTRATE_CIRCLE',
  LINE = 'LINE',
  LOYALTY_HOTELS__HIGH_TIER = 'LOYALTY_HOTELS__HIGH_TIER',
  LOYALTY_HOTELS__LOW_TIER = 'LOYALTY_HOTELS__LOW_TIER',
  LOYALTY_HOTELS__MIDDLE_TIER = 'LOYALTY_HOTELS__MIDDLE_TIER',
  LOYALTY_HOTELS__REWARDS = 'LOYALTY_HOTELS__REWARDS',
  LOYALTY_HOTELS__STAMP_EMPTY = 'LOYALTY_HOTELS__STAMP_EMPTY',
  LOYALTY_HOTELS__STAMP_PENDING = 'LOYALTY_HOTELS__STAMP_PENDING',
  LOYALTY_HOTELS__STAMP_SEARCHED = 'LOYALTY_HOTELS__STAMP_SEARCHED',
  LOYALTY_TVLY = 'LOYALTY_TVLY',
  MAPBOX = 'MAPBOX',
  MIP_PRIMARY = 'MIP_PRIMARY',
  MIP_REVERSE = 'MIP_REVERSE',
  MIP_SECONDARY = 'MIP_SECONDARY',
  MOD_CTX = 'MOD_CTX',
  MOD_EBOOK = 'MOD_EBOOK',
  MOD_EXP = 'MOD_EXP',
  MOD_HOTELS = 'MOD_HOTELS',
  MOD_ORB = 'MOD_ORB',
  MOD_TVLY = 'MOD_TVLY',
  MOD_WOTIF = 'MOD_WOTIF',
  NAVER = 'NAVER',
  ONEKEY__ABRITEL = 'ONEKEY__ABRITEL',
  ONEKEY__BLUE = 'ONEKEY__BLUE',
  ONEKEY__BOOKABACH = 'ONEKEY__BOOKABACH',
  ONEKEY__CASH = 'ONEKEY__CASH',
  ONEKEY__EXPEDIA = 'ONEKEY__EXPEDIA',
  ONEKEY__FEWODIREKT = 'ONEKEY__FEWODIREKT',
  ONEKEY__GOLD = 'ONEKEY__GOLD',
  ONEKEY__HOTELS__CHINESE = 'ONEKEY__HOTELS__CHINESE',
  ONEKEY__HOTELS__ENGLISH = 'ONEKEY__HOTELS__ENGLISH',
  ONEKEY__HOTELS__PORTUGUESE = 'ONEKEY__HOTELS__PORTUGUESE',
  ONEKEY__HOTELS__SPANISH = 'ONEKEY__HOTELS__SPANISH',
  ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT = 'ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT',
  ONEKEY__PLATINUM = 'ONEKEY__PLATINUM',
  ONEKEY__SILVER = 'ONEKEY__SILVER',
  ONEKEY__STANDARD = 'ONEKEY__STANDARD',
  ONEKEY__STANDARD__ALWAYS_LIGHT = 'ONEKEY__STANDARD__ALWAYS_LIGHT',
  ONEKEY__STAYZ = 'ONEKEY__STAYZ',
  ONEKEY__VRBO = 'ONEKEY__VRBO',
  ONEKEY__WORDMARK = 'ONEKEY__WORDMARK',
  ONEKEY__WORDMARK__ALWAYS_LIGHT = 'ONEKEY__WORDMARK__ALWAYS_LIGHT',
  PAYMENT__7_ELEVEN = 'PAYMENT__7_ELEVEN',
  PAYMENT__AFFIRM = 'PAYMENT__AFFIRM',
  PAYMENT__AIRPLUS = 'PAYMENT__AIRPLUS',
  PAYMENT__ALIPAY = 'PAYMENT__ALIPAY',
  PAYMENT__AMEX = 'PAYMENT__AMEX',
  PAYMENT__APPLEPAY = 'PAYMENT__APPLEPAY',
  PAYMENT__CHASE = 'PAYMENT__CHASE',
  PAYMENT__CLICKTOPAY = 'PAYMENT__CLICKTOPAY',
  PAYMENT__DINERS_CLUB_INTERNATIONAL = 'PAYMENT__DINERS_CLUB_INTERNATIONAL',
  PAYMENT__DISCOVER = 'PAYMENT__DISCOVER',
  PAYMENT__GOOGLE_PAY = 'PAYMENT__GOOGLE_PAY',
  PAYMENT__IDEAL = 'PAYMENT__IDEAL',
  PAYMENT__JAPAN_CREDIT_BUREAU = 'PAYMENT__JAPAN_CREDIT_BUREAU',
  PAYMENT__KLARNA = 'PAYMENT__KLARNA',
  PAYMENT__MAESTRO = 'PAYMENT__MAESTRO',
  PAYMENT__MASTERCARD = 'PAYMENT__MASTERCARD',
  PAYMENT__MASTERPASS = 'PAYMENT__MASTERPASS',
  PAYMENT__PAYPAL = 'PAYMENT__PAYPAL',
  PAYMENT__SAMSUNG_CARD = 'PAYMENT__SAMSUNG_CARD',
  PAYMENT__UATP = 'PAYMENT__UATP',
  PAYMENT__UNION_PAY = 'PAYMENT__UNION_PAY',
  PAYMENT__VISA = 'PAYMENT__VISA',
  PLUS_CIRCLE = 'PLUS_CIRCLE',
  PLUS_CIRCLE_CTX = 'PLUS_CIRCLE_CTX',
  PLUS_CIRCLE_EBOOK = 'PLUS_CIRCLE_EBOOK',
  PLUS_CIRCLE_ORB = 'PLUS_CIRCLE_ORB',
  PLUS_CIRCLE_TVLY = 'PLUS_CIRCLE_TVLY',
  PLUS_CIRCLE_WOTIF = 'PLUS_CIRCLE_WOTIF',
  PREMIUM_TVLY = 'PREMIUM_TVLY',
  REWARDS_ORB = 'REWARDS_ORB',
  TRIPADVISOR = 'TRIPADVISOR',
  TRIVAGO = 'TRIVAGO',
  VAP_HOTELS__HIGH_TIER = 'VAP_HOTELS__HIGH_TIER',
  VAP_HOTELS__LOW_TIER = 'VAP_HOTELS__LOW_TIER',
  VAP_HOTELS__MIDDLE_TIER = 'VAP_HOTELS__MIDDLE_TIER',
  VIP_BEX = 'VIP_BEX',
  VIP_CIRCLE_BEX = 'VIP_CIRCLE_BEX',
  VIP_CIRCLE_EBOOKERS = 'VIP_CIRCLE_EBOOKERS',
  VIP_CIRCLE_HOTELS = 'VIP_CIRCLE_HOTELS',
  VIP_CIRCLE_ORBITZ = 'VIP_CIRCLE_ORBITZ',
  VIP_EBOOKERS = 'VIP_EBOOKERS',
  VIP_ORBITZ = 'VIP_ORBITZ',
  VIRGIN_AU = 'VIRGIN_AU',
  VRBO = 'VRBO'
}





















/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EgdsParagraphStyle {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3'
}


/** The type of path for directions */
export enum EgdsPathType {
  CYCLING = 'CYCLING',
  DRIVING = 'DRIVING',
  FLYING = 'FLYING',
  TRANSIT = 'TRANSIT',
  WALKING = 'WALKING'
}

/** Possible camera movement for the photosphere image */
export enum EgdsPhotosphereCameraMovement {
  AUTO_PAN = 'AUTO_PAN',
  DISABLED = 'DISABLED',
  FULL_MOVE = 'FULL_MOVE'
}






































/** Type of EGDSSheet */
export enum EgdsSheetType {
  BOTTOM = 'BOTTOM',
  CENTERED = 'CENTERED',
  FULLSCREEN = 'FULLSCREEN',
  POPOVER = 'POPOVER',
  SIDE = 'SIDE'
}





























export enum EgdsTextListItemStyle {
  DEFAULT = 'DEFAULT',
  EMPHASIS = 'EMPHASIS',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}


/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export enum EgdsTextListSize {
  LIST_1 = 'LIST_1',
  LIST_2 = 'LIST_2',
  LIST_3 = 'LIST_3'
}

/**
 * This represents UI variations of EGDS List
 *        figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 */
export enum EgdsTextListType {
  BULLET = 'BULLET',
  ICON = 'ICON',
  NO_BULLET = 'NO_BULLET',
  NUMBER = 'NUMBER'
}

















/** Represents different type of travelers validation. */
export enum EgdsTravelersValidationType {
  /** Used to validate child age required. */
  CHILD_AGE_REQUIRED = 'CHILD_AGE_REQUIRED',
  /** Used to validate maximum number of allowed infants in seat. */
  MANY_INFANT_IN_SEAT = 'MANY_INFANT_IN_SEAT',
  /** Used to validate maximum number of allowed infants on lap. */
  MANY_INFANT_ON_LAP = 'MANY_INFANT_ON_LAP',
  /** Used to validate maximum allowed travelers for search. */
  MAX_TRAVELERS = 'MAX_TRAVELERS'
}



/** Defines how typeahead results should be displayed on client. */
export enum EgdsTypeaheadRenderType {
  ADAPTIVE = 'ADAPTIVE',
  DIALOG = 'DIALOG',
  MENU = 'MENU'
}



/**
 * Used to specify event type for an interaction.
 * See https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/referrer.json#L26
 */
export enum EgReferrerEventType {
  /** Used to track a click on a UI component. */
  CLICK = 'CLICK',
  /** Used to track an impression of a UI component. */
  IMPRESSION = 'IMPRESSION'
}


















































/**
 * "The `EssentialInfoItemInput` contains essentialInfoItemId along with bookingItemID separated by -. eg. 1-4020303
 * essentialInfoItemId identifies which essential info to render and bookingItemID is used as an parameter to lodgingDemandReservationService's getVrStayEssentialInfo API
 */
export interface EssentialInfoItemInput {
  itemId: Scalars['String'];
}


export enum EventType {
  DELETETRIPALERTPRESENTED = 'DeleteTripAlertPresented',
  DELETETRIPDIALOGPRESENTED = 'DeleteTripDialogPresented',
  DELETETRIPERRORTOASTPRESENTED = 'DeleteTripErrorToastPresented',
  DELETETRIPFAILED = 'DeleteTripFailed',
  DELETETRIPSUCCEEDED = 'DeleteTripSucceeded',
  DELETETRIPSUCCESSTOASTPRESENTED = 'DeleteTripSuccessToastPresented',
  HEROMODULECAMPAIGN = 'HeroModuleCampaign',
  HEROMODULECOLDSTART = 'HeroModuleColdStart',
  ITINACTIVECAR = 'ItinActiveCar',
  ITINACTIVECRUISE = 'ItinActiveCruise',
  ITINACTIVEFLIGHT = 'ItinActiveFlight',
  ITINACTIVEGT = 'ItinActiveGT',
  ITINACTIVEHOTEL = 'ItinActiveHotel',
  ITINACTIVELX = 'ItinActiveLX',
  ITINACTIVEPACKAGEFH = 'ItinActivePackageFH',
  ITINACTIVERAIL = 'ItinActiveRail',
  ITINCANCELLATION = 'ItinCancellation',
  MOVEITEMDRAWERPRESENTED = 'MoveItemDrawerPresented',
  MOVEITEMERRORTOASTPRESENTED = 'MoveItemErrorToastPresented',
  MOVEITEMSUBMITTED = 'MoveItemSubmitted',
  MOVEITEMSUCCESSTOASTPRESENTED = 'MoveItemSuccessToastPresented',
  MOVEITEMSUCEEDED = 'MoveItemSuceeded',
  MOVELINKEDITEMSDIALOGPRESENTED = 'MoveLinkedItemsDialogPresented',
  REMOVEITEMDIALOGPRESENTED = 'RemoveItemDialogPresented',
  TRIPITEMMENUPRESENTED = 'TripItemMenuPresented',
  TRIPSIGNINDIALOGPRESENTED = 'TripSignInDialogPresented',
  TRIPSCOLLABINVITECONFIRMATIONVIEWED = 'TripsCollabInviteConfirmationViewed',
  TRIPSCOLLABINVITEFAILUREVIEWED = 'TripsCollabInviteFailureViewed',
  TRIPSCOLLABINVITESUCCEEDED = 'TripsCollabInviteSucceeded',
  TRIPSCOLLABJOINGROUPFAILED = 'TripsCollabJoinGroupFailed',
  TRIPSCOLLABJOINGROUPSUCCEEDED = 'TripsCollabJoinGroupSucceeded',
  TRIPSCOLLABJOINTRIPCONFIRMATIONVIEWED = 'TripsCollabJoinTripConfirmationViewed',
  TRIPSCOLLABJOINTRIPERRORTOASTPRESENTED = 'TripsCollabJoinTripErrorToastPresented',
  TRIPSCOLLABLANDINGSCREENREDIRECTTOTRIPOVERVIEW = 'TripsCollabLandingScreenRedirectToTripOverView',
  TRIPSCOLLABLANDINGSCREENVIEWED = 'TripsCollabLandingScreenViewed',
  TRIPSCOLLABMANAGEGROUPVIEWED = 'TripsCollabManageGroupViewed',
  TRIPSCOLLABVIEWPRESENTEDACTIVITIES = 'TripsCollabViewPresentedActivities',
  TRIPSCOLLABVIEWPRESENTEDCARS = 'TripsCollabViewPresentedCars',
  TRIPSCOLLABVIEWPRESENTEDCRUISE = 'TripsCollabViewPresentedCruise',
  TRIPSCOLLABVIEWPRESENTEDFLIGHT = 'TripsCollabViewPresentedFlight',
  TRIPSCOLLABVIEWPRESENTEDHOTEL = 'TripsCollabViewPresentedHotel',
  TRIPSCOLLABVIEWPRESENTEDVACATIONRENTAL = 'TripsCollabViewPresentedVacationRental',
  TRIPSEDITITEMSUCCEEDED = 'TripsEditItemSucceeded',
  TRIPSEDITTRIPERRORTOASTPRESENTED = 'TripsEditTripErrorToastPresented',
  TRIPSEDITTRIPPRESENTED = 'TripsEditTripPresented',
  TRIPSEDITTRIPSUBMITTED = 'TripsEditTripSubmitted',
  TRIPSEDITTRIPSUCCESSTOASTPRESENTED = 'TripsEditTripSuccessToastPresented',
  TRIPSFLIGHTSCHEDULECHANGEBANNERDISPLAYED = 'TripsFlightScheduleChangeBannerDisplayed',
  TRIPSHEROMODULECURRENTTRIP = 'TripsHeroModuleCurrentTrip',
  TRIPSHEROMODULEPOSSIBLEACTIVITYTRIP = 'TripsHeroModulePossibleActivityTrip',
  TRIPSHEROMODULEPOSSIBLEAIRTRIP = 'TripsHeroModulePossibleAirTrip',
  TRIPSHEROMODULEPOSSIBLECARTRIP = 'TripsHeroModulePossibleCarTrip',
  TRIPSHEROMODULEPOSSIBLEHOTELTRIP = 'TripsHeroModulePossibleHotelTrip',
  TRIPSHEROMODULEPOSSIBLEPACKAGEHFTRIP = 'TripsHeroModulePossiblePackageHFTrip',
  TRIPSHEROMODULEPOSSIBLETRIP = 'TripsHeroModulePossibleTrip',
  TRIPSHEROMODULEPOTENTIALTRIP = 'TripsHeroModulePotentialTrip',
  TRIPSHEROMODULEUPCOMINGTRIP = 'TripsHeroModuleUpcomingTrip',
  TRIPSITEMDETAILVIEWED = 'TripsItemDetailViewed',
  TRIPSLISTVIEWED = 'TripsListViewed',
  TRIPSMODULEDESTINATIONGUIDE = 'TripsModuleDestinationGuide',
  TRIPSMODULERECOMMENDEDACTIVITY = 'TripsModuleRecommendedActivity',
  TRIPSMODULERECOMMENDEDCAR = 'TripsModuleRecommendedCar',
  TRIPSMODULERECOMMENDEDHOTEL = 'TripsModuleRecommendedHotel',
  TRIPSOVERVIEWVIEWED = 'TripsOverviewViewed',
  TRIPSTRAVELPLANNERITINNUMBERPRESENT = 'TripsTravelPlannerItinNumberPresent',
  UNKNOWN = 'Unknown'
}



export enum ExpLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}



/** Specifies the position of the trigger icon  */
export enum ExpandoTriggerPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}















/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: Scalars['Int'];
  /** The numeric Abacus ID for an experiment */
  id: Scalars['String'];
}

export enum FacetType {
  BUTTON = 'BUTTON',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  SLIDER = 'SLIDER'
}





















/** Represents the state of the fare */
export enum FareState {
  /** Fare is selected on meta search, but it has unselected visual state */
  META_UNSELECTED = 'META_UNSELECTED',
  /** Fare is selected */
  SELECTED = 'SELECTED',
  /** Fare is selected with PMP */
  SELECTED_PMP_SELECTED = 'SELECTED_PMP_SELECTED',
  /** Fare is unselected */
  UNSELECTED = 'UNSELECTED',
  /** Fare is unselected with PMP */
  UNSELECTED_PMP_SELECTED = 'UNSELECTED_PMP_SELECTED'
}






export enum FeeType {
  CARD_ON_FILE_DAMAGE_LIABILITY = 'CARD_ON_FILE_DAMAGE_LIABILITY',
  DEFAULT = 'DEFAULT',
  DEFAULT_SUPPLIER_COLLECTED = 'DEFAULT_SUPPLIER_COLLECTED',
  GROUPED_MANDATORY_FEES = 'GROUPED_MANDATORY_FEES',
  L26_TAX_BREAKOUT = 'L26_TAX_BREAKOUT',
  NORMAL = 'NORMAL',
  OTHER = 'OTHER',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PROPERTY = 'PROPERTY',
  REFUNDABLE_DAMAGE_DEPOSIT = 'REFUNDABLE_DAMAGE_DEPOSIT',
  RESORT = 'RESORT'
}















/** The filter placement for the map view */
export enum FilterPlacement {
  /** Display the filters on the bottom, over the map */
  OVERLAY_BOTTOM = 'OVERLAY_BOTTOM',
  /** Display the filters on the top, over the map */
  OVERLAY_TOP = 'OVERLAY_TOP',
  /** Display the filters in the toolbar */
  TOOLBAR = 'TOOLBAR'
}

/** Enum class to represent the type of flexible change policies */
export enum FilterPolicyType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}

/** Enum class to represent the type of travel and baggage */
export enum FilterTravelAndBaggageType {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}









export enum FlavorType {
  DEMO = 'DEMO',
  INT = 'INT',
  LAB = 'LAB',
  PROD = 'PROD',
  SANDBOX = 'SANDBOX'
}

/** Controls the alignment along the cross axis. */
export enum FlexAlignItems {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
  STRETCH = 'STRETCH'
}

/** The direction children items are placed inside the flex container, it determines the direction of the main axis (and the cross axis, perpendicular to the main axis). */
export enum FlexDirection {
  ROW = 'ROW'
}

/** Controls the alignment along the main axis. */
export enum FlexJustifyContent {
  CENTER = 'CENTER',
  END = 'END',
  SPACE_AROUND = 'SPACE_AROUND',
  SPACE_BETWEEN = 'SPACE_BETWEEN',
  START = 'START'
}

/** Controls whether the flex container is single-line or multi-line, and the direction of the cross axis. */
export enum FlexWrap {
  NOWRAP = 'NOWRAP'
}


/** The core criteria needed for a flex search */
export interface FlexibleSearchCriteriaInput {
  /** The raw flexibility of the search */
  flexibility?: Maybe<Array<DatePeriodInput>>;
  flexibleSearchMonths?: Maybe<Array<Scalars['Int']>>;
  flexibleSearchTripDurationType?: Maybe<FlexibleSearchTripDurationType>;
  numFlexibleDays?: Maybe<Scalars['Int']>;
  /** The search range for the flexible search */
  searchRange?: Maybe<Array<DateRangeInput>>;
}

/** The trip duration type for the flex search */
export enum FlexibleSearchTripDurationType {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND'
}



export interface FlightAncillaryBagSelectionInput {
  /** Represents count of options available for corresponding bag */
  availableOptionsCount?: Maybe<Scalars['Int']>;
  /** Represents index of the selected bag */
  selectedBagIndex: Scalars['Int'];
  /** Represents the price of selected bag */
  selectedBagPrice?: Maybe<Scalars['Float']>;
}


/** Represents details of air ancillary selections for a journey */
export interface FlightAncillaryJourneySelectionInput {
  /** Represents the state of `apply same ancillaries for all travellers` checkbox */
  applySameAncillaryForAllTravellers: Scalars['Boolean'];
  /** It's contains the count of included checked bag */
  checkedBagIncluded?: Maybe<Scalars['Int']>;
  /** Represents list of selected ancillaries for each traveller */
  flightAncillaryTravelerSelections: Array<FlightAncillaryTravelerSelectionInput>;
  /** Represents index of the journey */
  journeyIndex: Scalars['Int'];
}


/** Represents list of selected ancillaries for a traveller */
export interface FlightAncillaryTravelerSelectionInput {
  /** Represents sequence index of the combined ancillaries in cache */
  combinedAncillaryIndex?: Maybe<Scalars['Int']>;
  /** Represents list of selected bags */
  flightAncillaryBagSelections: Array<FlightAncillaryBagSelectionInput>;
  /** Represents index of the traveller */
  travelerIndex: Scalars['Int'];
}


export enum FlightCabinClassInfo {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}

/** Flight cabin class */
export enum FlightClass {
  BUSINESS = 'BUSINESS',
  ECONOMY = 'ECONOMY',
  FIRST_CLASS = 'FIRST_CLASS',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}


/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = 'CAR',
  HOTEL = 'HOTEL'
}






/** Represents the enum for flight journey status */
export enum FlightJourneyStatus {
  /** Represents that the segment status as failure */
  FAILURE = 'FAILURE',
  /** Represents that the segment status as success */
  SUCCESS = 'SUCCESS'
}



/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: Scalars['String'];
  productTokens: Array<Scalars['String']>;
  travelers: Array<TravelerDetailsInput>;
}




/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}









/** Represent Type for the values of FlightSelectableAncillaryOption */
export enum FlightSelectableAncillaryOptionValuesType {
  /** Represents NONE value */
  NONE = 'NONE',
  /** Represents a Valid value | eg: upto 15 kg */
  VALID = 'VALID'
}
















/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  /** Checkbox. Example: To add Price Match Promise */
  CHECKBOX = 'CHECKBOX',
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  PRIMARY = 'PRIMARY',
  /** Radio Button. Example: To choose seats for a particular traveler */
  RADIO_BUTTON = 'RADIO_BUTTON',
  /** Secondary action. */
  SECONDARY = 'SECONDARY',
  /** Switch toggle action. Example: price alerts subscription toggle */
  SWITCH = 'SWITCH',
  /** Tertiary action. Example: 'No Thanks' */
  TERTIARY = 'TERTIARY',
  /** Toggle action. Example: seat button in seat map */
  TOGGLE = 'TOGGLE'
}


/** Available action types an actionable element */
export enum FlightsActionType {
  /** Add Price Match Promise to the seleted fare */
  ADD_PRICE_MATCH_PROMISE = 'ADD_PRICE_MATCH_PROMISE',
  /** User has selected seat(s) for all passengers in that leg */
  ALL_SEATS_SELECTED_FOR_A_LEG = 'ALL_SEATS_SELECTED_FOR_A_LEG',
  /** Selects the chosen fare and reloads dynamic elements */
  APPLY_FARE = 'APPLY_FARE',
  /** Highlights the fare chosen by the user */
  CHOOSE_FARE = 'CHOOSE_FARE',
  /** Dialog Box used when customer clicks the 'Next Flight' Button before selecting seats for Current Flight */
  CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG = 'CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG',
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG = 'CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Go to coupon credit page */
  COUPON_CREDIT = 'COUPON_CREDIT',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Activates the suggested filter */
  ENABLE_SUGGESTED_FILTER = 'ENABLE_SUGGESTED_FILTER',
  /** Fetch more search listings */
  FETCH_SEARCH_LISTINGS = 'FETCH_SEARCH_LISTINGS',
  /** Redirect used when customer clicks signin/signup page/module option from 'you might have credits module listing' */
  GO_TO_AUTH = 'GO_TO_AUTH',
  /** Go to Checkout page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the next set of journey results */
  GO_TO_NEXT_JOURNEY = 'GO_TO_NEXT_JOURNEY',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Redirects to flights search page */
  GO_TO_SEARCH = 'GO_TO_SEARCH',
  /** Redirects back to storefront */
  GO_TO_STOREFRONT = 'GO_TO_STOREFRONT',
  /** Opens a dialog for to display cross sell information */
  LOAD_CROSS_SELL_DIALOG = 'LOAD_CROSS_SELL_DIALOG',
  /** open amenities tray and upsell options for standard offer flight listings */
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = 'LOAD_STANDARD_OFFER_FARE_RULE_MODULE',
  /** Opens a dialog to display tax breakdown information */
  LOAD_TAX_BREAKDOWN_DIALOG = 'LOAD_TAX_BREAKDOWN_DIALOG',
  /** User has not selected seat(s) for any passengers in that leg */
  NO_SEATS_SELECTED_FOR_A_LEG = 'NO_SEATS_SELECTED_FOR_A_LEG',
  /** Opens bags selection alert dialog on clicking on checkout button on FIS */
  OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT = 'OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT',
  /** Opens sidesheet for bags selection */
  OPEN_BAGS_SELECTION_SHEET = 'OPEN_BAGS_SELECTION_SHEET',
  /** Opens a dialog to to go to Airlines Site for Booking */
  OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG = 'OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG',
  /** Dialog Box used when customer clicks the 'Select credit' or 'Change Credit' option from 'you might have credits module listing' */
  OPEN_CREDIT_DIALOG = 'OPEN_CREDIT_DIALOG',
  /** Open Fare Seat information when clicked on required seat button */
  OPEN_FARE_SEAT_MAP_SEAT_SHEET = 'OPEN_FARE_SEAT_MAP_SEAT_SHEET',
  /** Open Fare Seat view to preview the seat map */
  OPEN_FARE_SEAT_MAP_VIEW = 'OPEN_FARE_SEAT_MAP_VIEW',
  /** Open Fare Seat view to select the seat */
  OPEN_FARE_SEAT_SELECT_VIEW = 'OPEN_FARE_SEAT_SELECT_VIEW',
  /** Open Flight leg drop down in seat map view */
  OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG = 'OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG',
  /** Open Legend info sheet in bottom in case of mobile */
  OPEN_LEGEND_INFO_SHEET_MOBILE = 'OPEN_LEGEND_INFO_SHEET_MOBILE',
  /** Open price summary */
  OPEN_PRICE_SUMMARY = 'OPEN_PRICE_SUMMARY',
  /** Opens seat selection alert dialog on clicking on checkout button on FIS */
  OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT = 'OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT',
  /** Redirects to Airlines Site for Booking */
  REDIRECT_TO_AIRLINES_FOR_BOOKING = 'REDIRECT_TO_AIRLINES_FOR_BOOKING',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Actionable item to add a journey */
  SEARCH_FORM_ADD_JOURNEY = 'SEARCH_FORM_ADD_JOURNEY',
  /** Closes the expanded Search Form */
  SEARCH_FORM_CLOSE_BUTTON = 'SEARCH_FORM_CLOSE_BUTTON',
  /** Actionable item to remove a journey */
  SEARCH_FORM_REMOVE_JOURNEY = 'SEARCH_FORM_REMOVE_JOURNEY',
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG = 'SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Continues to flight details page after selecting seats for all flights */
  SEAT_MAP_CONTINUE_BOOKING = 'SEAT_MAP_CONTINUE_BOOKING',
  /** Closes the current flight seat selection page and continues for next flight */
  SEAT_MAP_GO_TO_NEXT_FLIGHT = 'SEAT_MAP_GO_TO_NEXT_FLIGHT',
  /** Go to next flight section for selecting seats */
  SEAT_MAP_NEXT_FLIGHT = 'SEAT_MAP_NEXT_FLIGHT',
  /** Saves user's seat preferences and redirects to FIS */
  SEAT_MAP_SAVE_AND_EXIT = 'SEAT_MAP_SAVE_AND_EXIT',
  /** Stays at Page displaying Seat Map when selected by user */
  SEAT_MAP_STAY_HERE = 'SEAT_MAP_STAY_HERE',
  /** Continues to stay on the current flight seat selection page */
  SEAT_MAP_STAY_ON_THIS_PAGE = 'SEAT_MAP_STAY_ON_THIS_PAGE',
  /** Allows User to Continue Booking from the Seat Selection Dialog Box */
  SEAT_SELECT_DIALOG_CONTINUE_BOOKING = 'SEAT_SELECT_DIALOG_CONTINUE_BOOKING',
  /** Displays seat map preview corresponding to each traveler */
  SEAT_SELECT_PREVIEW_FOR_TRAVELER = 'SEAT_SELECT_PREVIEW_FOR_TRAVELER',
  /** Select Flight leg in seat map drop down menu */
  SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG = 'SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG',
  /** Select the seat */
  SELECT_SEAT = 'SELECT_SEAT',
  /** Open Opinion Lab Share Feedback dialogue */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Open a modal showing details of the free Price Match Promise product */
  SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS',
  /** Open a modal showing details of the Price Match Promise product */
  SHOW_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_PRICE_MATCH_PROMISE_DETAILS',
  /** User has selected seat(s) for at least 1 passenger but not all passengers in that leg */
  SOME_SEATS_SELECTED_FOR_A_LEG = 'SOME_SEATS_SELECTED_FOR_A_LEG',
  /** Subscribe to emails */
  SUBSCRIBE_TO_EMAILS = 'SUBSCRIBE_TO_EMAILS',
  /** Subscribe/Unsubscribes from price alerts */
  TOGGLE_PRICE_ALERTS = 'TOGGLE_PRICE_ALERTS',
  /** Unselect the selected seat */
  UNSELECT_SEAT = 'UNSELECT_SEAT',
  /** Opens FIS sidesheet and highlights next fare to upgrade */
  UPGRADE_TO_NEXT_FARE = 'UPGRADE_TO_NEXT_FARE'
}




/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = 'NONSTOP',
  REFUNDABLE = 'REFUNDABLE'
}

/** Represents details of air ancillary selection request */
export interface FlightsAirAncillarySelectionDetailInput {
  /** Represents index of each traveler. Example: '1' */
  travelerIndex: Scalars['Int'];
  /** Represents details of flight, ancillaries in encoded form mapped to each traveler. */
  unselectedAirAncillaryProductToken: Scalars['String'];
}




/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: Scalars['String'];
}








/** Ancillary summary criteria for the selected fare */
export interface FlightsAncillaryCriteriaInput {
  /** Represents ancillaryID to signify whether ancillaries were selected, null when no ancillaries were selected. */
  ancillaryId?: Maybe<Scalars['String']>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: Maybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents the ancillary requested in the summary */
  ancillaryType: FlightsAncillaryType;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: Maybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight, null for first call on page load */
  selectedOfferToken?: Maybe<Scalars['String']>;
}





/** Enum class to represent the ancillary display action */
export enum FlightsAncillaryDisplayAction {
  NONE = 'NONE',
  PREFETCH = 'PREFETCH'
}










/** Accessibility message types to be announced post selection */
export enum FlightsAncillarySelectionAccessibilityMsgType {
  /** Ancillary Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Ancillary Selection Success */
  SELECTION_SUCCESS = 'SELECTION_SUCCESS'
}

/** Error types which can occur during ancillary selection */
export enum FlightsAncillarySelectionErrorType {
  /** Baggage Details loaded call failed */
  BAGGAGE_DETAILS_LOADED_FAILED = 'BAGGAGE_DETAILS_LOADED_FAILED',
  /** Ancillary details loading failed */
  DETAILS_LOADING_FAILED = 'DETAILS_LOADING_FAILED',
  /** Ancillary Pre-Selection Unavailable */
  PRE_SELECTION_FAILED = 'PRE_SELECTION_FAILED',
  /** Ancillary Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Ancillary Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE'
}









/** Type of ancillaries supported */
export enum FlightsAncillaryType {
  BAGS = 'BAGS',
  BAGS_V2 = 'BAGS_V2',
  SEATS = 'SEATS'
}








/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  BRAND = 'BRAND',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  VIEWED = 'VIEWED',
  VIP = 'VIP'
}




















/** Represents the button width in the UI */
export enum FlightsButtonWidth {
  /** Button will take the width it needs */
  DEFAULT = 'DEFAULT',
  /** Button will take the full width of the content */
  FULL_WIDTH = 'FULL_WIDTH'
}

/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}




/** Represents the value associated with travel and baggage filter - carry on bag */
export interface FlightsCarryOnBagBasedFilterValueInput {
  carryOnBag: CarryOnBagType;
}








/** Represents the value associated with travel and baggage filter - checked bag */
export interface FlightsCheckedBagBasedFilterValueInput {
  numOfCheckedBags: Scalars['Int'];
}











/** Represents the value credit eligible filter */
export interface FlightsCreditEligibleFilterValueInput {
  creditEligible: CreditEligibleFilterType;
}













/** Represents an individual cross sort parameter */
export interface FlightsCrossSortOptionInput {
  /** Enumeration of the parameter type for the accompanying weight */
  type: FlightsCrossSortType;
  /** The current weight of the individual cross sort parameter */
  weight: Scalars['Int'];
}


/** User specified parameters for cross sort */
export interface FlightsCrossSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOption: Array<FlightsCrossSortOptionInput>;
}



/** Enum class to represent cross sort types */
export enum FlightsCrossSortType {
  CABIN_CLASS = 'CABIN_CLASS',
  CANCELLATION = 'CANCELLATION',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHANGE_ALLOWED = 'CHANGE_ALLOWED',
  CHECKED_BAG = 'CHECKED_BAG',
  DURATION = 'DURATION',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PRICE = 'PRICE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}


/** Represents criteria for continue booking for selecting ancillaries on flight information page */
export interface FlightsDetailAncillaryUpdateCriteriaInput {
  /** Represents details of air ancillary selection request */
  airAncillaryDetails: Array<FlightsAirAncillarySelectionDetailInput>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: Maybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents the ancillary type for update */
  ancillaryType?: Maybe<FlightsAncillaryType>;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: Maybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
}

/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
  /** Represents Price of the selected flight */
  originalPrice?: Maybe<MoneyInput>;
  /** Represents QueryParams of the selected flight */
  queryParams?: Maybe<Array<GraphQlPairInput>>;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: Array<FlightsTravelerDetailsInput>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars['String']>;
}


/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** This will contain the list of ancillaries for which auto shopping is complete. */
  additionalShoppedAncillaries?: Maybe<Array<AdditionalShoppedAncillaries>>;
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: Maybe<Scalars['String']>;
  /** Represents the type of the channel for example VirtualAgent */
  channelType?: Maybe<ChannelType>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars['String']>;
}








/** Represents the information of the user device */
export interface FlightsDevicePermissionsInput {
  /** Represents the array of all the notifications enabled for the user device */
  pushNotificationsEnabled: Array<NotificationsType>;
}


/** Represents flights dialog actions */
export enum FlightsDialogAction {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  TOGGLE = 'TOGGLE'
}

/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = 'FADE',
  NONE = 'NONE'
}




/** Represents IDs for flights dialogs */
export enum FlightsDialogId {
  /** Represents the Airlines credit dialog */
  AIRLINE_CREDITS = 'AIRLINE_CREDITS',
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  BAGGAGE_CLOSE_COMPLETE_DIALOG = 'BAGGAGE_CLOSE_COMPLETE_DIALOG',
  /** Represents the Close button dialog for the baggage details */
  BAGGAGE_CLOSE_DIALOG = 'BAGGAGE_CLOSE_DIALOG',
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  BAGGAGE_CLOSE_INCOMPLETE_DIALOG = 'BAGGAGE_CLOSE_INCOMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  BAGGAGE_CONTINUE_BOOKING = 'BAGGAGE_CONTINUE_BOOKING',
  /** Represents the dialog ID for Baggage details */
  BAGGAGE_DETAILS_DIALOG = 'BAGGAGE_DETAILS_DIALOG',
  /** Represents the bags popup dialog on checkout button */
  BAGS_POPUP_ON_CHECKOUT = 'BAGS_POPUP_ON_CHECKOUT',
  /** Represents the check credits dialog for users coming from MCC and VA */
  CHECK_CREDITS_DIALOG = 'CHECK_CREDITS_DIALOG',
  /** Represents the Flights Details and Fares dialog */
  FLIGHTS_DETAILS_AND_FARES = 'FLIGHTS_DETAILS_AND_FARES',
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FORCED_CHOICE_MODAL = 'FORCED_CHOICE_MODAL',
  /** Represents the How Airlines Work dialog inside Select Credits */
  HOW_CREDITS_WORK = 'HOW_CREDITS_WORK',
  /** Represents the Leave This Page dialog inside Select Credits */
  LEAVE_TO_COUPONS = 'LEAVE_TO_COUPONS',
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  PAID_BAGS_DIALOG = 'PAID_BAGS_DIALOG',
  /** Represents the Info dialog for Price Match Promise Selected Card */
  PMP_INFO_DIALOG = 'PMP_INFO_DIALOG',
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  PMP_REMOVE_DIALOG = 'PMP_REMOVE_DIALOG',
  /** Represents the seats popup dialog on checkout button */
  SEATS_POPUP_ON_CHECKOUT = 'SEATS_POPUP_ON_CHECKOUT',
  /** Represents the Close button dialog for the seat details */
  SEAT_CLOSE_COMPLETE_DIALOG = 'SEAT_CLOSE_COMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  SEAT_CONTINUE_BOOKING = 'SEAT_CONTINUE_BOOKING',
  /** Represents the dialog ID for seat legends dialog */
  SEAT_LEGEND_DIALOG = 'SEAT_LEGEND_DIALOG',
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  SEAT_SELECTION_DIALOG = 'SEAT_SELECTION_DIALOG',
  /** Represents the dialog on traveler mismatch for credits offer */
  TRAVELER_MISMATCH_DIALOG = 'TRAVELER_MISMATCH_DIALOG'
}


/** Represents a pre action in flights dialog trigger */
export enum FlightsDialogPreAction {
  CLOSE_ALL_DIALOGS = 'CLOSE_ALL_DIALOGS'
}










/** Represents flights component */
export enum FlightsDisplayComponent {
  SMART_NFF_ALTERNATE_SUGGESTION = 'SMART_NFF_ALTERNATE_SUGGESTION'
}


/** Represents display count of a component within a session e.g How many time NFF shows consecutively   */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: Scalars['Int'];
  flightsDisplayComponent: FlightsDisplayComponent;
}


/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: Maybe<Array<FlightsDisplayComponentCountingValueInput>>;
}


/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: Scalars['Int'];
}
















/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  UNDEFINED = 'UNDEFINED'
}






/** Represent the fares needs to be present in listing results */
export enum FlightsFaresSeparationType {
  BASE_AND_UPSELL = 'BASE_AND_UPSELL',
  NONSTOP_BASE_AND_UPSELL = 'NONSTOP_BASE_AND_UPSELL',
  NONSTOP_ONLY_BASE = 'NONSTOP_ONLY_BASE',
  NONSTOP_ONLY_UPSELL = 'NONSTOP_ONLY_UPSELL',
  ONLY_BASE = 'ONLY_BASE',
  ONLY_UPSELL = 'ONLY_UPSELL'
}









export enum FlightsFilterType {
  ARRIVAL_AIRPORT = 'ARRIVAL_AIRPORT',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHECKED_BAG = 'CHECKED_BAG',
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE',
  DEPARTURE_AIRPORT = 'DEPARTURE_AIRPORT',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DURATION = 'DURATION',
  FLEXIBLE_CHANGE_POLICIES = 'FLEXIBLE_CHANGE_POLICIES',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PREFERRED_AIRLINE = 'PREFERRED_AIRLINE',
  SEAT_CHOICE = 'SEAT_CHOICE',
  TRAVEL_AND_BAGGAGE = 'TRAVEL_AND_BAGGAGE'
}




/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}

/** Represents the flexible grid type */
export enum FlightsFlexibleGridType {
  /** Flex Search type shown for OW */
  FLEX_SEARCH = 'FLEX_SEARCH',
  /** Flex Search Grid type shown for RT Outbound */
  FLEX_SEARCH_GRID = 'FLEX_SEARCH_GRID',
  /** No Flex Search variant shown */
  FLEX_SEARCH_NOT_APPLICABLE = 'FLEX_SEARCH_NOT_APPLICABLE'
}







/** Represent flexible search header cell theme */
export enum FlightsFlexibleSearchHeaderCellTheme {
  /** Theme to represent an outbound or inbound departureDate header */
  DEFAULT = 'DEFAULT',
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  SEARCHED_DATE_HEADER = 'SEARCHED_DATE_HEADER'
}


/** Represent flexible search legend cell theme */
export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = 'DEFAULT'
}






/** Represent flexible search result cell theme */
export enum FlightsFlexibleSearchResultCellTheme {
  /** Default theme */
  DEFAULT_PRICE = 'DEFAULT_PRICE',
  /** Theme to represent highest priced cells in the matrix */
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  /** Theme to represent the lowest price displayed in the matrix */
  LOWEST_PRICE = 'LOWEST_PRICE',
  /** Theme to represent when no price is available, 'Search' */
  NO_PRICE = 'NO_PRICE',
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  SEARCHED_DATE = 'SEARCHED_DATE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  SEARCHED_DATE_LOWEST_PRICE = 'SEARCHED_DATE_LOWEST_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  SEARCHED_DATE_NO_PRICE = 'SEARCHED_DATE_NO_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = 'SEARCHED_DATE_UNAVAILABLE_FLIGHTS',
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  UNAVAILABLE_FLIGHTS = 'UNAVAILABLE_FLIGHTS'
}











/** Represents the position of the icon */
export enum FlightsIconPosition {
  /** Icon will be rendered at the beginning of the content */
  LEADING = 'LEADING',
  /** Icon will be rendered at the end of the content */
  TRAILING = 'TRAILING'
}






















/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: Maybe<DateInput>;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: Scalars['String'];
  /** Location type of the destination airport */
  destinationAirportLocationType?: Maybe<AirportLocationType>;
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: Maybe<FlightsCabinClass>;
  /** Three letter code of the origin airport */
  origin: Scalars['String'];
  /** Location type of the origin airport */
  originAirportLocationType?: Maybe<AirportLocationType>;
}

























/** Target of the Link when clicked */
export enum FlightsLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}









/** Represents page load type of FSR */
export enum FlightsListingsViewType {
  MIXED = 'MIXED',
  SINGLE = 'SINGLE'
}



















/** Metrics names */
export enum FlightsMetricName {
  LISTINGS_SUPPLY_RESPONSE_TIME = 'LISTINGS_SUPPLY_RESPONSE_TIME'
}







/** Represents the value associated with travel and baggage filter - no cancel fee */
export interface FlightsNoCancelFeeBasedFilterValueInput {
  noCancelFee: NoCancelFeeType;
}


/** Represents the value associated with travel and baggage filter - no change name */
export interface FlightsNoChangeFeeBasedFilterValueInput {
  noChangeFee: NoChangeFeeType;
}





























/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}



/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export enum FlightsPlacardDisplayType {
  /** Represents the placard type to be shown immediately */
  IMMEDIATE = 'IMMEDIATE',
  /** Represents the placard type to be shown during server error of sort and filter action */
  SORT_FILTERS_SERVER_ERROR = 'SORT_FILTERS_SERVER_ERROR'
}


/** Represents a type of placards the client can request for */
export enum FlightsPlacardType {
  /** Represents the placard of type free cancellation */
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  /** Represents the placard of type hotel attach */
  HOTEL_ATTACH = 'HOTEL_ATTACH',
  /** Represents the placard of type loyalty reward */
  LOYALTY_REWARD = 'LOYALTY_REWARD',
  /** Represents the placard of type no change fees */
  NO_CHANGE_FEES = 'NO_CHANGE_FEES',
  /** Represents the placard of type passport */
  PASSPORT = 'PASSPORT',
  /** Represents the placard of type price change */
  PRICE_CHANGE = 'PRICE_CHANGE',
  /** Represents the placard of type split ticket */
  SPLIT_TICKET = 'SPLIT_TICKET'
}


/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: Scalars['String'];
}













/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}















/** Enum class to represent the id associated with the rewards option */
export enum FlightsRewardsOptionId {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION'
}


export interface FlightsSearchComponentCriteriaInput {
  /** Parameter to recognize that traffic source is meta search */
  isMetaTraffic?: Maybe<Scalars['Boolean']>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier?: Maybe<Scalars['String']>;
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: Maybe<Array<GraphQlPairInput>>;
}


/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represents that the user is intending to redeem credits (i.e. coming from My Coupons and Credits or Virtual Agent) */
  hasCreditRedemptionIntent?: Maybe<Scalars['Boolean']>;
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: Maybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: Maybe<Array<JourneyFlightSelectionInput>>;
  /** Represents the previously selected credit's originalBookingId to correctly render the toast when credits are changed */
  previousOriginalBookingId?: Maybe<Scalars['String']>;
  /** Represents the mismatched search criteria between the current search and servicing need */
  searchCriteriaMismatch?: Maybe<Array<FlightsSearchCriteriaMismatch>>;
  /** Trip type in search */
  tripType: FlightsTripType;
}


/** Represents the mismatched criterion between the current search and servicing need */
export enum FlightsSearchCriteriaMismatch {
  TRAVELER = 'TRAVELER'
}



/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: Maybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - carry on bag. */
  carryOnBagBasedFilterValue?: Maybe<FlightsCarryOnBagBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - checked bag. */
  checkedBagBasedFilterValue?: Maybe<FlightsCheckedBagBasedFilterValueInput>;
  /** Represents the value associated with credit eligible filter */
  creditEligibleFilterValue?: Maybe<FlightsCreditEligibleFilterValueInput>;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: Maybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: Maybe<FlightsDurationBasedFilterValueInput>;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: Maybe<FlightsFlexibleChangePolicyBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no cancel fee. */
  noCancelFeeBasedFilterValue?: Maybe<FlightsNoCancelFeeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no change fee. */
  noChangeFeeBasedFilterValue?: Maybe<FlightsNoChangeFeeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: Maybe<FlightsStopBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: Maybe<FlightsPreferredAirlineFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - seat choice. */
  seatChoiceBasedFilterValue?: Maybe<FlightsSeatChoiceBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter. */
  travelAndBaggageBasedFilterValue?: Maybe<FlightsTravelAndBaggageBasedFilterValueInput>;
}








export enum FlightsSearchFormErrorType {
  /** Age of child is missing */
  CHILD_AGE_MISSING = 'CHILD_AGE_MISSING',
  /** Date before previous date - Multi-dest */
  DATE_BEFORE_PREVIOUS_DATE = 'DATE_BEFORE_PREVIOUS_DATE',
  /** Date must be between a range */
  DATE_NOT_IN_VALID_RANGE = 'DATE_NOT_IN_VALID_RANGE',
  /** Dates must be greater than or equal to default date/checkin date. */
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = 'DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE',
  /** Age of infant is missing */
  INFANT_AGE_MISSING = 'INFANT_AGE_MISSING',
  /** Date must be in the correct format */
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  /** Total traveler count must be equal or lower than max */
  INVALID_TRAVELER_COUNT = 'INVALID_TRAVELER_COUNT',
  /** At least 1 traveler required in a booking */
  LESS_THAN_MINIMUM_ADULT = 'LESS_THAN_MINIMUM_ADULT',
  /** Location must not be blank */
  LOCATION_EMPTY = 'LOCATION_EMPTY',
  /** Origin and destination location must not be the same */
  LOCATION_SAME = 'LOCATION_SAME',
  /** Dates must be no more than 26 days apart */
  MAX_STAY_DURATION_ERROR = 'MAX_STAY_DURATION_ERROR',
  /** Origin and Destination city cannot be same */
  SAME_CITY = 'SAME_CITY',
  /** Special characters are not allowed */
  SPECIAL_CHARACTER_NOT_ALLOWED = 'SPECIAL_CHARACTER_NOT_ALLOWED',
  /** Enter at least 3 characters of the airport name */
  TOO_SHORT_AIRPORT_STRING = 'TOO_SHORT_AIRPORT_STRING',
  /** Number of infant in lap must be equal or lower than number of adults */
  UNATTENDED_INFANT_IN_LAP = 'UNATTENDED_INFANT_IN_LAP',
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  UNATTENDED_INFANT_IN_SEAT = 'UNATTENDED_INFANT_IN_SEAT'
}


















/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: Maybe<Array<FlightsAdvancedFilterType>>;
  airline?: Maybe<Scalars['String']>;
  cabinClass: FlightsCabinClass;
}












/** Represents the enum to handle different styles for the card */
export enum FlightsSeatCardStyles {
  /** Represents that the card should have border */
  BORDER = 'BORDER',
  /** Represents that the card should not have a border */
  WITHOUT_BORDER = 'WITHOUT_BORDER'
}



/** Represents the value associated with travel and baggage filter - seat choice */
export interface FlightsSeatChoiceBasedFilterValueInput {
  seatChoice: SeatChoiceType;
}





/** Represents criteria for flights seat map. */
export interface FlightsSeatMapCriteriaInput {
  /** Represents which offer seat map to be shown. This will be decoded and used to create seat map service request */
  offerIdentifier: Scalars['String'];
  /** Represents pricing construct containing price related information. Ex: '[AA.QNNF00S7:SEADEL][AA.QNNF00S7CH:SEADEL][AA.QNNF00S7CH:SEADEL]{BFSDiag}{FC}11JUL21SEA AA X/LON BA DEL M318.00NUC318.00END ROE1.000000{/FC}{DollarAfc}{/DollarAfc}{/BFSDiag}{Published}' */
  pricingConstruct?: Maybe<Scalars['String']>;
  /** Represents list of segments for which seat map for selection is to be shown. */
  seatSegments?: Maybe<Array<SeatSegmentInput>>;
  /** RepreArraysents list of segments for which seat map is to be shown. This will identify the segments from the decoded offer identifier and request seat map downstream. */
  segmentIdentifiers: Array<Scalars['String']>;
}














/** Enum class to represent the seat type variant. */
export enum FlightsSeatMapSeatVariant {
  ACCESSIBLE = 'ACCESSIBLE',
  AISLE = 'AISLE',
  AVAILABLE = 'AVAILABLE',
  COLUMN = 'COLUMN',
  EXIT = 'EXIT',
  GALLEY = 'GALLEY',
  PREFERRED = 'PREFERRED',
  RESTROOM = 'RESTROOM',
  ROW = 'ROW',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE'
}







/** Error types which can occur during seat selection */
export enum FlightsSeatSelectionErrorType {
  /** Seat Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Seat Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE'
}





/** Represents the enum for handling whether new seats experience should be enabled or not */
export enum FlightsSeatsExperienceType {
  /** Represents frontend to show old seats experience */
  CURRENT_SEATS_EXPERIENCE = 'CURRENT_SEATS_EXPERIENCE',
  /** Represents frontend to show new seats experience */
  NEW_SEATS_EXPERIENCE = 'NEW_SEATS_EXPERIENCE'
}










/** Represents criteria for flights servicing confirmation page. */
export interface FlightsServicingConfirmationCriteriaInput {
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId?: Maybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId: Scalars['String'];
  /** Represents the trip id */
  tripId?: Maybe<Scalars['String']>;
}


/** Represents criteria for flights servicing page. */
export interface FlightsServicingCriteriaInput {
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: Maybe<Scalars['String']>;
  /** Represents the identifier to deduce change order flow */
  isResumeChange?: Maybe<Scalars['Boolean']>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Represents the trip id */
  tripId?: Maybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars['String']>;
}












/** Represents the button width in the UI */
export enum FlightsSmartShoppingButtonWidth {
  /** Button will take the width it needs */
  DEFAULT = 'DEFAULT',
  /** Button will take the full width of the content */
  FULL_WIDTH = 'FULL_WIDTH'
}




/** Represents flights dialog actions */
export enum FlightsSmartShoppingDialogAction {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  TOGGLE = 'TOGGLE'
}

/** Represents IDs for flights dialogs */
export enum FlightsSmartShoppingDialogId {
  /** Represents the Airlines credit dialog */
  AIRLINE_CREDITS = 'AIRLINE_CREDITS',
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  BAGGAGE_CLOSE_COMPLETE_DIALOG = 'BAGGAGE_CLOSE_COMPLETE_DIALOG',
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  BAGGAGE_CLOSE_INCOMPLETE_DIALOG = 'BAGGAGE_CLOSE_INCOMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  BAGGAGE_CONTINUE_BOOKING = 'BAGGAGE_CONTINUE_BOOKING',
  /** Represents the dialog ID for Baggage details */
  BAGGAGE_DETAILS_DIALOG = 'BAGGAGE_DETAILS_DIALOG',
  /** Represents the bags popup dialog on checkout button */
  BAGS_POPUP_ON_CHECKOUT = 'BAGS_POPUP_ON_CHECKOUT',
  /** Represents the check credits dialog for users coming from MCC and VA */
  CHECK_CREDITS_DIALOG = 'CHECK_CREDITS_DIALOG',
  /** Represents the Flights Details and Fares dialog */
  FLIGHTS_DETAILS_AND_FARES = 'FLIGHTS_DETAILS_AND_FARES',
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FORCED_CHOICE_MODAL = 'FORCED_CHOICE_MODAL',
  /** Represents the How Airlines Work dialog inside Select Credits */
  HOW_CREDITS_WORK = 'HOW_CREDITS_WORK',
  /** Represents the Leave This Page dialog inside Select Credits */
  LEAVE_TO_COUPONS = 'LEAVE_TO_COUPONS',
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  PAID_BAGS_DIALOG = 'PAID_BAGS_DIALOG',
  /** Represents the Info dialog for Price Match Promise Selected Card */
  PMP_INFO_DIALOG = 'PMP_INFO_DIALOG',
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  PMP_REMOVE_DIALOG = 'PMP_REMOVE_DIALOG',
  /** Represents the seats popup dialog on checkout button */
  SEATS_POPUP_ON_CHECKOUT = 'SEATS_POPUP_ON_CHECKOUT',
  /** Represents the Close button dialog for the seat details */
  SEAT_CLOSE_COMPLETE_DIALOG = 'SEAT_CLOSE_COMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  SEAT_CONTINUE_BOOKING = 'SEAT_CONTINUE_BOOKING',
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  SEAT_SELECTION_DIALOG = 'SEAT_SELECTION_DIALOG',
  /** Represents the dialog on traveler mismatch for credits offer */
  TRAVELER_MISMATCH_DIALOG = 'TRAVELER_MISMATCH_DIALOG'
}




/** Represents the position of the icon */
export enum FlightsSmartShoppingIconPosition {
  /** Icon will be rendered at the beginning of the content */
  LEADING = 'LEADING',
  /** Icon will be rendered at the end of the content */
  TRAILING = 'TRAILING'
}

/** Target of the Link when clicked */
export enum FlightsSmartShoppingLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}


















/** Traveler details for flights search */
export interface FlightsSmartShoppingTravelerDetailsInput {
  /** Age for each traveler */
  ages?: Maybe<Array<Scalars['Int']>>;
  /** Traveler count */
  count: Scalars['Int'];
  /** Traveler type */
  travelerType: TravelerDetailsType;
}









/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOptionList?: Maybe<Array<FlightsCrossSortOptionInput>>;
  crossSortOptionType?: Maybe<FlightsCrossSortOptionTypeInput>;
  sortOrder: FlightsSortOrder;
  sortType: FlightsSortType;
}

/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = 'DECREASING',
  INCREASING = 'INCREASING'
}


/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = 'ARRIVAL',
  BEST_BETS = 'BEST_BETS',
  BEST_SORT = 'BEST_SORT',
  CROSS_SORT = 'CROSS_SORT',
  DEPARTURE = 'DEPARTURE',
  DURATION = 'DURATION',
  NONSTOP = 'NONSTOP',
  PRICE = 'PRICE',
  RECOMMENDED = 'RECOMMENDED'
}







/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}

/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = 'EQUAL',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL'
}


/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: Scalars['Int'];
  stopFilterOperation: FlightsStopFilterOperation;
}














/** This represents a decorator that can be applied to a section */
export enum FlightsTextSectionDecorator {
  /** This represents a separator that renders after the text section */
  BOTTOMSEPARATOR = 'BOTTOMSEPARATOR',
  /** This represents a separator that renders above the text section */
  TOPSEPARATOR = 'TOPSEPARATOR'
}


/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}

/** Enum representing the various time slots in a day  */
export enum FlightsTimeOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}

export enum FlightsTimePeriodOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}



/** Represents the value associated with travel and baggage filter */
export interface FlightsTravelAndBaggageBasedFilterValueInput {
  travelAndBaggageName: FilterTravelAndBaggageType;
}



/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: Maybe<Array<Scalars['Int']>>;
  /** Traveler count */
  count: Scalars['Int'];
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}





/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}





export enum FooterButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}










export enum FooterSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}







/** Represents all the common information in the journey review block on FIS  */
export enum FreeCancellationApplicability {
  ALL_JOURNEYS = 'ALL_JOURNEYS',
  CURRENT_JOUNRNEY = 'CURRENT_JOUNRNEY',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}




export enum FunnelLocation {
  CHECKOUT = 'CHECKOUT',
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  CONFIRMATION = 'CONFIRMATION',
  DETAILS = 'DETAILS',
  ENTRY = 'ENTRY',
  FEATURES = 'FEATURES',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  POST_BOOKING = 'POST_BOOKING',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}



/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = 'AIRPORT',
  DESTINATION = 'DESTINATION',
  PROPERTY = 'PROPERTY'
}





/** Line of business that is querying the global navigation elements. */
export enum GlobalNavigationLineOfBusiness {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  UNKNOWN = 'UNKNOWN'
}


/**
 * An object with simple key/value combination. This can be used to represent generic input where you do not know all the values that can be provided.
 *
 * It should be avoided in favor of a strict type with set fields, but can be useful in specific situations.
 */
export interface GraphQlPairInput {
  key: Scalars['String'];
  value: Scalars['String'];
}





export enum GroundTransfersBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}








/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = 'FROM_AIRPORT',
  ROUNDTRIP = 'ROUNDTRIP',
  TO_AIRPORT = 'TO_AIRPORT'
}






export enum GroundTransfersGroupViewType {
  CARDS_LIST = 'CARDS_LIST'
}


/** Provides the ground transfers criteria for each part of the journey. For instance, round-trip journey will comprise 2 parts, airport(origin) to hotel(destination) and hotel(origin) to airport(destination). */
export interface GroundTransfersJourneyCriteriaInput {
  dateTime: DateTimeInput;
  destination: GroundTransfersLocationInput;
  origin: GroundTransfersLocationInput;
}



/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: Maybe<CoordinatesInput>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type: GeoType;
}




export enum GroundTransfersMapTransitOption {
  BUS = 'BUS',
  NONE = 'NONE',
  TRAIN = 'TRAIN'
}

export enum GroundTransfersMapTravelMode {
  DRIVING = 'DRIVING',
  TRANSIT = 'TRANSIT'
}






/** The ground transfers natural key that contains an offer token */
export interface GroundTransfersNaturalKeyInput {
  offerToken: Scalars['String'];
}









export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}




export enum GroundTransfersSectionStyle {
  BULLETED = 'BULLETED',
  STANDARD = 'STANDARD'
}




/** Text style to apply to text */
export enum GroundTransfersStyle {
  /** Bold styling */
  EMPHASISED = 'EMPHASISED',
  /** Loyalty messages styling */
  LOYALTY = 'LOYALTY',
  /** Green text styling */
  POSITIVE = 'POSITIVE',
  /** Regular text with no styling, default Value */
  STANDARD = 'STANDARD'
}





/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: Scalars['Int'];
  type: GroundTransfersTravelerDetailsType;
}

/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT'
}






/** Header section alignment of elements to either the start or end of the section container. */
export enum HeaderAlignment {
  END = 'END',
  START = 'START'
}



/** Determines the type of button to display.  Primary or tertiary. */
export enum HeaderButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}


/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export enum HeaderItemPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

/** Header layout. */
export enum HeaderLayout {
  DEFAULT = 'DEFAULT',
  MINIMAL = 'MINIMAL',
  SIMPLIFIED = 'SIMPLIFIED'
}






/** Used to pass certain marketing details to the header for google ad awareness */
export interface HeaderMarketingInput {
  googleClickIdentifier?: Maybe<Scalars['String']>;
  metaDistributionPartnersDetails?: Maybe<Scalars['String']>;
}
















/** Inserts a separator in header menus. */
export enum HeaderSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}







/** Type of text.  Heading or subheading. */
export enum HeaderTextType {
  HEADING = 'HEADING',
  SUBHEADING = 'SUBHEADING'
}

/** Different viewport sizes to display the header. */
export enum HeaderViewSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}























/** Browse request to get articles */
export interface HelpArticlesSearchRequestInput {
  /** Specify specific category from product to retrieve articles */
  category?: Maybe<Scalars['String']>;
  /** Specify article id to get article data */
  helpArticleId?: Maybe<Scalars['String']>;
  /** Specify search term to get articles suggestions */
  helpArticlesSearchTerm?: Maybe<Scalars['String']>;
  /** Specify specific product from homepage to retrieve articles */
  product?: Maybe<Scalars['String']>;
}













/** Hero View type to be rendered based on requested type */
export enum HeroViewType {
  HERO_COMPONENT = 'HERO_COMPONENT',
  HERO_TAKEOVER = 'HERO_TAKEOVER'
}

















export enum HistoryType {
  ACTIVITY_DETAIL = 'ACTIVITY_DETAIL',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_DETAIL = 'CAR_DETAIL',
  CAR_SEARCH = 'CAR_SEARCH',
  CRUISE_SEARCH = 'CRUISE_SEARCH',
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_SEARCH = 'PACKAGE_SEARCH',
  PROPERTY_DETAIL = 'PROPERTY_DETAIL',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH'
}







export interface HttpHeaderInput {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
}

export enum HttpStatus {
  ACCEPTED = 'ACCEPTED',
  ALREADY_REPORTED = 'ALREADY_REPORTED',
  BAD_GATEWAY = 'BAD_GATEWAY',
  BAD_REQUEST = 'BAD_REQUEST',
  BANDWIDTH_LIMIT_EXCEEDED = 'BANDWIDTH_LIMIT_EXCEEDED',
  CHECKPOINT = 'CHECKPOINT',
  CONFLICT = 'CONFLICT',
  CONTINUE = 'CONTINUE',
  CREATED = 'CREATED',
  DESTINATION_LOCKED = 'DESTINATION_LOCKED',
  EXPECTATION_FAILED = 'EXPECTATION_FAILED',
  FAILED_DEPENDENCY = 'FAILED_DEPENDENCY',
  FORBIDDEN = 'FORBIDDEN',
  FOUND = 'FOUND',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  GONE = 'GONE',
  HTTP_VERSION_NOT_SUPPORTED = 'HTTP_VERSION_NOT_SUPPORTED',
  IM_USED = 'IM_USED',
  INSUFFICIENT_SPACE_ON_RESOURCE = 'INSUFFICIENT_SPACE_ON_RESOURCE',
  INSUFFICIENT_STORAGE = 'INSUFFICIENT_STORAGE',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  I_AM_A_TEAPOT = 'I_AM_A_TEAPOT',
  LENGTH_REQUIRED = 'LENGTH_REQUIRED',
  LOCKED = 'LOCKED',
  LOOP_DETECTED = 'LOOP_DETECTED',
  METHOD_FAILURE = 'METHOD_FAILURE',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  MOVED_PERMANENTLY = 'MOVED_PERMANENTLY',
  MOVED_TEMPORARILY = 'MOVED_TEMPORARILY',
  MULTIPLE_CHOICES = 'MULTIPLE_CHOICES',
  MULTI_STATUS = 'MULTI_STATUS',
  NETWORK_AUTHENTICATION_REQUIRED = 'NETWORK_AUTHENTICATION_REQUIRED',
  NON_AUTHORITATIVE_INFORMATION = 'NON_AUTHORITATIVE_INFORMATION',
  NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
  NOT_EXTENDED = 'NOT_EXTENDED',
  NOT_FOUND = 'NOT_FOUND',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  NOT_MODIFIED = 'NOT_MODIFIED',
  NO_CONTENT = 'NO_CONTENT',
  OK = 'OK',
  PARTIAL_CONTENT = 'PARTIAL_CONTENT',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PERMANENT_REDIRECT = 'PERMANENT_REDIRECT',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',
  PRECONDITION_REQUIRED = 'PRECONDITION_REQUIRED',
  PROCESSING = 'PROCESSING',
  PROXY_AUTHENTICATION_REQUIRED = 'PROXY_AUTHENTICATION_REQUIRED',
  REQUESTED_RANGE_NOT_SATISFIABLE = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  REQUEST_ENTITY_TOO_LARGE = 'REQUEST_ENTITY_TOO_LARGE',
  REQUEST_HEADER_FIELDS_TOO_LARGE = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  REQUEST_URI_TOO_LONG = 'REQUEST_URI_TOO_LONG',
  RESET_CONTENT = 'RESET_CONTENT',
  SEE_OTHER = 'SEE_OTHER',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  SWITCHING_PROTOCOLS = 'SWITCHING_PROTOCOLS',
  TEMPORARY_REDIRECT = 'TEMPORARY_REDIRECT',
  TOO_EARLY = 'TOO_EARLY',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAVAILABLE_FOR_LEGAL_REASONS = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED',
  URI_TOO_LONG = 'URI_TOO_LONG',
  USE_PROXY = 'USE_PROXY',
  VARIANT_ALSO_NEGOTIATES = 'VARIANT_ALSO_NEGOTIATES'
}











/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE'
}

/** Supported themes of spotlights. See the prop definitions here: https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115 */
export enum IconSpotLight {
  INFO = 'INFO',
  POSITIVE = 'POSITIVE',
  STANDARD = 'STANDARD',
  WARNING = 'WARNING'
}

/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export enum IconTheme {
  DEFAULT = 'default',
  EMPHASIS = 'emphasis',
  NEGATIVE = 'negative',
  POSITIVE = 'positive'
}


/** Enum to specify the type for inputId */
export enum IdentifierType {
  CART_ID = 'CART_ID',
  ENTITY_ID = 'ENTITY_ID',
  OFFER_ID = 'OFFER_ID',
  ORDER_ID = 'ORDER_ID',
  PROPERTY_ID = 'PROPERTY_ID'
}


export enum IdentityAccountCreationState {
  INVALID = 'INVALID',
  NOT_UPGRADED = 'NOT_UPGRADED',
  UPGRADED = 'UPGRADED'
}

export enum IdentityAccountCreationType {
  INVALID = 'INVALID',
  REGISTERED = 'REGISTERED',
  UNREGISTERED = 'UNREGISTERED'
}



export interface IdentityAccountTakeOverDeviceInput {
  payload: Scalars['String'];
  type: IdentityAccountTakeOverDeviceType;
}

export enum IdentityAccountTakeOverDeviceType {
  TRUST_WIDGET = 'TRUST_WIDGET'
}

/** EG Universal Login AccountTakeOver input from client */
export interface IdentityAccountTakeOverInput {
  inputs: Array<GraphQlPairInput>;
  type: Scalars['String'];
}


export interface IdentityAccountTakeOverShieldInput {
  accountTakeOverTokens?: Maybe<Array<IdentityAccountTakeOverTokenInput>>;
  crossSiteRequestForgeryData: IdentityCrossSiteRequestForgeryInput;
  devices?: Maybe<Array<IdentityAccountTakeOverDeviceInput>>;
  placement?: Maybe<Scalars['String']>;
}


export interface IdentityAccountTakeOverTokenInput {
  name: Scalars['String'];
  value: Scalars['String'];
}

export enum IdentityAccountTakeOverType {
  CAPTCHA_SAFETYNET_ANDROID = 'CAPTCHA_SAFETYNET_ANDROID',
  CSRF = 'CSRF',
  DEVICE_CHECK = 'DEVICE_CHECK',
  TRUST_WIDGET = 'TRUST_WIDGET'
}











export enum IdentityChannelType {
  ANDROID = 'ANDROID',
  DESKTOP = 'DESKTOP',
  IOS = 'IOS'
}

/** EG Universal Login input for IdentityClientInfo query and mutation */
export interface IdentityClientInfoInput {
  appName: Scalars['String'];
  appVersion: Scalars['String'];
  channelType: IdentityChannelType;
  deviceOS: Scalars['String'];
  deviceType: DeviceType;
}





/** EG Identity Creation Account Request */
export interface IdentityCreateAccountRequestInput {
  accountTakeOverShield: IdentityAccountTakeOverShieldInput;
  channelType?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneDetails?: Maybe<IdentityPhoneDetailsInput>;
  rememberMe?: Maybe<Scalars['Boolean']>;
}



export interface IdentityCrossSiteRequestForgeryInput {
  token: Scalars['String'];
}










/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: Maybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars['UUID'];
  /** The Expedia User ID */
  expUserId?: Maybe<Scalars['String']>;
  /** The user TUID */
  tuid?: Maybe<Scalars['String']>;
}

export enum IdentityLayout {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  LAUNCH_ONE_IDENTITY = 'LAUNCH_ONE_IDENTITY',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SIGNIN = 'SIGNIN',
  SIGNUP = 'SIGNUP'
}





export interface IdentityPhoneDetailsInput {
  countryCode: Scalars['String'];
  locale: Scalars['String'];
  phoneNumber: Scalars['String'];
}















export enum IdentitySocialButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export interface IdentitySocialInput {
  nonce: Scalars['String'];
  socialType: IdentitySocialType;
  token: Scalars['String'];
  tokenType: IdentitySocialTokenType;
}



export enum IdentitySocialTokenType {
  ACCESS = 'Access',
  AUTHCODE = 'AuthCode',
  ID = 'ID'
}

export enum IdentitySocialType {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

/** EG Universal Login spacing definition */
export enum IdentitySpaceSize {
  S0X = 'S0X',
  S0XH = 'S0XH',
  S10X = 'S10X',
  S11X = 'S11X',
  S12X = 'S12X',
  S14X = 'S14X',
  S16X = 'S16X',
  S18X = 'S18X',
  S1X = 'S1X',
  S2X = 'S2X',
  S3X = 'S3X',
  S4X = 'S4X',
  S5X = 'S5X',
  S6X = 'S6X',
  S8X = 'S8X'
}


/** EG Universal Login input for IdentityFormSubmit mutation */
export interface IdentitySubmitRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  context: Scalars['String'];
  input: Array<GraphQlPairInput>;
  socialInput?: Maybe<IdentitySocialInput>;
}



export enum IdentitySuccessType {
  ONE_KEY_ONBOARDING = 'ONE_KEY_ONBOARDING',
  ORIGIN = 'ORIGIN'
}





















































/** Input type for fetching the Inquiry form. */
export interface InquiryFormInput {
  petsIncluded?: Maybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput?: Maybe<PrimaryPropertyCriteriaInput>;
}




export enum InquiryProminence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

/** Input type for submitting a new Inquiry request. */
export interface InquiryRequestInput {
  inquirerPhoneCountryCode?: Maybe<Scalars['String']>;
  inquirerPhoneNumber?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  optInForMarketing?: Maybe<Scalars['Boolean']>;
  petsIncluded?: Maybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput: PrimaryPropertyCriteriaInput;
}




/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: Maybe<Scalars['String']>;
  /** Gaia region id of the location */
  regionId?: Maybe<Scalars['String']>;
}











/** GraphQL request for benefit details */
export interface InsuranceBenefitDetailsQueryRequestInput {
  /** Benefit Id for which the details are requested */
  benefitId: Scalars['String'];
  /** emil src to collect analytics when it's true  */
  isEmailSrc?: Maybe<Scalars['Boolean']>;
  /** Order Id of the booking */
  orderNumber?: Maybe<Scalars['String']>;
  /** Trip Id of the booking */
  tripId?: Maybe<Scalars['String']>;
}


export interface InsuranceBookingCancellationRequestInput {
  orderId: Scalars['String'];
  orderLineId: Scalars['String'];
}



export interface InsuranceBookingOverviewRequestInput {
  orderNumber?: Maybe<Scalars['String']>;
  tripId?: Maybe<Scalars['String']>;
}


/** GraphQL request for Insurance Claim Details */
export interface InsuranceClaimDetailsRequestInput {
  /** Order Id of the booking */
  orderNumber?: Maybe<Scalars['String']>;
}




/** Represents criteria for insurance. */
export interface InsuranceCriteriaInput {
  /** Represents free price match promise marketing placement */
  freePmpCustomerPlacement?: Maybe<Scalars['String']>;
  /** offer token for insurance product */
  insuranceOfferToken?: Maybe<Scalars['String']>;
  /** Represents PMP up-funnel selection */
  selectedProductId?: Maybe<Scalars['String']>;
}


export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars['String']>;
  /** Drop-off location for car */
  dropOffLocation?: Maybe<InsuranceLocationInput>;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: Maybe<InsuranceRewardsPointSelectionEnum>;
  /** List of accessories added with Car */
  selectedAccessories?: Maybe<Array<Scalars['String']>>;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}




export interface InsuranceFileAClaimRequestInput {
  benefitId: Scalars['String'];
  /** emil src to collect analytics when it's true  */
  isEmailSrc?: Maybe<Scalars['Boolean']>;
  orderNumber?: Maybe<Scalars['String']>;
  tripId?: Maybe<Scalars['String']>;
}









export enum InsuranceListLayout {
  SINGLE_COLUMN = 'SINGLE_COLUMN'
}

export enum InsuranceListType {
  ORDERED = 'ORDERED',
  UNORDERED = 'UNORDERED'
}

export enum InsuranceListTypeOld {
  ICON = 'ICON',
  NUMBERED = 'NUMBERED'
}


export interface InsuranceLocationInput {
  /** Region id */
  regionId: Scalars['String'];
  /** Search term */
  searchTerm: Scalars['String'];
}


export enum InsuranceMessageType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING'
}


export enum InsuranceMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

export enum InsuranceMutationType {
  ADD_INSURANCE = 'ADD_INSURANCE',
  REMOVE_INSURANCE = 'REMOVE_INSURANCE'
}










export enum InsurancePhrasePartStyle {
  /** Green */
  COLOR_GREEN = 'COLOR_GREEN',
  /** Red */
  COLOR_RED = 'COLOR_RED',
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}







export enum InsuranceRewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}


export interface InsuranceSelectionDetailsInput {
  /** Insurance id of already added insurance */
  existingInsuranceProductIds?: Maybe<Array<Scalars['String']>>;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: Maybe<Scalars['String']>;
  /** Details of already added insurance */
  insuranceSelectionDetails?: Maybe<InsuranceSelectionDetailsInput>;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: Maybe<Scalars['String']>;
  /** TripId */
  tripId: Scalars['UUID'];
  /** In order to ignore the caching at client level and make an actual shopping call version hash is changed in subsequent requests */
  versionHash?: Maybe<Scalars['String']>;
}













export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;
  insuranceSearchId?: Maybe<Scalars['String']>;
  offerTypeId?: Maybe<Scalars['Int']>;
}









/** Client Id Possibilities */
export enum InsurtechClientId {
  CAR_INFO_SITE = 'CAR_INFO_SITE',
  EG_CHECKOUT = 'EG_CHECKOUT',
  FCR_CHECKOUT = 'FCR_CHECKOUT'
}










/** Status Possibilities */
export enum InsurtechMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}




export interface InsurtechPrimingCardRequestInput {
  /** Identifier offer for car inventory */
  offer: OfferIdentityInput;
}











/** Interaction to publish an event for */
export enum InteractionEventName {
  BOOK = 'BOOK',
  CHECKOUT_PAGE_LOAD = 'CHECKOUT_PAGE_LOAD',
  CONFIRMATION_PAGE_LOAD = 'CONFIRMATION_PAGE_LOAD'
}



/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: Maybe<Scalars['String']>;
  /** Name of interest */
  name?: Maybe<Scalars['String']>;
}


/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = 'AICTRAVELGROUP',
  AMOMA = 'AMOMA',
  ANA = 'ANA',
  BESTBUYHOTEL = 'BESTBUYHOTEL',
  BONOTEL = 'BONOTEL',
  CNTRAVEL = 'CNTRAVEL',
  CTRIP = 'CTRIP',
  DESPEGAR = 'DESPEGAR',
  DIDATRAVEL = 'DIDATRAVEL',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  EUROPLAYAS = 'EUROPLAYAS',
  EXCITEHOLIDAYS = 'EXCITEHOLIDAYS',
  EZZEGO_1 = 'EZZEGO_1',
  GETAROOM = 'GETAROOM',
  HOME_AWAY = 'HOME_AWAY',
  HOTELDOBESTDAYTRAVEL = 'HOTELDOBESTDAYTRAVEL',
  HOTEL_BEDS = 'HOTEL_BEDS',
  HRS = 'HRS',
  JAC_TRAVEL = 'JAC_TRAVEL',
  JAL = 'JAL',
  JALAN = 'JALAN',
  JTB = 'JTB',
  JUMBOTOURS = 'JUMBOTOURS',
  MAGICROOMS = 'MAGICROOMS',
  MERCHANT = 'MERCHANT',
  MGBEDBANK = 'MGBEDBANK',
  MIKI = 'MIKI',
  MTS = 'MTS',
  NTA = 'NTA',
  NUITEE = 'NUITEE',
  OPAQUE = 'OPAQUE',
  OSTROVOK = 'OSTROVOK',
  PEGASUS = 'PEGASUS',
  RAKUTEN = 'RAKUTEN',
  RESTEL = 'RESTEL',
  ROOMER = 'ROOMER',
  SMYROOMS = 'SMYROOMS',
  SUNHOTELS = 'SUNHOTELS',
  THOMASCOOK_EUR = 'THOMASCOOK_EUR',
  THOMASCOOK_UK = 'THOMASCOOK_UK',
  TOURICO = 'TOURICO',
  TRAVELLANDA = 'TRAVELLANDA',
  TRAVELREPUBLIC = 'TRAVELREPUBLIC',
  VENERE = 'VENERE',
  VRBO = 'VRBO',
  WELCOME_BEDS = 'WELCOME_BEDS',
  WOORI = 'WOORI',
  WORLDHOTELLINK = 'WORLDHOTELLINK',
  WORLDSPAN = 'WORLDSPAN',
  WOTIF = 'WOTIF',
  YOUTRAVEL = 'YOUTRAVEL',
  ZUMATA = 'ZUMATA'
}












/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: Scalars['Int'];
  /** Represents the flight combination the customer previously selected for the indexed segment. This will be used to highlight the previously selected offer for pinned listing. */
  offerIdentifier: Scalars['String'];
}








export enum KeyPhrasesClientType {
  DEFAULT = 'DEFAULT',
  FILTER = 'FILTER',
  SNIPPET = 'SNIPPET'
}






/** PWA ONLY: Input that is sent directly from the URL value. These inputs can not be parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: Maybe<Array<Scalars['String']>>;
  /** Maps to ReviewScoreRange */
  guestRating?: Maybe<Scalars['String']>;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: Maybe<Array<Scalars['String']>>;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: Maybe<Array<Scalars['Int']>>;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** Maps to PropertySort */
  sort?: Maybe<Scalars['String']>;
  /** Maps to starList */
  stars?: Maybe<Scalars['String']>;
  /** Maps to StructureType */
  structureTypes?: Maybe<Array<Scalars['String']>>;
}














/** Line of business in request */
export enum LineOfBusiness {
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL'
}

/** Line of business */
export enum LineOfBusinessDomain {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

/** ADs related property search options  */
export enum Listings {
  /** Only return travelAds */
  ADS_ONLY = 'ADS_ONLY'
}




export enum LiveAnnouncePoliteness {
  ASSERTIVE = 'ASSERTIVE',
  OFF = 'OFF',
  POLITE = 'POLITE'
}
















/** Data type for AdaptEx testing. Contains a list of traveler states on UI to provide consistent experience. For more info, read https://github.expedia.biz/lodging-experience/experience-api-lodging-schema-reviews/blob/master/proposals/property-comparison-tool-adaptex/PROPOSAL.md */
export interface LodgingAdaptExContextInput {
  /** Contains a list of AdaptEx states */
  state: Array<LodgingAdaptExStateInput>;
}


/** Data type for AdaptEx testing. Contains a state of a traveler on UI to provide consistent experience. For example, it can indicate if user has seen a popup. */
export interface LodgingAdaptExStateInput {
  /** Name of the state. For example, 'userSawPrompt' */
  name: Scalars['String'];
  /** Value of the state. For example, 'true' */
  value: Scalars['String'];
}




















































/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = 'CAR'
}




























export enum LodgingFormMethod {
  GET = 'GET',
  POST = 'POST'
}










export enum LodgingInputType {
  EMAIL = 'EMAIL',
  HIDDEN = 'HIDDEN',
  PASSWORD = 'PASSWORD',
  TEL = 'TEL',
  TEXT = 'TEXT',
  URL = 'URL'
}















/** Theme information for a message. */
export enum LodgingMessageTheme {
  /** To be used for warnings/errors; typically red. */
  AGGRESSIVE = 'AGGRESSIVE',
  /** To be used for success/perks; typically green. */
  HIGHLIGHT = 'HIGHLIGHT',
  /** To be used for emphasis; typically bold. */
  STRONG = 'STRONG'
}






















































export enum LodgingStepperState {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE'
}







export enum LodgingTrackPosition {
  END = 'END',
  STANDARD = 'STANDARD',
  START = 'START'
}


/** Type to select a category of action for an UnescoPledge */
export enum LodgingTravelPledgeCategory {
  /** Category to support local communities */
  COMMUNITY_ENGAGEMENT = 'COMMUNITY_ENGAGEMENT',
  /** Category to save energy consumption */
  CONSERVE_ENERGY = 'CONSERVE_ENERGY',
  /** Category to save water consumption */
  CONSERVE_WATER = 'CONSERVE_WATER',
  /** USE AT YOUR OWN RISK! Category used just for testing  */
  FEEDBACK_MESSAGE = 'FEEDBACK_MESSAGE',
  /** Category to add additional information about sustainability */
  OTHER = 'OTHER',
  /** Category to reduce plastic usage */
  REDUCE_PLASTIC = 'REDUCE_PLASTIC',
  /** Category to reduce waste */
  REDUCE_WASTE = 'REDUCE_WASTE'
}


/** Type to specify a filter related UnescoPledges */
export interface LodgingTravelPledgeFilterInput {
  /** Categories to filter */
  categories?: Maybe<Array<LodgingTravelPledgeCategory>>;
  /** Number of UnescoPledges to visualize */
  pledgesNumber?: Maybe<Scalars['Int']>;
  /** Number of the starting index of UnescoPledges list */
  startingIndex?: Maybe<Scalars['Int']>;
  /** String value to search around PropertyCountry, Property City and PropertyName */
  textSearchValue?: Maybe<Scalars['String']>;
}

























export enum LoyaltyExperienceStrategy {
  HIDE_TRAVELER_INFO_AND_REWARDS_LINK = 'HIDE_TRAVELER_INFO_AND_REWARDS_LINK',
  SHOW_TRAVELER_INFO_AND_REWARDS_LINK = 'SHOW_TRAVELER_INFO_AND_REWARDS_LINK'
}




























/** Enumeration for 2fa/mfa verification method */
export enum MfaVerificationMethod {
  SMS = 'SMS',
  CALL = 'CALL'
}

export enum Moderation_Rule {
  BLOCK = 'BLOCK',
  ADVISE = 'ADVISE'
}

export enum Moderation_Type {
  WORD = 'WORD',
  CHARACTER = 'CHARACTER'
}





















/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  GROCERY = 'GROCERY',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN'
}



/** Toolbar action type */
export enum MapToolbarActionsType {
  /** Show filters button in the toolbar */
  FILTERS = 'FILTERS'
}




/** The type of map marker */
export enum MarkerType {
  HOTEL = 'HOTEL',
  POI = 'POI'
}




/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  /** Hypertext markup language */
  HTML = 'HTML'
}



export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FULL_BOARD = 'FULL_BOARD',
  HALF_BOARD = 'HALF_BOARD'
}




export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}


export interface MemberPricingInput {
  /** Discount percentage */
  discountPercentage?: Maybe<Scalars['Int']>;
  /** Is lead in offer MOD */
  leadInMemberOffer?: Maybe<Scalars['Boolean']>;
  /** Is any offer MOD */
  memberOfferAvailable?: Maybe<Scalars['Boolean']>;
}



export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER'
}


















/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = 'ADDON',
  BRANDED_THEME_ACCENT = 'BRANDED_THEME_ACCENT',
  BRANDED_THEME_DARK = 'BRANDED_THEME_DARK',
  BRANDED_THEME_LIGHT = 'BRANDED_THEME_LIGHT',
  COMPRESSION = 'COMPRESSION',
  COUPON = 'COUPON',
  DOUBLE_POINTS = 'DOUBLE_POINTS',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  FREE_LX = 'FREE_LX',
  HOTRATE = 'HOTRATE',
  LEGAL = 'LEGAL',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  NO_CC = 'NO_CC',
  OVERFILTERED = 'OVERFILTERED',
  PARTNER_LINKOFF = 'PARTNER_LINKOFF',
  VACATION_RENTALS = 'VACATION_RENTALS'
}











/** Product natural keys required for session recovery */
export interface MishopRecoveryNaturalKeysInput {
  flightNaturalKeys: Array<FlightNaturalKeyInput>;
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}















/** Change Package Search Form Primer */
export interface MishopUiChangePackageFormPrimerInput {
  multiItemSessionId: Scalars['String'];
}













/** The type of button to display */
export enum MishopUiDialogButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}






































/** Contains the necessary data for calling packageSummaryContent query */
export interface MishopUiPackageSummaryContentPrimerInput {
  naturalKey: PackageNaturalKeyInput;
}






/** Contains the necessary data for rendering to the customer a placard describing announcements relevant to their trip */
export interface MishopUiPlacardNotificationInput {
  multiItemPriceToken?: Maybe<Scalars['String']>;
  placardType: MishopUiPlacardType;
  priceDetailsOptions?: Maybe<PriceDetailsOptionsInput>;
  shoppedProducts: Array<ShoppedProductInput>;
}

export enum MishopUiPlacardType {
  PRICE_CHANGE = 'PRICE_CHANGE'
}

















export enum MishopUiProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  PROPERTY = 'PROPERTY'
}






/** Contains necessary data for fetching property content */
export interface MishopUiPropertyContentPrimerInput {
  changePropertyAction: PropertySearchMultiItemShoppingActionInput;
  changeRoomAction: PropertyDetailsMultiItemShoppingActionInput;
  naturalKey: PropertyNaturalKeyInput;
  propertyChangeLink?: Maybe<Scalars['String']>;
  relativeChangePropertyLink: Scalars['String'];
  relativeChangeRoomLink: Scalars['String'];
}





















export enum MobilitySearchDialogsId {
  /** This represents a dialog to display price summary details */
  PRICE_SUMMARY_DETAILS = 'PRICE_SUMMARY_DETAILS'
}




/** Pricing information */
export interface MoneyInput {
  /** DEPRECATED: Use platform formatters and return localized strings instead. Numeric portion of the price */
  amount: Scalars['Float'];
  /** DEPRECATED: The currency should be specified from the context instead. The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: Maybe<Scalars['String']>;
}


/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}









/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: Scalars['String'];
  /** The package type for this search */
  packageType: PackageType;
}























/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: Maybe<Array<ActivityNaturalKeyInput>>;
  cars?: Maybe<Array<CarNaturalKeyInput>>;
  flights?: Maybe<Array<FlightNaturalKeyInput>>;
  groundTransfers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  packages?: Maybe<Array<PackageNaturalKeyInput>>;
  properties?: Maybe<Array<PropertyNaturalKeyInput>>;
}






/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: Maybe<Array<CarSearchCriteriaInput>>;
  flights?: Maybe<Array<FlightSearchCriteriaInput>>;
  properties?: Maybe<Array<PropertySearchCriteriaInput>>;
}

















/** Enum class to represent the type of no cancel fee */
export enum NoCancelFeeType {
  NO_CANCEL_FEE = 'NO_CANCEL_FEE'
}

/** Enum class to represent the type of no change fee */
export enum NoChangeFeeType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}
































/** The button type of the Customer notification submit button */
export enum NotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}





/** Represents the target of the link */
export enum NotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

/** Represents the link type */
export enum NotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

export enum NotificationLocation {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}

export enum NotificationLocationOnPage {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  ERROR = 'ERROR',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}




/** Enumeration of possible layout types */
export enum NotificationMessageCardLayout {
  ICON_ON_SIDE = 'ICON_ON_SIDE',
  ICON_ON_TOP = 'ICON_ON_TOP'
}

/** The display type of the Customer notification message */
export enum NotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum NotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

export enum NotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS'
}


/** Optional information to get a better contextual customer notification */
export interface NotificationOptionalContextInput {
  /** the optional field containing an error token, triggering the retrieval of an error message */
  errorToken?: Maybe<Scalars['String']>;
  /** itinerary number */
  itineraryNumber?: Maybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: Maybe<Array<NotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: Maybe<Scalars['URL']>;
  /** the optional field containing the token to retrieve the travel information */
  travelApiId?: Maybe<Scalars['String']>;
  /** trip folder id */
  tripFolderId?: Maybe<Scalars['String']>;
  /** trip item id */
  tripItemId?: Maybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaFiltersInput {
  /** airport code */
  airlinesFilter?: Maybe<Array<Scalars['String']>>;
  /** flight amenities */
  amenitiesFilter?: Maybe<Array<AmenityFilter>>;
  /** arrival time */
  arrivalTimeFilter?: Maybe<Array<FlightsTimePeriodOfDay>>;
  /** departure time */
  departureTimeFilter?: Maybe<Array<FlightsTimePeriodOfDay>>;
  /** number of stops */
  numberOfStopsFilter?: Maybe<Array<Scalars['Int']>>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaInput {
  /** cabin class */
  cabinClass?: Maybe<FlightsCabinClass>;
  /** start date and end date of the trip */
  dateRange?: Maybe<DateRangeInput>;
  /** destination information */
  destination?: Maybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip filters */
  filter?: Maybe<Array<NotificationOptionalContextJourneyCriteriaFiltersInput>>;
  /** origin information */
  origin?: Maybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip schedule changes status */
  scheduleChangeStatus?: Maybe<TripScheduleChangeStatus>;
  /** traveler details */
  travelerDetail?: Maybe<Array<TravelerDetailsInput>>;
  /** trip type */
  tripType?: Maybe<FlightsTripType>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: Maybe<Scalars['String']>;
  /** property id */
  propertyId?: Maybe<Scalars['String']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
}



/** The style to apply to phrase links */
export enum NotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}


/** The text style to apply to strings */
export enum NotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}









/** Represents the attributes on a notification that could be changed after an interaction */
export interface NotificationSpecificationsInput {
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars['Boolean']>;
  /** Notification id */
  id?: Maybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars['Boolean']>;
}

export enum NotificationState {
  READ = 'READ',
  SEEN = 'SEEN',
  UNKNOWN = 'UNKNOWN',
  UNSEEN = 'UNSEEN'
}

export enum NotificationSubType {
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  DEFAULT = 'DEFAULT'
}





export enum NotificationType {
  ALERT = 'ALERT',
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  BOTTOM_SHEET = 'BOTTOM_SHEET',
  CENTERED_SHEET = 'CENTERED_SHEET',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  CLEANLINESS = 'CLEANLINESS',
  CONFIGURABLE = 'CONFIGURABLE',
  ERROR = 'ERROR',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  ONETRUST = 'ONETRUST',
  OSANO = 'OSANO',
  RAF_BANNER = 'RAF_BANNER',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY',
  TRUST_MSG_BANNER = 'TRUST_MSG_BANNER',
  UNRECOVERABLE_ERROR = 'UNRECOVERABLE_ERROR'
}


export enum NotificationUserActionType {
  DELETE = 'DELETE',
  MARK_AS_READ = 'MARK_AS_READ',
  MARK_AS_UNREAD = 'MARK_AS_UNREAD',
  UNKNOWN = 'UNKNOWN'
}

/** Represents the the user input for customer notification mutation */
export interface NotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<NotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface NotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}

export enum NotificationsType {
  ALL = 'ALL'
}


/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: Scalars['String'];
  value: Scalars['Int'];
}




export enum OfferAttributeType {
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CC_REQUIRED = 'NO_CC_REQUIRED',
  PAYMENT_CHOICE = 'PAYMENT_CHOICE',
  VIP = 'VIP'
}








export interface OfferIdentityInput {
  /** Type of the offer details whether token or id */
  type: OfferIdentityType;
  /** The value of the identifier */
  value: Scalars['String'];
}

/** The identity to get or update insurtech offers could be both */
export enum OfferIdentityType {
  EG_OFFER_ID = 'EG_OFFER_ID',
  EG_OFFER_TOKEN = 'EG_OFFER_TOKEN'
}









/**
 * Represents EG Travel Platform API, consists of a productLine enumeration and a token.
 * https://confluence.expedia.biz/display/RPT/RFC-62-EG+-+OfferToken+-+guidelines+for+Product+Line+SPIs
 */
export interface OfferTokenInput {
  /** ProductLine associated with an Offer Token */
  lineOfBusiness: LineOfBusinessDomain;
  /** Encoded offer token string used to identify a specific product offer for purchase */
  token: Scalars['String'];
}







export interface OffersRecommendationAvailabilityFilterInput {
  dates?: Maybe<OptionalDateTimeRangeInput>;
  destination?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  travelMemberGroups?: Maybe<Array<TravelMemberGroupInput>>;
}







export enum OffersRecommendationContainerType {
  CAROUSEL = 'CAROUSEL',
  GRID = 'GRID'
}



export interface OffersRecommendationProductIdentifierInput {
  lineOfBusiness: LineOfBusinessDomain;
  productId: Scalars['String'];
}

export enum OffersRecommendationStrategy {
  ALTERNATE = 'ALTERNATE',
  ATTACH = 'ATTACH',
  CO_CLICK = 'CO_CLICK',
  NEARBY = 'NEARBY',
  POPULAR = 'POPULAR',
  TRENDING = 'TRENDING'
}


export interface OnboardingContext {
  onboardingSource: Scalars['String'];
}














export enum OneKeyOnboardingOperationStatus {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED',
  TIMED_OUT = 'TIMED_OUT'
}








export enum Operation {
  ADDITION = 'ADDITION',
  MULTIPLICATION = 'MULTIPLICATION'
}

export enum OperationStatus {
  FAILURE = 'FAILURE',
  INVALID_INPUT = 'INVALID_INPUT',
  SUCCESS = 'SUCCESS'
}



/** In order to pass any additional parameters */
export interface OptionalContextInput {
  /** If app user has enabled push notification in the device */
  pushEnabled?: Maybe<Scalars['Boolean']>;
}


/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: Maybe<DateTimeInput>;
  /** Optional starting date & time in this range */
  start?: Maybe<DateTimeInput>;
}

export interface OrderInfoInput {
  orderId: Scalars['String'];
  orderLine?: Maybe<Scalars['String']>;
}

/** Possible values for UITK mark's orientation prop */
export enum Orientation {
  /** Landscape orientation */
  LANDSCAPE = 'LANDSCAPE',
  /** Portrait orientation */
  PORTRAIT = 'PORTRAIT'
}








/** Package location */
export interface PackageLocationInput {
  airportCode: Scalars['String'];
  /** The Geo location of the region to search */
  coordinates?: Maybe<CoordinatesInput>;
  regionId?: Maybe<Scalars['String']>;
  /** The name of the region */
  regionName?: Maybe<Scalars['String']>;
}


/** Minimum set of data used to retrieve content about a package */
export interface PackageNaturalKeyInput {
  offerToken: Scalars['String'];
}




/** Represents the search criteria with which customers searched for packages */
export interface PackageSearchCriteriaInput {
  primary: PrimaryPackageSearchCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}


export enum PackageSort {
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}

export enum PackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_CAR = 'HOTEL_CAR'
}






export interface PackageUiActivityHeaderPrimerInput {
  productType: MishopUiProductType;
}



















export interface PackageUiFlightHeaderPrimerInput {
  productType: MishopUiProductType;
}



export interface PackageUiGroundTransferHeaderPrimerInput {
  productType: MishopUiProductType;
}




















/** Contains the necessary data to render banner for a changed product */
export interface PackageUiProductChangedBannerPrimerInput {
  currentPackageOfferId: PackageNaturalKeyInput;
  previousOffers: MultiItemProductsInput;
  previousPackageOfferId: PackageNaturalKeyInput;
}



/** Information needed to render the prebundle package product header */
export interface PackageUiProductHeaderPrimerInput {
  activityHeaderPrimer?: Maybe<PackageUiActivityHeaderPrimerInput>;
  flightHeaderPrimer?: Maybe<PackageUiFlightHeaderPrimerInput>;
  groundTransferHeaderPrimer?: Maybe<PackageUiGroundTransferHeaderPrimerInput>;
  propertyHeaderPrimer?: Maybe<PackageUiPropertyHeaderPrimerInput>;
}



export interface PackageUiPropertyHeaderPrimerInput {
  productType: MishopUiProductType;
}









/** Optional custom context information about the page where the query results will eventually be rendered */
export interface PageContextInput {
  propertySearch?: Maybe<PropertySearchCriteriaInput>;
}


/** Page identity */
export enum PageLocation {
  /** All checkout related pages */
  CHECKOUT = 'CHECKOUT',
  /** Checkout error pages for all LOBs */
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  /** Order confirmation pages for all LOBs */
  CONFIRMATION = 'CONFIRMATION',
  /** All product detail pages are identified as DETAILS */
  DETAILS = 'DETAILS',
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  ENTRY = 'ENTRY',
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  FEATURES = 'FEATURES',
  /** Payment error pages for all LOBs */
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  POST_BOOKING = 'POST_BOOKING',
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  SYSTEM = 'SYSTEM',
  /** User pages including sign-in, my account and rewards */
  USER = 'USER'
}

export enum PageState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}

/** Input for travelGuidePageContextInput pageType parameter */
export enum PageType {
  HOME_PAGE = 'HOME_PAGE',
  TRAVEL_GUIDE = 'TRAVEL_GUIDE'
}



export interface PaginationDetailsInput {
  next?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  previous?: Maybe<Scalars['Int']>;
}

/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: Maybe<Scalars['Int']>;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: Maybe<Scalars['Int']>;
}


export interface PartnerContextInput {
  detailsSiteConfiguration?: Maybe<TravelStoreV1CarDetailsInput>;
  partnerAccountId: Scalars['String'];
  searchSiteConfiguration?: Maybe<TravelStoreV1CarSearchInput>;
}











export enum PasswordWithStrengthMeterInputStrength {
  STRONG = 'STRONG',
  VERY_STRONG = 'VERY_STRONG',
  WEAK = 'WEAK'
}



export enum PasswordWithStrengthMeterProgressBarTheme {
  MUTED = 'MUTED',
  POSITIVE = 'POSITIVE'
}






































export enum PaymentType {
  COUPON_ELIGIBLE = 'COUPON_ELIGIBLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  GIFT_CARD = 'GIFT_CARD',
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_WITHOUT_CREDITCARD = 'PAY_WITHOUT_CREDITCARD'
}



/** Represents the logo size used by the client to render */
export enum PaymentTypeLogoSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL'
}






export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = 'GLOBAL_NAV_BUTTON',
  GLOBAL_NAV_LINK = 'GLOBAL_NAV_LINK'
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = 'MENU_ITEM',
  NAV_LINK = 'NAV_LINK'
}





export enum Placement {
  /** Horizontal Orientation of Images in the List */
  HORIZONTAL = 'Horizontal',
  /** Vertical Orientation of Images in the List */
  VERTICAL = 'Vertical'
}








/**
 * Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 * Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 * http://cldr.unicode.org/index/cldr-spec/plural-rules
 */
export enum PluralCategory {
  FEW = 'FEW',
  MANY = 'MANY',
  ONE = 'ONE',
  OTHER = 'OTHER',
  TWO = 'TWO',
  ZERO = 'ZERO'
}



/** Points related property search options  */
export enum Points {
  /** Don't use loyalty points to calculate the strikeout price. */
  SHOP_WITHOUT_POINTS = 'SHOP_WITHOUT_POINTS',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}







export interface PolicyFetchParamsInput {
  cartId?: Maybe<Scalars['String']>;
  offerToken?: Maybe<OfferTokenInput>;
  orderInfo?: Maybe<OrderInfoInput>;
}























/** Options that alter behavior of mutation - for backward compatibility */
export enum PrepareCheckoutResponseOption {
  ALTERNATIVE_ACTION_ON_FAILURE = 'ALTERNATIVE_ACTION_ON_FAILURE'
}






export interface PriceDetailsOptionsInput {
  metaDeeplink: Scalars['Boolean'];
}




export interface PriceFilterInput {
  facetValuesSize: Scalars['Int'];
  max: Scalars['Int'];
  maxIndex: Scalars['Int'];
  min: Scalars['Int'];
}
















/** Represents a query parameter in the deep link. */
export interface PriceInsightsDeepLinkQueryParamInput {
  key: Scalars['String'];
  value: Scalars['String'];
}
















/** Represent search context for all product lines */
export interface PriceInsightsSearchContextInput {
  carSearchCriteria?: Maybe<CarSearchCriteriaInput>;
  flightSearchCriteria?: Maybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: Maybe<PropertySearchCriteriaInput>;
}














export enum PriceMatchPromiseChartType {
  BAR = 'BAR',
  LINE = 'LINE'
}














export enum PriceMatchPromiseScaleType {
  DATE = 'DATE',
  LABEL = 'LABEL',
  TIME = 'TIME'
}



/** Represents the state for the PMP module */
export enum PriceMatchPromiseState {
  /** Represents when the PMP module is removable */
  REMOVABLE = 'REMOVABLE',
  /** Represents when the PMP module is selectable */
  SELECTABLE = 'SELECTABLE',
  /** Represents when the PMP module is static */
  STATIC = 'STATIC',
  /** Represents when the PMP module is toggleable */
  TOGGLEABLE = 'TOGGLEABLE'
}



















/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: Maybe<Scalars['Float']>;
  /** The minimum price, e.g. 50.00 */
  min?: Maybe<Scalars['Float']>;
}
















export enum PricingSchemeType {
  DAILY_RATE = 'DAILY_RATE',
  TOTAL_RATE = 'TOTAL_RATE'
}


/** Core criteria needed for an activities search */
export interface PrimaryActivitySearchCriteriaInput {
  dateRange?: Maybe<ActivitySearchCriteriaDateRangeInput>;
  destination?: Maybe<ActivitySearchCriteriaLocationInput>;
}


/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;
  dropOffLocation?: Maybe<CarRentalLocationInput>;
  pickUpDateTime: DateTimeInput;
  pickUpLocation: CarRentalLocationInput;
}

/** The core criteria needed for a cruise search */
export interface PrimaryCruiseCriteriaInput {
  adultCount?: Maybe<Scalars['Int']>;
  childCount?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<CruiseChildInput>>;
  departureDateRange?: Maybe<DateRangeInput>;
  destinations?: Maybe<Array<Scalars['String']>>;
  durationRange?: Maybe<CruiseDurationRangeInput>;
}


/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: Array<FlightsJourneyCriteriaInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  travelers: Array<TravelerDetailsInput>;
  tripType: FlightsTripType;
}


/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;
  direction: GroundTransfersDirection;
  journeyCriteria?: Maybe<Array<GroundTransfersJourneyCriteriaInput>>;
  locations: Array<GroundTransfersLocationInput>;
  pinnedOffers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  pinnedProductIds?: Maybe<Array<Scalars['String']>>;
  selectedOffers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  shoppingPath?: Maybe<ShoppingPathType>;
  travelerDetails: Array<GroundTransfersTravelerDetailsInput>;
}




export interface PrimaryPackageSearchCriteriaInput {
  /** Cabin class chosen for flight */
  cabinClass?: Maybe<FlightsCabinClass>;
  /** If not provided, packages returned will be for different duration and popular advance purchase window based on the themes */
  dateRange?: Maybe<DateRangeInput>;
  /** If not provided, packages returned will be for different popular destinations based on the themes */
  destination?: Maybe<PackageLocationInput>;
  /** If not provided, it will be resolved using user profile or ip sniffing */
  origin?: Maybe<PackageLocationInput>;
  /** If not provided, it will be defaulted to 1 occupancy unit for 2 adults */
  travelerOccupancyGroups?: Maybe<Array<TravelerOccupancyGroupInput>>;
}


/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: Maybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  flexSearchCriteria?: Maybe<FlexibleSearchCriteriaInput>;
  rooms: Array<RoomInput>;
}

/** User preference for data sharing with third parties which users may update */
export enum PrivacySellState {
  CAN_NOT_SELL = 'CAN_NOT_SELL',
  CAN_SELL = 'CAN_SELL'
}

/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK'
}










export enum ProductEntityAssetSelection {
  AMENITY = 'AMENITY',
  HEADLINE = 'HEADLINE',
  RELEVANT_AMENITY_DETAILS = 'RELEVANT_AMENITY_DETAILS',
  REVIEW_SUMMARY = 'REVIEW_SUMMARY'
}

/** Product Entity Input params */
export interface ProductEntityInput {
  /** product line */
  assetSelectionList: Array<ProductEntityAssetSelection>;
  /** Product Identifier */
  productIdentifier: ProductIdentifierInput;
}

/** Product Identifier wrapping type */
export interface ProductIdentifierInput {
  /** Id */
  id: Scalars['String'];
  /** product line */
  productLine?: Maybe<ProductLine>;
  /** search context */
  searchCriteriaSelections?: Maybe<Array<SearchCriteriaSelectionsInput>>;
  /** Identifier Type of Input */
  type: IdentifierType;
}


/** Enum to specify image width for product image */
export enum ProductImageWidth {
  FULL_WIDTH = 'FULL_WIDTH',
  HALF_WIDTH = 'HALF_WIDTH',
  QUARTER_WIDTH = 'QUARTER_WIDTH',
  THIRD_WIDTH = 'THIRD_WIDTH'
}



export enum ProductLine {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  INSURANCE = 'INSURANCE',
  LODGING = 'LODGING',
  PACKAGE = 'PACKAGE',
  PRODUCT_LINE_INVALID = 'PRODUCT_LINE_INVALID',
  RAIL = 'RAIL',
  UNRECOGNIZED = 'UNRECOGNIZED'
}







/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: Maybe<Scalars['String']>;
}

export enum ProductQuestionTopic {
  HOTEL = 'HOTEL'
}









/** Input to productSummary Query */
export interface ProductSummaryInput {
  /** Identifier String of Input */
  id: Scalars['String'];
  /** Identifier Type of Input */
  idType: IdentifierType;
}




export enum ProductType {
  ARTICLE = 'ARTICLE',
  CAR_DETAILS = 'CAR_DETAILS',
  DESTINATION = 'DESTINATION',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  EXPERIENCE = 'EXPERIENCE',
  EXPERT_TIP = 'EXPERT_TIP',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LX_DETAILS = 'LX_DETAILS',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI_GAIA = 'POI_GAIA',
  PROPERTY_DETAILS = 'PROPERTY_DETAILS'
}




















/** Represents layout of buttons. */
export enum ProfileButtonLayout {
  /** Horizontally stacked buttons. */
  INLINE = 'INLINE',
  /** Vertically stacked buttons. */
  STACKED = 'STACKED'
}






















/** Specifies whether to open the link in the same user interface context or in a different context */
export enum ProfileLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}





















/** Represents where a wizard will be displayed */
export interface ProfileWizardContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageLocation: PageLocation;
}




/** Possible actions for the Activities Cross Sell links that will be shown as a sticky card on PDP  */
export enum PropertyActivitiesCrossSellActionType {
  DISMISS = 'DISMISS',
  EDIT = 'EDIT',
  OPEN = 'OPEN',
  REMOVE = 'REMOVE'
}










/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE'
}


export enum PropertyAmenityType {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CONVENIENCES = 'CONVENIENCES',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FOOD_DRINK = 'FOOD_DRINK',
  GUEST_SERVICES = 'GUEST_SERVICES',
  INTERNET = 'INTERNET',
  MORE = 'MORE',
  OUTDOOR = 'OUTDOOR',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PROPERTY = 'PROPERTY',
  ROOM = 'ROOM',
  SPA = 'SPA',
  THINGS_TO_DO = 'THINGS_TO_DO'
}





export enum PropertyCalendarPriceTrend {
  /** Negative price trend */
  NEGATIVE = 'NEGATIVE',
  /** Positive price trend */
  POSITIVE = 'POSITIVE'
}




export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  REFUNDABLE_WITH_NO_PENALTY = 'REFUNDABLE_WITH_NO_PENALTY',
  REFUNDABLE_WITH_PENALTY = 'REFUNDABLE_WITH_PENALTY'
}




















export enum PropertyContentType {
  /** Detailed view that appears in expanded modal. */
  DETAILED = 'DETAILED',
  /** Simplified view that appears flat on page. */
  SUMMARY = 'SUMMARY'
}

export interface PropertyContext {
  propertyId: Scalars['String'];
}


export interface PropertyDateRangeInput {
  checkInDate: DateInput;
  checkOutDate: DateInput;
}






export interface PropertyDetailsMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

export enum PropertyDetailsPropertyType {
  HOTEL = 'HOTEL',
  VACATION_RENTAL = 'VACATION_RENTAL'
}







export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  ACCESSIBLE_PARKING = 'ACCESSIBLE_PARKING',
  ELEVATOR = 'ELEVATOR',
  IN_ROOM_ACCESSIBLE = 'IN_ROOM_ACCESSIBLE',
  ROLL_IN_SHOWER = 'ROLL_IN_SHOWER',
  SERVICE_ANIMAL = 'SERVICE_ANIMAL',
  SIGN_LANGUAGE_INTERPRETER = 'SIGN_LANGUAGE_INTERPRETER',
  STAIR_FREE_PATH = 'STAIR_FREE_PATH'
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  BALCONY_OR_TERRACE = 'BALCONY_OR_TERRACE',
  BAR = 'BAR',
  BEACH = 'BEACH',
  CASINO = 'CASINO',
  CRIB = 'CRIB',
  ELECTRIC_CAR = 'ELECTRIC_CAR',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  GOLF = 'GOLF',
  GYM = 'GYM',
  HOT_SPRING = 'HOT_SPRING',
  HOT_TUB = 'HOT_TUB',
  KITCHEN_KITCHEN = 'KITCHEN_KITCHEN',
  KITCHEN_KITCHENETTE = 'KITCHEN_KITCHENETTE',
  OCEAN_VIEW = 'OCEAN_VIEW',
  PARKING = 'PARKING',
  PETS = 'PETS',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  SPA_ON_SITE = 'SPA_ON_SITE',
  WASHER_DRYER = 'WASHER_DRYER',
  WATER_PARK = 'WATER_PARK',
  WIFI = 'WIFI'
}























/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}








/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta affcid channel code */
  affcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afflid channel code */
  afflid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afmcid channel code */
  afmcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta brandcid channel code */
  brandcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emlcid channel code */
  emlcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emldtl channel code */
  emldtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta gclid channel code */
  gclid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmcid channel code */
  icmcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmdtl channel code */
  icmdtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta k_user_id channel code */
  k_user_id?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta kword channel code */
  kword?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta lnkloc channel code */
  lnkloc?: Maybe<Scalars['String']>;
  /**
   * A consolidated list of marketing channels in key/value pairs.
   * Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}]
   */
  marketingChannels?: Maybe<Array<PropertyMarketingTagInput>>;
  /**
   * A consolidated list of marketing prices in key/value pairs.
   * Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}]
   */
  marketingPrices?: Maybe<Array<PropertyMarketingTagInput>>;
  /** Deprecated: Don't get/set value from this field , ReplaceWith("marketingChannels") ,Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: Maybe<Scalars['Int']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta mdpcid channel code */
  mdpcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field,ReplaceWith("marketingChannels"),  Meta mdpdtl channel code */
  mdpdtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta olacid channel code */
  olacid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta oladtl channel code */
  oladtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semcid channel code */
  semcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semdtl channel code */
  semdtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta seocid channel code */
  seocid?: Maybe<Scalars['String']>;
}


/**
 * An object with simple key/value combination for a marketing channel or price.
 * Example: {"key": "mctc", "value": "3"}
 */
export interface PropertyMarketingTagInput {
  key: Scalars['String'];
  value: Scalars['String'];
}


/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  businessModelType?: Maybe<BusinessModelType>;
  checkIn: DateInput;
  checkOut: DateInput;
  id: Scalars['String'];
  inventoryType: InventoryType;
  noCreditCard?: Maybe<Scalars['Boolean']>;
  /** Pet permissibility & inclusion at property. Necessary when pets are used in primary search criteria */
  petsIncluded?: Maybe<Scalars['Boolean']>;
  ratePlanId: Scalars['String'];
  ratePlanType?: Maybe<Scalars['String']>;
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  shoppingPath?: Maybe<ShoppingPathType>;
}



/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: Array<PropertyNaturalKeyInput>;
  /** The index of the room user is adding */
  offerIndex: Scalars['Int'];
}





export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = 'ARTIFICIALLY_FENCED_RATE',
  MIXED_RATE_PLAN = 'MIXED_RATE_PLAN',
  NO_CREDIT_CARD = 'NO_CREDIT_CARD'
}

export enum PropertyPaymentModel {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}



/** Indicate what are the payment options for a given offer */
export enum PropertyPaymentType {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}






export enum PropertyRecommendationStrategy {
  NEARBY_PROPERTIES = 'NEARBY_PROPERTIES',
  SIMILAR_PROPERTIES = 'SIMILAR_PROPERTIES'
}





/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = 'BUSINESS_TRAVELERS',
  COUPLES = 'COUPLES',
  EVERYONE = 'EVERYONE',
  FAMILIES = 'FAMILIES',
  GETAWAY_WITH_FRIENDS = 'GETAWAY_WITH_FRIENDS',
  GOLF = 'GOLF',
  OTHER = 'OTHER',
  OVERNIGHT_STAY = 'OVERNIGHT_STAY',
  PERSONAL_EVENT = 'PERSONAL_EVENT',
  SHOPPING = 'SHOPPING',
  SPA = 'SPA',
  STUDENTS = 'STUDENTS'
}



/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: Maybe<PropertyReviewCategory>;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: Maybe<Scalars['Boolean']>;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: Maybe<Scalars['Boolean']>;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: Maybe<Scalars['String']>;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Maybe<Scalars['Locale']>;
  /** Filter review results by a list of review ratings */
  ratings?: Maybe<Array<Scalars['Float']>>;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: Maybe<PropertyReviewType>;
  /** Filter review results by room type */
  roomTypeId?: Maybe<Scalars['Int']>;
  /** Filter review results by user provided keyword */
  searchTerm?: Maybe<Scalars['String']>;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by travel companions */
  travelCompanion?: Maybe<Array<Scalars['String']>>;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by trip reasons */
  tripReason?: Maybe<Array<Scalars['String']>>;
}








/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  NEWEST_TO_OLDEST_BY_LANGUAGE = 'NEWEST_TO_OLDEST_BY_LANGUAGE',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
  OLDEST_TO_NEWEST_BY_LANGUAGE = 'OLDEST_TO_NEWEST_BY_LANGUAGE'
}




/** [Optional] Review filter type */
export enum PropertyReviewType {
  /** filter reviews by rating <= 2 */
  CRITICAL = 'CRITICAL',
  /** filter reviews by rating >= 3 */
  POSITIVE = 'POSITIVE',
  /** filter reviews by latest date */
  RECENT = 'RECENT'
}





/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
}



/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}



/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: Maybe<Array<PropertyFilterAccessibility>>;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: Maybe<Array<AgencyBusinessModel>>;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: Maybe<Array<PropertyFilterAmenity>>;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: Maybe<Array<Scalars['Int']>>;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: Maybe<Scalars['String']>;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: Maybe<Array<CleaningAndSafetyPractice>>;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: Maybe<Array<CommissionTier>>;
  /** Filter results by Deals */
  deals?: Maybe<Array<DealType>>;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: Maybe<Array<MealPlanFilterAmenity>>;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: Maybe<Scalars['String']>;
  /** Filter results by the payment type. */
  paymentType?: Maybe<Array<PaymentType>>;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: Maybe<Scalars['String']>;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: Maybe<PriceRangeInput>;
  /** Deprecated: Legacy input is now combined", ReplaceWith("LegacyPropertySearchCriteria", PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: Maybe<Array<Scalars['Int']>>;
  /** Filter results by user provided string */
  propertyName?: Maybe<Scalars['String']>;
  /** Property syle filters */
  propertyStyles?: Maybe<Array<PropertyStyle>>;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: Maybe<ReviewScoreRangeInput>;
  /** Rewards Type filters */
  rewards?: Maybe<Array<Scalars['String']>>;
  /** Filter results by availability */
  showAvailableOnly?: Maybe<Scalars['Boolean']>;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: Maybe<Array<Scalars['Float']>>;
  /** Deprecated - ReplaceWith("starList") , Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: Maybe<StarRangeInput>;
  /** Deprecated: TNL 42683 - BEX_VR_STAY_FILTER, Filter results by Stay Type. Example: Hotels and Resorts, Vacation Rentals */
  stayTypes?: Maybe<Array<StayType>>;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: Maybe<Array<StructureType>>;
  /** An SEM theme that needs to be passed through to other services */
  theme?: Maybe<Scalars['String']>;
  /** Filter results by the type of traveler. */
  travelerType?: Maybe<Array<TravelerType>>;
  /** Filter results by VIP only properties */
  vipOnly?: Maybe<Scalars['Boolean']>;
}







export interface PropertySearchMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  /** Only return travelAds, excluding this will result in a mixed set of organic listings and ads */
  ADS_ONLY = 'ADS_ONLY',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}



export enum PropertySectionRef {
  PRICE_DISPLAY_SERVICE_RESPONSE = 'PRICE_DISPLAY_SERVICE_RESPONSE',
  RECOMMENDED_OFFER = 'RECOMMENDED_OFFER',
  ROOMS_AND_RATES = 'ROOMS_AND_RATES'
}



/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: Maybe<Listings>;
  /** Paandi redirection to white label */
  paandiRedirection?: Maybe<Scalars['String']>;
  /** Points related property search option */
  points?: Maybe<Points>;
  /** DEPRECATED. regionType only used for EG-Typeahead url params */
  typeaheadRegionType?: Maybe<Scalars['Int']>;
}

/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = 'AARP_MEMBER_DISCOUNT',
  BEST_DEAL = 'BEST_DEAL',
  DISTANCE = 'DISTANCE',
  MAXIMUM_SAVINGS = 'MAXIMUM_SAVINGS',
  MAXIMUM_SAVINGS_PERCENT = 'MAXIMUM_SAVINGS_PERCENT',
  MEMBER_PRICING = 'MEMBER_PRICING',
  PACKAGE_SAVINGS = 'PACKAGE_SAVINGS',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_RELEVANT = 'PRICE_RELEVANT',
  PROPERTY_CLASS = 'PROPERTY_CLASS',
  PROPERTY_NAME = 'PROPERTY_NAME',
  RECOMMENDED = 'RECOMMENDED',
  REVIEW = 'REVIEW',
  REVIEW_RELEVANT = 'REVIEW_RELEVANT',
  VACATION_RENTAL = 'VACATION_RENTAL'
}



export enum PropertyStyle {
  BOUTIQUE = 'BOUTIQUE',
  HOMES = 'HOMES',
  HOTELS = 'HOTELS',
  LGBT = 'LGBT',
  LUXURY = 'LUXURY',
  OUTDOOR = 'OUTDOOR',
  UNIQUE = 'UNIQUE'
}







/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: Maybe<Scalars['String']>;
  candidateHmGuid?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  slots?: Maybe<Scalars['String']>;
  testVersionOverride?: Maybe<Scalars['String']>;
  trackingData: Scalars['String'];
}










export enum QuestionSortType {
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST'
}





/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
}


export enum RateDiscountType {
  MEMBER_DEAL = 'MEMBER_DEAL',
  MOBILE_EXCLUSIVE = 'MOBILE_EXCLUSIVE',
  REGULAR = 'REGULAR',
  TONIGHT_ONLY = 'TONIGHT_ONLY'
}











export enum RecentActivityType {
  BROWSING_HISTORY = 'BROWSING_HISTORY',
  RECENT_SEARCHES = 'RECENT_SEARCHES',
  VIEWED_OFFERS = 'VIEWED_OFFERS',
  VIEWED_PRODUCTS = 'VIEWED_PRODUCTS'
}








export enum RecommendedType {
  BESPOKE = 'BESPOKE',
  DESTINATIONS = 'DESTINATIONS',
  OFFERS = 'OFFERS'
}



/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  HIGH_LEVEL_REGION = 'HIGH_LEVEL_REGION',
  METRO_STATION = 'METRO_STATION',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  PROVINCE_STATE = 'PROVINCE_STATE',
  TRAIN_STATION = 'TRAIN_STATION',
  UNKNOWN = 'UNKNOWN'
}



export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars['String']>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars['String'];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars['String'];
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: Scalars['String'];
  offerTypeId?: Maybe<Scalars['Int']>;
}










export interface ResidencyDetailsInput {
  /** Country code Selection */
  countryCode?: Maybe<Scalars['String']>;
  /** Region code Selection */
  regionCode?: Maybe<Scalars['String']>;
}

export enum ResidencyState {
  APPLIED = 'APPLIED',
  AVAILABLE = 'AVAILABLE'
}


/** Tags Associated with the response */
export enum ResponseTagType {
  CACHE_SOURCE_AIRBLAZE = 'CACHE_SOURCE_AIRBLAZE',
  CACHE_SOURCE_BYOT_AIRBLAZE = 'CACHE_SOURCE_BYOT_AIRBLAZE',
  EXPERIENCE_SEARCH_CACHE_HYDRATOR = 'EXPERIENCE_SEARCH_CACHE_HYDRATOR',
  LISTINGS_PAGINATED_SLICED = 'LISTINGS_PAGINATED_SLICED',
  LISTING_CACHE_SOURCE = 'LISTING_CACHE_SOURCE',
  LISTING_DOWNLEVEL_SOURCE = 'LISTING_DOWNLEVEL_SOURCE',
  RESPONSE_SUMMARY_CACHED_CONFIG = 'RESPONSE_SUMMARY_CACHED_CONFIG',
  RESPONSE_SUMMARY_CACHED_ML = 'RESPONSE_SUMMARY_CACHED_ML',
  RESPONSE_SUMMARY_HYBRID = 'RESPONSE_SUMMARY_HYBRID',
  RESPONSE_SUMMARY_LIVE = 'RESPONSE_SUMMARY_LIVE',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum Result {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}











export interface ReviewAnswerInput {
  answer?: Maybe<ReviewsFormRatingValueInput>;
  questionUrn: Scalars['String'];
}




/** Enum of types of review interactions */
export enum ReviewInteractionType {
  HELPFUL_REVIEW = 'HELPFUL_REVIEW',
  REVIEW_REPORT_FLAG = 'REVIEW_REPORT_FLAG'
}


/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: Maybe<Scalars['Float']>;
  /** The minimum review score, e.g. 1.0 */
  min?: Maybe<Scalars['Float']>;
}


















export interface ReviewsFormRatingValueInput {
  boolValue?: Maybe<Scalars['Boolean']>;
  numberValue?: Maybe<Scalars['Int']>;
  stringValue?: Maybe<Scalars['String']>;
  tagValue?: Maybe<ReviewsFormTagValueInput>;
}


export interface ReviewsFormTagValueInput {
  customValue?: Maybe<Scalars['String']>;
  tagUrns: Array<Scalars['String']>;
}

export enum RewardsOption {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION'
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}





/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: Scalars['Int'];
  /** The number of children in the room */
  children?: Maybe<Array<ChildInput>>;
}






export enum RouteType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}





















/** SearchCriteriaSelections */
export interface SearchCriteriaSelectionsInput {
  /** Id */
  id: Scalars['String'];
  /** value */
  value: Scalars['String'];
}




/** Search form product types */
export enum SearchFormProductType {
  ACTIVITIES = 'ACTIVITIES',
  CARS = 'CARS',
  CRUISES = 'CRUISES',
  FLIGHTS = 'FLIGHTS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES'
}



/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  /** Grouping using searches made 7 days from most recent search in same region */
  SEVEN_DAYS = 'SEVEN_DAYS',
  /** Grouping using searches made 3 days from most recent search in same region */
  THREE_DAYS = 'THREE_DAYS'
}

/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  /** Grouping using multi_city_vicinity destination type for searches. */
  METRO_CITY = 'METRO_CITY'
}



/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: Scalars['String'];
  /** Search item regionId. */
  regionId: Scalars['String'];
  /** Search item region type. */
  regionType?: Maybe<Scalars['String']>;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: Scalars['String'];
}

/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: Maybe<SearchHistoryDayRange>;
  /** Search history grouping based on specified destination type. */
  destinationType?: Maybe<SearchHistoryDestinationType>;
}


/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** DEPRECATED: Customer spinner call no longer made before property search. List of interests coming from Customer Spinner */
  interests?: Maybe<Array<InterestInput>>;
  /** DEPRECATED. Use semdtl. SEM param, fetch from URL */
  semDtl?: Maybe<Scalars['String']>;
  /** SEM param, fetch from URL */
  semdtl?: Maybe<Scalars['String']>;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: Maybe<Scalars['String']>;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: Maybe<Scalars['String']>;
}

/** The offer details from the search results page */
export interface SearchOfferInput {
  /** Used to pass selected offer data from SRP to PDP */
  offerDetails?: Maybe<Array<SelectedValueInput>>;
  /** The price of the search results offer */
  offerPrice?: Maybe<SearchOfferPriceInput>;
  ratePlanId?: Maybe<Scalars['String']>;
  roomTypeId?: Maybe<Scalars['String']>;
}

/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: Maybe<Scalars['String']>;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: Maybe<Scalars['String']>;
  /** The total price of the search offer */
  price?: Maybe<MoneyInput>;
}


/** Enum class to represent the type of seat choice */
export enum SeatChoiceType {
  SEAT_CHOICE = 'SEAT_CHOICE'
}




/** Represents seat segment for which seat map is to be shown. */
export interface SeatSegmentInput {
  /** Fare Basis Code required for traveler */
  fareBasisCode: Scalars['String'];
  /** This will be used for unique identification of segment */
  identifier: Scalars['String'];
  /** Operating Carrier Code for each segment */
  operatingCarrierCode: Scalars['String'];
}

/** Enum class to represent the seat type variant. */
export enum SeatVariant {
  ACCESSIBLE = 'ACCESSIBLE',
  AISLE = 'AISLE',
  AVAILABLE = 'AVAILABLE',
  COLUMN = 'COLUMN',
  EXIT = 'EXIT',
  GALLEY = 'GALLEY',
  PREFERRED = 'PREFERRED',
  RESTROOM = 'RESTROOM',
  ROW = 'ROW',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE'
}




















/** Type for Selected Baggage template */
export enum SelectedAncillaryTemplateType {
  MULTIPLE = 'MULTIPLE',
  NONE = 'NONE',
  ONE = 'ONE'
}


/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}














export enum ServiceAutomationToolbarElevation {
  FLAT = 'FLAT',
  FLOATING = 'FLOATING'
}

export enum ServiceAutomationToolbarNavType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
  EXPAND_UP = 'EXPAND_UP'
}















export interface ShopInsurtechOffersRequestInput {
  /** The cart ID */
  cartId: Scalars['String'];
  /** Client id that refer to the page the user reach out to the module from, e.g.: eg_checkout, car_info_site. */
  insurtechClientId: InsurtechClientId;
  /** Residency details to get details according to country and region */
  residencyDetails?: Maybe<ResidencyDetailsInput>;
  /** identify whether the residency already applied or available */
  residencyState?: Maybe<ResidencyState>;
}



export interface ShoppedProductInput {
  products: MultiItemProductsInput;
  shoppingPath: ShoppingPathType;
}



/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: Maybe<MultiItemContextInput>;
}












/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = 'ATTACH',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE'
}








/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: Maybe<Array<BooleanValueInput>>;
  counts?: Maybe<Array<NumberValueInput>>;
  dates?: Maybe<Array<DateValueInput>>;
  ranges?: Maybe<Array<RangeValueInput>>;
  selections?: Maybe<Array<SelectedValueInput>>;
}







/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  CLEAR_DATA = 'CLEAR_DATA',
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  CLOSE_AND_APPLY = 'CLOSE_AND_APPLY',
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  CLOSE_AND_DO_NOT_APPLY = 'CLOSE_AND_DO_NOT_APPLY',
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   *        on click of Input Field it should open Typeahead Modal
   */
  OPEN_MODAL = 'OPEN_MODAL'
}



















export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not have to match region type, but will be used to find the relevant destination type based on region type provided */
  regionId: Scalars['String'];
}





/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: Scalars['String'];
  value: Scalars['String'];
}






export interface SideSheetQueryContextInput {
  addOnRequested: Array<AddOnRequested>;
  isFirstLoad?: Maybe<Scalars['Boolean']>;
  journeyContinuationId: Scalars['String'];
}












/** Input argument for Sites configurations request */
export interface SiteConfigurationsRequestInput {
  /** List of Site IDs to retrieve site information for */
  siteIds: Array<Scalars['Int']>;
}














export interface SmartFormDataInput {
  /** Timestamp at which this mutation was sent by the client. */
  timestamp: Scalars['String'];
  userInput: SmartFormUserInput;
}




























/** To define which type of keystrokes will be considered by this input. */
export enum SmartFormTextInputVariant {
  EMAIL = 'EMAIL',
  NUMERIC = 'NUMERIC',
  TEL = 'TEL',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA'
}



/** Value collected corresponding to a field represented by inputId */
export interface SmartFormUserFieldInput {
  inputId: Scalars['String'];
  value: Array<Scalars['String']>;
}

/** Collection of the values collected corresponding to fields */
export interface SmartFormUserInput {
  userFieldInputs: Array<SmartFormUserFieldInput>;
}







/**
 * "
 *     Type of operation to perform.
 */
export enum SortAndFilterBasicFilterPayloadType {
  /** Check selected filter option */
  OPTION = 'OPTION',
  /** Remove selected filter */
  REMOVE = 'REMOVE'
}




/** Specifies when a signal should be emitted */
export enum SortAndFilterSignalCondition {
  /** When a filter value changes from the default value to a non default value */
  DEFAULT_TO_NON_DEFAULT = 'DEFAULT_TO_NON_DEFAULT',
  /** When a filter value changes from a non default value to the default value */
  NON_DEFAULT_TO_DEFAULT = 'NON_DEFAULT_TO_DEFAULT',
  /** When a filter value changes from a non default value to a different non default value */
  NON_DEFAULT_TO_NON_DEFAULT = 'NON_DEFAULT_TO_NON_DEFAULT',
  /** When a filter state changes from unselected to selected */
  SELECTED = 'SELECTED',
  /** When a filter state changes from selected to unselected */
  UNSELECTED = 'UNSELECTED'
}






/** Contains the different views for Sort and Filters, where each of them is meant to be on a specific page section or viewport. */
export enum SortAndFiltersViewType {
  /**
   * Represent a view where it's displayed applied filters as removable pills.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  APPLIED_FILTERS = 'APPLIED_FILTERS',
  /**
   * Represent a view where it's only displayed a list of filters.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, in the left side of the results on a Search Results Page.
   */
  FILTERS = 'FILTERS',
  /**
   * Represent a view where the list of filters are displayed as pills.
   * Used for all viewport sizes, on top of the results on a Search Results Page.
   */
  FILTERS_PILLS = 'FILTERS_PILLS',
  /**
   * Represent a view where it displays a filter bar with an All Filters button.
   * Used for all viewport sizes, above the results in the Vrbex SRP split view template.
   */
  FILTER_BAR = 'FILTER_BAR',
  /**
   * Represent a view where it displays a dialog with only `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for all viewport sizes, inside toolbars.
   */
  FILTER_DIALOG = 'FILTER_DIALOG',
  /**
   * Represent a view where it's only displayed a list of sort fields, it usually contains a single section with a sort field.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, above the results in a Search Results Page.
   */
  SORT = 'SORT',
  /**
   * Represent a view of a combined list of the `sort` and `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SORT_AND_FILTERS = 'SORT_AND_FILTERS',
  /**
   * Represent a view where sort options are displayed as tabs with each tab displaying the sorted results based on the selected tab.
   * Used for all viewport sizes.
   */
  SORT_TABS = 'SORT_TABS'
}


export enum SourceType {
  ESR = 'ESR',
  GDS = 'GDS'
}






/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
  BICYCLE_RACK = 'BICYCLE_RACK',
  BOOSTER_SEAT = 'BOOSTER_SEAT',
  INFANT_SEAT = 'INFANT_SEAT',
  LEFT_HAND_CONTROL = 'LEFT_HAND_CONTROL',
  LUGGAGE_RACK = 'LUGGAGE_RACK',
  NAV_SYSTEM = 'NAV_SYSTEM',
  RIGHT_HAND_CONTROL = 'RIGHT_HAND_CONTROL',
  ROAD_CONGESTION_PAYMENT_SCHEME = 'ROAD_CONGESTION_PAYMENT_SCHEME',
  SATELLITE_RADIO = 'SATELLITE_RADIO',
  SKI_RACK = 'SKI_RACK',
  SNOW_CHAINS = 'SNOW_CHAINS',
  SNOW_TIRES = 'SNOW_TIRES',
  TODDLER_SEAT = 'TODDLER_SEAT',
  TOLL_PAYMENT_TAG_PASS = 'TOLL_PAYMENT_TAG_PASS',
  TRAILER_HITCH = 'TRAILER_HITCH',
  WIFI_ACCESS = 'WIFI_ACCESS',
  WINTER_PACKAGE = 'WINTER_PACKAGE'
}








/** Context needed to request sponsored content */
export interface SponsoredContentContextInput {
  /** Page name Eg. page.Hotels.Infosite.Information */
  pageName: Scalars['String'];
  /** Unique identifier for sponsored content placements */
  sponsoredContentId: Scalars['String'];
  /** Model for ad targeting input */
  targeting?: Maybe<SponsoredContentTargetingInput>;
  /** Target variant. Eg. pwa */
  variant?: Maybe<Scalars['String']>;
}


/** Location resolution by type */
export enum SponsoredContentLocationResolver {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA'
}

/** Location resolution by type */
export enum SponsoredContentLocationResolverInput {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA'
}






/** The type of the ad placement */
export enum SponsoredContentProductType {
  BRAND_RESULT_LISTING_FLIGHTS = 'BRAND_RESULT_LISTING_FLIGHTS',
  BRAND_RESULT_LISTING_LODGING = 'BRAND_RESULT_LISTING_LODGING',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  MULTI_LISTING_AD = 'MULTI_LISTING_AD'
}



/** Input model to hold targeting params for queries. */
export interface SponsoredContentTargetingInput {
  /** number of adults included in the search */
  adults?: Maybe<Scalars['Int']>;
  /** End date of trip. Optional for dateless searches */
  dateEnd?: Maybe<DateInput>;
  /** Start date of trip. Optional for dateless searches */
  dateStart?: Maybe<DateInput>;
  /** Destination for the trip. */
  destination?: Maybe<Scalars['String']>;
  /** number of kids included in the search */
  kids?: Maybe<Scalars['Int']>;
  /** Type of location for origin and dest. */
  locationResolver?: Maybe<SponsoredContentLocationResolverInput>;
  /** Origin for the trip. */
  origin?: Maybe<Scalars['String']>;
}



export interface StarRangeInput {
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
}









/** Property search filtering options */
export enum StayType {
  CONVENTIONAL = 'CONVENTIONAL',
  VACATION_RENTALS = 'VACATION_RENTALS'
}














export enum StepReviewInlineEditingSheetButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}








export enum StrikeOutType {
  ATTACH = 'ATTACH',
  INVALID = 'INVALID',
  LOYALTY = 'LOYALTY',
  PACKAGE = 'PACKAGE',
  PRICE_SURVEY = 'PRICE_SURVEY',
  STANDALONE = 'STANDALONE'
}

export enum StructureType {
  AGRITOURISM = 'AGRITOURISM',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APARTMENT = 'APARTMENT',
  APART_HOTEL = 'APART_HOTEL',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CABIN = 'CABIN',
  CAPSULE_HOTEL = 'CAPSULE_HOTEL',
  CARAVAN_PARK = 'CARAVAN_PARK',
  CASTLE = 'CASTLE',
  CHALET = 'CHALET',
  CONDO = 'CONDO',
  CONDO_RESORT = 'CONDO_RESORT',
  COTTAGE = 'COTTAGE',
  COUNTRY_HOUSE = 'COUNTRY_HOUSE',
  CRUISE = 'CRUISE',
  ECO_HOTEL = 'ECO_HOTEL',
  GUEST_HOUSE = 'GUEST_HOUSE',
  HOLIDAY_PARK = 'HOLIDAY_PARK',
  HOSTAL = 'HOSTAL',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  HOTEL_RESORT = 'HOTEL_RESORT',
  HOUSE_BOAT = 'HOUSE_BOAT',
  INN = 'INN',
  LODGE = 'LODGE',
  LONGHOUSE = 'LONGHOUSE',
  MOTEL = 'MOTEL',
  OVERWATER = 'OVERWATER',
  PALACE = 'PALACE',
  PENSION = 'PENSION',
  POUSADA_BRAZIL = 'POUSADA_BRAZIL',
  POUSADA_PORTUGAL = 'POUSADA_PORTUGAL',
  RANCH = 'RANCH',
  RESIDENCE = 'RESIDENCE',
  RIAD = 'RIAD',
  RYOKAN = 'RYOKAN',
  SAFARI = 'SAFARI',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  TOWNHOUSE = 'TOWNHOUSE',
  TRADITIONAL_BUILDING = 'TRADITIONAL_BUILDING',
  TREE_HOUSE = 'TREE_HOUSE',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  VILLA = 'VILLA',
  VIP = 'VIP'
}








export interface SupplyAmenitiesGroupInput {
  groupId: Scalars['String'];
  roomTypeId?: Maybe<Scalars['String']>;
  spaceId?: Maybe<Scalars['String']>;
}




export interface SupplyAmenitiesUpdateInput {
  groupId: Scalars['String'];
  roomTypeId?: Maybe<Scalars['String']>;
  amenities: Array<SupplyAmenityInput>;
}


export interface SupplyAmenityInput {
  elementId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}







export interface SupplyCancellationWaiverApprovalRequestContext {
  bookingItemId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
}







export interface SupplyCancellationWaiverReservationContext {
  bookingItemId: Scalars['String'];
}









export interface SupplyContentAdditionalInfoUpdateInput {
  bathrooms?: Maybe<Scalars['String']>;
  bedrooms?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
}


export interface SupplyContentAmenityInput {
  uuid: Scalars['String'];
  value: Scalars['String'];
}








export enum SupplyContentDescriptionSectionName {
  PROPERTY_NAME = 'PROPERTY_NAME',
  HEADLINE = 'HEADLINE',
  DESCRIPTION = 'DESCRIPTION',
  MANUAL_TRANSLATION = 'MANUAL_TRANSLATION',
  ABOUT_YOU = 'ABOUT_YOU',
  WHY_THIS_PROPERTY = 'WHY_THIS_PROPERTY',
  UNIQUE_BENEFITS = 'UNIQUE_BENEFITS',
  BATHROOMS_ADDITIONAL_INFO = 'BATHROOMS_ADDITIONAL_INFO',
  BEDROOMS_ADDITIONAL_INFO = 'BEDROOMS_ADDITIONAL_INFO',
  PROPERTY_ADDITIONAL_INFO = 'PROPERTY_ADDITIONAL_INFO',
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  INTERIOR_SIZE = 'INTERIOR_SIZE',
  SUITABILITY_AMENITY = 'SUITABILITY_AMENITY'
}








export interface SupplyContentHeadlineDescriptionUpdateInput {
  propertyName?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
}














export enum SupplyContentManualTranslationOperation {
  ADD = 'ADD',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE'
}





export interface SupplyContentManualTranslationUpdateInput {
  locale: Scalars['String'];
  optOutAutoTranslation: Scalars['Boolean'];
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  operation: SupplyContentManualTranslationOperation;
}

















export interface SupplyContentUpdateLocationInput {
  showExactLocation: Scalars['Boolean'];
}



export interface SupplyContentYourPropertyUpdateInput {
  propertyTypeId?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  amenities?: Maybe<Array<SupplyContentAmenityInput>>;
}


export interface SupplyContentYourStoryUpdateInput {
  aboutYou?: Maybe<Scalars['String']>;
  whyThisProperty?: Maybe<Scalars['String']>;
  uniqueBenefits?: Maybe<Scalars['String']>;
}












export interface SupplyCurrentPageContext {
  /** The current relative path for the page */
  path?: Maybe<Scalars['String']>;
  /** specifies any query params the current page has like htid */
  search?: Maybe<Scalars['String']>;
  /** field for native , defining the current native view- like reservations/inbox */
  view?: Maybe<Scalars['String']>;
}




export enum SupplyDashboardType {
  DASHBOARD = 'DASHBOARD',
  LEGACY = 'LEGACY'
}


export interface SupplyFeeFilterInput {
  includedFees?: Maybe<Array<Scalars['String']>>;
}




export interface SupplyFeesInput {
  productCode: Scalars['String'];
  type: Scalars['String'];
  amount: Scalars['Float'];
}









export interface SupplyIndirectTaxInput {
  legalName: Scalars['String'];
  registrationStatus: Scalars['String'];
  taxId: Scalars['String'];
}

























/** Input for generating mfa code */
export interface SupplyMultiFactorCodeGenerationInput {
  /** Country code for the phone number */
  countryCode: Scalars['String'];
  /** Phone number of the user */
  phoneNumber: Scalars['String'];
  /** MFA Verification type */
  verifyMethod: MfaVerificationMethod;
  /** Optional challenge ticket in case use tries to request for a new code via `send me a new code` operation */
  challengeTicket?: Maybe<Scalars['String']>;
}

/** Input for verifying mfa code */
export interface SupplyMultiFactorCodeVerificationInput {
  /** 6 digit Code sent to user */
  code: Scalars['String'];
  /** Challenge ticket associated with the mfa flow */
  challengeTicket: Scalars['String'];
  /** MFA verification method */
  verifyMethod: MfaVerificationMethod;
  /** Country code for the phone number */
  countryCode: Scalars['String'];
  /** Phone number of the user */
  phoneNumber: Scalars['String'];
}










export interface SupplyNavigationContext {
  showSidebarTrigger: Scalars['Boolean'];
  fallbackUrls?: Maybe<SupplyNavigationContextFallbackUrls>;
}

export interface SupplyNavigationContextFallbackUrls {
  signInUrl?: Maybe<Scalars['String']>;
  helpAndSupportUrl?: Maybe<Scalars['String']>;
  termsOfUseUrl?: Maybe<Scalars['String']>;
}







export enum SupplyNavigationHeaderMenuType {
  PROPERTY_DETAILS = 'PROPERTY_DETAILS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  PROPERTY_FILTER = 'PROPERTY_FILTER',
  SEARCH = 'SEARCH'
}



































export interface SupplyNewListingOfferEnrollmentInput {
  enrolled: Scalars['Boolean'];
}









export enum SupplyOnboardingAvailabilityType {
  OPEN = 'OPEN',
  BLOCK = 'BLOCK'
}





export enum SupplyOnboardingButtonType {
  BACK = 'BACK',
  SKIP = 'SKIP',
  NEXT = 'NEXT',
  LINK = 'LINK',
  DONE = 'DONE'
}










/** Input for Billing Address */
export interface SupplyOnboardingPartnerBillingAddressInput {
  /** Flag for removing or adding address */
  isAddingAddress: Scalars['Boolean'];
  streetAddress: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  stateProvince: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
}


export interface SupplyOnboardingPartnerBusinessNameInput {
  businessName: Scalars['String'];
}





export interface SupplyOnboardingPartnerLegalNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}




















export enum SupplyOnboardingTipCardId {
  AMENITIES = 'AMENITIES',
  REGULATORY = 'REGULATORY',
  PHOTOS = 'PHOTOS'
}




















export enum SupplyPartnerLifeCycleStage {
  LIFE_CYCLE_STAGE_BABY = 'LIFE_CYCLE_STAGE_BABY',
  LIFE_CYCLE_STAGE_KID = 'LIFE_CYCLE_STAGE_KID',
  LIFE_CYCLE_STAGE_TEENAGER = 'LIFE_CYCLE_STAGE_TEENAGER',
  LIFE_CYCLE_STAGE_YOUNG_ADULT = 'LIFE_CYCLE_STAGE_YOUNG_ADULT',
  LIFE_CYCLE_STAGE_ALL_GROWN_UP = 'LIFE_CYCLE_STAGE_ALL_GROWN_UP',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export interface SupplyPartnerPayoutDeferredAccountInput {
  currency: Scalars['String'];
  bankingCountry: Scalars['String'];
}






export enum SupplyPaymentDetailsExpandoPositioning {
  TRAILING = 'TRAILING',
  LEADING = 'LEADING'
}









export enum SupplyPaymentDisplayToolbarIcon {
  CLOSE = 'CLOSE',
  BACK = 'BACK'
}


























export interface SupplyPromotionCreateMembersOnlyDealsTiersInput {
  name: Scalars['String'];
  memberTiersDiscounts: SupplyPromotionMemberTiersDiscountsInput;
  canStackToOtherPromotions?: Maybe<Scalars['Boolean']>;
  promotionRunDates?: Maybe<SupplyPromotionDateRangeInput>;
  blockoutDates?: Maybe<Array<SupplyPromotionDateRangeInput>>;
  ratePlanIds?: Maybe<Array<Scalars['String']>>;
  bookingDates?: Maybe<SupplyPromotionDateRangeInput>;
  stayDates?: Maybe<SupplyPromotionDateRangeInput>;
}



export enum SupplyPromotionDatePickerMode {
  SINGLE_DATE = 'SINGLE_DATE',
  DATE_RANGE = 'DATE_RANGE'
}


export interface SupplyPromotionDateRangeInput {
  startDate: DateInput;
  endDate?: Maybe<DateInput>;
}









export interface SupplyPromotionMemberTiersDiscountsInput {
  baseMemberDiscount: Scalars['Int'];
  middleMemberDiscount?: Maybe<Scalars['Int']>;
  topMemberDiscount?: Maybe<Scalars['Int']>;
}







export enum SupplyPromotionNotificationType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}




export enum SupplyPromotionReservationMode {
  ADVANCED = 'ADVANCED',
  STANDARD = 'STANDARD'
}

export enum SupplyPromotionResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}









export interface SupplyPromotionUpdateMembersOnlyDealsTiersInput {
  name: Scalars['String'];
  memberTiersDiscounts: SupplyPromotionMemberTiersDiscountsInput;
  canStackToOtherPromotions?: Maybe<Scalars['Boolean']>;
  ratePlanIds?: Maybe<Array<Scalars['String']>>;
  promotionRunDates?: Maybe<SupplyPromotionDateRangeInput>;
  blockoutDates?: Maybe<Array<SupplyPromotionDateRangeInput>>;
  bookingDates?: Maybe<SupplyPromotionDateRangeInput>;
  stayDates?: Maybe<SupplyPromotionDateRangeInput>;
}









export interface SupplyPropertyRateInput {
  currencyCode: Scalars['String'];
  language: Scalars['String'];
  baseRate: Scalars['Float'];
}














/** Allowed operations on subscribe event */
export enum SupplyQuickActionElementVisibility {
  HIDE_SELF = 'HIDE_SELF',
  SHOW_SELF = 'SHOW_SELF'
}




/** Allowed operations on subscribe event */
export enum SupplyQuickActionFieldProcessorOperation {
  PLAIN_REPLACE = 'PLAIN_REPLACE',
  PERCENT_CALC_AND_REPLACE = 'PERCENT_CALC_AND_REPLACE',
  SUBTRACT_AND_REPLACE = 'SUBTRACT_AND_REPLACE'
}


export enum SupplyQuickActionFieldSetDirection {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL'
}




export interface SupplyQuickActionFormContextInput {
  key: Scalars['String'];
  values: Array<Scalars['String']>;
}












/**
 * SupplyQuickActionSpacingSize
 * Note: only 0X_HALF, 1X, 2X, 3X, 4X, 6X, 12X, 16X are supported for desktop.
 * Using other sizes may render differently different on mobile and desktop
 */
export enum SupplyQuickActionSpacingSize {
  SPACING__0X__HALF = 'SPACING__0X__HALF',
  SPACING__10X = 'SPACING__10X',
  SPACING__11X = 'SPACING__11X',
  SPACING__12X = 'SPACING__12X',
  SPACING__14X = 'SPACING__14X',
  SPACING__16X = 'SPACING__16X',
  SPACING__1X = 'SPACING__1X',
  SPACING__2X = 'SPACING__2X',
  SPACING__3X = 'SPACING__3X',
  SPACING__4X = 'SPACING__4X',
  SPACING__5X = 'SPACING__5X',
  SPACING__6X = 'SPACING__6X',
  SPACING__8X = 'SPACING__8X'
}
















export enum SupplyQuickActionTableItemCellType {
  NORMAL = 'NORMAL',
  STRIKETHROUGH = 'STRIKETHROUGH'
}


















export interface SupplyRegulatoryFlowThirdPartyValidationInput {
  /** The Third party validation rule */
  rule: Scalars['String'];
  /** The field to validate */
  field: Scalars['String'];
  /** The field value to validate */
  value: Scalars['String'];
  /** other possible parameters for the Third party validation */
  options: Array<SupplyRegulatoryFlowThirdPartyValidationOption>;
}

export interface SupplyRegulatoryFlowThirdPartyValidationOption {
  name: Scalars['String'];
  value: Scalars['String'];
}











export interface SupplyRegulatorySettingInput {
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}

export enum SupplyRegulatoryStatus {
  COMPLIANT = 'COMPLIANT',
  NOT_COMPLIANT = 'NOT_COMPLIANT',
  NONE = 'NONE'
}

export interface SupplyReservationsAccessIdentifierInput {
  id: Scalars['String'];
  idType: Scalars['String'];
}


export interface SupplyReservationsAccessInstructionPhotoInput {
  imageId: Scalars['UUID'];
  photoUrl: Scalars['String'];
  title?: Maybe<Scalars['String']>;
}


export interface SupplyReservationsAccessInstructionsInput {
  accessType: SupplyReservationsAccessTypes;
  accessCode?: Maybe<Scalars['String']>;
  instructions: Scalars['String'];
  gallery?: Maybe<Array<Maybe<SupplyReservationsAccessInstructionPhotoInput>>>;
}


export enum SupplyReservationsAccessTypes {
  SMART_LOCK = 'SMART_LOCK',
  LOCKBOX = 'LOCKBOX',
  KEYPAD = 'KEYPAD',
  PICKUP = 'PICKUP',
  DOORMAN = 'DOORMAN',
  OTHER = 'OTHER'
}


export enum SupplyReservationsActionType {
  ACCESS_INSTRUCTIONS_ADD = 'ACCESS_INSTRUCTIONS_ADD',
  ACCESS_INSTRUCTIONS_EDIT = 'ACCESS_INSTRUCTIONS_EDIT',
  HEADER_MARK_AS_UNREAD = 'HEADER_MARK_AS_UNREAD',
  HEADER_MARK_AS_SPAM = 'HEADER_MARK_AS_SPAM',
  HEADER_ARCHIVE = 'HEADER_ARCHIVE',
  HEADER_PRINT = 'HEADER_PRINT',
  HEADER_SHARE = 'HEADER_SHARE',
  HEADER_FEEDBACK = 'HEADER_FEEDBACK',
  HEADER_HELP_CENTER = 'HEADER_HELP_CENTER',
  DAMAGE_PROTECTION_REPORT_DAMAGE = 'DAMAGE_PROTECTION_REPORT_DAMAGE',
  DAMAGE_PROTECTION_REFUND_DEPOSIT = 'DAMAGE_PROTECTION_REFUND_DEPOSIT',
  DAMAGE_PROTECTION_SEE_POLICY = 'DAMAGE_PROTECTION_SEE_POLICY',
  DAMAGE_PROTECTION_SEE_DAMAGE_REPORT = 'DAMAGE_PROTECTION_SEE_DAMAGE_REPORT',
  DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL = 'DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL',
  PAYMENT_SCHEDULE_MARK_PAID = 'PAYMENT_SCHEDULE_MARK_PAID',
  PAYMENT_SCHEDULE_RESEND_REQUEST = 'PAYMENT_SCHEDULE_RESEND_REQUEST',
  PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST = 'PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST',
  PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE = 'PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE',
  PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE = 'PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE',
  PAYMENT_SCHEDULE_SEND_A_REFUND = 'PAYMENT_SCHEDULE_SEND_A_REFUND',
  GUEST_INFO_EMAIL = 'GUEST_INFO_EMAIL',
  GUEST_INFO_PHONE = 'GUEST_INFO_PHONE',
  GUEST_INFO_VIEW_PROFILE = 'GUEST_INFO_VIEW_PROFILE',
  RENTAL_AGREEMENT_VIEW = 'RENTAL_AGREEMENT_VIEW',
  PAYMENT_SUMMARY_VIEW = 'PAYMENT_SUMMARY_VIEW',
  NOTES_EDIT = 'NOTES_EDIT',
  NOTES_ADD = 'NOTES_ADD',
  NOTES_CANCEL = 'NOTES_CANCEL',
  NOTES_SAVE = 'NOTES_SAVE',
  STAY_DETAILS_CHANGE_DATES = 'STAY_DETAILS_CHANGE_DATES',
  STAY_DETAILS_CHANGE_TIME = 'STAY_DETAILS_CHANGE_TIME',
  STAY_DETAILS_ADD_REMOVE_GUESTS = 'STAY_DETAILS_ADD_REMOVE_GUESTS',
  STAY_DETAILS_CANCEL_RESERVATION = 'STAY_DETAILS_CANCEL_RESERVATION',
  STAY_DETAILS_CONFIRM_CANCELLATION = 'STAY_DETAILS_CONFIRM_CANCELLATION'
}










export enum SupplyReservationsDetailsActionType {
  CHANGE_DATES = 'CHANGE_DATES',
  CHANGE_TIME = 'CHANGE_TIME',
  ADD_REMOVE_GUESTS = 'ADD_REMOVE_GUESTS',
  CANCEL_RESERVATION = 'CANCEL_RESERVATION'
}




























export enum SupplyReservationsInteractionListActionDialogFooterActionType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}




export enum SupplyReservationsInteractionListColumnHorizontalAlign {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  CENTER = 'CENTER',
  JUSTIFY = 'JUSTIFY',
  JUSTIFY_ALL = 'JUSTIFY_ALL',
  START = 'START',
  END = 'END',
  MATCH_PARENT = 'MATCH_PARENT'
}

export enum SupplyReservationsInteractionListColumnVerticalAlign {
  BASELINE = 'BASELINE',
  SUB = 'SUB',
  SUPER = 'SUPER',
  TEXT_TOP = 'TEXT_TOP',
  TEXT_BOTTOM = 'TEXT_BOTTOM',
  MIDDLE = 'MIDDLE',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM'
}

export enum SupplyReservationsInteractionListItemAction {
  UNREAD = 'UNREAD',
  READ = 'READ',
  SPAM = 'SPAM',
  ARCHIVE = 'ARCHIVE',
  UNARCHIVE = 'UNARCHIVE'
}









export enum SupplyReservationsInteractionListSwipeActionEdge {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}




export enum SupplyReservationsInteractionMessageMode {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING'
}




















export interface SupplyReservationsInteractionsClientDataInput {
  timezone: Scalars['String'];
}




export interface SupplyReservationsInteractionsFilterInput {
  /**
   * List of selected filters
   * Should be the value of "options.name"
   * Examples:
   *     "message.unread"
   *     "guest.requests.inquiry"
   */
  filters?: Maybe<Array<Scalars['String']>>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
}









export interface SupplyReservationsInteractionsPageInput {
  pageNumber?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
}








export enum SupplyReservationsInteractionsSort {
  GUEST_ASC = 'GUEST_ASC',
  GUEST_DESC = 'GUEST_DESC',
  CHECKIN_DATE_ASC = 'CHECKIN_DATE_ASC',
  CHECKIN_DATE_DESC = 'CHECKIN_DATE_DESC',
  RECEIVED_ON_ASC = 'RECEIVED_ON_ASC',
  RECEIVED_ON_DESC = 'RECEIVED_ON_DESC'
}














export enum SupplyReservationsPaymentDetailsExpandoPositioning {
  TRAILING = 'TRAILING',
  LEADING = 'LEADING'
}









export enum SupplyReservationsPaymentDisplayToolbarIcon {
  CLOSE = 'CLOSE',
  BACK = 'BACK'
}







export enum SupplyReservationsRenderHint {
  COLLAPSED = 'COLLAPSED',
  LIST = 'LIST'
}
























































export enum SupplyScoreFactorBmlAuditItemObervationType {
  RATE = 'RATE',
  AVAILABILITY = 'AVAILABILITY'
}





export enum SupplyScoreFactorNotificationType {
  DOING_GREAT = 'DOING_GREAT',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION'
}





















/** Description of a SupplyScoreMessaging's card */
export enum SupplyScoreMessagingTheme {
  MESSAGE = 'MESSAGE',
  INFO = 'INFO',
  WARNING = 'WARNING'
}













export interface SupplyTaxesAmountInput {
  amount: Scalars['Float'];
  age: Scalars['Int'];
}


export interface SupplyTaxesInput {
  type: SupplyTaxesType;
  taxesPercent?: Maybe<SupplyTaxesPercentInput>;
  taxesAmount?: Maybe<SupplyTaxesAmountInput>;
}







export interface SupplyTaxesPercentInput {
  percent: Scalars['Float'];
}

export enum SupplyTaxesType {
  AMOUNT = 'AMOUNT',
  PERCENT = 'PERCENT',
  NOT_INCLUDED = 'NOT_INCLUDED'
}





























/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = 'LTR',
  RTL = 'RTL'
}

/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  INVERSE = 'INVERSE',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = 'BOLD',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR'
}



export enum Theme {
  BRAND = 'BRAND',
  BRANDED_DEAL = 'BRANDED_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO = 'INFO',
  LINK = 'LINK',
  LOYALTY = 'LOYALTY',
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  NOTIFICATION = 'NOTIFICATION',
  PROMOTED = 'PROMOTED',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  URGENT = 'URGENT',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
  VIP_ACCESS = 'VIP_ACCESS'
}





export interface TopTaskCardAction {
  cardAction: CardActions;
  topTaskType: TopTaskTypes;
  taskId: Scalars['String'];
}

export enum TopTaskTypes {
  BOOKING_REQUEST = 'BOOKING_REQUEST',
  INQUIRY = 'INQUIRY',
  CURRENT_STAY = 'CURRENT_STAY',
  ARRIVING = 'ARRIVING',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  RATE_TRAVELER = 'RATE_TRAVELER',
  CANCELLATION = 'CANCELLATION'
}














/** Optional inputs for custom flex content */
export interface TravelContentAttributesInput {
  /** content Id */
  contentId: Scalars['String'];
  /** preview */
  preview: Scalars['Boolean'];
}










/** URI context to get flex content. */
export interface TravelContentUriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes: UriContextAttributesInput;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers: UriContextIdentifiersInput;
}





export interface TravelGuidePageContextInput {
  pageType: PageType;
  placeId?: Maybe<Scalars['String']>;
}

export interface TravelMemberGroupInput {
  adults: Scalars['Int'];
  childrenAges?: Maybe<Array<Scalars['Int']>>;
}


export interface TravelStoreV1CarDetailsInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
}

export interface TravelStoreV1CarSearchInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  defaultSortOption: Scalars['String'];
  filterOptions: Array<Scalars['String']>;
  messagingOptions: Array<Scalars['String']>;
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
  sortOptions: Array<Scalars['String']>;
}












/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: Maybe<Scalars['Int']>;
  type: TravelerDetailsType;
}

/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}


/** Package traveler occupancy group */
export interface TravelerOccupancyGroupInput {
  travelers: Array<TravelerDetailsInput>;
}


export enum TravelerType {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY',
  LGBT = 'LGBT',
  ROMANTIC = 'ROMANTIC'
}

/** Represents per traveller ancillary selection */
export interface TravellerAncillarySelectionInput {
  /** Represents the list of encoded AncillaryToken for each selection made */
  ancillaryTokens: Array<Scalars['String']>;
  /** Represents the traveler index for which the selection is applicable */
  travelerIndex: Scalars['Int'];
}





export enum TripCareButtonAction {
  BACK = 'BACK',
  CANCEL_POLICY = 'CANCEL_POLICY',
  DISMISS_POPUP = 'DISMISS_POPUP',
  POPUP = 'POPUP',
  RELOAD = 'RELOAD'
}

export enum TripCareButtonState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}














export enum TripCareLayoutStyle {
  CARD_BORDER_TOP = 'CARD_BORDER_TOP'
}



export enum TripCareListType {
  BULLET = 'BULLET',
  NO_BULLET = 'NO_BULLET',
  NUMBERED = 'NUMBERED'
}




export enum TripCarePhraseStyle {
  BOLD = 'BOLD',
  HR_DIVIDER_BOTTOM = 'HR_DIVIDER_BOTTOM',
  HR_DIVIDER_TOP = 'HR_DIVIDER_TOP',
  SIZE_100 = 'SIZE_100',
  SIZE_200 = 'SIZE_200',
  SIZE_300 = 'SIZE_300',
  SIZE_400 = 'SIZE_400',
  SIZE_500 = 'SIZE_500',
  SIZE_600 = 'SIZE_600',
  SIZE_700 = 'SIZE_700',
  SIZE_800 = 'SIZE_800',
  SIZE_900 = 'SIZE_900',
  SMALL = 'SMALL',
  SPACING_FOUR = 'SPACING_FOUR',
  SPACING_HALF = 'SPACING_HALF',
  SPACING_ONE = 'SPACING_ONE',
  SPACING_SIX = 'SPACING_SIX',
  SPACING_THREE = 'SPACING_THREE',
  SPACING_TWO = 'SPACING_TWO',
  THEME_EMPHASIS = 'THEME_EMPHASIS',
  THEME_NEGATIVE = 'THEME_NEGATIVE',
  THEME_POSITIVE = 'THEME_POSITIVE',
  WEIGHT_BOLD = 'WEIGHT_BOLD',
  WEIGHT_MEDIUM = 'WEIGHT_MEDIUM',
  WEIGHT_REGULAR = 'WEIGHT_REGULAR'
}

export enum TripCarePhraseType {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
  TEXT = 'TEXT'
}








export enum TripCreationEntryPoint {
  HOTEL_SEARCH_RESULTS = 'HOTEL_SEARCH_RESULTS',
  TRIPS_LIST = 'TRIPS_LIST',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW'
}


/** Metadata which can be provided when creating a new trip. */
export interface TripCreationMetadataInput {
  entryPoint?: Maybe<TripCreationEntryPoint>;
  itemId?: Maybe<Scalars['String']>;
  /** An input provided when creating a new trip as part of moving an item to a trip */
  moveItemInput?: Maybe<TripItemInput>;
  /** Trip planning inputs provided when creating a new trip as part of saving an item to a trip */
  saveItemInput?: Maybe<TripsPlanInput>;
}

export interface TripDetailsSupportRequestsInput {
  buttonStyle: EgdsButtonStyle;
  itineraryNumber: Scalars['String'];
  lineOfBusiness: Scalars['String'];
  orderLineId: Scalars['String'];
}

/** The TripEntity defines a list of supported items which can be can be saved to a trip. */
export enum TripEntity {
  ACTIVITY_PRODUCT = 'ACTIVITY_PRODUCT',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LODGING_PRODUCT = 'LODGING_PRODUCT'
}





export enum TripIntentPersonType {
  ADULT = 'ADULT',
  CHILD = 'CHILD'
}






/**
 * The `TripInviteInput` complex type contains a `inviteId` known by the Trip Domain.
 * The inviteId is invitation identifier to be opened from trips overview screen or redirected to by invite deep link.
 * The server will construct all the necessary information based on invite that has back reference to trip with all needed information to populate view
 * It also provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripInviteInput {
  inviteId: Scalars['String'];
}




/**
 * "The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain, plus an optional filter known to the Trips Graph.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Item Details view for functions such as back navigation.
 */
export interface TripItemInput {
  filter?: Maybe<Scalars['String']>;
  tripEntity?: Maybe<TripEntity>;
  tripItemId: Scalars['String'];
  tripViewId: Scalars['String'];
}




/**
 * The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain and an optional `filter` known by the Trips Graph Service.
 * The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.
 * The server will determine how much of the trip and which actions to return based on the sharing rules associated with the TripViewId.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripOverviewInput {
  filter?: Maybe<Scalars['String']>;
  inviteId?: Maybe<Scalars['String']>;
  segments?: Maybe<Array<Scalars['String']>>;
  tripViewId: Scalars['String'];
}



export enum TripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE'
}














/** Represents different avatar sizes. */
export enum TripsAvatarSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}


/** Supported Trips badge themes */
export enum TripsBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  SAVED = 'SAVED',
  STATUS_NEGATIVE = 'STATUS_NEGATIVE',
  STATUS_POSITIVE = 'STATUS_POSITIVE',
  UTILITY_STANDARD = 'UTILITY_STANDARD',
  VIP = 'VIP'
}





export enum TripsButtonWidth {
  MATCH_PARENT_CONTAINER = 'MATCH_PARENT_CONTAINER',
  WRAP_CONTENT = 'WRAP_CONTENT'
}

export enum TripsCalendarSelectionType {
  SINGLE = 'SINGLE',
  START_AND_END = 'START_AND_END',
  START_AND_END_WITH_SAME_DATE = 'START_AND_END_WITH_SAME_DATE'
}








/** Contains attributes for trip cancellation */
export interface TripsCancellationAttributesInput {
  orderLineNumbers?: Maybe<Array<Scalars['String']>>;
  orderNumber?: Maybe<Scalars['String']>;
  /** Formatted string. This is optional attribute. In case of partial refund, we are passing this value to the backend. */
  penaltyAmount?: Maybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed refund amount to user. If this value set then compare between displayed amount and actual amount from backend. */
  refundAmount?: Maybe<Scalars['String']>;
}

export enum TripsCancellationType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  HOTEL = 'HOTEL',
  INSURANCE = 'INSURANCE'
}


/** Represents a TripsCard's selection/active state */
export enum TripsCardState {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}










/** Type of the drawer/sheet we want the client to render. CENTER is for desktop where we want to show the drawer as a center sheet/dialogBOTTOM is for app and mweb where the drawer comes from the bottom of the screenSIDE is for desktop where the sheet comes from the right of the screen. eg. plan, moveFULL is equivalent to sidesheet on mweb where the sheet will cover the whole page */
export enum TripsComposableDrawerType {
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
  FULL = 'FULL',
  SIDE = 'SIDE'
}













/** Display theme for trips content */
export enum TripsContentTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS',
  /** The ordered list should always be displayed with numbers */
  ORDERED = 'ORDERED',
  /** Paragraph type list */
  PARAGRAPH = 'PARAGRAPH'
}

export enum TripsContentType {
  PDF = 'PDF'
}


export enum TripsContentUnorderedListTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS'
}












export enum TripsCustomerNotificationTripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE'
}





/** Represents layout of buttons on a modal dialog */
export enum TripsDialogButtonLayout {
  /** Dialog with horizontally stacked buttons */
  INLINE = 'INLINE',
  /** Dialog with vertically stacked buttons */
  STACKED = 'STACKED'
}



export enum TripsDisplayMode {
  DEFAULT = 'DEFAULT',
  MODAL = 'MODAL'
}











/**
 * The `TripsFilterInput` contains a filter identifier.
 * The set of supported filter identifiers is defined by the Trips Graph Service and may represent a simple filter like Upcoming or Past or an arbitrarily complex filter defined by an ML algorithm.
 * See the Trips Graph team for a list of reserved values.
 */
export interface TripsFilterInput {
  filter: Scalars['String'];
}

export enum TripsFindItineraryNumberView {
  FIND_ITINERARY_OTHER_EMAIL = 'FIND_ITINERARY_OTHER_EMAIL',
  FIND_ITINERARY_USER_EMAIL = 'FIND_ITINERARY_USER_EMAIL',
  RESULT = 'RESULT'
}


/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export enum TripsFittedImageType {
  BARCODE = 'BARCODE',
  E_FRANKING_STAMP = 'E_FRANKING_STAMP',
  QR_CODE = 'QR_CODE'
}













/** This enum is to indicate whether the form container should have padding or it should fit right inside the parent component */
export enum TripsFormContainerTheme {
  MATCH_PARENT = 'MATCH_PARENT',
  WRAP_CONTENT = 'WRAP_CONTENT'
}




export enum TripsFormType {
  CREATE_NEW_TRIP_FROM_ITEM = 'CREATE_NEW_TRIP_FROM_ITEM',
  FIND_ITINERARY_NUMBER = 'FIND_ITINERARY_NUMBER',
  INVITE = 'INVITE',
  SAVE_NEW_TRIP = 'SAVE_NEW_TRIP',
  SEARCH_BOOKING = 'SEARCH_BOOKING',
  SEND_ITINERARY_EMAIL = 'SEND_ITINERARY_EMAIL',
  UPDATE_TRIP = 'UPDATE_TRIP'
}













/** Enum to represent the number of lines that the text field supports. Defaulted to one line (single) if no changes are made. */
export enum TripsInputType {
  MULTIPLE = 'MULTIPLE',
  SINGLE = 'SINGLE'
}







export interface TripsItemsGroupFilterInput {
  type: Scalars['String'];
  value: Scalars['String'];
}

/** Contains filters and sort fields to control how the items appear in groups. */
export interface TripsItemsGroupInput {
  filters: Array<TripsItemsGroupFilterInput>;
  sort?: Maybe<Scalars['String']>;
}



export enum TripsLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}












/** The type of map marker */
export enum TripsMarkerType {
  ACTIVITYEVENTMARKER = 'ActivityEventMarker',
  ACTIVITYGUESTPICKUPMARKER = 'ActivityGuestPickupMarker',
  ACTIVITYLOCATIONMARKER = 'ActivityLocationMarker',
  ACTIVITYREDEMPTIONMARKER = 'ActivityRedemptionMarker',
  AIRPORTMARKER = 'AirportMarker',
  CARMARKER = 'CarMarker',
  CRUISEMARKER = 'CruiseMarker',
  HOTELMARKER = 'HotelMarker',
  PLACEMARKER = 'PlaceMarker'
}
































export interface TripsNotAuthorizedInput {
  filter?: Maybe<Scalars['String']>;
  inviteId?: Maybe<Scalars['String']>;
  screen?: Maybe<TripsScreen>;
  tripItemId?: Maybe<Scalars['String']>;
  tripViewId?: Maybe<Scalars['String']>;
}


















/** Input to the trips.plan query. */
export interface TripsPlanInput {
  /** Provides LOB specific search context */
  attributes?: Maybe<TripsSaveItemAttributesInput>;
  /** The id of the item being saved, e.g property id */
  itemId: Scalars['String'];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: Maybe<PageLocation>;
  source?: Maybe<TripsPlanSourceType>;
  /** Attributes needed to create or update trip items subscription data */
  subscriptionAttributes?: Maybe<TripsSubscriptionAttributesInput>;
}

/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export enum TripsPlanSourceType {
  ACTIVITY_DETAILS = 'ACTIVITY_DETAILS',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  HOTEL_SEARCH = 'HOTEL_SEARCH',
  LODGING_DETAILS = 'LODGING_DETAILS',
  LODGING_SEARCH = 'LODGING_SEARCH',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW'
}









/** Input to the trips.screenshot query. */
export interface TripsProductSearchCriteriaInput {
  flightSearchCriteria?: Maybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: Maybe<PropertySearchCriteriaInput>;
}





export enum TripsResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}



/** Save activity input details */
export interface TripsSaveActivityAttributesInput {
  /** Date range representing activity search, if absent the default [today, today+14d] is used */
  dateRange?: Maybe<DateRangeInput>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
}




/** Type grouping all the optional additional information that's required when saving an item. */
export interface TripsSaveItemAttributesInput {
  /** Activity input details */
  activityAttributes?: Maybe<TripsSaveActivityAttributesInput>;
  /** Flight input details */
  flightAttributes?: Maybe<FlightSearchCriteriaInput>;
  /** Stay input details */
  stayAttributes?: Maybe<TripsSaveStayAttributesInput>;
}


export interface TripsSaveItemInput {
  anchorPrice?: Maybe<Scalars['String']>;
  productSearchCriteria: TripsProductSearchCriteriaInput;
}






/** Save stay input details */
export interface TripsSaveStayAttributesInput {
  /** The check-in date for the property */
  checkInDate?: Maybe<DateInput>;
  /** The check-out date for the property */
  checkoutDate?: Maybe<DateInput>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** Provides Stay traveler information */
  roomConfiguration?: Maybe<Array<PropertyRoomInput>>;
}

/** Stay input details */
export interface TripsSaveStayInput {
  checkInDate?: Maybe<DateTimeInput>;
  checkoutDate?: Maybe<DateTimeInput>;
  propertyId: Scalars['String'];
  regionId?: Maybe<Scalars['String']>;
  roomConfiguration?: Maybe<Array<TripsStayRoomTravelerInfoInput>>;
  sourceType?: Maybe<TripsPlanSourceType>;
}



export enum TripsScreen {
  INVITE_LANDING_PAGE = 'INVITE_LANDING_PAGE',
  TRIP_ITEM_ITINERARY = 'TRIP_ITEM_ITINERARY',
  TRIP_ITEM_MANAGE_BOOKING = 'TRIP_ITEM_MANAGE_BOOKING',
  TRIP_ITEM_PRICING_REWARDS = 'TRIP_ITEM_PRICING_REWARDS',
  TRIP_ITEM_RECEIPT = 'TRIP_ITEM_RECEIPT',
  TRIP_MANAGE_GUESTS = 'TRIP_MANAGE_GUESTS',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
  TRIP_OVERVIEW_ITINERARY = 'TRIP_OVERVIEW_ITINERARY'
}

/** Input to the trips.screenshot query. */
export interface TripsScreenshotInput {
  /** The id of the item being saved, e.g property id */
  itemId: Scalars['String'];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: Maybe<PageLocation>;
  /** Provides LOB specific search context */
  saveItemAttributes: TripsSaveItemAttributesInput;
}

export enum TripsSearchBookingView {
  SEARCH_BY_ITINERARY_NUMBER = 'SEARCH_BY_ITINERARY_NUMBER',
  SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL = 'SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL',
  SEARCH_RESULT = 'SEARCH_RESULT'
}












/** This enum represents the different fields that a TripsSignalPair relates to. */
export enum TripsSignalPairKey {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  STATUS = 'STATUS'
}


/** This enum represents the different category types of signals registered within the platform. */
export enum TripsSignalType {
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}





/** Stay room traveler information */
export interface TripsStayRoomTravelerInfoInput {
  childrenAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
}


/** Attributes needed to create or update trip items subscription data */
export interface TripsSubscriptionAttributesInput {
  anchorPrice?: Maybe<Scalars['String']>;
  subscriptionInputs?: Maybe<Array<GraphQlPairInput>>;
}




/** Represents a toggle's state. */
export enum TripsToggleStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}























export enum TripsViewType {
  ACTIVITIES_SEARCH_RESULTS = 'ACTIVITIES_SEARCH_RESULTS',
  CAMPAIGNS = 'CAMPAIGNS',
  CARS_SEARCH_RESULTS = 'CARS_SEARCH_RESULTS',
  FILTERED = 'FILTERED',
  FIND_ITINERARY_BY_OTHER_EMAIL = 'FIND_ITINERARY_BY_OTHER_EMAIL',
  FIND_ITINERARY_BY_USER_EMAIL = 'FIND_ITINERARY_BY_USER_EMAIL',
  FLIGHTS_SEARCH_RESULTS = 'FLIGHTS_SEARCH_RESULTS',
  ITEM_DETAILS = 'ITEM_DETAILS',
  ITEM_ESSENTIAL_INFO = 'ITEM_ESSENTIAL_INFO',
  ITEM_PRICING_AND_REWARDS = 'ITEM_PRICING_AND_REWARDS',
  ITEM_VOUCHER = 'ITEM_VOUCHER',
  LOB_SELECTION_VIEW = 'LOB_SELECTION_VIEW',
  LODGING_SEARCH_RESULTS = 'LODGING_SEARCH_RESULTS',
  MANAGE_BOOKING = 'MANAGE_BOOKING',
  MANAGE_GUESTS = 'MANAGE_GUESTS',
  OVERVIEW = 'OVERVIEW',
  PACKAGES_FC_SEARCH_RESULTS = 'PACKAGES_FC_SEARCH_RESULTS',
  PACKAGES_FHC_SEARCH_RESULTS = 'PACKAGES_FHC_SEARCH_RESULTS',
  PACKAGES_HC_SEARCH_RESULTS = 'PACKAGES_HC_SEARCH_RESULTS',
  PACKAGES_HF_SEARCH_RESULTS = 'PACKAGES_HF_SEARCH_RESULTS',
  PENDING_INVITE = 'PENDING_INVITE',
  SEARCH_BY_ITINERARY_NUMBER = 'SEARCH_BY_ITINERARY_NUMBER',
  SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL = 'SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL',
  TRIPS_LIST = 'TRIPS_LIST'
}











/** Represents a typing indicator event's content */
export interface TypingIndicatorEventContentInput {
  /** Represents if the user is typing or not - isTyping: true equals start: true */
  isTyping?: Maybe<Scalars['Boolean']>;
}











/** Specifies whether to open the link in the same user interface context or in a different context */
export enum UiLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}









export enum UiSignal {
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
  GENERIC_DOWNSTREAM_ERROR = 'GENERIC_DOWNSTREAM_ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  UNKNOWN = 'UNKNOWN',
  UNRECOVERABLE_FAILURE = 'UNRECOVERABLE_FAILURE'
}













/** Type to select a category of action for an UnescoPledge */
export enum UnescoPledgeCategory {
  /** Category to support local communities */
  COMMUNITY_ENGAGEMENT = 'COMMUNITY_ENGAGEMENT',
  /** Category to save energy consumption */
  CONSERVE_ENERGY = 'CONSERVE_ENERGY',
  /** Category to save water consumption */
  CONSERVE_WATER = 'CONSERVE_WATER',
  /** Category to add additional information about sustainability */
  OTHER = 'OTHER',
  /** Category to reduce plastic usage */
  REDUCE_PLASTIC = 'REDUCE_PLASTIC',
  /** Category to reduce waste */
  REDUCE_WASTE = 'REDUCE_WASTE'
}

/** Type to specify a filter related UnescoPledges */
export interface UnescoPledgeFilterInput {
  /** Categories to filter */
  category?: Maybe<Array<Maybe<UnescoPledgeCategory>>>;
  /** Number of UnescoPledge to visualize */
  pledgesNumber?: Maybe<Scalars['Int']>;
  /** Number of the starting index of UnescoPledge list */
  startingIndex?: Maybe<Scalars['Int']>;
}






export enum UniversalProfileAccountManagementOptionType {
  TRAVELER_ARRANGER = 'TRAVELER_ARRANGER'
}







export interface UniversalProfileAccountTakeOverWidgetRequestInput {
  content?: Maybe<Scalars['String']>;
  type: UniversalProfileAccountTakeOverWidgetTypeRequest;
}

export enum UniversalProfileAccountTakeOverWidgetTypeRequest {
  CAPTCHA = 'CAPTCHA',
  CSRF = 'CSRF'
}








export interface UniversalProfileAddressInput {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
}



export enum UniversalProfileAnalyticEventInputSubtype {
  BLURRED = 'BLURRED',
  FOCUSED = 'FOCUSED',
  INPUTED = 'INPUTED',
  SUCCEEDED = 'SUCCEEDED'
}




export interface UniversalProfileBasicInformationDateOfBirthInput {
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
}



export interface UniversalProfileBasicInformationNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
}

export interface UniversalProfileBasicInformationRequestInput {
  accessibilityNeeds?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  dateOfBirth: UniversalProfileBasicInformationDateOfBirthInput;
  gender?: Maybe<Scalars['String']>;
  name: UniversalProfileBasicInformationNameInput;
}








export enum UniversalProfileCategorySwitchOperator {
  OFF = 'OFF',
  ON = 'ON'
}

export interface UniversalProfileChangeEmailRequestInput {
  email: Scalars['String'];
}



/** EG Universal profile input for accessing client type */
export interface UniversalProfileClientInfoInput {
  channelType: UniversalProfileClientType;
}

export enum UniversalProfileClientType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB'
}


export interface UniversalProfileCommunicationPreferenceEmailRequestInput {
  categoryConsent: Array<UniversalProfileEmailCommunicationPreferenceUpdateInput>;
  unsubscribeFromAll: Scalars['Boolean'];
}

export interface UniversalProfileCommunicationPreferenceRequestInput {
  updates: Array<UniversalProfileCommunicationPreferenceUpdateInput>;
}

export interface UniversalProfileCommunicationPreferenceUnsubRequestInput {
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
}

export interface UniversalProfileCommunicationPreferenceUnsubscribeCategoriesRequestInput {
  categoryTypes: Array<UniversalProfileCommunicationPreferencesCategoryType>;
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  isStrict: Scalars['Boolean'];
}

export interface UniversalProfileCommunicationPreferenceUnsubscribePreferenceRequestInput {
  categoryType: UniversalProfileCommunicationPreferencesCategoryType;
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
}

export interface UniversalProfileCommunicationPreferenceUpdateInput {
  category: UniversalProfileCommunicationPreferencesCategoryType;
  selectedChannels?: Maybe<Array<CommunicationChannel>>;
}



export enum UniversalProfileCommunicationPreferencesCategoryType {
  ACCOUNT_SUPPORT = 'ACCOUNT_SUPPORT',
  CONFIRMATION_AND_CRITICAL_UPDATES = 'CONFIRMATION_AND_CRITICAL_UPDATES',
  OFFERS_AND_INSPIRATION = 'OFFERS_AND_INSPIRATION',
  ONE_KEY = 'ONE_KEY',
  ONE_KEY_MONTHLY_STATEMENTS = 'ONE_KEY_MONTHLY_STATEMENTS',
  ONE_KEY_REWARD_ACCOUNT_UPDATES = 'ONE_KEY_REWARD_ACCOUNT_UPDATES',
  PARTNERS_OFFERS_WITH_US = 'PARTNERS_OFFERS_WITH_US',
  PERSONALIZED_TRIP_RECOMMENDATIONS = 'PERSONALIZED_TRIP_RECOMMENDATIONS',
  REVIEWS = 'REVIEWS',
  SURVEYS = 'SURVEYS',
  THE_TRAVEL_EDIT = 'THE_TRAVEL_EDIT',
  TRIP_BOARD_ACTIVITY = 'TRIP_BOARD_ACTIVITY',
  TRIP_PLANNING_ASSISTANCE = 'TRIP_PLANNING_ASSISTANCE'
}




export enum UniversalProfileCommunicationPreferencesFormType {
  COMMUNICATION_PREFERENCE_CATEGORY_FORM = 'COMMUNICATION_PREFERENCE_CATEGORY_FORM',
  COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM = 'COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM',
  COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM = 'COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM',
  COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM = 'COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM'
}











export interface UniversalProfileContactInformationRequestInput {
  address: UniversalProfileAddressInput;
  emergencyContact: UniversalProfileEmergencyContactInput;
  phone: UniversalProfilePhoneInput;
}



export interface UniversalProfileContextInput {
  accountTakeOverWidgets?: Maybe<Array<UniversalProfileAccountTakeOverWidgetRequestInput>>;
  additionalTravelerIdentifier?: Maybe<Scalars['String']>;
  communicationPreferencesCategoryType?: Maybe<UniversalProfileCommunicationPreferencesCategoryType>;
  communicationPreferencesFormType?: Maybe<UniversalProfileCommunicationPreferencesFormType>;
  communicationPreferencesUnsubscribeContext?: Maybe<UniversalProfileCommunicationPreferenceUnsubRequestInput>;
  experienceType?: Maybe<UniversalProfileExperienceType>;
  informationFormType?: Maybe<UniversalProfileInformationFormType>;
  settingsFormType?: Maybe<UniversalProfileSettingsFormType>;
  subExperienceType?: Maybe<UniversalProfileSubExperienceType>;
}










export enum UniversalProfileDashboardOptionType {
  COMMUNICATIONS = 'COMMUNICATIONS',
  COUPONS = 'COUPONS',
  CREDITS = 'CREDITS',
  HELP = 'HELP',
  PAYMENTS = 'PAYMENTS',
  PROFILE = 'PROFILE',
  REVIEWS = 'REVIEWS',
  SETTINGS = 'SETTINGS'
}








export enum UniversalProfileDependsOnFieldIdentificationCriteriaOperator {
  EXCLUDES = 'EXCLUDES',
  INCLUDES = 'INCLUDES'
}


export interface UniversalProfileEmailCommunicationPreferenceUpdateInput {
  category: UniversalProfileCommunicationPreferencesCategoryType;
  emailOptIn: Scalars['Boolean'];
}






export interface UniversalProfileEmergencyContactInput {
  contactName?: Maybe<Scalars['String']>;
  phone: UniversalProfilePhoneInput;
}






export enum UniversalProfileExperienceType {
  COMMUNICATION_PREFERENCES = 'COMMUNICATION_PREFERENCES',
  HELP = 'HELP',
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS'
}














export enum UniversalProfileInformationFormType {
  COMMUNICATION_PREFERENCE_UNSUB = 'COMMUNICATION_PREFERENCE_UNSUB',
  UPDATE_BASIC_INFORMATION = 'UPDATE_BASIC_INFORMATION',
  UPDATE_COMMUNICATION_PREFERENCE = 'UPDATE_COMMUNICATION_PREFERENCE',
  UPDATE_CONTACT_INFORMATION = 'UPDATE_CONTACT_INFORMATION',
  UPDATE_CONTACT_INFORMATION_EMAIL = 'UPDATE_CONTACT_INFORMATION_EMAIL',
  UPDATE_CONTACT_INFORMATION_PHONE_NUMBER = 'UPDATE_CONTACT_INFORMATION_PHONE_NUMBER'
}











export enum UniversalProfileLocationAndLanguageOptionType {
  COUNTY = 'COUNTY',
  CURRENCY = 'CURRENCY',
  LANGUAGE = 'LANGUAGE'
}



export enum UniversalProfileLoginInformationSettingsOptionType {
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CONNECTED_DEVICES = 'CONNECTED_DEVICES',
  EMAIL = 'EMAIL'
}



export enum UniversalProfileMoreDetailsOptionType {
  AIRPORT_SECURITY = 'AIRPORT_SECURITY',
  FLIGHT_PREFERENCES = 'FLIGHT_PREFERENCES',
  REWARD_PROGRAM = 'REWARD_PROGRAM',
  TRAVELER_DOCUMENTS = 'TRAVELER_DOCUMENTS'
}









export interface UniversalProfilePhoneInput {
  countryCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  smsInfo?: Maybe<Scalars['Boolean']>;
}



export enum UniversalProfilePreferencesOptionType {
  COUNTRY = 'COUNTRY',
  CURRENCY = 'CURRENCY',
  DISPLAY_APPEARANCE = 'DISPLAY_APPEARANCE',
  LANGUAGE = 'LANGUAGE'
}









export enum UniversalProfileSettingsFormType {
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  UPDATE_COUNTRY = 'UPDATE_COUNTRY',
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  UPDATE_LANGUAGE = 'UPDATE_LANGUAGE',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD'
}







export interface UniversalProfileSmsContactInformationRequestInput {
  phone: UniversalProfilePhoneInput;
}



export enum UniversalProfileSubExperienceType {
  COMMUNICATION_PREFERENCES_EXPEDIA = 'COMMUNICATION_PREFERENCES_EXPEDIA',
  COMMUNICATION_PREFERENCES_HOTELS = 'COMMUNICATION_PREFERENCES_HOTELS',
  COMMUNICATION_PREFERENCES_VRBO = 'COMMUNICATION_PREFERENCES_VRBO'
}










/** Enum for holding values with reference to page stack history */
export enum UpdateHistory {
  REMOVE = 'REMOVE'
}

export interface UpdateInsurtechOfferRequestInput {
  /** The cart ID */
  cartId: Scalars['String'];
  /** list of offer tokens to be added to the main offer */
  offersToAdd: Array<OfferIdentityInput>;
  /** list of offer ids to be removed from the main offer */
  offersToRemove: Array<OfferIdentityInput>;
  /** The identity of the target offer to be updated, e.g.: Hotel, Flight, Car, etc. */
  targetOfferIdentity: OfferIdentityInput;
}




export enum UpdateTripType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}



export interface UriAttributesInput {
  /**
   * Used to specify the GAIA feature TYPE
   * Example Value: Multi-City
   */
  gaiaType?: Maybe<Scalars['String']>;
  lodgingUrlCode?: Maybe<Scalars['String']>;
}

export interface UriContextAttributesInput {
  affinity?: Maybe<Scalars['String']>;
  airCarrierCode?: Maybe<Scalars['String']>;
  carClass?: Maybe<Scalars['String']>;
  carSupplier?: Maybe<Scalars['String']>;
  gaiaType?: Maybe<Scalars['String']>;
  lodgingUrlCode?: Maybe<Scalars['String']>;
  starRating?: Maybe<Scalars['String']>;
}

export interface UriContextIdentifiersInput {
  destination: Scalars['String'];
  /** Only for PDP pages */
  hotelId?: Maybe<Scalars['Int']>;
  origin?: Maybe<Scalars['String']>;
}

/**
 * A context that can be used to retrieve targeted flex content
 * with combination of attributes and identifiers that uniquely identify a URI.
 */
export interface UriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes?: Maybe<UriAttributesInput>;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers?: Maybe<UriIdentifiersInput>;
}

/** A identifiers list that can be used to uniquely identify a URI. */
export interface UriIdentifiersInput {
  /**
   * Used to specify the accommodation type.
   * Example Value: Apartments
   */
  accommodationType?: Maybe<Scalars['String']>;
  /**
   * Used to specify airports city GAIA feature ID
   * Example Value: 178279
   */
  airport?: Maybe<Scalars['String']>;
  /**
   * Used to specify the brand.
   * Example Value: Travelodge UK
   */
  brand?: Maybe<Scalars['String']>;
  /**
   * Used to specify the car class.
   * Example Value: Economy
   */
  carClass?: Maybe<Scalars['String']>;
  /**
   * Used to specify the car supplier location ID (aka CVL ID).
   * Example Value: 12245
   */
  carSupplierLocation?: Maybe<Scalars['String']>;
  /**
   * Used to specify the carrier code.
   * Example Value: BA
   */
  carrierCode?: Maybe<Scalars['String']>;
  /**
   * Used to specify vendor ID
   * Example Value: ET
   */
  company?: Maybe<Scalars['String']>;
  /**
   * Used to specify the cruise line ID
   * Example Value: CV
   */
  cruiseLine?: Maybe<Scalars['String']>;
  /**
   * Used to specify the GAIA feature ID of destination
   * Example Value:
   */
  destination?: Maybe<Scalars['String']>;
  /**
   * Used to specify the discriminator for hotel landing pages
   * Example Value: ho
   */
  discriminator?: Maybe<Scalars['String']>;
  /**
   * Used to specify current screen feature displayed to user
   * Example Value: reviews, lodgingDiscovery, destinationDiscovery
   */
  feature?: Maybe<Scalars['String']>;
  /**
   * Used to specify the flight route type
   * Example Value: open / fixed
   */
  flightRoute?: Maybe<Scalars['String']>;
  /**
   * Used to specify current location of user in the conversion funnel
   * Example Value: entry
   */
  funnelLocation?: Maybe<Scalars['String']>;
  /**
   * Used to specify the hotel ID
   * Example Value: 1
   */
  hotel?: Maybe<Scalars['String']>;
  /**
   * Used to specify hotel PCS ID for HCOM pages
   * Example Value: 456469
   */
  id?: Maybe<Scalars['String']>;
  /**
   * Used to specify the line of business
   * Example Value: flight
   */
  lineOfBusiness?: Maybe<Scalars['String']>;
  /**
   * Used to specify the type of lodging
   * Example Value: alternative
   */
  lodgingType?: Maybe<Scalars['String']>;
  /**
   * Used to specify the GAIA feature ID of origin
   * Example Value: 178286
   */
  origin?: Maybe<Scalars['String']>;
  /**
   * Used to specify the ship code of the ship
   * Example Value: AVW
   */
  ship?: Maybe<Scalars['String']>;
  /**
   * Used to specify the hotel's star rating
   * Source of truth is flex-hotels-service
   * Example Value: 5
   */
  starRating?: Maybe<Scalars['String']>;
  /**
   * Used to specify the hotel's theme
   * Source of truth is affinity prime
   * Example Value: romantic
   */
  theme?: Maybe<Scalars['String']>;
  /**
   * Used to specify the url mapping path, without leading '/'
   * Example Value: lp/deals
   */
  url?: Maybe<Scalars['String']>;
}




export interface UserContextInput {
  siteId: Scalars['Int'];
  tuid: Scalars['Int'];
}




export interface UserLocationInput {
  userCountryCode?: Maybe<Scalars['String']>;
  userLatitude?: Maybe<Scalars['BigDecimal']>;
  userLongitude?: Maybe<Scalars['BigDecimal']>;
  userSelectedOrigin?: Maybe<Scalars['String']>;
}














/** Represents the status of response */
export enum VirtualAgentCheckoutStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

/** Represents the virtual agent context */
export interface VirtualAgentContextInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber: Scalars['String'];
  /** Represents the token which is used in exchange of information */
  opaqueToken: Scalars['String'];
}










/** Represents a new input type, used by the new mutation to send event data */
export interface VirtualAgentControlConversationEventInput {
  /** Represents a typing indicator event's content */
  typingIndicator?: Maybe<TypingIndicatorEventContentInput>;
}












/** Represents VAC input message data */
export interface VirtualAgentControlMessageInput {
  /** Represents an optional payload of message input */
  payload?: Maybe<Scalars['String']>;
  /** Represents the text of message input */
  text?: Maybe<Scalars['String']>;
  /** Represents a unique identifier on the UI */
  umid: Scalars['String'];
}
































export type FlightsFlexibleSearchQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext?: Maybe<FlightsSearchContextInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  travelerDetails?: Maybe<Array<FlightsTravelerDetailsInput> | FlightsTravelerDetailsInput>;
}>;


export type FlightsFlexibleSearchQuery = { __typename: 'Query', flightsSearch: { __typename: 'FlightsSearchResponse', flexibleSearchResponse?: Maybe<{ __typename: 'FlightsFlexibleSearchResponse', title: string, subTitle: string, titleAccessibility: string, flexGridType: FlightsFlexibleGridType, loadingStateAccessibility: string, searchTriggerAction?: Maybe<string>, dismissGridAccessibility: { __typename: 'FlightsAccessibilityMessage', usage?: Maybe<string> }, analytics: { __typename: 'FlightsFlexibleSearchResponseAnalytics', priceFillRate: string }, departureLegend?: Maybe<{ __typename: 'FlightsFlexibleSearchGridLegendBadge', labelText?: Maybe<string>, accessibility: string, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> }>, resultsGrid: { __typename: 'FlightsFlexibleSearchResultsGrid', results: Array<Array<(
          { __typename: 'FlightsFlexibleSearchHeaderCell' }
          & FlightsFlexSearchHeaderCellFragment
        ) | (
          { __typename: 'FlightsFlexibleSearchLegendCell' }
          & FlightsFlexSearchLegendCellFragment
        ) | (
          { __typename: 'FlightsFlexibleSearchResultCell' }
          & FlightsFlexSearchResultsFragment
        )>> }, coverageAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), coverageNotValidAnalytics?: Maybe<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )>, gridTrigger?: Maybe<{ __typename: 'FlightsFlexibleSearchGridTrigger', collapseAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), expandAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) }> }> } };

export type FlightsFlexSearchResultsFragment = { __typename: 'FlightsFlexibleSearchResultCell', valueText?: Maybe<string>, labelText?: Maybe<string>, theme: FlightsFlexibleSearchResultCellTheme, summary?: Maybe<string>, journeyDate?: Maybe<string>, accessibility: { __typename: 'FlightsFlexibleSearchCellAccessibility', highlightDescription?: Maybe<string>, selectionDescription?: Maybe<string> }, nextSearchCriteria?: Maybe<{ __typename: 'FlightsNextJourneyCriteriaLink' } | (
    { __typename: 'FlightsNextJourneyCriteriaValues' }
    & FlightsNextJourneyCriteriaValuesFragment
  )>, selectAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsNextJourneyCriteriaValuesFragment = { __typename: 'FlightsNextJourneyCriteriaValues', journeyCriteria: Array<Maybe<{ __typename: 'FlightsJourneyCriteria', destination: string, origin: string, departureDate: { __typename: 'Date', day: number, month: number, year: number } }>>, searchPreferences: { __typename: 'FlightSearchPreferences', cabinClass: FlightCabinClassInfo } };

export type FlightsFlexSearchLegendCellFragment = { __typename: 'FlightsFlexibleSearchLegendCell', valueText?: Maybe<string>, legendTheme: FlightsFlexibleSearchLegendCellTheme, accessibilityMessage?: Maybe<{ __typename: 'FlightsAccessibilityMessage', usage?: Maybe<string> }>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> };

export type FlightsFlexSearchHeaderCellFragment = { __typename: 'FlightsFlexibleSearchHeaderCell', labelText?: Maybe<string>, valueText?: Maybe<string>, headerTheme: FlightsFlexibleSearchHeaderCellTheme };

export type FlightsAnalyticsFragment = { __typename: 'FlightsAnalytics', linkName: string, referrerId: string };

export type FlightsFlexibleDiscoverySearchQueryVariables = Exact<{
  context: ContextInput;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  flightsSearchContext: FlightsSearchContextInput;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
}>;


export type FlightsFlexibleDiscoverySearchQuery = { __typename: 'Query', flexibleSearch?: Maybe<{ __typename: 'FlightsFlexibleSearchResponse', title: string, subTitle: string, titleAccessibility: string, flexGridType: FlightsFlexibleGridType, loadingStateAccessibility: string, searchTriggerAction?: Maybe<string>, dismissGridAccessibility: { __typename: 'FlightsAccessibilityMessage', usage?: Maybe<string> }, analytics: { __typename: 'FlightsFlexibleSearchResponseAnalytics', priceFillRate: string }, departureLegend?: Maybe<{ __typename: 'FlightsFlexibleSearchGridLegendBadge', labelText?: Maybe<string>, accessibility: string, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> }>, resultsGrid: { __typename: 'FlightsFlexibleSearchResultsGrid', results: Array<Array<(
        { __typename: 'FlightsFlexibleSearchHeaderCell' }
        & FlightsFlexSearchHeaderDiscoveryCellFragment
      ) | (
        { __typename: 'FlightsFlexibleSearchLegendCell' }
        & FlightsFlexSearchLegendDiscoveryCellFragment
      ) | (
        { __typename: 'FlightsFlexibleSearchResultCell' }
        & FlightsFlexSearchResultCellFragment
      )>> }, coverageAnalytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), coverageNotValidAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, gridTrigger?: Maybe<{ __typename: 'FlightsFlexibleSearchGridTrigger', collapseAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), expandAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }> }> };

export type FlightsFlexSearchHeaderDiscoveryCellFragment = { __typename: 'FlightsFlexibleSearchHeaderCell', valueText?: Maybe<string>, labelText?: Maybe<string>, headerTheme: FlightsFlexibleSearchHeaderCellTheme };

export type FlightsFlexSearchLegendDiscoveryCellFragment = { __typename: 'FlightsFlexibleSearchLegendCell', valueText?: Maybe<string>, labelText?: Maybe<string>, legendTheme: FlightsFlexibleSearchLegendCellTheme, accessibilityMessage?: Maybe<{ __typename: 'FlightsAccessibilityMessage', usage?: Maybe<string> }>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> };

export type FlightsFlexSearchResultCellFragment = { __typename: 'FlightsFlexibleSearchResultCell', valueText?: Maybe<string>, labelText?: Maybe<string>, theme: FlightsFlexibleSearchResultCellTheme, summary?: Maybe<string>, journeyDate?: Maybe<string>, nextSearchCriteria?: Maybe<{ __typename: 'FlightsNextJourneyCriteriaLink' } | (
    { __typename: 'FlightsNextJourneyCriteriaValues' }
    & FlightsNextJourneyCriteriaValuesFragment
  )>, accessibility: { __typename: 'FlightsFlexibleSearchCellAccessibility', highlightDescription?: Maybe<string>, selectionDescription?: Maybe<string> }, selectAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsShoppingPwaFlightInformationResultsQueryVariables = Exact<{
  context: ContextInput;
  flightsDetailCriteria: FlightsDetailCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  virtualAgentContext?: Maybe<VirtualAgentContextInput>;
}>;


export type FlightsShoppingPwaFlightInformationResultsQuery = { __typename: 'Query', flightsDetail: { __typename: 'FlightsInformationResponse', gaiaId?: Maybe<string>, journeyContinuationId?: Maybe<string>, baseOfferAncillaryID?: Maybe<string>, smartShoppingExperienceEligibility?: Maybe<boolean>, analytics?: Maybe<{ __typename: 'FlightsInformationAnalytics', footerOnViewedAnalytics?: Maybe<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )>, onLoadAnalyticsList?: Maybe<Array<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )>> }>, clientMetadata?: Maybe<{ __typename: 'FlightsPWAMetadata', pageName: string, pageNameAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }>, flightsOpinionLab?: Maybe<{ __typename: 'FlightsActionAndLabel', label: string, selectAction: (
        { __typename: 'FlightsAction' }
        & FlightsActionInformationLoadedFragment
      ) }>, pageTitle?: Maybe<{ __typename: 'FlightsPageTitle', pageAccessibility?: Maybe<string>, title: (
        { __typename: 'FlightsResponsiveMessage' }
        & FlightsResponsiveMessageFragment
      ) }>, messagingCards?: Maybe<Array<(
      { __typename: 'FlightsIconPlacard' }
      & FlightsIconPlacardInformationLoadedFragment
    ) | (
      { __typename: 'FlightsImagePlacard' }
      & FlightsImagePlacardInformationLoadedFragment
    ) | (
      { __typename: 'FlightsMarkPlacard' }
      & FlightsMarkPlacardInformationLoadedFragment
    )>>, partnerLoyaltyEarnMessage?: Maybe<(
      { __typename: 'FlightsMarkPlacard' }
      & FlightsMarkPlacardFragment
    )>, banners?: Maybe<Array<(
      { __typename: 'FlightsIconPlacard' }
      & FlightsIconPlacardInformationLoadedFragment
    ) | { __typename: 'FlightsImagePlacard' } | { __typename: 'FlightsMarkPlacard' }>>, freeCancellation?: Maybe<{ __typename: 'FlightsIconPlacard' } | (
      { __typename: 'FlightsImagePlacard' }
      & FlightsImagePlacardInformationLoadedFragment
    ) | { __typename: 'FlightsMarkPlacard' }>, flightsSelectedJourneyReview?: Maybe<Array<{ __typename: 'LoadedFlightsSelectedJourneyReview', upsellNudgingFeatureEnabled: boolean, flightsJourneyInformation?: Maybe<{ __typename: 'FlightsDetailedJourneyInformation', details: (
          { __typename: 'FlightsToggle' }
          & FlightsToggleInformationLoadedFragment
        ), flightJourneyDetails: { __typename: 'FlightsJourneyDetails', journeySections: Array<{ __typename: 'JourneySection', journeyConnectionInformation: Array<{ __typename: 'AdditionalInformation', durationAndStop: string, nextFlightOriginAirportInfo?: Maybe<{ __typename: 'FlightsIconAndLabel', label: string, theme: TextTheme, accessibility?: Maybe<string>, icon: (
                  { __typename: 'Icon' }
                  & IconInformationLoadedFragment
                ) }> } | { __typename: 'FlightsConnectionInformation', flightsConnection: { __typename: 'FlightsConnection', aircraftModel?: Maybe<string>, airlineInfo: string, cabinClassAndBookingCode: string, duration: string, operatedBy?: Maybe<string>, connectionArrival: (
                  { __typename: 'CoordinateInformation' }
                  & CoordinateInformationInformationLoadedFragment
                ), connectionDeparture: (
                  { __typename: 'CoordinateInformation' }
                  & CoordinateInformationInformationLoadedFragment
                ), journeyAmenities?: Maybe<(
                  { __typename: 'FlightsJourneyAmenities' }
                  & FlightsInformationJourneyAmenitiesFragment
                )> } }> }>, journeyAmenities?: Maybe<Array<{ __typename: 'FlightsIconAndLabel', label: string, accessibility?: Maybe<string>, value?: Maybe<string>, theme: TextTheme, icon: (
              { __typename: 'Icon' }
              & IconInformationLoadedFragment
            ), displayAnalytics?: Maybe<Array<(
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            )>> }>> } }>, flightsJourneyHeaders: (
        { __typename: 'FlightsJourneyHeaders' }
        & FlightsJourneyHeadersFragment
      ), flightsJourneySummary: { __typename: 'FlightsBargainJourneySummary', arrivalDayInformation: string, heading: (
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        ), differentDayArrival?: Maybe<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        )>, basicFlightDetails: Array<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        )> } | { __typename: 'LoadedFlightsStandardJourneySummary', journeyAmenities?: Maybe<(
          { __typename: 'FlightsJourneyAmenities' }
          & FlightsInformationJourneyAmenitiesFragment
        )>, heading: (
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        ), differentDayArrival?: Maybe<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        )>, basicFlightDetails: Array<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        )> } | { __typename: 'LoadingFlightsStandardJourneySummary', heading: (
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        ), differentDayArrival?: Maybe<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        )>, basicFlightDetails: Array<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadedFragment
        )> }, journeyHighlights?: Maybe<Array<{ __typename: 'FlightsJourneyHighlights', flightsJourneyHeaders: (
          { __typename: 'FlightsJourneyHeaders' }
          & FlightsJourneyHeadersFragment
        ), flightsJourneySummary: { __typename: 'FlightsBargainJourneySummary', arrivalDayInformation: string, heading: (
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          ), differentDayArrival?: Maybe<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          )>, basicFlightDetails: Array<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          )> } | { __typename: 'LoadedFlightsStandardJourneySummary', heading: (
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          ), differentDayArrival?: Maybe<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          )>, basicFlightDetails: Array<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          )> } | { __typename: 'LoadingFlightsStandardJourneySummary', heading: (
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          ), differentDayArrival?: Maybe<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          )>, basicFlightDetails: Array<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadedFragment
          )> } }>>, onViewedAnalytics?: Maybe<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )>, changeFlight: (
        { __typename: 'FlightsAction' }
        & FlightsActionInformationLoadedFragment
      ), changeFlightDialog?: Maybe<{ __typename: 'FlightsDialogChangeFlight', header: string, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), analyticsList: Array<(
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          )> }>, displayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )> }>, fareDetails: { __typename: 'FareDetails', fareSummary?: Maybe<{ __typename: 'FareSummary', message: string, title: string, upsellNudgingFeatureEnabled: boolean, flightsSelectedJourneyAvailableFaresInformation?: Maybe<(
            { __typename: 'FlightsSelectedJourneyAvailableFares' }
            & FlightsSelectedJourneyAvailableFaresFragment
          )>, details: (
            { __typename: 'FlightsAction' }
            & FlightsActionInformationLoadedFragment
          ), flightsFareNudgeMessage?: Maybe<(
            { __typename: 'FlightsIconAndLabel' }
            & FlightsIconAndLabelLoadedFragment
          )> }>, defaultBaggageInformation?: Maybe<(
          { __typename: 'FlightsBaggageInformation' }
          & FlightsBaggageInformationFragment
        )>, fareSeatMapInformation?: Maybe<(
          { __typename: 'FareSeatMapInformation' }
          & FareSeatMapInformationFragment
        )>, changeAndCancellationFees?: Maybe<(
          { __typename: 'FlightsChangeAndCancellationFees' }
          & FlightsChangeAndCancellationFeesFragment
        )> }, flightsJourneyPolicies?: Maybe<(
        { __typename: 'FlightsTextSection' }
        & FlightsInformationTextSectionLoadedFragment
      )>, journeyInformation?: Maybe<(
        { __typename: 'JourneyInformation' }
        & JourneyInformationFragment
      )> } | { __typename: 'LoadingFlightsSelectedJourneyReview' }>>, priceSummary?: Maybe<(
      { __typename: 'FlightsLoadedPriceSummary' }
      & FlightsLoadedPriceSummaryFragment
    ) | { __typename: 'FlightsLoadingPriceSummary' }>, separateTicketBanner?: Maybe<(
      { __typename: 'FlightsIconPlacard' }
      & FlightsIconPlacardInformationLoadedFragment
    )>, serverErrorMessaging?: Maybe<(
      { __typename: 'FlightsActionableErrorMessaging' }
      & FlightsInformationServerErrorMessagingFragment
    ) | { __typename: 'FlightsNoFlightsFoundMessaging' } | { __typename: 'FlightsNoFlightsFoundWithFilterMessaging' } | { __typename: 'FlightsSmartNoFlightsFoundMessaging' }>, dynamicElementsGroups?: Maybe<Array<{ __typename: 'FlightsInformationDynamicElementsGroup', ancillaryId?: Maybe<string>, identifier: string, dynamicElements: { __typename: 'FlightsInformationDynamicElements', airOfferToken: string, totalPrice: string, priceSummary: (
          { __typename: 'FlightsLoadedPriceSummary' }
          & FlightsLoadedPriceSummaryFragment
        ), fareChoiceInformationDynamicElement?: Maybe<{ __typename: 'FareChoiceInformationDynamicElement', farePricePerPerson: string }>, flightsJourneyDetailsDynamicElements?: Maybe<Array<{ __typename: 'FlightsJourneyDetailsDynamicElements', fareName?: Maybe<string>, title: string, message?: Maybe<string>, journeyPartsDynamicElements: Array<{ __typename: 'JourneyPartsDynamicElements', cabinClassAndBookingCode: string }>, fareSeatMapDynamicElement?: Maybe<{ __typename: 'FareSeatMapDynamicElement', onSelectAnalytics: Array<(
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            )>, flightLegsDetails?: Maybe<(
              { __typename: 'FareSeatMapAvailableFlightLegsDetails' }
              & FareSeatMapAvailableFlightLegsDetailsFragment
            )> }>, selectedSeatDetails?: Maybe<Array<(
            { __typename: 'FlightsSelectedSeatDetail' }
            & FlightsSelectedSeatDetailFragment
          )>>, details?: Maybe<(
            { __typename: 'FlightsAction' }
            & FlightsActionInformationLoadedFragment
          )>, flightsFareNudgeMessage?: Maybe<(
            { __typename: 'FlightsIconAndLabel' }
            & FlightsIconAndLabelLoadedFragment
          )>, fareChangeAction?: Maybe<(
            { __typename: 'FlightsAction' }
            & FlightsActionInformationLoadedFragment
          )> }>>, dynamicElementsGroupTrackEventAnalytics?: Maybe<{ __typename: 'FlightsDynamicElementsTrackEventAnalytics', stringifiedAllFlightProducts: string, analyticsList: Array<{ __typename: 'FlightsAnalytics', linkName: string, referrerId: string }> }> } | { __typename: 'FlightsSearchResultsDynamicElements', flightsJourneyDetailsDynamicElements?: Maybe<Array<{ __typename: 'FlightsJourneyDetailsDynamicElements', fareName?: Maybe<string>, title: string, message?: Maybe<string>, journeyPartsDynamicElements: Array<{ __typename: 'JourneyPartsDynamicElements', cabinClassAndBookingCode: string }>, fareSeatMapDynamicElement?: Maybe<{ __typename: 'FareSeatMapDynamicElement', onSelectAnalytics: Array<(
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            )>, flightLegsDetails?: Maybe<(
              { __typename: 'FareSeatMapAvailableFlightLegsDetails' }
              & FareSeatMapAvailableFlightLegsDetailsFragment
            )> }>, selectedSeatDetails?: Maybe<Array<(
            { __typename: 'FlightsSelectedSeatDetail' }
            & FlightsSelectedSeatDetailFragment
          )>>, details?: Maybe<(
            { __typename: 'FlightsAction' }
            & FlightsActionInformationLoadedFragment
          )>, flightsFareNudgeMessage?: Maybe<(
            { __typename: 'FlightsIconAndLabel' }
            & FlightsIconAndLabelLoadedFragment
          )>, fareChangeAction?: Maybe<(
            { __typename: 'FlightsAction' }
            & FlightsActionInformationLoadedFragment
          )> }>>, dynamicElementsGroupTrackEventAnalytics?: Maybe<{ __typename: 'FlightsDynamicElementsTrackEventAnalytics', stringifiedAllFlightProducts: string, analyticsList: Array<{ __typename: 'FlightsAnalytics', linkName: string, referrerId: string }> }> } }>>, multiItemDynamicCrossSellPrimer?: Maybe<{ __typename: 'MultiItemDynamicCrossSellPrimer', multiItemSearchContext: (
        { __typename: 'MultiItemSearchContext' }
        & MultiItemFlightsSearchContextFragment
      ), multiItemSelectedFlightProducts: (
        { __typename: 'MultiItemSelectedFlightProducts' }
        & MultiItemFlightNaturalKeyFragment
      ) }>, flightsInformationPriceMatchPromise?: Maybe<{ __typename: 'FlightsInformationPriceMatchPromise', surveyElementId?: Maybe<string>, card?: Maybe<(
        { __typename: 'FlightsMessagingCardPlacard' }
        & FlightsMessagingCardFisPlacardFragmentFragment
      )> }> } };

export type FlightsJourneyHeadersFragment = { __typename: 'FlightsJourneyHeaders', flightsJourneySubheading: string, heading: string, flightsJourneySubheadingMark?: Maybe<{ __typename: 'Mark', description: string, id: string, size?: Maybe<string>, token: string, url?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }> };

export type FlightsChangeAndCancellationFeesFragment = { __typename: 'FlightsChangeAndCancellationFees', heading: string, changeAndCancellationDetails: Array<(
    { __typename: 'FlightsLabelAndValue' }
    & FlightsLabelAndValueFragment
  )>, displayAnalytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type FlightsLabelAndValueFragment = { __typename: 'FlightsLabelAndValue', label: string, value: string, accessibilityMessage: string };

export type FareSeatMapInformationFragment = { __typename: 'FareSeatMapInformation', message: string, title: string, ancillaryId?: Maybe<string>, enableSeatSelection?: Maybe<boolean>, errorMessage?: Maybe<string>, skeletonCount: number, details?: Maybe<(
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  )>, fareSeatMapViewDetails?: Maybe<(
    { __typename: 'FareSeatMapViewDetails' }
    & FareSeatMapViewDetailsFragment
  )>, selectedSeatDetails?: Maybe<Array<(
    { __typename: 'FlightsSelectedSeatDetail' }
    & FlightsSelectedSeatDetailFragment
  )>>, errorMessages?: Maybe<Array<(
    { __typename: 'FlightsSeatSelectionErrorMessage' }
    & FlightsSeatSelectionErrorMessageFragment
  )>> };

export type FlightsSeatSelectionErrorMessageFragment = { __typename: 'FlightsSeatSelectionErrorMessage', id: FlightsSeatSelectionErrorType, message: string, analytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type FlightsSelectedSeatDetailFragment = { __typename: 'FlightsSelectedSeatDetail', flightInformation?: Maybe<string>, travelerSeatsInformation?: Maybe<Array<string>> };

export type FareSeatMapViewDetailsFragment = { __typename: 'FareSeatMapViewDetails', onLoadAccessibilityMessage?: Maybe<string>, title: string, dismissSeatMapDialog: (
    { __typename: 'FlightsActionableIcon' }
    & FlightsActionableInformationIconLoadedFragment
  ), errorMessage?: Maybe<(
    { __typename: 'FlightsIconPlacard' }
    & FlightsIconPlacardInformationLoadedFragment
  )>, fareSeatMapLegendsInformation?: Maybe<(
    { __typename: 'FareSeatMapLegendsInformation' }
    & FareSeatMapLegendsInformationFragment
  )>, flightLegsDetails?: Maybe<(
    { __typename: 'FareSeatMapAvailableFlightLegsDetails' }
    & FareSeatMapAvailableFlightLegsDetailsFragment
  )>, seatMapAlertDialog?: Maybe<Array<(
    { __typename: 'FareSeatMapAlertDialog' }
    & FareSeatMapAlertDialogFragment
  )>>, seatMapDialogAnalyticsList?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type FareSeatMapAlertDialogFragment = { __typename: 'FareSeatMapAlertDialog', id: FlightsActionType, alert: { __typename: 'FlightsDialogStandard', animation: FlightsDialogAnimation, message?: Maybe<string>, title?: Maybe<string>, actions: Array<(
      { __typename: 'FlightsAction' }
      & FlightsActionInformationLoadedFragment
    )>, displayedAnalytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ) } };

export type FareSeatMapAvailableFlightLegsDetailsFragment = { __typename: 'FareSeatMapAvailableFlightLegsDetails', offerIdentifier: string, pricingConstruct?: Maybe<string>, flightLegSelectionList: Array<(
    { __typename: 'FareSeatMapAvailableFlightLegSelection' }
    & FareSeatMapAvailableFlightLegSelectionFragment
  )>, onViewedAnalytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type FareSeatMapAvailableFlightLegSelectionFragment = { __typename: 'FareSeatMapAvailableFlightLegSelection', identifier: string, isSelected: boolean, errorAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), seatMapLegSummary?: Maybe<(
    { __typename: 'FlightsSeatMapLegSummary' }
    & FlightsSeatMapLegSummaryFragment
  )>, seatSegment?: Maybe<(
    { __typename: 'SeatSegment' }
    & FlightsSeatSegmentLoadedFragment
  )>, selectedCard: (
    { __typename: 'FlightsIconPlacard' }
    & FlightsIconPlacardInformationLoadedFragment
  ), unselectedCard: (
    { __typename: 'FlightsIconPlacard' }
    & FlightsIconPlacardInformationLoadedFragment
  ) };

export type FlightsSeatMapTotalDetailsFragment = { __typename: 'FlightsSeatMapTotalDetails', noSeatSelected: string, seatDelimiter: string, label: (
    { __typename: 'FlightsResponsiveMessage' }
    & FlightsResponsiveMessageFragment
  ), seatsSelectedMessage: (
    { __typename: 'FlightsSimpleLocalizationTemplate' }
    & FlightsSimpleLocalizationTemplateFragment
  ), selectedSeats: Array<(
    { __typename: 'FlightsSeatMapSeatDetails' }
    & FlightsSeatMapSeatDetailsFragment
  )>, totalPrice: (
    { __typename: 'FlightsSimpleLocalizationTemplate' }
    & FlightsSimpleLocalizationTemplateFragment
  ) };

export type FlightsResponsiveMessageFragment = { __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> };

export type FlightsSeatMapLegSummaryActionTypeFragment = { __typename: 'FlightsSeatMapLegSummaryActionType', id: FlightsActionType, analyticsList: Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsSeatMapLegSummaryFragment = { __typename: 'FlightsSeatMapLegSummary', buttonAction: (
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  ), buttonActionTypes: Array<(
    { __typename: 'FlightsSeatMapLegSummaryActionType' }
    & FlightsSeatMapLegSummaryActionTypeFragment
  )>, seatTotalDetails: (
    { __typename: 'FlightsSeatMapTotalDetails' }
    & FlightsSeatMapTotalDetailsFragment
  ), travelerSummary: { __typename: 'FlightsSeatMapTravelersSummary', title: (
      { __typename: 'FlightsResponsiveMessage' }
      & FlightsResponsiveMessageFragment
    ), travelers: Array<{ __typename: 'FlightsSeatMapTravelerSummaryItem', id: number, action: { __typename: 'FlightsActionAndLabel', label: string, selectAction: (
          { __typename: 'FlightsAction' }
          & FlightsActionInformationLoadedFragment
        ) }, seatDetails: (
        { __typename: 'FlightsSeatMapSeatDetails' }
        & FlightsSeatMapSeatDetailsFragment
      ) }> } };

export type FlightsSeatMapSeatDetailsFragment = { __typename: 'FlightsSeatMapSeatDetails', assignedSeat?: Maybe<string>, id: number, price: { __typename: 'FlightsSeatMapSeatPrice', amount?: Maybe<number>, default: string, selected?: Maybe<(
      { __typename: 'FlightsSimpleLocalizationTemplate' }
      & FlightsSimpleLocalizationTemplateFragment
    )> } };

export type FlightsSimpleLocalizationTemplateFragment = { __typename: 'FlightsSimpleLocalizationTemplate', initialValue?: Maybe<string>, template: string, tokens: Array<string> };

export type FlightsSeatSegmentLoadedFragment = { __typename: 'SeatSegment', fareBasisCode: string, identifier: string, operatingCarrierCode: string };

export type FareSeatMapLegendsInformationFragment = { __typename: 'FareSeatMapLegendsInformation', accessibilityMessage: string, dismissSeatMapLegends?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, legendDetails: (
    { __typename: 'FlightsSeatMapLegends' }
    & FlightsSeatMapLegendsFragment
  ), viewLegendButton?: Maybe<(
    { __typename: 'FlightsActionableIcon' }
    & FlightsActionableInformationIconLoadedFragment
  )> };

export type ClientAnalyticsFragment = { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> };

type ClientAction_FlightsAncillaryContinueAction_Fragment = { __typename: 'FlightsAncillaryContinueAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsBookingAction_Fragment = { __typename: 'FlightsBookingAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsBoundNavigation_Fragment = { __typename: 'FlightsBoundNavigation', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsClickAction_Fragment = { __typename: 'FlightsClickAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsCreditClearAction_Fragment = { __typename: 'FlightsCreditClearAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsCreditSelectionAction_Fragment = { __typename: 'FlightsCreditSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsCreditSelectorOpenAction_Fragment = { __typename: 'FlightsCreditSelectorOpenAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsDialogCloseAction_Fragment = { __typename: 'FlightsDialogCloseAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsDialogTriggerAction_Fragment = { __typename: 'FlightsDialogTriggerAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsFareTypeSelectionAction_Fragment = { __typename: 'FlightsFareTypeSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsLegDropdownItemSelection_Fragment = { __typename: 'FlightsLegDropdownItemSelection', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsLoadAncillariesAction_Fragment = { __typename: 'FlightsLoadAncillariesAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsNavigateToDetails_Fragment = { __typename: 'FlightsNavigateToDetails', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsRedirectOrDialog_Fragment = { __typename: 'FlightsRedirectOrDialog', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsRefreshAction_Fragment = { __typename: 'FlightsRefreshAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsRemovePriceMatchPromiseAction_Fragment = { __typename: 'FlightsRemovePriceMatchPromiseAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsResourceLinkAction_Fragment = { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsResourceRedirectAction_Fragment = { __typename: 'FlightsResourceRedirectAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsSearchCriteriaChangeAction_Fragment = { __typename: 'FlightsSearchCriteriaChangeAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsSelectionAction_Fragment = { __typename: 'FlightsSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_FlightsSwitchToggleAction_Fragment = { __typename: 'FlightsSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_InsuranceSwitchToggleAction_Fragment = { __typename: 'InsuranceSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_MultiItemSelectPackage_Fragment = { __typename: 'MultiItemSelectPackage', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type ClientAction_MultiItemSelectProducts_Fragment = { __typename: 'MultiItemSelectProducts', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

export type ClientActionFragment = ClientAction_FlightsAncillaryContinueAction_Fragment | ClientAction_FlightsBookingAction_Fragment | ClientAction_FlightsBoundNavigation_Fragment | ClientAction_FlightsClickAction_Fragment | ClientAction_FlightsCreditClearAction_Fragment | ClientAction_FlightsCreditSelectionAction_Fragment | ClientAction_FlightsCreditSelectorOpenAction_Fragment | ClientAction_FlightsDialogCloseAction_Fragment | ClientAction_FlightsDialogTriggerAction_Fragment | ClientAction_FlightsFareTypeSelectionAction_Fragment | ClientAction_FlightsLegDropdownItemSelection_Fragment | ClientAction_FlightsLoadAncillariesAction_Fragment | ClientAction_FlightsNavigateToDetails_Fragment | ClientAction_FlightsRedirectOrDialog_Fragment | ClientAction_FlightsRefreshAction_Fragment | ClientAction_FlightsRemovePriceMatchPromiseAction_Fragment | ClientAction_FlightsResourceLinkAction_Fragment | ClientAction_FlightsResourceRedirectAction_Fragment | ClientAction_FlightsSearchCriteriaChangeAction_Fragment | ClientAction_FlightsSelectionAction_Fragment | ClientAction_FlightsSwitchToggleAction_Fragment | ClientAction_InsuranceSwitchToggleAction_Fragment | ClientAction_MultiItemSelectPackage_Fragment | ClientAction_MultiItemSelectProducts_Fragment;

export type FlightsSeatMapLegendsFragment = { __typename: 'FlightsSeatMapLegends', title: string, close: { __typename: 'FlightsActionButton', primary?: Maybe<string>, style: EgdsButtonStyle, accessibility?: Maybe<string>, disabled: boolean, clientAction: (
      { __typename: 'FlightsAncillaryContinueAction' }
      & ClientAction_FlightsAncillaryContinueAction_Fragment
    ) | (
      { __typename: 'FlightsBookingAction' }
      & ClientAction_FlightsBookingAction_Fragment
    ) | (
      { __typename: 'FlightsBoundNavigation' }
      & ClientAction_FlightsBoundNavigation_Fragment
    ) | (
      { __typename: 'FlightsClickAction' }
      & ClientAction_FlightsClickAction_Fragment
    ) | (
      { __typename: 'FlightsCreditClearAction' }
      & ClientAction_FlightsCreditClearAction_Fragment
    ) | (
      { __typename: 'FlightsCreditSelectionAction' }
      & ClientAction_FlightsCreditSelectionAction_Fragment
    ) | (
      { __typename: 'FlightsCreditSelectorOpenAction' }
      & ClientAction_FlightsCreditSelectorOpenAction_Fragment
    ) | (
      { __typename: 'FlightsDialogCloseAction' }
      & ClientAction_FlightsDialogCloseAction_Fragment
    ) | (
      { __typename: 'FlightsDialogTriggerAction' }
      & ClientAction_FlightsDialogTriggerAction_Fragment
    ) | (
      { __typename: 'FlightsFareTypeSelectionAction' }
      & ClientAction_FlightsFareTypeSelectionAction_Fragment
    ) | (
      { __typename: 'FlightsLegDropdownItemSelection' }
      & ClientAction_FlightsLegDropdownItemSelection_Fragment
    ) | (
      { __typename: 'FlightsLoadAncillariesAction' }
      & ClientAction_FlightsLoadAncillariesAction_Fragment
    ) | (
      { __typename: 'FlightsNavigateToDetails' }
      & ClientAction_FlightsNavigateToDetails_Fragment
    ) | (
      { __typename: 'FlightsRedirectOrDialog' }
      & ClientAction_FlightsRedirectOrDialog_Fragment
    ) | (
      { __typename: 'FlightsRefreshAction' }
      & ClientAction_FlightsRefreshAction_Fragment
    ) | (
      { __typename: 'FlightsRemovePriceMatchPromiseAction' }
      & ClientAction_FlightsRemovePriceMatchPromiseAction_Fragment
    ) | (
      { __typename: 'FlightsResourceLinkAction' }
      & ClientAction_FlightsResourceLinkAction_Fragment
    ) | (
      { __typename: 'FlightsResourceRedirectAction' }
      & ClientAction_FlightsResourceRedirectAction_Fragment
    ) | (
      { __typename: 'FlightsSearchCriteriaChangeAction' }
      & ClientAction_FlightsSearchCriteriaChangeAction_Fragment
    ) | (
      { __typename: 'FlightsSelectionAction' }
      & ClientAction_FlightsSelectionAction_Fragment
    ) | (
      { __typename: 'FlightsSwitchToggleAction' }
      & ClientAction_FlightsSwitchToggleAction_Fragment
    ) | (
      { __typename: 'InsuranceSwitchToggleAction' }
      & ClientAction_InsuranceSwitchToggleAction_Fragment
    ) | (
      { __typename: 'MultiItemSelectPackage' }
      & ClientAction_MultiItemSelectPackage_Fragment
    ) | (
      { __typename: 'MultiItemSelectProducts' }
      & ClientAction_MultiItemSelectProducts_Fragment
    ), icon?: Maybe<(
      { __typename: 'Icon' }
      & IconInformationLoadedFragment
    )> }, legendVariants: Array<(
    { __typename: 'FlightsSeatMapLegendVariant' }
    & FlightsSeatMapLegendVariantFragment
  )> };

export type FlightsSeatMapLegendVariantFragment = { __typename: 'FlightsSeatMapLegendVariant', title: string, legendCard: { __typename: 'FlightsSeatMapCellCard', text?: Maybe<string>, accessibilityMessage?: Maybe<string>, icon?: Maybe<(
      { __typename: 'Icon' }
      & IconInformationLoadedFragment
    )> } };

export type MultiItemFlightsSearchContextFragment = { __typename: 'MultiItemSearchContext', flights?: Maybe<Array<{ __typename: 'FlightSearchCriteria', primary: { __typename: 'PrimaryFlightCriteria', tripType: FlightsTripType, journeyCriterias: Array<{ __typename: 'FlightsJourneyCriteria', origin: string, destination: string, departureDate: { __typename: 'Date', day: number, month: number, year: number } }>, searchPreferences?: Maybe<{ __typename: 'FlightsSearchPreferences', advancedFilters?: Maybe<Array<FlightsAdvancedFilterType>>, airline?: Maybe<string>, cabinClass: FlightsCabinClass }>, travelers: Array<{ __typename: 'TravelerDetails', age?: Maybe<number>, type: TravelerDetailsType }> } }>> };

export type MultiItemFlightNaturalKeyFragment = { __typename: 'MultiItemSelectedFlightProducts', flights: Array<{ __typename: 'MultiItemSelectedFlightNaturalKey', offerToken: string, productTokens: Array<string>, travelers: Array<{ __typename: 'TravelerDetails', age?: Maybe<number>, type: TravelerDetailsType }> }> };

export type FlightsInformationJourneyAmenitiesFragment = { __typename: 'FlightsJourneyAmenities', accessibilityMessage: string, amenities: Array<(
    { __typename: 'FlightsIconAndLabel' }
    & FlightsIconAndLabelLoadedFragment
  )>, analytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsSelectedJourneyAvailableFaresFragment = { __typename: 'FlightsSelectedJourneyAvailableFares', openAccessibility: string, fareChoiceInformation: { __typename: 'FlightsFareChoiceInformation', accessibleHeading: string, message: string, nextFareChoiceAccessibilityMessage: string, previousFareChoiceAccessibilityMessage: string, tripTypePerTraveler: string, heading: (
      { __typename: 'FlightsResponsiveMessage' }
      & FlightsResponsiveMessageFragment
    ), displayAnalytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), scrollAnalytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), errorAnalytics?: Maybe<Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>>, convertAnalytics?: Maybe<Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>>, fares?: Maybe<Array<{ __typename: 'FlightsJourneyFare', name: string, cabinClass: string, cabinClassAndBookingCodes?: Maybe<Array<string>>, accessibilityMessage: string, safetyLocationAccessibilityMessage?: Maybe<string>, selectFareActionAltText?: Maybe<string>, journeyFareTotalPrice?: Maybe<string>, totalPrice: string, identifier: string, selected: boolean, upsellOfferToken: string, chooseFareAction: { __typename: 'FlightsAction', displayAction: string, accessibilityMessage?: Maybe<string>, type: FlightsActionType }, loyaltyPointsOption?: Maybe<(
        { __typename: 'FlightsLoyaltyPointsOption' }
        & FlightsLoyaltyPointsOptionFragment
      )>, formattedPrice: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, clickEventAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), fareScrollAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), collapsedRules: (
        { __typename: 'FlightsJourneyAmenities' }
        & FlightsInformationJourneyAmenitiesFragment
      ), expandedRules: Array<{ __typename: 'FlightsJourneyAmenitiesWithLabel', label: string, rules: (
          { __typename: 'FlightsJourneyAmenities' }
          & FlightsInformationJourneyAmenitiesFragment
        ) }>, amenityHierarchyRules?: Maybe<Array<{ __typename: 'FlightsJourneyAmenitiesWithLabel', label: string, rules: (
          { __typename: 'FlightsJourneyAmenities' }
          & FlightsInformationJourneyAmenitiesFragment
        ) }>>, baggageFeesInformation: (
        { __typename: 'FlightsBaggageInformation' }
        & FlightsBaggageInformationFragment
      ), showMoreAmenitiesToggle?: Maybe<(
        { __typename: 'FlightsToggle' }
        & FlightsToggleInformationLoadedFragment
      )>, selectFareAction: (
        { __typename: 'FlightsAction' }
        & FlightsActionInformationLoadedFragment
      ), recommendation?: Maybe<{ __typename: 'FlightsBadge', text?: Maybe<string>, type: FlightsBadgeTheme }>, amenityRules: { __typename: 'FlightsJourneyAmenityRules', itemsDefaultDisplayCount: number, amenities: Array<{ __typename: 'FlightsIconAndLabel', accessibility?: Maybe<string>, label: string, theme: TextTheme, icon: (
            { __typename: 'Icon' }
            & IconInformationLoadedFragment
          ), displayAnalytics?: Maybe<Array<(
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          )>> }> }, badges?: Maybe<Array<{ __typename: 'EGDSBadgeNotification', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSLoyaltyBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSProgramBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSStandardBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> }>>, priceLockup: { __typename: 'EGDSPriceLockup', accessibilityPrice: string, lockupPrice?: Maybe<string>, strikeThroughPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>> } } | { __typename: 'FlightsPMPJourneyFare', isPmpSelected: boolean, name: string, cabinClass: string, cabinClassAndBookingCodes?: Maybe<Array<string>>, accessibilityMessage: string, safetyLocationAccessibilityMessage?: Maybe<string>, selectFareActionAltText?: Maybe<string>, journeyFareTotalPrice?: Maybe<string>, totalPrice: string, identifier: string, selected: boolean, upsellOfferToken: string, priceLockupWithPMP: { __typename: 'EGDSPriceLockup', accessibilityPrice: string, lockupPrice?: Maybe<string>, strikeThroughPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>> }, selectFareActionWithPMP: (
        { __typename: 'FlightsAction' }
        & FlightsActionInformationLoadedFragment
      ), priceMatchPromiseSelectionCardSection?: Maybe<(
        { __typename: 'PriceMatchPromiseSelectionCardSection' }
        & PriceMatchPromiseSelectionCardFragmentFragment
      )>, priceMatchPromiseSelectedCardSection?: Maybe<(
        { __typename: 'PriceMatchPromiseSelectedCardSection' }
        & PriceMatchPromiseSelectedCardFragmentFragment
      )>, chooseFareAction: { __typename: 'FlightsAction', displayAction: string, accessibilityMessage?: Maybe<string>, type: FlightsActionType }, loyaltyPointsOption?: Maybe<(
        { __typename: 'FlightsLoyaltyPointsOption' }
        & FlightsLoyaltyPointsOptionFragment
      )>, formattedPrice: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, clickEventAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), fareScrollAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), collapsedRules: (
        { __typename: 'FlightsJourneyAmenities' }
        & FlightsInformationJourneyAmenitiesFragment
      ), expandedRules: Array<{ __typename: 'FlightsJourneyAmenitiesWithLabel', label: string, rules: (
          { __typename: 'FlightsJourneyAmenities' }
          & FlightsInformationJourneyAmenitiesFragment
        ) }>, amenityHierarchyRules?: Maybe<Array<{ __typename: 'FlightsJourneyAmenitiesWithLabel', label: string, rules: (
          { __typename: 'FlightsJourneyAmenities' }
          & FlightsInformationJourneyAmenitiesFragment
        ) }>>, baggageFeesInformation: (
        { __typename: 'FlightsBaggageInformation' }
        & FlightsBaggageInformationFragment
      ), showMoreAmenitiesToggle?: Maybe<(
        { __typename: 'FlightsToggle' }
        & FlightsToggleInformationLoadedFragment
      )>, selectFareAction: (
        { __typename: 'FlightsAction' }
        & FlightsActionInformationLoadedFragment
      ), recommendation?: Maybe<{ __typename: 'FlightsBadge', text?: Maybe<string>, type: FlightsBadgeTheme }>, amenityRules: { __typename: 'FlightsJourneyAmenityRules', itemsDefaultDisplayCount: number, amenities: Array<{ __typename: 'FlightsIconAndLabel', accessibility?: Maybe<string>, label: string, theme: TextTheme, icon: (
            { __typename: 'Icon' }
            & IconInformationLoadedFragment
          ), displayAnalytics?: Maybe<Array<(
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          )>> }> }, badges?: Maybe<Array<{ __typename: 'EGDSBadgeNotification', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSLoyaltyBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSProgramBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSStandardBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> }>>, priceLockup: { __typename: 'EGDSPriceLockup', accessibilityPrice: string, lockupPrice?: Maybe<string>, strikeThroughPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>> } }>>, defaultBaggageInformation: (
      { __typename: 'FlightsBaggageInformation' }
      & FlightsBaggageInformationFragment
    ), sustainabilityInformation?: Maybe<(
      { __typename: 'FlightsIconPhrases' }
      & FlightsIconLoadedPhrasesFragment
    )>, dialogs?: Maybe<Array<(
      { __typename: 'FlightsDialog' }
      & FaresDialogsFisFragment
    )>> }, dismissDetailedJourneyInformation: (
    { __typename: 'FlightsActionableIcon' }
    & FlightsActionableInformationIconLoadedFragment
  ), flightsJourneyHeaders: (
    { __typename: 'FlightsJourneyHeaders' }
    & FlightsJourneyHeadersFragment
  ) };

export type FlightsLoadedPriceSummaryFragment = { __typename: 'FlightsLoadedPriceSummary', title: string, tripTotalLabel: string, creditShoppingRedirectMessaging?: Maybe<string>, bookWithAirlinesDialog?: Maybe<(
    { __typename: 'BookWithAirlinesDialog' }
    & FlightsDialogPresentation_BookWithAirlinesDialog_Fragment
  )>, breakdown: Array<(
    { __typename: 'FlightsPriceSummaryGroup' }
    & FlightsPriceSummaryGroupLoadedFragment
  )>, buttonAction: (
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  ), dismiss: (
    { __typename: 'FlightsActionableIcon' }
    & FlightsActionableInformationIconLoadedFragment
  ), policies: (
    { __typename: 'FlightsTextSection' }
    & FlightsInformationTextSectionLoadedFragment
  ), totals?: Maybe<Array<(
    { __typename: 'FlightsPriceSummaryGroup' }
    & FlightsPriceSummaryGroupLoadedFragment
  )>>, tripTotalDetails: (
    { __typename: 'FlightsPriceSummaryTripTotalItem' }
    & FlightsLoadedPriceSummaryTripTotalItemFragment
  ), viewPriceSummary: (
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  ), creditShoppingRedirectAction?: Maybe<(
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  )>, urgencyMessage?: Maybe<(
    { __typename: 'EGDSBadgeNotification' }
    & EgdsBadgeFragment_EgdsBadgeNotification_Fragment
  ) | (
    { __typename: 'EGDSLoyaltyBadge' }
    & EgdsBadgeFragment_EgdsLoyaltyBadge_Fragment
  ) | (
    { __typename: 'EGDSProgramBadge' }
    & EgdsBadgeFragment_EgdsProgramBadge_Fragment
  ) | (
    { __typename: 'EGDSStandardBadge' }
    & EgdsBadgeFragment_EgdsStandardBadge_Fragment
  )>, displayAnalytics?: Maybe<Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )>> };

type EgdsBadgeFragment_EgdsBadgeNotification_Fragment = { __typename: 'EGDSBadgeNotification', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> };

type EgdsBadgeFragment_EgdsLoyaltyBadge_Fragment = { __typename: 'EGDSLoyaltyBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> };

type EgdsBadgeFragment_EgdsProgramBadge_Fragment = { __typename: 'EGDSProgramBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> };

type EgdsBadgeFragment_EgdsStandardBadge_Fragment = { __typename: 'EGDSStandardBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> };

export type EgdsBadgeFragmentFragment = EgdsBadgeFragment_EgdsBadgeNotification_Fragment | EgdsBadgeFragment_EgdsLoyaltyBadge_Fragment | EgdsBadgeFragment_EgdsProgramBadge_Fragment | EgdsBadgeFragment_EgdsStandardBadge_Fragment;

export type FlightsInformationServerErrorMessagingFragment = { __typename: 'FlightsActionableErrorMessaging', message: string, title: string, action: (
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  ), icon: (
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  ) };

export type FlightsMessageAndAccessibilityInformationLoadedFragment = { __typename: 'FlightsMessageAndAccessibility', text: string, accessibilityMessage: string };

export type FlightsLoyaltyPointsOptionFragment = { __typename: 'FlightsLoyaltyPointsOption', overageAmount?: Maybe<string>, strikeThroughFormattedPoints?: Maybe<string>, leadingCaption: string, formattedPoints: string, isPointsFirst: boolean, isStrikeThroughFirst: boolean, accessibility: string };

export type FlightsToggleInformationLoadedFragment = { __typename: 'FlightsToggle', expanded: boolean, collapseActionable: (
    { __typename: 'TogglePhase' }
    & TogglePhaseInformationLoadedFragment
  ), expandActionable: (
    { __typename: 'TogglePhase' }
    & TogglePhaseInformationLoadedFragment
  ) };

export type IconInformationLoadedFragment = { __typename: 'Icon', description: string, id: string, size?: Maybe<IconSize>, withBackground?: Maybe<boolean>, theme?: Maybe<IconTheme> };

export type TogglePhaseInformationLoadedFragment = { __typename: 'TogglePhase', accessibilityMessage?: Maybe<string>, action: string, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  )> };

export type CoordinateInformationInformationLoadedFragment = { __typename: 'CoordinateInformation', subtitle: string, icon: (
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  ), flightDetailsWarningInfo?: Maybe<{ __typename: 'FlightsIconAndLabel', label: string, theme: TextTheme, accessibility?: Maybe<string>, subLabel?: Maybe<string>, icon: (
      { __typename: 'Icon' }
      & IconInformationLoadedFragment
    ) }>, titleAndAccessibilityMessage: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string } };

export type FlightsMarkPlacardFragment = { __typename: 'FlightsMarkPlacard', heading?: Maybe<string>, message: string, displayType?: Maybe<FlightsPlacardDisplayType>, mark?: Maybe<{ __typename: 'Mark', description: string, id: string }>, stylisedText?: Maybe<(
    { __typename: 'EGDSSpannableText' }
    & EgdsSpannableTextFragmentInformationFragment
  )>, onViewedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsMarkPlacardInformationLoadedFragment = { __typename: 'FlightsMarkPlacard', heading?: Maybe<string>, message: string, displayType?: Maybe<FlightsPlacardDisplayType>, mark?: Maybe<{ __typename: 'Mark', description: string, id: string }>, actions?: Maybe<Array<(
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  )>>, onViewedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsImagePlacardInformationLoadedFragment = { __typename: 'FlightsImagePlacard', heading?: Maybe<string>, message: string, image: { __typename: 'Image', url: any, description: string }, actions?: Maybe<Array<(
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  )>>, onViewedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsIconPlacardInformationLoadedFragment = { __typename: 'FlightsIconPlacard', heading?: Maybe<string>, message: string, displayType?: Maybe<FlightsPlacardDisplayType>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  )>, actions?: Maybe<Array<(
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  )>>, onViewedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type EgdsSpannableTextFragmentInformationFragment = { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> } | { __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string, style: EgdsParagraphStyle } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } } | { __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, stylizedSize?: Maybe<string> } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<(
    { __typename: 'EGDSGraphicText' }
    & EgdsGraphicTextFragmentInformationFragment
  ) | { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } } | { __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, stylizedSize?: Maybe<string> }> };

export type MarkFragmentsFragment = { __typename: 'Mark', description: string, id: string, markSize?: Maybe<string>, url?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> };

export type FlightsActionInformationLoadedFragment = { __typename: 'FlightsAction', accessibilityMessage?: Maybe<string>, accessibilityCheckoutMessage?: Maybe<string>, displayAction: string, displayType: FlightsActionDisplayType, enable?: Maybe<boolean>, type: FlightsActionType, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), analyticsList: Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, relativePackageableURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }>, displayAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsPriceSummaryGroupLoadedFragment = { __typename: 'FlightsPriceSummaryGroup', accessibilityMessage?: Maybe<string>, entries: Array<(
    { __typename: 'FlightsPriceSummaryItem' }
    & FlightsPriceSummaryLoadedItemFragment
  )>, title?: Maybe<(
    { __typename: 'FlightsPriceSummaryItem' }
    & FlightsPriceSummaryLoadedItemFragment
  )> };

export type FlightsPriceSummaryItemDetailsLoadedFragment = { __typename: 'FlightsPriceSummaryItemDetails', action: (
    { __typename: 'FlightsActionableIcon' }
    & FlightsActionableInformationIconLoadedFragment
  ), breakdown: (
    { __typename: 'FlightsPriceSummaryItemGroup' }
    & FlightsPriceSummaryItemGroupLoadedFragment
  ) };

export type FlightsPriceSummaryItemGroupLoadedFragment = { __typename: 'FlightsPriceSummaryItemGroup', title: string, entries: Array<{ __typename: 'FlightsPriceSummaryItem', label: string, price: string }>, error?: Maybe<(
    { __typename: 'FlightsPriceSummaryItemError' }
    & FlightsPriceSummaryItemErrorLoadedFragment
  )>, action: (
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  ) };

export type FlightsPriceSummaryItemErrorLoadedFragment = { __typename: 'FlightsPriceSummaryItemError', message: string, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsPriceSummaryLoadedItemFragment = { __typename: 'FlightsPriceSummaryItem', label: string, price: string, roundedPrice?: Maybe<string>, loyaltyPoints?: Maybe<string>, details?: Maybe<(
    { __typename: 'FlightsPriceSummaryItemDetails' }
    & FlightsPriceSummaryItemDetailsLoadedFragment
  )> };

export type FlightsActionableInformationIconLoadedFragment = { __typename: 'FlightsActionableIcon', type: FlightsActionType, displayText?: Maybe<string>, accessibilityMessage?: Maybe<string>, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), icon: (
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  ) };

export type FlightsInformationTextSectionLoadedFragment = { __typename: 'FlightsTextSection', heading?: Maybe<string>, displayAction?: Maybe<(
    { __typename: 'FlightsToggle' }
    & FlightsToggleInformationLoadedFragment
  )>, messages: Array<(
    { __typename: 'FlightsPhrase' }
    & FlightsInformationLoadedPhraseFragment
  )>, onViewedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, displayAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, displayAnalyticsList?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type FlightsInformationLoadedPhraseFragment = { __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, link: any, icon?: Maybe<string>, text: string, styles: Array<FlightsPhrasePartStyle>, analytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), displayAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, scrollAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> };

export type FlightsLoadedPriceSummaryTripTotalItemFragment = { __typename: 'FlightsPriceSummaryTripTotalItem', ratesCurrencyMessage: string, ratesCurrencyText?: Maybe<string>, messages?: Maybe<Array<{ __typename: 'FlightsTextSection', heading?: Maybe<string>, messages: Array<{ __typename: 'FlightsPhrase', completeText: string, size?: Maybe<number> }> }>>, tripTotal: (
    { __typename: 'FlightsPriceSummaryItem' }
    & FlightsPriceSummaryLoadedItemFragment
  ) };

export type FlightsBaggageInformationFragment = { __typename: 'FlightsBaggageInformation', label: string, defaultBagSelectionMessage?: Maybe<string>, displayDetailsAction?: Maybe<string>, dismissAction?: Maybe<string>, bagFeesMoreInfo: Array<(
    { __typename: 'FlightsPhrase' }
    & FlightsInformationLoadedPhraseFragment
  )>, displayAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, details?: Maybe<Array<(
    { __typename: 'FlightBaggageInformationDetail' }
    & FlightsBaggageInformationDetailFragment
  )>>, displayAnalyticsItems?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type FlightsBaggageInformationDetailFragment = { __typename: 'FlightBaggageInformationDetail', topic: string, baggageDetail: string };

export type JourneyInformationFragment = { __typename: 'JourneyInformation', destinationAirportCode: string, originAirportCode: string, tripType: string };

type FlightsDialogPresentation_BookWithAirlinesDialog_Fragment = { __typename: 'BookWithAirlinesDialog', message?: Maybe<string>, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, type: FlightsActionType, analyticsList: Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }>, displayedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

type FlightsDialogPresentation_FlightsDialogChangeFlight_Fragment = { __typename: 'FlightsDialogChangeFlight', message?: Maybe<string>, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, type: FlightsActionType, analyticsList: Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }>, displayedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

type FlightsDialogPresentation_FlightsDialogMultiPassengerCredit_Fragment = { __typename: 'FlightsDialogMultiPassengerCredit', message: string, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, type: FlightsActionType, analyticsList: Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }>, displayedAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

type FlightsDialogPresentation_FlightsDialogServerError_Fragment = { __typename: 'FlightsDialogServerError', message?: Maybe<string>, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, type: FlightsActionType, analyticsList: Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }>, displayedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

type FlightsDialogPresentation_FlightsDialogStaleSession_Fragment = { __typename: 'FlightsDialogStaleSession', message?: Maybe<string>, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, type: FlightsActionType, analyticsList: Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }>, displayedAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

type FlightsDialogPresentation_FlightsDialogStandard_Fragment = { __typename: 'FlightsDialogStandard', message?: Maybe<string>, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, type: FlightsActionType, analyticsList: Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }>, displayedAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

type FlightsDialogPresentation_FlightsForcedChoiceCrossSellDialog_Fragment = { __typename: 'FlightsForcedChoiceCrossSellDialog', message?: Maybe<string>, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, type: FlightsActionType, analyticsList: Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }>, displayedAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsDialogPresentationFragment = FlightsDialogPresentation_BookWithAirlinesDialog_Fragment | FlightsDialogPresentation_FlightsDialogChangeFlight_Fragment | FlightsDialogPresentation_FlightsDialogMultiPassengerCredit_Fragment | FlightsDialogPresentation_FlightsDialogServerError_Fragment | FlightsDialogPresentation_FlightsDialogStaleSession_Fragment | FlightsDialogPresentation_FlightsDialogStandard_Fragment | FlightsDialogPresentation_FlightsForcedChoiceCrossSellDialog_Fragment;

export type FlightsIconLoadedPhrasesFragment = { __typename: 'FlightsIconPhrases', text: Array<(
    { __typename: 'FlightsPhrase' }
    & FlightsInformationLoadedPhraseFragment
  )>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  )> };

export type FlightsIconAndLabelLoadedFragment = { __typename: 'FlightsIconAndLabel', label: string, subLabel?: Maybe<string>, accessibility?: Maybe<string>, value?: Maybe<string>, theme: TextTheme, icon: (
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  ), displayAnalytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>>, subText?: Maybe<{ __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, size?: Maybe<string> }> };

export type FlightsMessagingCardFisPlacardFragmentFragment = { __typename: 'FlightsMessagingCardPlacard', messagingCard: { __typename: 'UIMessagingCard', primary?: Maybe<string>, secondaries?: Maybe<Array<string>>, graphic?: Maybe<{ __typename: 'Icon' } | (
      { __typename: 'Illustration' }
      & EgdsGraphicIllustrationFragmentFragment
    ) | { __typename: 'Mark' }> }, button?: Maybe<(
    { __typename: 'FlightsActionButton' }
    & FlightsActionButtonFragmentFragment
  )>, onViewedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsDialogTriggerActionFisFragment = { __typename: 'FlightsDialogTriggerAction', dialog: { __typename: 'AdditionalInformationPopoverDialogSection' } | { __typename: 'ClientSideErrorRepresentationDialog' } | (
    { __typename: 'EGDSActionDialog' }
    & EgdsActionDialogFragmentFragment
  ) | { __typename: 'EGDSFullScreenDialog' } | { __typename: 'EGDSLoaderDialog' } | { __typename: 'PriceInsightsExistingTrackingDialogAction' } | { __typename: 'PriceInsightsTrackingRetryDialogAction' } | { __typename: 'ServicingDialog' }, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )>, dialogContents: Array<{ __typename: 'ActivitySearchForm' } | { __typename: 'AgencyUIPrimaryFloatingActionButton' } | { __typename: 'AgencyUISecondaryFloatingActionButton' } | { __typename: 'CarSearchForm' } | { __typename: 'CruiseSearchForm' } | { __typename: 'DurationSpanSelector' } | { __typename: 'EGDSBadgeNotification' } | { __typename: 'EGDSBasicCheckBox' } | { __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSBasicOption' } | { __typename: 'EGDSBasicSelect' } | { __typename: 'EGDSBasicStepInput' } | { __typename: 'EGDSBasicTab' } | { __typename: 'EGDSBasicTabs' } | { __typename: 'EGDSBasicTravelerSelector' } | { __typename: 'EGDSBulletedList' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSComposableTextElementSectionContainer' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSEmailInputField' } | { __typename: 'EGDSErrorSummary' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSImageLink' } | { __typename: 'EGDSImageLinkCard' } | { __typename: 'EGDSInfantSeatRadioButton' } | { __typename: 'EGDSLinkList' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSLoyaltyBadge' } | { __typename: 'EGDSNumberInputField' } | { __typename: 'EGDSOrderedList' } | { __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPasswordInputField' } | { __typename: 'EGDSProgramBadge' } | { __typename: 'EGDSRoomsTravelerSelector' } | { __typename: 'EGDSSearchFormButton' } | { __typename: 'EGDSSearchFormDatePickerField' } | { __typename: 'EGDSSearchFormInputField' } | { __typename: 'EGDSSearchFormLocationField' } | { __typename: 'EGDSSearchFormLocationsField' } | { __typename: 'EGDSSearchFormTravelersField' } | { __typename: 'EGDSSectionContainer' } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardBadge' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStandardMessagingCard' } | { __typename: 'EGDSTextAreaInputField' } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconList' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextInputField' } | { __typename: 'EGDSTextListSection' } | { __typename: 'EGDSTextSection' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' } | { __typename: 'EGDSToast' } | { __typename: 'EGDSTravelerChildAgeSelect' } | { __typename: 'EGDSTravelerInfantSeatSelection' } | { __typename: 'EGDSTravelerStepInput' } | { __typename: 'EGDSTypeaheadInputField' } | { __typename: 'EGDSUnorderedList' } | { __typename: 'FlightSearchForm' } | { __typename: 'FlightSearchInputForm' } | { __typename: 'FlightsActionButton' } | { __typename: 'FlightsActionCheckbox' } | { __typename: 'FlightsActionLink' } | { __typename: 'FlightsDialogTrigger' } | { __typename: 'IdentityBasicBlock' } | { __typename: 'IdentityButton' } | { __typename: 'IdentityConsentNestedCheckBox' } | { __typename: 'IdentityImage' } | { __typename: 'IdentityImageGallery' } | { __typename: 'IdentityInfoLinkComponent' } | { __typename: 'IdentityPasswordStrengthComponent' } | { __typename: 'IdentityResendButton' } | { __typename: 'IdentitySingleColumnComponentLayout' } | { __typename: 'IdentitySocialButton' } | { __typename: 'IdentityText' } | { __typename: 'Illustration' } | { __typename: 'LodgingSearchForm' } | { __typename: 'PackagesSearchForm' } | { __typename: 'ProductSummaryCard' } | { __typename: 'ProfileAccountLink' } | { __typename: 'ProfileActionButtonCard' } | { __typename: 'ProfileBulletedList' } | { __typename: 'ProfileEGDSSectionContainer' } | { __typename: 'ProfileFormHorizontalContainer' } | { __typename: 'ProfileFormSection' } | { __typename: 'ProfileLink' } | { __typename: 'ProfileNumberField' } | { __typename: 'ProfilePhoneNumberField' } | { __typename: 'ProfileRadioButton' } | { __typename: 'ProfileRadioButtonGroup' } | { __typename: 'ProfileSelectField' } | { __typename: 'ProfileSlimCard' } | { __typename: 'ProfileSwitchOption' } | { __typename: 'ProfileTextField' } | { __typename: 'SearchFormDurationSpanField' } | { __typename: 'TripsMediaGallery' } | { __typename: 'TripsValidatedInput' } | { __typename: 'UIBanner' } | { __typename: 'UIEmptyState' } | { __typename: 'UIMessagingCard' } | { __typename: 'UIPrimaryButton' } | { __typename: 'UIPrimaryFloatingActionButton' } | { __typename: 'UISecondaryButton' } | { __typename: 'UISecondaryFloatingActionButton' } | { __typename: 'UITertiaryButton' }> };

export type EgdsActionDialogFragmentFragment = { __typename: 'EGDSActionDialog', footer: (
    { __typename: 'EGDSInlineDialogFooter' }
    & EgdsActionDialogFooter_EgdsInlineDialogFooter_Fragment
  ) | (
    { __typename: 'EGDSStackedDialogFooter' }
    & EgdsActionDialogFooter_EgdsStackedDialogFooter_Fragment
  ) };

type EgdsActionDialogFooter_EgdsInlineDialogFooter_Fragment = { __typename: 'EGDSInlineDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSSearchFormButton' } | { __typename: 'FlightsActionButton', style: EgdsButtonStyle, primary?: Maybe<string>, clientAction: { __typename: 'FlightsAncillaryContinueAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsBookingAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsBoundNavigation', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsClickAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsCreditClearAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsCreditSelectionAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsCreditSelectorOpenAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsDialogCloseAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsDialogTriggerAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsFareTypeSelectionAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsLegDropdownItemSelection', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsLoadAncillariesAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsNavigateToDetails', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsRedirectOrDialog', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsRefreshAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsRemovePriceMatchPromiseAction', journeyContinuationId: string, analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsResourceLinkAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsResourceRedirectAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsSearchCriteriaChangeAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsSelectionAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsSwitchToggleAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'InsuranceSwitchToggleAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'MultiItemSelectPackage', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'MultiItemSelectProducts', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } } | { __typename: 'FlightsDialogTrigger' } | { __typename: 'FlightsExperienceActionButton' } | { __typename: 'FlightsSmartShoppingActionButton' } | { __typename: 'PackageUIActionDialogFooterButton' } | { __typename: 'PackageUIHideSearchFormAction' } | { __typename: 'PackageUITravelGuideButton' } | { __typename: 'ServicingButton' } | { __typename: 'SupplyCancelWaiverActionButton' } | { __typename: 'SupplyContentLinkStyleButton' } | { __typename: 'UIPrimaryButton' } | { __typename: 'UISecondaryButton' } | (
    { __typename: 'UITertiaryButton' }
    & UiTertiaryButtonFragmentFragment
  )> };

type EgdsActionDialogFooter_EgdsStackedDialogFooter_Fragment = { __typename: 'EGDSStackedDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSSearchFormButton' } | { __typename: 'FlightsActionButton', style: EgdsButtonStyle, primary?: Maybe<string>, clientAction: { __typename: 'FlightsAncillaryContinueAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsBookingAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsBoundNavigation', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsClickAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsCreditClearAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsCreditSelectionAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsCreditSelectorOpenAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsDialogCloseAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsDialogTriggerAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsFareTypeSelectionAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsLegDropdownItemSelection', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsLoadAncillariesAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsNavigateToDetails', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsRedirectOrDialog', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsRefreshAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsRemovePriceMatchPromiseAction', journeyContinuationId: string, analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsResourceLinkAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsResourceRedirectAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsSearchCriteriaChangeAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsSelectionAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'FlightsSwitchToggleAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'InsuranceSwitchToggleAction', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'MultiItemSelectPackage', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } | { __typename: 'MultiItemSelectProducts', analyticsList: Array<(
        { __typename: 'ClientSideAnalytics' }
        & ClientAnalyticsFragment
      )> } } | { __typename: 'FlightsDialogTrigger' } | { __typename: 'FlightsExperienceActionButton' } | { __typename: 'FlightsSmartShoppingActionButton' } | { __typename: 'PackageUIActionDialogFooterButton' } | { __typename: 'PackageUIHideSearchFormAction' } | { __typename: 'PackageUITravelGuideButton' } | { __typename: 'ServicingButton' } | { __typename: 'SupplyCancelWaiverActionButton' } | { __typename: 'SupplyContentLinkStyleButton' } | { __typename: 'UIPrimaryButton' } | { __typename: 'UISecondaryButton' } | (
    { __typename: 'UITertiaryButton' }
    & UiTertiaryButtonFragmentFragment
  )> };

export type EgdsActionDialogFooterFragment = EgdsActionDialogFooter_EgdsInlineDialogFooter_Fragment | EgdsActionDialogFooter_EgdsStackedDialogFooter_Fragment;

export type FlightsActionButtonFragmentFragment = { __typename: 'FlightsActionButton', accessibility?: Maybe<string>, disabled: boolean, egdsElementId?: Maybe<string>, primary?: Maybe<string>, style: EgdsButtonStyle, clientAction: { __typename: 'FlightsAncillaryContinueAction' } | { __typename: 'FlightsBookingAction' } | { __typename: 'FlightsBoundNavigation' } | { __typename: 'FlightsClickAction' } | { __typename: 'FlightsCreditClearAction' } | { __typename: 'FlightsCreditSelectionAction' } | { __typename: 'FlightsCreditSelectorOpenAction' } | { __typename: 'FlightsDialogCloseAction' } | (
    { __typename: 'FlightsDialogTriggerAction' }
    & FlightsDialogTriggerActionFisFragment
  ) | { __typename: 'FlightsFareTypeSelectionAction' } | { __typename: 'FlightsLegDropdownItemSelection' } | { __typename: 'FlightsLoadAncillariesAction' } | { __typename: 'FlightsNavigateToDetails' } | { __typename: 'FlightsRedirectOrDialog' } | { __typename: 'FlightsRefreshAction' } | { __typename: 'FlightsRemovePriceMatchPromiseAction' } | { __typename: 'FlightsResourceLinkAction' } | { __typename: 'FlightsResourceRedirectAction' } | { __typename: 'FlightsSearchCriteriaChangeAction' } | { __typename: 'FlightsSelectionAction' } | { __typename: 'FlightsSwitchToggleAction' } | { __typename: 'InsuranceSwitchToggleAction' } | { __typename: 'MultiItemSelectPackage' } | { __typename: 'MultiItemSelectProducts' }, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  )>, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ActivityCloseDialogAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ActivityMultiItemTripUpdateAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ActivityOpenDialogAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ActivityOpenOffersModalAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ActivityPaginationAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ActivityRemoveOffersFromTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ActivityUpdateOfferInTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'AgencyQuoteAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'AirCreditWebAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CDFOpenFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CDFOpenNextPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CDFSubmitFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CouponAndCreditAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CouponAndCreditChatbotAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CouponsAndCreditsSimpleAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CrossSellButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CrossSellLinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'CruiseAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'DirectFeedbackOpenFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'DirectFeedbackOpenNextPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'DirectFeedbackOpenPreviousPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'DirectFeedbackSubmitFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'EGDSOpenDatePickerAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'EGDSOpenTravelerSelectorAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'EGDSSubmitSearchFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'FlightsCreditSelectorOpenUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'FlightsDialogCloseUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'FlightsDialogTriggerUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'GroundTransfersBookAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'GroundTransfersDetailsOpenAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'GroundTransfersDismissAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'GroundTransfersLinkClickAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'GroundTransfersMultiItemTripUpdateAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'GroundTransfersSelectionClickAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'MemberWalletBadge', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'MemberWalletUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'MishopDetailsUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'MultiItemCrossSellUIButtonAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'MultiItemCrossSellUILinkAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'OpenTypeaheadAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'PaymentDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'PaymentDialogElement', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'PriceInsightsExistingDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileAccountFormSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileAddMembershipAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileAddPassportAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileFormSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileLinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileReloadAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileRewardProgramFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileUpdateMembershipAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ProfileUpdatePassportAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'QuoteAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'ShoppingSortAndFilterAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'SupplyNavigationHeaderSearchTrigger', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'TripsRetryOperationAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'UIFlightAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'UILinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'WizardAdditionalUserInputRequiredAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'WizardSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) }> };

export type EgdsGraphicIllustrationFragmentFragment = { __typename: 'Illustration', id: string, description: string, link: any };

export type UiTertiaryButtonFragmentFragment = { __typename: 'UITertiaryButton', disabled: boolean, primary?: Maybe<string>, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction' } | { __typename: 'ActivityCloseDialogAction' } | { __typename: 'ActivityMultiItemTripUpdateAction' } | { __typename: 'ActivityOpenDialogAction' } | { __typename: 'ActivityOpenOffersModalAction' } | { __typename: 'ActivityPaginationAction' } | { __typename: 'ActivityRemoveOffersFromTripAction' } | { __typename: 'ActivityUpdateOfferInTripAction' } | { __typename: 'AgencyQuoteAction' } | { __typename: 'AirCreditWebAction' } | { __typename: 'CDFOpenFormAction' } | { __typename: 'CDFOpenNextPageAction' } | { __typename: 'CDFSubmitFormAction' } | { __typename: 'CouponAndCreditAction' } | { __typename: 'CouponAndCreditChatbotAction' } | { __typename: 'CouponsAndCreditsSimpleAction' } | { __typename: 'CrossSellButtonAction' } | { __typename: 'CrossSellLinkAction' } | { __typename: 'CruiseAction' } | { __typename: 'DirectFeedbackOpenFormAction' } | { __typename: 'DirectFeedbackOpenNextPageAction' } | { __typename: 'DirectFeedbackOpenPreviousPageAction' } | { __typename: 'DirectFeedbackSubmitFormAction' } | { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'FlightsCreditSelectorOpenUIAction' } | { __typename: 'FlightsDialogCloseUIAction' } | { __typename: 'FlightsDialogTriggerUIAction' } | { __typename: 'GroundTransfersBookAction' } | { __typename: 'GroundTransfersDetailsOpenAction' } | { __typename: 'GroundTransfersDismissAction' } | { __typename: 'GroundTransfersLinkClickAction' } | { __typename: 'GroundTransfersMultiItemTripUpdateAction' } | { __typename: 'GroundTransfersSelectionClickAction' } | { __typename: 'MemberWalletBadge' } | { __typename: 'MemberWalletUIAction' } | { __typename: 'MishopDetailsUIAction' } | { __typename: 'MultiItemCrossSellUIButtonAction' } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' } | { __typename: 'MultiItemCrossSellUILinkAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'PaymentDialogButtonAction' } | { __typename: 'PaymentDialogElement' } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' } | { __typename: 'PriceInsightsExistingDialogButtonAction' } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' } | { __typename: 'ProfileAccountFormSubmitAction' } | { __typename: 'ProfileAddMembershipAction' } | { __typename: 'ProfileAddPassportAction' } | { __typename: 'ProfileFormSubmitAction' } | { __typename: 'ProfileLinkAction' } | { __typename: 'ProfileReloadAction' } | { __typename: 'ProfileRewardProgramFormAction' } | { __typename: 'ProfileUpdateMembershipAction' } | { __typename: 'ProfileUpdatePassportAction' } | { __typename: 'QuoteAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'SupplyNavigationHeaderSearchTrigger' } | { __typename: 'TripsRetryOperationAction' } | { __typename: 'UIFlightAction', analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } | { __typename: 'UILinkAction' } | { __typename: 'WizardAdditionalUserInputRequiredAction' } | { __typename: 'WizardSubmitAction' }> };

export type FlightsDialogTriggerFisFragment = { __typename: 'FlightsDialogTrigger', dialogAction: FlightsDialogAction, dialogId: FlightsDialogId, trigger: (
    { __typename: 'FlightsActionButton' }
    & FlightsActionButtonFragmentFragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & FlightsActionLinkFisFragment
  ) | { __typename: 'FlightsExperienceActionButton' } | { __typename: 'FlightsExperienceActionLink' } };

export type FaresDialogsFisFragment = { __typename: 'FlightsDialog', dialogId: FlightsDialogId, dialog: (
    { __typename: 'AdditionalInformationPopoverDialogSection' }
    & EgdsDialogFis_AdditionalInformationPopoverDialogSection_Fragment
  ) | (
    { __typename: 'ClientSideErrorRepresentationDialog' }
    & EgdsDialogFis_ClientSideErrorRepresentationDialog_Fragment
  ) | (
    { __typename: 'EGDSActionDialog' }
    & EgdsDialogFis_EgdsActionDialog_Fragment
  ) | (
    { __typename: 'EGDSFullScreenDialog' }
    & EgdsDialogFis_EgdsFullScreenDialog_Fragment
  ) | (
    { __typename: 'EGDSLoaderDialog' }
    & EgdsDialogFis_EgdsLoaderDialog_Fragment
  ) | (
    { __typename: 'PriceInsightsExistingTrackingDialogAction' }
    & EgdsDialogFis_PriceInsightsExistingTrackingDialogAction_Fragment
  ) | (
    { __typename: 'PriceInsightsTrackingRetryDialogAction' }
    & EgdsDialogFis_PriceInsightsTrackingRetryDialogAction_Fragment
  ) | (
    { __typename: 'ServicingDialog' }
    & EgdsDialogFis_ServicingDialog_Fragment
  ), dialogContent?: Maybe<Array<(
    { __typename: 'ActivitySearchForm' }
    & EgdsElementFragmentFis_ActivitySearchForm_Fragment
  ) | (
    { __typename: 'AgencyUIPrimaryFloatingActionButton' }
    & EgdsElementFragmentFis_AgencyUiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'AgencyUISecondaryFloatingActionButton' }
    & EgdsElementFragmentFis_AgencyUiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'CarSearchForm' }
    & EgdsElementFragmentFis_CarSearchForm_Fragment
  ) | (
    { __typename: 'CruiseSearchForm' }
    & EgdsElementFragmentFis_CruiseSearchForm_Fragment
  ) | (
    { __typename: 'DurationSpanSelector' }
    & EgdsElementFragmentFis_DurationSpanSelector_Fragment
  ) | (
    { __typename: 'EGDSBadgeNotification' }
    & EgdsElementFragmentFis_EgdsBadgeNotification_Fragment
  ) | (
    { __typename: 'EGDSBasicCheckBox' }
    & EgdsElementFragmentFis_EgdsBasicCheckBox_Fragment
  ) | (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsElementFragmentFis_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSBasicOption' }
    & EgdsElementFragmentFis_EgdsBasicOption_Fragment
  ) | (
    { __typename: 'EGDSBasicSelect' }
    & EgdsElementFragmentFis_EgdsBasicSelect_Fragment
  ) | (
    { __typename: 'EGDSBasicStepInput' }
    & EgdsElementFragmentFis_EgdsBasicStepInput_Fragment
  ) | (
    { __typename: 'EGDSBasicTab' }
    & EgdsElementFragmentFis_EgdsBasicTab_Fragment
  ) | (
    { __typename: 'EGDSBasicTabs' }
    & EgdsElementFragmentFis_EgdsBasicTabs_Fragment
  ) | (
    { __typename: 'EGDSBasicTravelerSelector' }
    & EgdsElementFragmentFis_EgdsBasicTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSBulletedList' }
    & EgdsElementFragmentFis_EgdsBulletedList_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsElementFragmentFis_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSComposableTextElementSectionContainer' }
    & EgdsElementFragmentFis_EgdsComposableTextElementSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsElementFragmentFis_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSEmailInputField' }
    & EgdsElementFragmentFis_EgdsEmailInputField_Fragment
  ) | (
    { __typename: 'EGDSErrorSummary' }
    & EgdsElementFragmentFis_EgdsErrorSummary_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsElementFragmentFis_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSImageLink' }
    & EgdsElementFragmentFis_EgdsImageLink_Fragment
  ) | (
    { __typename: 'EGDSImageLinkCard' }
    & EgdsElementFragmentFis_EgdsImageLinkCard_Fragment
  ) | (
    { __typename: 'EGDSInfantSeatRadioButton' }
    & EgdsElementFragmentFis_EgdsInfantSeatRadioButton_Fragment
  ) | (
    { __typename: 'EGDSLinkList' }
    & EgdsElementFragmentFis_EgdsLinkList_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsElementFragmentFis_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSLoyaltyBadge' }
    & EgdsElementFragmentFis_EgdsLoyaltyBadge_Fragment
  ) | (
    { __typename: 'EGDSNumberInputField' }
    & EgdsElementFragmentFis_EgdsNumberInputField_Fragment
  ) | (
    { __typename: 'EGDSOrderedList' }
    & EgdsElementFragmentFis_EgdsOrderedList_Fragment
  ) | (
    { __typename: 'EGDSOverlayButton' }
    & EgdsElementFragmentFis_EgdsOverlayButton_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsElementFragmentFis_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPasswordInputField' }
    & EgdsElementFragmentFis_EgdsPasswordInputField_Fragment
  ) | (
    { __typename: 'EGDSProgramBadge' }
    & EgdsElementFragmentFis_EgdsProgramBadge_Fragment
  ) | (
    { __typename: 'EGDSRoomsTravelerSelector' }
    & EgdsElementFragmentFis_EgdsRoomsTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSSearchFormButton' }
    & EgdsElementFragmentFis_EgdsSearchFormButton_Fragment
  ) | (
    { __typename: 'EGDSSearchFormDatePickerField' }
    & EgdsElementFragmentFis_EgdsSearchFormDatePickerField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormInputField' }
    & EgdsElementFragmentFis_EgdsSearchFormInputField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationField' }
    & EgdsElementFragmentFis_EgdsSearchFormLocationField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationsField' }
    & EgdsElementFragmentFis_EgdsSearchFormLocationsField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormTravelersField' }
    & EgdsElementFragmentFis_EgdsSearchFormTravelersField_Fragment
  ) | (
    { __typename: 'EGDSSectionContainer' }
    & EgdsElementFragmentFis_EgdsSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsElementFragmentFis_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardBadge' }
    & EgdsElementFragmentFis_EgdsStandardBadge_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsElementFragmentFis_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStandardMessagingCard' }
    & EgdsElementFragmentFis_EgdsStandardMessagingCard_Fragment
  ) | (
    { __typename: 'EGDSTextAreaInputField' }
    & EgdsElementFragmentFis_EgdsTextAreaInputField_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsElementFragmentFis_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconList' }
    & EgdsElementFragmentFis_EgdsTextIconList_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsElementFragmentFis_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextInputField' }
    & EgdsElementFragmentFis_EgdsTextInputField_Fragment
  ) | (
    { __typename: 'EGDSTextListSection' }
    & EgdsElementFragmentFis_EgdsTextListSection_Fragment
  ) | (
    { __typename: 'EGDSTextSection' }
    & EgdsElementFragmentFis_EgdsTextSection_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsElementFragmentFis_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsElementFragmentFis_EgdsTextWithMarkListItem_Fragment
  ) | (
    { __typename: 'EGDSToast' }
    & EgdsElementFragmentFis_EgdsToast_Fragment
  ) | (
    { __typename: 'EGDSTravelerChildAgeSelect' }
    & EgdsElementFragmentFis_EgdsTravelerChildAgeSelect_Fragment
  ) | (
    { __typename: 'EGDSTravelerInfantSeatSelection' }
    & EgdsElementFragmentFis_EgdsTravelerInfantSeatSelection_Fragment
  ) | (
    { __typename: 'EGDSTravelerStepInput' }
    & EgdsElementFragmentFis_EgdsTravelerStepInput_Fragment
  ) | (
    { __typename: 'EGDSTypeaheadInputField' }
    & EgdsElementFragmentFis_EgdsTypeaheadInputField_Fragment
  ) | (
    { __typename: 'EGDSUnorderedList' }
    & EgdsElementFragmentFis_EgdsUnorderedList_Fragment
  ) | (
    { __typename: 'FlightSearchForm' }
    & EgdsElementFragmentFis_FlightSearchForm_Fragment
  ) | (
    { __typename: 'FlightSearchInputForm' }
    & EgdsElementFragmentFis_FlightSearchInputForm_Fragment
  ) | (
    { __typename: 'FlightsActionButton' }
    & EgdsElementFragmentFis_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsActionCheckbox' }
    & EgdsElementFragmentFis_FlightsActionCheckbox_Fragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & EgdsElementFragmentFis_FlightsActionLink_Fragment
  ) | (
    { __typename: 'FlightsDialogTrigger' }
    & FlightsDialogTriggerFisFragment
    & EgdsElementFragmentFis_FlightsDialogTrigger_Fragment
  ) | (
    { __typename: 'IdentityBasicBlock' }
    & EgdsElementFragmentFis_IdentityBasicBlock_Fragment
  ) | (
    { __typename: 'IdentityButton' }
    & EgdsElementFragmentFis_IdentityButton_Fragment
  ) | (
    { __typename: 'IdentityConsentNestedCheckBox' }
    & EgdsElementFragmentFis_IdentityConsentNestedCheckBox_Fragment
  ) | (
    { __typename: 'IdentityImage' }
    & EgdsElementFragmentFis_IdentityImage_Fragment
  ) | (
    { __typename: 'IdentityImageGallery' }
    & EgdsElementFragmentFis_IdentityImageGallery_Fragment
  ) | (
    { __typename: 'IdentityInfoLinkComponent' }
    & EgdsElementFragmentFis_IdentityInfoLinkComponent_Fragment
  ) | (
    { __typename: 'IdentityPasswordStrengthComponent' }
    & EgdsElementFragmentFis_IdentityPasswordStrengthComponent_Fragment
  ) | (
    { __typename: 'IdentityResendButton' }
    & EgdsElementFragmentFis_IdentityResendButton_Fragment
  ) | (
    { __typename: 'IdentitySingleColumnComponentLayout' }
    & EgdsElementFragmentFis_IdentitySingleColumnComponentLayout_Fragment
  ) | (
    { __typename: 'IdentitySocialButton' }
    & EgdsElementFragmentFis_IdentitySocialButton_Fragment
  ) | (
    { __typename: 'IdentityText' }
    & EgdsElementFragmentFis_IdentityText_Fragment
  ) | (
    { __typename: 'Illustration' }
    & EgdsElementFragmentFis_Illustration_Fragment
  ) | (
    { __typename: 'LodgingSearchForm' }
    & EgdsElementFragmentFis_LodgingSearchForm_Fragment
  ) | (
    { __typename: 'PackagesSearchForm' }
    & EgdsElementFragmentFis_PackagesSearchForm_Fragment
  ) | (
    { __typename: 'ProductSummaryCard' }
    & EgdsElementFragmentFis_ProductSummaryCard_Fragment
  ) | (
    { __typename: 'ProfileAccountLink' }
    & EgdsElementFragmentFis_ProfileAccountLink_Fragment
  ) | (
    { __typename: 'ProfileActionButtonCard' }
    & EgdsElementFragmentFis_ProfileActionButtonCard_Fragment
  ) | (
    { __typename: 'ProfileBulletedList' }
    & EgdsElementFragmentFis_ProfileBulletedList_Fragment
  ) | (
    { __typename: 'ProfileEGDSSectionContainer' }
    & EgdsElementFragmentFis_ProfileEgdsSectionContainer_Fragment
  ) | (
    { __typename: 'ProfileFormHorizontalContainer' }
    & EgdsElementFragmentFis_ProfileFormHorizontalContainer_Fragment
  ) | (
    { __typename: 'ProfileFormSection' }
    & EgdsElementFragmentFis_ProfileFormSection_Fragment
  ) | (
    { __typename: 'ProfileLink' }
    & EgdsElementFragmentFis_ProfileLink_Fragment
  ) | (
    { __typename: 'ProfileNumberField' }
    & EgdsElementFragmentFis_ProfileNumberField_Fragment
  ) | (
    { __typename: 'ProfilePhoneNumberField' }
    & EgdsElementFragmentFis_ProfilePhoneNumberField_Fragment
  ) | (
    { __typename: 'ProfileRadioButton' }
    & EgdsElementFragmentFis_ProfileRadioButton_Fragment
  ) | (
    { __typename: 'ProfileRadioButtonGroup' }
    & EgdsElementFragmentFis_ProfileRadioButtonGroup_Fragment
  ) | (
    { __typename: 'ProfileSelectField' }
    & EgdsElementFragmentFis_ProfileSelectField_Fragment
  ) | (
    { __typename: 'ProfileSlimCard' }
    & EgdsElementFragmentFis_ProfileSlimCard_Fragment
  ) | (
    { __typename: 'ProfileSwitchOption' }
    & EgdsElementFragmentFis_ProfileSwitchOption_Fragment
  ) | (
    { __typename: 'ProfileTextField' }
    & EgdsElementFragmentFis_ProfileTextField_Fragment
  ) | (
    { __typename: 'SearchFormDurationSpanField' }
    & EgdsElementFragmentFis_SearchFormDurationSpanField_Fragment
  ) | (
    { __typename: 'TripsMediaGallery' }
    & EgdsElementFragmentFis_TripsMediaGallery_Fragment
  ) | (
    { __typename: 'TripsValidatedInput' }
    & EgdsElementFragmentFis_TripsValidatedInput_Fragment
  ) | (
    { __typename: 'UIBanner' }
    & EgdsElementFragmentFis_UiBanner_Fragment
  ) | (
    { __typename: 'UIEmptyState' }
    & EgdsElementFragmentFis_UiEmptyState_Fragment
  ) | (
    { __typename: 'UIMessagingCard' }
    & EgdsElementFragmentFis_UiMessagingCard_Fragment
  ) | (
    { __typename: 'UIPrimaryButton' }
    & EgdsElementFragmentFis_UiPrimaryButton_Fragment
  ) | (
    { __typename: 'UIPrimaryFloatingActionButton' }
    & EgdsElementFragmentFis_UiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UISecondaryButton' }
    & EgdsElementFragmentFis_UiSecondaryButton_Fragment
  ) | (
    { __typename: 'UISecondaryFloatingActionButton' }
    & EgdsElementFragmentFis_UiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UITertiaryButton' }
    & EgdsElementFragmentFis_UiTertiaryButton_Fragment
  )>> };

type EgdsDialogFis_AdditionalInformationPopoverDialogSection_Fragment = { __typename: 'AdditionalInformationPopoverDialogSection', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type EgdsDialogFis_ClientSideErrorRepresentationDialog_Fragment = { __typename: 'ClientSideErrorRepresentationDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type EgdsDialogFis_EgdsActionDialog_Fragment = { __typename: 'EGDSActionDialog', footer: { __typename: 'EGDSInlineDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSSearchFormButton' } | (
      { __typename: 'FlightsActionButton' }
      & FlightsActionButtonFragmentFragment
    ) | (
      { __typename: 'FlightsDialogTrigger' }
      & FlightsDialogTriggerFisFragment
    ) | { __typename: 'FlightsExperienceActionButton' } | { __typename: 'FlightsSmartShoppingActionButton' } | { __typename: 'PackageUIActionDialogFooterButton' } | { __typename: 'PackageUIHideSearchFormAction' } | { __typename: 'PackageUITravelGuideButton' } | { __typename: 'ServicingButton' } | { __typename: 'SupplyCancelWaiverActionButton' } | { __typename: 'SupplyContentLinkStyleButton' } | { __typename: 'UIPrimaryButton' } | { __typename: 'UISecondaryButton' } | { __typename: 'UITertiaryButton' }> } | { __typename: 'EGDSStackedDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSSearchFormButton' } | (
      { __typename: 'FlightsActionButton' }
      & FlightsActionButtonFragmentFragment
    ) | (
      { __typename: 'FlightsDialogTrigger' }
      & FlightsDialogTriggerFisFragment
    ) | { __typename: 'FlightsExperienceActionButton' } | { __typename: 'FlightsSmartShoppingActionButton' } | { __typename: 'PackageUIActionDialogFooterButton' } | { __typename: 'PackageUIHideSearchFormAction' } | { __typename: 'PackageUITravelGuideButton' } | { __typename: 'ServicingButton' } | { __typename: 'SupplyCancelWaiverActionButton' } | { __typename: 'SupplyContentLinkStyleButton' } | { __typename: 'UIPrimaryButton' } | { __typename: 'UISecondaryButton' } | { __typename: 'UITertiaryButton' }> }, closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type EgdsDialogFis_EgdsFullScreenDialog_Fragment = (
  { __typename: 'EGDSFullScreenDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> }
  & EgdsFullScreenDialogFragmentFisFragment
);

type EgdsDialogFis_EgdsLoaderDialog_Fragment = { __typename: 'EGDSLoaderDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type EgdsDialogFis_PriceInsightsExistingTrackingDialogAction_Fragment = { __typename: 'PriceInsightsExistingTrackingDialogAction', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type EgdsDialogFis_PriceInsightsTrackingRetryDialogAction_Fragment = { __typename: 'PriceInsightsTrackingRetryDialogAction', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

type EgdsDialogFis_ServicingDialog_Fragment = { __typename: 'ServicingDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientAnalyticsFragment
  )> };

export type EgdsDialogFisFragment = EgdsDialogFis_AdditionalInformationPopoverDialogSection_Fragment | EgdsDialogFis_ClientSideErrorRepresentationDialog_Fragment | EgdsDialogFis_EgdsActionDialog_Fragment | EgdsDialogFis_EgdsFullScreenDialog_Fragment | EgdsDialogFis_EgdsLoaderDialog_Fragment | EgdsDialogFis_PriceInsightsExistingTrackingDialogAction_Fragment | EgdsDialogFis_PriceInsightsTrackingRetryDialogAction_Fragment | EgdsDialogFis_ServicingDialog_Fragment;

export type PriceMatchPromiseSelectionCardFragmentFragment = { __typename: 'PriceMatchPromiseSelectionCardSection', header: string, description: string, price?: Maybe<string>, icon: (
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  ), toggleCheckbox?: Maybe<(
    { __typename: 'FlightsActionCheckbox' }
    & FlightsActionCheckboxFragmentFisFragment
  )>, onDisplayAnalytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type PriceMatchPromiseSelectedCardFragmentFragment = { __typename: 'PriceMatchPromiseSelectedCardSection', header: string, description: string, icon: (
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  ), removeActionLink?: Maybe<(
    { __typename: 'FlightsActionLink' }
    & FlightsActionLinkFisFragment
  )>, onDisplayAnalytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type FlightsActionCheckboxFragmentFisFragment = { __typename: 'FlightsActionCheckbox', label: (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsTextFragmentFis_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsTextFragmentFis_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsTextFragmentFis_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSGraphicText' }
    & EgdsTextFragmentFis_EgdsGraphicText_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsTextFragmentFis_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSIconText' }
    & EgdsTextFragmentFis_EgdsIconText_Fragment
  ) | (
    { __typename: 'EGDSInlineLink' }
    & EgdsTextFragmentFis_EgdsInlineLink_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsTextFragmentFis_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsTextFragmentFis_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPlainText' }
    & EgdsTextFragmentFis_EgdsPlainText_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsTextFragmentFis_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsTextFragmentFis_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStylizedText' }
    & EgdsTextFragmentFis_EgdsStylizedText_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsTextFragmentFis_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsTextFragmentFis_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsTextFragmentFis_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsTextFragmentFis_EgdsTextWithMarkListItem_Fragment
  ) };

export type FlightsActionLinkFisFragment = { __typename: 'FlightsActionLink', disabled: boolean, primary?: Maybe<string>, clientAction: (
    { __typename: 'FlightsAncillaryContinueAction' }
    & ClientAction_FlightsAncillaryContinueAction_Fragment
  ) | (
    { __typename: 'FlightsBookingAction' }
    & ClientAction_FlightsBookingAction_Fragment
  ) | (
    { __typename: 'FlightsBoundNavigation' }
    & ClientAction_FlightsBoundNavigation_Fragment
  ) | (
    { __typename: 'FlightsClickAction' }
    & ClientAction_FlightsClickAction_Fragment
  ) | (
    { __typename: 'FlightsCreditClearAction' }
    & ClientAction_FlightsCreditClearAction_Fragment
  ) | (
    { __typename: 'FlightsCreditSelectionAction', originalBookingId: string }
    & ClientAction_FlightsCreditSelectionAction_Fragment
  ) | (
    { __typename: 'FlightsCreditSelectorOpenAction' }
    & ClientAction_FlightsCreditSelectorOpenAction_Fragment
  ) | (
    { __typename: 'FlightsDialogCloseAction' }
    & ClientAction_FlightsDialogCloseAction_Fragment
  ) | (
    { __typename: 'FlightsDialogTriggerAction' }
    & ClientAction_FlightsDialogTriggerAction_Fragment
  ) | (
    { __typename: 'FlightsFareTypeSelectionAction' }
    & ClientAction_FlightsFareTypeSelectionAction_Fragment
  ) | (
    { __typename: 'FlightsLegDropdownItemSelection' }
    & ClientAction_FlightsLegDropdownItemSelection_Fragment
  ) | (
    { __typename: 'FlightsLoadAncillariesAction' }
    & ClientAction_FlightsLoadAncillariesAction_Fragment
  ) | (
    { __typename: 'FlightsNavigateToDetails' }
    & ClientAction_FlightsNavigateToDetails_Fragment
  ) | (
    { __typename: 'FlightsRedirectOrDialog' }
    & ClientAction_FlightsRedirectOrDialog_Fragment
  ) | (
    { __typename: 'FlightsRefreshAction' }
    & ClientAction_FlightsRefreshAction_Fragment
  ) | (
    { __typename: 'FlightsRemovePriceMatchPromiseAction' }
    & ClientAction_FlightsRemovePriceMatchPromiseAction_Fragment
  ) | (
    { __typename: 'FlightsResourceLinkAction', resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } }
    & ClientAction_FlightsResourceLinkAction_Fragment
  ) | (
    { __typename: 'FlightsResourceRedirectAction' }
    & ClientAction_FlightsResourceRedirectAction_Fragment
  ) | (
    { __typename: 'FlightsSearchCriteriaChangeAction' }
    & ClientAction_FlightsSearchCriteriaChangeAction_Fragment
  ) | (
    { __typename: 'FlightsSelectionAction' }
    & ClientAction_FlightsSelectionAction_Fragment
  ) | (
    { __typename: 'FlightsSwitchToggleAction' }
    & ClientAction_FlightsSwitchToggleAction_Fragment
  ) | (
    { __typename: 'InsuranceSwitchToggleAction' }
    & ClientAction_InsuranceSwitchToggleAction_Fragment
  ) | (
    { __typename: 'MultiItemSelectPackage' }
    & ClientAction_MultiItemSelectPackage_Fragment
  ) | (
    { __typename: 'MultiItemSelectProducts' }
    & ClientAction_MultiItemSelectProducts_Fragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & IconInformationLoadedFragment
  )> };

type EgdsElementFragmentFis_ActivitySearchForm_Fragment = { __typename: 'ActivitySearchForm' };

type EgdsElementFragmentFis_AgencyUiPrimaryFloatingActionButton_Fragment = { __typename: 'AgencyUIPrimaryFloatingActionButton' };

type EgdsElementFragmentFis_AgencyUiSecondaryFloatingActionButton_Fragment = { __typename: 'AgencyUISecondaryFloatingActionButton' };

type EgdsElementFragmentFis_CarSearchForm_Fragment = { __typename: 'CarSearchForm' };

type EgdsElementFragmentFis_CruiseSearchForm_Fragment = { __typename: 'CruiseSearchForm' };

type EgdsElementFragmentFis_DurationSpanSelector_Fragment = { __typename: 'DurationSpanSelector' };

type EgdsElementFragmentFis_EgdsBadgeNotification_Fragment = { __typename: 'EGDSBadgeNotification' };

type EgdsElementFragmentFis_EgdsBasicCheckBox_Fragment = { __typename: 'EGDSBasicCheckBox' };

type EgdsElementFragmentFis_EgdsBasicLocalizedText_Fragment = (
  { __typename: 'EGDSBasicLocalizedText' }
  & EgdsTextFragmentFis_EgdsBasicLocalizedText_Fragment
);

type EgdsElementFragmentFis_EgdsBasicOption_Fragment = { __typename: 'EGDSBasicOption' };

type EgdsElementFragmentFis_EgdsBasicSelect_Fragment = { __typename: 'EGDSBasicSelect' };

type EgdsElementFragmentFis_EgdsBasicStepInput_Fragment = { __typename: 'EGDSBasicStepInput' };

type EgdsElementFragmentFis_EgdsBasicTab_Fragment = { __typename: 'EGDSBasicTab' };

type EgdsElementFragmentFis_EgdsBasicTabs_Fragment = { __typename: 'EGDSBasicTabs' };

type EgdsElementFragmentFis_EgdsBasicTravelerSelector_Fragment = { __typename: 'EGDSBasicTravelerSelector' };

type EgdsElementFragmentFis_EgdsBulletedList_Fragment = { __typename: 'EGDSBulletedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } | { __typename: 'EGDSTextWithMarkListItem', text: string } | { __typename: 'EarnMessageContainerListItem', text: string } | { __typename: 'FlightsTextContainerListItem', text: string } | { __typename: 'MishopUITextContainerListItem', text: string }> };

type EgdsElementFragmentFis_EgdsCardinalLocalizedText_Fragment = (
  { __typename: 'EGDSCardinalLocalizedText' }
  & EgdsTextFragmentFis_EgdsCardinalLocalizedText_Fragment
);

type EgdsElementFragmentFis_EgdsComposableTextElementSectionContainer_Fragment = { __typename: 'EGDSComposableTextElementSectionContainer' };

type EgdsElementFragmentFis_EgdsCompositeLocalizedText_Fragment = (
  { __typename: 'EGDSCompositeLocalizedText' }
  & EgdsTextFragmentFis_EgdsCompositeLocalizedText_Fragment
);

type EgdsElementFragmentFis_EgdsEmailInputField_Fragment = { __typename: 'EGDSEmailInputField' };

type EgdsElementFragmentFis_EgdsErrorSummary_Fragment = { __typename: 'EGDSErrorSummary' };

type EgdsElementFragmentFis_EgdsHeading_Fragment = (
  { __typename: 'EGDSHeading' }
  & EgdsTextFragmentFis_EgdsHeading_Fragment
);

type EgdsElementFragmentFis_EgdsImageLink_Fragment = { __typename: 'EGDSImageLink' };

type EgdsElementFragmentFis_EgdsImageLinkCard_Fragment = { __typename: 'EGDSImageLinkCard' };

type EgdsElementFragmentFis_EgdsInfantSeatRadioButton_Fragment = { __typename: 'EGDSInfantSeatRadioButton' };

type EgdsElementFragmentFis_EgdsLinkList_Fragment = { __typename: 'EGDSLinkList' };

type EgdsElementFragmentFis_EgdsLocalizedTextTemplate_Fragment = (
  { __typename: 'EGDSLocalizedTextTemplate' }
  & EgdsTextFragmentFis_EgdsLocalizedTextTemplate_Fragment
);

type EgdsElementFragmentFis_EgdsLoyaltyBadge_Fragment = { __typename: 'EGDSLoyaltyBadge' };

type EgdsElementFragmentFis_EgdsNumberInputField_Fragment = { __typename: 'EGDSNumberInputField' };

type EgdsElementFragmentFis_EgdsOrderedList_Fragment = { __typename: 'EGDSOrderedList' };

type EgdsElementFragmentFis_EgdsOverlayButton_Fragment = { __typename: 'EGDSOverlayButton' };

type EgdsElementFragmentFis_EgdsParagraph_Fragment = (
  { __typename: 'EGDSParagraph' }
  & EgdsTextFragmentFis_EgdsParagraph_Fragment
);

type EgdsElementFragmentFis_EgdsPasswordInputField_Fragment = { __typename: 'EGDSPasswordInputField' };

type EgdsElementFragmentFis_EgdsProgramBadge_Fragment = { __typename: 'EGDSProgramBadge' };

type EgdsElementFragmentFis_EgdsRoomsTravelerSelector_Fragment = { __typename: 'EGDSRoomsTravelerSelector' };

type EgdsElementFragmentFis_EgdsSearchFormButton_Fragment = { __typename: 'EGDSSearchFormButton' };

type EgdsElementFragmentFis_EgdsSearchFormDatePickerField_Fragment = { __typename: 'EGDSSearchFormDatePickerField' };

type EgdsElementFragmentFis_EgdsSearchFormInputField_Fragment = { __typename: 'EGDSSearchFormInputField' };

type EgdsElementFragmentFis_EgdsSearchFormLocationField_Fragment = { __typename: 'EGDSSearchFormLocationField' };

type EgdsElementFragmentFis_EgdsSearchFormLocationsField_Fragment = { __typename: 'EGDSSearchFormLocationsField' };

type EgdsElementFragmentFis_EgdsSearchFormTravelersField_Fragment = { __typename: 'EGDSSearchFormTravelersField' };

type EgdsElementFragmentFis_EgdsSectionContainer_Fragment = { __typename: 'EGDSSectionContainer' };

type EgdsElementFragmentFis_EgdsSpannableText_Fragment = (
  { __typename: 'EGDSSpannableText' }
  & EgdsTextFragmentFis_EgdsSpannableText_Fragment
);

type EgdsElementFragmentFis_EgdsStandardBadge_Fragment = { __typename: 'EGDSStandardBadge' };

type EgdsElementFragmentFis_EgdsStandardLink_Fragment = (
  { __typename: 'EGDSStandardLink' }
  & EgdsTextFragmentFis_EgdsStandardLink_Fragment
);

type EgdsElementFragmentFis_EgdsStandardMessagingCard_Fragment = { __typename: 'EGDSStandardMessagingCard' };

type EgdsElementFragmentFis_EgdsTextAreaInputField_Fragment = { __typename: 'EGDSTextAreaInputField' };

type EgdsElementFragmentFis_EgdsTextIconLinkListItem_Fragment = (
  { __typename: 'EGDSTextIconLinkListItem' }
  & EgdsTextFragmentFis_EgdsTextIconLinkListItem_Fragment
);

type EgdsElementFragmentFis_EgdsTextIconList_Fragment = { __typename: 'EGDSTextIconList' };

type EgdsElementFragmentFis_EgdsTextIconListItem_Fragment = (
  { __typename: 'EGDSTextIconListItem' }
  & EgdsTextFragmentFis_EgdsTextIconListItem_Fragment
);

type EgdsElementFragmentFis_EgdsTextInputField_Fragment = { __typename: 'EGDSTextInputField' };

type EgdsElementFragmentFis_EgdsTextListSection_Fragment = { __typename: 'EGDSTextListSection' };

type EgdsElementFragmentFis_EgdsTextSection_Fragment = { __typename: 'EGDSTextSection' };

type EgdsElementFragmentFis_EgdsTextStandardListItem_Fragment = (
  { __typename: 'EGDSTextStandardListItem' }
  & EgdsTextFragmentFis_EgdsTextStandardListItem_Fragment
);

type EgdsElementFragmentFis_EgdsTextWithMarkListItem_Fragment = (
  { __typename: 'EGDSTextWithMarkListItem' }
  & EgdsTextFragmentFis_EgdsTextWithMarkListItem_Fragment
);

type EgdsElementFragmentFis_EgdsToast_Fragment = { __typename: 'EGDSToast' };

type EgdsElementFragmentFis_EgdsTravelerChildAgeSelect_Fragment = { __typename: 'EGDSTravelerChildAgeSelect' };

type EgdsElementFragmentFis_EgdsTravelerInfantSeatSelection_Fragment = { __typename: 'EGDSTravelerInfantSeatSelection' };

type EgdsElementFragmentFis_EgdsTravelerStepInput_Fragment = { __typename: 'EGDSTravelerStepInput' };

type EgdsElementFragmentFis_EgdsTypeaheadInputField_Fragment = { __typename: 'EGDSTypeaheadInputField' };

type EgdsElementFragmentFis_EgdsUnorderedList_Fragment = { __typename: 'EGDSUnorderedList' };

type EgdsElementFragmentFis_FlightSearchForm_Fragment = { __typename: 'FlightSearchForm' };

type EgdsElementFragmentFis_FlightSearchInputForm_Fragment = { __typename: 'FlightSearchInputForm' };

type EgdsElementFragmentFis_FlightsActionButton_Fragment = { __typename: 'FlightsActionButton' };

type EgdsElementFragmentFis_FlightsActionCheckbox_Fragment = { __typename: 'FlightsActionCheckbox' };

type EgdsElementFragmentFis_FlightsActionLink_Fragment = { __typename: 'FlightsActionLink' };

type EgdsElementFragmentFis_FlightsDialogTrigger_Fragment = { __typename: 'FlightsDialogTrigger' };

type EgdsElementFragmentFis_IdentityBasicBlock_Fragment = { __typename: 'IdentityBasicBlock' };

type EgdsElementFragmentFis_IdentityButton_Fragment = { __typename: 'IdentityButton' };

type EgdsElementFragmentFis_IdentityConsentNestedCheckBox_Fragment = { __typename: 'IdentityConsentNestedCheckBox' };

type EgdsElementFragmentFis_IdentityImage_Fragment = { __typename: 'IdentityImage' };

type EgdsElementFragmentFis_IdentityImageGallery_Fragment = { __typename: 'IdentityImageGallery' };

type EgdsElementFragmentFis_IdentityInfoLinkComponent_Fragment = { __typename: 'IdentityInfoLinkComponent' };

type EgdsElementFragmentFis_IdentityPasswordStrengthComponent_Fragment = { __typename: 'IdentityPasswordStrengthComponent' };

type EgdsElementFragmentFis_IdentityResendButton_Fragment = { __typename: 'IdentityResendButton' };

type EgdsElementFragmentFis_IdentitySingleColumnComponentLayout_Fragment = { __typename: 'IdentitySingleColumnComponentLayout' };

type EgdsElementFragmentFis_IdentitySocialButton_Fragment = { __typename: 'IdentitySocialButton' };

type EgdsElementFragmentFis_IdentityText_Fragment = { __typename: 'IdentityText' };

type EgdsElementFragmentFis_Illustration_Fragment = (
  { __typename: 'Illustration' }
  & EgdsGraphicIllustrationFragmentFragment
);

type EgdsElementFragmentFis_LodgingSearchForm_Fragment = { __typename: 'LodgingSearchForm' };

type EgdsElementFragmentFis_PackagesSearchForm_Fragment = { __typename: 'PackagesSearchForm' };

type EgdsElementFragmentFis_ProductSummaryCard_Fragment = { __typename: 'ProductSummaryCard' };

type EgdsElementFragmentFis_ProfileAccountLink_Fragment = { __typename: 'ProfileAccountLink' };

type EgdsElementFragmentFis_ProfileActionButtonCard_Fragment = { __typename: 'ProfileActionButtonCard' };

type EgdsElementFragmentFis_ProfileBulletedList_Fragment = { __typename: 'ProfileBulletedList' };

type EgdsElementFragmentFis_ProfileEgdsSectionContainer_Fragment = { __typename: 'ProfileEGDSSectionContainer' };

type EgdsElementFragmentFis_ProfileFormHorizontalContainer_Fragment = { __typename: 'ProfileFormHorizontalContainer' };

type EgdsElementFragmentFis_ProfileFormSection_Fragment = { __typename: 'ProfileFormSection' };

type EgdsElementFragmentFis_ProfileLink_Fragment = { __typename: 'ProfileLink' };

type EgdsElementFragmentFis_ProfileNumberField_Fragment = { __typename: 'ProfileNumberField' };

type EgdsElementFragmentFis_ProfilePhoneNumberField_Fragment = { __typename: 'ProfilePhoneNumberField' };

type EgdsElementFragmentFis_ProfileRadioButton_Fragment = { __typename: 'ProfileRadioButton' };

type EgdsElementFragmentFis_ProfileRadioButtonGroup_Fragment = { __typename: 'ProfileRadioButtonGroup' };

type EgdsElementFragmentFis_ProfileSelectField_Fragment = { __typename: 'ProfileSelectField' };

type EgdsElementFragmentFis_ProfileSlimCard_Fragment = { __typename: 'ProfileSlimCard' };

type EgdsElementFragmentFis_ProfileSwitchOption_Fragment = { __typename: 'ProfileSwitchOption' };

type EgdsElementFragmentFis_ProfileTextField_Fragment = { __typename: 'ProfileTextField' };

type EgdsElementFragmentFis_SearchFormDurationSpanField_Fragment = { __typename: 'SearchFormDurationSpanField' };

type EgdsElementFragmentFis_TripsMediaGallery_Fragment = { __typename: 'TripsMediaGallery' };

type EgdsElementFragmentFis_TripsValidatedInput_Fragment = { __typename: 'TripsValidatedInput' };

type EgdsElementFragmentFis_UiBanner_Fragment = { __typename: 'UIBanner' };

type EgdsElementFragmentFis_UiEmptyState_Fragment = { __typename: 'UIEmptyState' };

type EgdsElementFragmentFis_UiMessagingCard_Fragment = { __typename: 'UIMessagingCard', primary?: Maybe<string>, secondaries?: Maybe<Array<string>>, graphic?: Maybe<{ __typename: 'Icon' } | (
    { __typename: 'Illustration' }
    & EgdsGraphicIllustrationFragmentFragment
  ) | { __typename: 'Mark' }> };

type EgdsElementFragmentFis_UiPrimaryButton_Fragment = { __typename: 'UIPrimaryButton' };

type EgdsElementFragmentFis_UiPrimaryFloatingActionButton_Fragment = { __typename: 'UIPrimaryFloatingActionButton' };

type EgdsElementFragmentFis_UiSecondaryButton_Fragment = { __typename: 'UISecondaryButton' };

type EgdsElementFragmentFis_UiSecondaryFloatingActionButton_Fragment = { __typename: 'UISecondaryFloatingActionButton' };

type EgdsElementFragmentFis_UiTertiaryButton_Fragment = { __typename: 'UITertiaryButton' };

export type EgdsElementFragmentFisFragment = EgdsElementFragmentFis_ActivitySearchForm_Fragment | EgdsElementFragmentFis_AgencyUiPrimaryFloatingActionButton_Fragment | EgdsElementFragmentFis_AgencyUiSecondaryFloatingActionButton_Fragment | EgdsElementFragmentFis_CarSearchForm_Fragment | EgdsElementFragmentFis_CruiseSearchForm_Fragment | EgdsElementFragmentFis_DurationSpanSelector_Fragment | EgdsElementFragmentFis_EgdsBadgeNotification_Fragment | EgdsElementFragmentFis_EgdsBasicCheckBox_Fragment | EgdsElementFragmentFis_EgdsBasicLocalizedText_Fragment | EgdsElementFragmentFis_EgdsBasicOption_Fragment | EgdsElementFragmentFis_EgdsBasicSelect_Fragment | EgdsElementFragmentFis_EgdsBasicStepInput_Fragment | EgdsElementFragmentFis_EgdsBasicTab_Fragment | EgdsElementFragmentFis_EgdsBasicTabs_Fragment | EgdsElementFragmentFis_EgdsBasicTravelerSelector_Fragment | EgdsElementFragmentFis_EgdsBulletedList_Fragment | EgdsElementFragmentFis_EgdsCardinalLocalizedText_Fragment | EgdsElementFragmentFis_EgdsComposableTextElementSectionContainer_Fragment | EgdsElementFragmentFis_EgdsCompositeLocalizedText_Fragment | EgdsElementFragmentFis_EgdsEmailInputField_Fragment | EgdsElementFragmentFis_EgdsErrorSummary_Fragment | EgdsElementFragmentFis_EgdsHeading_Fragment | EgdsElementFragmentFis_EgdsImageLink_Fragment | EgdsElementFragmentFis_EgdsImageLinkCard_Fragment | EgdsElementFragmentFis_EgdsInfantSeatRadioButton_Fragment | EgdsElementFragmentFis_EgdsLinkList_Fragment | EgdsElementFragmentFis_EgdsLocalizedTextTemplate_Fragment | EgdsElementFragmentFis_EgdsLoyaltyBadge_Fragment | EgdsElementFragmentFis_EgdsNumberInputField_Fragment | EgdsElementFragmentFis_EgdsOrderedList_Fragment | EgdsElementFragmentFis_EgdsOverlayButton_Fragment | EgdsElementFragmentFis_EgdsParagraph_Fragment | EgdsElementFragmentFis_EgdsPasswordInputField_Fragment | EgdsElementFragmentFis_EgdsProgramBadge_Fragment | EgdsElementFragmentFis_EgdsRoomsTravelerSelector_Fragment | EgdsElementFragmentFis_EgdsSearchFormButton_Fragment | EgdsElementFragmentFis_EgdsSearchFormDatePickerField_Fragment | EgdsElementFragmentFis_EgdsSearchFormInputField_Fragment | EgdsElementFragmentFis_EgdsSearchFormLocationField_Fragment | EgdsElementFragmentFis_EgdsSearchFormLocationsField_Fragment | EgdsElementFragmentFis_EgdsSearchFormTravelersField_Fragment | EgdsElementFragmentFis_EgdsSectionContainer_Fragment | EgdsElementFragmentFis_EgdsSpannableText_Fragment | EgdsElementFragmentFis_EgdsStandardBadge_Fragment | EgdsElementFragmentFis_EgdsStandardLink_Fragment | EgdsElementFragmentFis_EgdsStandardMessagingCard_Fragment | EgdsElementFragmentFis_EgdsTextAreaInputField_Fragment | EgdsElementFragmentFis_EgdsTextIconLinkListItem_Fragment | EgdsElementFragmentFis_EgdsTextIconList_Fragment | EgdsElementFragmentFis_EgdsTextIconListItem_Fragment | EgdsElementFragmentFis_EgdsTextInputField_Fragment | EgdsElementFragmentFis_EgdsTextListSection_Fragment | EgdsElementFragmentFis_EgdsTextSection_Fragment | EgdsElementFragmentFis_EgdsTextStandardListItem_Fragment | EgdsElementFragmentFis_EgdsTextWithMarkListItem_Fragment | EgdsElementFragmentFis_EgdsToast_Fragment | EgdsElementFragmentFis_EgdsTravelerChildAgeSelect_Fragment | EgdsElementFragmentFis_EgdsTravelerInfantSeatSelection_Fragment | EgdsElementFragmentFis_EgdsTravelerStepInput_Fragment | EgdsElementFragmentFis_EgdsTypeaheadInputField_Fragment | EgdsElementFragmentFis_EgdsUnorderedList_Fragment | EgdsElementFragmentFis_FlightSearchForm_Fragment | EgdsElementFragmentFis_FlightSearchInputForm_Fragment | EgdsElementFragmentFis_FlightsActionButton_Fragment | EgdsElementFragmentFis_FlightsActionCheckbox_Fragment | EgdsElementFragmentFis_FlightsActionLink_Fragment | EgdsElementFragmentFis_FlightsDialogTrigger_Fragment | EgdsElementFragmentFis_IdentityBasicBlock_Fragment | EgdsElementFragmentFis_IdentityButton_Fragment | EgdsElementFragmentFis_IdentityConsentNestedCheckBox_Fragment | EgdsElementFragmentFis_IdentityImage_Fragment | EgdsElementFragmentFis_IdentityImageGallery_Fragment | EgdsElementFragmentFis_IdentityInfoLinkComponent_Fragment | EgdsElementFragmentFis_IdentityPasswordStrengthComponent_Fragment | EgdsElementFragmentFis_IdentityResendButton_Fragment | EgdsElementFragmentFis_IdentitySingleColumnComponentLayout_Fragment | EgdsElementFragmentFis_IdentitySocialButton_Fragment | EgdsElementFragmentFis_IdentityText_Fragment | EgdsElementFragmentFis_Illustration_Fragment | EgdsElementFragmentFis_LodgingSearchForm_Fragment | EgdsElementFragmentFis_PackagesSearchForm_Fragment | EgdsElementFragmentFis_ProductSummaryCard_Fragment | EgdsElementFragmentFis_ProfileAccountLink_Fragment | EgdsElementFragmentFis_ProfileActionButtonCard_Fragment | EgdsElementFragmentFis_ProfileBulletedList_Fragment | EgdsElementFragmentFis_ProfileEgdsSectionContainer_Fragment | EgdsElementFragmentFis_ProfileFormHorizontalContainer_Fragment | EgdsElementFragmentFis_ProfileFormSection_Fragment | EgdsElementFragmentFis_ProfileLink_Fragment | EgdsElementFragmentFis_ProfileNumberField_Fragment | EgdsElementFragmentFis_ProfilePhoneNumberField_Fragment | EgdsElementFragmentFis_ProfileRadioButton_Fragment | EgdsElementFragmentFis_ProfileRadioButtonGroup_Fragment | EgdsElementFragmentFis_ProfileSelectField_Fragment | EgdsElementFragmentFis_ProfileSlimCard_Fragment | EgdsElementFragmentFis_ProfileSwitchOption_Fragment | EgdsElementFragmentFis_ProfileTextField_Fragment | EgdsElementFragmentFis_SearchFormDurationSpanField_Fragment | EgdsElementFragmentFis_TripsMediaGallery_Fragment | EgdsElementFragmentFis_TripsValidatedInput_Fragment | EgdsElementFragmentFis_UiBanner_Fragment | EgdsElementFragmentFis_UiEmptyState_Fragment | EgdsElementFragmentFis_UiMessagingCard_Fragment | EgdsElementFragmentFis_UiPrimaryButton_Fragment | EgdsElementFragmentFis_UiPrimaryFloatingActionButton_Fragment | EgdsElementFragmentFis_UiSecondaryButton_Fragment | EgdsElementFragmentFis_UiSecondaryFloatingActionButton_Fragment | EgdsElementFragmentFis_UiTertiaryButton_Fragment;

type EgdsTextFragmentFis_EgdsBasicLocalizedText_Fragment = { __typename: 'EGDSBasicLocalizedText' };

type EgdsTextFragmentFis_EgdsCardinalLocalizedText_Fragment = { __typename: 'EGDSCardinalLocalizedText' };

type EgdsTextFragmentFis_EgdsCompositeLocalizedText_Fragment = { __typename: 'EGDSCompositeLocalizedText' };

type EgdsTextFragmentFis_EgdsGraphicText_Fragment = (
  { __typename: 'EGDSGraphicText' }
  & EgdsGraphicTextFragmentInformationFragment
);

type EgdsTextFragmentFis_EgdsHeading_Fragment = { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> };

type EgdsTextFragmentFis_EgdsIconText_Fragment = { __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', id: string } };

type EgdsTextFragmentFis_EgdsInlineLink_Fragment = { __typename: 'EGDSInlineLink' };

type EgdsTextFragmentFis_EgdsLocalizedTextTemplate_Fragment = { __typename: 'EGDSLocalizedTextTemplate' };

type EgdsTextFragmentFis_EgdsParagraph_Fragment = { __typename: 'EGDSParagraph', text: string, style: EgdsParagraphStyle };

type EgdsTextFragmentFis_EgdsPlainText_Fragment = { __typename: 'EGDSPlainText' };

type EgdsTextFragmentFis_EgdsSpannableText_Fragment = (
  { __typename: 'EGDSSpannableText' }
  & EgdsSpannableTextFragmentInformationFragment
);

type EgdsTextFragmentFis_EgdsStandardLink_Fragment = { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientAnalyticsFragment
    ) } };

type EgdsTextFragmentFis_EgdsStylizedText_Fragment = { __typename: 'EGDSStylizedText' };

type EgdsTextFragmentFis_EgdsTextIconLinkListItem_Fragment = { __typename: 'EGDSTextIconLinkListItem' };

type EgdsTextFragmentFis_EgdsTextIconListItem_Fragment = { __typename: 'EGDSTextIconListItem' };

type EgdsTextFragmentFis_EgdsTextStandardListItem_Fragment = { __typename: 'EGDSTextStandardListItem' };

type EgdsTextFragmentFis_EgdsTextWithMarkListItem_Fragment = { __typename: 'EGDSTextWithMarkListItem' };

export type EgdsTextFragmentFisFragment = EgdsTextFragmentFis_EgdsBasicLocalizedText_Fragment | EgdsTextFragmentFis_EgdsCardinalLocalizedText_Fragment | EgdsTextFragmentFis_EgdsCompositeLocalizedText_Fragment | EgdsTextFragmentFis_EgdsGraphicText_Fragment | EgdsTextFragmentFis_EgdsHeading_Fragment | EgdsTextFragmentFis_EgdsIconText_Fragment | EgdsTextFragmentFis_EgdsInlineLink_Fragment | EgdsTextFragmentFis_EgdsLocalizedTextTemplate_Fragment | EgdsTextFragmentFis_EgdsParagraph_Fragment | EgdsTextFragmentFis_EgdsPlainText_Fragment | EgdsTextFragmentFis_EgdsSpannableText_Fragment | EgdsTextFragmentFis_EgdsStandardLink_Fragment | EgdsTextFragmentFis_EgdsStylizedText_Fragment | EgdsTextFragmentFis_EgdsTextIconLinkListItem_Fragment | EgdsTextFragmentFis_EgdsTextIconListItem_Fragment | EgdsTextFragmentFis_EgdsTextStandardListItem_Fragment | EgdsTextFragmentFis_EgdsTextWithMarkListItem_Fragment;

export type EgdsFullScreenDialogFragmentFisFragment = { __typename: 'EGDSFullScreenDialog', toolbar: { __typename: 'EGDSDialogToolbar', title: string, closeText?: Maybe<string> } };

export type EgdsGraphicTextFragmentInformationFragment = { __typename: 'EGDSGraphicText', text: string, textGraphic: (
    { __typename: 'Icon' }
    & UiGraphicFragmentInformation_Icon_Fragment
  ) | (
    { __typename: 'Illustration' }
    & UiGraphicFragmentInformation_Illustration_Fragment
  ) | (
    { __typename: 'Mark' }
    & UiGraphicFragmentInformation_Mark_Fragment
  ) };

type UiGraphicFragmentInformation_Icon_Fragment = (
  { __typename: 'Icon' }
  & IconInformationLoadedFragment
);

type UiGraphicFragmentInformation_Illustration_Fragment = (
  { __typename: 'Illustration' }
  & EgdsGraphicIllustrationFragmentFragment
);

type UiGraphicFragmentInformation_Mark_Fragment = (
  { __typename: 'Mark' }
  & MarkFragmentsFragment
);

export type UiGraphicFragmentInformationFragment = UiGraphicFragmentInformation_Icon_Fragment | UiGraphicFragmentInformation_Illustration_Fragment | UiGraphicFragmentInformation_Mark_Fragment;

export type FlightsShoppingPwaFlightInformationResultsLoadingQueryVariables = Exact<{
  context: ContextInput;
  flightsDetailCriteria?: Maybe<FlightsDetailCriteriaInput>;
  flightsDetailComponentsCriteria?: Maybe<FlightsDetailComponentsCriteriaInput>;
  queryState?: Maybe<FlightsQueryState>;
}>;


export type FlightsShoppingPwaFlightInformationResultsLoadingQuery = { __typename: 'Query', flightsDetail: { __typename: 'FlightsInformationResponse', gaiaIds?: Maybe<Array<string>>, additionalShopping?: Maybe<Array<AdditionalShopping>>, journeyContinuationId?: Maybe<string>, journeyStartEndDates?: Maybe<Array<{ __typename: 'JourneyStartEndDates', startDate: string, endDate: string }>>, clientMetadata?: Maybe<{ __typename: 'FlightsPWAMetadata', pageName: string, pageNameAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }>, pageTitle?: Maybe<{ __typename: 'FlightsPageTitle', pageAccessibility?: Maybe<string>, title: { __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> } }>, freeCancellation?: Maybe<{ __typename: 'FlightsIconPlacard' } | (
      { __typename: 'FlightsImagePlacard' }
      & FlightsImagePlacardInformationLoadingFragment
    ) | { __typename: 'FlightsMarkPlacard' }>, flightsSelectedJourneyReview?: Maybe<Array<{ __typename: 'LoadedFlightsSelectedJourneyReview' } | { __typename: 'LoadingFlightsSelectedJourneyReview', fareSummarySkeletonCount: number, upsellNudgingFeatureEnabled: boolean, journeyInformation?: Maybe<{ __typename: 'JourneyInformation', tripType: string }>, flightsJourneyHeaders: { __typename: 'FlightsJourneyHeaders', heading: string, flightsJourneySubheading: string, flightsJourneySubheadingMark?: Maybe<{ __typename: 'Mark', description: string, id: string, size?: Maybe<string>, token: string, url?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }> }, flightsJourneySummary: { __typename: 'FlightsBargainJourneySummary', arrivalDayInformation: string, heading: (
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        ), differentDayArrival?: Maybe<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        )>, basicFlightDetails: Array<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        )> } | { __typename: 'LoadedFlightsStandardJourneySummary', heading: (
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        ), differentDayArrival?: Maybe<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        )>, basicFlightDetails: Array<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        )> } | { __typename: 'LoadingFlightsStandardJourneySummary', skeletonCount: number, heading: (
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        ), differentDayArrival?: Maybe<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        )>, basicFlightDetails: Array<(
          { __typename: 'FlightsMessageAndAccessibility' }
          & FlightsMessageAndAccessibilityInformationLoadingFragment
        )> }, journeyHighlights?: Maybe<Array<{ __typename: 'FlightsJourneyHighlights', flightsJourneyHeaders: { __typename: 'FlightsJourneyHeaders', heading: string, flightsJourneySubheading: string, flightsJourneySubheadingMark?: Maybe<{ __typename: 'Mark', description: string, id: string, size?: Maybe<string>, token: string, url?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }> }, flightsJourneySummary: { __typename: 'FlightsBargainJourneySummary', arrivalDayInformation: string, heading: (
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          ), differentDayArrival?: Maybe<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          )>, basicFlightDetails: Array<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          )> } | { __typename: 'LoadedFlightsStandardJourneySummary', heading: (
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          ), differentDayArrival?: Maybe<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          )>, basicFlightDetails: Array<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          )> } | { __typename: 'LoadingFlightsStandardJourneySummary', skeletonCount: number, heading: (
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          ), differentDayArrival?: Maybe<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          )>, basicFlightDetails: Array<(
            { __typename: 'FlightsMessageAndAccessibility' }
            & FlightsMessageAndAccessibilityInformationLoadingFragment
          )> } }>>, changeFlight: (
        { __typename: 'FlightsAction' }
        & FlightsActionInformationLoadingFragment
      ), changeFlightDialog?: Maybe<{ __typename: 'FlightsDialogChangeFlight', header: string, title?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, accessibilityMessage?: Maybe<string>, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), analyticsList: Array<(
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          )> }>, displayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )> }> }>>, priceSummary?: Maybe<{ __typename: 'FlightsLoadedPriceSummary' } | { __typename: 'FlightsLoadingPriceSummary', title: string, skeletonCount: number, tripTotalLabel: string, buttonAction: (
        { __typename: 'FlightsAction' }
        & FlightsActionInformationLoadingFragment
      ) }>, serverErrorMessaging?: Maybe<(
      { __typename: 'FlightsActionableErrorMessaging' }
      & FlightsInformationLoadingServerErrorMessagingFragment
    ) | { __typename: 'FlightsNoFlightsFoundMessaging' } | { __typename: 'FlightsNoFlightsFoundWithFilterMessaging' } | { __typename: 'FlightsSmartNoFlightsFoundMessaging' }>, stepIndicator?: Maybe<(
      { __typename: 'FlightsStepIndicator' }
      & FlightsInformationStepIndicatorFragment
    )>, flightsSupportedAncillaries?: Maybe<(
      { __typename: 'FlightsSupportedAncillaryInfo' }
      & FlightsInformationSupportedAncillaryInfoFragment
    )> } };

export type FlightsInformationSupportedAncillaryInfoFragment = { __typename: 'FlightsSupportedAncillaryInfo', journeyContinuationId: string, ancillaryTypes: Array<FlightsAncillaryType> };

export type FlightsInformationStepIndicatorFragment = { __typename: 'FlightsStepIndicator', journeyContinuationId: string, errorAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsInformationLoadingServerErrorMessagingFragment = { __typename: 'FlightsActionableErrorMessaging', message: string, title: string, action: (
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadingFragment
  ), icon: (
    { __typename: 'Icon' }
    & IconInformationLoadingFragment
  ) };

export type IconInformationLoadingFragment = { __typename: 'Icon', id: string };

export type FlightsMessageAndAccessibilityInformationLoadingFragment = { __typename: 'FlightsMessageAndAccessibility', text: string, accessibilityMessage: string };

export type FlightsImagePlacardInformationLoadingFragment = { __typename: 'FlightsImagePlacard', heading?: Maybe<string>, message: string, image: { __typename: 'Image', url: any, description: string } };

export type FlightsActionInformationLoadingFragment = { __typename: 'FlightsAction', accessibilityMessage?: Maybe<string>, displayAction: string, displayType: FlightsActionDisplayType, enable?: Maybe<boolean>, type: FlightsActionType, analyticsList: Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, relativePackageableURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> };

export type FlightsShoppingPwaSeatSelectionQueryVariables = Exact<{
  context: ContextInput;
  flightsDetailCriteria: FlightsDetailCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
}>;


export type FlightsShoppingPwaSeatSelectionQuery = { __typename: 'Query', flightsDetail: { __typename: 'FlightsInformationResponse', baseOfferAncillaryID?: Maybe<string>, flightsSelectedJourneyReview?: Maybe<Array<{ __typename: 'LoadedFlightsSelectedJourneyReview', fareDetails: { __typename: 'FareDetails', fareSeatMapInformation?: Maybe<(
          { __typename: 'FareSeatMapInformation' }
          & FareSeatMapInfoFragment
        )> } } | { __typename: 'LoadingFlightsSelectedJourneyReview' }>>, priceSummary?: Maybe<(
      { __typename: 'FlightsLoadedPriceSummary' }
      & FlightsLoadedPriceSummaryFragment
    ) | { __typename: 'FlightsLoadingPriceSummary' }>, dynamicElementsGroups?: Maybe<Array<{ __typename: 'FlightsInformationDynamicElementsGroup', ancillaryId?: Maybe<string>, identifier: string, dynamicElements: { __typename: 'FlightsInformationDynamicElements', totalPrice: string, priceSummary: (
          { __typename: 'FlightsLoadedPriceSummary' }
          & FlightsLoadedPriceSummaryFragment
        ), fareChoiceInformationDynamicElement?: Maybe<{ __typename: 'FareChoiceInformationDynamicElement', farePricePerPerson: string }>, flightsJourneyDetailsDynamicElements?: Maybe<Array<{ __typename: 'FlightsJourneyDetailsDynamicElements', fareName?: Maybe<string>, title: string, message?: Maybe<string>, journeyPartsDynamicElements: Array<{ __typename: 'JourneyPartsDynamicElements', cabinClassAndBookingCode: string }>, fareSeatMapDynamicElement?: Maybe<{ __typename: 'FareSeatMapDynamicElement', onSelectAnalytics: Array<(
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            )>, flightLegsDetails?: Maybe<(
              { __typename: 'FareSeatMapAvailableFlightLegsDetails' }
              & FareSeatMapAvailableFlightLegsDetailsFragment
            )> }>, selectedSeatDetails?: Maybe<Array<(
            { __typename: 'FlightsSelectedSeatDetail' }
            & FlightsSelectedSeatDetailFragment
          )>>, details?: Maybe<(
            { __typename: 'FlightsAction' }
            & FlightsActionInformationLoadedFragment
          )> }>>, dynamicElementsGroupTrackEventAnalytics?: Maybe<{ __typename: 'FlightsDynamicElementsTrackEventAnalytics', stringifiedAllFlightProducts: string, analyticsList: Array<{ __typename: 'FlightsAnalytics', linkName: string, referrerId: string }> }> } | { __typename: 'FlightsSearchResultsDynamicElements', flightsJourneyDetailsDynamicElements?: Maybe<Array<{ __typename: 'FlightsJourneyDetailsDynamicElements', fareName?: Maybe<string>, title: string, message?: Maybe<string>, journeyPartsDynamicElements: Array<{ __typename: 'JourneyPartsDynamicElements', cabinClassAndBookingCode: string }>, fareSeatMapDynamicElement?: Maybe<{ __typename: 'FareSeatMapDynamicElement', onSelectAnalytics: Array<(
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            )>, flightLegsDetails?: Maybe<(
              { __typename: 'FareSeatMapAvailableFlightLegsDetails' }
              & FareSeatMapAvailableFlightLegsDetailsFragment
            )> }>, selectedSeatDetails?: Maybe<Array<(
            { __typename: 'FlightsSelectedSeatDetail' }
            & FlightsSelectedSeatDetailFragment
          )>>, details?: Maybe<(
            { __typename: 'FlightsAction' }
            & FlightsActionInformationLoadedFragment
          )> }>>, dynamicElementsGroupTrackEventAnalytics?: Maybe<{ __typename: 'FlightsDynamicElementsTrackEventAnalytics', stringifiedAllFlightProducts: string, analyticsList: Array<{ __typename: 'FlightsAnalytics', linkName: string, referrerId: string }> }> } }>> } };

export type FareSeatMapInfoFragment = { __typename: 'FareSeatMapInformation', message: string, title: string, ancillaryId?: Maybe<string>, enableSeatSelection?: Maybe<boolean>, skeletonCount: number, details?: Maybe<(
    { __typename: 'FlightsAction' }
    & FlightsActionInformationLoadedFragment
  )>, fareSeatMapViewDetails?: Maybe<(
    { __typename: 'FareSeatMapViewDetails' }
    & FareSeatMapViewDetailsFragment
  )>, selectedSeatDetails?: Maybe<Array<(
    { __typename: 'FlightsSelectedSeatDetail' }
    & FlightsSelectedSeatDetailFragment
  )>>, errorMessages?: Maybe<Array<(
    { __typename: 'FlightsSeatSelectionErrorMessage' }
    & FlightsSeatSelectionErrorMessageFragment
  )>> };

export type FlightsShoppingPwaFlightServicingResultsQueryVariables = Exact<{
  context: ContextInput;
  flightsServicingCriteria: FlightsServicingCriteriaInput;
}>;


export type FlightsShoppingPwaFlightServicingResultsQuery = { __typename: 'Query', flightsServicing: { __typename: 'FlightsServicingResponse', addCollectRequired?: Maybe<boolean>, clientMetadata: { __typename: 'FlightsPWAMetadata', pageName: string, pageNameAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragmentFragment
      ), pageAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragmentFragment
      )> }, booking: { __typename: 'FlightsBooking', primaryText?: Maybe<{ __typename: 'EGDSPlainText', text: string }> }, creditResidualMessaging?: Maybe<{ __typename: 'FlightsCreditResidualMessaging', heading: { __typename: 'EGDSHeading', text: string } }>, importantTripInfo: { __typename: 'FlightsImportantTripInfo', heading: { __typename: 'EGDSHeading', text: string } }, payment: { __typename: 'FlightsPayment', paymentPresentation?: Maybe<{ __typename: 'FlightsPaymentPresentation', heading: string }> }, priceSummary?: Maybe<{ __typename: 'FlightsLoadedPriceSummary', title: string } | { __typename: 'FlightsLoadingPriceSummary', title: string }>, reviewAndBook: { __typename: 'FlightsReviewAndBook', heading: { __typename: 'EGDSHeading', text: string } }, tripSummary?: Maybe<{ __typename: 'FlightsTripSummary', heading: string }>, serverErrorMessaging?: Maybe<{ __typename: 'FlightServicingBookingFailure', emptyState?: Maybe<(
        { __typename: 'FlightServicingBookingEmptyState' }
        & FlightServicingBookingEmptyStateFragmentFragment
      )>, placards?: Maybe<Array<(
        { __typename: 'FlightsBannerPlacard' }
        & FlightsBannerPlacardFragmentFragment
      ) | { __typename: 'FlightsMessagingCardPlacard' }>> }> } };

export type FlightsAnalyticsFragmentFragment = { __typename: 'FlightsAnalytics', linkName: string, referrerId: string };

export type ClientSideAnalyticsFragmentFragment = { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> };

export type FlightsBannerPlacardFragmentFragment = { __typename: 'FlightsBannerPlacard', displayType: FlightsPlacardDisplayType, onViewedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragmentFragment
  )>, banner: { __typename: 'UIBanner', heading?: Maybe<string>, message: string, fullWidth?: Maybe<boolean> } };

export type FlightServicingBookingEmptyStateFragmentFragment = { __typename: 'FlightServicingBookingEmptyState', presentation: { __typename: 'UIEmptyState', heading?: Maybe<string>, body: string, icon?: Maybe<{ __typename: 'Icon', description: string, id: string, token: string }>, primaryButton?: Maybe<{ __typename: 'UIPrimaryButton', accessibility?: Maybe<string>, primary?: Maybe<string>, analytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragmentFragment
      )> }> }, primaryAction: { __typename: 'FlightsAncillaryContinueAction' } | { __typename: 'FlightsBookingAction' } | { __typename: 'FlightsBoundNavigation' } | { __typename: 'FlightsClickAction' } | { __typename: 'FlightsCreditClearAction' } | { __typename: 'FlightsCreditSelectionAction' } | { __typename: 'FlightsCreditSelectorOpenAction' } | { __typename: 'FlightsDialogCloseAction' } | { __typename: 'FlightsDialogTriggerAction' } | { __typename: 'FlightsFareTypeSelectionAction' } | { __typename: 'FlightsLegDropdownItemSelection' } | { __typename: 'FlightsLoadAncillariesAction' } | { __typename: 'FlightsNavigateToDetails' } | { __typename: 'FlightsRedirectOrDialog' } | (
    { __typename: 'FlightsRefreshAction' }
    & FlightsRefreshActionFragmentFragment
  ) | { __typename: 'FlightsRemovePriceMatchPromiseAction' } | (
    { __typename: 'FlightsResourceLinkAction' }
    & FlightsResourceLinkActionFragmentFragment
  ) | { __typename: 'FlightsResourceRedirectAction' } | { __typename: 'FlightsSearchCriteriaChangeAction' } | { __typename: 'FlightsSelectionAction' } | { __typename: 'FlightsSwitchToggleAction' } | { __typename: 'InsuranceSwitchToggleAction' } | { __typename: 'MultiItemSelectPackage' } | { __typename: 'MultiItemSelectProducts' } };

export type FlightsResourceLinkActionFragmentFragment = { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragmentFragment
  )>, resource: { __typename: 'GeoURI' } | (
    { __typename: 'HttpURI' }
    & HttpUriFragmentFragment
  ) | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | (
    { __typename: 'TelURI' }
    & TelUriFragmentFragment
  ) | { __typename: 'Uri' } };

export type FlightsRefreshActionFragmentFragment = { __typename: 'FlightsRefreshAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragmentFragment
  )> };

export type HttpUriFragmentFragment = { __typename: 'HttpURI', relativePath: string, value: string };

export type TelUriFragmentFragment = { __typename: 'TelURI', phoneNumber: string, value: string };

export type FlightsShoppingPwaFlightServicingConfirmationResultsQueryVariables = Exact<{
  context: ContextInput;
  flightsServicingConfirmationCriteria: FlightsServicingConfirmationCriteriaInput;
}>;


export type FlightsShoppingPwaFlightServicingConfirmationResultsQuery = { __typename: 'Query', flightsServicingConfirmation: { __typename: 'FlightsServicingConfirmationResponse', confirmationHeading: string, clientMetadata: { __typename: 'FlightsPWAMetadata', pageName: string, pageNameAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsConfirmationFragmentFragment
      ), pageAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsConfirmationFragmentFragment
      )> }, errorMessaging?: Maybe<{ __typename: 'FlightServicingBookingFailure', emptyState?: Maybe<(
        { __typename: 'FlightServicingBookingEmptyState' }
        & FlightServicingBookingEmptyStateConfirmationFragmentFragment
      )> }> } };

export type FlightsAnalyticsConfirmationFragmentFragment = { __typename: 'FlightsAnalytics', linkName: string, referrerId: string };

export type ClientSideAnalyticsConfirmationFragmentFragment = { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> };

export type FlightServicingBookingEmptyStateConfirmationFragmentFragment = { __typename: 'FlightServicingBookingEmptyState', presentation: { __typename: 'UIEmptyState', heading?: Maybe<string>, body: string, icon?: Maybe<{ __typename: 'Icon', description: string, id: string, token: string }>, primaryButton?: Maybe<{ __typename: 'UIPrimaryButton', accessibility?: Maybe<string>, primary?: Maybe<string> }> }, primaryAction: { __typename: 'FlightsAncillaryContinueAction' } | (
    { __typename: 'FlightsBookingAction' }
    & FlightsBookingActionFragmentFragment
  ) | { __typename: 'FlightsBoundNavigation' } | { __typename: 'FlightsClickAction' } | { __typename: 'FlightsCreditClearAction' } | { __typename: 'FlightsCreditSelectionAction' } | { __typename: 'FlightsCreditSelectorOpenAction' } | { __typename: 'FlightsDialogCloseAction' } | { __typename: 'FlightsDialogTriggerAction' } | { __typename: 'FlightsFareTypeSelectionAction' } | { __typename: 'FlightsLegDropdownItemSelection' } | { __typename: 'FlightsLoadAncillariesAction' } | { __typename: 'FlightsNavigateToDetails' } | { __typename: 'FlightsRedirectOrDialog' } | { __typename: 'FlightsRefreshAction' } | { __typename: 'FlightsRemovePriceMatchPromiseAction' } | { __typename: 'FlightsResourceLinkAction' } | { __typename: 'FlightsResourceRedirectAction' } | { __typename: 'FlightsSearchCriteriaChangeAction' } | { __typename: 'FlightsSelectionAction' } | { __typename: 'FlightsSwitchToggleAction' } | { __typename: 'InsuranceSwitchToggleAction' } | { __typename: 'MultiItemSelectPackage' } | { __typename: 'MultiItemSelectProducts' } };

export type FlightsBookingActionFragmentFragment = { __typename: 'FlightsBookingAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsConfirmationFragmentFragment
  )> };

export type FlightsSearchMetadataQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext: FlightsSearchContextInput;
  journeyCriteria: FlightsJourneyCriteriaInput;
}>;


export type FlightsSearchMetadataQuery = { __typename: 'Query', flightsSearchMetadata: { __typename: 'FlightsMetadata', pageName?: Maybe<string>, pageAnalytics?: Maybe<(
      { __typename: 'ClientSideImpressionEventAnalytics' }
      & ClientSideImpressionEventAnalyticsFragmentFragment
    )>, messaging?: Maybe<{ __typename: 'FlightsMessaging', primary: string, secondary?: Maybe<string> }> } };

export type ClientSideImpressionEventAnalyticsFragmentFragment = { __typename: 'ClientSideImpressionEventAnalytics', linkName?: Maybe<string>, referrerId: string, event: string };

export type InitiateMultiItemSessionMutationVariables = Exact<{
  context: ContextInput;
  searchContext: MultiItemSearchContextInput;
}>;


export type InitiateMultiItemSessionMutation = { __typename: 'Mutation', multiItemShopping: { __typename: 'MultiItemSessionMutations', initiate: { __typename: 'MultiItemSearchContextCreatedResponse', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'MultiItemSearchContextErrorResponse', message?: Maybe<string> } } };

export type FlightsShoppingPwaFlightSearchFormLoadedQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext?: Maybe<FlightsSearchContextInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  travelerDetails?: Maybe<Array<FlightsTravelerDetailsInput> | FlightsTravelerDetailsInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
}>;


export type FlightsShoppingPwaFlightSearchFormLoadedQuery = { __typename: 'Query', flightsSearch: { __typename: 'FlightsSearchResponse', searchForm?: Maybe<{ __typename: 'FlightsLoadedSearchForm', accessibilityMessage?: Maybe<string>, appliedFilterCount?: Maybe<number>, closeActionAccessibility?: Maybe<string>, originAndDestinationLocations?: Maybe<string>, searchAction?: Maybe<string>, searchActionAccessibility?: Maybe<string>, airportDropdownEnabled?: Maybe<boolean>, addJourneyAction?: Maybe<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, type: FlightsActionType, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) }>, bookingChangeLink?: Maybe<(
        { __typename: 'FlightsResourceLinkAction' }
        & FlightsResourceLinkActionFragment
      )>, collapseFormAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), departureAndReturnDates?: Maybe<{ __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> }>, errorSummary: { __typename: 'FlightsErrorSummary', header: string, linkText: string, displayAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), linkAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) }, expandFilterAction: { __typename: 'FlightsIconAndLabel', label: string, icon: { __typename: 'Icon', id: string, description: string } }, expandFormAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), expandSearchFormAction: { __typename: 'Icon', id: string, description: string }, closeFormAction?: Maybe<{ __typename: 'FlightsAction', displayAction: string, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) }>, journeys: Array<{ __typename: 'FlightsSearchFormJourneyCriteria', departureDate: (
          { __typename: 'FlightsSearchFormDateField' }
          & FlightsDateFragment
        ), destinationLocation: { __typename: 'FlightsSearchFormLocationField', currentError?: Maybe<string>, label: string, placeholder: string, value?: Maybe<string>, airportCode?: Maybe<string>, airportLocationType?: Maybe<AirportLocationType>, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), onTypeAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), icon: { __typename: 'Icon', id: string, description: string }, possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ) }> }, label: (
          { __typename: 'FlightsSimpleLocalizationTemplate' }
          & FlightsSimpleLocalizationTemplateFragment
        ), originLocation: { __typename: 'FlightsSearchFormLocationField', currentError?: Maybe<string>, label: string, placeholder: string, value?: Maybe<string>, airportCode?: Maybe<string>, airportLocationType?: Maybe<AirportLocationType>, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), onTypeAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), icon: { __typename: 'Icon', id: string, description: string }, possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ) }> }, returnDate?: Maybe<(
          { __typename: 'FlightsSearchFormDateField' }
          & FlightsDateFragment
        )>, removeJourneyAction?: Maybe<{ __typename: 'FlightsAction', displayAction: string, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), accessibilityUsageMessage?: Maybe<(
            { __typename: 'FlightsSimpleLocalizationTemplate' }
            & FlightsSimpleLocalizationTemplateFragment
          )> }>, swapLocationsAction: { __typename: 'FlightsSwapLocationAction', accessibilityMessage: string, icon: { __typename: 'FlightsResponsiveIcon', smallView: { __typename: 'Icon', id: string, size?: Maybe<IconSize> }, largeView: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } }, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), multiDestAccessibilityMessage: (
            { __typename: 'FlightsSimpleLocalizationTemplate' }
            & FlightsSimpleLocalizationTemplateFragment
          ), accessibilityUsageMessage: (
            { __typename: 'FlightsSimpleLocalizationTemplate' }
            & FlightsSimpleLocalizationTemplateFragment
          ) } }>, newJourneyTemplate: { __typename: 'FlightsSearchFormJourneyCriteria', departureDate: { __typename: 'FlightsSearchFormDateField', currentError?: Maybe<string>, dateFormat: string, daysBookableInAdvance: number, label: string, placeholder: string, doneAction: string, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), handleClickAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), date?: Maybe<{ __typename: 'Date', day: number, month: number, year: number, formatted: string, isoFormat: string, shortDateFormat?: Maybe<string> }>, possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ) }> }, destinationLocation: { __typename: 'FlightsSearchFormLocationField', currentError?: Maybe<string>, label: string, placeholder: string, value?: Maybe<string>, airportCode?: Maybe<string>, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), onTypeAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), icon: { __typename: 'Icon', id: string, description: string }, possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ) }> }, originLocation: { __typename: 'FlightsSearchFormLocationField', currentError?: Maybe<string>, label: string, placeholder: string, value?: Maybe<string>, airportCode?: Maybe<string>, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), onTypeAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), icon: { __typename: 'Icon', id: string, description: string }, possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ) }> }, returnDate?: Maybe<{ __typename: 'FlightsSearchFormDateField', currentError?: Maybe<string>, dateFormat: string, daysBookableInAdvance: number, label: string, placeholder: string, doneAction: string, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), handleClickAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), date?: Maybe<{ __typename: 'Date', day: number, month: number, year: number, formatted: string, isoFormat: string, shortDateFormat?: Maybe<string> }>, possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ) }> }>, label: (
          { __typename: 'FlightsSimpleLocalizationTemplate' }
          & FlightsSimpleLocalizationTemplateFragment
        ), removeJourneyAction?: Maybe<{ __typename: 'FlightsAction', displayAction: string, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), accessibilityUsageMessage?: Maybe<(
            { __typename: 'FlightsSimpleLocalizationTemplate' }
            & FlightsSimpleLocalizationTemplateFragment
          )> }>, swapLocationsAction: { __typename: 'FlightsSwapLocationAction', accessibilityMessage: string, icon: { __typename: 'FlightsResponsiveIcon', smallView: { __typename: 'Icon', id: string, size?: Maybe<IconSize> }, largeView: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } }, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), multiDestAccessibilityMessage: (
            { __typename: 'FlightsSimpleLocalizationTemplate' }
            & FlightsSimpleLocalizationTemplateFragment
          ), accessibilityUsageMessage: (
            { __typename: 'FlightsSimpleLocalizationTemplate' }
            & FlightsSimpleLocalizationTemplateFragment
          ) } }, searchActionAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), searchOptions: Array<{ __typename: 'FlightsSearchFormAirlineOption', label: string, doneAction: string, doneActionAccessibility?: Maybe<string>, icon: { __typename: 'Icon', id: string, description: string }, fieldIcon: { __typename: 'Icon', id: string, description: string }, applyAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), cancelAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), openAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), items: Array<{ __typename: 'FlightsSearchFormAirlineOptionItem', airline: string, label: string, selected: boolean, airlineSelectedAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ) }>, selectedItem: { __typename: 'FlightsSearchFormAirlineOptionItem', airline: string, label: string }, closeIcon?: Maybe<{ __typename: 'FlightsIconAndAccessibility', accessibility?: Maybe<string> }> } | { __typename: 'FlightsSearchFormCabinClassOption', label: string, icon: { __typename: 'Icon', id: string, description: string }, fieldIcon: { __typename: 'Icon', id: string, description: string }, openAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), items: Array<{ __typename: 'FlightsSearchFormCabinClassOptionItem', cabinClass: FlightsCabinClass, label: string, selected: boolean, cabinClassSelectedAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ) }>, selectedItem: { __typename: 'FlightsSearchFormCabinClassOptionItem', cabinClass: FlightsCabinClass, label: string } } | { __typename: 'FlightsSearchFormMoreFiltersOption', label: string, doneAction: string, icon: { __typename: 'Icon', id: string, description: string }, openAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), items: Array<{ __typename: 'FlightsSearchFormMoreFiltersOptionItem', advancedFilterType: FlightsAdvancedFilterType, label: string, selected: boolean, advancedFilterSelectedAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), advancedFilterRemoveAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ) }> } | { __typename: 'FlightsSearchFormTravelersOption', label: string, travelerLimitLabel: string, cancelAction: string, doneAction: string, currentErrors?: Maybe<Array<Maybe<string>>>, doneActionAccessibility?: Maybe<string>, cancelActionAccessibility?: Maybe<string>, icon: { __typename: 'Icon', id: string, description: string }, fieldIcon: { __typename: 'Icon', id: string, description: string }, ageRulesLink: { __typename: 'FlightsLinkAction', accessibility?: Maybe<string>, displayAction: string, url: any, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ) }, applyAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), cancelAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), changeAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), adultSelectedAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), childrenSelectedAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), infantSelectedAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), infantLapAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), infantSeatAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), openAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ) }>, valueTemplate: { __typename: 'FlightsMultiPluralLocalizationTemplate', oneTemplate: string, manyTemplate: string, tokens: Array<string>, fewTemplate: string, otherTemplate: string, twoTemplate: string, zeroTemplate: string }, items: Array<{ __typename: 'FlightsSearchFormTravelerInfantOptionItem', caption?: Maybe<string>, currentError?: Maybe<string>, increaseCountAccessibility?: Maybe<string>, decreaseCountAccessibility?: Maybe<string>, label: string, max: number, minCount: number, travelerCount: number, type: FlightsTravelerType, infantsOption: { __typename: 'FlightsSearchFormTravelerInfantsOption', label: string, items: Array<{ __typename: 'FlightsSearchFormTravelerInfantsSelection', label: string, selected: boolean, type: FlightsTravelerType }> }, decreaseCountAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), increaseCountAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), travelerAgeSelectorTemplate?: Maybe<{ __typename: 'FlightsTravelerAgeSelector', placeholder: string, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ), items: Array<{ __typename: 'FlightsSearchFormTravelerAgeOptionItem', label: string, selected: boolean, value: number }>, label: (
              { __typename: 'FlightsSimpleLocalizationTemplate' }
              & FlightsSimpleLocalizationTemplateFragment
            ) }>, travelerAges?: Maybe<Array<{ __typename: 'FlightsTravelerAgeSelector', placeholder: string, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ), items: Array<{ __typename: 'FlightsSearchFormTravelerAgeOptionItem', label: string, selected: boolean, value: number }>, label: (
              { __typename: 'FlightsSimpleLocalizationTemplate' }
              & FlightsSimpleLocalizationTemplateFragment
            ) }>> } | { __typename: 'FlightsSearchFormTravelersOptionItem', caption?: Maybe<string>, currentError?: Maybe<string>, increaseCountAccessibility?: Maybe<string>, decreaseCountAccessibility?: Maybe<string>, label: string, max: number, minCount: number, travelerCount: number, type: FlightsTravelerType, decreaseCountAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), increaseCountAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), travelerAgeSelectorTemplate?: Maybe<{ __typename: 'FlightsTravelerAgeSelector', placeholder: string, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ), items: Array<{ __typename: 'FlightsSearchFormTravelerAgeOptionItem', label: string, selected: boolean, value: number }>, label: (
              { __typename: 'FlightsSimpleLocalizationTemplate' }
              & FlightsSimpleLocalizationTemplateFragment
            ) }>, travelerAges?: Maybe<Array<{ __typename: 'FlightsTravelerAgeSelector', placeholder: string, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ), items: Array<{ __typename: 'FlightsSearchFormTravelerAgeOptionItem', label: string, selected: boolean, value: number }>, label: (
              { __typename: 'FlightsSimpleLocalizationTemplate' }
              & FlightsSimpleLocalizationTemplateFragment
            ) }>> }> } | { __typename: 'FlightsSearchFormTripTypeOption', label: string, icon: { __typename: 'Icon', id: string, description: string }, openAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), items: Array<{ __typename: 'FlightsSearchFormTripTypeOptionItem', label: string, selected: boolean, tripType: FlightsTripType, tripTypeSelectedAnalytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ) }> }>, availableRoutes?: Maybe<{ __typename: 'AvailableRoutes', destinationsString?: Maybe<string>, originString?: Maybe<string>, originCountries: Array<{ __typename: 'OriginCountry', countryName?: Maybe<string>, origins: Array<{ __typename: 'OriginAirport', airportName?: Maybe<string>, airportCode: string, destinationCountries: Array<{ __typename: 'DestinationCountry', countryName?: Maybe<string>, destinations: Array<{ __typename: 'DestinationAirport', airportName?: Maybe<string>, airportCode: string }> }> }> }> }> } | { __typename: 'FlightsLoadingSearchForm' }> } };

export type ClientSideAnalyticsFragment = { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> };

export type FlightsDateFragment = { __typename: 'FlightsSearchFormDateField', currentError?: Maybe<string>, dateFormat: string, daysBookableInAdvance: number, label: string, placeholder: string, doneAction: string, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), handleClickAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), date?: Maybe<{ __typename: 'Date', day: number, month: number, year: number, formatted: string, isoFormat: string }>, possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ) }> };

export type FlightsResourceLinkActionFragment = { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>, resource: { __typename: 'GeoURI' } | (
    { __typename: 'HttpURI' }
    & HttpUriFragment
  ) | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } };

export type HttpUriFragment = { __typename: 'HttpURI', relativePath: string, value: string };

export type FlightsShoppingPwaFlightSearchFormLoadingQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext?: Maybe<FlightsSearchContextInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  searchFilterValuesList?: Maybe<Array<FlightsSearchFilterValuesInput> | FlightsSearchFilterValuesInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  sortOption?: Maybe<FlightsSortOptionTypeInput>;
  travelerDetails?: Maybe<Array<FlightsTravelerDetailsInput> | FlightsTravelerDetailsInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
}>;


export type FlightsShoppingPwaFlightSearchFormLoadingQuery = { __typename: 'Query', flightsSearch: { __typename: 'FlightsSearchResponse', gaiaId?: Maybe<string>, clientMetadata?: Maybe<{ __typename: 'FlightsPWAMetadata', pageName: string, pageNameAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }>, searchForm?: Maybe<{ __typename: 'FlightsLoadedSearchForm' } | { __typename: 'FlightsLoadingSearchForm', originAndDestinationLocations?: Maybe<string>, searchAction?: Maybe<string>, airportDropdownEnabled?: Maybe<boolean>, addJourneyAction?: Maybe<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType }>, departureAndReturnDates?: Maybe<{ __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> }>, journeys: Array<{ __typename: 'FlightsSearchFormJourneyCriteria', departureDate: { __typename: 'FlightsSearchFormDateField', label: string, placeholder: string, date?: Maybe<{ __typename: 'Date', isoFormat: string }> }, label: { __typename: 'FlightsSimpleLocalizationTemplate', initialValue?: Maybe<string>, template: string, tokens: Array<string> }, destinationLocation: { __typename: 'FlightsSearchFormLocationField', label: string, placeholder: string, value?: Maybe<string>, airportCode?: Maybe<string>, airportLocationType?: Maybe<AirportLocationType>, icon: { __typename: 'Icon', id: string } }, originLocation: { __typename: 'FlightsSearchFormLocationField', label: string, placeholder: string, value?: Maybe<string>, airportCode?: Maybe<string>, airportLocationType?: Maybe<AirportLocationType>, icon: { __typename: 'Icon', id: string } }, returnDate?: Maybe<{ __typename: 'FlightsSearchFormDateField', label: string, placeholder: string, date?: Maybe<{ __typename: 'Date', isoFormat: string }> }>, removeJourneyAction?: Maybe<{ __typename: 'FlightsAction', displayAction: string }>, swapLocationsAction: { __typename: 'FlightsSwapLocationAction', icon: { __typename: 'FlightsResponsiveIcon', smallView: { __typename: 'Icon', id: string, size?: Maybe<IconSize> }, largeView: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } } } }>, searchOptions: Array<{ __typename: 'FlightsSearchFormAirlineOption', label: string, icon: { __typename: 'Icon', id: string }, selectedItem: { __typename: 'FlightsSearchFormAirlineOptionItem', airline: string, label: string } } | { __typename: 'FlightsSearchFormCabinClassOption', label: string, icon: { __typename: 'Icon', id: string }, selectedItem: { __typename: 'FlightsSearchFormCabinClassOptionItem', cabinClass: FlightsCabinClass, label: string } } | { __typename: 'FlightsSearchFormMoreFiltersOption', label: string, icon: { __typename: 'Icon', id: string } } | { __typename: 'FlightsSearchFormTravelersOption', label: string, icon: { __typename: 'Icon', id: string }, valueTemplate: { __typename: 'FlightsMultiPluralLocalizationTemplate', oneTemplate: string, manyTemplate: string, tokens: Array<string>, fewTemplate: string, otherTemplate: string, twoTemplate: string, zeroTemplate: string }, items: Array<{ __typename: 'FlightsSearchFormTravelerInfantOptionItem', label: string, travelerCount: number, type: FlightsTravelerType } | { __typename: 'FlightsSearchFormTravelersOptionItem', label: string, travelerCount: number, type: FlightsTravelerType }> } | { __typename: 'FlightsSearchFormTripTypeOption', icon: { __typename: 'Icon', id: string }, items: Array<{ __typename: 'FlightsSearchFormTripTypeOptionItem', label: string, selected: boolean, tripType: FlightsTripType }> }>, availableRoutes?: Maybe<{ __typename: 'AvailableRoutes', destinationsString?: Maybe<string>, originString?: Maybe<string>, originCountries: Array<{ __typename: 'OriginCountry', countryName?: Maybe<string>, origins: Array<{ __typename: 'OriginAirport', airportName?: Maybe<string>, airportCode: string, destinationCountries: Array<{ __typename: 'DestinationCountry', countryName?: Maybe<string>, destinations: Array<{ __typename: 'DestinationAirport', airportName?: Maybe<string>, airportCode: string }> }> }> }> }> }> } };

export type FlightsShoppingPwaFlightSearchResultsFlightsSearchQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext?: Maybe<FlightsSearchContextInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  searchFilterValuesList?: Maybe<Array<FlightsSearchFilterValuesInput> | FlightsSearchFilterValuesInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  sortOption?: Maybe<FlightsSortOptionTypeInput>;
  rewardsOption?: Maybe<RewardsOption>;
  travelerDetails?: Maybe<Array<FlightsTravelerDetailsInput> | FlightsTravelerDetailsInput>;
  searchPagination?: Maybe<PaginationInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
  faresSeparationType?: Maybe<FlightsFaresSeparationType>;
  flightsSearchComponentCriteria?: Maybe<FlightsSearchComponentCriteriaInput>;
  fareCalendarPrice?: Maybe<Scalars['String']>;
  flightsDisplayComponentValues?: Maybe<FlightsDisplayComponentValuesInput>;
  virtualAgentContext?: Maybe<VirtualAgentContextInput>;
  flightsListingsViewType?: Maybe<FlightsListingsViewType>;
}>;


export type FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery = { __typename: 'Query', flightsSearch: { __typename: 'FlightsSearchResponse', gaiaId?: Maybe<string>, clientMetadata?: Maybe<{ __typename: 'FlightsPWAMetadata', pageName: string, responseTags?: Maybe<Array<ResponseTagType>>, pageNameAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), responseMetrics?: Maybe<Array<{ __typename: 'FlightsResponseTimeMetrics', name: FlightsMetricName, value: string }>> }>, failedRequestMessaging?: Maybe<{ __typename: 'FlightsActionableErrorMessaging', message: string, title: string, icon: { __typename: 'Icon', description: string, id: string }, action: (
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      ), errorRecoveryButtons?: Maybe<Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>> }>, noListingMessaging?: Maybe<{ __typename: 'FlightsActionableErrorMessaging', message: string, title: string, icon: { __typename: 'Icon', description: string, id: string }, action: (
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      ), errorRecoveryButtons?: Maybe<Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>> } | { __typename: 'FlightsNoFlightsFoundMessaging', message: string, title: string, icon: { __typename: 'Icon', id: string, description: string } } | { __typename: 'FlightsNoFlightsFoundWithFilterMessaging', message: string, title: string, icon: { __typename: 'Icon', id: string, description: string }, clearFiltersAction?: Maybe<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )> } | { __typename: 'FlightsSmartNoFlightsFoundMessaging', message: string, title: string, alternateAirportOptions?: Maybe<(
        { __typename: 'AlternateAirportOptions' }
        & AlternateAirportOptionsFragment
      )>, alternateDateOptions?: Maybe<(
        { __typename: 'AlternateDateOptions' }
        & AlternateDateOptionsFragment
      )>, editSearchButton?: Maybe<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, flightsDisplayComponentCountingValue?: Maybe<(
        { __typename: 'FlightsDisplayComponentCountingValue' }
        & FlightsDisplayComponentCountingValueFragment
      )>, icon: (
        { __typename: 'Icon' }
        & IconSearchFragment
      ) }>, sortAndFilterResult?: Maybe<{ __typename: 'FlightsLoadedSortAndFilterResult', title: string, filterAnalyticsList?: Maybe<Array<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )>>, appliedFiltersSummary?: Maybe<{ __typename: 'FlightsAppliedFiltersSummary', appliedFilters?: Maybe<Array<{ __typename: 'FlightsAppliedFilter', label: string, identifier: string, accessibilityMessage: string, dismissIconAccessibility?: Maybe<string>, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), dismissIcon: { __typename: 'Icon', description: string, id: string }, nextSearchSortFilterCriteria?: Maybe<{ __typename: 'FlightsSearchSortAndFilterCriteria', filterCriteria: Array<{ __typename: 'FlightsSearchFilterValues', arrivalAirportCodeFilterValue?: Maybe<{ __typename: 'FlightsAirportCodeFilterValue', airportCode: string }>, arrivalTimeFilterValue?: Maybe<{ __typename: 'FlightsTimeBasedFilterValue', timeOfDay: FlightsTimeOfDay }>, departureAirportCodeFilterValue?: Maybe<{ __typename: 'FlightsAirportCodeFilterValue', airportCode: string }>, departureTimeFilterValue?: Maybe<{ __typename: 'FlightsTimeBasedFilterValue', timeOfDay: FlightsTimeOfDay }>, durationFilterValue?: Maybe<{ __typename: 'FlightsDurationBasedFilterValue', maxDuration: number }>, numOfStopFilterValue?: Maybe<{ __typename: 'FlightsStopBasedFilterValue', stopInfo: { __typename: 'FlightsStopInfo', numberOfStops: number, stopFilterOperation: FlightsStopFilterOperation } }>, preferredAirlineFilterValue?: Maybe<{ __typename: 'FlightsPreferredAirlineFilterValue', carrierCode: string }>, flexibleChangePolicyBasedFilterValue?: Maybe<{ __typename: 'FlightsFlexibleChangePolicyBasedFilterValue', policyName: FilterPolicyType }>, seatChoiceBasedFilterValue?: Maybe<{ __typename: 'FlightsSeatChoiceBasedFilterValue', seatChoice: SeatChoiceType }>, carryOnBagBasedFilterValue?: Maybe<{ __typename: 'FlightsCarryOnBagBasedFilterValue', carryOnBag: CarryOnBagType }>, checkedBagBasedFilterValue?: Maybe<{ __typename: 'FlightsCheckedBagBasedFilterValue', numOfCheckedBags: number }>, noCancelFeeBasedFilterValue?: Maybe<{ __typename: 'FlightsNoCancelFeeBasedFilterValue', noCancelFee: NoCancelFeeType }>, creditEligibleFilterValue?: Maybe<{ __typename: 'FlightsCreditEligibleFilterValue', creditEligible: CreditEligibleFilterType }> }> }> }>> }>, applyAction: { __typename: 'FlightsSortAndFilterAction', details?: Maybe<string>, label: string, accessibility: { __typename: 'FlightsAccessibilityMessage', onCompletion?: Maybe<string>, usage?: Maybe<string> }, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) }, clearSelectionLabel: { __typename: 'FlightsActionableLabel', label: string, analytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, accessibility?: Maybe<{ __typename: 'FlightsAccessibilityMessage', onCompletion?: Maybe<string>, usage?: Maybe<string> }> }, clearAllSelectionLabel: { __typename: 'FlightsActionableLabel', label: string, analytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, accessibility?: Maybe<{ __typename: 'FlightsAccessibilityMessage', onCompletion?: Maybe<string>, usage?: Maybe<string> }> }, dismiss: { __typename: 'Icon', description: string, id: string }, dismissAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), revealAction: { __typename: 'FlightsSortAndFilterRevealAction', appliedFilterCount?: Maybe<number>, enabled: boolean, accessibility?: Maybe<{ __typename: 'FlightsAccessibilityMessage', onCompletion?: Maybe<string>, usage?: Maybe<string> }>, iconAndLabel: { __typename: 'FlightsIconAndLabel', label: string, icon: { __typename: 'Icon', description: string, id: string } } }, revealActionAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), sortPresentation: { __typename: 'FlightsSortLoadedPresentation', label: string, selectionActive: boolean, options: Array<{ __typename: 'FlightsSortOptionItem', label: string, accessibility?: Maybe<{ __typename: 'FlightsAccessibilityMessage', onCompletion?: Maybe<string>, usage?: Maybe<string> }>, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ), sortType: { __typename: 'FlightsSortOptionType', sortOrder: FlightsSortOrder, sortType: FlightsSortType } }>, selectedOption: { __typename: 'FlightsSortOptionItem', label: string, sortType: { __typename: 'FlightsSortOptionType', sortOrder: FlightsSortOrder, sortType: FlightsSortType } } }, filterPresentation?: Maybe<{ __typename: 'FlightsFilterLoadedPresentation', title?: Maybe<string>, emptyFiltersMessage?: Maybe<string>, accessibility: { __typename: 'FlightsAccessibilityMessage', onCompletion?: Maybe<string>, usage?: Maybe<string> }, eventAnalytics: (
          { __typename: 'FlightsFiltersEventAnalytics' }
          & FlightsFiltersEventAnalyticsFragment
        ), options?: Maybe<Array<{ __typename: 'FlightsCardsDisplayFilterOption', label: string, type: FlightsFilterType, supportsMultipleSelection: boolean, items: Array<(
            { __typename: 'FlightsCardsDisplayFilterItem' }
            & FlightsCardsDisplayFilterItemFragment
          )> } | { __typename: 'FlightsListDisplayFilterOption', itemsDefaultDisplayCount: number, label: string, priceFromLabel?: Maybe<string>, supportsMultipleSelection: boolean, type: FlightsFilterType, items: Array<(
            { __typename: 'FlightsListDisplayFilterItem' }
            & FlightsListDisplayFilterItemFragment
          )>, showMoreToggle?: Maybe<(
            { __typename: 'FlightsToggle' }
            & FlightsToggleSearchFragment
          )> } | { __typename: 'FlightsSliderDisplayFilterOption' }>> }> } | { __typename: 'FlightsLoadingSortAndFilterResult' }>, listingResult?: Maybe<{ __typename: 'FlightsLoadedListingResult', pinnedListingUnavailableMessage?: Maybe<string>, accessibilityMessage?: Maybe<string>, appliedFilterAccessibility?: Maybe<string>, showMoreListingLoadedAccessibilityMessage?: Maybe<string>, appliedSortingAccessibility?: Maybe<string>, moreListingsAvailable?: Maybe<string>, listings?: Maybe<Array<(
        { __typename: 'EGDSElementWrapper' }
        & FlightsEgdsElementWrapperFragment
      ) | (
        { __typename: 'FlightsBargainFareOffer' }
        & FlightsBargainFareOfferFragment
      ) | { __typename: 'FlightsCarryOverFiltersCard' } | (
        { __typename: 'FlightsCouponCredit' }
        & FlightsCouponCreditFragment
      ) | (
        { __typename: 'FlightsCreditsAvailableListing' }
        & FlightsCreditsAvailableListingFragment
      ) | (
        { __typename: 'FlightsCrossSellMessage' }
        & FlightsCrossSellMessageFragment
      ) | (
        { __typename: 'FlightsCrossSellOffer' }
        & FlightsCrossSellOfferFragment
      ) | { __typename: 'FlightsElementsWrapper' } | { __typename: 'FlightsEmailSubscription' } | (
        { __typename: 'FlightsFeedback' }
        & FlightsFeedbackFragment
      ) | (
        { __typename: 'FlightsListingMessagingCard' }
        & FlightsListingMessagingCardFragment
      ) | { __typename: 'FlightsListingOffer' } | { __typename: 'FlightsOfferCard' } | { __typename: 'FlightsPriceAlertsListing' } | { __typename: 'FlightsSocialProofMessage' } | (
        { __typename: 'FlightsSponsoredContentAdListing' }
        & FlightsSponsoredContentAdListingFragment
      ) | (
        { __typename: 'FlightsStandardOffer' }
        & FlightsStandardOfferFragment
      ) | (
        { __typename: 'FlightsSuggestedFilterMessageListing' }
        & FlightsSuggestedFilterMessageListingFragment
      ) | (
        { __typename: 'FlightsSustainabilityMessage' }
        & FlightsSustainabilityMessageFragment
      )>>, flightsListingsAnalytics: { __typename: 'FlightsListingsAnalytics', onViewedAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ), onViewedAnalyticsList: Array<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, pinnedListingDisplayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, moreListingsDisplayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, moreListingsErrorAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, moreListingsLoadTimeAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, fareCalendarAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, fareUpsellPercentageAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, bestBetsDisplayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, bestSortDisplayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, urgencyMessageAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>, nonstopSectionDisplayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )> }, listingsAction?: Maybe<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )> } | { __typename: 'FlightsLoadingListingResult' } | { __typename: 'FlightsProgressBarDetails' }>, flightsOpinionLab?: Maybe<{ __typename: 'FlightsActionAndLabel', label: string, selectAction: (
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      ) }>, rewardsPricingInfo?: Maybe<(
      { __typename: 'FlightsRewardsPricingInfo' }
      & FlightsRewardsPricingInfoFragment
    )>, pageTitle?: Maybe<(
      { __typename: 'FlightsPageTitle' }
      & PageTitleFragment
    )>, dialogs?: Maybe<Array<{ __typename: 'BookWithAirlinesDialog' } | { __typename: 'FlightsDialogChangeFlight' } | { __typename: 'FlightsDialogMultiPassengerCredit' } | { __typename: 'FlightsDialogServerError' } | { __typename: 'FlightsDialogStaleSession', animation: FlightsDialogAnimation, header: string, message?: Maybe<string>, timeoutInSeconds: number, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } | { __typename: 'FlightsDialogStandard', animation: FlightsDialogAnimation, title?: Maybe<string>, header: string, message?: Maybe<string>, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } | { __typename: 'FlightsForcedChoiceCrossSellDialog', animation: FlightsDialogAnimation, header: string, message?: Maybe<string>, displayCounter?: Maybe<number>, hotelDatesTitle?: Maybe<string>, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, annotation: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', link: any, styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }, messageBody: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | (
        { __typename: 'EGDSGraphicText' }
        & EgdsGraphicTextFragmentFragment
      ) | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText' } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, displayedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), displayBlockedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), checkInDate?: Maybe<(
        { __typename: 'FlightsSearchFormDateField' }
        & HotelsDateFragment
      )>, checkOutDate?: Maybe<(
        { __typename: 'FlightsSearchFormDateField' }
        & HotelsDateFragment
      )> }>>, banners?: Maybe<Array<(
      { __typename: 'FlightsIconPlacard' }
      & FlightsIconPlacardFragment
    ) | { __typename: 'FlightsImagePlacard' } | { __typename: 'FlightsMarkPlacard' }>>, allBanners?: Maybe<Array<(
      { __typename: 'FlightsIconPlacard' }
      & FlightsIconPlacardFragment
    ) | { __typename: 'FlightsImagePlacard' } | { __typename: 'FlightsMarkPlacard' }>>, cheapestListingInfo?: Maybe<{ __typename: 'FlightsCheapestListingInfo', price: string, analytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), nffAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), deviationAnalytics?: Maybe<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )> }>, stepIndicator?: Maybe<(
      { __typename: 'FlightsStepIndicator' }
      & FlightsStepIndicatorFragment
    )>, flightsReviewLoadingElements?: Maybe<{ __typename: 'FlightsReviewLoadingElements', freeCancellation: { __typename: 'FlightsIconPlacard' } | { __typename: 'FlightsImagePlacard', heading?: Maybe<string>, message: string, image: { __typename: 'Image', url: any, description: string } } | { __typename: 'FlightsMarkPlacard' }, flightsJourneyReviewCommon: Array<{ __typename: 'FlightsJourneyReviewCommon', fareSummarySkeletonCount: number, flightSummarySkeletonCount: number, changeFlight: (
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        ) }>, clientMetaData: (
        { __typename: 'FlightsPWAMetadata' }
        & ClientMetaDataFragment
      ), pageTitle: (
        { __typename: 'FlightsPageTitle' }
        & PageTitleFragment
      ), priceSummary: { __typename: 'FlightsLoadingPriceSummary', title: string, skeletonCount: number, tripTotalLabel: string, buttonAction: (
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        ) } }>, shoppingContext?: Maybe<{ __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> }>, listingsHeaderPlacards?: Maybe<Array<(
      { __typename: 'FlightsMessagingCardPlacard' }
      & FlightsMessagingCardPlacardFragmentFragment
    )>> } };

export type FlightsCardsDisplayFilterItemFragment = { __typename: 'FlightsCardsDisplayFilterItem', label: string, identifier: string, subLabel: string, selected: boolean, accessibility?: Maybe<{ __typename: 'FlightsAccessibilityMessage', onCompletion?: Maybe<string>, usage?: Maybe<string> }>, card: { __typename: 'Icon', id: string, description: string }, deselectAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), flightsSearchFilterValues: { __typename: 'FlightsSearchFilterValues', arrivalAirportCodeFilterValue?: Maybe<{ __typename: 'FlightsAirportCodeFilterValue', airportCode: string }>, arrivalTimeFilterValue?: Maybe<{ __typename: 'FlightsTimeBasedFilterValue', timeOfDay: FlightsTimeOfDay }>, departureAirportCodeFilterValue?: Maybe<{ __typename: 'FlightsAirportCodeFilterValue', airportCode: string }>, departureTimeFilterValue?: Maybe<{ __typename: 'FlightsTimeBasedFilterValue', timeOfDay: FlightsTimeOfDay }>, durationFilterValue?: Maybe<{ __typename: 'FlightsDurationBasedFilterValue', maxDuration: number }>, numOfStopFilterValue?: Maybe<{ __typename: 'FlightsStopBasedFilterValue', stopInfo: { __typename: 'FlightsStopInfo', stopFilterOperation: FlightsStopFilterOperation, numberOfStops: number } }>, preferredAirlineFilterValue?: Maybe<{ __typename: 'FlightsPreferredAirlineFilterValue', carrierCode: string }>, flexibleChangePolicyBasedFilterValue?: Maybe<{ __typename: 'FlightsFlexibleChangePolicyBasedFilterValue', policyName: FilterPolicyType }>, seatChoiceBasedFilterValue?: Maybe<{ __typename: 'FlightsSeatChoiceBasedFilterValue', seatChoice: SeatChoiceType }>, carryOnBagBasedFilterValue?: Maybe<{ __typename: 'FlightsCarryOnBagBasedFilterValue', carryOnBag: CarryOnBagType }>, checkedBagBasedFilterValue?: Maybe<{ __typename: 'FlightsCheckedBagBasedFilterValue', numOfCheckedBags: number }>, noCancelFeeBasedFilterValue?: Maybe<{ __typename: 'FlightsNoCancelFeeBasedFilterValue', noCancelFee: NoCancelFeeType }>, creditEligibleFilterValue?: Maybe<{ __typename: 'FlightsCreditEligibleFilterValue', creditEligible: CreditEligibleFilterType }> }, selectAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), value: { __typename: 'FlightsAirportCodeFilterValue', airportCode: string } | { __typename: 'FlightsCarryOnBagBasedFilterValue', carryOnBag: CarryOnBagType } | { __typename: 'FlightsCheckedBagBasedFilterValue', numOfCheckedBags: number } | { __typename: 'FlightsCreditEligibleFilterValue', creditEligible: CreditEligibleFilterType } | { __typename: 'FlightsDurationBasedFilterValue', maxDuration: number } | { __typename: 'FlightsFlexibleChangePolicyBasedFilterValue', policyName: FilterPolicyType } | { __typename: 'FlightsNoCancelFeeBasedFilterValue', noCancelFee: NoCancelFeeType } | { __typename: 'FlightsNoChangeFeeBasedFilterValue' } | { __typename: 'FlightsPreferredAirlineFilterValue', carrierCode: string } | { __typename: 'FlightsSeatChoiceBasedFilterValue', seatChoice: SeatChoiceType } | { __typename: 'FlightsStopBasedFilterValue', stopInfo: { __typename: 'FlightsStopInfo', stopFilterOperation: FlightsStopFilterOperation, numberOfStops: number } } | { __typename: 'FlightsTimeBasedFilterValue', timeOfDay: FlightsTimeOfDay } | { __typename: 'FlightsTravelAndBaggageBasedFilterValue' } };

export type FlightsListDisplayFilterItemFragment = { __typename: 'FlightsListDisplayFilterItem', label: string, identifier: string, selected: boolean, formattedMultiItemStartingPrice?: Maybe<string>, selectPositionAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, analytics: (
    { __typename: 'FlightsFilterItemAnalytics' }
    & FlightsFilterItemAnalyticsFragment
  ), accessibility?: Maybe<{ __typename: 'FlightsAccessibilityMessage', onCompletion?: Maybe<string>, usage?: Maybe<string> }>, deselectAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), flightsSearchFilterValues: { __typename: 'FlightsSearchFilterValues', arrivalAirportCodeFilterValue?: Maybe<{ __typename: 'FlightsAirportCodeFilterValue', airportCode: string }>, arrivalTimeFilterValue?: Maybe<{ __typename: 'FlightsTimeBasedFilterValue', timeOfDay: FlightsTimeOfDay }>, departureAirportCodeFilterValue?: Maybe<{ __typename: 'FlightsAirportCodeFilterValue', airportCode: string }>, departureTimeFilterValue?: Maybe<{ __typename: 'FlightsTimeBasedFilterValue', timeOfDay: FlightsTimeOfDay }>, durationFilterValue?: Maybe<{ __typename: 'FlightsDurationBasedFilterValue', maxDuration: number }>, numOfStopFilterValue?: Maybe<{ __typename: 'FlightsStopBasedFilterValue', stopInfo: { __typename: 'FlightsStopInfo', stopFilterOperation: FlightsStopFilterOperation, numberOfStops: number } }>, preferredAirlineFilterValue?: Maybe<{ __typename: 'FlightsPreferredAirlineFilterValue', carrierCode: string }>, flexibleChangePolicyBasedFilterValue?: Maybe<{ __typename: 'FlightsFlexibleChangePolicyBasedFilterValue', policyName: FilterPolicyType }>, seatChoiceBasedFilterValue?: Maybe<{ __typename: 'FlightsSeatChoiceBasedFilterValue', seatChoice: SeatChoiceType }>, carryOnBagBasedFilterValue?: Maybe<{ __typename: 'FlightsCarryOnBagBasedFilterValue', carryOnBag: CarryOnBagType }>, checkedBagBasedFilterValue?: Maybe<{ __typename: 'FlightsCheckedBagBasedFilterValue', numOfCheckedBags: number }>, noCancelFeeBasedFilterValue?: Maybe<{ __typename: 'FlightsNoCancelFeeBasedFilterValue', noCancelFee: NoCancelFeeType }>, creditEligibleFilterValue?: Maybe<{ __typename: 'FlightsCreditEligibleFilterValue', creditEligible: CreditEligibleFilterType }> }, selectAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), startingPrice?: Maybe<{ __typename: 'Money', formatted: string }>, value: { __typename: 'FlightsAirportCodeFilterValue', airportCode: string } | { __typename: 'FlightsCarryOnBagBasedFilterValue', carryOnBag: CarryOnBagType } | { __typename: 'FlightsCheckedBagBasedFilterValue', numOfCheckedBags: number } | { __typename: 'FlightsCreditEligibleFilterValue', creditEligible: CreditEligibleFilterType } | { __typename: 'FlightsDurationBasedFilterValue', maxDuration: number } | { __typename: 'FlightsFlexibleChangePolicyBasedFilterValue', policyName: FilterPolicyType } | { __typename: 'FlightsNoCancelFeeBasedFilterValue', noCancelFee: NoCancelFeeType } | { __typename: 'FlightsNoChangeFeeBasedFilterValue' } | { __typename: 'FlightsPreferredAirlineFilterValue', carrierCode: string } | { __typename: 'FlightsSeatChoiceBasedFilterValue', seatChoice: SeatChoiceType } | { __typename: 'FlightsStopBasedFilterValue', stopInfo: { __typename: 'FlightsStopInfo', stopFilterOperation: FlightsStopFilterOperation, numberOfStops: number } } | { __typename: 'FlightsTimeBasedFilterValue', timeOfDay: FlightsTimeOfDay } | { __typename: 'FlightsTravelAndBaggageBasedFilterValue' } };

export type FlightsBargainFareOfferFragment = { __typename: 'FlightsBargainFareOffer', accessibilityHeading?: Maybe<string>, journeyContinuationId?: Maybe<string>, stepIndicatorJcid?: Maybe<string>, bargainOfferAccessibilityMessage: string, bargainPricingInformation?: Maybe<{ __typename: 'FlightsPricingInformation', cancellationMessage?: Maybe<string>, taxesLabel?: Maybe<string>, totalLabel: string, tripType?: Maybe<string>, subText?: Maybe<Array<string>>, priceLockup: (
      { __typename: 'EGDSPriceLockup' }
      & PriceLockupFragmentFragment
    ), price: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }, mainPrice: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }, pricePerTraveler: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }, totalPriceForAllTravelers?: Maybe<{ __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }> }>, description: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', link: any, styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }, header: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', link: any, text: string, styles: Array<FlightsPhrasePartStyle>, analytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, image: { __typename: 'Image', url: any }, journeys: Array<{ __typename: 'FlightsOfferJourney', flightsJourneyAvailableFaresInformation?: Maybe<(
      { __typename: 'FlightsJourneyAvailableFares' }
      & FlightsJourneyAvailableFaresFragment
    )>, flightsDetailsAndFaresPresentation: (
      { __typename: 'FlightsDetailsAndFaresPresentation' }
      & FlightsDetailsAndFaresPresentationFragmentFragment
    ) }>, onClickAnalyticsList: Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsSuggestedFilterMessageListingFragment = { __typename: 'FlightsSuggestedFilterMessageListing', suggestedFilterDetails: { __typename: 'FlightsImagePlacard', heading?: Maybe<string>, message: string, image: { __typename: 'Image', url: any }, actions?: Maybe<Array<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType, type: FlightsActionType, analytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }>> }, suggestedFilter: { __typename: 'FlightsSuggestedFilterItem', selected: boolean, identifier: string, label: string, type: FlightsFilterType, accessibility?: Maybe<{ __typename: 'FlightsAccessibilityMessage', usage?: Maybe<string>, onCompletion?: Maybe<string> }>, value: { __typename: 'FlightsAirportCodeFilterValue' } | { __typename: 'FlightsCarryOnBagBasedFilterValue' } | { __typename: 'FlightsCheckedBagBasedFilterValue' } | { __typename: 'FlightsCreditEligibleFilterValue' } | { __typename: 'FlightsDurationBasedFilterValue' } | { __typename: 'FlightsFlexibleChangePolicyBasedFilterValue', policyName: FilterPolicyType } | { __typename: 'FlightsNoCancelFeeBasedFilterValue' } | { __typename: 'FlightsNoChangeFeeBasedFilterValue' } | { __typename: 'FlightsPreferredAirlineFilterValue' } | { __typename: 'FlightsSeatChoiceBasedFilterValue' } | { __typename: 'FlightsStopBasedFilterValue' } | { __typename: 'FlightsTimeBasedFilterValue' } | { __typename: 'FlightsTravelAndBaggageBasedFilterValue' } } };

export type FlightsSustainabilityMessageFragment = { __typename: 'FlightsSustainabilityMessage', details: (
    { __typename: 'FlightsSustainabilityDialogDetails' }
    & FlightsSustainabilityDialogDetailsFragment
  ), information: (
    { __typename: 'FlightsIconPlacard' }
    & FlightsIconPlacardFragment
  ) };

export type FlightsSustainabilityDialogDetailsFragment = { __typename: 'FlightsSustainabilityDialogDetails', heading: string, dismiss: (
    { __typename: 'FlightsAction' }
    & FlightActionFragment
  ), closingText: (
    { __typename: 'FlightsTextSection' }
    & FlightsTextSectionFragment
  ), iconRow: { __typename: 'FlightsIconAndHeading', heading: string, icons: Array<(
      { __typename: 'FlightsIconAndLabel' }
      & FlightsIconAndLabelFragment
    )> }, introduction: Array<(
    { __typename: 'FlightsPhrase' }
    & FlightsPhraseFragment
  )> };

export type FlightsTextSectionFragment = { __typename: 'FlightsTextSection', heading?: Maybe<string>, displayAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, messages: Array<(
    { __typename: 'FlightsPhrase' }
    & FlightsPhraseFragment
  )> };

export type FlightsFeedbackFragment = { __typename: 'FlightsFeedback', feedbackLinkAction: (
    { __typename: 'FlightsAction' }
    & FlightActionFragment
  ), iconAndLabel: { __typename: 'FlightsIconAndLabel', label: string, accessibility?: Maybe<string>, icon: { __typename: 'Icon', description: string, id: string } } };

export type FlightsCouponCreditFragment = { __typename: 'FlightsCouponCredit', couponCreditAction: (
    { __typename: 'FlightsAction' }
    & FlightActionFragment
  ), imageListingLabel: (
    { __typename: 'FlightsImageListingLabel' }
    & FlightsImageListingLabelFragment
  ) };

export type FlightsImageListingLabelFragment = { __typename: 'FlightsImageListingLabel', label: string, subLabel?: Maybe<string>, image: { __typename: 'Image', url: any } };

export type MultiItemSearchContextFragment = { __typename: 'MultiItemSearchContext', flights?: Maybe<Array<{ __typename: 'FlightSearchCriteria', primary: { __typename: 'PrimaryFlightCriteria', tripType: FlightsTripType, journeyCriterias: Array<{ __typename: 'FlightsJourneyCriteria', origin: string, destination: string, departureDate: { __typename: 'Date', day: number, month: number, year: number } }>, searchPreferences?: Maybe<{ __typename: 'FlightsSearchPreferences', cabinClass: FlightsCabinClass, advancedFilters?: Maybe<Array<FlightsAdvancedFilterType>> }>, travelers: Array<{ __typename: 'TravelerDetails', age?: Maybe<number>, type: TravelerDetailsType }> } }>> };

export type FlightsEgdsElementWrapperFragment = { __typename: 'EGDSElementWrapper', element: { __typename: 'ActivitySearchForm' } | { __typename: 'AgencyUIPrimaryFloatingActionButton' } | { __typename: 'AgencyUISecondaryFloatingActionButton' } | { __typename: 'CarSearchForm' } | { __typename: 'CruiseSearchForm' } | { __typename: 'DurationSpanSelector' } | { __typename: 'EGDSBadgeNotification' } | { __typename: 'EGDSBasicCheckBox' } | (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsTextFragment_EgdsBasicLocalizedText_Fragment
  ) | { __typename: 'EGDSBasicOption' } | { __typename: 'EGDSBasicSelect' } | { __typename: 'EGDSBasicStepInput' } | { __typename: 'EGDSBasicTab' } | { __typename: 'EGDSBasicTabs' } | { __typename: 'EGDSBasicTravelerSelector' } | { __typename: 'EGDSBulletedList' } | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsTextFragment_EgdsCardinalLocalizedText_Fragment
  ) | { __typename: 'EGDSComposableTextElementSectionContainer' } | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsTextFragment_EgdsCompositeLocalizedText_Fragment
  ) | { __typename: 'EGDSEmailInputField' } | { __typename: 'EGDSErrorSummary' } | (
    { __typename: 'EGDSHeading' }
    & EgdsTextFragment_EgdsHeading_Fragment
  ) | { __typename: 'EGDSImageLink' } | { __typename: 'EGDSImageLinkCard' } | { __typename: 'EGDSInfantSeatRadioButton' } | { __typename: 'EGDSLinkList' } | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment
  ) | { __typename: 'EGDSLoyaltyBadge' } | { __typename: 'EGDSNumberInputField' } | { __typename: 'EGDSOrderedList' } | { __typename: 'EGDSOverlayButton' } | (
    { __typename: 'EGDSParagraph' }
    & EgdsTextFragment_EgdsParagraph_Fragment
  ) | { __typename: 'EGDSPasswordInputField' } | { __typename: 'EGDSProgramBadge' } | { __typename: 'EGDSRoomsTravelerSelector' } | { __typename: 'EGDSSearchFormButton' } | { __typename: 'EGDSSearchFormDatePickerField' } | { __typename: 'EGDSSearchFormInputField' } | { __typename: 'EGDSSearchFormLocationField' } | { __typename: 'EGDSSearchFormLocationsField' } | { __typename: 'EGDSSearchFormTravelersField' } | { __typename: 'EGDSSectionContainer' } | (
    { __typename: 'EGDSSpannableText' }
    & EgdsTextFragment_EgdsSpannableText_Fragment
  ) | { __typename: 'EGDSStandardBadge' } | (
    { __typename: 'EGDSStandardLink' }
    & EgdsTextFragment_EgdsStandardLink_Fragment
  ) | { __typename: 'EGDSStandardMessagingCard' } | { __typename: 'EGDSTextAreaInputField' } | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsTextFragment_EgdsTextIconLinkListItem_Fragment
  ) | { __typename: 'EGDSTextIconList' } | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsTextFragment_EgdsTextIconListItem_Fragment
  ) | { __typename: 'EGDSTextInputField' } | { __typename: 'EGDSTextListSection' } | { __typename: 'EGDSTextSection' } | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsTextFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsTextFragment_EgdsTextWithMarkListItem_Fragment
  ) | { __typename: 'EGDSToast' } | { __typename: 'EGDSTravelerChildAgeSelect' } | { __typename: 'EGDSTravelerInfantSeatSelection' } | { __typename: 'EGDSTravelerStepInput' } | { __typename: 'EGDSTypeaheadInputField' } | { __typename: 'EGDSUnorderedList' } | { __typename: 'FlightSearchForm' } | { __typename: 'FlightSearchInputForm' } | { __typename: 'FlightsActionButton' } | { __typename: 'FlightsActionCheckbox' } | { __typename: 'FlightsActionLink' } | { __typename: 'FlightsDialogTrigger' } | { __typename: 'IdentityBasicBlock' } | { __typename: 'IdentityButton' } | { __typename: 'IdentityConsentNestedCheckBox' } | { __typename: 'IdentityImage' } | { __typename: 'IdentityImageGallery' } | { __typename: 'IdentityInfoLinkComponent' } | { __typename: 'IdentityPasswordStrengthComponent' } | { __typename: 'IdentityResendButton' } | { __typename: 'IdentitySingleColumnComponentLayout' } | { __typename: 'IdentitySocialButton' } | { __typename: 'IdentityText' } | { __typename: 'Illustration' } | { __typename: 'LodgingSearchForm' } | { __typename: 'PackagesSearchForm' } | { __typename: 'ProductSummaryCard' } | { __typename: 'ProfileAccountLink' } | { __typename: 'ProfileActionButtonCard' } | { __typename: 'ProfileBulletedList' } | { __typename: 'ProfileEGDSSectionContainer' } | { __typename: 'ProfileFormHorizontalContainer' } | { __typename: 'ProfileFormSection' } | { __typename: 'ProfileLink' } | { __typename: 'ProfileNumberField' } | { __typename: 'ProfilePhoneNumberField' } | { __typename: 'ProfileRadioButton' } | { __typename: 'ProfileRadioButtonGroup' } | { __typename: 'ProfileSelectField' } | { __typename: 'ProfileSlimCard' } | { __typename: 'ProfileSwitchOption' } | { __typename: 'ProfileTextField' } | { __typename: 'SearchFormDurationSpanField' } | { __typename: 'TripsMediaGallery' } | { __typename: 'TripsValidatedInput' } | { __typename: 'UIBanner' } | { __typename: 'UIEmptyState' } | { __typename: 'UIMessagingCard' } | { __typename: 'UIPrimaryButton' } | { __typename: 'UIPrimaryFloatingActionButton' } | { __typename: 'UISecondaryButton' } | { __typename: 'UISecondaryFloatingActionButton' } | { __typename: 'UITertiaryButton' } };

export type FlightsCrossSellMessageFragment = { __typename: 'FlightsCrossSellMessage', multiItemFlightCrossSellPrimer: { __typename: 'MultiItemFlightCrossSellPrimer', flightCrossSellProductType?: Maybe<FlightCrossSellProductType>, multiItemSearchContext: (
      { __typename: 'MultiItemSearchContext' }
      & MultiItemSearchContextFragment
    ) } };

export type FlightsSponsoredContentAdListingFragment = { __typename: 'FlightsSponsoredContentAdListing', sponsoredContentPlacement: { __typename: 'SponsoredContentPlacement', productType: SponsoredContentProductType, sponsoredContentContext: { __typename: 'SponsoredContentContext', pageName: string, sponsoredContentId: string, variant?: Maybe<string>, targeting?: Maybe<{ __typename: 'SponsoredContentTargeting', adults?: Maybe<number>, destination?: Maybe<string>, kids?: Maybe<number>, locationResolver?: Maybe<SponsoredContentLocationResolver>, origin?: Maybe<string>, dateEnd?: Maybe<{ __typename: 'Date', day: number, month: number, year: number }>, dateStart?: Maybe<{ __typename: 'Date', day: number, month: number, year: number }> }> } } };

export type FlightsStandardOfferFragment = { __typename: 'FlightsStandardOffer', accessibilityHeading?: Maybe<string>, accessibilityMessage?: Maybe<string>, pinnedOfferMessage?: Maybe<string>, specialFareType?: Maybe<string>, journeyContinuationId?: Maybe<string>, stepIndicatorJcid?: Maybe<string>, badges?: Maybe<Array<{ __typename: 'FlightsBadge', accessibilityMessage?: Maybe<string>, text?: Maybe<string>, type: FlightsBadgeTheme, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> }>>, journeys: Array<{ __typename: 'FlightsOfferJourney', cabinClass: string, departureAndArrivalLocations: string, layoverInformation?: Maybe<string>, differentDayArrival?: Maybe<string>, differentDayArrivalAccessibilityMessage?: Maybe<string>, durationAndStops: string, flightOperatedBy?: Maybe<string>, label: string, urgencyMessage?: Maybe<string>, urgencyAccessibilityMessage?: Maybe<string>, hygieneAmenitiesMessage?: Maybe<string>, positiveHighlightsMessage?: Maybe<string>, airlines: Array<{ __typename: 'FlightsImageAndLabel', text: string, image: { __typename: 'Image', url: any, description: string } }>, departureAndArrivalTime: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }, displayAction: { __typename: 'Icon', id: string, description: string }, flightsJourneyAvailableFaresInformation?: Maybe<(
      { __typename: 'FlightsJourneyAvailableFares' }
      & FlightsJourneyAvailableFaresFragment
    )>, flightsDetailsAndFaresPresentation: (
      { __typename: 'FlightsDetailsAndFaresPresentation' }
      & FlightsDetailsAndFaresPresentationFragmentFragment
    ), adjustedStayDatesMessage?: Maybe<(
      { __typename: 'FlightsIconPhrases' }
      & FlightsIconPhrasesFragment
    )>, restrictiveAmenityIcons?: Maybe<Array<(
      { __typename: 'Icon' }
      & IconSearchFragment
    )>>, highlightRelevantFaresAnalytics?: Maybe<Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>> }>, pricingInformation: { __typename: 'FlightsPricingInformation', taxesLabel?: Maybe<string>, totalLabel: string, subText?: Maybe<Array<string>>, tripType?: Maybe<string>, loyaltyEarnMessage?: Maybe<(
      { __typename: 'FlightsMarkAndLabel' }
      & FlightsMarkAndLabelFragment
    )>, partnerLoyaltyEarnMessage?: Maybe<(
      { __typename: 'FlightsMarkAndLabel' }
      & FlightsMarkAndLabelFragment
    )>, loyaltyPointsOption?: Maybe<(
      { __typename: 'FlightsLoyaltyPointsOption' }
      & FlightsLoyaltyPointsOptionFragment
    )>, price: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, mainPrice: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, subPrice?: Maybe<{ __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }>, pricePerTraveler: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, totalPriceForAllTravelers?: Maybe<{ __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }>, priceLockup: (
      { __typename: 'EGDSPriceLockup' }
      & PriceLockupFragmentFragment
    ), subTexts?: Maybe<Array<{ __typename: 'EGDSBasicLocalizedText', text: string } | { __typename: 'EGDSCardinalLocalizedText', text: string } | { __typename: 'EGDSCompositeLocalizedText', text: string } | { __typename: 'EGDSGraphicText', text: string } | { __typename: 'EGDSHeading', text: string } | { __typename: 'EGDSIconText', text: string } | { __typename: 'EGDSInlineLink', text: string } | { __typename: 'EGDSLocalizedTextTemplate', text: string } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText', text: string } | { __typename: 'EGDSStandardLink', text: string } | { __typename: 'EGDSStylizedText', theme?: Maybe<TextTheme>, text: string } | { __typename: 'EGDSTextIconLinkListItem', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } | { __typename: 'EGDSTextWithMarkListItem', text: string }>> }, restrictiveFareRules?: Maybe<{ __typename: 'FlightsRestrictiveFareRules', dismissLabel: string, rules: Array<string>, title: string, displayAction: { __typename: 'FlightsIconAndPhrase', icon: { __typename: 'Icon', id: string, description: string }, label: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> } } }>, sponsoredAirline?: Maybe<{ __typename: 'FlightsOfferSponsoredAirline', airlineName?: Maybe<string>, airlineCode?: Maybe<string>, adUnitID?: Maybe<string>, advertiserID?: Maybe<string>, creativeID?: Maybe<string>, clickTrackingURL?: Maybe<string>, delayedImpressionURL?: Maybe<string>, orderID?: Maybe<string>, sponsoredHeader?: Maybe<string>, sponsoredText?: Maybe<string>, airlineImage?: Maybe<{ __typename: 'Image', url: any }> }>, tag?: Maybe<{ __typename: 'FlightsOfferTag', message: string, image: { __typename: 'Image', description: string, url: any } }>, flightsOfferAnalytics: { __typename: 'FlightsOfferAnalytics', onViewedAnalyticsList: Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )> }, onClickAnalyticsList: Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, sponsoredUpsell?: Maybe<(
    { __typename: 'FlightsOfferSponsoredUpsell' }
    & FlightsOfferSponsoredUpsellFragment
  )> };

export type FlightsCreditsAvailableListingFragment = { __typename: 'FlightsCreditsAvailableListing', immediateDialogAction?: Maybe<{ __typename: 'FlightsDialogTriggerUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ), dialog: { __typename: 'AdditionalInformationPopoverDialogSection', closeAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> } | { __typename: 'ClientSideErrorRepresentationDialog', closeAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> } | { __typename: 'EGDSActionDialog', closeAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> } | { __typename: 'EGDSFullScreenDialog', closeAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> } | { __typename: 'EGDSLoaderDialog', closeAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> } | { __typename: 'PriceInsightsExistingTrackingDialogAction', closeAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> } | { __typename: 'PriceInsightsTrackingRetryDialogAction', closeAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> } | { __typename: 'ServicingDialog', closeAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> }, dialogContents: Array<{ __typename: 'ActivitySearchForm', egdsElementId?: Maybe<string> } | { __typename: 'AgencyUIPrimaryFloatingActionButton', egdsElementId?: Maybe<string> } | { __typename: 'AgencyUISecondaryFloatingActionButton', egdsElementId?: Maybe<string> } | { __typename: 'CarSearchForm', egdsElementId?: Maybe<string> } | { __typename: 'CruiseSearchForm', egdsElementId?: Maybe<string> } | { __typename: 'DurationSpanSelector', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBadgeNotification', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBasicCheckBox', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBasicLocalizedText', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBasicOption', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBasicSelect', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBasicStepInput', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBasicTab', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBasicTabs', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBasicTravelerSelector', egdsElementId?: Maybe<string> } | { __typename: 'EGDSBulletedList', egdsElementId?: Maybe<string> } | { __typename: 'EGDSCardinalLocalizedText', egdsElementId?: Maybe<string> } | { __typename: 'EGDSComposableTextElementSectionContainer', egdsElementId?: Maybe<string> } | { __typename: 'EGDSCompositeLocalizedText', egdsElementId?: Maybe<string> } | { __typename: 'EGDSEmailInputField', egdsElementId?: Maybe<string> } | { __typename: 'EGDSErrorSummary', egdsElementId?: Maybe<string> } | { __typename: 'EGDSHeading', egdsElementId?: Maybe<string> } | { __typename: 'EGDSImageLink', egdsElementId?: Maybe<string> } | { __typename: 'EGDSImageLinkCard', egdsElementId?: Maybe<string> } | { __typename: 'EGDSInfantSeatRadioButton', egdsElementId?: Maybe<string> } | { __typename: 'EGDSLinkList', egdsElementId?: Maybe<string> } | { __typename: 'EGDSLocalizedTextTemplate', egdsElementId?: Maybe<string> } | { __typename: 'EGDSLoyaltyBadge', egdsElementId?: Maybe<string> } | { __typename: 'EGDSNumberInputField', egdsElementId?: Maybe<string> } | { __typename: 'EGDSOrderedList', egdsElementId?: Maybe<string> } | { __typename: 'EGDSOverlayButton', egdsElementId?: Maybe<string> } | { __typename: 'EGDSParagraph', egdsElementId?: Maybe<string> } | { __typename: 'EGDSPasswordInputField', egdsElementId?: Maybe<string> } | { __typename: 'EGDSProgramBadge', egdsElementId?: Maybe<string> } | { __typename: 'EGDSRoomsTravelerSelector', egdsElementId?: Maybe<string> } | { __typename: 'EGDSSearchFormButton', egdsElementId?: Maybe<string> } | { __typename: 'EGDSSearchFormDatePickerField', egdsElementId: string } | { __typename: 'EGDSSearchFormInputField', egdsElementId: string } | { __typename: 'EGDSSearchFormLocationField', egdsElementId: string } | { __typename: 'EGDSSearchFormLocationsField', egdsElementId: string } | { __typename: 'EGDSSearchFormTravelersField', egdsElementId: string } | { __typename: 'EGDSSectionContainer', egdsElementId?: Maybe<string> } | { __typename: 'EGDSSpannableText', egdsElementId?: Maybe<string> } | { __typename: 'EGDSStandardBadge', egdsElementId?: Maybe<string> } | { __typename: 'EGDSStandardLink', egdsElementId?: Maybe<string> } | { __typename: 'EGDSStandardMessagingCard', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextAreaInputField', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextIconLinkListItem', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextIconList', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextIconListItem', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextInputField', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextListSection', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextSection', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextStandardListItem', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTextWithMarkListItem', egdsElementId?: Maybe<string> } | { __typename: 'EGDSToast', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTravelerChildAgeSelect', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTravelerInfantSeatSelection', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTravelerStepInput', egdsElementId?: Maybe<string> } | { __typename: 'EGDSTypeaheadInputField', egdsElementId?: Maybe<string> } | { __typename: 'EGDSUnorderedList', egdsElementId?: Maybe<string> } | { __typename: 'FlightSearchForm', egdsElementId?: Maybe<string> } | { __typename: 'FlightSearchInputForm', egdsElementId?: Maybe<string> } | { __typename: 'FlightsActionButton', egdsElementId?: Maybe<string> } | { __typename: 'FlightsActionCheckbox', egdsElementId?: Maybe<string> } | { __typename: 'FlightsActionLink', egdsElementId?: Maybe<string> } | { __typename: 'FlightsDialogTrigger', egdsElementId?: Maybe<string> } | { __typename: 'IdentityBasicBlock', egdsElementId?: Maybe<string> } | { __typename: 'IdentityButton', egdsElementId?: Maybe<string> } | { __typename: 'IdentityConsentNestedCheckBox', egdsElementId: string } | { __typename: 'IdentityImage', egdsElementId?: Maybe<string> } | { __typename: 'IdentityImageGallery', egdsElementId: string } | { __typename: 'IdentityInfoLinkComponent', egdsElementId?: Maybe<string> } | { __typename: 'IdentityPasswordStrengthComponent', egdsElementId?: Maybe<string> } | { __typename: 'IdentityResendButton', egdsElementId?: Maybe<string> } | { __typename: 'IdentitySingleColumnComponentLayout', egdsElementId?: Maybe<string> } | { __typename: 'IdentitySocialButton', egdsElementId?: Maybe<string> } | { __typename: 'IdentityText', egdsElementId?: Maybe<string> } | { __typename: 'Illustration', egdsElementId?: Maybe<string> } | { __typename: 'LodgingSearchForm', egdsElementId?: Maybe<string> } | { __typename: 'PackagesSearchForm', egdsElementId?: Maybe<string> } | { __typename: 'ProductSummaryCard', egdsElementId: string } | { __typename: 'ProfileAccountLink', egdsElementId?: Maybe<string> } | { __typename: 'ProfileActionButtonCard', egdsElementId?: Maybe<string> } | { __typename: 'ProfileBulletedList', egdsElementId?: Maybe<string> } | { __typename: 'ProfileEGDSSectionContainer', egdsElementId?: Maybe<string> } | { __typename: 'ProfileFormHorizontalContainer', egdsElementId?: Maybe<string> } | { __typename: 'ProfileFormSection', egdsElementId?: Maybe<string> } | { __typename: 'ProfileLink', egdsElementId?: Maybe<string> } | { __typename: 'ProfileNumberField', egdsElementId?: Maybe<string> } | { __typename: 'ProfilePhoneNumberField', egdsElementId?: Maybe<string> } | { __typename: 'ProfileRadioButton', egdsElementId?: Maybe<string> } | { __typename: 'ProfileRadioButtonGroup', egdsElementId?: Maybe<string> } | { __typename: 'ProfileSelectField', egdsElementId?: Maybe<string> } | { __typename: 'ProfileSlimCard', egdsElementId?: Maybe<string> } | { __typename: 'ProfileSwitchOption', egdsElementId?: Maybe<string> } | { __typename: 'ProfileTextField', egdsElementId?: Maybe<string> } | { __typename: 'SearchFormDurationSpanField', egdsElementId: string } | { __typename: 'TripsMediaGallery', egdsElementId?: Maybe<string> } | { __typename: 'TripsValidatedInput', egdsElementId: string } | { __typename: 'UIBanner', egdsElementId?: Maybe<string> } | { __typename: 'UIEmptyState', egdsElementId?: Maybe<string> } | { __typename: 'UIMessagingCard', egdsElementId?: Maybe<string> } | { __typename: 'UIPrimaryButton', egdsElementId?: Maybe<string> } | { __typename: 'UIPrimaryFloatingActionButton', egdsElementId?: Maybe<string> } | { __typename: 'UISecondaryButton', egdsElementId?: Maybe<string> } | { __typename: 'UISecondaryFloatingActionButton', egdsElementId?: Maybe<string> } | { __typename: 'UITertiaryButton', egdsElementId?: Maybe<string> }> }>, messagingCardPlacard: { __typename: 'FlightsMessagingCardPlacard', displayType: FlightsPlacardDisplayType, button?: Maybe<(
      { __typename: 'FlightsActionButton' }
      & FlightsActionButtonFragment
    )>, messagingCard: (
      { __typename: 'UIMessagingCard' }
      & UiMessagingCardFragment
    ), onViewedAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )> }, toastNotification?: Maybe<{ __typename: 'EGDSToast', egdsElementId?: Maybe<string>, text: string }> };

export type FlightsActionButtonFragment = { __typename: 'FlightsActionButton', accessibility?: Maybe<string>, disabled: boolean, egdsElementId?: Maybe<string>, primary?: Maybe<string>, style: EgdsButtonStyle, buttonStyle: EgdsButtonStyle, clientAction: { __typename: 'FlightsAncillaryContinueAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsBookingAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | (
    { __typename: 'FlightsBoundNavigation', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & FlightsBoundNavigationFragment
  ) | { __typename: 'FlightsClickAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsCreditClearAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsCreditSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | (
    { __typename: 'FlightsCreditSelectorOpenAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & FlightsCreditSelectorOpenActionFragment
  ) | { __typename: 'FlightsDialogCloseAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsDialogTriggerAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsFareTypeSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsLegDropdownItemSelection', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsLoadAncillariesAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | (
    { __typename: 'FlightsNavigateToDetails', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & FlightsNavigateToDetailsFragment
  ) | { __typename: 'FlightsRedirectOrDialog', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsRefreshAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsRemovePriceMatchPromiseAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | (
    { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & FlightsResourceLinkActionFragment
  ) | { __typename: 'FlightsResourceRedirectAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsSearchCriteriaChangeAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | (
    { __typename: 'FlightsSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & FlightsSelectionActionFragment
  ) | { __typename: 'FlightsSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'InsuranceSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | (
    { __typename: 'MultiItemSelectPackage', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & MultiItemSelectPackageFragment
  ) | (
    { __typename: 'MultiItemSelectProducts', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & MultiItemSelectProductsFragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchFragment
  )>, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ActivityCloseDialogAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ActivityMultiItemTripUpdateAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ActivityOpenDialogAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ActivityOpenOffersModalAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ActivityPaginationAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ActivityRemoveOffersFromTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ActivityUpdateOfferInTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'AgencyQuoteAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'AirCreditWebAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CDFOpenFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CDFOpenNextPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CDFSubmitFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CouponAndCreditAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CouponAndCreditChatbotAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CouponsAndCreditsSimpleAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CrossSellButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CrossSellLinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'CruiseAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'DirectFeedbackOpenFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'DirectFeedbackOpenNextPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'DirectFeedbackOpenPreviousPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'DirectFeedbackSubmitFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'EGDSOpenDatePickerAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'EGDSOpenTravelerSelectorAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'EGDSSubmitSearchFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'FlightsCreditSelectorOpenUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'FlightsDialogCloseUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'FlightsDialogTriggerUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'GroundTransfersBookAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'GroundTransfersDetailsOpenAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'GroundTransfersDismissAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'GroundTransfersLinkClickAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'GroundTransfersMultiItemTripUpdateAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'GroundTransfersSelectionClickAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'MemberWalletBadge', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'MemberWalletUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'MishopDetailsUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'MultiItemCrossSellUIButtonAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'MultiItemCrossSellUILinkAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'OpenTypeaheadAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'PaymentDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'PaymentDialogElement', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'PriceInsightsExistingDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileAccountFormSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileAddMembershipAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileAddPassportAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileFormSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileLinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileReloadAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileRewardProgramFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileUpdateMembershipAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ProfileUpdatePassportAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'QuoteAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'ShoppingSortAndFilterAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'SupplyNavigationHeaderSearchTrigger', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'TripsRetryOperationAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'UIFlightAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'UILinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'WizardAdditionalUserInputRequiredAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) } | { __typename: 'WizardSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    ) }> };

export type FlightsCreditSelectorOpenActionFragment = { __typename: 'FlightsCreditSelectorOpenAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type FlightsSelectionActionFragment = { __typename: 'FlightsSelectionAction', value: string };

export type FlightsBoundNavigationFragment = { __typename: 'FlightsBoundNavigation', jcid: string, mipt?: Maybe<string>, pageId: string, stepIndicatorJcid: string };

export type FlightsNavigateToDetailsFragment = { __typename: 'FlightsNavigateToDetails', dialogId: string, nextPage: { __typename: 'GeoURI' } | (
    { __typename: 'HttpURI' }
    & HttpUriFragment
  ) | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' }, packagesUrl?: Maybe<{ __typename: 'GeoURI' } | (
    { __typename: 'HttpURI' }
    & HttpUriFragment
  ) | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' }> };

export type MultiItemSelectProductsFragment = { __typename: 'MultiItemSelectProducts', multiItemPriceToken?: Maybe<string>, multiItemSessionId: string, flightsOfferNaturalKeys: (
    { __typename: 'FlightsOfferNaturalKeys' }
    & FlightsOfferNaturalKeysFragmentFragment
  ) };

export type MultiItemSelectPackageFragment = { __typename: 'MultiItemSelectPackage', packageOfferId: string };

export type UiMessagingCardFragment = { __typename: 'UIMessagingCard', egdsElementId?: Maybe<string>, primary?: Maybe<string>, secondaries?: Maybe<Array<string>>, graphic?: Maybe<(
    { __typename: 'Icon' }
    & UiGraphicFragment_Icon_Fragment
  ) | (
    { __typename: 'Illustration' }
    & UiGraphicFragment_Illustration_Fragment
  ) | (
    { __typename: 'Mark' }
    & UiGraphicFragment_Mark_Fragment
  )> };

export type FlightsMarkAndLabelFragment = { __typename: 'FlightsMarkAndLabel', accessibility?: Maybe<string>, label: string, subLabel?: Maybe<string>, mark?: Maybe<{ __typename: 'Mark', id: string, description: string }>, stylisedText?: Maybe<(
    { __typename: 'EGDSSpannableText' }
    & EgdsSpannableTextFragmentFragment
  )> };

export type FlightsToggleSearchFragment = { __typename: 'FlightsToggle', expanded: boolean, collapseActionable: (
    { __typename: 'TogglePhase' }
    & TogglePhaseSearchFragment
  ), expandActionable: (
    { __typename: 'TogglePhase' }
    & TogglePhaseSearchFragment
  ) };

export type IconSearchFragment = { __typename: 'Icon', description: string, id: string, size?: Maybe<IconSize>, withBackground?: Maybe<boolean>, theme?: Maybe<IconTheme>, title?: Maybe<string> };

export type TogglePhaseSearchFragment = { __typename: 'TogglePhase', accessibilityMessage?: Maybe<string>, action: string, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchFragment
  )> };

export type FlightsIconPlacardFragment = { __typename: 'FlightsIconPlacard', heading?: Maybe<string>, message: string, displayType?: Maybe<FlightsPlacardDisplayType>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string, size?: Maybe<IconSize>, withBackground?: Maybe<boolean> }>, actions?: Maybe<Array<(
    { __typename: 'FlightsAction' }
    & FlightActionFragment
  )>> };

export type FlightActionFragment = { __typename: 'FlightsAction', accessibilityMessage?: Maybe<string>, displayAction: string, displayType: FlightsActionDisplayType, type: FlightsActionType, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), analyticsList: Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, displayAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, accessibilityActionMessage?: Maybe<{ __typename: 'FlightsAccessibilityMessage', usage?: Maybe<string>, onCompletion?: Maybe<string> }>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchFragment
  )>, journeySearchCriteria?: Maybe<{ __typename: 'FlightsJourneySearchCriteria', previousFlightSelections?: Maybe<Array<{ __typename: 'JourneyFlightSelection', journeyIndex: number, offerIdentifier: string }>>, journeyCriteria: Array<{ __typename: 'FlightsJourneyCriteria', destination: string, origin: string, departureDate: { __typename: 'Date', day: number, month: number, year: number } }>, searchPreferences?: Maybe<{ __typename: 'FlightsSearchPreferences', cabinClass: FlightsCabinClass }> }>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }>, relativePackageableURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }>, stepIndicator?: Maybe<(
    { __typename: 'FlightsStepIndicator' }
    & FlightsStepIndicatorFragment
  )>, searchPagination?: Maybe<(
    { __typename: 'Pagination' }
    & PaginationFragment
  )> };

export type FlightsStepIndicatorFragment = { __typename: 'FlightsStepIndicator', journeyContinuationId: string, errorAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type CoordinateInformationSearchFragment = { __typename: 'CoordinateInformation', subtitle: string, icon: (
    { __typename: 'Icon' }
    & IconSearchFragment
  ), flightDetailsWarningInfo?: Maybe<(
    { __typename: 'FlightsIconAndLabel' }
    & FlightsIconAndLabelFragment
  )>, titleAndAccessibilityMessage: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string } };

export type FlightsJourneyAvailableFaresFragment = { __typename: 'FlightsJourneyAvailableFares', applySelection: (
    { __typename: 'FlightsAction' }
    & FlightActionFragment
  ), fareChoiceInformation?: Maybe<{ __typename: 'FlightsFareChoiceInformation', availableFaresCount: number, message: string, nextFareChoiceAccessibilityMessage: string, previousFareChoiceAccessibilityMessage: string, tripTypePerTraveler: string, defaultBaggageInformation: { __typename: 'FlightsBaggageInformation', defaultBagSelectionMessage?: Maybe<string>, dismissAction?: Maybe<string>, displayDetailsAction?: Maybe<string>, label: string, bagFeesMoreInfo: Array<{ __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, icon?: Maybe<string>, link: any, styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }>, details?: Maybe<Array<{ __typename: 'FlightBaggageInformationDetail', baggageDetail: string, topic: string }>> }, fares?: Maybe<Array<{ __typename: 'FlightsJourneyFare', accessibilityMessage: string, selectFareActionAltText?: Maybe<string>, multiItemPriceToken?: Maybe<string>, cabinClass: string, cabinClassAndBookingCodes?: Maybe<Array<string>>, identifier: string, name: string, selected: boolean, totalPrice: string, priceAccessibilityMessage: string, journeyFareTotalPrice?: Maybe<string>, upsellOfferToken: string, multiItemAction?: Maybe<{ __typename: 'MultiItemSelectPackageAction', packageOfferId: string } | { __typename: 'MultiItemSelectProductsAction', multiItemSessionId: string, multiItemPriceToken?: Maybe<string>, flightsOfferNaturalKeys: (
          { __typename: 'FlightsOfferNaturalKeys' }
          & FlightsOfferNaturalKeysFragmentFragment
        ) }>, flightsOfferNaturalKeys?: Maybe<(
        { __typename: 'FlightsOfferNaturalKeys' }
        & FlightsOfferNaturalKeysFragmentFragment
      )>, baggageFeesInformation: { __typename: 'FlightsBaggageInformation', defaultBagSelectionMessage?: Maybe<string>, displayDetailsAction?: Maybe<string>, dismissAction?: Maybe<string>, label: string, details?: Maybe<Array<{ __typename: 'FlightBaggageInformationDetail', baggageDetail: string, topic: string }>> }, selectFareAction: (
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      ), collapsedRules: (
        { __typename: 'FlightsJourneyAmenities' }
        & FlightsJourneyAmenitiesFragment
      ), expandedRules: Array<(
        { __typename: 'FlightsJourneyAmenitiesWithLabel' }
        & FlightsJourneyAmenitiesWithLabelFragment
      )>, amenityHierarchyRules?: Maybe<Array<(
        { __typename: 'FlightsJourneyAmenitiesWithLabel' }
        & FlightsJourneyAmenitiesWithLabelFragment
      )>>, amenityRules: { __typename: 'FlightsJourneyAmenityRules', itemsDefaultDisplayCount: number, amenities: Array<(
          { __typename: 'FlightsIconAndLabel' }
          & FlightsIconAndLabelFragment
        )> }, chooseFareAction: { __typename: 'FlightsAction', accessibilityMessage?: Maybe<string>, displayAction: string, type: FlightsActionType }, loyaltyPointsOption?: Maybe<(
        { __typename: 'FlightsLoyaltyPointsOption' }
        & FlightsLoyaltyPointsOptionFragment
      )>, partnerLoyaltyEarnAward?: Maybe<(
        { __typename: 'FlightsMarkAndLabel' }
        & FlightsMarkAndLabelFragment
      )>, recommendation?: Maybe<(
        { __typename: 'FlightsBadge' }
        & FlightsBadgeFragment
      )>, showMoreAmenitiesToggle?: Maybe<(
        { __typename: 'FlightsToggle' }
        & FlightsToggleSearchFragment
      )>, badges?: Maybe<Array<{ __typename: 'EGDSBadgeNotification', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSLoyaltyBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSProgramBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSStandardBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> }>>, priceLockup: { __typename: 'EGDSPriceLockup', accessibilityPrice: string, lockupPrice?: Maybe<string>, strikeThroughPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>> } } | { __typename: 'FlightsPMPJourneyFare', accessibilityMessage: string, selectFareActionAltText?: Maybe<string>, multiItemPriceToken?: Maybe<string>, cabinClass: string, cabinClassAndBookingCodes?: Maybe<Array<string>>, identifier: string, name: string, selected: boolean, totalPrice: string, priceAccessibilityMessage: string, journeyFareTotalPrice?: Maybe<string>, upsellOfferToken: string, multiItemAction?: Maybe<{ __typename: 'MultiItemSelectPackageAction', packageOfferId: string } | { __typename: 'MultiItemSelectProductsAction', multiItemSessionId: string, multiItemPriceToken?: Maybe<string>, flightsOfferNaturalKeys: (
          { __typename: 'FlightsOfferNaturalKeys' }
          & FlightsOfferNaturalKeysFragmentFragment
        ) }>, flightsOfferNaturalKeys?: Maybe<(
        { __typename: 'FlightsOfferNaturalKeys' }
        & FlightsOfferNaturalKeysFragmentFragment
      )>, baggageFeesInformation: { __typename: 'FlightsBaggageInformation', defaultBagSelectionMessage?: Maybe<string>, displayDetailsAction?: Maybe<string>, dismissAction?: Maybe<string>, label: string, details?: Maybe<Array<{ __typename: 'FlightBaggageInformationDetail', baggageDetail: string, topic: string }>> }, selectFareAction: (
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      ), collapsedRules: (
        { __typename: 'FlightsJourneyAmenities' }
        & FlightsJourneyAmenitiesFragment
      ), expandedRules: Array<(
        { __typename: 'FlightsJourneyAmenitiesWithLabel' }
        & FlightsJourneyAmenitiesWithLabelFragment
      )>, amenityHierarchyRules?: Maybe<Array<(
        { __typename: 'FlightsJourneyAmenitiesWithLabel' }
        & FlightsJourneyAmenitiesWithLabelFragment
      )>>, amenityRules: { __typename: 'FlightsJourneyAmenityRules', itemsDefaultDisplayCount: number, amenities: Array<(
          { __typename: 'FlightsIconAndLabel' }
          & FlightsIconAndLabelFragment
        )> }, chooseFareAction: { __typename: 'FlightsAction', accessibilityMessage?: Maybe<string>, displayAction: string, type: FlightsActionType }, loyaltyPointsOption?: Maybe<(
        { __typename: 'FlightsLoyaltyPointsOption' }
        & FlightsLoyaltyPointsOptionFragment
      )>, partnerLoyaltyEarnAward?: Maybe<(
        { __typename: 'FlightsMarkAndLabel' }
        & FlightsMarkAndLabelFragment
      )>, recommendation?: Maybe<(
        { __typename: 'FlightsBadge' }
        & FlightsBadgeFragment
      )>, showMoreAmenitiesToggle?: Maybe<(
        { __typename: 'FlightsToggle' }
        & FlightsToggleSearchFragment
      )>, badges?: Maybe<Array<{ __typename: 'EGDSBadgeNotification', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSLoyaltyBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSProgramBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSStandardBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> }>>, priceLockup: { __typename: 'EGDSPriceLockup', accessibilityPrice: string, lockupPrice?: Maybe<string>, strikeThroughPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>> } }>>, heading: (
      { __typename: 'FlightsResponsiveMessage' }
      & FlightsResponsiveMessageFragment
    ), percentageDelaysAndCancellationLink?: Maybe<{ __typename: 'FlightsLinkAction', displayAction: string, url: any, accessibility?: Maybe<string>, analytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }>, sustainabilityInformation?: Maybe<(
      { __typename: 'FlightsIconPhrases' }
      & FlightsIconPhrasesFragment
    )>, dialogs?: Maybe<Array<(
      { __typename: 'FlightsDialog' }
      & FaresDialogsFragmentFragment
    )>> }>, flightsJourneyHeaders: { __typename: 'FlightsJourneyHeaders', accessibilityMessage?: Maybe<string>, flightsJourneySubheading: string, heading: string, flightsJourneySubheadingMark?: Maybe<{ __typename: 'Mark', description: string, id: string, size?: Maybe<string>, token: string, url?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }>, journeyAmenities?: Maybe<(
      { __typename: 'FlightsJourneyAmenities' }
      & FlightsJourneyAmenitiesFragment
    )> }, flightsJourneyInformation?: Maybe<(
    { __typename: 'FlightsDetailedJourneyInformation' }
    & FlightsJourneyInformationFragment
  )>, flightsJourneySummary: { __typename: 'FlightsBargainJourneySummary', arrivalDayInformation: string, tripTypePerTraveler?: Maybe<string>, totalPrice?: Maybe<string>, formattedPrice?: Maybe<{ __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }>, heading: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }, differentDayArrival?: Maybe<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string, theme?: Maybe<TextTheme>, size?: Maybe<number> }>, basicFlightDetails: Array<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string, theme?: Maybe<TextTheme> }> } | { __typename: 'LoadedFlightsStandardJourneySummary', heading: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }, differentDayArrival?: Maybe<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string, theme?: Maybe<TextTheme>, size?: Maybe<number> }>, basicFlightDetails: Array<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string, theme?: Maybe<TextTheme> }> } | { __typename: 'LoadingFlightsStandardJourneySummary', heading: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }, differentDayArrival?: Maybe<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string, theme?: Maybe<TextTheme>, size?: Maybe<number> }>, basicFlightDetails: Array<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string, theme?: Maybe<TextTheme> }> }, hygieneAmenitiesPresentation?: Maybe<{ __typename: 'FlightsHygieneAmenitiesPresentation', disclaimerMessage: string, amenitiesAction?: Maybe<{ __typename: 'FlightsTextSection', heading?: Maybe<string> }>, airlineAmenityGroups: Array<{ __typename: 'FlightsAirlineAmenityGroup', headerText?: Maybe<string>, amenities?: Maybe<Array<{ __typename: 'FlightsIconAndLabel', label: string, theme: TextTheme, icon: (
          { __typename: 'Icon' }
          & IconSearchFragment
        ) }>> }> }> };

export type FlightsDetailsAndFaresPresentationFragmentFragment = { __typename: 'FlightsDetailsAndFaresPresentation', content: (
    { __typename: 'FlightsDetailsAndFaresContent' }
    & FlightsDetailsAndFaresContentFragmentFragment
  ), flightsFaresWrapper: (
    { __typename: 'FlightsDialogSheet' }
    & FlightsDialogSheetFragmentFragment
  ), footer?: Maybe<(
    { __typename: 'FlightsDetailsAndFaresFooter' }
    & FlightsDetailsAndFaresFooterFragmentFragment
  )>, trigger: (
    { __typename: 'FlightsDialogTrigger' }
    & FlightsDialogTriggerFragmentFragment
  ) };

export type FlightsDetailsAndFaresContentFragmentFragment = { __typename: 'FlightsDetailsAndFaresContent', dialogId: FlightsDialogId, dynamicDialogId?: Maybe<string>, nestedDialogs?: Maybe<Array<(
    { __typename: 'FlightsDialog' }
    & FaresDialogsFragmentFragment
  )>>, priceMatchPromiseNestedDialogs?: Maybe<Array<(
    { __typename: 'FlightsDialog' }
    & FaresDialogsFragmentFragment
  )>>, sections: Array<(
    { __typename: 'FlightsFaresInformation' }
    & FlightsFaresInformationFragmentFragment
  ) | (
    { __typename: 'FlightsHygieneAmenitiesSection' }
    & FlightsHygieneAmenitiesSectionFragmentFragment
  ) | (
    { __typename: 'FlightsJourneyDetailsInformation' }
    & FlightsJourneyDetailsInformationFragmentFragment
  ) | (
    { __typename: 'FlightsJourneyHeaderInformation' }
    & FlightsJourneyHeaderFragmentFragment
  ) | (
    { __typename: 'FlightsJourneyWithDetails' }
    & FlightsJourneyWithDetailsFragmentFragment
  ) | (
    { __typename: 'FlightsMessagingCard' }
    & FlightsMessagingCardFragmentFragment
  ) | (
    { __typename: 'FlightsSustainabilityCard' }
    & FlightsSustainabilityCardFragmentFragment
  ) | { __typename: 'FlightsSustainabilityMessaging' } | (
    { __typename: 'TextWrapper' }
    & TextWrapperFragmentFragment
  )> };

export type FlightsFaresInformationFragmentFragment = { __typename: 'FlightsFaresInformation', heading?: Maybe<string>, subheading?: Maybe<string>, carousel: (
    { __typename: 'EGDSCarouselContainer' }
    & EgdsCarouselContainerFragmentFragment
  ), faresCarousel: (
    { __typename: 'EGDSCarousel' }
    & EgdsCarouselFragmentFragment
  ), fares: Array<(
    { __typename: 'FareInformationCard' }
    & FareInformationCardFragmentFragment
  )>, scrollAnalytics: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type EgdsCarouselFragmentFragment = { __typename: 'EGDSCarousel', nextButton?: Maybe<(
    { __typename: 'EGDSOverlayButton' }
    & EgdsButtonFragment_EgdsOverlayButton_Fragment
  ) | (
    { __typename: 'EGDSSearchFormButton' }
    & EgdsButtonFragment_EgdsSearchFormButton_Fragment
  ) | (
    { __typename: 'FlightsActionButton' }
    & EgdsButtonFragment_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsDialogTrigger' }
    & EgdsButtonFragment_FlightsDialogTrigger_Fragment
  ) | (
    { __typename: 'FlightsExperienceActionButton' }
    & EgdsButtonFragment_FlightsExperienceActionButton_Fragment
  ) | (
    { __typename: 'FlightsSmartShoppingActionButton' }
    & EgdsButtonFragment_FlightsSmartShoppingActionButton_Fragment
  ) | (
    { __typename: 'PackageUIActionDialogFooterButton' }
    & EgdsButtonFragment_PackageUiActionDialogFooterButton_Fragment
  ) | (
    { __typename: 'PackageUIHideSearchFormAction' }
    & EgdsButtonFragment_PackageUiHideSearchFormAction_Fragment
  ) | (
    { __typename: 'PackageUITravelGuideButton' }
    & EgdsButtonFragment_PackageUiTravelGuideButton_Fragment
  ) | (
    { __typename: 'ServicingButton' }
    & EgdsButtonFragment_ServicingButton_Fragment
  ) | (
    { __typename: 'SupplyCancelWaiverActionButton' }
    & EgdsButtonFragment_SupplyCancelWaiverActionButton_Fragment
  ) | (
    { __typename: 'SupplyContentLinkStyleButton' }
    & EgdsButtonFragment_SupplyContentLinkStyleButton_Fragment
  ) | (
    { __typename: 'UIPrimaryButton' }
    & EgdsButtonFragment_UiPrimaryButton_Fragment
  ) | (
    { __typename: 'UISecondaryButton' }
    & EgdsButtonFragment_UiSecondaryButton_Fragment
  ) | (
    { __typename: 'UITertiaryButton' }
    & EgdsButtonFragment_UiTertiaryButton_Fragment
  )>, previousButton?: Maybe<(
    { __typename: 'EGDSOverlayButton' }
    & EgdsButtonFragment_EgdsOverlayButton_Fragment
  ) | (
    { __typename: 'EGDSSearchFormButton' }
    & EgdsButtonFragment_EgdsSearchFormButton_Fragment
  ) | (
    { __typename: 'FlightsActionButton' }
    & EgdsButtonFragment_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsDialogTrigger' }
    & EgdsButtonFragment_FlightsDialogTrigger_Fragment
  ) | (
    { __typename: 'FlightsExperienceActionButton' }
    & EgdsButtonFragment_FlightsExperienceActionButton_Fragment
  ) | (
    { __typename: 'FlightsSmartShoppingActionButton' }
    & EgdsButtonFragment_FlightsSmartShoppingActionButton_Fragment
  ) | (
    { __typename: 'PackageUIActionDialogFooterButton' }
    & EgdsButtonFragment_PackageUiActionDialogFooterButton_Fragment
  ) | (
    { __typename: 'PackageUIHideSearchFormAction' }
    & EgdsButtonFragment_PackageUiHideSearchFormAction_Fragment
  ) | (
    { __typename: 'PackageUITravelGuideButton' }
    & EgdsButtonFragment_PackageUiTravelGuideButton_Fragment
  ) | (
    { __typename: 'ServicingButton' }
    & EgdsButtonFragment_ServicingButton_Fragment
  ) | (
    { __typename: 'SupplyCancelWaiverActionButton' }
    & EgdsButtonFragment_SupplyCancelWaiverActionButton_Fragment
  ) | (
    { __typename: 'SupplyContentLinkStyleButton' }
    & EgdsButtonFragment_SupplyContentLinkStyleButton_Fragment
  ) | (
    { __typename: 'UIPrimaryButton' }
    & EgdsButtonFragment_UiPrimaryButton_Fragment
  ) | (
    { __typename: 'UISecondaryButton' }
    & EgdsButtonFragment_UiSecondaryButton_Fragment
  ) | (
    { __typename: 'UITertiaryButton' }
    & EgdsButtonFragment_UiTertiaryButton_Fragment
  )> };

export type FlightsDialogSheetFragmentFragment = { __typename: 'FlightsDialogSheet', dialogId: FlightsDialogId, dynamicDialogId?: Maybe<string>, dialog: (
    { __typename: 'FlightsDialog' }
    & FaresDialogsFragmentFragment
  ), sheet: (
    { __typename: 'FlightsSideSheet' }
    & FlightsSideSheetFragmentFragment
  ) };

export type FlightsDetailsAndFaresFooterFragmentFragment = { __typename: 'FlightsDetailsAndFaresFooter', dialogId: FlightsDialogId, dynamicDialogId?: Maybe<string>, action: (
    { __typename: 'FlightsActionButton' }
    & FlightsActionButtonFragment
  ), priceLockup: (
    { __typename: 'EGDSPriceLockup' }
    & PriceLockupFragmentFragment
  ) };

export type FlightsJourneyHeaderFragmentFragment = { __typename: 'FlightsJourneyHeaderInformation', content: Array<(
    { __typename: 'FlightsInformationText' }
    & FlightsInformationTextFragmentFragment
  )> };

export type FlightsJourneyDetailsInformationFragmentFragment = { __typename: 'FlightsJourneyDetailsInformation', content: Array<(
    { __typename: 'FlightsJourneyDetails' }
    & FlightsJourneyDetailsFragmentFragment
  )>, expando: (
    { __typename: 'EGDSExpandoLink' }
    & EgdsExpandoFragment_EgdsExpandoLink_Fragment
  ) };

export type FlightsJourneyDetailsFragmentFragment = { __typename: 'FlightsJourneyDetails', journeySections: Array<(
    { __typename: 'JourneySection' }
    & JourneySectionFragmentFragment
  )>, journeyAmenities?: Maybe<Array<(
    { __typename: 'FlightsIconAndLabel' }
    & FlightsIconAndLabelFragment
  )>> };

export type FlightsJourneyWithDetailsFragmentFragment = { __typename: 'FlightsJourneyWithDetails', header: string, subheader: string, details: Array<(
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsTextFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsTextFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsTextFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSGraphicText' }
    & EgdsTextFragment_EgdsGraphicText_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsTextFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSIconText' }
    & EgdsTextFragment_EgdsIconText_Fragment
  ) | (
    { __typename: 'EGDSInlineLink' }
    & EgdsTextFragment_EgdsInlineLink_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsTextFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPlainText' }
    & EgdsTextFragment_EgdsPlainText_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsTextFragment_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsTextFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStylizedText' }
    & EgdsTextFragment_EgdsStylizedText_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsTextFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsTextFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsTextFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsTextFragment_EgdsTextWithMarkListItem_Fragment
  )>, footnotes: Array<(
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsTextFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsTextFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsTextFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSGraphicText' }
    & EgdsTextFragment_EgdsGraphicText_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsTextFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSIconText' }
    & EgdsTextFragment_EgdsIconText_Fragment
  ) | (
    { __typename: 'EGDSInlineLink' }
    & EgdsTextFragment_EgdsInlineLink_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsTextFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPlainText' }
    & EgdsTextFragment_EgdsPlainText_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsTextFragment_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsTextFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStylizedText' }
    & EgdsTextFragment_EgdsStylizedText_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsTextFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsTextFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsTextFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsTextFragment_EgdsTextWithMarkListItem_Fragment
  )> };

export type FlightsHygieneAmenitiesSectionFragmentFragment = { __typename: 'FlightsHygieneAmenitiesSection', header: string, footer: string, amenities: Array<(
    { __typename: 'EGDSIconText' }
    & EgdsIconTextFragmentFragment
  )> };

export type TextWrapperFragmentFragment = { __typename: 'TextWrapper', textA11yMessage?: Maybe<string>, text: (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsTextFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsTextFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsTextFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSGraphicText' }
    & EgdsTextFragment_EgdsGraphicText_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsTextFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSIconText' }
    & EgdsTextFragment_EgdsIconText_Fragment
  ) | (
    { __typename: 'EGDSInlineLink' }
    & EgdsTextFragment_EgdsInlineLink_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsTextFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPlainText' }
    & EgdsTextFragment_EgdsPlainText_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsTextFragment_EgdsSpannableText_Fragment
    & EgdsSpannableTextFragmentFragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsTextFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStylizedText' }
    & EgdsTextFragment_EgdsStylizedText_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsTextFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsTextFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsTextFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsTextFragment_EgdsTextWithMarkListItem_Fragment
  ) };

export type FlightsSustainabilityCardFragmentFragment = { __typename: 'FlightsSustainabilityCard', cardContent: { __typename: 'FlightsIconPhrases', text: Array<(
      { __typename: 'FlightsPhrase' }
      & FlightsPhraseFragment
    )>, icon?: Maybe<(
      { __typename: 'Icon' }
      & IconSearchFragment
    )> } };

export type FareInformationCardFragmentFragment = { __typename: 'FareInformationCard', state: FareState, highlighted: boolean, action: Array<(
    { __typename: 'FareAction' }
    & FareActionFragmentFragment
  )>, amenities: (
    { __typename: 'FlightsCategorizedList' }
    & FlightsCategorizedListFragmentFragment
  ), fareDetails: Array<(
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsTextFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsTextFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsTextFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSGraphicText' }
    & EgdsTextFragment_EgdsGraphicText_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsTextFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSIconText' }
    & EgdsTextFragment_EgdsIconText_Fragment
  ) | (
    { __typename: 'EGDSInlineLink' }
    & EgdsTextFragment_EgdsInlineLink_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsTextFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPlainText' }
    & EgdsTextFragment_EgdsPlainText_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsTextFragment_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsTextFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStylizedText' }
    & EgdsTextFragment_EgdsStylizedText_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsTextFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsTextFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsTextFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsTextFragment_EgdsTextWithMarkListItem_Fragment
  )>, heading: (
    { __typename: 'FareHeading' }
    & FareHeadingFragmentFragment
  ), priceMatchPromise?: Maybe<(
    { __typename: 'FarePriceMatchPromisePresentation' }
    & FarePriceMatchPromisePresentationFragmentFragment
  )>, scrollAnalytics: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>, fareTabs?: Maybe<(
    { __typename: 'EGDSBasicTabs' }
    & EgdsBasicTabsFragmentFragment
  )>, sponsoredContent?: Maybe<(
    { __typename: 'FlightsSponsoredFareInformation' }
    & FlightsSponsoredUpsellDetailsFragment
  )> };

export type EgdsBasicTabsFragmentFragment = { __typename: 'EGDSBasicTabs', egdsElementId?: Maybe<string>, selectedTabId?: Maybe<string>, tabs: Array<{ __typename: 'CouponEntryTab' } | { __typename: 'EGDSBasicTab', tabId: string, label: string, accessibility?: Maybe<string>, clickAnalytics?: Maybe<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'MishopUINavigationBarTab' }> };

export type FlightsSideSheetFragmentFragment = { __typename: 'FlightsSideSheet', title?: Maybe<string>, content?: Maybe<Array<(
    { __typename: 'ActivitySearchForm' }
    & EgdsElementFragment_ActivitySearchForm_Fragment
  ) | (
    { __typename: 'AgencyUIPrimaryFloatingActionButton' }
    & EgdsElementFragment_AgencyUiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'AgencyUISecondaryFloatingActionButton' }
    & EgdsElementFragment_AgencyUiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'CarSearchForm' }
    & EgdsElementFragment_CarSearchForm_Fragment
  ) | (
    { __typename: 'CruiseSearchForm' }
    & EgdsElementFragment_CruiseSearchForm_Fragment
  ) | (
    { __typename: 'DurationSpanSelector' }
    & EgdsElementFragment_DurationSpanSelector_Fragment
  ) | (
    { __typename: 'EGDSBadgeNotification' }
    & EgdsElementFragment_EgdsBadgeNotification_Fragment
  ) | (
    { __typename: 'EGDSBasicCheckBox' }
    & EgdsElementFragment_EgdsBasicCheckBox_Fragment
  ) | (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsElementFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSBasicOption' }
    & EgdsElementFragment_EgdsBasicOption_Fragment
  ) | (
    { __typename: 'EGDSBasicSelect' }
    & EgdsElementFragment_EgdsBasicSelect_Fragment
  ) | (
    { __typename: 'EGDSBasicStepInput' }
    & EgdsElementFragment_EgdsBasicStepInput_Fragment
  ) | (
    { __typename: 'EGDSBasicTab' }
    & EgdsElementFragment_EgdsBasicTab_Fragment
  ) | (
    { __typename: 'EGDSBasicTabs' }
    & EgdsElementFragment_EgdsBasicTabs_Fragment
  ) | (
    { __typename: 'EGDSBasicTravelerSelector' }
    & EgdsElementFragment_EgdsBasicTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSBulletedList' }
    & EgdsElementFragment_EgdsBulletedList_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsElementFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSComposableTextElementSectionContainer' }
    & EgdsElementFragment_EgdsComposableTextElementSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsElementFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSEmailInputField' }
    & EgdsElementFragment_EgdsEmailInputField_Fragment
  ) | (
    { __typename: 'EGDSErrorSummary' }
    & EgdsElementFragment_EgdsErrorSummary_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsElementFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSImageLink' }
    & EgdsElementFragment_EgdsImageLink_Fragment
  ) | (
    { __typename: 'EGDSImageLinkCard' }
    & EgdsElementFragment_EgdsImageLinkCard_Fragment
  ) | (
    { __typename: 'EGDSInfantSeatRadioButton' }
    & EgdsElementFragment_EgdsInfantSeatRadioButton_Fragment
  ) | (
    { __typename: 'EGDSLinkList' }
    & EgdsElementFragment_EgdsLinkList_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsElementFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSLoyaltyBadge' }
    & EgdsElementFragment_EgdsLoyaltyBadge_Fragment
  ) | (
    { __typename: 'EGDSNumberInputField' }
    & EgdsElementFragment_EgdsNumberInputField_Fragment
  ) | (
    { __typename: 'EGDSOrderedList' }
    & EgdsElementFragment_EgdsOrderedList_Fragment
  ) | (
    { __typename: 'EGDSOverlayButton' }
    & EgdsElementFragment_EgdsOverlayButton_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsElementFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPasswordInputField' }
    & EgdsElementFragment_EgdsPasswordInputField_Fragment
  ) | (
    { __typename: 'EGDSProgramBadge' }
    & EgdsElementFragment_EgdsProgramBadge_Fragment
  ) | (
    { __typename: 'EGDSRoomsTravelerSelector' }
    & EgdsElementFragment_EgdsRoomsTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSSearchFormButton' }
    & EgdsElementFragment_EgdsSearchFormButton_Fragment
  ) | (
    { __typename: 'EGDSSearchFormDatePickerField' }
    & EgdsElementFragment_EgdsSearchFormDatePickerField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormInputField' }
    & EgdsElementFragment_EgdsSearchFormInputField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationField' }
    & EgdsElementFragment_EgdsSearchFormLocationField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationsField' }
    & EgdsElementFragment_EgdsSearchFormLocationsField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormTravelersField' }
    & EgdsElementFragment_EgdsSearchFormTravelersField_Fragment
  ) | (
    { __typename: 'EGDSSectionContainer' }
    & EgdsElementFragment_EgdsSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsElementFragment_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardBadge' }
    & EgdsElementFragment_EgdsStandardBadge_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsElementFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStandardMessagingCard' }
    & EgdsElementFragment_EgdsStandardMessagingCard_Fragment
  ) | (
    { __typename: 'EGDSTextAreaInputField' }
    & EgdsElementFragment_EgdsTextAreaInputField_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsElementFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconList' }
    & EgdsElementFragment_EgdsTextIconList_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsElementFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextInputField' }
    & EgdsElementFragment_EgdsTextInputField_Fragment
  ) | (
    { __typename: 'EGDSTextListSection' }
    & EgdsElementFragment_EgdsTextListSection_Fragment
  ) | (
    { __typename: 'EGDSTextSection' }
    & EgdsElementFragment_EgdsTextSection_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsElementFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsElementFragment_EgdsTextWithMarkListItem_Fragment
  ) | (
    { __typename: 'EGDSToast' }
    & EgdsElementFragment_EgdsToast_Fragment
  ) | (
    { __typename: 'EGDSTravelerChildAgeSelect' }
    & EgdsElementFragment_EgdsTravelerChildAgeSelect_Fragment
  ) | (
    { __typename: 'EGDSTravelerInfantSeatSelection' }
    & EgdsElementFragment_EgdsTravelerInfantSeatSelection_Fragment
  ) | (
    { __typename: 'EGDSTravelerStepInput' }
    & EgdsElementFragment_EgdsTravelerStepInput_Fragment
  ) | (
    { __typename: 'EGDSTypeaheadInputField' }
    & EgdsElementFragment_EgdsTypeaheadInputField_Fragment
  ) | (
    { __typename: 'EGDSUnorderedList' }
    & EgdsElementFragment_EgdsUnorderedList_Fragment
  ) | (
    { __typename: 'FlightSearchForm' }
    & EgdsElementFragment_FlightSearchForm_Fragment
  ) | (
    { __typename: 'FlightSearchInputForm' }
    & EgdsElementFragment_FlightSearchInputForm_Fragment
  ) | (
    { __typename: 'FlightsActionButton' }
    & EgdsElementFragment_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsActionCheckbox' }
    & EgdsElementFragment_FlightsActionCheckbox_Fragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & EgdsElementFragment_FlightsActionLink_Fragment
  ) | (
    { __typename: 'FlightsDialogTrigger' }
    & EgdsElementFragment_FlightsDialogTrigger_Fragment
  ) | (
    { __typename: 'IdentityBasicBlock' }
    & EgdsElementFragment_IdentityBasicBlock_Fragment
  ) | (
    { __typename: 'IdentityButton' }
    & EgdsElementFragment_IdentityButton_Fragment
  ) | (
    { __typename: 'IdentityConsentNestedCheckBox' }
    & EgdsElementFragment_IdentityConsentNestedCheckBox_Fragment
  ) | (
    { __typename: 'IdentityImage' }
    & EgdsElementFragment_IdentityImage_Fragment
  ) | (
    { __typename: 'IdentityImageGallery' }
    & EgdsElementFragment_IdentityImageGallery_Fragment
  ) | (
    { __typename: 'IdentityInfoLinkComponent' }
    & EgdsElementFragment_IdentityInfoLinkComponent_Fragment
  ) | (
    { __typename: 'IdentityPasswordStrengthComponent' }
    & EgdsElementFragment_IdentityPasswordStrengthComponent_Fragment
  ) | (
    { __typename: 'IdentityResendButton' }
    & EgdsElementFragment_IdentityResendButton_Fragment
  ) | (
    { __typename: 'IdentitySingleColumnComponentLayout' }
    & EgdsElementFragment_IdentitySingleColumnComponentLayout_Fragment
  ) | (
    { __typename: 'IdentitySocialButton' }
    & EgdsElementFragment_IdentitySocialButton_Fragment
  ) | (
    { __typename: 'IdentityText' }
    & EgdsElementFragment_IdentityText_Fragment
  ) | (
    { __typename: 'Illustration' }
    & EgdsElementFragment_Illustration_Fragment
  ) | (
    { __typename: 'LodgingSearchForm' }
    & EgdsElementFragment_LodgingSearchForm_Fragment
  ) | (
    { __typename: 'PackagesSearchForm' }
    & EgdsElementFragment_PackagesSearchForm_Fragment
  ) | (
    { __typename: 'ProductSummaryCard' }
    & EgdsElementFragment_ProductSummaryCard_Fragment
  ) | (
    { __typename: 'ProfileAccountLink' }
    & EgdsElementFragment_ProfileAccountLink_Fragment
  ) | (
    { __typename: 'ProfileActionButtonCard' }
    & EgdsElementFragment_ProfileActionButtonCard_Fragment
  ) | (
    { __typename: 'ProfileBulletedList' }
    & EgdsElementFragment_ProfileBulletedList_Fragment
  ) | (
    { __typename: 'ProfileEGDSSectionContainer' }
    & EgdsElementFragment_ProfileEgdsSectionContainer_Fragment
  ) | (
    { __typename: 'ProfileFormHorizontalContainer' }
    & EgdsElementFragment_ProfileFormHorizontalContainer_Fragment
  ) | (
    { __typename: 'ProfileFormSection' }
    & EgdsElementFragment_ProfileFormSection_Fragment
  ) | (
    { __typename: 'ProfileLink' }
    & EgdsElementFragment_ProfileLink_Fragment
  ) | (
    { __typename: 'ProfileNumberField' }
    & EgdsElementFragment_ProfileNumberField_Fragment
  ) | (
    { __typename: 'ProfilePhoneNumberField' }
    & EgdsElementFragment_ProfilePhoneNumberField_Fragment
  ) | (
    { __typename: 'ProfileRadioButton' }
    & EgdsElementFragment_ProfileRadioButton_Fragment
  ) | (
    { __typename: 'ProfileRadioButtonGroup' }
    & EgdsElementFragment_ProfileRadioButtonGroup_Fragment
  ) | (
    { __typename: 'ProfileSelectField' }
    & EgdsElementFragment_ProfileSelectField_Fragment
  ) | (
    { __typename: 'ProfileSlimCard' }
    & EgdsElementFragment_ProfileSlimCard_Fragment
  ) | (
    { __typename: 'ProfileSwitchOption' }
    & EgdsElementFragment_ProfileSwitchOption_Fragment
  ) | (
    { __typename: 'ProfileTextField' }
    & EgdsElementFragment_ProfileTextField_Fragment
  ) | (
    { __typename: 'SearchFormDurationSpanField' }
    & EgdsElementFragment_SearchFormDurationSpanField_Fragment
  ) | (
    { __typename: 'TripsMediaGallery' }
    & EgdsElementFragment_TripsMediaGallery_Fragment
  ) | (
    { __typename: 'TripsValidatedInput' }
    & EgdsElementFragment_TripsValidatedInput_Fragment
  ) | (
    { __typename: 'UIBanner' }
    & EgdsElementFragment_UiBanner_Fragment
  ) | (
    { __typename: 'UIEmptyState' }
    & EgdsElementFragment_UiEmptyState_Fragment
  ) | (
    { __typename: 'UIMessagingCard' }
    & EgdsElementFragment_UiMessagingCard_Fragment
  ) | (
    { __typename: 'UIPrimaryButton' }
    & EgdsElementFragment_UiPrimaryButton_Fragment
  ) | (
    { __typename: 'UIPrimaryFloatingActionButton' }
    & EgdsElementFragment_UiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UISecondaryButton' }
    & EgdsElementFragment_UiSecondaryButton_Fragment
  ) | (
    { __typename: 'UISecondaryFloatingActionButton' }
    & EgdsElementFragment_UiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UITertiaryButton' }
    & EgdsElementFragment_UiTertiaryButton_Fragment
  )>>, footer?: Maybe<Array<(
    { __typename: 'ActivitySearchForm' }
    & EgdsElementFragment_ActivitySearchForm_Fragment
  ) | (
    { __typename: 'AgencyUIPrimaryFloatingActionButton' }
    & EgdsElementFragment_AgencyUiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'AgencyUISecondaryFloatingActionButton' }
    & EgdsElementFragment_AgencyUiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'CarSearchForm' }
    & EgdsElementFragment_CarSearchForm_Fragment
  ) | (
    { __typename: 'CruiseSearchForm' }
    & EgdsElementFragment_CruiseSearchForm_Fragment
  ) | (
    { __typename: 'DurationSpanSelector' }
    & EgdsElementFragment_DurationSpanSelector_Fragment
  ) | (
    { __typename: 'EGDSBadgeNotification' }
    & EgdsElementFragment_EgdsBadgeNotification_Fragment
  ) | (
    { __typename: 'EGDSBasicCheckBox' }
    & EgdsElementFragment_EgdsBasicCheckBox_Fragment
  ) | (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsElementFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSBasicOption' }
    & EgdsElementFragment_EgdsBasicOption_Fragment
  ) | (
    { __typename: 'EGDSBasicSelect' }
    & EgdsElementFragment_EgdsBasicSelect_Fragment
  ) | (
    { __typename: 'EGDSBasicStepInput' }
    & EgdsElementFragment_EgdsBasicStepInput_Fragment
  ) | (
    { __typename: 'EGDSBasicTab' }
    & EgdsElementFragment_EgdsBasicTab_Fragment
  ) | (
    { __typename: 'EGDSBasicTabs' }
    & EgdsElementFragment_EgdsBasicTabs_Fragment
  ) | (
    { __typename: 'EGDSBasicTravelerSelector' }
    & EgdsElementFragment_EgdsBasicTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSBulletedList' }
    & EgdsElementFragment_EgdsBulletedList_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsElementFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSComposableTextElementSectionContainer' }
    & EgdsElementFragment_EgdsComposableTextElementSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsElementFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSEmailInputField' }
    & EgdsElementFragment_EgdsEmailInputField_Fragment
  ) | (
    { __typename: 'EGDSErrorSummary' }
    & EgdsElementFragment_EgdsErrorSummary_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsElementFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSImageLink' }
    & EgdsElementFragment_EgdsImageLink_Fragment
  ) | (
    { __typename: 'EGDSImageLinkCard' }
    & EgdsElementFragment_EgdsImageLinkCard_Fragment
  ) | (
    { __typename: 'EGDSInfantSeatRadioButton' }
    & EgdsElementFragment_EgdsInfantSeatRadioButton_Fragment
  ) | (
    { __typename: 'EGDSLinkList' }
    & EgdsElementFragment_EgdsLinkList_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsElementFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSLoyaltyBadge' }
    & EgdsElementFragment_EgdsLoyaltyBadge_Fragment
  ) | (
    { __typename: 'EGDSNumberInputField' }
    & EgdsElementFragment_EgdsNumberInputField_Fragment
  ) | (
    { __typename: 'EGDSOrderedList' }
    & EgdsElementFragment_EgdsOrderedList_Fragment
  ) | (
    { __typename: 'EGDSOverlayButton' }
    & EgdsElementFragment_EgdsOverlayButton_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsElementFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPasswordInputField' }
    & EgdsElementFragment_EgdsPasswordInputField_Fragment
  ) | (
    { __typename: 'EGDSProgramBadge' }
    & EgdsElementFragment_EgdsProgramBadge_Fragment
  ) | (
    { __typename: 'EGDSRoomsTravelerSelector' }
    & EgdsElementFragment_EgdsRoomsTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSSearchFormButton' }
    & EgdsElementFragment_EgdsSearchFormButton_Fragment
  ) | (
    { __typename: 'EGDSSearchFormDatePickerField' }
    & EgdsElementFragment_EgdsSearchFormDatePickerField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormInputField' }
    & EgdsElementFragment_EgdsSearchFormInputField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationField' }
    & EgdsElementFragment_EgdsSearchFormLocationField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationsField' }
    & EgdsElementFragment_EgdsSearchFormLocationsField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormTravelersField' }
    & EgdsElementFragment_EgdsSearchFormTravelersField_Fragment
  ) | (
    { __typename: 'EGDSSectionContainer' }
    & EgdsElementFragment_EgdsSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsElementFragment_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardBadge' }
    & EgdsElementFragment_EgdsStandardBadge_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsElementFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStandardMessagingCard' }
    & EgdsElementFragment_EgdsStandardMessagingCard_Fragment
  ) | (
    { __typename: 'EGDSTextAreaInputField' }
    & EgdsElementFragment_EgdsTextAreaInputField_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsElementFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconList' }
    & EgdsElementFragment_EgdsTextIconList_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsElementFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextInputField' }
    & EgdsElementFragment_EgdsTextInputField_Fragment
  ) | (
    { __typename: 'EGDSTextListSection' }
    & EgdsElementFragment_EgdsTextListSection_Fragment
  ) | (
    { __typename: 'EGDSTextSection' }
    & EgdsElementFragment_EgdsTextSection_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsElementFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsElementFragment_EgdsTextWithMarkListItem_Fragment
  ) | (
    { __typename: 'EGDSToast' }
    & EgdsElementFragment_EgdsToast_Fragment
  ) | (
    { __typename: 'EGDSTravelerChildAgeSelect' }
    & EgdsElementFragment_EgdsTravelerChildAgeSelect_Fragment
  ) | (
    { __typename: 'EGDSTravelerInfantSeatSelection' }
    & EgdsElementFragment_EgdsTravelerInfantSeatSelection_Fragment
  ) | (
    { __typename: 'EGDSTravelerStepInput' }
    & EgdsElementFragment_EgdsTravelerStepInput_Fragment
  ) | (
    { __typename: 'EGDSTypeaheadInputField' }
    & EgdsElementFragment_EgdsTypeaheadInputField_Fragment
  ) | (
    { __typename: 'EGDSUnorderedList' }
    & EgdsElementFragment_EgdsUnorderedList_Fragment
  ) | (
    { __typename: 'FlightSearchForm' }
    & EgdsElementFragment_FlightSearchForm_Fragment
  ) | (
    { __typename: 'FlightSearchInputForm' }
    & EgdsElementFragment_FlightSearchInputForm_Fragment
  ) | (
    { __typename: 'FlightsActionButton' }
    & EgdsElementFragment_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsActionCheckbox' }
    & EgdsElementFragment_FlightsActionCheckbox_Fragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & EgdsElementFragment_FlightsActionLink_Fragment
  ) | (
    { __typename: 'FlightsDialogTrigger' }
    & EgdsElementFragment_FlightsDialogTrigger_Fragment
  ) | (
    { __typename: 'IdentityBasicBlock' }
    & EgdsElementFragment_IdentityBasicBlock_Fragment
  ) | (
    { __typename: 'IdentityButton' }
    & EgdsElementFragment_IdentityButton_Fragment
  ) | (
    { __typename: 'IdentityConsentNestedCheckBox' }
    & EgdsElementFragment_IdentityConsentNestedCheckBox_Fragment
  ) | (
    { __typename: 'IdentityImage' }
    & EgdsElementFragment_IdentityImage_Fragment
  ) | (
    { __typename: 'IdentityImageGallery' }
    & EgdsElementFragment_IdentityImageGallery_Fragment
  ) | (
    { __typename: 'IdentityInfoLinkComponent' }
    & EgdsElementFragment_IdentityInfoLinkComponent_Fragment
  ) | (
    { __typename: 'IdentityPasswordStrengthComponent' }
    & EgdsElementFragment_IdentityPasswordStrengthComponent_Fragment
  ) | (
    { __typename: 'IdentityResendButton' }
    & EgdsElementFragment_IdentityResendButton_Fragment
  ) | (
    { __typename: 'IdentitySingleColumnComponentLayout' }
    & EgdsElementFragment_IdentitySingleColumnComponentLayout_Fragment
  ) | (
    { __typename: 'IdentitySocialButton' }
    & EgdsElementFragment_IdentitySocialButton_Fragment
  ) | (
    { __typename: 'IdentityText' }
    & EgdsElementFragment_IdentityText_Fragment
  ) | (
    { __typename: 'Illustration' }
    & EgdsElementFragment_Illustration_Fragment
  ) | (
    { __typename: 'LodgingSearchForm' }
    & EgdsElementFragment_LodgingSearchForm_Fragment
  ) | (
    { __typename: 'PackagesSearchForm' }
    & EgdsElementFragment_PackagesSearchForm_Fragment
  ) | (
    { __typename: 'ProductSummaryCard' }
    & EgdsElementFragment_ProductSummaryCard_Fragment
  ) | (
    { __typename: 'ProfileAccountLink' }
    & EgdsElementFragment_ProfileAccountLink_Fragment
  ) | (
    { __typename: 'ProfileActionButtonCard' }
    & EgdsElementFragment_ProfileActionButtonCard_Fragment
  ) | (
    { __typename: 'ProfileBulletedList' }
    & EgdsElementFragment_ProfileBulletedList_Fragment
  ) | (
    { __typename: 'ProfileEGDSSectionContainer' }
    & EgdsElementFragment_ProfileEgdsSectionContainer_Fragment
  ) | (
    { __typename: 'ProfileFormHorizontalContainer' }
    & EgdsElementFragment_ProfileFormHorizontalContainer_Fragment
  ) | (
    { __typename: 'ProfileFormSection' }
    & EgdsElementFragment_ProfileFormSection_Fragment
  ) | (
    { __typename: 'ProfileLink' }
    & EgdsElementFragment_ProfileLink_Fragment
  ) | (
    { __typename: 'ProfileNumberField' }
    & EgdsElementFragment_ProfileNumberField_Fragment
  ) | (
    { __typename: 'ProfilePhoneNumberField' }
    & EgdsElementFragment_ProfilePhoneNumberField_Fragment
  ) | (
    { __typename: 'ProfileRadioButton' }
    & EgdsElementFragment_ProfileRadioButton_Fragment
  ) | (
    { __typename: 'ProfileRadioButtonGroup' }
    & EgdsElementFragment_ProfileRadioButtonGroup_Fragment
  ) | (
    { __typename: 'ProfileSelectField' }
    & EgdsElementFragment_ProfileSelectField_Fragment
  ) | (
    { __typename: 'ProfileSlimCard' }
    & EgdsElementFragment_ProfileSlimCard_Fragment
  ) | (
    { __typename: 'ProfileSwitchOption' }
    & EgdsElementFragment_ProfileSwitchOption_Fragment
  ) | (
    { __typename: 'ProfileTextField' }
    & EgdsElementFragment_ProfileTextField_Fragment
  ) | (
    { __typename: 'SearchFormDurationSpanField' }
    & EgdsElementFragment_SearchFormDurationSpanField_Fragment
  ) | (
    { __typename: 'TripsMediaGallery' }
    & EgdsElementFragment_TripsMediaGallery_Fragment
  ) | (
    { __typename: 'TripsValidatedInput' }
    & EgdsElementFragment_TripsValidatedInput_Fragment
  ) | (
    { __typename: 'UIBanner' }
    & EgdsElementFragment_UiBanner_Fragment
  ) | (
    { __typename: 'UIEmptyState' }
    & EgdsElementFragment_UiEmptyState_Fragment
  ) | (
    { __typename: 'UIMessagingCard' }
    & EgdsElementFragment_UiMessagingCard_Fragment
  ) | (
    { __typename: 'UIPrimaryButton' }
    & EgdsElementFragment_UiPrimaryButton_Fragment
  ) | (
    { __typename: 'UIPrimaryFloatingActionButton' }
    & EgdsElementFragment_UiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UISecondaryButton' }
    & EgdsElementFragment_UiSecondaryButton_Fragment
  ) | (
    { __typename: 'UISecondaryFloatingActionButton' }
    & EgdsElementFragment_UiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UITertiaryButton' }
    & EgdsElementFragment_UiTertiaryButton_Fragment
  )>> };

export type JourneySectionFragmentFragment = { __typename: 'JourneySection', journeyConnectionInformation: Array<(
    { __typename: 'AdditionalInformation' }
    & AdditionalInformationFragmentFragment
  ) | (
    { __typename: 'FlightsConnectionInformation' }
    & FlightsConnectionInformationFragmentFragment
  )> };

type EgdsExpandoFragment_EgdsExpandoCard_Fragment = { __typename: 'EGDSExpandoCard' };

type EgdsExpandoFragment_EgdsExpandoLink_Fragment = (
  { __typename: 'EGDSExpandoLink' }
  & EgdsExpandoLinkFragmentFragment
);

type EgdsExpandoFragment_EgdsExpandoListItem_Fragment = (
  { __typename: 'EGDSExpandoListItem' }
  & EgdsExpandoListItemFragmentFragment
);

type EgdsExpandoFragment_EgdsExpandoPeek_Fragment = (
  { __typename: 'EGDSExpandoPeek' }
  & EgdsExpandoPeekFragmentFragment
);

type EgdsExpandoFragment_SupplyCancellationPolicyDetailsExpandoLink_Fragment = { __typename: 'SupplyCancellationPolicyDetailsExpandoLink' };

type EgdsExpandoFragment_SupplyPaymentDetailsExpandoLink_Fragment = { __typename: 'SupplyPaymentDetailsExpandoLink' };

export type EgdsExpandoFragmentFragment = EgdsExpandoFragment_EgdsExpandoCard_Fragment | EgdsExpandoFragment_EgdsExpandoLink_Fragment | EgdsExpandoFragment_EgdsExpandoListItem_Fragment | EgdsExpandoFragment_EgdsExpandoPeek_Fragment | EgdsExpandoFragment_SupplyCancellationPolicyDetailsExpandoLink_Fragment | EgdsExpandoFragment_SupplyPaymentDetailsExpandoLink_Fragment;

export type EgdsIconTextFragmentFragment = { __typename: 'EGDSIconText', text: string, icon: (
    { __typename: 'Icon' }
    & IconSearchFragment
  ) };

export type EgdsCarouselContainerFragmentFragment = { __typename: 'EGDSCarouselContainer', accessibilityHeadingText: string, nextButtonText?: Maybe<string>, previousButtonText?: Maybe<string> };

export type FareActionFragmentFragment = { __typename: 'FareAction', states: Array<FareState>, action: (
    { __typename: 'FlightsActionButton' }
    & FlightsActionButtonFragment
  ) };

export type FlightsCategorizedListFragmentFragment = { __typename: 'FlightsCategorizedList', sections: Array<(
    { __typename: 'FlightsCategorizedListSection' }
    & FlightsCategorizedListSectionFragmentFragment
  )> };

export type FlightsCategorizedListSectionFragmentFragment = { __typename: 'FlightsCategorizedListSection', footnote?: Maybe<Array<string>>, heading?: Maybe<string>, additionalInfo?: Maybe<Array<string>>, flightsCategorizedListSectionA11yMessage?: Maybe<string>, items: Array<(
    { __typename: 'FlightsCategorizedListItem' }
    & FlightsCategorizedListItemFragmentFragment
  )> };

export type FlightsCategorizedListItemFragmentFragment = { __typename: 'FlightsCategorizedListItem', secondary?: Maybe<string>, tertiary?: Maybe<string>, primary: (
    { __typename: 'EGDSSpannableText' }
    & EgdsSpannableTextFragmentFragment
  ) };

export type FareHeadingFragmentFragment = { __typename: 'FareHeading', badge?: Maybe<(
    { __typename: 'EGDSBadgeNotification' }
    & EgdsBadgeFragment_EgdsBadgeNotification_Fragment
  ) | (
    { __typename: 'EGDSLoyaltyBadge' }
    & EgdsBadgeFragment_EgdsLoyaltyBadge_Fragment
  ) | (
    { __typename: 'EGDSProgramBadge' }
    & EgdsBadgeFragment_EgdsProgramBadge_Fragment
  ) | (
    { __typename: 'EGDSStandardBadge' }
    & EgdsBadgeFragment_EgdsStandardBadge_Fragment
  )>, farePricing: Array<(
    { __typename: 'FarePricing' }
    & FarePricingFragmentFragment
  )> };

export type FarePriceMatchPromisePresentationFragmentFragment = { __typename: 'FarePriceMatchPromisePresentation', priceMatchPromiseState: PriceMatchPromiseState, cards: Array<(
    { __typename: 'FarePriceMatchPromiseRemovableCard' }
    & FarePriceMatchPromiseRemovableCardFragmentFragment
  ) | (
    { __typename: 'FarePriceMatchPromiseSelectableCard' }
    & FarePriceMatchPromiseSelectableCardFragmentFragment
  ) | (
    { __typename: 'FarePriceMatchPromiseStaticCard' }
    & FarePriceMatchPromiseStaticCardFragmentFragment
  ) | { __typename: 'PriceMatchPromiseToggleableCard' }> };

export type FarePriceMatchPromiseStaticCardFragmentFragment = { __typename: 'FarePriceMatchPromiseStaticCard', priceMatchPromiseState: PriceMatchPromiseState, subHeading: string, heading: (
    { __typename: 'EGDSIconText' }
    & EgdsIconTextFragmentFragment
  ) };

export type FarePriceMatchPromiseRemovableCardFragmentFragment = { __typename: 'FarePriceMatchPromiseRemovableCard', priceMatchPromiseState: PriceMatchPromiseState, subHeading: string, heading: (
    { __typename: 'EGDSIconText' }
    & EgdsIconTextFragmentFragment
  ), removeAction: (
    { __typename: 'FlightsActionLink' }
    & FlightsActionLinkFragmentFragment
  ) };

export type AdditionalInformationFragmentFragment = { __typename: 'AdditionalInformation', durationAndStop: string, nextFlightOriginAirportInfo?: Maybe<(
    { __typename: 'FlightsIconAndLabel' }
    & FlightsIconAndLabelFragment
  )> };

export type FlightsConnectionInformationFragmentFragment = { __typename: 'FlightsConnectionInformation', flightsConnection: { __typename: 'FlightsConnection', aircraftModel?: Maybe<string>, airlineInfo: string, cabinClassAndBookingCode: string, duration: string, connectionArrival: (
      { __typename: 'CoordinateInformation' }
      & CoordinateInformationSearchFragment
    ), connectionDeparture: (
      { __typename: 'CoordinateInformation' }
      & CoordinateInformationSearchFragment
    ), journeyAmenities?: Maybe<(
      { __typename: 'FlightsJourneyAmenities' }
      & FlightsJourneyAmenitiesFragment
    )> } };

export type EgdsExpandoPeekFragmentFragment = { __typename: 'EGDSExpandoPeek', expandedLabel: string, collapsedLabel: string, threshold?: Maybe<number>, minimalHeight?: Maybe<number>, expandAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type EgdsExpandoListItemFragmentFragment = { __typename: 'EGDSExpandoListItem', collapsedLabel: string, expandedLabel: string, expanded: boolean, collapseAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>, expandAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type EgdsExpandoLinkFragmentFragment = { __typename: 'EGDSExpandoLink', collapsedLabel: string, expanded: boolean, expandedLabel: string, collapseAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>, expandAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type FlightsInformationTextFragmentFragment = { __typename: 'FlightsInformationText', content: Array<(
    { __typename: 'IconWrapper' }
    & FlightsInformationTextItemFragment_IconWrapper_Fragment
  ) | (
    { __typename: 'MarkWrapper' }
    & FlightsInformationTextItemFragment_MarkWrapper_Fragment
  ) | (
    { __typename: 'SuperlativeText' }
    & FlightsInformationTextItemFragment_SuperlativeText_Fragment
  ) | (
    { __typename: 'TextWrapper' }
    & FlightsInformationTextItemFragment_TextWrapper_Fragment
  )> };

type FlightsInformationTextItemFragment_IconWrapper_Fragment = (
  { __typename: 'IconWrapper' }
  & IconWrapperFragmentFragment
);

type FlightsInformationTextItemFragment_MarkWrapper_Fragment = (
  { __typename: 'MarkWrapper' }
  & MarkWrapperFragmentFragment
);

type FlightsInformationTextItemFragment_SuperlativeText_Fragment = (
  { __typename: 'SuperlativeText' }
  & SuperlativeTextFragmentFragment
);

type FlightsInformationTextItemFragment_TextWrapper_Fragment = (
  { __typename: 'TextWrapper' }
  & TextWrapperFragmentFragment
);

export type FlightsInformationTextItemFragmentFragment = FlightsInformationTextItemFragment_IconWrapper_Fragment | FlightsInformationTextItemFragment_MarkWrapper_Fragment | FlightsInformationTextItemFragment_SuperlativeText_Fragment | FlightsInformationTextItemFragment_TextWrapper_Fragment;

export type FarePricingFragmentFragment = { __typename: 'FarePricing', states: Array<FareState>, priceLockup: (
    { __typename: 'EGDSPriceLockup' }
    & PriceLockupFragmentFragment
  ) };

export type FarePriceMatchPromiseSelectableCardFragmentFragment = { __typename: 'FarePriceMatchPromiseSelectableCard', price: string, priceMatchPromiseState: PriceMatchPromiseState, description?: Maybe<string>, checkbox: (
    { __typename: 'FlightsActionCheckbox' }
    & FlightsActionCheckboxFragmentFragment
  ), heading: (
    { __typename: 'EGDSIconText' }
    & EgdsIconTextFragmentFragment
  ), infoTrigger: (
    { __typename: 'FlightsDialogTrigger' }
    & FlightsDialogTriggerFragmentFragment
  ) };

export type EgdsSpannableTextFragmentFragment = { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> } | { __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string, style: EgdsParagraphStyle } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } } | { __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, stylizedSize?: Maybe<string> } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<(
    { __typename: 'EGDSGraphicText' }
    & EgdsGraphicTextFragmentFragment
  ) | { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } } | { __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, stylizedSize?: Maybe<string> }> };

export type MarkWrapperFragmentFragment = { __typename: 'MarkWrapper', mark: (
    { __typename: 'Mark' }
    & MarkFragmentsFragment
  ) };

export type IconWrapperFragmentFragment = { __typename: 'IconWrapper', iconA11yMessage?: Maybe<string>, icons: Array<(
    { __typename: 'Icon' }
    & IconSearchFragment
  )> };

export type SuperlativeTextFragmentFragment = { __typename: 'SuperlativeText', superlativeTextA11yMessage?: Maybe<string>, text: (
    { __typename: 'EGDSStylizedText' }
    & EgdsTextFragment_EgdsStylizedText_Fragment
  ) };

export type FlightsJourneyAmenitiesFragment = { __typename: 'FlightsJourneyAmenities', accessibilityMessage: string, amenities: Array<(
    { __typename: 'FlightsIconAndLabel' }
    & FlightsIconAndLabelFragment
  )>, analytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsJourneyAmenitiesWithLabelFragment = { __typename: 'FlightsJourneyAmenitiesWithLabel', label: string, rules: (
    { __typename: 'FlightsJourneyAmenities' }
    & FlightsJourneyAmenitiesFragment
  ) };

export type PaginationFragment = { __typename: 'Pagination', size?: Maybe<number>, startingIndex?: Maybe<number> };

export type FlightsIconAndLabelFragment = { __typename: 'FlightsIconAndLabel', label: string, subLabel?: Maybe<string>, accessibility?: Maybe<string>, value?: Maybe<string>, theme: TextTheme, icon: (
    { __typename: 'Icon' }
    & IconSearchFragment
  ), displayAnalytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>>, subText?: Maybe<{ __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, size?: Maybe<string> }> };

export type FlightsJourneyInformationFragment = { __typename: 'FlightsDetailedJourneyInformation', details: (
    { __typename: 'FlightsToggle' }
    & FlightsToggleSearchFragment
  ), flightJourneyDetails: { __typename: 'FlightsJourneyDetails', journeySections: Array<{ __typename: 'JourneySection', journeyConnectionInformation: Array<{ __typename: 'AdditionalInformation', durationAndStop: string, nextFlightOriginAirportInfo?: Maybe<(
          { __typename: 'FlightsIconAndLabel' }
          & FlightsIconAndLabelFragment
        )> } | { __typename: 'FlightsConnectionInformation', flightsConnection: { __typename: 'FlightsConnection', aircraftModel?: Maybe<string>, airlineInfo: string, cabinClassAndBookingCode: string, duration: string, operatedBy?: Maybe<string>, connectionArrival: (
            { __typename: 'CoordinateInformation' }
            & CoordinateInformationSearchFragment
          ), connectionDeparture: (
            { __typename: 'CoordinateInformation' }
            & CoordinateInformationSearchFragment
          ), journeyAmenities?: Maybe<(
            { __typename: 'FlightsJourneyAmenities' }
            & FlightsJourneyAmenitiesFragment
          )> } }> }>, journeyAmenities?: Maybe<Array<(
      { __typename: 'FlightsIconAndLabel' }
      & FlightsIconAndLabelFragment
    )>> } };

export type FlightsBadgeFragment = { __typename: 'FlightsBadge', accessibilityMessage?: Maybe<string>, text?: Maybe<string>, type: FlightsBadgeTheme, icon?: Maybe<{ __typename: 'Icon', id: string, description: string }> };

export type HotelsDateFragment = { __typename: 'FlightsSearchFormDateField', currentError?: Maybe<string>, dateFormat: string, daysBookableInAdvance: number, label: string, placeholder: string, maxStayDurationAllowed?: Maybe<number>, doneAction: string, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), date?: Maybe<{ __typename: 'Date', day: number, month: number, year: number, formatted: string, isoFormat: string }>, possibleErrors: Array<{ __typename: 'FlightsSearchFormError', message: string, type: FlightsSearchFormErrorType, analytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ) }>, possibleErrorsHeader?: Maybe<{ __typename: 'FlightsIconAndPhrase', icon: { __typename: 'Icon', id: string, description: string }, label: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> } }> };

export type ClientMetaDataFragment = { __typename: 'FlightsPWAMetadata', pageName: string, responseTags?: Maybe<Array<ResponseTagType>>, pageNameAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsRewardsPricingInfoFragment = { __typename: 'FlightsRewardsPricingInfo', title: (
    { __typename: 'FlightsResponsiveMessage' }
    & FlightsResponsiveMessageFragment
  ), options?: Maybe<Array<{ __typename: 'FlightsRewardsOption', label: string, identifier: RewardsOption, selected: boolean, accessibility?: Maybe<{ __typename: 'FlightsAccessibilityMessage', usage?: Maybe<string>, onCompletion?: Maybe<string> }> }>>, subText: Array<{ __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string, dialog: { __typename: 'BookWithAirlinesDialog', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        )>, displayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )> } | { __typename: 'FlightsDialogChangeFlight', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        )>, displayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )> } | { __typename: 'FlightsDialogMultiPassengerCredit', title?: Maybe<string>, message: string, animation: FlightsDialogAnimation, actions: Array<(
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        )>, displayedAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) } | { __typename: 'FlightsDialogServerError', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        )>, displayedAnalytics?: Maybe<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )> } | { __typename: 'FlightsDialogStaleSession', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        )>, displayedAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) } | { __typename: 'FlightsDialogStandard', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        )>, displayedAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) } | { __typename: 'FlightsForcedChoiceCrossSellDialog', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
          { __typename: 'FlightsAction' }
          & FlightActionFragment
        )>, displayedAnalytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) }, actionableIcon?: Maybe<{ __typename: 'Icon', id: string, description: string, token: string }> } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, icon?: Maybe<string>, link: any, styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }>, loyaltyBanners?: Maybe<Array<(
    { __typename: 'FlightsIconPlacard' }
    & FlightsIconPlacardFragment
  ) | { __typename: 'FlightsImagePlacard' } | { __typename: 'FlightsMarkPlacard' }>> };

export type PageTitleFragment = { __typename: 'FlightsPageTitle', date?: Maybe<{ __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> }>, disclaimerSubTitle?: Maybe<(
    { __typename: 'FlightsPhrase' }
    & FlightsPhraseFragment
  )>, title: { __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> } };

export type FlightsPhraseFragment = { __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, theme?: Maybe<TextTheme>, items: Array<{ __typename: 'FlightsPhraseDialogNode', accessibility?: Maybe<string>, text: string, styles: Array<FlightsPhrasePartStyle>, analytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), actionableIcon?: Maybe<{ __typename: 'Icon', id: string, description: string }>, dialog: { __typename: 'BookWithAirlinesDialog', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics?: Maybe<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )> } | { __typename: 'FlightsDialogChangeFlight', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics?: Maybe<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )> } | { __typename: 'FlightsDialogMultiPassengerCredit', title?: Maybe<string>, message: string, animation: FlightsDialogAnimation, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } | { __typename: 'FlightsDialogServerError', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics?: Maybe<(
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      )> } | { __typename: 'FlightsDialogStaleSession', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } | { __typename: 'FlightsDialogStandard', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } | { __typename: 'FlightsForcedChoiceCrossSellDialog', title?: Maybe<string>, message?: Maybe<string>, animation: FlightsDialogAnimation, actions: Array<(
        { __typename: 'FlightsAction' }
        & FlightActionFragment
      )>, displayedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) } } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, link: any, icon?: Maybe<string>, text: string, styles: Array<FlightsPhrasePartStyle>, analytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), displayAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, scrollAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> };

export type FlightsIconPhrasesFragment = { __typename: 'FlightsIconPhrases', text: Array<(
    { __typename: 'FlightsPhrase' }
    & FlightsPhraseFragment
  )>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchFragment
  )> };

export type AlternateAirportOptionsFragment = { __typename: 'AlternateAirportOptions', accessibilityTitle: string, alternateOptionTitle: string, airportOptionAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), airportOptions: Array<(
    { __typename: 'AirportOption' }
    & AirportOptionFragment
  )> };

export type AirportOptionFragment = { __typename: 'AirportOption', accessibilityHeading: string, accessibilityMessage: string, destinationAirportDistance: string, destinationCityName: string, originAirportDistance: string, originCityName: string, icon: (
    { __typename: 'Icon' }
    & IconSearchFragment
  ), selectAction: (
    { __typename: 'FlightsAction' }
    & FlightActionFragment
  ) };

export type AlternateDateOptionsFragment = { __typename: 'AlternateDateOptions', accessibilityTitle: string, alternateOptionTitle: string, dateOptionAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), dateOptions: Array<(
    { __typename: 'DateOption' }
    & DateOptionFragment
  )> };

export type DateOptionFragment = { __typename: 'DateOption', accessibilityHeading: string, accessibilityMessage: string, numDaysDifference: string, tripDates: string, tripOD: string, selectAction: (
    { __typename: 'FlightsAction' }
    & FlightActionFragment
  ) };

export type FlightsDisplayComponentCountingValueFragment = { __typename: 'FlightsDisplayComponentCountingValue', displayCount: number, flightsDisplayComponent: FlightsDisplayComponent };

export type DateFragmentFragment = { __typename: 'Date', month: number, day: number, year: number };

export type MultiItemPackageableProductFragment = { __typename: 'MultiItemPackageableProduct', flights: Array<{ __typename: 'MultiItemSelectedFlightNaturalKey', offerToken: string, productTokens: Array<string>, travelers: Array<{ __typename: 'TravelerDetails', age?: Maybe<number>, type: TravelerDetailsType }> }> };

export type MultiItemFlightCrossSellPrimerFragment = { __typename: 'MultiItemFlightCrossSellPrimer', flightCrossSellProductType?: Maybe<FlightCrossSellProductType>, multiItemSearchContext: (
    { __typename: 'MultiItemSearchContext' }
    & MultiItemSearchContextFragment
  ) };

export type FlightsCrossSellOfferFragment = { __typename: 'FlightsCrossSellOffer', multiItemFlightCrossSellOfferPrimer?: Maybe<{ __typename: 'MultiItemFlightCrossSellOfferPrimer', multiItemSearchContext: (
      { __typename: 'MultiItemSearchContext' }
      & MultiItemSearchContextFragment
    ), multiItemPackageableProduct?: Maybe<(
      { __typename: 'MultiItemPackageableProduct' }
      & MultiItemPackageableProductFragment
    )>, brandedDealFallBack?: Maybe<(
      { __typename: 'MultiItemFlightCrossSellPrimer' }
      & MultiItemFlightCrossSellPrimerFragment
    )>, price?: Maybe<{ __typename: 'BrandedDealPrice', base: { __typename: 'Money', amount: number }, taxesAndFees: { __typename: 'Money', amount: number } }> }> };

export type FlightsFiltersEventAnalyticsFragment = { __typename: 'FlightsFiltersEventAnalytics', filterAppliedEventName: string, filterRemovedEventName: string, eventType: string, eventCategory: string, pageName: string };

export type FlightsFilterItemAnalyticsFragment = { __typename: 'FlightsFilterItemAnalytics', id?: Maybe<string>, position?: Maybe<string>, category?: Maybe<string>, value?: Maybe<string>, min?: Maybe<string>, max?: Maybe<string> };

export type FlightsOfferNaturalKeysFragmentFragment = { __typename: 'FlightsOfferNaturalKeys', flightNaturalKey: { __typename: 'FlightNaturalKey', offerToken: string, productTokens: Array<string>, travelers: Array<{ __typename: 'TravelerDetails', age?: Maybe<number>, type: TravelerDetailsType }> }, packagedProductsNaturalKeys?: Maybe<Array<{ __typename: 'ActivityNaturalKey' } | { __typename: 'CarNaturalKey', offerToken: string } | { __typename: 'FlightNaturalKey' } | { __typename: 'GroundTransfersNaturalKey' } | { __typename: 'PackageNaturalKey' } | { __typename: 'PropertyNaturalKey', id: string, ratePlanId: string, roomTypeId: string, inventoryType: InventoryType, checkOut: (
      { __typename: 'Date' }
      & DateFragmentFragment
    ), checkIn: (
      { __typename: 'Date' }
      & DateFragmentFragment
    ), rooms: Array<{ __typename: 'PropertyRoom', childAges: Array<number>, numberOfAdults: number }> }>> };

export type PriceLockupFragmentFragment = { __typename: 'EGDSPriceLockup', accessibilityPrice: string, leadingCaption?: Maybe<string>, lockupFormattedPoints?: Maybe<string>, lockupPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>>, priceSubtextBold?: Maybe<string>, priceSubtextStandard?: Maybe<Array<string>>, strikeThroughPrice?: Maybe<string> };

export type FlightsMessagingCardPlacardFragmentFragment = { __typename: 'FlightsMessagingCardPlacard', messagingCard: (
    { __typename: 'UIMessagingCard' }
    & UiMessagingCardFragment
  ), button?: Maybe<{ __typename: 'FlightsActionButton', primary?: Maybe<string>, clientAction: { __typename: 'FlightsAncillaryContinueAction' } | { __typename: 'FlightsBookingAction' } | { __typename: 'FlightsBoundNavigation' } | { __typename: 'FlightsClickAction' } | { __typename: 'FlightsCreditClearAction' } | { __typename: 'FlightsCreditSelectionAction' } | { __typename: 'FlightsCreditSelectorOpenAction' } | { __typename: 'FlightsDialogCloseAction' } | (
      { __typename: 'FlightsDialogTriggerAction' }
      & ClientActionFragmentFragment
    ) | { __typename: 'FlightsFareTypeSelectionAction' } | { __typename: 'FlightsLegDropdownItemSelection' } | { __typename: 'FlightsLoadAncillariesAction' } | { __typename: 'FlightsNavigateToDetails' } | { __typename: 'FlightsRedirectOrDialog' } | { __typename: 'FlightsRefreshAction' } | { __typename: 'FlightsRemovePriceMatchPromiseAction' } | { __typename: 'FlightsResourceLinkAction' } | { __typename: 'FlightsResourceRedirectAction' } | { __typename: 'FlightsSearchCriteriaChangeAction' } | { __typename: 'FlightsSelectionAction' } | { __typename: 'FlightsSwitchToggleAction' } | { __typename: 'InsuranceSwitchToggleAction' } | { __typename: 'MultiItemSelectPackage' } | { __typename: 'MultiItemSelectProducts' } }>, onViewedAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, onViewedAnalyticsList?: Maybe<Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>>, actionElement?: Maybe<(
    { __typename: 'FlightsActionButton' }
    & FlightsClientActionElement_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & FlightsClientActionElement_FlightsActionLink_Fragment
  )> };

type FlightsClientActionElement_FlightsActionButton_Fragment = { __typename: 'FlightsActionButton' };

type FlightsClientActionElement_FlightsActionLink_Fragment = (
  { __typename: 'FlightsActionLink' }
  & FlightsActionLinkFragmentFragment
);

export type FlightsClientActionElementFragment = FlightsClientActionElement_FlightsActionButton_Fragment | FlightsClientActionElement_FlightsActionLink_Fragment;

export type EgdsGraphicIllustrationFragmentSearchFragment = { __typename: 'Illustration', id: string, description: string, egdsElementId?: Maybe<string>, link: any };

export type ClientActionFragmentFragment = { __typename: 'FlightsDialogTriggerAction', dialog: { __typename: 'AdditionalInformationPopoverDialogSection' } | { __typename: 'ClientSideErrorRepresentationDialog' } | { __typename: 'EGDSActionDialog' } | (
    { __typename: 'EGDSFullScreenDialog' }
    & EgdsFullScreenDialogFragmentFragment
  ) | { __typename: 'EGDSLoaderDialog' } | { __typename: 'PriceInsightsExistingTrackingDialogAction' } | { __typename: 'PriceInsightsTrackingRetryDialogAction' } | { __typename: 'ServicingDialog' }, dialogContents: Array<(
    { __typename: 'ActivitySearchForm' }
    & EgdsElementFragment_ActivitySearchForm_Fragment
  ) | (
    { __typename: 'AgencyUIPrimaryFloatingActionButton' }
    & EgdsElementFragment_AgencyUiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'AgencyUISecondaryFloatingActionButton' }
    & EgdsElementFragment_AgencyUiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'CarSearchForm' }
    & EgdsElementFragment_CarSearchForm_Fragment
  ) | (
    { __typename: 'CruiseSearchForm' }
    & EgdsElementFragment_CruiseSearchForm_Fragment
  ) | (
    { __typename: 'DurationSpanSelector' }
    & EgdsElementFragment_DurationSpanSelector_Fragment
  ) | (
    { __typename: 'EGDSBadgeNotification' }
    & EgdsElementFragment_EgdsBadgeNotification_Fragment
  ) | (
    { __typename: 'EGDSBasicCheckBox' }
    & EgdsElementFragment_EgdsBasicCheckBox_Fragment
  ) | (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsElementFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSBasicOption' }
    & EgdsElementFragment_EgdsBasicOption_Fragment
  ) | (
    { __typename: 'EGDSBasicSelect' }
    & EgdsElementFragment_EgdsBasicSelect_Fragment
  ) | (
    { __typename: 'EGDSBasicStepInput' }
    & EgdsElementFragment_EgdsBasicStepInput_Fragment
  ) | (
    { __typename: 'EGDSBasicTab' }
    & EgdsElementFragment_EgdsBasicTab_Fragment
  ) | (
    { __typename: 'EGDSBasicTabs' }
    & EgdsElementFragment_EgdsBasicTabs_Fragment
  ) | (
    { __typename: 'EGDSBasicTravelerSelector' }
    & EgdsElementFragment_EgdsBasicTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSBulletedList' }
    & EgdsElementFragment_EgdsBulletedList_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsElementFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSComposableTextElementSectionContainer' }
    & EgdsElementFragment_EgdsComposableTextElementSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsElementFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSEmailInputField' }
    & EgdsElementFragment_EgdsEmailInputField_Fragment
  ) | (
    { __typename: 'EGDSErrorSummary' }
    & EgdsElementFragment_EgdsErrorSummary_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsElementFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSImageLink' }
    & EgdsElementFragment_EgdsImageLink_Fragment
  ) | (
    { __typename: 'EGDSImageLinkCard' }
    & EgdsElementFragment_EgdsImageLinkCard_Fragment
  ) | (
    { __typename: 'EGDSInfantSeatRadioButton' }
    & EgdsElementFragment_EgdsInfantSeatRadioButton_Fragment
  ) | (
    { __typename: 'EGDSLinkList' }
    & EgdsElementFragment_EgdsLinkList_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsElementFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSLoyaltyBadge' }
    & EgdsElementFragment_EgdsLoyaltyBadge_Fragment
  ) | (
    { __typename: 'EGDSNumberInputField' }
    & EgdsElementFragment_EgdsNumberInputField_Fragment
  ) | (
    { __typename: 'EGDSOrderedList' }
    & EgdsElementFragment_EgdsOrderedList_Fragment
  ) | (
    { __typename: 'EGDSOverlayButton' }
    & EgdsElementFragment_EgdsOverlayButton_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsElementFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPasswordInputField' }
    & EgdsElementFragment_EgdsPasswordInputField_Fragment
  ) | (
    { __typename: 'EGDSProgramBadge' }
    & EgdsElementFragment_EgdsProgramBadge_Fragment
  ) | (
    { __typename: 'EGDSRoomsTravelerSelector' }
    & EgdsElementFragment_EgdsRoomsTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSSearchFormButton' }
    & EgdsElementFragment_EgdsSearchFormButton_Fragment
  ) | (
    { __typename: 'EGDSSearchFormDatePickerField' }
    & EgdsElementFragment_EgdsSearchFormDatePickerField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormInputField' }
    & EgdsElementFragment_EgdsSearchFormInputField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationField' }
    & EgdsElementFragment_EgdsSearchFormLocationField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationsField' }
    & EgdsElementFragment_EgdsSearchFormLocationsField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormTravelersField' }
    & EgdsElementFragment_EgdsSearchFormTravelersField_Fragment
  ) | (
    { __typename: 'EGDSSectionContainer' }
    & EgdsElementFragment_EgdsSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsElementFragment_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardBadge' }
    & EgdsElementFragment_EgdsStandardBadge_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsElementFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStandardMessagingCard' }
    & EgdsElementFragment_EgdsStandardMessagingCard_Fragment
  ) | (
    { __typename: 'EGDSTextAreaInputField' }
    & EgdsElementFragment_EgdsTextAreaInputField_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsElementFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconList' }
    & EgdsElementFragment_EgdsTextIconList_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsElementFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextInputField' }
    & EgdsElementFragment_EgdsTextInputField_Fragment
  ) | (
    { __typename: 'EGDSTextListSection' }
    & EgdsElementFragment_EgdsTextListSection_Fragment
  ) | (
    { __typename: 'EGDSTextSection' }
    & EgdsElementFragment_EgdsTextSection_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsElementFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsElementFragment_EgdsTextWithMarkListItem_Fragment
  ) | (
    { __typename: 'EGDSToast' }
    & EgdsElementFragment_EgdsToast_Fragment
  ) | (
    { __typename: 'EGDSTravelerChildAgeSelect' }
    & EgdsElementFragment_EgdsTravelerChildAgeSelect_Fragment
  ) | (
    { __typename: 'EGDSTravelerInfantSeatSelection' }
    & EgdsElementFragment_EgdsTravelerInfantSeatSelection_Fragment
  ) | (
    { __typename: 'EGDSTravelerStepInput' }
    & EgdsElementFragment_EgdsTravelerStepInput_Fragment
  ) | (
    { __typename: 'EGDSTypeaheadInputField' }
    & EgdsElementFragment_EgdsTypeaheadInputField_Fragment
  ) | (
    { __typename: 'EGDSUnorderedList' }
    & EgdsElementFragment_EgdsUnorderedList_Fragment
  ) | (
    { __typename: 'FlightSearchForm' }
    & EgdsElementFragment_FlightSearchForm_Fragment
  ) | (
    { __typename: 'FlightSearchInputForm' }
    & EgdsElementFragment_FlightSearchInputForm_Fragment
  ) | (
    { __typename: 'FlightsActionButton' }
    & EgdsElementFragment_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsActionCheckbox' }
    & EgdsElementFragment_FlightsActionCheckbox_Fragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & EgdsElementFragment_FlightsActionLink_Fragment
  ) | (
    { __typename: 'FlightsDialogTrigger' }
    & EgdsElementFragment_FlightsDialogTrigger_Fragment
  ) | (
    { __typename: 'IdentityBasicBlock' }
    & EgdsElementFragment_IdentityBasicBlock_Fragment
  ) | (
    { __typename: 'IdentityButton' }
    & EgdsElementFragment_IdentityButton_Fragment
  ) | (
    { __typename: 'IdentityConsentNestedCheckBox' }
    & EgdsElementFragment_IdentityConsentNestedCheckBox_Fragment
  ) | (
    { __typename: 'IdentityImage' }
    & EgdsElementFragment_IdentityImage_Fragment
  ) | (
    { __typename: 'IdentityImageGallery' }
    & EgdsElementFragment_IdentityImageGallery_Fragment
  ) | (
    { __typename: 'IdentityInfoLinkComponent' }
    & EgdsElementFragment_IdentityInfoLinkComponent_Fragment
  ) | (
    { __typename: 'IdentityPasswordStrengthComponent' }
    & EgdsElementFragment_IdentityPasswordStrengthComponent_Fragment
  ) | (
    { __typename: 'IdentityResendButton' }
    & EgdsElementFragment_IdentityResendButton_Fragment
  ) | (
    { __typename: 'IdentitySingleColumnComponentLayout' }
    & EgdsElementFragment_IdentitySingleColumnComponentLayout_Fragment
  ) | (
    { __typename: 'IdentitySocialButton' }
    & EgdsElementFragment_IdentitySocialButton_Fragment
  ) | (
    { __typename: 'IdentityText' }
    & EgdsElementFragment_IdentityText_Fragment
  ) | (
    { __typename: 'Illustration' }
    & EgdsElementFragment_Illustration_Fragment
  ) | (
    { __typename: 'LodgingSearchForm' }
    & EgdsElementFragment_LodgingSearchForm_Fragment
  ) | (
    { __typename: 'PackagesSearchForm' }
    & EgdsElementFragment_PackagesSearchForm_Fragment
  ) | (
    { __typename: 'ProductSummaryCard' }
    & EgdsElementFragment_ProductSummaryCard_Fragment
  ) | (
    { __typename: 'ProfileAccountLink' }
    & EgdsElementFragment_ProfileAccountLink_Fragment
  ) | (
    { __typename: 'ProfileActionButtonCard' }
    & EgdsElementFragment_ProfileActionButtonCard_Fragment
  ) | (
    { __typename: 'ProfileBulletedList' }
    & EgdsElementFragment_ProfileBulletedList_Fragment
  ) | (
    { __typename: 'ProfileEGDSSectionContainer' }
    & EgdsElementFragment_ProfileEgdsSectionContainer_Fragment
  ) | (
    { __typename: 'ProfileFormHorizontalContainer' }
    & EgdsElementFragment_ProfileFormHorizontalContainer_Fragment
  ) | (
    { __typename: 'ProfileFormSection' }
    & EgdsElementFragment_ProfileFormSection_Fragment
  ) | (
    { __typename: 'ProfileLink' }
    & EgdsElementFragment_ProfileLink_Fragment
  ) | (
    { __typename: 'ProfileNumberField' }
    & EgdsElementFragment_ProfileNumberField_Fragment
  ) | (
    { __typename: 'ProfilePhoneNumberField' }
    & EgdsElementFragment_ProfilePhoneNumberField_Fragment
  ) | (
    { __typename: 'ProfileRadioButton' }
    & EgdsElementFragment_ProfileRadioButton_Fragment
  ) | (
    { __typename: 'ProfileRadioButtonGroup' }
    & EgdsElementFragment_ProfileRadioButtonGroup_Fragment
  ) | (
    { __typename: 'ProfileSelectField' }
    & EgdsElementFragment_ProfileSelectField_Fragment
  ) | (
    { __typename: 'ProfileSlimCard' }
    & EgdsElementFragment_ProfileSlimCard_Fragment
  ) | (
    { __typename: 'ProfileSwitchOption' }
    & EgdsElementFragment_ProfileSwitchOption_Fragment
  ) | (
    { __typename: 'ProfileTextField' }
    & EgdsElementFragment_ProfileTextField_Fragment
  ) | (
    { __typename: 'SearchFormDurationSpanField' }
    & EgdsElementFragment_SearchFormDurationSpanField_Fragment
  ) | (
    { __typename: 'TripsMediaGallery' }
    & EgdsElementFragment_TripsMediaGallery_Fragment
  ) | (
    { __typename: 'TripsValidatedInput' }
    & EgdsElementFragment_TripsValidatedInput_Fragment
  ) | (
    { __typename: 'UIBanner' }
    & EgdsElementFragment_UiBanner_Fragment
  ) | (
    { __typename: 'UIEmptyState' }
    & EgdsElementFragment_UiEmptyState_Fragment
  ) | (
    { __typename: 'UIMessagingCard' }
    & EgdsElementFragment_UiMessagingCard_Fragment
  ) | (
    { __typename: 'UIPrimaryButton' }
    & EgdsElementFragment_UiPrimaryButton_Fragment
  ) | (
    { __typename: 'UIPrimaryFloatingActionButton' }
    & EgdsElementFragment_UiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UISecondaryButton' }
    & EgdsElementFragment_UiSecondaryButton_Fragment
  ) | (
    { __typename: 'UISecondaryFloatingActionButton' }
    & EgdsElementFragment_UiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UITertiaryButton' }
    & EgdsElementFragment_UiTertiaryButton_Fragment
  )>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type EgdsFullScreenDialogFragmentFragment = { __typename: 'EGDSFullScreenDialog', toolbar: (
    { __typename: 'EGDSDialogToolbar' }
    & EgdsDialogToolbarFragmentFragment
  ) };

type EgdsButtonFragment_EgdsOverlayButton_Fragment = { __typename: 'EGDSOverlayButton' };

type EgdsButtonFragment_EgdsSearchFormButton_Fragment = { __typename: 'EGDSSearchFormButton' };

type EgdsButtonFragment_FlightsActionButton_Fragment = (
  { __typename: 'FlightsActionButton' }
  & FlightsActionButtonFragment
);

type EgdsButtonFragment_FlightsDialogTrigger_Fragment = (
  { __typename: 'FlightsDialogTrigger' }
  & FlightsDialogTriggerFragmentFragment
);

type EgdsButtonFragment_FlightsExperienceActionButton_Fragment = { __typename: 'FlightsExperienceActionButton' };

type EgdsButtonFragment_FlightsSmartShoppingActionButton_Fragment = { __typename: 'FlightsSmartShoppingActionButton' };

type EgdsButtonFragment_PackageUiActionDialogFooterButton_Fragment = { __typename: 'PackageUIActionDialogFooterButton' };

type EgdsButtonFragment_PackageUiHideSearchFormAction_Fragment = { __typename: 'PackageUIHideSearchFormAction' };

type EgdsButtonFragment_PackageUiTravelGuideButton_Fragment = { __typename: 'PackageUITravelGuideButton' };

type EgdsButtonFragment_ServicingButton_Fragment = { __typename: 'ServicingButton' };

type EgdsButtonFragment_SupplyCancelWaiverActionButton_Fragment = { __typename: 'SupplyCancelWaiverActionButton' };

type EgdsButtonFragment_SupplyContentLinkStyleButton_Fragment = { __typename: 'SupplyContentLinkStyleButton' };

type EgdsButtonFragment_UiPrimaryButton_Fragment = { __typename: 'UIPrimaryButton' };

type EgdsButtonFragment_UiSecondaryButton_Fragment = { __typename: 'UISecondaryButton' };

type EgdsButtonFragment_UiTertiaryButton_Fragment = { __typename: 'UITertiaryButton' };

export type EgdsButtonFragmentFragment = EgdsButtonFragment_EgdsOverlayButton_Fragment | EgdsButtonFragment_EgdsSearchFormButton_Fragment | EgdsButtonFragment_FlightsActionButton_Fragment | EgdsButtonFragment_FlightsDialogTrigger_Fragment | EgdsButtonFragment_FlightsExperienceActionButton_Fragment | EgdsButtonFragment_FlightsSmartShoppingActionButton_Fragment | EgdsButtonFragment_PackageUiActionDialogFooterButton_Fragment | EgdsButtonFragment_PackageUiHideSearchFormAction_Fragment | EgdsButtonFragment_PackageUiTravelGuideButton_Fragment | EgdsButtonFragment_ServicingButton_Fragment | EgdsButtonFragment_SupplyCancelWaiverActionButton_Fragment | EgdsButtonFragment_SupplyContentLinkStyleButton_Fragment | EgdsButtonFragment_UiPrimaryButton_Fragment | EgdsButtonFragment_UiSecondaryButton_Fragment | EgdsButtonFragment_UiTertiaryButton_Fragment;

export type FlightsDialogTriggerFragmentFragment = { __typename: 'FlightsDialogTrigger', dialogAction: FlightsDialogAction, dialogId: FlightsDialogId, dynamicDialogId?: Maybe<string>, trigger: (
    { __typename: 'FlightsActionButton' }
    & FlightsActionButtonFragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & FlightsActionLinkFragmentFragment
  ) | (
    { __typename: 'FlightsExperienceActionButton' }
    & FlightsExperienceActionButtonFragmentFragment
  ) | (
    { __typename: 'FlightsExperienceActionLink' }
    & FlightsExperienceActionLinkFragmentFragment
  ) };

export type FlightsExperienceActionButtonFragmentFragment = { __typename: 'FlightsExperienceActionButton', accessibility?: Maybe<string>, primary?: Maybe<string>, clientAction: { __typename: 'FlightsAncillaryContinueAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsBookingAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsBoundNavigation', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsClickAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsCreditClearAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsCreditSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsCreditSelectorOpenAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsDialogCloseAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsDialogTriggerAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsFareTypeSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsLegDropdownItemSelection', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsLoadAncillariesAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsNavigateToDetails', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsRedirectOrDialog', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsRefreshAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsRemovePriceMatchPromiseAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsResourceRedirectAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsSearchCriteriaChangeAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | (
    { __typename: 'FlightsSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & FlightsSelectionActionFragment
  ) | { __typename: 'FlightsSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'InsuranceSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'MultiItemSelectPackage', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'MultiItemSelectProducts', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } };

export type FlightsExperienceActionLinkFragmentFragment = { __typename: 'FlightsExperienceActionLink', accessibility?: Maybe<string>, primary?: Maybe<string>, clientAction: { __typename: 'FlightsAncillaryContinueAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsBookingAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsBoundNavigation', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsClickAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsCreditClearAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsCreditSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsCreditSelectorOpenAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsDialogCloseAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsDialogTriggerAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsFareTypeSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsLegDropdownItemSelection', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsLoadAncillariesAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsNavigateToDetails', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsRedirectOrDialog', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsRefreshAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsRemovePriceMatchPromiseAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsResourceRedirectAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'FlightsSearchCriteriaChangeAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | (
    { __typename: 'FlightsSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> }
    & FlightsSelectionActionFragment
  ) | { __typename: 'FlightsSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'InsuranceSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'MultiItemSelectPackage', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } | { __typename: 'MultiItemSelectProducts', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsFragment
    )> } };

export type EgdsDialogToolbarFragmentFragment = { __typename: 'EGDSDialogToolbar', title: string, closeText?: Maybe<string> };

type EgdsElementFragment_ActivitySearchForm_Fragment = { __typename: 'ActivitySearchForm' };

type EgdsElementFragment_AgencyUiPrimaryFloatingActionButton_Fragment = { __typename: 'AgencyUIPrimaryFloatingActionButton' };

type EgdsElementFragment_AgencyUiSecondaryFloatingActionButton_Fragment = { __typename: 'AgencyUISecondaryFloatingActionButton' };

type EgdsElementFragment_CarSearchForm_Fragment = { __typename: 'CarSearchForm' };

type EgdsElementFragment_CruiseSearchForm_Fragment = { __typename: 'CruiseSearchForm' };

type EgdsElementFragment_DurationSpanSelector_Fragment = { __typename: 'DurationSpanSelector' };

type EgdsElementFragment_EgdsBadgeNotification_Fragment = { __typename: 'EGDSBadgeNotification' };

type EgdsElementFragment_EgdsBasicCheckBox_Fragment = { __typename: 'EGDSBasicCheckBox' };

type EgdsElementFragment_EgdsBasicLocalizedText_Fragment = (
  { __typename: 'EGDSBasicLocalizedText' }
  & EgdsTextFragment_EgdsBasicLocalizedText_Fragment
);

type EgdsElementFragment_EgdsBasicOption_Fragment = { __typename: 'EGDSBasicOption' };

type EgdsElementFragment_EgdsBasicSelect_Fragment = { __typename: 'EGDSBasicSelect' };

type EgdsElementFragment_EgdsBasicStepInput_Fragment = { __typename: 'EGDSBasicStepInput' };

type EgdsElementFragment_EgdsBasicTab_Fragment = { __typename: 'EGDSBasicTab' };

type EgdsElementFragment_EgdsBasicTabs_Fragment = { __typename: 'EGDSBasicTabs' };

type EgdsElementFragment_EgdsBasicTravelerSelector_Fragment = { __typename: 'EGDSBasicTravelerSelector' };

type EgdsElementFragment_EgdsBulletedList_Fragment = { __typename: 'EGDSBulletedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } | { __typename: 'EGDSTextWithMarkListItem', text: string } | { __typename: 'EarnMessageContainerListItem', text: string } | { __typename: 'FlightsTextContainerListItem', text: string } | { __typename: 'MishopUITextContainerListItem', text: string }> };

type EgdsElementFragment_EgdsCardinalLocalizedText_Fragment = (
  { __typename: 'EGDSCardinalLocalizedText' }
  & EgdsTextFragment_EgdsCardinalLocalizedText_Fragment
);

type EgdsElementFragment_EgdsComposableTextElementSectionContainer_Fragment = { __typename: 'EGDSComposableTextElementSectionContainer' };

type EgdsElementFragment_EgdsCompositeLocalizedText_Fragment = (
  { __typename: 'EGDSCompositeLocalizedText' }
  & EgdsTextFragment_EgdsCompositeLocalizedText_Fragment
);

type EgdsElementFragment_EgdsEmailInputField_Fragment = { __typename: 'EGDSEmailInputField' };

type EgdsElementFragment_EgdsErrorSummary_Fragment = { __typename: 'EGDSErrorSummary' };

type EgdsElementFragment_EgdsHeading_Fragment = (
  { __typename: 'EGDSHeading' }
  & EgdsTextFragment_EgdsHeading_Fragment
);

type EgdsElementFragment_EgdsImageLink_Fragment = { __typename: 'EGDSImageLink' };

type EgdsElementFragment_EgdsImageLinkCard_Fragment = { __typename: 'EGDSImageLinkCard' };

type EgdsElementFragment_EgdsInfantSeatRadioButton_Fragment = { __typename: 'EGDSInfantSeatRadioButton' };

type EgdsElementFragment_EgdsLinkList_Fragment = { __typename: 'EGDSLinkList' };

type EgdsElementFragment_EgdsLocalizedTextTemplate_Fragment = (
  { __typename: 'EGDSLocalizedTextTemplate' }
  & EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment
);

type EgdsElementFragment_EgdsLoyaltyBadge_Fragment = { __typename: 'EGDSLoyaltyBadge' };

type EgdsElementFragment_EgdsNumberInputField_Fragment = { __typename: 'EGDSNumberInputField' };

type EgdsElementFragment_EgdsOrderedList_Fragment = { __typename: 'EGDSOrderedList' };

type EgdsElementFragment_EgdsOverlayButton_Fragment = { __typename: 'EGDSOverlayButton' };

type EgdsElementFragment_EgdsParagraph_Fragment = (
  { __typename: 'EGDSParagraph' }
  & EgdsTextFragment_EgdsParagraph_Fragment
);

type EgdsElementFragment_EgdsPasswordInputField_Fragment = { __typename: 'EGDSPasswordInputField' };

type EgdsElementFragment_EgdsProgramBadge_Fragment = { __typename: 'EGDSProgramBadge' };

type EgdsElementFragment_EgdsRoomsTravelerSelector_Fragment = { __typename: 'EGDSRoomsTravelerSelector' };

type EgdsElementFragment_EgdsSearchFormButton_Fragment = { __typename: 'EGDSSearchFormButton' };

type EgdsElementFragment_EgdsSearchFormDatePickerField_Fragment = { __typename: 'EGDSSearchFormDatePickerField' };

type EgdsElementFragment_EgdsSearchFormInputField_Fragment = { __typename: 'EGDSSearchFormInputField' };

type EgdsElementFragment_EgdsSearchFormLocationField_Fragment = { __typename: 'EGDSSearchFormLocationField' };

type EgdsElementFragment_EgdsSearchFormLocationsField_Fragment = { __typename: 'EGDSSearchFormLocationsField' };

type EgdsElementFragment_EgdsSearchFormTravelersField_Fragment = { __typename: 'EGDSSearchFormTravelersField' };

type EgdsElementFragment_EgdsSectionContainer_Fragment = { __typename: 'EGDSSectionContainer' };

type EgdsElementFragment_EgdsSpannableText_Fragment = (
  { __typename: 'EGDSSpannableText' }
  & EgdsTextFragment_EgdsSpannableText_Fragment
);

type EgdsElementFragment_EgdsStandardBadge_Fragment = { __typename: 'EGDSStandardBadge' };

type EgdsElementFragment_EgdsStandardLink_Fragment = (
  { __typename: 'EGDSStandardLink' }
  & EgdsTextFragment_EgdsStandardLink_Fragment
);

type EgdsElementFragment_EgdsStandardMessagingCard_Fragment = { __typename: 'EGDSStandardMessagingCard' };

type EgdsElementFragment_EgdsTextAreaInputField_Fragment = { __typename: 'EGDSTextAreaInputField' };

type EgdsElementFragment_EgdsTextIconLinkListItem_Fragment = (
  { __typename: 'EGDSTextIconLinkListItem' }
  & EgdsTextFragment_EgdsTextIconLinkListItem_Fragment
);

type EgdsElementFragment_EgdsTextIconList_Fragment = { __typename: 'EGDSTextIconList' };

type EgdsElementFragment_EgdsTextIconListItem_Fragment = (
  { __typename: 'EGDSTextIconListItem' }
  & EgdsTextFragment_EgdsTextIconListItem_Fragment
);

type EgdsElementFragment_EgdsTextInputField_Fragment = { __typename: 'EGDSTextInputField' };

type EgdsElementFragment_EgdsTextListSection_Fragment = { __typename: 'EGDSTextListSection' };

type EgdsElementFragment_EgdsTextSection_Fragment = { __typename: 'EGDSTextSection' };

type EgdsElementFragment_EgdsTextStandardListItem_Fragment = (
  { __typename: 'EGDSTextStandardListItem' }
  & EgdsTextFragment_EgdsTextStandardListItem_Fragment
);

type EgdsElementFragment_EgdsTextWithMarkListItem_Fragment = (
  { __typename: 'EGDSTextWithMarkListItem' }
  & EgdsTextFragment_EgdsTextWithMarkListItem_Fragment
);

type EgdsElementFragment_EgdsToast_Fragment = { __typename: 'EGDSToast' };

type EgdsElementFragment_EgdsTravelerChildAgeSelect_Fragment = { __typename: 'EGDSTravelerChildAgeSelect' };

type EgdsElementFragment_EgdsTravelerInfantSeatSelection_Fragment = { __typename: 'EGDSTravelerInfantSeatSelection' };

type EgdsElementFragment_EgdsTravelerStepInput_Fragment = { __typename: 'EGDSTravelerStepInput' };

type EgdsElementFragment_EgdsTypeaheadInputField_Fragment = { __typename: 'EGDSTypeaheadInputField' };

type EgdsElementFragment_EgdsUnorderedList_Fragment = { __typename: 'EGDSUnorderedList' };

type EgdsElementFragment_FlightSearchForm_Fragment = { __typename: 'FlightSearchForm' };

type EgdsElementFragment_FlightSearchInputForm_Fragment = { __typename: 'FlightSearchInputForm' };

type EgdsElementFragment_FlightsActionButton_Fragment = { __typename: 'FlightsActionButton' };

type EgdsElementFragment_FlightsActionCheckbox_Fragment = { __typename: 'FlightsActionCheckbox' };

type EgdsElementFragment_FlightsActionLink_Fragment = { __typename: 'FlightsActionLink' };

type EgdsElementFragment_FlightsDialogTrigger_Fragment = { __typename: 'FlightsDialogTrigger' };

type EgdsElementFragment_IdentityBasicBlock_Fragment = { __typename: 'IdentityBasicBlock' };

type EgdsElementFragment_IdentityButton_Fragment = { __typename: 'IdentityButton' };

type EgdsElementFragment_IdentityConsentNestedCheckBox_Fragment = { __typename: 'IdentityConsentNestedCheckBox' };

type EgdsElementFragment_IdentityImage_Fragment = { __typename: 'IdentityImage' };

type EgdsElementFragment_IdentityImageGallery_Fragment = { __typename: 'IdentityImageGallery' };

type EgdsElementFragment_IdentityInfoLinkComponent_Fragment = { __typename: 'IdentityInfoLinkComponent' };

type EgdsElementFragment_IdentityPasswordStrengthComponent_Fragment = { __typename: 'IdentityPasswordStrengthComponent' };

type EgdsElementFragment_IdentityResendButton_Fragment = { __typename: 'IdentityResendButton' };

type EgdsElementFragment_IdentitySingleColumnComponentLayout_Fragment = { __typename: 'IdentitySingleColumnComponentLayout' };

type EgdsElementFragment_IdentitySocialButton_Fragment = { __typename: 'IdentitySocialButton' };

type EgdsElementFragment_IdentityText_Fragment = { __typename: 'IdentityText' };

type EgdsElementFragment_Illustration_Fragment = (
  { __typename: 'Illustration' }
  & EgdsGraphicIllustrationFragmentSearchFragment
);

type EgdsElementFragment_LodgingSearchForm_Fragment = { __typename: 'LodgingSearchForm' };

type EgdsElementFragment_PackagesSearchForm_Fragment = { __typename: 'PackagesSearchForm' };

type EgdsElementFragment_ProductSummaryCard_Fragment = { __typename: 'ProductSummaryCard' };

type EgdsElementFragment_ProfileAccountLink_Fragment = { __typename: 'ProfileAccountLink' };

type EgdsElementFragment_ProfileActionButtonCard_Fragment = { __typename: 'ProfileActionButtonCard' };

type EgdsElementFragment_ProfileBulletedList_Fragment = { __typename: 'ProfileBulletedList' };

type EgdsElementFragment_ProfileEgdsSectionContainer_Fragment = { __typename: 'ProfileEGDSSectionContainer' };

type EgdsElementFragment_ProfileFormHorizontalContainer_Fragment = { __typename: 'ProfileFormHorizontalContainer' };

type EgdsElementFragment_ProfileFormSection_Fragment = { __typename: 'ProfileFormSection' };

type EgdsElementFragment_ProfileLink_Fragment = { __typename: 'ProfileLink' };

type EgdsElementFragment_ProfileNumberField_Fragment = { __typename: 'ProfileNumberField' };

type EgdsElementFragment_ProfilePhoneNumberField_Fragment = { __typename: 'ProfilePhoneNumberField' };

type EgdsElementFragment_ProfileRadioButton_Fragment = { __typename: 'ProfileRadioButton' };

type EgdsElementFragment_ProfileRadioButtonGroup_Fragment = { __typename: 'ProfileRadioButtonGroup' };

type EgdsElementFragment_ProfileSelectField_Fragment = { __typename: 'ProfileSelectField' };

type EgdsElementFragment_ProfileSlimCard_Fragment = { __typename: 'ProfileSlimCard' };

type EgdsElementFragment_ProfileSwitchOption_Fragment = { __typename: 'ProfileSwitchOption' };

type EgdsElementFragment_ProfileTextField_Fragment = { __typename: 'ProfileTextField' };

type EgdsElementFragment_SearchFormDurationSpanField_Fragment = { __typename: 'SearchFormDurationSpanField' };

type EgdsElementFragment_TripsMediaGallery_Fragment = { __typename: 'TripsMediaGallery' };

type EgdsElementFragment_TripsValidatedInput_Fragment = { __typename: 'TripsValidatedInput' };

type EgdsElementFragment_UiBanner_Fragment = { __typename: 'UIBanner' };

type EgdsElementFragment_UiEmptyState_Fragment = { __typename: 'UIEmptyState' };

type EgdsElementFragment_UiMessagingCard_Fragment = { __typename: 'UIMessagingCard', primary?: Maybe<string>, secondaries?: Maybe<Array<string>>, graphic?: Maybe<{ __typename: 'Icon' } | (
    { __typename: 'Illustration', link: any }
    & EgdsGraphicIllustrationFragmentSearchFragment
  ) | { __typename: 'Mark' }> };

type EgdsElementFragment_UiPrimaryButton_Fragment = { __typename: 'UIPrimaryButton' };

type EgdsElementFragment_UiPrimaryFloatingActionButton_Fragment = { __typename: 'UIPrimaryFloatingActionButton' };

type EgdsElementFragment_UiSecondaryButton_Fragment = { __typename: 'UISecondaryButton' };

type EgdsElementFragment_UiSecondaryFloatingActionButton_Fragment = { __typename: 'UISecondaryFloatingActionButton' };

type EgdsElementFragment_UiTertiaryButton_Fragment = { __typename: 'UITertiaryButton' };

export type EgdsElementFragmentFragment = EgdsElementFragment_ActivitySearchForm_Fragment | EgdsElementFragment_AgencyUiPrimaryFloatingActionButton_Fragment | EgdsElementFragment_AgencyUiSecondaryFloatingActionButton_Fragment | EgdsElementFragment_CarSearchForm_Fragment | EgdsElementFragment_CruiseSearchForm_Fragment | EgdsElementFragment_DurationSpanSelector_Fragment | EgdsElementFragment_EgdsBadgeNotification_Fragment | EgdsElementFragment_EgdsBasicCheckBox_Fragment | EgdsElementFragment_EgdsBasicLocalizedText_Fragment | EgdsElementFragment_EgdsBasicOption_Fragment | EgdsElementFragment_EgdsBasicSelect_Fragment | EgdsElementFragment_EgdsBasicStepInput_Fragment | EgdsElementFragment_EgdsBasicTab_Fragment | EgdsElementFragment_EgdsBasicTabs_Fragment | EgdsElementFragment_EgdsBasicTravelerSelector_Fragment | EgdsElementFragment_EgdsBulletedList_Fragment | EgdsElementFragment_EgdsCardinalLocalizedText_Fragment | EgdsElementFragment_EgdsComposableTextElementSectionContainer_Fragment | EgdsElementFragment_EgdsCompositeLocalizedText_Fragment | EgdsElementFragment_EgdsEmailInputField_Fragment | EgdsElementFragment_EgdsErrorSummary_Fragment | EgdsElementFragment_EgdsHeading_Fragment | EgdsElementFragment_EgdsImageLink_Fragment | EgdsElementFragment_EgdsImageLinkCard_Fragment | EgdsElementFragment_EgdsInfantSeatRadioButton_Fragment | EgdsElementFragment_EgdsLinkList_Fragment | EgdsElementFragment_EgdsLocalizedTextTemplate_Fragment | EgdsElementFragment_EgdsLoyaltyBadge_Fragment | EgdsElementFragment_EgdsNumberInputField_Fragment | EgdsElementFragment_EgdsOrderedList_Fragment | EgdsElementFragment_EgdsOverlayButton_Fragment | EgdsElementFragment_EgdsParagraph_Fragment | EgdsElementFragment_EgdsPasswordInputField_Fragment | EgdsElementFragment_EgdsProgramBadge_Fragment | EgdsElementFragment_EgdsRoomsTravelerSelector_Fragment | EgdsElementFragment_EgdsSearchFormButton_Fragment | EgdsElementFragment_EgdsSearchFormDatePickerField_Fragment | EgdsElementFragment_EgdsSearchFormInputField_Fragment | EgdsElementFragment_EgdsSearchFormLocationField_Fragment | EgdsElementFragment_EgdsSearchFormLocationsField_Fragment | EgdsElementFragment_EgdsSearchFormTravelersField_Fragment | EgdsElementFragment_EgdsSectionContainer_Fragment | EgdsElementFragment_EgdsSpannableText_Fragment | EgdsElementFragment_EgdsStandardBadge_Fragment | EgdsElementFragment_EgdsStandardLink_Fragment | EgdsElementFragment_EgdsStandardMessagingCard_Fragment | EgdsElementFragment_EgdsTextAreaInputField_Fragment | EgdsElementFragment_EgdsTextIconLinkListItem_Fragment | EgdsElementFragment_EgdsTextIconList_Fragment | EgdsElementFragment_EgdsTextIconListItem_Fragment | EgdsElementFragment_EgdsTextInputField_Fragment | EgdsElementFragment_EgdsTextListSection_Fragment | EgdsElementFragment_EgdsTextSection_Fragment | EgdsElementFragment_EgdsTextStandardListItem_Fragment | EgdsElementFragment_EgdsTextWithMarkListItem_Fragment | EgdsElementFragment_EgdsToast_Fragment | EgdsElementFragment_EgdsTravelerChildAgeSelect_Fragment | EgdsElementFragment_EgdsTravelerInfantSeatSelection_Fragment | EgdsElementFragment_EgdsTravelerStepInput_Fragment | EgdsElementFragment_EgdsTypeaheadInputField_Fragment | EgdsElementFragment_EgdsUnorderedList_Fragment | EgdsElementFragment_FlightSearchForm_Fragment | EgdsElementFragment_FlightSearchInputForm_Fragment | EgdsElementFragment_FlightsActionButton_Fragment | EgdsElementFragment_FlightsActionCheckbox_Fragment | EgdsElementFragment_FlightsActionLink_Fragment | EgdsElementFragment_FlightsDialogTrigger_Fragment | EgdsElementFragment_IdentityBasicBlock_Fragment | EgdsElementFragment_IdentityButton_Fragment | EgdsElementFragment_IdentityConsentNestedCheckBox_Fragment | EgdsElementFragment_IdentityImage_Fragment | EgdsElementFragment_IdentityImageGallery_Fragment | EgdsElementFragment_IdentityInfoLinkComponent_Fragment | EgdsElementFragment_IdentityPasswordStrengthComponent_Fragment | EgdsElementFragment_IdentityResendButton_Fragment | EgdsElementFragment_IdentitySingleColumnComponentLayout_Fragment | EgdsElementFragment_IdentitySocialButton_Fragment | EgdsElementFragment_IdentityText_Fragment | EgdsElementFragment_Illustration_Fragment | EgdsElementFragment_LodgingSearchForm_Fragment | EgdsElementFragment_PackagesSearchForm_Fragment | EgdsElementFragment_ProductSummaryCard_Fragment | EgdsElementFragment_ProfileAccountLink_Fragment | EgdsElementFragment_ProfileActionButtonCard_Fragment | EgdsElementFragment_ProfileBulletedList_Fragment | EgdsElementFragment_ProfileEgdsSectionContainer_Fragment | EgdsElementFragment_ProfileFormHorizontalContainer_Fragment | EgdsElementFragment_ProfileFormSection_Fragment | EgdsElementFragment_ProfileLink_Fragment | EgdsElementFragment_ProfileNumberField_Fragment | EgdsElementFragment_ProfilePhoneNumberField_Fragment | EgdsElementFragment_ProfileRadioButton_Fragment | EgdsElementFragment_ProfileRadioButtonGroup_Fragment | EgdsElementFragment_ProfileSelectField_Fragment | EgdsElementFragment_ProfileSlimCard_Fragment | EgdsElementFragment_ProfileSwitchOption_Fragment | EgdsElementFragment_ProfileTextField_Fragment | EgdsElementFragment_SearchFormDurationSpanField_Fragment | EgdsElementFragment_TripsMediaGallery_Fragment | EgdsElementFragment_TripsValidatedInput_Fragment | EgdsElementFragment_UiBanner_Fragment | EgdsElementFragment_UiEmptyState_Fragment | EgdsElementFragment_UiMessagingCard_Fragment | EgdsElementFragment_UiPrimaryButton_Fragment | EgdsElementFragment_UiPrimaryFloatingActionButton_Fragment | EgdsElementFragment_UiSecondaryButton_Fragment | EgdsElementFragment_UiSecondaryFloatingActionButton_Fragment | EgdsElementFragment_UiTertiaryButton_Fragment;

type EgdsTextFragment_EgdsBasicLocalizedText_Fragment = { __typename: 'EGDSBasicLocalizedText' };

type EgdsTextFragment_EgdsCardinalLocalizedText_Fragment = { __typename: 'EGDSCardinalLocalizedText' };

type EgdsTextFragment_EgdsCompositeLocalizedText_Fragment = { __typename: 'EGDSCompositeLocalizedText' };

type EgdsTextFragment_EgdsGraphicText_Fragment = (
  { __typename: 'EGDSGraphicText' }
  & EgdsGraphicTextFragmentFragment
);

type EgdsTextFragment_EgdsHeading_Fragment = { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> };

type EgdsTextFragment_EgdsIconText_Fragment = { __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } };

type EgdsTextFragment_EgdsInlineLink_Fragment = { __typename: 'EGDSInlineLink' };

type EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment = { __typename: 'EGDSLocalizedTextTemplate' };

type EgdsTextFragment_EgdsParagraph_Fragment = { __typename: 'EGDSParagraph', text: string, style: EgdsParagraphStyle };

type EgdsTextFragment_EgdsPlainText_Fragment = { __typename: 'EGDSPlainText', text: string };

type EgdsTextFragment_EgdsSpannableText_Fragment = (
  { __typename: 'EGDSSpannableText' }
  & EgdsSpannableTextFragmentFragment
);

type EgdsTextFragment_EgdsStandardLink_Fragment = { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } };

type EgdsTextFragment_EgdsStylizedText_Fragment = { __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, stylizedSize?: Maybe<string> };

type EgdsTextFragment_EgdsTextIconLinkListItem_Fragment = { __typename: 'EGDSTextIconLinkListItem' };

type EgdsTextFragment_EgdsTextIconListItem_Fragment = { __typename: 'EGDSTextIconListItem' };

type EgdsTextFragment_EgdsTextStandardListItem_Fragment = { __typename: 'EGDSTextStandardListItem' };

type EgdsTextFragment_EgdsTextWithMarkListItem_Fragment = { __typename: 'EGDSTextWithMarkListItem' };

export type EgdsTextFragmentFragment = EgdsTextFragment_EgdsBasicLocalizedText_Fragment | EgdsTextFragment_EgdsCardinalLocalizedText_Fragment | EgdsTextFragment_EgdsCompositeLocalizedText_Fragment | EgdsTextFragment_EgdsGraphicText_Fragment | EgdsTextFragment_EgdsHeading_Fragment | EgdsTextFragment_EgdsIconText_Fragment | EgdsTextFragment_EgdsInlineLink_Fragment | EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment | EgdsTextFragment_EgdsParagraph_Fragment | EgdsTextFragment_EgdsPlainText_Fragment | EgdsTextFragment_EgdsSpannableText_Fragment | EgdsTextFragment_EgdsStandardLink_Fragment | EgdsTextFragment_EgdsStylizedText_Fragment | EgdsTextFragment_EgdsTextIconLinkListItem_Fragment | EgdsTextFragment_EgdsTextIconListItem_Fragment | EgdsTextFragment_EgdsTextStandardListItem_Fragment | EgdsTextFragment_EgdsTextWithMarkListItem_Fragment;

export type FaresDialogsFragmentFragment = { __typename: 'FlightsDialog', dialogId: FlightsDialogId, dynamicDialogId?: Maybe<string>, dialog: (
    { __typename: 'AdditionalInformationPopoverDialogSection' }
    & EgdsDialogFragment_AdditionalInformationPopoverDialogSection_Fragment
  ) | (
    { __typename: 'ClientSideErrorRepresentationDialog' }
    & EgdsDialogFragment_ClientSideErrorRepresentationDialog_Fragment
  ) | (
    { __typename: 'EGDSActionDialog' }
    & EgdsDialogFragment_EgdsActionDialog_Fragment
  ) | (
    { __typename: 'EGDSFullScreenDialog' }
    & EgdsDialogFragment_EgdsFullScreenDialog_Fragment
  ) | (
    { __typename: 'EGDSLoaderDialog' }
    & EgdsDialogFragment_EgdsLoaderDialog_Fragment
  ) | (
    { __typename: 'PriceInsightsExistingTrackingDialogAction' }
    & EgdsDialogFragment_PriceInsightsExistingTrackingDialogAction_Fragment
  ) | (
    { __typename: 'PriceInsightsTrackingRetryDialogAction' }
    & EgdsDialogFragment_PriceInsightsTrackingRetryDialogAction_Fragment
  ) | (
    { __typename: 'ServicingDialog' }
    & EgdsDialogFragment_ServicingDialog_Fragment
  ), dialogContent?: Maybe<Array<(
    { __typename: 'ActivitySearchForm' }
    & EgdsElementFragment_ActivitySearchForm_Fragment
  ) | (
    { __typename: 'AgencyUIPrimaryFloatingActionButton' }
    & EgdsElementFragment_AgencyUiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'AgencyUISecondaryFloatingActionButton' }
    & EgdsElementFragment_AgencyUiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'CarSearchForm' }
    & EgdsElementFragment_CarSearchForm_Fragment
  ) | (
    { __typename: 'CruiseSearchForm' }
    & EgdsElementFragment_CruiseSearchForm_Fragment
  ) | (
    { __typename: 'DurationSpanSelector' }
    & EgdsElementFragment_DurationSpanSelector_Fragment
  ) | (
    { __typename: 'EGDSBadgeNotification' }
    & EgdsElementFragment_EgdsBadgeNotification_Fragment
  ) | (
    { __typename: 'EGDSBasicCheckBox' }
    & EgdsElementFragment_EgdsBasicCheckBox_Fragment
  ) | (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsElementFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSBasicOption' }
    & EgdsElementFragment_EgdsBasicOption_Fragment
  ) | (
    { __typename: 'EGDSBasicSelect' }
    & EgdsElementFragment_EgdsBasicSelect_Fragment
  ) | (
    { __typename: 'EGDSBasicStepInput' }
    & EgdsElementFragment_EgdsBasicStepInput_Fragment
  ) | (
    { __typename: 'EGDSBasicTab' }
    & EgdsElementFragment_EgdsBasicTab_Fragment
  ) | (
    { __typename: 'EGDSBasicTabs' }
    & EgdsElementFragment_EgdsBasicTabs_Fragment
  ) | (
    { __typename: 'EGDSBasicTravelerSelector' }
    & EgdsElementFragment_EgdsBasicTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSBulletedList' }
    & EgdsElementFragment_EgdsBulletedList_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsElementFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSComposableTextElementSectionContainer' }
    & EgdsElementFragment_EgdsComposableTextElementSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsElementFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSEmailInputField' }
    & EgdsElementFragment_EgdsEmailInputField_Fragment
  ) | (
    { __typename: 'EGDSErrorSummary' }
    & EgdsElementFragment_EgdsErrorSummary_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsElementFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSImageLink' }
    & EgdsElementFragment_EgdsImageLink_Fragment
  ) | (
    { __typename: 'EGDSImageLinkCard' }
    & EgdsElementFragment_EgdsImageLinkCard_Fragment
  ) | (
    { __typename: 'EGDSInfantSeatRadioButton' }
    & EgdsElementFragment_EgdsInfantSeatRadioButton_Fragment
  ) | (
    { __typename: 'EGDSLinkList' }
    & EgdsElementFragment_EgdsLinkList_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsElementFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSLoyaltyBadge' }
    & EgdsElementFragment_EgdsLoyaltyBadge_Fragment
  ) | (
    { __typename: 'EGDSNumberInputField' }
    & EgdsElementFragment_EgdsNumberInputField_Fragment
  ) | (
    { __typename: 'EGDSOrderedList' }
    & EgdsElementFragment_EgdsOrderedList_Fragment
  ) | (
    { __typename: 'EGDSOverlayButton' }
    & EgdsElementFragment_EgdsOverlayButton_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsElementFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPasswordInputField' }
    & EgdsElementFragment_EgdsPasswordInputField_Fragment
  ) | (
    { __typename: 'EGDSProgramBadge' }
    & EgdsElementFragment_EgdsProgramBadge_Fragment
  ) | (
    { __typename: 'EGDSRoomsTravelerSelector' }
    & EgdsElementFragment_EgdsRoomsTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSSearchFormButton' }
    & EgdsElementFragment_EgdsSearchFormButton_Fragment
  ) | (
    { __typename: 'EGDSSearchFormDatePickerField' }
    & EgdsElementFragment_EgdsSearchFormDatePickerField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormInputField' }
    & EgdsElementFragment_EgdsSearchFormInputField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationField' }
    & EgdsElementFragment_EgdsSearchFormLocationField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationsField' }
    & EgdsElementFragment_EgdsSearchFormLocationsField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormTravelersField' }
    & EgdsElementFragment_EgdsSearchFormTravelersField_Fragment
  ) | (
    { __typename: 'EGDSSectionContainer' }
    & EgdsElementFragment_EgdsSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsElementFragment_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardBadge' }
    & EgdsElementFragment_EgdsStandardBadge_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsElementFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStandardMessagingCard' }
    & EgdsElementFragment_EgdsStandardMessagingCard_Fragment
  ) | (
    { __typename: 'EGDSTextAreaInputField' }
    & EgdsElementFragment_EgdsTextAreaInputField_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsElementFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconList' }
    & EgdsElementFragment_EgdsTextIconList_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsElementFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextInputField' }
    & EgdsElementFragment_EgdsTextInputField_Fragment
  ) | (
    { __typename: 'EGDSTextListSection' }
    & EgdsElementFragment_EgdsTextListSection_Fragment
  ) | (
    { __typename: 'EGDSTextSection' }
    & EgdsElementFragment_EgdsTextSection_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsElementFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsElementFragment_EgdsTextWithMarkListItem_Fragment
  ) | (
    { __typename: 'EGDSToast' }
    & EgdsElementFragment_EgdsToast_Fragment
  ) | (
    { __typename: 'EGDSTravelerChildAgeSelect' }
    & EgdsElementFragment_EgdsTravelerChildAgeSelect_Fragment
  ) | (
    { __typename: 'EGDSTravelerInfantSeatSelection' }
    & EgdsElementFragment_EgdsTravelerInfantSeatSelection_Fragment
  ) | (
    { __typename: 'EGDSTravelerStepInput' }
    & EgdsElementFragment_EgdsTravelerStepInput_Fragment
  ) | (
    { __typename: 'EGDSTypeaheadInputField' }
    & EgdsElementFragment_EgdsTypeaheadInputField_Fragment
  ) | (
    { __typename: 'EGDSUnorderedList' }
    & EgdsElementFragment_EgdsUnorderedList_Fragment
  ) | (
    { __typename: 'FlightSearchForm' }
    & EgdsElementFragment_FlightSearchForm_Fragment
  ) | (
    { __typename: 'FlightSearchInputForm' }
    & EgdsElementFragment_FlightSearchInputForm_Fragment
  ) | (
    { __typename: 'FlightsActionButton' }
    & EgdsElementFragment_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsActionCheckbox' }
    & EgdsElementFragment_FlightsActionCheckbox_Fragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & EgdsElementFragment_FlightsActionLink_Fragment
  ) | (
    { __typename: 'FlightsDialogTrigger' }
    & FlightsDialogTriggerFragmentFragment
    & EgdsElementFragment_FlightsDialogTrigger_Fragment
  ) | (
    { __typename: 'IdentityBasicBlock' }
    & EgdsElementFragment_IdentityBasicBlock_Fragment
  ) | (
    { __typename: 'IdentityButton' }
    & EgdsElementFragment_IdentityButton_Fragment
  ) | (
    { __typename: 'IdentityConsentNestedCheckBox' }
    & EgdsElementFragment_IdentityConsentNestedCheckBox_Fragment
  ) | (
    { __typename: 'IdentityImage' }
    & EgdsElementFragment_IdentityImage_Fragment
  ) | (
    { __typename: 'IdentityImageGallery' }
    & EgdsElementFragment_IdentityImageGallery_Fragment
  ) | (
    { __typename: 'IdentityInfoLinkComponent' }
    & EgdsElementFragment_IdentityInfoLinkComponent_Fragment
  ) | (
    { __typename: 'IdentityPasswordStrengthComponent' }
    & EgdsElementFragment_IdentityPasswordStrengthComponent_Fragment
  ) | (
    { __typename: 'IdentityResendButton' }
    & EgdsElementFragment_IdentityResendButton_Fragment
  ) | (
    { __typename: 'IdentitySingleColumnComponentLayout' }
    & EgdsElementFragment_IdentitySingleColumnComponentLayout_Fragment
  ) | (
    { __typename: 'IdentitySocialButton' }
    & EgdsElementFragment_IdentitySocialButton_Fragment
  ) | (
    { __typename: 'IdentityText' }
    & EgdsElementFragment_IdentityText_Fragment
  ) | (
    { __typename: 'Illustration' }
    & EgdsElementFragment_Illustration_Fragment
  ) | (
    { __typename: 'LodgingSearchForm' }
    & EgdsElementFragment_LodgingSearchForm_Fragment
  ) | (
    { __typename: 'PackagesSearchForm' }
    & EgdsElementFragment_PackagesSearchForm_Fragment
  ) | (
    { __typename: 'ProductSummaryCard' }
    & EgdsElementFragment_ProductSummaryCard_Fragment
  ) | (
    { __typename: 'ProfileAccountLink' }
    & EgdsElementFragment_ProfileAccountLink_Fragment
  ) | (
    { __typename: 'ProfileActionButtonCard' }
    & EgdsElementFragment_ProfileActionButtonCard_Fragment
  ) | (
    { __typename: 'ProfileBulletedList' }
    & EgdsElementFragment_ProfileBulletedList_Fragment
  ) | (
    { __typename: 'ProfileEGDSSectionContainer' }
    & EgdsElementFragment_ProfileEgdsSectionContainer_Fragment
  ) | (
    { __typename: 'ProfileFormHorizontalContainer' }
    & EgdsElementFragment_ProfileFormHorizontalContainer_Fragment
  ) | (
    { __typename: 'ProfileFormSection' }
    & EgdsElementFragment_ProfileFormSection_Fragment
  ) | (
    { __typename: 'ProfileLink' }
    & EgdsElementFragment_ProfileLink_Fragment
  ) | (
    { __typename: 'ProfileNumberField' }
    & EgdsElementFragment_ProfileNumberField_Fragment
  ) | (
    { __typename: 'ProfilePhoneNumberField' }
    & EgdsElementFragment_ProfilePhoneNumberField_Fragment
  ) | (
    { __typename: 'ProfileRadioButton' }
    & EgdsElementFragment_ProfileRadioButton_Fragment
  ) | (
    { __typename: 'ProfileRadioButtonGroup' }
    & EgdsElementFragment_ProfileRadioButtonGroup_Fragment
  ) | (
    { __typename: 'ProfileSelectField' }
    & EgdsElementFragment_ProfileSelectField_Fragment
  ) | (
    { __typename: 'ProfileSlimCard' }
    & EgdsElementFragment_ProfileSlimCard_Fragment
  ) | (
    { __typename: 'ProfileSwitchOption' }
    & EgdsElementFragment_ProfileSwitchOption_Fragment
  ) | (
    { __typename: 'ProfileTextField' }
    & EgdsElementFragment_ProfileTextField_Fragment
  ) | (
    { __typename: 'SearchFormDurationSpanField' }
    & EgdsElementFragment_SearchFormDurationSpanField_Fragment
  ) | (
    { __typename: 'TripsMediaGallery' }
    & EgdsElementFragment_TripsMediaGallery_Fragment
  ) | (
    { __typename: 'TripsValidatedInput' }
    & EgdsElementFragment_TripsValidatedInput_Fragment
  ) | (
    { __typename: 'UIBanner' }
    & EgdsElementFragment_UiBanner_Fragment
  ) | (
    { __typename: 'UIEmptyState' }
    & EgdsElementFragment_UiEmptyState_Fragment
  ) | (
    { __typename: 'UIMessagingCard' }
    & EgdsElementFragment_UiMessagingCard_Fragment
  ) | (
    { __typename: 'UIPrimaryButton' }
    & EgdsElementFragment_UiPrimaryButton_Fragment
  ) | (
    { __typename: 'UIPrimaryFloatingActionButton' }
    & EgdsElementFragment_UiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UISecondaryButton' }
    & EgdsElementFragment_UiSecondaryButton_Fragment
  ) | (
    { __typename: 'UISecondaryFloatingActionButton' }
    & EgdsElementFragment_UiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UITertiaryButton' }
    & EgdsElementFragment_UiTertiaryButton_Fragment
  )>> };

type EgdsDialogFragment_AdditionalInformationPopoverDialogSection_Fragment = { __typename: 'AdditionalInformationPopoverDialogSection', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type EgdsDialogFragment_ClientSideErrorRepresentationDialog_Fragment = { __typename: 'ClientSideErrorRepresentationDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type EgdsDialogFragment_EgdsActionDialog_Fragment = { __typename: 'EGDSActionDialog', footer: { __typename: 'EGDSInlineDialogFooter', buttons: Array<(
      { __typename: 'EGDSOverlayButton' }
      & EgdsButtonFragment_EgdsOverlayButton_Fragment
    ) | (
      { __typename: 'EGDSSearchFormButton' }
      & EgdsButtonFragment_EgdsSearchFormButton_Fragment
    ) | (
      { __typename: 'FlightsActionButton' }
      & EgdsButtonFragment_FlightsActionButton_Fragment
    ) | (
      { __typename: 'FlightsDialogTrigger' }
      & EgdsButtonFragment_FlightsDialogTrigger_Fragment
    ) | (
      { __typename: 'FlightsExperienceActionButton' }
      & EgdsButtonFragment_FlightsExperienceActionButton_Fragment
    ) | (
      { __typename: 'FlightsSmartShoppingActionButton' }
      & EgdsButtonFragment_FlightsSmartShoppingActionButton_Fragment
    ) | (
      { __typename: 'PackageUIActionDialogFooterButton' }
      & EgdsButtonFragment_PackageUiActionDialogFooterButton_Fragment
    ) | (
      { __typename: 'PackageUIHideSearchFormAction' }
      & EgdsButtonFragment_PackageUiHideSearchFormAction_Fragment
    ) | (
      { __typename: 'PackageUITravelGuideButton' }
      & EgdsButtonFragment_PackageUiTravelGuideButton_Fragment
    ) | (
      { __typename: 'ServicingButton' }
      & EgdsButtonFragment_ServicingButton_Fragment
    ) | (
      { __typename: 'SupplyCancelWaiverActionButton' }
      & EgdsButtonFragment_SupplyCancelWaiverActionButton_Fragment
    ) | (
      { __typename: 'SupplyContentLinkStyleButton' }
      & EgdsButtonFragment_SupplyContentLinkStyleButton_Fragment
    ) | (
      { __typename: 'UIPrimaryButton' }
      & EgdsButtonFragment_UiPrimaryButton_Fragment
    ) | (
      { __typename: 'UISecondaryButton' }
      & EgdsButtonFragment_UiSecondaryButton_Fragment
    ) | (
      { __typename: 'UITertiaryButton' }
      & EgdsButtonFragment_UiTertiaryButton_Fragment
    )> } | { __typename: 'EGDSStackedDialogFooter', buttons: Array<(
      { __typename: 'EGDSOverlayButton' }
      & EgdsButtonFragment_EgdsOverlayButton_Fragment
    ) | (
      { __typename: 'EGDSSearchFormButton' }
      & EgdsButtonFragment_EgdsSearchFormButton_Fragment
    ) | (
      { __typename: 'FlightsActionButton' }
      & EgdsButtonFragment_FlightsActionButton_Fragment
    ) | (
      { __typename: 'FlightsDialogTrigger' }
      & EgdsButtonFragment_FlightsDialogTrigger_Fragment
    ) | (
      { __typename: 'FlightsExperienceActionButton' }
      & EgdsButtonFragment_FlightsExperienceActionButton_Fragment
    ) | (
      { __typename: 'FlightsSmartShoppingActionButton' }
      & EgdsButtonFragment_FlightsSmartShoppingActionButton_Fragment
    ) | (
      { __typename: 'PackageUIActionDialogFooterButton' }
      & EgdsButtonFragment_PackageUiActionDialogFooterButton_Fragment
    ) | (
      { __typename: 'PackageUIHideSearchFormAction' }
      & EgdsButtonFragment_PackageUiHideSearchFormAction_Fragment
    ) | (
      { __typename: 'PackageUITravelGuideButton' }
      & EgdsButtonFragment_PackageUiTravelGuideButton_Fragment
    ) | (
      { __typename: 'ServicingButton' }
      & EgdsButtonFragment_ServicingButton_Fragment
    ) | (
      { __typename: 'SupplyCancelWaiverActionButton' }
      & EgdsButtonFragment_SupplyCancelWaiverActionButton_Fragment
    ) | (
      { __typename: 'SupplyContentLinkStyleButton' }
      & EgdsButtonFragment_SupplyContentLinkStyleButton_Fragment
    ) | (
      { __typename: 'UIPrimaryButton' }
      & EgdsButtonFragment_UiPrimaryButton_Fragment
    ) | (
      { __typename: 'UISecondaryButton' }
      & EgdsButtonFragment_UiSecondaryButton_Fragment
    ) | (
      { __typename: 'UITertiaryButton' }
      & EgdsButtonFragment_UiTertiaryButton_Fragment
    )> }, closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type EgdsDialogFragment_EgdsFullScreenDialog_Fragment = (
  { __typename: 'EGDSFullScreenDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> }
  & EgdsFullScreenDialogFragmentFragment
);

type EgdsDialogFragment_EgdsLoaderDialog_Fragment = { __typename: 'EGDSLoaderDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type EgdsDialogFragment_PriceInsightsExistingTrackingDialogAction_Fragment = { __typename: 'PriceInsightsExistingTrackingDialogAction', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type EgdsDialogFragment_PriceInsightsTrackingRetryDialogAction_Fragment = { __typename: 'PriceInsightsTrackingRetryDialogAction', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type EgdsDialogFragment_ServicingDialog_Fragment = { __typename: 'ServicingDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type EgdsDialogFragmentFragment = EgdsDialogFragment_AdditionalInformationPopoverDialogSection_Fragment | EgdsDialogFragment_ClientSideErrorRepresentationDialog_Fragment | EgdsDialogFragment_EgdsActionDialog_Fragment | EgdsDialogFragment_EgdsFullScreenDialog_Fragment | EgdsDialogFragment_EgdsLoaderDialog_Fragment | EgdsDialogFragment_PriceInsightsExistingTrackingDialogAction_Fragment | EgdsDialogFragment_PriceInsightsTrackingRetryDialogAction_Fragment | EgdsDialogFragment_ServicingDialog_Fragment;

export type FlightsActionCheckboxFragmentFragment = { __typename: 'FlightsActionCheckbox', label: (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsTextFragment_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsTextFragment_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsTextFragment_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSGraphicText' }
    & EgdsTextFragment_EgdsGraphicText_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsTextFragment_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSIconText' }
    & EgdsTextFragment_EgdsIconText_Fragment
  ) | (
    { __typename: 'EGDSInlineLink' }
    & EgdsTextFragment_EgdsInlineLink_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsTextFragment_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsTextFragment_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPlainText' }
    & EgdsTextFragment_EgdsPlainText_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsTextFragment_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsTextFragment_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStylizedText' }
    & EgdsTextFragment_EgdsStylizedText_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsTextFragment_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsTextFragment_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsTextFragment_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsTextFragment_EgdsTextWithMarkListItem_Fragment
  ), clientAction: { __typename: 'FlightsAncillaryContinueAction' } | { __typename: 'FlightsBookingAction' } | { __typename: 'FlightsBoundNavigation' } | (
    { __typename: 'FlightsClickAction' }
    & FlightsClickActionFragmentFragment
  ) | { __typename: 'FlightsCreditClearAction' } | { __typename: 'FlightsCreditSelectionAction' } | { __typename: 'FlightsCreditSelectorOpenAction' } | { __typename: 'FlightsDialogCloseAction' } | { __typename: 'FlightsDialogTriggerAction' } | { __typename: 'FlightsFareTypeSelectionAction' } | { __typename: 'FlightsLegDropdownItemSelection' } | { __typename: 'FlightsLoadAncillariesAction' } | { __typename: 'FlightsNavigateToDetails' } | { __typename: 'FlightsRedirectOrDialog' } | { __typename: 'FlightsRefreshAction' } | { __typename: 'FlightsRemovePriceMatchPromiseAction' } | { __typename: 'FlightsResourceLinkAction' } | { __typename: 'FlightsResourceRedirectAction' } | { __typename: 'FlightsSearchCriteriaChangeAction' } | { __typename: 'FlightsSelectionAction' } | { __typename: 'FlightsSwitchToggleAction' } | { __typename: 'InsuranceSwitchToggleAction' } | { __typename: 'MultiItemSelectPackage' } | { __typename: 'MultiItemSelectProducts' } };

export type FlightsActionLinkFragmentFragment = { __typename: 'FlightsActionLink', disabled: boolean, primary?: Maybe<string>, clientAction: (
    { __typename: 'FlightsAncillaryContinueAction' }
    & FlightsClientActionFragment_FlightsAncillaryContinueAction_Fragment
  ) | (
    { __typename: 'FlightsBookingAction' }
    & FlightsClientActionFragment_FlightsBookingAction_Fragment
  ) | (
    { __typename: 'FlightsBoundNavigation' }
    & FlightsClientActionFragment_FlightsBoundNavigation_Fragment
  ) | (
    { __typename: 'FlightsClickAction' }
    & FlightsClientActionFragment_FlightsClickAction_Fragment
  ) | (
    { __typename: 'FlightsCreditClearAction' }
    & FlightsClientActionFragment_FlightsCreditClearAction_Fragment
  ) | (
    { __typename: 'FlightsCreditSelectionAction' }
    & FlightsClientActionFragment_FlightsCreditSelectionAction_Fragment
  ) | (
    { __typename: 'FlightsCreditSelectorOpenAction' }
    & FlightsClientActionFragment_FlightsCreditSelectorOpenAction_Fragment
  ) | (
    { __typename: 'FlightsDialogCloseAction' }
    & FlightsClientActionFragment_FlightsDialogCloseAction_Fragment
  ) | (
    { __typename: 'FlightsDialogTriggerAction' }
    & FlightsClientActionFragment_FlightsDialogTriggerAction_Fragment
  ) | (
    { __typename: 'FlightsFareTypeSelectionAction' }
    & FlightsClientActionFragment_FlightsFareTypeSelectionAction_Fragment
  ) | (
    { __typename: 'FlightsLegDropdownItemSelection' }
    & FlightsClientActionFragment_FlightsLegDropdownItemSelection_Fragment
  ) | (
    { __typename: 'FlightsLoadAncillariesAction' }
    & FlightsClientActionFragment_FlightsLoadAncillariesAction_Fragment
  ) | (
    { __typename: 'FlightsNavigateToDetails' }
    & FlightsClientActionFragment_FlightsNavigateToDetails_Fragment
  ) | (
    { __typename: 'FlightsRedirectOrDialog' }
    & FlightsClientActionFragment_FlightsRedirectOrDialog_Fragment
  ) | (
    { __typename: 'FlightsRefreshAction' }
    & FlightsClientActionFragment_FlightsRefreshAction_Fragment
  ) | (
    { __typename: 'FlightsRemovePriceMatchPromiseAction' }
    & FlightsClientActionFragment_FlightsRemovePriceMatchPromiseAction_Fragment
  ) | (
    { __typename: 'FlightsResourceLinkAction' }
    & FlightsClientActionFragment_FlightsResourceLinkAction_Fragment
  ) | (
    { __typename: 'FlightsResourceRedirectAction' }
    & FlightsClientActionFragment_FlightsResourceRedirectAction_Fragment
  ) | (
    { __typename: 'FlightsSearchCriteriaChangeAction' }
    & FlightsClientActionFragment_FlightsSearchCriteriaChangeAction_Fragment
  ) | (
    { __typename: 'FlightsSelectionAction' }
    & FlightsClientActionFragment_FlightsSelectionAction_Fragment
  ) | (
    { __typename: 'FlightsSwitchToggleAction' }
    & FlightsClientActionFragment_FlightsSwitchToggleAction_Fragment
  ) | (
    { __typename: 'InsuranceSwitchToggleAction' }
    & FlightsClientActionFragment_InsuranceSwitchToggleAction_Fragment
  ) | (
    { __typename: 'MultiItemSelectPackage' }
    & FlightsClientActionFragment_MultiItemSelectPackage_Fragment
  ) | (
    { __typename: 'MultiItemSelectProducts' }
    & FlightsClientActionFragment_MultiItemSelectProducts_Fragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchFragment
  )>, analytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsAncillaryContinueAction_Fragment = { __typename: 'FlightsAncillaryContinueAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsBookingAction_Fragment = { __typename: 'FlightsBookingAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsBoundNavigation_Fragment = (
  { __typename: 'FlightsBoundNavigation', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> }
  & FlightsBoundNavigationFragment
);

type FlightsClientActionFragment_FlightsClickAction_Fragment = { __typename: 'FlightsClickAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsCreditClearAction_Fragment = { __typename: 'FlightsCreditClearAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsCreditSelectionAction_Fragment = { __typename: 'FlightsCreditSelectionAction', originalBookingId: string, accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsCreditSelectorOpenAction_Fragment = { __typename: 'FlightsCreditSelectorOpenAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsDialogCloseAction_Fragment = { __typename: 'FlightsDialogCloseAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsDialogTriggerAction_Fragment = { __typename: 'FlightsDialogTriggerAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsFareTypeSelectionAction_Fragment = { __typename: 'FlightsFareTypeSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsLegDropdownItemSelection_Fragment = { __typename: 'FlightsLegDropdownItemSelection', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsLoadAncillariesAction_Fragment = { __typename: 'FlightsLoadAncillariesAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsNavigateToDetails_Fragment = (
  { __typename: 'FlightsNavigateToDetails', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> }
  & FlightsNavigateToDetailsFragment
);

type FlightsClientActionFragment_FlightsRedirectOrDialog_Fragment = { __typename: 'FlightsRedirectOrDialog', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsRefreshAction_Fragment = { __typename: 'FlightsRefreshAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsRemovePriceMatchPromiseAction_Fragment = { __typename: 'FlightsRemovePriceMatchPromiseAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsResourceLinkAction_Fragment = (
  { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> }
  & FlightsResourceLinkActionFragment
);

type FlightsClientActionFragment_FlightsResourceRedirectAction_Fragment = { __typename: 'FlightsResourceRedirectAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsSearchCriteriaChangeAction_Fragment = { __typename: 'FlightsSearchCriteriaChangeAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_FlightsSelectionAction_Fragment = (
  { __typename: 'FlightsSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> }
  & FlightsSelectionActionFragment
);

type FlightsClientActionFragment_FlightsSwitchToggleAction_Fragment = { __typename: 'FlightsSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_InsuranceSwitchToggleAction_Fragment = { __typename: 'InsuranceSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

type FlightsClientActionFragment_MultiItemSelectPackage_Fragment = (
  { __typename: 'MultiItemSelectPackage', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> }
  & MultiItemSelectPackageFragment
);

type FlightsClientActionFragment_MultiItemSelectProducts_Fragment = (
  { __typename: 'MultiItemSelectProducts', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> }
  & MultiItemSelectProductsFragment
);

export type FlightsClientActionFragmentFragment = FlightsClientActionFragment_FlightsAncillaryContinueAction_Fragment | FlightsClientActionFragment_FlightsBookingAction_Fragment | FlightsClientActionFragment_FlightsBoundNavigation_Fragment | FlightsClientActionFragment_FlightsClickAction_Fragment | FlightsClientActionFragment_FlightsCreditClearAction_Fragment | FlightsClientActionFragment_FlightsCreditSelectionAction_Fragment | FlightsClientActionFragment_FlightsCreditSelectorOpenAction_Fragment | FlightsClientActionFragment_FlightsDialogCloseAction_Fragment | FlightsClientActionFragment_FlightsDialogTriggerAction_Fragment | FlightsClientActionFragment_FlightsFareTypeSelectionAction_Fragment | FlightsClientActionFragment_FlightsLegDropdownItemSelection_Fragment | FlightsClientActionFragment_FlightsLoadAncillariesAction_Fragment | FlightsClientActionFragment_FlightsNavigateToDetails_Fragment | FlightsClientActionFragment_FlightsRedirectOrDialog_Fragment | FlightsClientActionFragment_FlightsRefreshAction_Fragment | FlightsClientActionFragment_FlightsRemovePriceMatchPromiseAction_Fragment | FlightsClientActionFragment_FlightsResourceLinkAction_Fragment | FlightsClientActionFragment_FlightsResourceRedirectAction_Fragment | FlightsClientActionFragment_FlightsSearchCriteriaChangeAction_Fragment | FlightsClientActionFragment_FlightsSelectionAction_Fragment | FlightsClientActionFragment_FlightsSwitchToggleAction_Fragment | FlightsClientActionFragment_InsuranceSwitchToggleAction_Fragment | FlightsClientActionFragment_MultiItemSelectPackage_Fragment | FlightsClientActionFragment_MultiItemSelectProducts_Fragment;

export type FlightsClickActionFragmentFragment = { __typename: 'FlightsClickAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type FlightsMessagingCardFragmentFragment = { __typename: 'FlightsMessagingCard', cardContent: (
    { __typename: 'EGDSStandardMessagingCard' }
    & EgdsStandardMessagingCardFragmentFragment
  ), displayAnalytics?: Maybe<Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>> };

export type EgdsStandardMessagingCardFragmentFragment = { __typename: 'EGDSStandardMessagingCard', egdsElementId?: Maybe<string>, heading?: Maybe<string>, message: string, dismiss?: Maybe<(
    { __typename: 'EGDSDismissAction' }
    & EgdsDismissActionFragmentFragment
  )>, graphic?: Maybe<(
    { __typename: 'Icon' }
    & UiGraphicFragment_Icon_Fragment
  ) | (
    { __typename: 'Illustration' }
    & UiGraphicFragment_Illustration_Fragment
  ) | (
    { __typename: 'Mark' }
    & UiGraphicFragment_Mark_Fragment
  )>, links?: Maybe<Array<(
    { __typename: 'EGDSStandardLink' }
    & EgdsStandardLinkFragmentFragment
  )>>, rightIcon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchFragment
  )> };

export type EgdsDismissActionFragmentFragment = { __typename: 'EGDSDismissAction', accessibility?: Maybe<string>, label?: Maybe<string>, analytics: (
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  ) };

type UiGraphicFragment_Icon_Fragment = (
  { __typename: 'Icon' }
  & IconSearchFragment
);

type UiGraphicFragment_Illustration_Fragment = (
  { __typename: 'Illustration' }
  & EgdsGraphicIllustrationFragmentSearchFragment
);

type UiGraphicFragment_Mark_Fragment = (
  { __typename: 'Mark' }
  & MarkFragmentsFragment
);

export type UiGraphicFragmentFragment = UiGraphicFragment_Icon_Fragment | UiGraphicFragment_Illustration_Fragment | UiGraphicFragment_Mark_Fragment;

export type EgdsStandardLinkFragmentFragment = { __typename: 'EGDSStandardLink', disabled: boolean, iconPosition?: Maybe<EgdsIconPosition>, size: EgdsLinkSize, text: string, action: (
    { __typename: 'UILinkAction' }
    & UiLinkActionFragmentFragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchFragment
  )> };

export type UiLinkActionFragmentFragment = { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, useRelativePath: boolean, analytics: (
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  ), resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } };

export type FlightsListingMessagingCardFragment = { __typename: 'FlightsListingMessagingCard', messagingCard: (
    { __typename: 'FlightsMessagingCardPlacard' }
    & FlightsMessagingCardPlacardFragmentFragment
  ) };

export type FlightsOfferSponsoredUpsellFragment = { __typename: 'FlightsOfferSponsoredUpsell', badge: (
    { __typename: 'EGDSStandardBadge' }
    & EgdsBadgeFragment_EgdsStandardBadge_Fragment
  ), expando: (
    { __typename: 'EGDSExpandoCard' }
    & EgdsExpandoFragment_EgdsExpandoCard_Fragment
  ) | (
    { __typename: 'EGDSExpandoLink' }
    & EgdsExpandoFragment_EgdsExpandoLink_Fragment
  ) | (
    { __typename: 'EGDSExpandoListItem' }
    & EgdsExpandoFragment_EgdsExpandoListItem_Fragment
  ) | (
    { __typename: 'EGDSExpandoPeek' }
    & EgdsExpandoFragment_EgdsExpandoPeek_Fragment
  ) | (
    { __typename: 'SupplyCancellationPolicyDetailsExpandoLink' }
    & EgdsExpandoFragment_SupplyCancellationPolicyDetailsExpandoLink_Fragment
  ) | (
    { __typename: 'SupplyPaymentDetailsExpandoLink' }
    & EgdsExpandoFragment_SupplyPaymentDetailsExpandoLink_Fragment
  ), details: (
    { __typename: 'FlightsSponsoredFareInformation' }
    & FlightsSponsoredUpsellDetailsFragment
  ), action: (
    { __typename: 'FlightsDialogTrigger' }
    & FlightsDialogTriggerFragmentFragment
  ), onViewedAnalytics: (
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  ), sponsoredFareAnalyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )> };

export type FlightsSponsoredUpsellDetailsFragment = { __typename: 'FlightsSponsoredFareInformation', description?: Maybe<string>, mediaSection: { __typename: 'FareMediaSection', badge?: Maybe<(
      { __typename: 'EGDSStandardBadge' }
      & EgdsBadgeFragment_EgdsStandardBadge_Fragment
    )>, featureImage: { __typename: 'Image', url: any, description: string, thumbnailClickAnalytics?: Maybe<(
        { __typename: 'ClientSideAnalytics' }
        & ClientSideAnalyticsFragment
      )> } }, heading?: Maybe<{ __typename: 'EGDSHeading', accessibility?: Maybe<string>, text: string }>, bulletpoints?: Maybe<{ __typename: 'EGDSUnorderedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } | { __typename: 'EGDSTextWithMarkListItem', text: string } | { __typename: 'EarnMessageContainerListItem', text: string } | { __typename: 'FlightsTextContainerListItem', text: string } | { __typename: 'MishopUITextContainerListItem', text: string }> }>, priceLockup?: Maybe<(
    { __typename: 'EGDSPriceLockup' }
    & PriceLockupFragmentFragment
  )>, onViewedAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>, sponsoredFareAnalyticsList?: Maybe<Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>>, onClickAnalyticsList?: Maybe<Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  )>> };

export type EgdsGraphicTextFragmentFragment = { __typename: 'EGDSGraphicText', text: string, textGraphic: (
    { __typename: 'Icon' }
    & UiGraphicFragment_Icon_Fragment
  ) | (
    { __typename: 'Illustration' }
    & UiGraphicFragment_Illustration_Fragment
  ) | (
    { __typename: 'Mark' }
    & UiGraphicFragment_Mark_Fragment
  ) };

export type FlightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext?: Maybe<FlightsSearchContextInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  searchFilterValuesList?: Maybe<Array<FlightsSearchFilterValuesInput> | FlightsSearchFilterValuesInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  sortOption?: Maybe<FlightsSortOptionTypeInput>;
  travelerDetails?: Maybe<Array<FlightsTravelerDetailsInput> | FlightsTravelerDetailsInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
}>;


export type FlightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQuery = { __typename: 'Query', flightsSearch: { __typename: 'FlightsSearchResponse', listingResult?: Maybe<{ __typename: 'FlightsLoadedListingResult' } | { __typename: 'FlightsLoadingListingResult', listingsSkeletonCount: number } | { __typename: 'FlightsProgressBarDetails' }> } };

export type FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext?: Maybe<FlightsSearchContextInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  searchFilterValuesList?: Maybe<Array<FlightsSearchFilterValuesInput> | FlightsSearchFilterValuesInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  sortOption?: Maybe<FlightsSortOptionTypeInput>;
  travelerDetails?: Maybe<Array<FlightsTravelerDetailsInput> | FlightsTravelerDetailsInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
  flightsSearchComponentCriteria?: Maybe<FlightsSearchComponentCriteriaInput>;
}>;


export type FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery = { __typename: 'Query', flightsSearch: { __typename: 'FlightsSearchResponse', gaiaId?: Maybe<string>, journeysContinuationId?: Maybe<string>, clientMetadata?: Maybe<{ __typename: 'FlightsPWAMetadata', pageName: string, pageNameAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }>, pageTitle?: Maybe<{ __typename: 'FlightsPageTitle', date?: Maybe<{ __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> }>, disclaimerSubTitle?: Maybe<(
        { __typename: 'FlightsPhrase' }
        & FlightsPhraseLoadingFragment
      )>, title: { __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> } }>, listingResult?: Maybe<{ __typename: 'FlightsLoadedListingResult' } | { __typename: 'FlightsLoadingListingResult', listingsSkeletonCount: number, message: string, originDestination: string, progressBar: FlightsProgressBarDisplay, progressBarDetails?: Maybe<{ __typename: 'FlightsProgressBarDetails', accessibilityMessage?: Maybe<string>, listingsLatency: number, sortAndFilterLatency: number, accessibility: { __typename: 'FlightsSimpleLocalizationTemplate', initialValue?: Maybe<string>, template: string, tokens: Array<string> } }>, paginationConfig?: Maybe<Array<{ __typename: 'FlightsListingsPagination', faresSeparationType: FlightsFaresSeparationType, pagination: { __typename: 'Pagination', size?: Maybe<number>, startingIndex?: Maybe<number> } }>> } | { __typename: 'FlightsProgressBarDetails' }>, sortAndFilterResult?: Maybe<{ __typename: 'FlightsLoadedSortAndFilterResult' } | { __typename: 'FlightsLoadingSortAndFilterResult', filterPresentation: { __typename: 'FlightsFilterLoadingPresentation', title?: Maybe<string>, options: Array<{ __typename: 'FlightsFilterSkeletonOption', itemCount: number, label: string, priceFromLabel?: Maybe<string> }> }, revealAction: { __typename: 'FlightsSortAndFilterRevealAction', enabled: boolean, iconAndLabel: { __typename: 'FlightsIconAndLabel', label: string, icon: { __typename: 'Icon', id: string } } } }>, searchForm?: Maybe<{ __typename: 'FlightsLoadedSearchForm' } | { __typename: 'FlightsLoadingSearchForm', originAndDestinationLocations?: Maybe<string>, searchAction?: Maybe<string>, airportDropdownEnabled?: Maybe<boolean>, addJourneyAction?: Maybe<{ __typename: 'FlightsAction', displayAction: string, displayType: FlightsActionDisplayType }>, bookingChangeLink?: Maybe<(
        { __typename: 'FlightsResourceLinkAction' }
        & FlightsResourceLinkActionFragment
      )>, departureAndReturnDates?: Maybe<{ __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> }>, journeys: Array<{ __typename: 'FlightsSearchFormJourneyCriteria', departureDate: { __typename: 'FlightsSearchFormDateField', label: string, placeholder: string, date?: Maybe<{ __typename: 'Date', isoFormat: string }> }, label: { __typename: 'FlightsSimpleLocalizationTemplate', initialValue?: Maybe<string>, template: string, tokens: Array<string> }, destinationLocation: { __typename: 'FlightsSearchFormLocationField', label: string, placeholder: string, value?: Maybe<string>, airportCode?: Maybe<string>, icon: { __typename: 'Icon', id: string } }, originLocation: { __typename: 'FlightsSearchFormLocationField', label: string, placeholder: string, value?: Maybe<string>, airportCode?: Maybe<string>, icon: { __typename: 'Icon', id: string } }, returnDate?: Maybe<{ __typename: 'FlightsSearchFormDateField', label: string, placeholder: string, date?: Maybe<{ __typename: 'Date', isoFormat: string }> }>, removeJourneyAction?: Maybe<{ __typename: 'FlightsAction', displayAction: string }>, swapLocationsAction: { __typename: 'FlightsSwapLocationAction', icon: { __typename: 'FlightsResponsiveIcon', smallView: { __typename: 'Icon', id: string, size?: Maybe<IconSize> }, largeView: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } } } }>, searchOptions: Array<{ __typename: 'FlightsSearchFormAirlineOption', label: string, icon: { __typename: 'Icon', id: string }, selectedItem: { __typename: 'FlightsSearchFormAirlineOptionItem', airline: string, label: string } } | { __typename: 'FlightsSearchFormCabinClassOption', label: string, icon: { __typename: 'Icon', id: string }, selectedItem: { __typename: 'FlightsSearchFormCabinClassOptionItem', cabinClass: FlightsCabinClass, label: string } } | { __typename: 'FlightsSearchFormMoreFiltersOption', label: string, icon: { __typename: 'Icon', id: string } } | { __typename: 'FlightsSearchFormTravelersOption', label: string, icon: { __typename: 'Icon', id: string }, valueTemplate: { __typename: 'FlightsMultiPluralLocalizationTemplate', oneTemplate: string, manyTemplate: string, tokens: Array<string>, fewTemplate: string, otherTemplate: string, twoTemplate: string, zeroTemplate: string }, items: Array<{ __typename: 'FlightsSearchFormTravelerInfantOptionItem', label: string, travelerCount: number, type: FlightsTravelerType } | { __typename: 'FlightsSearchFormTravelersOptionItem', label: string, travelerCount: number, type: FlightsTravelerType }> } | { __typename: 'FlightsSearchFormTripTypeOption', icon: { __typename: 'Icon', id: string }, items: Array<{ __typename: 'FlightsSearchFormTripTypeOptionItem', label: string, selected: boolean, tripType: FlightsTripType }> }>, availableRoutes?: Maybe<{ __typename: 'AvailableRoutes', destinationsString?: Maybe<string>, originString?: Maybe<string>, originCountries: Array<{ __typename: 'OriginCountry', countryName?: Maybe<string>, origins: Array<{ __typename: 'OriginAirport', airportName?: Maybe<string>, airportCode: string, destinationCountries: Array<{ __typename: 'DestinationCountry', countryName?: Maybe<string>, destinations: Array<{ __typename: 'DestinationAirport', airportName?: Maybe<string>, airportCode: string }> }> }> }> }> }>, flexibleSearchResponse?: Maybe<{ __typename: 'FlightsFlexibleSearchResponse', title: string, subTitle: string, titleAccessibility: string, searchTriggerAction?: Maybe<string>, flexGridType: FlightsFlexibleGridType, loadingStateAccessibility: string }>, failedRequestMessaging?: Maybe<{ __typename: 'FlightsActionableErrorMessaging', message: string, icon: { __typename: 'Icon', id: string }, action: { __typename: 'FlightsAction', displayAction: string, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) }, errorRecoveryButtons?: Maybe<Array<{ __typename: 'FlightsAction', displayAction: string, analytics: (
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        ) }>> }>, stepIndicator?: Maybe<(
      { __typename: 'FlightsStepIndicator' }
      & FlightsStepIndicatorLoadingFragment
    )>, shoppingContext?: Maybe<{ __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> }> } };

export type FlightsStepIndicatorLoadingFragment = { __typename: 'FlightsStepIndicator', journeyContinuationId: string, errorAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsPhraseLoadingFragment = { __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, link: any, icon?: Maybe<string>, text: string, styles: Array<FlightsPhrasePartStyle>, analytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), displayAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> };

export type FlightSearchResultsOnClientLoadingQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext?: Maybe<FlightsSearchContextInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  searchFilterValuesList?: Maybe<Array<FlightsSearchFilterValuesInput> | FlightsSearchFilterValuesInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  sortOption?: Maybe<FlightsSortOptionTypeInput>;
  travelerDetails?: Maybe<Array<FlightsTravelerDetailsInput> | FlightsTravelerDetailsInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
}>;


export type FlightSearchResultsOnClientLoadingQuery = { __typename: 'Query', flightsSearch: { __typename: 'FlightsSearchResponse', stepIndicator?: Maybe<(
      { __typename: 'FlightsStepIndicator' }
      & FlightsStepIndicatorOnClientLoadingFragment
    )>, flexibleSearchResponse?: Maybe<{ __typename: 'FlightsFlexibleSearchResponse', title: string, subTitle: string, titleAccessibility: string, flexGridType: FlightsFlexibleGridType, loadingStateAccessibility: string }>, shoppingContext?: Maybe<{ __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> }> } };

export type FlightsStepIndicatorOnClientLoadingFragment = { __typename: 'FlightsStepIndicator', journeyContinuationId: string, errorAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQueryVariables = Exact<{
  context: ContextInput;
  flightsSearchContext?: Maybe<FlightsSearchContextInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput> | FlightsJourneyCriteriaInput;
  queryState?: Maybe<FlightsQueryState>;
  searchFilterValuesList?: Maybe<Array<FlightsSearchFilterValuesInput> | FlightsSearchFilterValuesInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  sortOption?: Maybe<FlightsSortOptionTypeInput>;
  travelerDetails?: Maybe<Array<FlightsTravelerDetailsInput> | FlightsTravelerDetailsInput>;
  searchPagination?: Maybe<PaginationInput>;
  faresSeparationType?: Maybe<FlightsFaresSeparationType>;
  shoppingContext?: Maybe<ShoppingContextInput>;
}>;


export type FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery = { __typename: 'Query', flightsSearch: { __typename: 'FlightsSearchResponse', availableFares?: Maybe<Array<{ __typename: 'FlightsJourneyAvailableFaresInformationElements', journeyContinuationId: string, flightsJourneyAvailableFaresInformation?: Maybe<(
        { __typename: 'FlightsJourneyAvailableFares' }
        & FlightsJourneyAvailableFaresUpsellFragment
      )> }>>, shoppingContext?: Maybe<{ __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> }> } };

export type FlightsToggleSearchUpsellFragment = { __typename: 'FlightsToggle', expanded: boolean, collapseActionable: (
    { __typename: 'TogglePhase' }
    & TogglePhaseSearchUpsellFragment
  ), expandActionable: (
    { __typename: 'TogglePhase' }
    & TogglePhaseSearchUpsellFragment
  ) };

export type IconSearchUpsellFragment = { __typename: 'Icon', description: string, id: string, size?: Maybe<IconSize>, theme?: Maybe<IconTheme>, withBackground?: Maybe<boolean> };

export type TogglePhaseSearchUpsellFragment = { __typename: 'TogglePhase', accessibilityMessage?: Maybe<string>, action: string, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchUpsellFragment
  )> };

export type FlightActionUpsellFragment = { __typename: 'FlightsAction', accessibilityMessage?: Maybe<string>, displayAction: string, displayType: FlightsActionDisplayType, type: FlightsActionType, analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ), analyticsList: Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, displayAnalytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>, journeySearchCriteria?: Maybe<{ __typename: 'FlightsJourneySearchCriteria', previousFlightSelections?: Maybe<Array<{ __typename: 'JourneyFlightSelection', journeyIndex: number, offerIdentifier: string }>> }>, relativeURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }>, relativePackageableURI?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }>, stepIndicator?: Maybe<(
    { __typename: 'FlightsStepIndicator' }
    & FlightsStepIndicatorUpsellFragment
  )>, searchPagination?: Maybe<(
    { __typename: 'Pagination' }
    & PaginationUpsellFragment
  )> };

export type FlightsStepIndicatorUpsellFragment = { __typename: 'FlightsStepIndicator', journeyContinuationId: string, errorAnalytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type CoordinateInformationSearchUpsellFragment = { __typename: 'CoordinateInformation', subtitle: string, icon: (
    { __typename: 'Icon' }
    & IconSearchUpsellFragment
  ), flightDetailsWarningInfo?: Maybe<{ __typename: 'FlightsIconAndLabel', label: string, theme: TextTheme, accessibility?: Maybe<string>, value?: Maybe<string>, icon: (
      { __typename: 'Icon' }
      & IconSearchUpsellFragment
    ), displayAnalytics?: Maybe<Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>> }>, titleAndAccessibilityMessage: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string } };

export type FlightsJourneyAvailableFaresUpsellFragment = { __typename: 'FlightsJourneyAvailableFares', openAccessibility: string, applySelection: (
    { __typename: 'FlightsAction' }
    & FlightActionUpsellFragment
  ), dismissDetailedJourneyInformation: (
    { __typename: 'FlightsActionableIcon' }
    & FlightsActionableIconUpsellFragment
  ), fareChoiceInformation?: Maybe<{ __typename: 'FlightsFareChoiceInformation', accessibleHeading: string, availableFaresCount: number, message: string, nextFareChoiceAccessibilityMessage: string, previousFareChoiceAccessibilityMessage: string, tripTypePerTraveler: string, defaultBaggageInformation: { __typename: 'FlightsBaggageInformation', defaultBagSelectionMessage?: Maybe<string>, dismissAction?: Maybe<string>, displayDetailsAction?: Maybe<string>, label: string, bagFeesMoreInfo: Array<{ __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, icon?: Maybe<string>, link: any, styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
            { __typename: 'FlightsAnalytics' }
            & FlightsAnalyticsFragment
          ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }>, details?: Maybe<Array<{ __typename: 'FlightBaggageInformationDetail', baggageDetail: string, topic: string }>> }, displayAnalytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), errorAnalytics?: Maybe<Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>>, scrollAnalytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), convertAnalytics?: Maybe<Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>>, fares?: Maybe<Array<{ __typename: 'FlightsJourneyFare', accessibilityMessage: string, safetyLocationAccessibilityMessage?: Maybe<string>, selectFareActionAltText?: Maybe<string>, multiItemPriceToken?: Maybe<string>, cabinClass: string, cabinClassAndBookingCodes?: Maybe<Array<string>>, identifier: string, name: string, selected: boolean, totalPrice: string, priceAccessibilityMessage: string, journeyFareTotalPrice?: Maybe<string>, upsellOfferToken: string, multiItemAction?: Maybe<{ __typename: 'MultiItemSelectPackageAction', packageOfferId: string } | { __typename: 'MultiItemSelectProductsAction', multiItemSessionId: string, multiItemPriceToken?: Maybe<string>, flightsOfferNaturalKeys: (
          { __typename: 'FlightsOfferNaturalKeys' }
          & FlightsOfferNaturalKeysFragment
        ) }>, flightsOfferNaturalKeys?: Maybe<(
        { __typename: 'FlightsOfferNaturalKeys' }
        & FlightsOfferNaturalKeysFragment
      )>, baggageFeesInformation: { __typename: 'FlightsBaggageInformation', defaultBagSelectionMessage?: Maybe<string>, displayDetailsAction?: Maybe<string>, dismissAction?: Maybe<string>, label: string, bagFeesMoreInfo: Array<{ __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, icon?: Maybe<string>, link: any, styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }>, details?: Maybe<Array<{ __typename: 'FlightBaggageInformationDetail', baggageDetail: string, topic: string }>> }, selectFareAction: (
        { __typename: 'FlightsAction' }
        & FlightActionUpsellFragment
      ), clickEventAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), collapsedRules: (
        { __typename: 'FlightsJourneyAmenities' }
        & FlightsJourneyAmenitiesUpsellFragment
      ), expandedRules: Array<(
        { __typename: 'FlightsJourneyAmenitiesWithLabel' }
        & FlightsJourneyAmenitiesWithLabelUpsellFragment
      )>, amenityHierarchyRules?: Maybe<Array<(
        { __typename: 'FlightsJourneyAmenitiesWithLabel' }
        & FlightsJourneyAmenitiesWithLabelUpsellFragment
      )>>, amenityRules: { __typename: 'FlightsJourneyAmenityRules', itemsDefaultDisplayCount: number, amenities: Array<{ __typename: 'FlightsIconAndLabel', accessibility?: Maybe<string>, label: string, theme: TextTheme, icon: (
            { __typename: 'Icon' }
            & IconSearchUpsellFragment
          ) }> }, changeCancellationMessages?: Maybe<{ __typename: 'FlightsTextSection', heading?: Maybe<string>, displayAnalyticsList?: Maybe<Array<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>>, messages: Array<(
          { __typename: 'FlightsPhrase' }
          & FlightsPhraseUpsellFragment
        )> }>, chooseFareAction: { __typename: 'FlightsAction', accessibilityMessage?: Maybe<string>, displayAction: string, type: FlightsActionType }, fareScrollAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), formattedPrice: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, formattedMainPrice: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, recommendation?: Maybe<(
        { __typename: 'FlightsBadge' }
        & FlightsBadgeUpsellFragment
      )>, showMoreAmenitiesToggle?: Maybe<(
        { __typename: 'FlightsToggle' }
        & FlightsToggleSearchUpsellFragment
      )>, badges?: Maybe<Array<{ __typename: 'EGDSBadgeNotification', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSLoyaltyBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSProgramBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSStandardBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> }>>, priceLockup: { __typename: 'EGDSPriceLockup', accessibilityPrice: string, lockupPrice?: Maybe<string>, strikeThroughPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>> } } | { __typename: 'FlightsPMPJourneyFare', isPmpSelected: boolean, accessibilityMessage: string, safetyLocationAccessibilityMessage?: Maybe<string>, selectFareActionAltText?: Maybe<string>, multiItemPriceToken?: Maybe<string>, cabinClass: string, cabinClassAndBookingCodes?: Maybe<Array<string>>, identifier: string, name: string, selected: boolean, totalPrice: string, priceAccessibilityMessage: string, journeyFareTotalPrice?: Maybe<string>, upsellOfferToken: string, priceLockupWithPMP: { __typename: 'EGDSPriceLockup', accessibilityPrice: string, lockupPrice?: Maybe<string>, strikeThroughPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>> }, selectFareActionWithPMP: (
        { __typename: 'FlightsAction' }
        & FlightActionUpsellFragment
      ), priceMatchPromiseSelectionCardSection?: Maybe<(
        { __typename: 'PriceMatchPromiseSelectionCardSection' }
        & PriceMatchPromiseSelectionFragmentFragment
      )>, priceMatchPromiseSelectedCardSection?: Maybe<(
        { __typename: 'PriceMatchPromiseSelectedCardSection' }
        & PriceMatchPromiseSelectedFragmentFragment
      )>, multiItemAction?: Maybe<{ __typename: 'MultiItemSelectPackageAction', packageOfferId: string } | { __typename: 'MultiItemSelectProductsAction', multiItemSessionId: string, multiItemPriceToken?: Maybe<string>, flightsOfferNaturalKeys: (
          { __typename: 'FlightsOfferNaturalKeys' }
          & FlightsOfferNaturalKeysFragment
        ) }>, flightsOfferNaturalKeys?: Maybe<(
        { __typename: 'FlightsOfferNaturalKeys' }
        & FlightsOfferNaturalKeysFragment
      )>, baggageFeesInformation: { __typename: 'FlightsBaggageInformation', defaultBagSelectionMessage?: Maybe<string>, displayDetailsAction?: Maybe<string>, dismissAction?: Maybe<string>, label: string, bagFeesMoreInfo: Array<{ __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, icon?: Maybe<string>, link: any, styles: Array<FlightsPhrasePartStyle>, text: string, analytics: (
              { __typename: 'FlightsAnalytics' }
              & FlightsAnalyticsFragment
            ) } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }>, details?: Maybe<Array<{ __typename: 'FlightBaggageInformationDetail', baggageDetail: string, topic: string }>> }, selectFareAction: (
        { __typename: 'FlightsAction' }
        & FlightActionUpsellFragment
      ), clickEventAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), collapsedRules: (
        { __typename: 'FlightsJourneyAmenities' }
        & FlightsJourneyAmenitiesUpsellFragment
      ), expandedRules: Array<(
        { __typename: 'FlightsJourneyAmenitiesWithLabel' }
        & FlightsJourneyAmenitiesWithLabelUpsellFragment
      )>, amenityHierarchyRules?: Maybe<Array<(
        { __typename: 'FlightsJourneyAmenitiesWithLabel' }
        & FlightsJourneyAmenitiesWithLabelUpsellFragment
      )>>, amenityRules: { __typename: 'FlightsJourneyAmenityRules', itemsDefaultDisplayCount: number, amenities: Array<{ __typename: 'FlightsIconAndLabel', accessibility?: Maybe<string>, label: string, theme: TextTheme, icon: (
            { __typename: 'Icon' }
            & IconSearchUpsellFragment
          ) }> }, changeCancellationMessages?: Maybe<{ __typename: 'FlightsTextSection', heading?: Maybe<string>, displayAnalyticsList?: Maybe<Array<(
          { __typename: 'FlightsAnalytics' }
          & FlightsAnalyticsFragment
        )>>, messages: Array<(
          { __typename: 'FlightsPhrase' }
          & FlightsPhraseUpsellFragment
        )> }>, chooseFareAction: { __typename: 'FlightsAction', accessibilityMessage?: Maybe<string>, displayAction: string, type: FlightsActionType }, fareScrollAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), formattedPrice: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, formattedMainPrice: { __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }, recommendation?: Maybe<(
        { __typename: 'FlightsBadge' }
        & FlightsBadgeUpsellFragment
      )>, showMoreAmenitiesToggle?: Maybe<(
        { __typename: 'FlightsToggle' }
        & FlightsToggleSearchUpsellFragment
      )>, badges?: Maybe<Array<{ __typename: 'EGDSBadgeNotification', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSLoyaltyBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSProgramBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> } | { __typename: 'EGDSStandardBadge', accessibility?: Maybe<string>, text?: Maybe<string>, theme?: Maybe<string> }>>, priceLockup: { __typename: 'EGDSPriceLockup', accessibilityPrice: string, lockupPrice?: Maybe<string>, strikeThroughPrice?: Maybe<string>, priceSubtextFirst?: Maybe<Array<string>> } }>>, heading: (
      { __typename: 'FlightsResponsiveMessage' }
      & FlightsResponsiveMessageUpsellFragment
    ), faresTypesLoadingAnalytics: { __typename: 'FaresTypesLoadingAnalytics', faresLoadErrorAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), faresLoadingDisplayedAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), faresLoadingTimeAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ), continueButtonOnClickAnalytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }, percentageDelaysAndCancellationLink?: Maybe<{ __typename: 'FlightsLinkAction', displayAction: string, url: any, accessibility?: Maybe<string>, analytics: (
        { __typename: 'FlightsAnalytics' }
        & FlightsAnalyticsFragment
      ) }>, sustainabilityInformation?: Maybe<(
      { __typename: 'FlightsIconPhrases' }
      & FlightsIconUpsellPhrasesFragment
    )>, dialogs?: Maybe<Array<(
      { __typename: 'FlightsDialog' }
      & FaresDialogsFragment
    )>> }>, flightsJourneyHeaders: { __typename: 'FlightsJourneyHeaders', flightsJourneySubheading: string, heading: string, flightsJourneySubheadingMark?: Maybe<{ __typename: 'Mark', description: string, id: string, size?: Maybe<string>, token: string, url?: Maybe<{ __typename: 'HttpURI', relativePath: string, value: string }> }> }, flightsJourneyInformation?: Maybe<(
    { __typename: 'FlightsDetailedJourneyInformation' }
    & FlightsJourneyInformationUpsellFragment
  )>, flightsJourneyPolicies?: Maybe<{ __typename: 'FlightsTextSection', messages: Array<{ __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> }> }>, flightsJourneySummary: { __typename: 'FlightsBargainJourneySummary', arrivalDayInformation: string, tripTypePerTraveler?: Maybe<string>, totalPrice?: Maybe<string>, formattedPrice?: Maybe<{ __typename: 'FlightsPhrase', completeText: string, items: Array<{ __typename: 'FlightsPhraseDialogNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseLinkNode', styles: Array<FlightsPhrasePartStyle>, text: string } | { __typename: 'FlightsPhraseTextNode', styles: Array<FlightsPhrasePartStyle>, text: string }> }>, heading: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }, differentDayArrival?: Maybe<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }>, basicFlightDetails: Array<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }> } | { __typename: 'LoadedFlightsStandardJourneySummary', heading: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }, differentDayArrival?: Maybe<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }>, basicFlightDetails: Array<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }> } | { __typename: 'LoadingFlightsStandardJourneySummary', heading: { __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }, differentDayArrival?: Maybe<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }>, basicFlightDetails: Array<{ __typename: 'FlightsMessageAndAccessibility', accessibilityMessage: string, text: string }> } };

export type FlightsJourneyAmenitiesUpsellFragment = { __typename: 'FlightsJourneyAmenities', accessibilityMessage: string, amenities: Array<{ __typename: 'FlightsIconAndLabel', label: string, subLabel?: Maybe<string>, theme: TextTheme, accessibility?: Maybe<string>, value?: Maybe<string>, icon: (
      { __typename: 'Icon' }
      & IconSearchUpsellFragment
    ), displayAnalytics?: Maybe<Array<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>> }>, analytics?: Maybe<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )> };

export type FlightsJourneyAmenitiesWithLabelUpsellFragment = { __typename: 'FlightsJourneyAmenitiesWithLabel', label: string, rules: (
    { __typename: 'FlightsJourneyAmenities' }
    & FlightsJourneyAmenitiesUpsellFragment
  ) };

export type PaginationUpsellFragment = { __typename: 'Pagination', size?: Maybe<number>, startingIndex?: Maybe<number> };

export type FlightsJourneyInformationUpsellFragment = { __typename: 'FlightsDetailedJourneyInformation', details: (
    { __typename: 'FlightsToggle' }
    & FlightsToggleSearchUpsellFragment
  ), flightJourneyDetails: { __typename: 'FlightsJourneyDetails', journeySections: Array<{ __typename: 'JourneySection', journeyConnectionInformation: Array<{ __typename: 'AdditionalInformation', durationAndStop: string, nextFlightOriginAirportInfo?: Maybe<{ __typename: 'FlightsIconAndLabel', label: string, theme: TextTheme, accessibility?: Maybe<string>, icon: (
            { __typename: 'Icon' }
            & IconSearchUpsellFragment
          ) }> } | { __typename: 'FlightsConnectionInformation', flightsConnection: { __typename: 'FlightsConnection', aircraftModel?: Maybe<string>, airlineInfo: string, cabinClassAndBookingCode: string, duration: string, operatedBy?: Maybe<string>, connectionArrival: (
            { __typename: 'CoordinateInformation' }
            & CoordinateInformationSearchUpsellFragment
          ), connectionDeparture: (
            { __typename: 'CoordinateInformation' }
            & CoordinateInformationSearchUpsellFragment
          ), journeyAmenities?: Maybe<(
            { __typename: 'FlightsJourneyAmenities' }
            & FlightsJourneyAmenitiesUpsellFragment
          )> } }> }> } };

export type FlightsBadgeUpsellFragment = { __typename: 'FlightsBadge', accessibilityMessage?: Maybe<string>, text?: Maybe<string>, type: FlightsBadgeTheme, icon?: Maybe<{ __typename: 'Icon', id: string, description: string }> };

export type FlightsActionableIconUpsellFragment = { __typename: 'FlightsActionableIcon', icon: (
    { __typename: 'Icon' }
    & IconSearchUpsellFragment
  ), analytics: (
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  ) };

export type FlightsResponsiveMessageUpsellFragment = { __typename: 'FlightsResponsiveMessage', longMessage: string, shortMessage?: Maybe<string> };

export type DateFragmentUpsellFragment = { __typename: 'Date', month: number, day: number, year: number };

export type FlightsIconUpsellPhrasesFragment = { __typename: 'FlightsIconPhrases', text: Array<(
    { __typename: 'FlightsPhrase' }
    & FlightsPhraseUpsellFragment
  )>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchUpsellFragment
  )> };

export type FlightsOfferNaturalKeysFragment = { __typename: 'FlightsOfferNaturalKeys', flightNaturalKey: { __typename: 'FlightNaturalKey', offerToken: string, productTokens: Array<string>, travelers: Array<{ __typename: 'TravelerDetails', age?: Maybe<number>, type: TravelerDetailsType }> }, packagedProductsNaturalKeys?: Maybe<Array<{ __typename: 'ActivityNaturalKey' } | { __typename: 'CarNaturalKey', offerToken: string } | { __typename: 'FlightNaturalKey' } | { __typename: 'GroundTransfersNaturalKey' } | { __typename: 'PackageNaturalKey' } | { __typename: 'PropertyNaturalKey', id: string, ratePlanId: string, roomTypeId: string, inventoryType: InventoryType, checkOut: (
      { __typename: 'Date' }
      & DateFragmentUpsellFragment
    ), checkIn: (
      { __typename: 'Date' }
      & DateFragmentUpsellFragment
    ), rooms: Array<{ __typename: 'PropertyRoom', childAges: Array<number>, numberOfAdults: number }> }>> };

export type FlightsPhraseUpsellFragment = { __typename: 'FlightsPhrase', completeText: string, delimeter?: Maybe<string>, items: Array<{ __typename: 'FlightsPhraseDialogNode', text: string, styles: Array<FlightsPhrasePartStyle> } | { __typename: 'FlightsPhraseLinkNode', accessibility?: Maybe<string>, link: any, icon?: Maybe<string>, text: string, styles: Array<FlightsPhrasePartStyle>, analytics: (
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    ), displayAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )>, scrollAnalytics?: Maybe<(
      { __typename: 'FlightsAnalytics' }
      & FlightsAnalyticsFragment
    )> } | { __typename: 'FlightsPhraseTextNode', text: string, styles: Array<FlightsPhrasePartStyle> }> };

type EgdsButton_EgdsOverlayButton_Fragment = { __typename: 'EGDSOverlayButton' };

type EgdsButton_EgdsSearchFormButton_Fragment = { __typename: 'EGDSSearchFormButton' };

type EgdsButton_FlightsActionButton_Fragment = (
  { __typename: 'FlightsActionButton' }
  & FlightsActionButtonUpsellFragment
);

type EgdsButton_FlightsDialogTrigger_Fragment = (
  { __typename: 'FlightsDialogTrigger' }
  & FlightsDialogTriggerFragment
);

type EgdsButton_FlightsExperienceActionButton_Fragment = { __typename: 'FlightsExperienceActionButton' };

type EgdsButton_FlightsSmartShoppingActionButton_Fragment = { __typename: 'FlightsSmartShoppingActionButton' };

type EgdsButton_PackageUiActionDialogFooterButton_Fragment = { __typename: 'PackageUIActionDialogFooterButton' };

type EgdsButton_PackageUiHideSearchFormAction_Fragment = { __typename: 'PackageUIHideSearchFormAction' };

type EgdsButton_PackageUiTravelGuideButton_Fragment = { __typename: 'PackageUITravelGuideButton' };

type EgdsButton_ServicingButton_Fragment = { __typename: 'ServicingButton' };

type EgdsButton_SupplyCancelWaiverActionButton_Fragment = { __typename: 'SupplyCancelWaiverActionButton' };

type EgdsButton_SupplyContentLinkStyleButton_Fragment = { __typename: 'SupplyContentLinkStyleButton' };

type EgdsButton_UiPrimaryButton_Fragment = { __typename: 'UIPrimaryButton' };

type EgdsButton_UiSecondaryButton_Fragment = { __typename: 'UISecondaryButton' };

type EgdsButton_UiTertiaryButton_Fragment = { __typename: 'UITertiaryButton' };

export type EgdsButtonFragment = EgdsButton_EgdsOverlayButton_Fragment | EgdsButton_EgdsSearchFormButton_Fragment | EgdsButton_FlightsActionButton_Fragment | EgdsButton_FlightsDialogTrigger_Fragment | EgdsButton_FlightsExperienceActionButton_Fragment | EgdsButton_FlightsSmartShoppingActionButton_Fragment | EgdsButton_PackageUiActionDialogFooterButton_Fragment | EgdsButton_PackageUiHideSearchFormAction_Fragment | EgdsButton_PackageUiTravelGuideButton_Fragment | EgdsButton_ServicingButton_Fragment | EgdsButton_SupplyCancelWaiverActionButton_Fragment | EgdsButton_SupplyContentLinkStyleButton_Fragment | EgdsButton_UiPrimaryButton_Fragment | EgdsButton_UiSecondaryButton_Fragment | EgdsButton_UiTertiaryButton_Fragment;

export type FlightsDialogTriggerFragment = { __typename: 'FlightsDialogTrigger', dialogAction: FlightsDialogAction, dialogId: FlightsDialogId, trigger: (
    { __typename: 'FlightsActionButton' }
    & FlightsActionButtonUpsellFragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & FlightsActionLinkFragment
  ) | { __typename: 'FlightsExperienceActionButton' } | { __typename: 'FlightsExperienceActionLink' } };

export type FaresDialogsFragment = { __typename: 'FlightsDialog', dialogId: FlightsDialogId, dialog: (
    { __typename: 'AdditionalInformationPopoverDialogSection' }
    & EgdsDialog_AdditionalInformationPopoverDialogSection_Fragment
  ) | (
    { __typename: 'ClientSideErrorRepresentationDialog' }
    & EgdsDialog_ClientSideErrorRepresentationDialog_Fragment
  ) | (
    { __typename: 'EGDSActionDialog' }
    & EgdsDialog_EgdsActionDialog_Fragment
  ) | (
    { __typename: 'EGDSFullScreenDialog' }
    & EgdsDialog_EgdsFullScreenDialog_Fragment
  ) | (
    { __typename: 'EGDSLoaderDialog' }
    & EgdsDialog_EgdsLoaderDialog_Fragment
  ) | (
    { __typename: 'PriceInsightsExistingTrackingDialogAction' }
    & EgdsDialog_PriceInsightsExistingTrackingDialogAction_Fragment
  ) | (
    { __typename: 'PriceInsightsTrackingRetryDialogAction' }
    & EgdsDialog_PriceInsightsTrackingRetryDialogAction_Fragment
  ) | (
    { __typename: 'ServicingDialog' }
    & EgdsDialog_ServicingDialog_Fragment
  ), dialogContent?: Maybe<Array<(
    { __typename: 'ActivitySearchForm' }
    & EgdsElementFragmentUpsell_ActivitySearchForm_Fragment
  ) | (
    { __typename: 'AgencyUIPrimaryFloatingActionButton' }
    & EgdsElementFragmentUpsell_AgencyUiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'AgencyUISecondaryFloatingActionButton' }
    & EgdsElementFragmentUpsell_AgencyUiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'CarSearchForm' }
    & EgdsElementFragmentUpsell_CarSearchForm_Fragment
  ) | (
    { __typename: 'CruiseSearchForm' }
    & EgdsElementFragmentUpsell_CruiseSearchForm_Fragment
  ) | (
    { __typename: 'DurationSpanSelector' }
    & EgdsElementFragmentUpsell_DurationSpanSelector_Fragment
  ) | (
    { __typename: 'EGDSBadgeNotification' }
    & EgdsElementFragmentUpsell_EgdsBadgeNotification_Fragment
  ) | (
    { __typename: 'EGDSBasicCheckBox' }
    & EgdsElementFragmentUpsell_EgdsBasicCheckBox_Fragment
  ) | (
    { __typename: 'EGDSBasicLocalizedText' }
    & EgdsElementFragmentUpsell_EgdsBasicLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSBasicOption' }
    & EgdsElementFragmentUpsell_EgdsBasicOption_Fragment
  ) | (
    { __typename: 'EGDSBasicSelect' }
    & EgdsElementFragmentUpsell_EgdsBasicSelect_Fragment
  ) | (
    { __typename: 'EGDSBasicStepInput' }
    & EgdsElementFragmentUpsell_EgdsBasicStepInput_Fragment
  ) | (
    { __typename: 'EGDSBasicTab' }
    & EgdsElementFragmentUpsell_EgdsBasicTab_Fragment
  ) | (
    { __typename: 'EGDSBasicTabs' }
    & EgdsElementFragmentUpsell_EgdsBasicTabs_Fragment
  ) | (
    { __typename: 'EGDSBasicTravelerSelector' }
    & EgdsElementFragmentUpsell_EgdsBasicTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSBulletedList' }
    & EgdsElementFragmentUpsell_EgdsBulletedList_Fragment
  ) | (
    { __typename: 'EGDSCardinalLocalizedText' }
    & EgdsElementFragmentUpsell_EgdsCardinalLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSComposableTextElementSectionContainer' }
    & EgdsElementFragmentUpsell_EgdsComposableTextElementSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSCompositeLocalizedText' }
    & EgdsElementFragmentUpsell_EgdsCompositeLocalizedText_Fragment
  ) | (
    { __typename: 'EGDSEmailInputField' }
    & EgdsElementFragmentUpsell_EgdsEmailInputField_Fragment
  ) | (
    { __typename: 'EGDSErrorSummary' }
    & EgdsElementFragmentUpsell_EgdsErrorSummary_Fragment
  ) | (
    { __typename: 'EGDSHeading' }
    & EgdsElementFragmentUpsell_EgdsHeading_Fragment
  ) | (
    { __typename: 'EGDSImageLink' }
    & EgdsElementFragmentUpsell_EgdsImageLink_Fragment
  ) | (
    { __typename: 'EGDSImageLinkCard' }
    & EgdsElementFragmentUpsell_EgdsImageLinkCard_Fragment
  ) | (
    { __typename: 'EGDSInfantSeatRadioButton' }
    & EgdsElementFragmentUpsell_EgdsInfantSeatRadioButton_Fragment
  ) | (
    { __typename: 'EGDSLinkList' }
    & EgdsElementFragmentUpsell_EgdsLinkList_Fragment
  ) | (
    { __typename: 'EGDSLocalizedTextTemplate' }
    & EgdsElementFragmentUpsell_EgdsLocalizedTextTemplate_Fragment
  ) | (
    { __typename: 'EGDSLoyaltyBadge' }
    & EgdsElementFragmentUpsell_EgdsLoyaltyBadge_Fragment
  ) | (
    { __typename: 'EGDSNumberInputField' }
    & EgdsElementFragmentUpsell_EgdsNumberInputField_Fragment
  ) | (
    { __typename: 'EGDSOrderedList' }
    & EgdsElementFragmentUpsell_EgdsOrderedList_Fragment
  ) | (
    { __typename: 'EGDSOverlayButton' }
    & EgdsElementFragmentUpsell_EgdsOverlayButton_Fragment
  ) | (
    { __typename: 'EGDSParagraph' }
    & EgdsElementFragmentUpsell_EgdsParagraph_Fragment
  ) | (
    { __typename: 'EGDSPasswordInputField' }
    & EgdsElementFragmentUpsell_EgdsPasswordInputField_Fragment
  ) | (
    { __typename: 'EGDSProgramBadge' }
    & EgdsElementFragmentUpsell_EgdsProgramBadge_Fragment
  ) | (
    { __typename: 'EGDSRoomsTravelerSelector' }
    & EgdsElementFragmentUpsell_EgdsRoomsTravelerSelector_Fragment
  ) | (
    { __typename: 'EGDSSearchFormButton' }
    & EgdsElementFragmentUpsell_EgdsSearchFormButton_Fragment
  ) | (
    { __typename: 'EGDSSearchFormDatePickerField' }
    & EgdsElementFragmentUpsell_EgdsSearchFormDatePickerField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormInputField' }
    & EgdsElementFragmentUpsell_EgdsSearchFormInputField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationField' }
    & EgdsElementFragmentUpsell_EgdsSearchFormLocationField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormLocationsField' }
    & EgdsElementFragmentUpsell_EgdsSearchFormLocationsField_Fragment
  ) | (
    { __typename: 'EGDSSearchFormTravelersField' }
    & EgdsElementFragmentUpsell_EgdsSearchFormTravelersField_Fragment
  ) | (
    { __typename: 'EGDSSectionContainer' }
    & EgdsElementFragmentUpsell_EgdsSectionContainer_Fragment
  ) | (
    { __typename: 'EGDSSpannableText' }
    & EgdsElementFragmentUpsell_EgdsSpannableText_Fragment
  ) | (
    { __typename: 'EGDSStandardBadge' }
    & EgdsElementFragmentUpsell_EgdsStandardBadge_Fragment
  ) | (
    { __typename: 'EGDSStandardLink' }
    & EgdsElementFragmentUpsell_EgdsStandardLink_Fragment
  ) | (
    { __typename: 'EGDSStandardMessagingCard' }
    & EgdsElementFragmentUpsell_EgdsStandardMessagingCard_Fragment
  ) | (
    { __typename: 'EGDSTextAreaInputField' }
    & EgdsElementFragmentUpsell_EgdsTextAreaInputField_Fragment
  ) | (
    { __typename: 'EGDSTextIconLinkListItem' }
    & EgdsElementFragmentUpsell_EgdsTextIconLinkListItem_Fragment
  ) | (
    { __typename: 'EGDSTextIconList' }
    & EgdsElementFragmentUpsell_EgdsTextIconList_Fragment
  ) | (
    { __typename: 'EGDSTextIconListItem' }
    & EgdsElementFragmentUpsell_EgdsTextIconListItem_Fragment
  ) | (
    { __typename: 'EGDSTextInputField' }
    & EgdsElementFragmentUpsell_EgdsTextInputField_Fragment
  ) | (
    { __typename: 'EGDSTextListSection' }
    & EgdsElementFragmentUpsell_EgdsTextListSection_Fragment
  ) | (
    { __typename: 'EGDSTextSection' }
    & EgdsElementFragmentUpsell_EgdsTextSection_Fragment
  ) | (
    { __typename: 'EGDSTextStandardListItem' }
    & EgdsElementFragmentUpsell_EgdsTextStandardListItem_Fragment
  ) | (
    { __typename: 'EGDSTextWithMarkListItem' }
    & EgdsElementFragmentUpsell_EgdsTextWithMarkListItem_Fragment
  ) | (
    { __typename: 'EGDSToast' }
    & EgdsElementFragmentUpsell_EgdsToast_Fragment
  ) | (
    { __typename: 'EGDSTravelerChildAgeSelect' }
    & EgdsElementFragmentUpsell_EgdsTravelerChildAgeSelect_Fragment
  ) | (
    { __typename: 'EGDSTravelerInfantSeatSelection' }
    & EgdsElementFragmentUpsell_EgdsTravelerInfantSeatSelection_Fragment
  ) | (
    { __typename: 'EGDSTravelerStepInput' }
    & EgdsElementFragmentUpsell_EgdsTravelerStepInput_Fragment
  ) | (
    { __typename: 'EGDSTypeaheadInputField' }
    & EgdsElementFragmentUpsell_EgdsTypeaheadInputField_Fragment
  ) | (
    { __typename: 'EGDSUnorderedList' }
    & EgdsElementFragmentUpsell_EgdsUnorderedList_Fragment
  ) | (
    { __typename: 'FlightSearchForm' }
    & EgdsElementFragmentUpsell_FlightSearchForm_Fragment
  ) | (
    { __typename: 'FlightSearchInputForm' }
    & EgdsElementFragmentUpsell_FlightSearchInputForm_Fragment
  ) | (
    { __typename: 'FlightsActionButton' }
    & EgdsElementFragmentUpsell_FlightsActionButton_Fragment
  ) | (
    { __typename: 'FlightsActionCheckbox' }
    & EgdsElementFragmentUpsell_FlightsActionCheckbox_Fragment
  ) | (
    { __typename: 'FlightsActionLink' }
    & EgdsElementFragmentUpsell_FlightsActionLink_Fragment
  ) | (
    { __typename: 'FlightsDialogTrigger' }
    & FlightsDialogTriggerFragment
    & EgdsElementFragmentUpsell_FlightsDialogTrigger_Fragment
  ) | (
    { __typename: 'IdentityBasicBlock' }
    & EgdsElementFragmentUpsell_IdentityBasicBlock_Fragment
  ) | (
    { __typename: 'IdentityButton' }
    & EgdsElementFragmentUpsell_IdentityButton_Fragment
  ) | (
    { __typename: 'IdentityConsentNestedCheckBox' }
    & EgdsElementFragmentUpsell_IdentityConsentNestedCheckBox_Fragment
  ) | (
    { __typename: 'IdentityImage' }
    & EgdsElementFragmentUpsell_IdentityImage_Fragment
  ) | (
    { __typename: 'IdentityImageGallery' }
    & EgdsElementFragmentUpsell_IdentityImageGallery_Fragment
  ) | (
    { __typename: 'IdentityInfoLinkComponent' }
    & EgdsElementFragmentUpsell_IdentityInfoLinkComponent_Fragment
  ) | (
    { __typename: 'IdentityPasswordStrengthComponent' }
    & EgdsElementFragmentUpsell_IdentityPasswordStrengthComponent_Fragment
  ) | (
    { __typename: 'IdentityResendButton' }
    & EgdsElementFragmentUpsell_IdentityResendButton_Fragment
  ) | (
    { __typename: 'IdentitySingleColumnComponentLayout' }
    & EgdsElementFragmentUpsell_IdentitySingleColumnComponentLayout_Fragment
  ) | (
    { __typename: 'IdentitySocialButton' }
    & EgdsElementFragmentUpsell_IdentitySocialButton_Fragment
  ) | (
    { __typename: 'IdentityText' }
    & EgdsElementFragmentUpsell_IdentityText_Fragment
  ) | (
    { __typename: 'Illustration' }
    & EgdsElementFragmentUpsell_Illustration_Fragment
  ) | (
    { __typename: 'LodgingSearchForm' }
    & EgdsElementFragmentUpsell_LodgingSearchForm_Fragment
  ) | (
    { __typename: 'PackagesSearchForm' }
    & EgdsElementFragmentUpsell_PackagesSearchForm_Fragment
  ) | (
    { __typename: 'ProductSummaryCard' }
    & EgdsElementFragmentUpsell_ProductSummaryCard_Fragment
  ) | (
    { __typename: 'ProfileAccountLink' }
    & EgdsElementFragmentUpsell_ProfileAccountLink_Fragment
  ) | (
    { __typename: 'ProfileActionButtonCard' }
    & EgdsElementFragmentUpsell_ProfileActionButtonCard_Fragment
  ) | (
    { __typename: 'ProfileBulletedList' }
    & EgdsElementFragmentUpsell_ProfileBulletedList_Fragment
  ) | (
    { __typename: 'ProfileEGDSSectionContainer' }
    & EgdsElementFragmentUpsell_ProfileEgdsSectionContainer_Fragment
  ) | (
    { __typename: 'ProfileFormHorizontalContainer' }
    & EgdsElementFragmentUpsell_ProfileFormHorizontalContainer_Fragment
  ) | (
    { __typename: 'ProfileFormSection' }
    & EgdsElementFragmentUpsell_ProfileFormSection_Fragment
  ) | (
    { __typename: 'ProfileLink' }
    & EgdsElementFragmentUpsell_ProfileLink_Fragment
  ) | (
    { __typename: 'ProfileNumberField' }
    & EgdsElementFragmentUpsell_ProfileNumberField_Fragment
  ) | (
    { __typename: 'ProfilePhoneNumberField' }
    & EgdsElementFragmentUpsell_ProfilePhoneNumberField_Fragment
  ) | (
    { __typename: 'ProfileRadioButton' }
    & EgdsElementFragmentUpsell_ProfileRadioButton_Fragment
  ) | (
    { __typename: 'ProfileRadioButtonGroup' }
    & EgdsElementFragmentUpsell_ProfileRadioButtonGroup_Fragment
  ) | (
    { __typename: 'ProfileSelectField' }
    & EgdsElementFragmentUpsell_ProfileSelectField_Fragment
  ) | (
    { __typename: 'ProfileSlimCard' }
    & EgdsElementFragmentUpsell_ProfileSlimCard_Fragment
  ) | (
    { __typename: 'ProfileSwitchOption' }
    & EgdsElementFragmentUpsell_ProfileSwitchOption_Fragment
  ) | (
    { __typename: 'ProfileTextField' }
    & EgdsElementFragmentUpsell_ProfileTextField_Fragment
  ) | (
    { __typename: 'SearchFormDurationSpanField' }
    & EgdsElementFragmentUpsell_SearchFormDurationSpanField_Fragment
  ) | (
    { __typename: 'TripsMediaGallery' }
    & EgdsElementFragmentUpsell_TripsMediaGallery_Fragment
  ) | (
    { __typename: 'TripsValidatedInput' }
    & EgdsElementFragmentUpsell_TripsValidatedInput_Fragment
  ) | (
    { __typename: 'UIBanner' }
    & EgdsElementFragmentUpsell_UiBanner_Fragment
  ) | (
    { __typename: 'UIEmptyState' }
    & EgdsElementFragmentUpsell_UiEmptyState_Fragment
  ) | (
    { __typename: 'UIMessagingCard' }
    & EgdsElementFragmentUpsell_UiMessagingCard_Fragment
  ) | (
    { __typename: 'UIPrimaryButton' }
    & EgdsElementFragmentUpsell_UiPrimaryButton_Fragment
  ) | (
    { __typename: 'UIPrimaryFloatingActionButton' }
    & EgdsElementFragmentUpsell_UiPrimaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UISecondaryButton' }
    & EgdsElementFragmentUpsell_UiSecondaryButton_Fragment
  ) | (
    { __typename: 'UISecondaryFloatingActionButton' }
    & EgdsElementFragmentUpsell_UiSecondaryFloatingActionButton_Fragment
  ) | (
    { __typename: 'UITertiaryButton' }
    & EgdsElementFragmentUpsell_UiTertiaryButton_Fragment
  )>> };

type EgdsDialog_AdditionalInformationPopoverDialogSection_Fragment = { __typename: 'AdditionalInformationPopoverDialogSection', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

type EgdsDialog_ClientSideErrorRepresentationDialog_Fragment = { __typename: 'ClientSideErrorRepresentationDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

type EgdsDialog_EgdsActionDialog_Fragment = { __typename: 'EGDSActionDialog', footer: { __typename: 'EGDSInlineDialogFooter', buttons: Array<(
      { __typename: 'EGDSOverlayButton' }
      & EgdsButton_EgdsOverlayButton_Fragment
    ) | (
      { __typename: 'EGDSSearchFormButton' }
      & EgdsButton_EgdsSearchFormButton_Fragment
    ) | (
      { __typename: 'FlightsActionButton' }
      & EgdsButton_FlightsActionButton_Fragment
    ) | (
      { __typename: 'FlightsDialogTrigger' }
      & EgdsButton_FlightsDialogTrigger_Fragment
    ) | (
      { __typename: 'FlightsExperienceActionButton' }
      & EgdsButton_FlightsExperienceActionButton_Fragment
    ) | (
      { __typename: 'FlightsSmartShoppingActionButton' }
      & EgdsButton_FlightsSmartShoppingActionButton_Fragment
    ) | (
      { __typename: 'PackageUIActionDialogFooterButton' }
      & EgdsButton_PackageUiActionDialogFooterButton_Fragment
    ) | (
      { __typename: 'PackageUIHideSearchFormAction' }
      & EgdsButton_PackageUiHideSearchFormAction_Fragment
    ) | (
      { __typename: 'PackageUITravelGuideButton' }
      & EgdsButton_PackageUiTravelGuideButton_Fragment
    ) | (
      { __typename: 'ServicingButton' }
      & EgdsButton_ServicingButton_Fragment
    ) | (
      { __typename: 'SupplyCancelWaiverActionButton' }
      & EgdsButton_SupplyCancelWaiverActionButton_Fragment
    ) | (
      { __typename: 'SupplyContentLinkStyleButton' }
      & EgdsButton_SupplyContentLinkStyleButton_Fragment
    ) | (
      { __typename: 'UIPrimaryButton' }
      & EgdsButton_UiPrimaryButton_Fragment
    ) | (
      { __typename: 'UISecondaryButton' }
      & EgdsButton_UiSecondaryButton_Fragment
    ) | (
      { __typename: 'UITertiaryButton' }
      & EgdsButton_UiTertiaryButton_Fragment
    )> } | { __typename: 'EGDSStackedDialogFooter', buttons: Array<(
      { __typename: 'EGDSOverlayButton' }
      & EgdsButton_EgdsOverlayButton_Fragment
    ) | (
      { __typename: 'EGDSSearchFormButton' }
      & EgdsButton_EgdsSearchFormButton_Fragment
    ) | (
      { __typename: 'FlightsActionButton' }
      & EgdsButton_FlightsActionButton_Fragment
    ) | (
      { __typename: 'FlightsDialogTrigger' }
      & EgdsButton_FlightsDialogTrigger_Fragment
    ) | (
      { __typename: 'FlightsExperienceActionButton' }
      & EgdsButton_FlightsExperienceActionButton_Fragment
    ) | (
      { __typename: 'FlightsSmartShoppingActionButton' }
      & EgdsButton_FlightsSmartShoppingActionButton_Fragment
    ) | (
      { __typename: 'PackageUIActionDialogFooterButton' }
      & EgdsButton_PackageUiActionDialogFooterButton_Fragment
    ) | (
      { __typename: 'PackageUIHideSearchFormAction' }
      & EgdsButton_PackageUiHideSearchFormAction_Fragment
    ) | (
      { __typename: 'PackageUITravelGuideButton' }
      & EgdsButton_PackageUiTravelGuideButton_Fragment
    ) | (
      { __typename: 'ServicingButton' }
      & EgdsButton_ServicingButton_Fragment
    ) | (
      { __typename: 'SupplyCancelWaiverActionButton' }
      & EgdsButton_SupplyCancelWaiverActionButton_Fragment
    ) | (
      { __typename: 'SupplyContentLinkStyleButton' }
      & EgdsButton_SupplyContentLinkStyleButton_Fragment
    ) | (
      { __typename: 'UIPrimaryButton' }
      & EgdsButton_UiPrimaryButton_Fragment
    ) | (
      { __typename: 'UISecondaryButton' }
      & EgdsButton_UiSecondaryButton_Fragment
    ) | (
      { __typename: 'UITertiaryButton' }
      & EgdsButton_UiTertiaryButton_Fragment
    )> }, closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

type EgdsDialog_EgdsFullScreenDialog_Fragment = (
  { __typename: 'EGDSFullScreenDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> }
  & EgdsFullScreenDialogFragmentUpsellFragment
);

type EgdsDialog_EgdsLoaderDialog_Fragment = { __typename: 'EGDSLoaderDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

type EgdsDialog_PriceInsightsExistingTrackingDialogAction_Fragment = { __typename: 'PriceInsightsExistingTrackingDialogAction', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

type EgdsDialog_PriceInsightsTrackingRetryDialogAction_Fragment = { __typename: 'PriceInsightsTrackingRetryDialogAction', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

type EgdsDialog_ServicingDialog_Fragment = { __typename: 'ServicingDialog', closeAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

export type EgdsDialogFragment = EgdsDialog_AdditionalInformationPopoverDialogSection_Fragment | EgdsDialog_ClientSideErrorRepresentationDialog_Fragment | EgdsDialog_EgdsActionDialog_Fragment | EgdsDialog_EgdsFullScreenDialog_Fragment | EgdsDialog_EgdsLoaderDialog_Fragment | EgdsDialog_PriceInsightsExistingTrackingDialogAction_Fragment | EgdsDialog_PriceInsightsTrackingRetryDialogAction_Fragment | EgdsDialog_ServicingDialog_Fragment;

export type PriceMatchPromiseSelectionFragmentFragment = { __typename: 'PriceMatchPromiseSelectionCardSection', header: string, description: string, price?: Maybe<string>, icon: (
    { __typename: 'Icon' }
    & IconSearchUpsellFragment
  ), toggleCheckbox?: Maybe<{ __typename: 'FlightsActionCheckbox', label: (
      { __typename: 'EGDSBasicLocalizedText' }
      & EgdsTextFragmentUpsell_EgdsBasicLocalizedText_Fragment
    ) | (
      { __typename: 'EGDSCardinalLocalizedText' }
      & EgdsTextFragmentUpsell_EgdsCardinalLocalizedText_Fragment
    ) | (
      { __typename: 'EGDSCompositeLocalizedText' }
      & EgdsTextFragmentUpsell_EgdsCompositeLocalizedText_Fragment
    ) | (
      { __typename: 'EGDSGraphicText' }
      & EgdsTextFragmentUpsell_EgdsGraphicText_Fragment
    ) | (
      { __typename: 'EGDSHeading' }
      & EgdsTextFragmentUpsell_EgdsHeading_Fragment
    ) | (
      { __typename: 'EGDSIconText' }
      & EgdsTextFragmentUpsell_EgdsIconText_Fragment
    ) | (
      { __typename: 'EGDSInlineLink' }
      & EgdsTextFragmentUpsell_EgdsInlineLink_Fragment
    ) | (
      { __typename: 'EGDSLocalizedTextTemplate' }
      & EgdsTextFragmentUpsell_EgdsLocalizedTextTemplate_Fragment
    ) | (
      { __typename: 'EGDSParagraph' }
      & EgdsTextFragmentUpsell_EgdsParagraph_Fragment
    ) | (
      { __typename: 'EGDSPlainText' }
      & EgdsTextFragmentUpsell_EgdsPlainText_Fragment
    ) | (
      { __typename: 'EGDSSpannableText' }
      & EgdsTextFragmentUpsell_EgdsSpannableText_Fragment
    ) | (
      { __typename: 'EGDSStandardLink' }
      & EgdsTextFragmentUpsell_EgdsStandardLink_Fragment
    ) | (
      { __typename: 'EGDSStylizedText' }
      & EgdsTextFragmentUpsell_EgdsStylizedText_Fragment
    ) | (
      { __typename: 'EGDSTextIconLinkListItem' }
      & EgdsTextFragmentUpsell_EgdsTextIconLinkListItem_Fragment
    ) | (
      { __typename: 'EGDSTextIconListItem' }
      & EgdsTextFragmentUpsell_EgdsTextIconListItem_Fragment
    ) | (
      { __typename: 'EGDSTextStandardListItem' }
      & EgdsTextFragmentUpsell_EgdsTextStandardListItem_Fragment
    ) | (
      { __typename: 'EGDSTextWithMarkListItem' }
      & EgdsTextFragmentUpsell_EgdsTextWithMarkListItem_Fragment
    ), clientAction: { __typename: 'FlightsAncillaryContinueAction' } | { __typename: 'FlightsBookingAction' } | { __typename: 'FlightsBoundNavigation' } | (
      { __typename: 'FlightsClickAction' }
      & FlightsClickActionUpsellFragmentFragment
    ) | { __typename: 'FlightsCreditClearAction' } | { __typename: 'FlightsCreditSelectionAction' } | { __typename: 'FlightsCreditSelectorOpenAction' } | { __typename: 'FlightsDialogCloseAction' } | { __typename: 'FlightsDialogTriggerAction' } | { __typename: 'FlightsFareTypeSelectionAction' } | { __typename: 'FlightsLegDropdownItemSelection' } | { __typename: 'FlightsLoadAncillariesAction' } | { __typename: 'FlightsNavigateToDetails' } | { __typename: 'FlightsRedirectOrDialog' } | { __typename: 'FlightsRefreshAction' } | { __typename: 'FlightsRemovePriceMatchPromiseAction' } | { __typename: 'FlightsResourceLinkAction' } | { __typename: 'FlightsResourceRedirectAction' } | { __typename: 'FlightsSearchCriteriaChangeAction' } | { __typename: 'FlightsSelectionAction' } | { __typename: 'FlightsSwitchToggleAction' } | { __typename: 'InsuranceSwitchToggleAction' } | { __typename: 'MultiItemSelectPackage' } | { __typename: 'MultiItemSelectProducts' } }>, onDisplayAnalytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>>, infoTrigger?: Maybe<(
    { __typename: 'FlightsDialogTrigger' }
    & FlightsDialogTriggerFragment
  )> };

export type PriceMatchPromiseSelectedFragmentFragment = { __typename: 'PriceMatchPromiseSelectedCardSection', header: string, description: string, icon: (
    { __typename: 'Icon' }
    & IconSearchUpsellFragment
  ), removeActionLink?: Maybe<(
    { __typename: 'FlightsActionLink' }
    & FlightsActionLinkFragment
  )>, onDisplayAnalytics?: Maybe<Array<(
    { __typename: 'FlightsAnalytics' }
    & FlightsAnalyticsFragment
  )>> };

export type FlightsActionLinkFragment = { __typename: 'FlightsActionLink', disabled: boolean, primary?: Maybe<string>, clientAction: { __typename: 'FlightsAncillaryContinueAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsBookingAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsBoundNavigation', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsClickAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsCreditClearAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsCreditSelectionAction', originalBookingId: string, accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsCreditSelectorOpenAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsDialogCloseAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsDialogTriggerAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsFareTypeSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsLegDropdownItemSelection', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsLoadAncillariesAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsNavigateToDetails', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsRedirectOrDialog', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsRefreshAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsRemovePriceMatchPromiseAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' }, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsResourceRedirectAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsSearchCriteriaChangeAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsSelectionAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'InsuranceSwitchToggleAction', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'MultiItemSelectPackage', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'MultiItemSelectProducts', accessibility?: Maybe<string>, analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> }, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchUpsellFragment
  )> };

type EgdsElementFragmentUpsell_ActivitySearchForm_Fragment = { __typename: 'ActivitySearchForm' };

type EgdsElementFragmentUpsell_AgencyUiPrimaryFloatingActionButton_Fragment = { __typename: 'AgencyUIPrimaryFloatingActionButton' };

type EgdsElementFragmentUpsell_AgencyUiSecondaryFloatingActionButton_Fragment = { __typename: 'AgencyUISecondaryFloatingActionButton' };

type EgdsElementFragmentUpsell_CarSearchForm_Fragment = { __typename: 'CarSearchForm' };

type EgdsElementFragmentUpsell_CruiseSearchForm_Fragment = { __typename: 'CruiseSearchForm' };

type EgdsElementFragmentUpsell_DurationSpanSelector_Fragment = { __typename: 'DurationSpanSelector' };

type EgdsElementFragmentUpsell_EgdsBadgeNotification_Fragment = { __typename: 'EGDSBadgeNotification' };

type EgdsElementFragmentUpsell_EgdsBasicCheckBox_Fragment = { __typename: 'EGDSBasicCheckBox' };

type EgdsElementFragmentUpsell_EgdsBasicLocalizedText_Fragment = (
  { __typename: 'EGDSBasicLocalizedText' }
  & EgdsTextFragmentUpsell_EgdsBasicLocalizedText_Fragment
);

type EgdsElementFragmentUpsell_EgdsBasicOption_Fragment = { __typename: 'EGDSBasicOption' };

type EgdsElementFragmentUpsell_EgdsBasicSelect_Fragment = { __typename: 'EGDSBasicSelect' };

type EgdsElementFragmentUpsell_EgdsBasicStepInput_Fragment = { __typename: 'EGDSBasicStepInput' };

type EgdsElementFragmentUpsell_EgdsBasicTab_Fragment = { __typename: 'EGDSBasicTab' };

type EgdsElementFragmentUpsell_EgdsBasicTabs_Fragment = { __typename: 'EGDSBasicTabs' };

type EgdsElementFragmentUpsell_EgdsBasicTravelerSelector_Fragment = { __typename: 'EGDSBasicTravelerSelector' };

type EgdsElementFragmentUpsell_EgdsBulletedList_Fragment = { __typename: 'EGDSBulletedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } | { __typename: 'EGDSTextWithMarkListItem', text: string } | { __typename: 'EarnMessageContainerListItem', text: string } | { __typename: 'FlightsTextContainerListItem', text: string } | { __typename: 'MishopUITextContainerListItem', text: string }> };

type EgdsElementFragmentUpsell_EgdsCardinalLocalizedText_Fragment = (
  { __typename: 'EGDSCardinalLocalizedText' }
  & EgdsTextFragmentUpsell_EgdsCardinalLocalizedText_Fragment
);

type EgdsElementFragmentUpsell_EgdsComposableTextElementSectionContainer_Fragment = { __typename: 'EGDSComposableTextElementSectionContainer' };

type EgdsElementFragmentUpsell_EgdsCompositeLocalizedText_Fragment = (
  { __typename: 'EGDSCompositeLocalizedText' }
  & EgdsTextFragmentUpsell_EgdsCompositeLocalizedText_Fragment
);

type EgdsElementFragmentUpsell_EgdsEmailInputField_Fragment = { __typename: 'EGDSEmailInputField' };

type EgdsElementFragmentUpsell_EgdsErrorSummary_Fragment = { __typename: 'EGDSErrorSummary' };

type EgdsElementFragmentUpsell_EgdsHeading_Fragment = (
  { __typename: 'EGDSHeading' }
  & EgdsTextFragmentUpsell_EgdsHeading_Fragment
);

type EgdsElementFragmentUpsell_EgdsImageLink_Fragment = { __typename: 'EGDSImageLink' };

type EgdsElementFragmentUpsell_EgdsImageLinkCard_Fragment = { __typename: 'EGDSImageLinkCard' };

type EgdsElementFragmentUpsell_EgdsInfantSeatRadioButton_Fragment = { __typename: 'EGDSInfantSeatRadioButton' };

type EgdsElementFragmentUpsell_EgdsLinkList_Fragment = { __typename: 'EGDSLinkList' };

type EgdsElementFragmentUpsell_EgdsLocalizedTextTemplate_Fragment = (
  { __typename: 'EGDSLocalizedTextTemplate' }
  & EgdsTextFragmentUpsell_EgdsLocalizedTextTemplate_Fragment
);

type EgdsElementFragmentUpsell_EgdsLoyaltyBadge_Fragment = { __typename: 'EGDSLoyaltyBadge' };

type EgdsElementFragmentUpsell_EgdsNumberInputField_Fragment = { __typename: 'EGDSNumberInputField' };

type EgdsElementFragmentUpsell_EgdsOrderedList_Fragment = { __typename: 'EGDSOrderedList' };

type EgdsElementFragmentUpsell_EgdsOverlayButton_Fragment = { __typename: 'EGDSOverlayButton' };

type EgdsElementFragmentUpsell_EgdsParagraph_Fragment = (
  { __typename: 'EGDSParagraph' }
  & EgdsTextFragmentUpsell_EgdsParagraph_Fragment
);

type EgdsElementFragmentUpsell_EgdsPasswordInputField_Fragment = { __typename: 'EGDSPasswordInputField' };

type EgdsElementFragmentUpsell_EgdsProgramBadge_Fragment = { __typename: 'EGDSProgramBadge' };

type EgdsElementFragmentUpsell_EgdsRoomsTravelerSelector_Fragment = { __typename: 'EGDSRoomsTravelerSelector' };

type EgdsElementFragmentUpsell_EgdsSearchFormButton_Fragment = { __typename: 'EGDSSearchFormButton' };

type EgdsElementFragmentUpsell_EgdsSearchFormDatePickerField_Fragment = { __typename: 'EGDSSearchFormDatePickerField' };

type EgdsElementFragmentUpsell_EgdsSearchFormInputField_Fragment = { __typename: 'EGDSSearchFormInputField' };

type EgdsElementFragmentUpsell_EgdsSearchFormLocationField_Fragment = { __typename: 'EGDSSearchFormLocationField' };

type EgdsElementFragmentUpsell_EgdsSearchFormLocationsField_Fragment = { __typename: 'EGDSSearchFormLocationsField' };

type EgdsElementFragmentUpsell_EgdsSearchFormTravelersField_Fragment = { __typename: 'EGDSSearchFormTravelersField' };

type EgdsElementFragmentUpsell_EgdsSectionContainer_Fragment = { __typename: 'EGDSSectionContainer' };

type EgdsElementFragmentUpsell_EgdsSpannableText_Fragment = (
  { __typename: 'EGDSSpannableText' }
  & EgdsTextFragmentUpsell_EgdsSpannableText_Fragment
);

type EgdsElementFragmentUpsell_EgdsStandardBadge_Fragment = { __typename: 'EGDSStandardBadge' };

type EgdsElementFragmentUpsell_EgdsStandardLink_Fragment = (
  { __typename: 'EGDSStandardLink' }
  & EgdsTextFragmentUpsell_EgdsStandardLink_Fragment
);

type EgdsElementFragmentUpsell_EgdsStandardMessagingCard_Fragment = { __typename: 'EGDSStandardMessagingCard' };

type EgdsElementFragmentUpsell_EgdsTextAreaInputField_Fragment = { __typename: 'EGDSTextAreaInputField' };

type EgdsElementFragmentUpsell_EgdsTextIconLinkListItem_Fragment = (
  { __typename: 'EGDSTextIconLinkListItem' }
  & EgdsTextFragmentUpsell_EgdsTextIconLinkListItem_Fragment
);

type EgdsElementFragmentUpsell_EgdsTextIconList_Fragment = { __typename: 'EGDSTextIconList' };

type EgdsElementFragmentUpsell_EgdsTextIconListItem_Fragment = (
  { __typename: 'EGDSTextIconListItem' }
  & EgdsTextFragmentUpsell_EgdsTextIconListItem_Fragment
);

type EgdsElementFragmentUpsell_EgdsTextInputField_Fragment = { __typename: 'EGDSTextInputField' };

type EgdsElementFragmentUpsell_EgdsTextListSection_Fragment = { __typename: 'EGDSTextListSection' };

type EgdsElementFragmentUpsell_EgdsTextSection_Fragment = { __typename: 'EGDSTextSection' };

type EgdsElementFragmentUpsell_EgdsTextStandardListItem_Fragment = (
  { __typename: 'EGDSTextStandardListItem' }
  & EgdsTextFragmentUpsell_EgdsTextStandardListItem_Fragment
);

type EgdsElementFragmentUpsell_EgdsTextWithMarkListItem_Fragment = (
  { __typename: 'EGDSTextWithMarkListItem' }
  & EgdsTextFragmentUpsell_EgdsTextWithMarkListItem_Fragment
);

type EgdsElementFragmentUpsell_EgdsToast_Fragment = { __typename: 'EGDSToast' };

type EgdsElementFragmentUpsell_EgdsTravelerChildAgeSelect_Fragment = { __typename: 'EGDSTravelerChildAgeSelect' };

type EgdsElementFragmentUpsell_EgdsTravelerInfantSeatSelection_Fragment = { __typename: 'EGDSTravelerInfantSeatSelection' };

type EgdsElementFragmentUpsell_EgdsTravelerStepInput_Fragment = { __typename: 'EGDSTravelerStepInput' };

type EgdsElementFragmentUpsell_EgdsTypeaheadInputField_Fragment = { __typename: 'EGDSTypeaheadInputField' };

type EgdsElementFragmentUpsell_EgdsUnorderedList_Fragment = { __typename: 'EGDSUnorderedList' };

type EgdsElementFragmentUpsell_FlightSearchForm_Fragment = { __typename: 'FlightSearchForm' };

type EgdsElementFragmentUpsell_FlightSearchInputForm_Fragment = { __typename: 'FlightSearchInputForm' };

type EgdsElementFragmentUpsell_FlightsActionButton_Fragment = { __typename: 'FlightsActionButton' };

type EgdsElementFragmentUpsell_FlightsActionCheckbox_Fragment = { __typename: 'FlightsActionCheckbox' };

type EgdsElementFragmentUpsell_FlightsActionLink_Fragment = { __typename: 'FlightsActionLink' };

type EgdsElementFragmentUpsell_FlightsDialogTrigger_Fragment = { __typename: 'FlightsDialogTrigger' };

type EgdsElementFragmentUpsell_IdentityBasicBlock_Fragment = { __typename: 'IdentityBasicBlock' };

type EgdsElementFragmentUpsell_IdentityButton_Fragment = { __typename: 'IdentityButton' };

type EgdsElementFragmentUpsell_IdentityConsentNestedCheckBox_Fragment = { __typename: 'IdentityConsentNestedCheckBox' };

type EgdsElementFragmentUpsell_IdentityImage_Fragment = { __typename: 'IdentityImage' };

type EgdsElementFragmentUpsell_IdentityImageGallery_Fragment = { __typename: 'IdentityImageGallery' };

type EgdsElementFragmentUpsell_IdentityInfoLinkComponent_Fragment = { __typename: 'IdentityInfoLinkComponent' };

type EgdsElementFragmentUpsell_IdentityPasswordStrengthComponent_Fragment = { __typename: 'IdentityPasswordStrengthComponent' };

type EgdsElementFragmentUpsell_IdentityResendButton_Fragment = { __typename: 'IdentityResendButton' };

type EgdsElementFragmentUpsell_IdentitySingleColumnComponentLayout_Fragment = { __typename: 'IdentitySingleColumnComponentLayout' };

type EgdsElementFragmentUpsell_IdentitySocialButton_Fragment = { __typename: 'IdentitySocialButton' };

type EgdsElementFragmentUpsell_IdentityText_Fragment = { __typename: 'IdentityText' };

type EgdsElementFragmentUpsell_Illustration_Fragment = (
  { __typename: 'Illustration' }
  & EgdsGraphicIllustrationFragmentFragment
);

type EgdsElementFragmentUpsell_LodgingSearchForm_Fragment = { __typename: 'LodgingSearchForm' };

type EgdsElementFragmentUpsell_PackagesSearchForm_Fragment = { __typename: 'PackagesSearchForm' };

type EgdsElementFragmentUpsell_ProductSummaryCard_Fragment = { __typename: 'ProductSummaryCard' };

type EgdsElementFragmentUpsell_ProfileAccountLink_Fragment = { __typename: 'ProfileAccountLink' };

type EgdsElementFragmentUpsell_ProfileActionButtonCard_Fragment = { __typename: 'ProfileActionButtonCard' };

type EgdsElementFragmentUpsell_ProfileBulletedList_Fragment = { __typename: 'ProfileBulletedList' };

type EgdsElementFragmentUpsell_ProfileEgdsSectionContainer_Fragment = { __typename: 'ProfileEGDSSectionContainer' };

type EgdsElementFragmentUpsell_ProfileFormHorizontalContainer_Fragment = { __typename: 'ProfileFormHorizontalContainer' };

type EgdsElementFragmentUpsell_ProfileFormSection_Fragment = { __typename: 'ProfileFormSection' };

type EgdsElementFragmentUpsell_ProfileLink_Fragment = { __typename: 'ProfileLink' };

type EgdsElementFragmentUpsell_ProfileNumberField_Fragment = { __typename: 'ProfileNumberField' };

type EgdsElementFragmentUpsell_ProfilePhoneNumberField_Fragment = { __typename: 'ProfilePhoneNumberField' };

type EgdsElementFragmentUpsell_ProfileRadioButton_Fragment = { __typename: 'ProfileRadioButton' };

type EgdsElementFragmentUpsell_ProfileRadioButtonGroup_Fragment = { __typename: 'ProfileRadioButtonGroup' };

type EgdsElementFragmentUpsell_ProfileSelectField_Fragment = { __typename: 'ProfileSelectField' };

type EgdsElementFragmentUpsell_ProfileSlimCard_Fragment = { __typename: 'ProfileSlimCard' };

type EgdsElementFragmentUpsell_ProfileSwitchOption_Fragment = { __typename: 'ProfileSwitchOption' };

type EgdsElementFragmentUpsell_ProfileTextField_Fragment = { __typename: 'ProfileTextField' };

type EgdsElementFragmentUpsell_SearchFormDurationSpanField_Fragment = { __typename: 'SearchFormDurationSpanField' };

type EgdsElementFragmentUpsell_TripsMediaGallery_Fragment = { __typename: 'TripsMediaGallery' };

type EgdsElementFragmentUpsell_TripsValidatedInput_Fragment = { __typename: 'TripsValidatedInput' };

type EgdsElementFragmentUpsell_UiBanner_Fragment = { __typename: 'UIBanner' };

type EgdsElementFragmentUpsell_UiEmptyState_Fragment = { __typename: 'UIEmptyState' };

type EgdsElementFragmentUpsell_UiMessagingCard_Fragment = { __typename: 'UIMessagingCard', primary?: Maybe<string>, secondaries?: Maybe<Array<string>>, graphic?: Maybe<{ __typename: 'Icon' } | (
    { __typename: 'Illustration', link: any }
    & EgdsGraphicIllustrationFragmentFragment
  ) | { __typename: 'Mark' }> };

type EgdsElementFragmentUpsell_UiPrimaryButton_Fragment = { __typename: 'UIPrimaryButton' };

type EgdsElementFragmentUpsell_UiPrimaryFloatingActionButton_Fragment = { __typename: 'UIPrimaryFloatingActionButton' };

type EgdsElementFragmentUpsell_UiSecondaryButton_Fragment = { __typename: 'UISecondaryButton' };

type EgdsElementFragmentUpsell_UiSecondaryFloatingActionButton_Fragment = { __typename: 'UISecondaryFloatingActionButton' };

type EgdsElementFragmentUpsell_UiTertiaryButton_Fragment = { __typename: 'UITertiaryButton' };

export type EgdsElementFragmentUpsellFragment = EgdsElementFragmentUpsell_ActivitySearchForm_Fragment | EgdsElementFragmentUpsell_AgencyUiPrimaryFloatingActionButton_Fragment | EgdsElementFragmentUpsell_AgencyUiSecondaryFloatingActionButton_Fragment | EgdsElementFragmentUpsell_CarSearchForm_Fragment | EgdsElementFragmentUpsell_CruiseSearchForm_Fragment | EgdsElementFragmentUpsell_DurationSpanSelector_Fragment | EgdsElementFragmentUpsell_EgdsBadgeNotification_Fragment | EgdsElementFragmentUpsell_EgdsBasicCheckBox_Fragment | EgdsElementFragmentUpsell_EgdsBasicLocalizedText_Fragment | EgdsElementFragmentUpsell_EgdsBasicOption_Fragment | EgdsElementFragmentUpsell_EgdsBasicSelect_Fragment | EgdsElementFragmentUpsell_EgdsBasicStepInput_Fragment | EgdsElementFragmentUpsell_EgdsBasicTab_Fragment | EgdsElementFragmentUpsell_EgdsBasicTabs_Fragment | EgdsElementFragmentUpsell_EgdsBasicTravelerSelector_Fragment | EgdsElementFragmentUpsell_EgdsBulletedList_Fragment | EgdsElementFragmentUpsell_EgdsCardinalLocalizedText_Fragment | EgdsElementFragmentUpsell_EgdsComposableTextElementSectionContainer_Fragment | EgdsElementFragmentUpsell_EgdsCompositeLocalizedText_Fragment | EgdsElementFragmentUpsell_EgdsEmailInputField_Fragment | EgdsElementFragmentUpsell_EgdsErrorSummary_Fragment | EgdsElementFragmentUpsell_EgdsHeading_Fragment | EgdsElementFragmentUpsell_EgdsImageLink_Fragment | EgdsElementFragmentUpsell_EgdsImageLinkCard_Fragment | EgdsElementFragmentUpsell_EgdsInfantSeatRadioButton_Fragment | EgdsElementFragmentUpsell_EgdsLinkList_Fragment | EgdsElementFragmentUpsell_EgdsLocalizedTextTemplate_Fragment | EgdsElementFragmentUpsell_EgdsLoyaltyBadge_Fragment | EgdsElementFragmentUpsell_EgdsNumberInputField_Fragment | EgdsElementFragmentUpsell_EgdsOrderedList_Fragment | EgdsElementFragmentUpsell_EgdsOverlayButton_Fragment | EgdsElementFragmentUpsell_EgdsParagraph_Fragment | EgdsElementFragmentUpsell_EgdsPasswordInputField_Fragment | EgdsElementFragmentUpsell_EgdsProgramBadge_Fragment | EgdsElementFragmentUpsell_EgdsRoomsTravelerSelector_Fragment | EgdsElementFragmentUpsell_EgdsSearchFormButton_Fragment | EgdsElementFragmentUpsell_EgdsSearchFormDatePickerField_Fragment | EgdsElementFragmentUpsell_EgdsSearchFormInputField_Fragment | EgdsElementFragmentUpsell_EgdsSearchFormLocationField_Fragment | EgdsElementFragmentUpsell_EgdsSearchFormLocationsField_Fragment | EgdsElementFragmentUpsell_EgdsSearchFormTravelersField_Fragment | EgdsElementFragmentUpsell_EgdsSectionContainer_Fragment | EgdsElementFragmentUpsell_EgdsSpannableText_Fragment | EgdsElementFragmentUpsell_EgdsStandardBadge_Fragment | EgdsElementFragmentUpsell_EgdsStandardLink_Fragment | EgdsElementFragmentUpsell_EgdsStandardMessagingCard_Fragment | EgdsElementFragmentUpsell_EgdsTextAreaInputField_Fragment | EgdsElementFragmentUpsell_EgdsTextIconLinkListItem_Fragment | EgdsElementFragmentUpsell_EgdsTextIconList_Fragment | EgdsElementFragmentUpsell_EgdsTextIconListItem_Fragment | EgdsElementFragmentUpsell_EgdsTextInputField_Fragment | EgdsElementFragmentUpsell_EgdsTextListSection_Fragment | EgdsElementFragmentUpsell_EgdsTextSection_Fragment | EgdsElementFragmentUpsell_EgdsTextStandardListItem_Fragment | EgdsElementFragmentUpsell_EgdsTextWithMarkListItem_Fragment | EgdsElementFragmentUpsell_EgdsToast_Fragment | EgdsElementFragmentUpsell_EgdsTravelerChildAgeSelect_Fragment | EgdsElementFragmentUpsell_EgdsTravelerInfantSeatSelection_Fragment | EgdsElementFragmentUpsell_EgdsTravelerStepInput_Fragment | EgdsElementFragmentUpsell_EgdsTypeaheadInputField_Fragment | EgdsElementFragmentUpsell_EgdsUnorderedList_Fragment | EgdsElementFragmentUpsell_FlightSearchForm_Fragment | EgdsElementFragmentUpsell_FlightSearchInputForm_Fragment | EgdsElementFragmentUpsell_FlightsActionButton_Fragment | EgdsElementFragmentUpsell_FlightsActionCheckbox_Fragment | EgdsElementFragmentUpsell_FlightsActionLink_Fragment | EgdsElementFragmentUpsell_FlightsDialogTrigger_Fragment | EgdsElementFragmentUpsell_IdentityBasicBlock_Fragment | EgdsElementFragmentUpsell_IdentityButton_Fragment | EgdsElementFragmentUpsell_IdentityConsentNestedCheckBox_Fragment | EgdsElementFragmentUpsell_IdentityImage_Fragment | EgdsElementFragmentUpsell_IdentityImageGallery_Fragment | EgdsElementFragmentUpsell_IdentityInfoLinkComponent_Fragment | EgdsElementFragmentUpsell_IdentityPasswordStrengthComponent_Fragment | EgdsElementFragmentUpsell_IdentityResendButton_Fragment | EgdsElementFragmentUpsell_IdentitySingleColumnComponentLayout_Fragment | EgdsElementFragmentUpsell_IdentitySocialButton_Fragment | EgdsElementFragmentUpsell_IdentityText_Fragment | EgdsElementFragmentUpsell_Illustration_Fragment | EgdsElementFragmentUpsell_LodgingSearchForm_Fragment | EgdsElementFragmentUpsell_PackagesSearchForm_Fragment | EgdsElementFragmentUpsell_ProductSummaryCard_Fragment | EgdsElementFragmentUpsell_ProfileAccountLink_Fragment | EgdsElementFragmentUpsell_ProfileActionButtonCard_Fragment | EgdsElementFragmentUpsell_ProfileBulletedList_Fragment | EgdsElementFragmentUpsell_ProfileEgdsSectionContainer_Fragment | EgdsElementFragmentUpsell_ProfileFormHorizontalContainer_Fragment | EgdsElementFragmentUpsell_ProfileFormSection_Fragment | EgdsElementFragmentUpsell_ProfileLink_Fragment | EgdsElementFragmentUpsell_ProfileNumberField_Fragment | EgdsElementFragmentUpsell_ProfilePhoneNumberField_Fragment | EgdsElementFragmentUpsell_ProfileRadioButton_Fragment | EgdsElementFragmentUpsell_ProfileRadioButtonGroup_Fragment | EgdsElementFragmentUpsell_ProfileSelectField_Fragment | EgdsElementFragmentUpsell_ProfileSlimCard_Fragment | EgdsElementFragmentUpsell_ProfileSwitchOption_Fragment | EgdsElementFragmentUpsell_ProfileTextField_Fragment | EgdsElementFragmentUpsell_SearchFormDurationSpanField_Fragment | EgdsElementFragmentUpsell_TripsMediaGallery_Fragment | EgdsElementFragmentUpsell_TripsValidatedInput_Fragment | EgdsElementFragmentUpsell_UiBanner_Fragment | EgdsElementFragmentUpsell_UiEmptyState_Fragment | EgdsElementFragmentUpsell_UiMessagingCard_Fragment | EgdsElementFragmentUpsell_UiPrimaryButton_Fragment | EgdsElementFragmentUpsell_UiPrimaryFloatingActionButton_Fragment | EgdsElementFragmentUpsell_UiSecondaryButton_Fragment | EgdsElementFragmentUpsell_UiSecondaryFloatingActionButton_Fragment | EgdsElementFragmentUpsell_UiTertiaryButton_Fragment;

type EgdsTextFragmentUpsell_EgdsBasicLocalizedText_Fragment = { __typename: 'EGDSBasicLocalizedText' };

type EgdsTextFragmentUpsell_EgdsCardinalLocalizedText_Fragment = { __typename: 'EGDSCardinalLocalizedText' };

type EgdsTextFragmentUpsell_EgdsCompositeLocalizedText_Fragment = { __typename: 'EGDSCompositeLocalizedText' };

type EgdsTextFragmentUpsell_EgdsGraphicText_Fragment = (
  { __typename: 'EGDSGraphicText' }
  & EgdsGraphicTextFragmentUpsellFragment
);

type EgdsTextFragmentUpsell_EgdsHeading_Fragment = { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> };

type EgdsTextFragmentUpsell_EgdsIconText_Fragment = { __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } };

type EgdsTextFragmentUpsell_EgdsInlineLink_Fragment = { __typename: 'EGDSInlineLink' };

type EgdsTextFragmentUpsell_EgdsLocalizedTextTemplate_Fragment = { __typename: 'EGDSLocalizedTextTemplate' };

type EgdsTextFragmentUpsell_EgdsParagraph_Fragment = { __typename: 'EGDSParagraph', text: string, style: EgdsParagraphStyle };

type EgdsTextFragmentUpsell_EgdsPlainText_Fragment = { __typename: 'EGDSPlainText', text: string };

type EgdsTextFragmentUpsell_EgdsSpannableText_Fragment = (
  { __typename: 'EGDSSpannableText' }
  & EgdsSpannableTextFragmentUpsellFragment
);

type EgdsTextFragmentUpsell_EgdsStandardLink_Fragment = { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } };

type EgdsTextFragmentUpsell_EgdsStylizedText_Fragment = { __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, stylizedSize?: Maybe<string> };

type EgdsTextFragmentUpsell_EgdsTextIconLinkListItem_Fragment = { __typename: 'EGDSTextIconLinkListItem' };

type EgdsTextFragmentUpsell_EgdsTextIconListItem_Fragment = { __typename: 'EGDSTextIconListItem' };

type EgdsTextFragmentUpsell_EgdsTextStandardListItem_Fragment = { __typename: 'EGDSTextStandardListItem' };

type EgdsTextFragmentUpsell_EgdsTextWithMarkListItem_Fragment = { __typename: 'EGDSTextWithMarkListItem' };

export type EgdsTextFragmentUpsellFragment = EgdsTextFragmentUpsell_EgdsBasicLocalizedText_Fragment | EgdsTextFragmentUpsell_EgdsCardinalLocalizedText_Fragment | EgdsTextFragmentUpsell_EgdsCompositeLocalizedText_Fragment | EgdsTextFragmentUpsell_EgdsGraphicText_Fragment | EgdsTextFragmentUpsell_EgdsHeading_Fragment | EgdsTextFragmentUpsell_EgdsIconText_Fragment | EgdsTextFragmentUpsell_EgdsInlineLink_Fragment | EgdsTextFragmentUpsell_EgdsLocalizedTextTemplate_Fragment | EgdsTextFragmentUpsell_EgdsParagraph_Fragment | EgdsTextFragmentUpsell_EgdsPlainText_Fragment | EgdsTextFragmentUpsell_EgdsSpannableText_Fragment | EgdsTextFragmentUpsell_EgdsStandardLink_Fragment | EgdsTextFragmentUpsell_EgdsStylizedText_Fragment | EgdsTextFragmentUpsell_EgdsTextIconLinkListItem_Fragment | EgdsTextFragmentUpsell_EgdsTextIconListItem_Fragment | EgdsTextFragmentUpsell_EgdsTextStandardListItem_Fragment | EgdsTextFragmentUpsell_EgdsTextWithMarkListItem_Fragment;

export type FlightsActionButtonUpsellFragment = { __typename: 'FlightsActionButton', accessibility?: Maybe<string>, disabled: boolean, egdsElementId?: Maybe<string>, primary?: Maybe<string>, style: EgdsButtonStyle, buttonStyle: EgdsButtonStyle, clientAction: { __typename: 'FlightsAncillaryContinueAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsBookingAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsBoundNavigation', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsClickAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsCreditClearAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsCreditSelectionAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | (
    { __typename: 'FlightsCreditSelectorOpenAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> }
    & FlightsCreditSelectorOpenActionUpsellFragment
  ) | { __typename: 'FlightsDialogCloseAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsDialogTriggerAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsFareTypeSelectionAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsLegDropdownItemSelection', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsLoadAncillariesAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsNavigateToDetails', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsRedirectOrDialog', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsRefreshAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsRemovePriceMatchPromiseAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | (
    { __typename: 'FlightsResourceLinkAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> }
    & FlightsResourceLinkActionUpsellFragment
  ) | { __typename: 'FlightsResourceRedirectAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsSearchCriteriaChangeAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsSelectionAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'FlightsSwitchToggleAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'InsuranceSwitchToggleAction', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'MultiItemSelectPackage', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> } | { __typename: 'MultiItemSelectProducts', analyticsList: Array<(
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    )> }, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconSearchUpsellFragment
  )>, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ActivityCloseDialogAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ActivityMultiItemTripUpdateAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ActivityOpenDialogAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ActivityOpenOffersModalAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ActivityPaginationAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ActivityRemoveOffersFromTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ActivityUpdateOfferInTripAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'AgencyQuoteAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'AirCreditWebAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CDFOpenFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CDFOpenNextPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CDFSubmitFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CouponAndCreditAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CouponAndCreditChatbotAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CouponsAndCreditsSimpleAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CrossSellButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CrossSellLinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'CruiseAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'DirectFeedbackOpenFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'DirectFeedbackOpenNextPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'DirectFeedbackOpenPreviousPageAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'DirectFeedbackSubmitFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'EGDSOpenDatePickerAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'EGDSOpenTravelerSelectorAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'EGDSSubmitSearchFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'FlightsCreditSelectorOpenUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'FlightsDialogCloseUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'FlightsDialogTriggerUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'GroundTransfersBookAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'GroundTransfersDetailsOpenAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'GroundTransfersDismissAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'GroundTransfersLinkClickAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'GroundTransfersMultiItemTripUpdateAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'GroundTransfersSelectionClickAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'MemberWalletBadge', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'MemberWalletUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'MishopDetailsUIAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'MultiItemCrossSellUIButtonAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'MultiItemCrossSellUILinkAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'OpenTypeaheadAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'PaymentDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'PaymentDialogElement', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'PriceInsightsExistingDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileAccountFormSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileAddMembershipAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileAddPassportAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileFormSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileLinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileReloadAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileRewardProgramFormAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileUpdateMembershipAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ProfileUpdatePassportAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'QuoteAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'ShoppingSortAndFilterAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'SupplyNavigationHeaderSearchTrigger', accessibility: string, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'TripsRetryOperationAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'UIFlightAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'UILinkAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'WizardAdditionalUserInputRequiredAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) } | { __typename: 'WizardSubmitAction', accessibility?: Maybe<string>, analytics: (
      { __typename: 'ClientSideAnalytics' }
      & ClientSideAnalyticsUpsellFragment
    ) }> };

export type FlightsCreditSelectorOpenActionUpsellFragment = { __typename: 'FlightsCreditSelectorOpenAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

export type ClientSideAnalyticsUpsellFragment = { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> };

export type EgdsFullScreenDialogFragmentUpsellFragment = { __typename: 'EGDSFullScreenDialog', toolbar: { __typename: 'EGDSDialogToolbar', title: string, closeText?: Maybe<string> } };

export type FlightsResourceLinkActionUpsellFragment = { __typename: 'FlightsResourceLinkAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )>, resource: { __typename: 'GeoURI' } | (
    { __typename: 'HttpURI' }
    & HttpUriFragment
  ) | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } };

export type FlightsClickActionUpsellFragmentFragment = { __typename: 'FlightsClickAction', accessibility?: Maybe<string>, analyticsList: Array<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsUpsellFragment
  )> };

export type EgdsSpannableTextFragmentUpsellFragment = { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> } | { __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', id: string, size?: Maybe<IconSize> } } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string, style: EgdsParagraphStyle } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } } | { __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, stylizedSize?: Maybe<string> } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<(
    { __typename: 'EGDSGraphicText' }
    & EgdsGraphicTextFragmentUpsellFragment
  ) | { __typename: 'EGDSHeading', text: string, headingType?: Maybe<EgdsHeadingStyle> } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: Maybe<string>, target: UiLinkTarget, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } } | { __typename: 'EGDSStylizedText', decorative?: Maybe<EgdsDecorativeText>, text: string, theme?: Maybe<TextTheme>, weight?: Maybe<TextWeight>, stylizedSize?: Maybe<string> }> };

export type EgdsGraphicTextFragmentUpsellFragment = { __typename: 'EGDSGraphicText', text: string, textGraphic: (
    { __typename: 'Icon' }
    & UiGraphicFragmentUpsell_Icon_Fragment
  ) | (
    { __typename: 'Illustration' }
    & UiGraphicFragmentUpsell_Illustration_Fragment
  ) | (
    { __typename: 'Mark' }
    & UiGraphicFragmentUpsell_Mark_Fragment
  ) };

type UiGraphicFragmentUpsell_Icon_Fragment = (
  { __typename: 'Icon' }
  & IconSearchUpsellFragment
);

type UiGraphicFragmentUpsell_Illustration_Fragment = (
  { __typename: 'Illustration' }
  & EgdsGraphicIllustrationFragmentFragment
);

type UiGraphicFragmentUpsell_Mark_Fragment = (
  { __typename: 'Mark' }
  & MarkFragmentsFragment
);

export type UiGraphicFragmentUpsellFragment = UiGraphicFragmentUpsell_Icon_Fragment | UiGraphicFragmentUpsell_Illustration_Fragment | UiGraphicFragmentUpsell_Mark_Fragment;

export type SelectPackageMutationVariables = Exact<{
  context: ContextInput;
  packageOfferId: Scalars['String'];
  sessionId: Scalars['String'];
}>;


export type SelectPackageMutation = { __typename: 'Mutation', multiItemShopping: { __typename: 'MultiItemSessionMutations', selectPackage: { __typename: 'MultiItemSearchContextCreatedResponse', redirectUrl?: Maybe<any>, action: { __typename: 'CarSearchMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'CheckoutMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'DetailsMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'FlightSearchMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'HomeMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'NoMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'PackageDetailsMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'PropertyDetailsMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'PropertySearchMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'RetryMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'SelectPackageMultiItemShoppingAction', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } } | { __typename: 'MultiItemSearchContextErrorResponse', message?: Maybe<string> } } };

export type SelectProductsMutationVariables = Exact<{
  context: ContextInput;
  sessionId: Scalars['String'];
  priceToken?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<PropertyNaturalKeyInput> | PropertyNaturalKeyInput>;
  flights?: Maybe<Array<FlightNaturalKeyInput> | FlightNaturalKeyInput>;
  cars?: Maybe<Array<CarNaturalKeyInput> | CarNaturalKeyInput>;
}>;


export type SelectProductsMutation = { __typename: 'Mutation', multiItemShopping: { __typename: 'MultiItemSessionMutations', selectProducts: { __typename: 'MultiItemSearchContextCreatedResponse', redirectUrl?: Maybe<any>, shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'MultiItemSearchContextErrorResponse', message?: Maybe<string> } } };

export type VirtualAgentFlightCheckoutMutationVariables = Exact<{
  context: ContextInput;
  flightsDetailsCriteria: FlightsDetailCriteriaInput;
  virtualAgentContext: VirtualAgentContextInput;
}>;


export type VirtualAgentFlightCheckoutMutation = { __typename: 'Mutation', virtualAgentFlightCheckout: { __typename: 'VirtualAgentCheckoutResponse', status: VirtualAgentCheckoutStatus } };

type DiscriminateUnion<T, U> = T extends U ? T : never;

export namespace FlightsFlexibleSearch {
  export type Variables = FlightsFlexibleSearchQueryVariables;
  export type Query = FlightsFlexibleSearchQuery;
  export type FlightsSearch = (NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>);
  export type FlexibleSearchResponse = (NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>);
  export type DismissGridAccessibility = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['dismissGridAccessibility']>);
  export type Analytics = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['analytics']>);
  export type DepartureLegend = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['departureLegend']>);
  export type Icon = (NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['departureLegend']>)['icon']>);
  export type ResultsGrid = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['resultsGrid']>);
  export type Results = NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['resultsGrid']>)['results']>)[number]>[number]>;
  export type CoverageAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['coverageAnalytics']>);
  export type CoverageNotValidAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['coverageNotValidAnalytics']>);
  export type GridTrigger = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['gridTrigger']>);
  export type CollapseAnalytics = (NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['gridTrigger']>)['collapseAnalytics']>);
  export type ExpandAnalytics = (NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsFlexibleSearchQuery['flightsSearch']>)['flexibleSearchResponse']>)['gridTrigger']>)['expandAnalytics']>);
}

export namespace FlightsFlexSearchResults {
  export type Fragment = FlightsFlexSearchResultsFragment;
  export type Accessibility = (NonNullable<FlightsFlexSearchResultsFragment['accessibility']>);
  export type NextSearchCriteria = (NonNullable<FlightsFlexSearchResultsFragment['nextSearchCriteria']>);
  export type SelectAnalytics = (NonNullable<FlightsFlexSearchResultsFragment['selectAnalytics']>);
}

export namespace FlightsNextJourneyCriteriaValues {
  export type Fragment = FlightsNextJourneyCriteriaValuesFragment;
  export type JourneyCriteria = NonNullable<(NonNullable<FlightsNextJourneyCriteriaValuesFragment['journeyCriteria']>)[number]>;
  export type DepartureDate = (NonNullable<NonNullable<(NonNullable<FlightsNextJourneyCriteriaValuesFragment['journeyCriteria']>)[number]>['departureDate']>);
  export type SearchPreferences = (NonNullable<FlightsNextJourneyCriteriaValuesFragment['searchPreferences']>);
}

export namespace FlightsFlexSearchLegendCell {
  export type Fragment = FlightsFlexSearchLegendCellFragment;
  export type AccessibilityMessage = (NonNullable<FlightsFlexSearchLegendCellFragment['accessibilityMessage']>);
  export type Icon = (NonNullable<FlightsFlexSearchLegendCellFragment['icon']>);
}

export namespace FlightsFlexSearchHeaderCell {
  export type Fragment = FlightsFlexSearchHeaderCellFragment;
}

export namespace FlightsAnalytics {
  export type Fragment = FlightsAnalyticsFragment;
}

export namespace FlightsFlexibleDiscoverySearch {
  export type Variables = FlightsFlexibleDiscoverySearchQueryVariables;
  export type Query = FlightsFlexibleDiscoverySearchQuery;
  export type FlexibleSearch = (NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>);
  export type DismissGridAccessibility = (NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['dismissGridAccessibility']>);
  export type Analytics = (NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['analytics']>);
  export type DepartureLegend = (NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['departureLegend']>);
  export type Icon = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['departureLegend']>)['icon']>);
  export type ResultsGrid = (NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['resultsGrid']>);
  export type Results = NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['resultsGrid']>)['results']>)[number]>[number]>;
  export type CoverageAnalytics = (NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['coverageAnalytics']>);
  export type CoverageNotValidAnalytics = (NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['coverageNotValidAnalytics']>);
  export type GridTrigger = (NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['gridTrigger']>);
  export type CollapseAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['gridTrigger']>)['collapseAnalytics']>);
  export type ExpandAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsFlexibleDiscoverySearchQuery['flexibleSearch']>)['gridTrigger']>)['expandAnalytics']>);
}

export namespace FlightsFlexSearchHeaderDiscoveryCell {
  export type Fragment = FlightsFlexSearchHeaderDiscoveryCellFragment;
}

export namespace FlightsFlexSearchLegendDiscoveryCell {
  export type Fragment = FlightsFlexSearchLegendDiscoveryCellFragment;
  export type AccessibilityMessage = (NonNullable<FlightsFlexSearchLegendDiscoveryCellFragment['accessibilityMessage']>);
  export type Icon = (NonNullable<FlightsFlexSearchLegendDiscoveryCellFragment['icon']>);
}

export namespace FlightsFlexSearchResultCell {
  export type Fragment = FlightsFlexSearchResultCellFragment;
  export type NextSearchCriteria = (NonNullable<FlightsFlexSearchResultCellFragment['nextSearchCriteria']>);
  export type Accessibility = (NonNullable<FlightsFlexSearchResultCellFragment['accessibility']>);
  export type SelectAnalytics = (NonNullable<FlightsFlexSearchResultCellFragment['selectAnalytics']>);
}

export namespace FlightsShoppingPwaFlightInformationResults {
  export type Variables = FlightsShoppingPwaFlightInformationResultsQueryVariables;
  export type Query = FlightsShoppingPwaFlightInformationResultsQuery;
  export type FlightsDetail = (NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>);
  export type Analytics = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['analytics']>);
  export type FooterOnViewedAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['analytics']>)['footerOnViewedAnalytics']>);
  export type OnLoadAnalyticsList = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['analytics']>)['onLoadAnalyticsList']>)[number]>;
  export type ClientMetadata = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['clientMetadata']>);
  export type FlightsPwaMetadataInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>);
  export type PageNameAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>)['pageNameAnalytics']>);
  export type FlightsOpinionLab = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsOpinionLab']>);
  export type FlightsActionAndLabelInlineFragment = ({ __typename: 'FlightsActionAndLabel' } & Pick<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsOpinionLab']>), 'label' | 'selectAction'>);
  export type SelectAction = (NonNullable<({ __typename: 'FlightsActionAndLabel' } & Pick<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsOpinionLab']>), 'label' | 'selectAction'>)['selectAction']>);
  export type PageTitle = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['pageTitle']>);
  export type FlightsPageTitleInlineFragment = ({ __typename: 'FlightsPageTitle' } & Pick<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['pageTitle']>), 'title' | 'pageAccessibility'>);
  export type Title = (NonNullable<({ __typename: 'FlightsPageTitle' } & Pick<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['pageTitle']>), 'title' | 'pageAccessibility'>)['title']>);
  export type MessagingCards = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['messagingCards']>)[number]>;
  export type PartnerLoyaltyEarnMessage = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['partnerLoyaltyEarnMessage']>);
  export type Banners = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['banners']>)[number]>;
  export type FreeCancellation = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['freeCancellation']>);
  export type FlightsSelectedJourneyReview = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>;
  export type LoadedFlightsSelectedJourneyReviewInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>);
  export type FlightsJourneyInformation = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>);
  export type Details = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['details']>);
  export type FlightJourneyDetails = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>);
  export type JourneySections = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>;
  export type JourneyConnectionInformation = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>;
  export type AdditionalInformationInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>);
  export type NextFlightOriginAirportInfo = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>)['nextFlightOriginAirportInfo']>);
  export type Icon = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>)['nextFlightOriginAirportInfo']>)['icon']>);
  export type FlightsConnectionInformationInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>);
  export type FlightsConnection = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>);
  export type ConnectionArrival = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['connectionArrival']>);
  export type ConnectionDeparture = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['connectionDeparture']>);
  export type JourneyAmenities = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['journeyAmenities']>);
  export type _JourneyAmenities = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeyAmenities']>)[number]>;
  export type _Icon = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeyAmenities']>)[number]>['icon']>);
  export type DisplayAnalytics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyInformation']>)['flightJourneyDetails']>)['journeyAmenities']>)[number]>['displayAnalytics']>)[number]>;
  export type FlightsJourneyHeaders = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyHeaders']>);
  export type FlightsJourneySummary = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>);
  export type Heading = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>)['heading']>);
  export type DifferentDayArrival = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>)['differentDayArrival']>);
  export type BasicFlightDetails = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>)['basicFlightDetails']>)[number]>;
  export type FlightsBargainJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>);
  export type LoadedFlightsStandardJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>), { __typename: 'LoadedFlightsStandardJourneySummary' }>);
  export type __JourneyAmenities = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>), { __typename: 'LoadedFlightsStandardJourneySummary' }>)['journeyAmenities']>);
  export type JourneyHighlights = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>;
  export type _FlightsJourneyHeaders = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneyHeaders']>);
  export type _FlightsJourneySummary = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>);
  export type _Heading = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>)['heading']>);
  export type _DifferentDayArrival = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>)['differentDayArrival']>);
  export type _BasicFlightDetails = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>)['basicFlightDetails']>)[number]>;
  export type _FlightsBargainJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>);
  export type OnViewedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['onViewedAnalytics']>);
  export type ChangeFlight = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['changeFlight']>);
  export type ChangeFlightDialog = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['changeFlightDialog']>);
  export type Actions = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['changeFlightDialog']>)['actions']>)[number]>;
  export type _Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['changeFlightDialog']>)['actions']>)[number]>['analytics']>);
  export type AnalyticsList = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['changeFlightDialog']>)['actions']>)[number]>['analyticsList']>)[number]>;
  export type DisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['changeFlightDialog']>)['displayedAnalytics']>);
  export type FareDetails = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>);
  export type FareSummary = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>)['fareSummary']>);
  export type FlightsSelectedJourneyAvailableFaresInformation = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>)['fareSummary']>)['flightsSelectedJourneyAvailableFaresInformation']>);
  export type _Details = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>)['fareSummary']>)['details']>);
  export type FlightsFareNudgeMessage = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>)['fareSummary']>)['flightsFareNudgeMessage']>);
  export type DefaultBaggageInformation = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>)['defaultBaggageInformation']>);
  export type FareSeatMapInformation = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>)['fareSeatMapInformation']>);
  export type ChangeAndCancellationFees = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>)['changeAndCancellationFees']>);
  export type FlightsJourneyPolicies = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['flightsJourneyPolicies']>);
  export type JourneyInformation = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['journeyInformation']>);
  export type PriceSummary = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['priceSummary']>);
  export type SeparateTicketBanner = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['separateTicketBanner']>);
  export type ServerErrorMessaging = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['serverErrorMessaging']>);
  export type DynamicElementsGroups = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>;
  export type DynamicElements = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>);
  export type FlightsJourneyDetailsDynamicElements = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>;
  export type JourneyPartsDynamicElements = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['journeyPartsDynamicElements']>)[number]>;
  export type FareSeatMapDynamicElement = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['fareSeatMapDynamicElement']>);
  export type OnSelectAnalytics = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['fareSeatMapDynamicElement']>)['onSelectAnalytics']>)[number]>;
  export type FlightLegsDetails = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['fareSeatMapDynamicElement']>)['flightLegsDetails']>);
  export type SelectedSeatDetails = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['selectedSeatDetails']>)[number]>;
  export type __Details = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['details']>);
  export type _FlightsFareNudgeMessage = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['flightsFareNudgeMessage']>);
  export type FareChangeAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['fareChangeAction']>);
  export type DynamicElementsGroupTrackEventAnalytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['dynamicElementsGroupTrackEventAnalytics']>);
  export type _AnalyticsList = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['dynamicElementsGroupTrackEventAnalytics']>)['analyticsList']>)[number]>;
  export type FlightsInformationDynamicElementsInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>), { __typename: 'FlightsInformationDynamicElements' }>);
  export type _PriceSummary = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>), { __typename: 'FlightsInformationDynamicElements' }>)['priceSummary']>);
  export type FareChoiceInformationDynamicElement = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>), { __typename: 'FlightsInformationDynamicElements' }>)['fareChoiceInformationDynamicElement']>);
  export type MultiItemDynamicCrossSellPrimer = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['multiItemDynamicCrossSellPrimer']>);
  export type MultiItemSearchContext = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['multiItemDynamicCrossSellPrimer']>)['multiItemSearchContext']>);
  export type MultiItemSelectedFlightProducts = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['multiItemDynamicCrossSellPrimer']>)['multiItemSelectedFlightProducts']>);
  export type FlightsInformationPriceMatchPromise = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsInformationPriceMatchPromise']>);
  export type Card = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsQuery['flightsDetail']>)['flightsInformationPriceMatchPromise']>)['card']>);
}

export namespace FlightsJourneyHeaders {
  export type Fragment = FlightsJourneyHeadersFragment;
  export type FlightsJourneySubheadingMark = (NonNullable<FlightsJourneyHeadersFragment['flightsJourneySubheadingMark']>);
  export type Url = (NonNullable<(NonNullable<FlightsJourneyHeadersFragment['flightsJourneySubheadingMark']>)['url']>);
}

export namespace FlightsChangeAndCancellationFees {
  export type Fragment = FlightsChangeAndCancellationFeesFragment;
  export type ChangeAndCancellationDetails = NonNullable<(NonNullable<FlightsChangeAndCancellationFeesFragment['changeAndCancellationDetails']>)[number]>;
  export type DisplayAnalytics = NonNullable<(NonNullable<FlightsChangeAndCancellationFeesFragment['displayAnalytics']>)[number]>;
}

export namespace FlightsLabelAndValue {
  export type Fragment = FlightsLabelAndValueFragment;
}

export namespace FareSeatMapInformation {
  export type Fragment = FareSeatMapInformationFragment;
  export type Details = (NonNullable<FareSeatMapInformationFragment['details']>);
  export type FareSeatMapViewDetails = (NonNullable<FareSeatMapInformationFragment['fareSeatMapViewDetails']>);
  export type SelectedSeatDetails = NonNullable<(NonNullable<FareSeatMapInformationFragment['selectedSeatDetails']>)[number]>;
  export type ErrorMessages = NonNullable<(NonNullable<FareSeatMapInformationFragment['errorMessages']>)[number]>;
}

export namespace FlightsSeatSelectionErrorMessage {
  export type Fragment = FlightsSeatSelectionErrorMessageFragment;
  export type Analytics = NonNullable<(NonNullable<FlightsSeatSelectionErrorMessageFragment['analytics']>)[number]>;
}

export namespace FlightsSelectedSeatDetail {
  export type Fragment = FlightsSelectedSeatDetailFragment;
}

export namespace FareSeatMapViewDetails {
  export type Fragment = FareSeatMapViewDetailsFragment;
  export type DismissSeatMapDialog = (NonNullable<FareSeatMapViewDetailsFragment['dismissSeatMapDialog']>);
  export type ErrorMessage = (NonNullable<FareSeatMapViewDetailsFragment['errorMessage']>);
  export type FareSeatMapLegendsInformation = (NonNullable<FareSeatMapViewDetailsFragment['fareSeatMapLegendsInformation']>);
  export type FlightLegsDetails = (NonNullable<FareSeatMapViewDetailsFragment['flightLegsDetails']>);
  export type SeatMapAlertDialog = NonNullable<(NonNullable<FareSeatMapViewDetailsFragment['seatMapAlertDialog']>)[number]>;
  export type SeatMapDialogAnalyticsList = NonNullable<(NonNullable<FareSeatMapViewDetailsFragment['seatMapDialogAnalyticsList']>)[number]>;
}

export namespace FareSeatMapAlertDialog {
  export type Fragment = FareSeatMapAlertDialogFragment;
  export type Alert = (NonNullable<FareSeatMapAlertDialogFragment['alert']>);
  export type Actions = NonNullable<(NonNullable<(NonNullable<FareSeatMapAlertDialogFragment['alert']>)['actions']>)[number]>;
  export type DisplayedAnalytics = (NonNullable<(NonNullable<FareSeatMapAlertDialogFragment['alert']>)['displayedAnalytics']>);
}

export namespace FareSeatMapAvailableFlightLegsDetails {
  export type Fragment = FareSeatMapAvailableFlightLegsDetailsFragment;
  export type FlightLegSelectionList = NonNullable<(NonNullable<FareSeatMapAvailableFlightLegsDetailsFragment['flightLegSelectionList']>)[number]>;
  export type OnViewedAnalytics = NonNullable<(NonNullable<FareSeatMapAvailableFlightLegsDetailsFragment['onViewedAnalytics']>)[number]>;
}

export namespace FareSeatMapAvailableFlightLegSelection {
  export type Fragment = FareSeatMapAvailableFlightLegSelectionFragment;
  export type ErrorAnalytics = (NonNullable<FareSeatMapAvailableFlightLegSelectionFragment['errorAnalytics']>);
  export type SeatMapLegSummary = (NonNullable<FareSeatMapAvailableFlightLegSelectionFragment['seatMapLegSummary']>);
  export type SeatSegment = (NonNullable<FareSeatMapAvailableFlightLegSelectionFragment['seatSegment']>);
  export type SelectedCard = (NonNullable<FareSeatMapAvailableFlightLegSelectionFragment['selectedCard']>);
  export type UnselectedCard = (NonNullable<FareSeatMapAvailableFlightLegSelectionFragment['unselectedCard']>);
}

export namespace FlightsSeatMapTotalDetails {
  export type Fragment = FlightsSeatMapTotalDetailsFragment;
  export type Label = (NonNullable<FlightsSeatMapTotalDetailsFragment['label']>);
  export type SeatsSelectedMessage = (NonNullable<FlightsSeatMapTotalDetailsFragment['seatsSelectedMessage']>);
  export type SelectedSeats = NonNullable<(NonNullable<FlightsSeatMapTotalDetailsFragment['selectedSeats']>)[number]>;
  export type TotalPrice = (NonNullable<FlightsSeatMapTotalDetailsFragment['totalPrice']>);
}

export namespace FlightsResponsiveMessage {
  export type Fragment = FlightsResponsiveMessageFragment;
}

export namespace FlightsSeatMapLegSummaryActionType {
  export type Fragment = FlightsSeatMapLegSummaryActionTypeFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsSeatMapLegSummaryActionTypeFragment['analyticsList']>)[number]>;
}

export namespace FlightsSeatMapLegSummary {
  export type Fragment = FlightsSeatMapLegSummaryFragment;
  export type ButtonAction = (NonNullable<FlightsSeatMapLegSummaryFragment['buttonAction']>);
  export type ButtonActionTypes = NonNullable<(NonNullable<FlightsSeatMapLegSummaryFragment['buttonActionTypes']>)[number]>;
  export type SeatTotalDetails = (NonNullable<FlightsSeatMapLegSummaryFragment['seatTotalDetails']>);
  export type TravelerSummary = (NonNullable<FlightsSeatMapLegSummaryFragment['travelerSummary']>);
  export type Title = (NonNullable<(NonNullable<FlightsSeatMapLegSummaryFragment['travelerSummary']>)['title']>);
  export type Travelers = NonNullable<(NonNullable<(NonNullable<FlightsSeatMapLegSummaryFragment['travelerSummary']>)['travelers']>)[number]>;
  export type Action = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSeatMapLegSummaryFragment['travelerSummary']>)['travelers']>)[number]>['action']>);
  export type FlightsActionAndLabelInlineFragment = ({ __typename: 'FlightsActionAndLabel' } & Pick<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSeatMapLegSummaryFragment['travelerSummary']>)['travelers']>)[number]>['action']>), '__typename' | 'label' | 'selectAction'>);
  export type SelectAction = (NonNullable<({ __typename: 'FlightsActionAndLabel' } & Pick<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSeatMapLegSummaryFragment['travelerSummary']>)['travelers']>)[number]>['action']>), '__typename' | 'label' | 'selectAction'>)['selectAction']>);
  export type SeatDetails = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSeatMapLegSummaryFragment['travelerSummary']>)['travelers']>)[number]>['seatDetails']>);
}

export namespace FlightsSeatMapSeatDetails {
  export type Fragment = FlightsSeatMapSeatDetailsFragment;
  export type Price = (NonNullable<FlightsSeatMapSeatDetailsFragment['price']>);
  export type Selected = (NonNullable<(NonNullable<FlightsSeatMapSeatDetailsFragment['price']>)['selected']>);
}

export namespace FlightsSimpleLocalizationTemplate {
  export type Fragment = FlightsSimpleLocalizationTemplateFragment;
}

export namespace FlightsSeatSegmentLoaded {
  export type Fragment = FlightsSeatSegmentLoadedFragment;
}

export namespace FareSeatMapLegendsInformation {
  export type Fragment = FareSeatMapLegendsInformationFragment;
  export type DismissSeatMapLegends = (NonNullable<FareSeatMapLegendsInformationFragment['dismissSeatMapLegends']>);
  export type LegendDetails = (NonNullable<FareSeatMapLegendsInformationFragment['legendDetails']>);
  export type ViewLegendButton = (NonNullable<FareSeatMapLegendsInformationFragment['viewLegendButton']>);
}

export namespace ClientAnalytics {
  export type Fragment = ClientAnalyticsFragment;
  export type UisPrimeMessages = NonNullable<(NonNullable<ClientAnalyticsFragment['uisPrimeMessages']>)[number]>;
}

export namespace ClientAction {
  export type Fragment = ClientActionFragment;
  export type AnalyticsList = NonNullable<(NonNullable<ClientActionFragment['analyticsList']>)[number]>;
}

export namespace FlightsSeatMapLegends {
  export type Fragment = FlightsSeatMapLegendsFragment;
  export type Close = (NonNullable<FlightsSeatMapLegendsFragment['close']>);
  export type ClientAction = (NonNullable<(NonNullable<FlightsSeatMapLegendsFragment['close']>)['clientAction']>);
  export type Icon = (NonNullable<(NonNullable<FlightsSeatMapLegendsFragment['close']>)['icon']>);
  export type LegendVariants = NonNullable<(NonNullable<FlightsSeatMapLegendsFragment['legendVariants']>)[number]>;
}

export namespace FlightsSeatMapLegendVariant {
  export type Fragment = FlightsSeatMapLegendVariantFragment;
  export type LegendCard = (NonNullable<FlightsSeatMapLegendVariantFragment['legendCard']>);
  export type Icon = (NonNullable<(NonNullable<FlightsSeatMapLegendVariantFragment['legendCard']>)['icon']>);
}

export namespace MultiItemFlightsSearchContext {
  export type Fragment = MultiItemFlightsSearchContextFragment;
  export type Flights = NonNullable<(NonNullable<MultiItemFlightsSearchContextFragment['flights']>)[number]>;
  export type Primary = (NonNullable<NonNullable<(NonNullable<MultiItemFlightsSearchContextFragment['flights']>)[number]>['primary']>);
  export type JourneyCriterias = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemFlightsSearchContextFragment['flights']>)[number]>['primary']>)['journeyCriterias']>)[number]>;
  export type DepartureDate = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemFlightsSearchContextFragment['flights']>)[number]>['primary']>)['journeyCriterias']>)[number]>['departureDate']>);
  export type SearchPreferences = (NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemFlightsSearchContextFragment['flights']>)[number]>['primary']>)['searchPreferences']>);
  export type Travelers = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemFlightsSearchContextFragment['flights']>)[number]>['primary']>)['travelers']>)[number]>;
}

export namespace MultiItemFlightNaturalKey {
  export type Fragment = MultiItemFlightNaturalKeyFragment;
  export type Flights = NonNullable<(NonNullable<MultiItemFlightNaturalKeyFragment['flights']>)[number]>;
  export type Travelers = NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemFlightNaturalKeyFragment['flights']>)[number]>['travelers']>)[number]>;
}

export namespace FlightsInformationJourneyAmenities {
  export type Fragment = FlightsInformationJourneyAmenitiesFragment;
  export type Amenities = NonNullable<(NonNullable<FlightsInformationJourneyAmenitiesFragment['amenities']>)[number]>;
  export type Analytics = (NonNullable<FlightsInformationJourneyAmenitiesFragment['analytics']>);
}

export namespace FlightsSelectedJourneyAvailableFares {
  export type Fragment = FlightsSelectedJourneyAvailableFaresFragment;
  export type FareChoiceInformation = (NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>);
  export type Heading = (NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['heading']>);
  export type DisplayAnalytics = (NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['displayAnalytics']>);
  export type ScrollAnalytics = (NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['scrollAnalytics']>);
  export type ErrorAnalytics = NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['errorAnalytics']>)[number]>;
  export type ConvertAnalytics = NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['convertAnalytics']>)[number]>;
  export type Fares = NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>;
  export type ChooseFareAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['chooseFareAction']>);
  export type LoyaltyPointsOption = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['loyaltyPointsOption']>);
  export type FormattedPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['formattedPrice']>);
  export type Items = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['formattedPrice']>)['items']>)[number]>;
  export type ClickEventAnalytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['clickEventAnalytics']>);
  export type FareScrollAnalytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['fareScrollAnalytics']>);
  export type CollapsedRules = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['collapsedRules']>);
  export type ExpandedRules = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['expandedRules']>)[number]>;
  export type Rules = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['expandedRules']>)[number]>['rules']>);
  export type AmenityHierarchyRules = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityHierarchyRules']>)[number]>;
  export type _Rules = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityHierarchyRules']>)[number]>['rules']>);
  export type BaggageFeesInformation = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>);
  export type ShowMoreAmenitiesToggle = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['showMoreAmenitiesToggle']>);
  export type SelectFareAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['selectFareAction']>);
  export type Recommendation = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['recommendation']>);
  export type AmenityRules = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>);
  export type Amenities = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>)['amenities']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>)['amenities']>)[number]>['icon']>);
  export type _DisplayAnalytics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>)['amenities']>)[number]>['displayAnalytics']>)[number]>;
  export type Badges = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['badges']>)[number]>;
  export type PriceLockup = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['priceLockup']>);
  export type FlightsPmpJourneyFareInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>);
  export type PriceLockupWithPmp = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>)['priceLockupWithPMP']>);
  export type SelectFareActionWithPmp = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>)['selectFareActionWithPMP']>);
  export type PriceMatchPromiseSelectionCardSection = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>)['priceMatchPromiseSelectionCardSection']>);
  export type PriceMatchPromiseSelectedCardSection = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>)['priceMatchPromiseSelectedCardSection']>);
  export type DefaultBaggageInformation = (NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['defaultBaggageInformation']>);
  export type SustainabilityInformation = (NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['sustainabilityInformation']>);
  export type Dialogs = NonNullable<(NonNullable<(NonNullable<FlightsSelectedJourneyAvailableFaresFragment['fareChoiceInformation']>)['dialogs']>)[number]>;
  export type DismissDetailedJourneyInformation = (NonNullable<FlightsSelectedJourneyAvailableFaresFragment['dismissDetailedJourneyInformation']>);
  export type FlightsJourneyHeaders = (NonNullable<FlightsSelectedJourneyAvailableFaresFragment['flightsJourneyHeaders']>);
}

export namespace FlightsLoadedPriceSummary {
  export type Fragment = FlightsLoadedPriceSummaryFragment;
  export type BookWithAirlinesDialog = (NonNullable<FlightsLoadedPriceSummaryFragment['bookWithAirlinesDialog']>);
  export type Breakdown = NonNullable<(NonNullable<FlightsLoadedPriceSummaryFragment['breakdown']>)[number]>;
  export type ButtonAction = (NonNullable<FlightsLoadedPriceSummaryFragment['buttonAction']>);
  export type Dismiss = (NonNullable<FlightsLoadedPriceSummaryFragment['dismiss']>);
  export type Policies = (NonNullable<FlightsLoadedPriceSummaryFragment['policies']>);
  export type Totals = NonNullable<(NonNullable<FlightsLoadedPriceSummaryFragment['totals']>)[number]>;
  export type TripTotalDetails = (NonNullable<FlightsLoadedPriceSummaryFragment['tripTotalDetails']>);
  export type ViewPriceSummary = (NonNullable<FlightsLoadedPriceSummaryFragment['viewPriceSummary']>);
  export type CreditShoppingRedirectAction = (NonNullable<FlightsLoadedPriceSummaryFragment['creditShoppingRedirectAction']>);
  export type UrgencyMessage = (NonNullable<FlightsLoadedPriceSummaryFragment['urgencyMessage']>);
  export type DisplayAnalytics = NonNullable<(NonNullable<FlightsLoadedPriceSummaryFragment['displayAnalytics']>)[number]>;
}

export namespace EgdsBadgeFragment {
  export type Fragment = EgdsBadgeFragmentFragment;
}

export namespace FlightsInformationServerErrorMessaging {
  export type Fragment = FlightsInformationServerErrorMessagingFragment;
  export type Action = (NonNullable<FlightsInformationServerErrorMessagingFragment['action']>);
  export type Icon = (NonNullable<FlightsInformationServerErrorMessagingFragment['icon']>);
}

export namespace FlightsMessageAndAccessibilityInformationLoaded {
  export type Fragment = FlightsMessageAndAccessibilityInformationLoadedFragment;
}

export namespace FlightsLoyaltyPointsOption {
  export type Fragment = FlightsLoyaltyPointsOptionFragment;
}

export namespace FlightsToggleInformationLoaded {
  export type Fragment = FlightsToggleInformationLoadedFragment;
  export type CollapseActionable = (NonNullable<FlightsToggleInformationLoadedFragment['collapseActionable']>);
  export type ExpandActionable = (NonNullable<FlightsToggleInformationLoadedFragment['expandActionable']>);
}

export namespace IconInformationLoaded {
  export type Fragment = IconInformationLoadedFragment;
}

export namespace TogglePhaseInformationLoaded {
  export type Fragment = TogglePhaseInformationLoadedFragment;
  export type Analytics = (NonNullable<TogglePhaseInformationLoadedFragment['analytics']>);
  export type Icon = (NonNullable<TogglePhaseInformationLoadedFragment['icon']>);
}

export namespace CoordinateInformationInformationLoaded {
  export type Fragment = CoordinateInformationInformationLoadedFragment;
  export type Icon = (NonNullable<CoordinateInformationInformationLoadedFragment['icon']>);
  export type FlightDetailsWarningInfo = (NonNullable<CoordinateInformationInformationLoadedFragment['flightDetailsWarningInfo']>);
  export type _Icon = (NonNullable<(NonNullable<CoordinateInformationInformationLoadedFragment['flightDetailsWarningInfo']>)['icon']>);
  export type TitleAndAccessibilityMessage = (NonNullable<CoordinateInformationInformationLoadedFragment['titleAndAccessibilityMessage']>);
}

export namespace FlightsMarkPlacard {
  export type Fragment = FlightsMarkPlacardFragment;
  export type Mark = (NonNullable<FlightsMarkPlacardFragment['mark']>);
  export type StylisedText = (NonNullable<FlightsMarkPlacardFragment['stylisedText']>);
  export type OnViewedAnalytics = (NonNullable<FlightsMarkPlacardFragment['onViewedAnalytics']>);
}

export namespace FlightsMarkPlacardInformationLoaded {
  export type Fragment = FlightsMarkPlacardInformationLoadedFragment;
  export type Mark = (NonNullable<FlightsMarkPlacardInformationLoadedFragment['mark']>);
  export type Actions = NonNullable<(NonNullable<FlightsMarkPlacardInformationLoadedFragment['actions']>)[number]>;
  export type OnViewedAnalytics = (NonNullable<FlightsMarkPlacardInformationLoadedFragment['onViewedAnalytics']>);
}

export namespace FlightsImagePlacardInformationLoaded {
  export type Fragment = FlightsImagePlacardInformationLoadedFragment;
  export type Image = (NonNullable<FlightsImagePlacardInformationLoadedFragment['image']>);
  export type Actions = NonNullable<(NonNullable<FlightsImagePlacardInformationLoadedFragment['actions']>)[number]>;
  export type OnViewedAnalytics = (NonNullable<FlightsImagePlacardInformationLoadedFragment['onViewedAnalytics']>);
}

export namespace FlightsIconPlacardInformationLoaded {
  export type Fragment = FlightsIconPlacardInformationLoadedFragment;
  export type Icon = (NonNullable<FlightsIconPlacardInformationLoadedFragment['icon']>);
  export type Actions = NonNullable<(NonNullable<FlightsIconPlacardInformationLoadedFragment['actions']>)[number]>;
  export type OnViewedAnalytics = (NonNullable<FlightsIconPlacardInformationLoadedFragment['onViewedAnalytics']>);
}

export namespace EgdsSpannableTextFragmentInformation {
  export type Fragment = EgdsSpannableTextFragmentInformationFragment;
  export type Contents = NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>;
  export type EgdsHeadingInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSHeading' }>);
  export type EgdsParagraphInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSParagraph' }>);
  export type EgdsIconTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSIconText' }>)['icon']>);
  export type EgdsStandardLinkInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>);
  export type Action = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type Resource = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type EgdsPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type EgdsStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['contents']>)[number]>, { __typename: 'EGDSStylizedText' }>);
  export type InlineContent = NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>;
  export type _EgdsHeadingInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>, { __typename: 'EGDSHeading' }>);
  export type EgdsGraphicTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>, { __typename: 'EGDSGraphicText' }>);
  export type _EgdsStandardLinkInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>);
  export type _Action = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type _Resource = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type _Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type _EgdsPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type _EgdsStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentInformationFragment['inlineContent']>)[number]>, { __typename: 'EGDSStylizedText' }>);
}

export namespace MarkFragments {
  export type Fragment = MarkFragmentsFragment;
  export type Url = (NonNullable<MarkFragmentsFragment['url']>);
  export type HttpUriInlineFragment = ({ __typename: 'HttpURI' } & Pick<(NonNullable<MarkFragmentsFragment['url']>), '__typename' | 'relativePath' | 'value'>);
}

export namespace FlightsActionInformationLoaded {
  export type Fragment = FlightsActionInformationLoadedFragment;
  export type Analytics = (NonNullable<FlightsActionInformationLoadedFragment['analytics']>);
  export type AnalyticsList = NonNullable<(NonNullable<FlightsActionInformationLoadedFragment['analyticsList']>)[number]>;
  export type RelativePackageableUri = (NonNullable<FlightsActionInformationLoadedFragment['relativePackageableURI']>);
  export type RelativeUri = (NonNullable<FlightsActionInformationLoadedFragment['relativeURI']>);
  export type DisplayAnalytics = (NonNullable<FlightsActionInformationLoadedFragment['displayAnalytics']>);
}

export namespace FlightsPriceSummaryGroupLoaded {
  export type Fragment = FlightsPriceSummaryGroupLoadedFragment;
  export type Entries = NonNullable<(NonNullable<FlightsPriceSummaryGroupLoadedFragment['entries']>)[number]>;
  export type Title = (NonNullable<FlightsPriceSummaryGroupLoadedFragment['title']>);
}

export namespace FlightsPriceSummaryItemDetailsLoaded {
  export type Fragment = FlightsPriceSummaryItemDetailsLoadedFragment;
  export type Action = (NonNullable<FlightsPriceSummaryItemDetailsLoadedFragment['action']>);
  export type Breakdown = (NonNullable<FlightsPriceSummaryItemDetailsLoadedFragment['breakdown']>);
}

export namespace FlightsPriceSummaryItemGroupLoaded {
  export type Fragment = FlightsPriceSummaryItemGroupLoadedFragment;
  export type Entries = NonNullable<(NonNullable<FlightsPriceSummaryItemGroupLoadedFragment['entries']>)[number]>;
  export type FlightsPriceSummaryItemInlineFragment = ({ __typename: 'FlightsPriceSummaryItem' } & Pick<NonNullable<(NonNullable<FlightsPriceSummaryItemGroupLoadedFragment['entries']>)[number]>, 'label' | 'price'>);
  export type Error = (NonNullable<FlightsPriceSummaryItemGroupLoadedFragment['error']>);
  export type Action = (NonNullable<FlightsPriceSummaryItemGroupLoadedFragment['action']>);
}

export namespace FlightsPriceSummaryItemErrorLoaded {
  export type Fragment = FlightsPriceSummaryItemErrorLoadedFragment;
  export type Analytics = (NonNullable<FlightsPriceSummaryItemErrorLoadedFragment['analytics']>);
}

export namespace FlightsPriceSummaryLoadedItem {
  export type Fragment = FlightsPriceSummaryLoadedItemFragment;
  export type Details = (NonNullable<FlightsPriceSummaryLoadedItemFragment['details']>);
}

export namespace FlightsActionableInformationIconLoaded {
  export type Fragment = FlightsActionableInformationIconLoadedFragment;
  export type Analytics = (NonNullable<FlightsActionableInformationIconLoadedFragment['analytics']>);
  export type Icon = (NonNullable<FlightsActionableInformationIconLoadedFragment['icon']>);
}

export namespace FlightsInformationTextSectionLoaded {
  export type Fragment = FlightsInformationTextSectionLoadedFragment;
  export type DisplayAction = (NonNullable<FlightsInformationTextSectionLoadedFragment['displayAction']>);
  export type Messages = NonNullable<(NonNullable<FlightsInformationTextSectionLoadedFragment['messages']>)[number]>;
  export type OnViewedAnalytics = (NonNullable<FlightsInformationTextSectionLoadedFragment['onViewedAnalytics']>);
  export type DisplayAnalytics = (NonNullable<FlightsInformationTextSectionLoadedFragment['displayAnalytics']>);
  export type DisplayAnalyticsList = NonNullable<(NonNullable<FlightsInformationTextSectionLoadedFragment['displayAnalyticsList']>)[number]>;
}

export namespace FlightsInformationLoadedPhrase {
  export type Fragment = FlightsInformationLoadedPhraseFragment;
  export type Items = NonNullable<(NonNullable<FlightsInformationLoadedPhraseFragment['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsInformationLoadedPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsInformationLoadedPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type DisplayAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsInformationLoadedPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['displayAnalytics']>);
  export type ScrollAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsInformationLoadedPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['scrollAnalytics']>);
}

export namespace FlightsLoadedPriceSummaryTripTotalItem {
  export type Fragment = FlightsLoadedPriceSummaryTripTotalItemFragment;
  export type Messages = NonNullable<(NonNullable<FlightsLoadedPriceSummaryTripTotalItemFragment['messages']>)[number]>;
  export type _Messages = NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsLoadedPriceSummaryTripTotalItemFragment['messages']>)[number]>['messages']>)[number]>;
  export type TripTotal = (NonNullable<FlightsLoadedPriceSummaryTripTotalItemFragment['tripTotal']>);
}

export namespace FlightsBaggageInformation {
  export type Fragment = FlightsBaggageInformationFragment;
  export type BagFeesMoreInfo = NonNullable<(NonNullable<FlightsBaggageInformationFragment['bagFeesMoreInfo']>)[number]>;
  export type DisplayAnalytics = (NonNullable<FlightsBaggageInformationFragment['displayAnalytics']>);
  export type Details = NonNullable<(NonNullable<FlightsBaggageInformationFragment['details']>)[number]>;
  export type DisplayAnalyticsItems = NonNullable<(NonNullable<FlightsBaggageInformationFragment['displayAnalyticsItems']>)[number]>;
}

export namespace FlightsBaggageInformationDetail {
  export type Fragment = FlightsBaggageInformationDetailFragment;
}

export namespace JourneyInformation {
  export type Fragment = JourneyInformationFragment;
}

export namespace FlightsDialogPresentation {
  export type Fragment = FlightsDialogPresentationFragment;
  export type Actions = NonNullable<(NonNullable<FlightsDialogPresentationFragment['actions']>)[number]>;
  export type AnalyticsList = NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsDialogPresentationFragment['actions']>)[number]>['analyticsList']>)[number]>;
  export type RelativeUri = (NonNullable<NonNullable<(NonNullable<FlightsDialogPresentationFragment['actions']>)[number]>['relativeURI']>);
  export type DisplayedAnalytics = (NonNullable<FlightsDialogPresentationFragment['displayedAnalytics']>);
}

export namespace FlightsIconLoadedPhrases {
  export type Fragment = FlightsIconLoadedPhrasesFragment;
  export type Text = NonNullable<(NonNullable<FlightsIconLoadedPhrasesFragment['text']>)[number]>;
  export type Icon = (NonNullable<FlightsIconLoadedPhrasesFragment['icon']>);
}

export namespace FlightsIconAndLabelLoaded {
  export type Fragment = FlightsIconAndLabelLoadedFragment;
  export type Icon = (NonNullable<FlightsIconAndLabelLoadedFragment['icon']>);
  export type DisplayAnalytics = NonNullable<(NonNullable<FlightsIconAndLabelLoadedFragment['displayAnalytics']>)[number]>;
  export type SubText = (NonNullable<FlightsIconAndLabelLoadedFragment['subText']>);
  export type EgdsStylizedTextInlineFragment = ({ __typename: 'EGDSStylizedText' } & Pick<(NonNullable<FlightsIconAndLabelLoadedFragment['subText']>), 'decorative' | 'text' | 'theme' | 'weight' | 'size'>);
}

export namespace FlightsMessagingCardFisPlacardFragment {
  export type Fragment = FlightsMessagingCardFisPlacardFragmentFragment;
  export type MessagingCard = (NonNullable<FlightsMessagingCardFisPlacardFragmentFragment['messagingCard']>);
  export type Graphic = (NonNullable<(NonNullable<FlightsMessagingCardFisPlacardFragmentFragment['messagingCard']>)['graphic']>);
  export type Button = (NonNullable<FlightsMessagingCardFisPlacardFragmentFragment['button']>);
  export type OnViewedAnalytics = (NonNullable<FlightsMessagingCardFisPlacardFragmentFragment['onViewedAnalytics']>);
}

export namespace FlightsDialogTriggerActionFis {
  export type Fragment = FlightsDialogTriggerActionFisFragment;
  export type Dialog = (NonNullable<FlightsDialogTriggerActionFisFragment['dialog']>);
  export type AnalyticsList = NonNullable<(NonNullable<FlightsDialogTriggerActionFisFragment['analyticsList']>)[number]>;
  export type DialogContents = NonNullable<(NonNullable<FlightsDialogTriggerActionFisFragment['dialogContents']>)[number]>;
  export type EgdsParagraphInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsDialogTriggerActionFisFragment['dialogContents']>)[number]>, { __typename: 'EGDSParagraph' }>);
}

export namespace EgdsActionDialogFragment {
  export type Fragment = EgdsActionDialogFragmentFragment;
  export type Footer = (NonNullable<EgdsActionDialogFragmentFragment['footer']>);
}

export namespace EgdsActionDialogFooter {
  export type Fragment = EgdsActionDialogFooterFragment;
  export type Buttons = NonNullable<(NonNullable<EgdsActionDialogFooterFragment['buttons']>)[number]>;
  export type FlightsActionButtonInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsActionDialogFooterFragment['buttons']>)[number]>, { __typename: 'FlightsActionButton' }>);
  export type ClientAction = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsActionDialogFooterFragment['buttons']>)[number]>, { __typename: 'FlightsActionButton' }>)['clientAction']>);
  export type AnalyticsList = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsActionDialogFooterFragment['buttons']>)[number]>, { __typename: 'FlightsActionButton' }>)['clientAction']>)['analyticsList']>)[number]>;
  export type FlightsRemovePriceMatchPromiseActionInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsActionDialogFooterFragment['buttons']>)[number]>, { __typename: 'FlightsActionButton' }>)['clientAction']>), { __typename: 'FlightsRemovePriceMatchPromiseAction' }>);
}

export namespace FlightsActionButtonFragment {
  export type Fragment = FlightsActionButtonFragmentFragment;
  export type ClientAction = (NonNullable<FlightsActionButtonFragmentFragment['clientAction']>);
  export type Icon = (NonNullable<FlightsActionButtonFragmentFragment['icon']>);
  export type Action = (NonNullable<FlightsActionButtonFragmentFragment['action']>);
  export type Analytics = (NonNullable<(NonNullable<FlightsActionButtonFragmentFragment['action']>)['analytics']>);
}

export namespace EgdsGraphicIllustrationFragment {
  export type Fragment = EgdsGraphicIllustrationFragmentFragment;
}

export namespace UiTertiaryButtonFragment {
  export type Fragment = UiTertiaryButtonFragmentFragment;
  export type Action = (NonNullable<UiTertiaryButtonFragmentFragment['action']>);
  export type UiFlightActionInlineFragment = (DiscriminateUnion<(NonNullable<UiTertiaryButtonFragmentFragment['action']>), { __typename: 'UIFlightAction' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<(NonNullable<UiTertiaryButtonFragmentFragment['action']>), { __typename: 'UIFlightAction' }>)['analytics']>);
}

export namespace FlightsDialogTriggerFis {
  export type Fragment = FlightsDialogTriggerFisFragment;
  export type Trigger = (NonNullable<FlightsDialogTriggerFisFragment['trigger']>);
}

export namespace FaresDialogsFis {
  export type Fragment = FaresDialogsFisFragment;
  export type Dialog = (NonNullable<FaresDialogsFisFragment['dialog']>);
  export type DialogContent = NonNullable<(NonNullable<FaresDialogsFisFragment['dialogContent']>)[number]>;
  export type FlightsDialogTriggerInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FaresDialogsFisFragment['dialogContent']>)[number]>, { __typename: 'FlightsDialogTrigger' }>);
}

export namespace EgdsDialogFis {
  export type Fragment = EgdsDialogFisFragment;
  export type CloseAnalytics = (NonNullable<EgdsDialogFisFragment['closeAnalytics']>);
  export type EgdsActionDialogInlineFragment = (DiscriminateUnion<EgdsDialogFisFragment, { __typename: 'EGDSActionDialog' }>);
  export type Footer = (NonNullable<(DiscriminateUnion<EgdsDialogFisFragment, { __typename: 'EGDSActionDialog' }>)['footer']>);
  export type Buttons = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<EgdsDialogFisFragment, { __typename: 'EGDSActionDialog' }>)['footer']>)['buttons']>)[number]>;
}

export namespace PriceMatchPromiseSelectionCardFragment {
  export type Fragment = PriceMatchPromiseSelectionCardFragmentFragment;
  export type Icon = (NonNullable<PriceMatchPromiseSelectionCardFragmentFragment['icon']>);
  export type ToggleCheckbox = (NonNullable<PriceMatchPromiseSelectionCardFragmentFragment['toggleCheckbox']>);
  export type OnDisplayAnalytics = NonNullable<(NonNullable<PriceMatchPromiseSelectionCardFragmentFragment['onDisplayAnalytics']>)[number]>;
}

export namespace PriceMatchPromiseSelectedCardFragment {
  export type Fragment = PriceMatchPromiseSelectedCardFragmentFragment;
  export type Icon = (NonNullable<PriceMatchPromiseSelectedCardFragmentFragment['icon']>);
  export type RemoveActionLink = (NonNullable<PriceMatchPromiseSelectedCardFragmentFragment['removeActionLink']>);
  export type OnDisplayAnalytics = NonNullable<(NonNullable<PriceMatchPromiseSelectedCardFragmentFragment['onDisplayAnalytics']>)[number]>;
}

export namespace FlightsActionCheckboxFragmentFis {
  export type Fragment = FlightsActionCheckboxFragmentFisFragment;
  export type Label = (NonNullable<FlightsActionCheckboxFragmentFisFragment['label']>);
}

export namespace FlightsActionLinkFis {
  export type Fragment = FlightsActionLinkFisFragment;
  export type ClientAction = (NonNullable<FlightsActionLinkFisFragment['clientAction']>);
  export type FlightsCreditSelectionActionInlineFragment = (DiscriminateUnion<(NonNullable<FlightsActionLinkFisFragment['clientAction']>), { __typename: 'FlightsCreditSelectionAction' }>);
  export type FlightsResourceLinkActionInlineFragment = (DiscriminateUnion<(NonNullable<FlightsActionLinkFisFragment['clientAction']>), { __typename: 'FlightsResourceLinkAction' }>);
  export type Resource = (NonNullable<(DiscriminateUnion<(NonNullable<FlightsActionLinkFisFragment['clientAction']>), { __typename: 'FlightsResourceLinkAction' }>)['resource']>);
  export type HttpUriInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<FlightsActionLinkFisFragment['clientAction']>), { __typename: 'FlightsResourceLinkAction' }>)['resource']>), { __typename: 'HttpURI' }>);
  export type Icon = (NonNullable<FlightsActionLinkFisFragment['icon']>);
}

export namespace EgdsElementFragmentFis {
  export type Fragment = EgdsElementFragmentFisFragment;
  export type IllustrationInlineFragment = (DiscriminateUnion<EgdsElementFragmentFisFragment, { __typename: 'Illustration' }>);
  export type EgdsTextInlineFragment = (DiscriminateUnion<EgdsElementFragmentFisFragment, { __typename: 'EGDSText' }>);
  export type UiMessagingCardInlineFragment = (DiscriminateUnion<EgdsElementFragmentFisFragment, { __typename: 'UIMessagingCard' }>);
  export type Graphic = (NonNullable<(DiscriminateUnion<EgdsElementFragmentFisFragment, { __typename: 'UIMessagingCard' }>)['graphic']>);
  export type EgdsBulletedListInlineFragment = (DiscriminateUnion<EgdsElementFragmentFisFragment, { __typename: 'EGDSBulletedList' }>);
  export type ListItems = NonNullable<(NonNullable<(DiscriminateUnion<EgdsElementFragmentFisFragment, { __typename: 'EGDSBulletedList' }>)['listItems']>)[number]>;
}

export namespace EgdsTextFragmentFis {
  export type Fragment = EgdsTextFragmentFisFragment;
  export type EgdsGraphicTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSGraphicText' }>);
  export type EgdsHeadingInlineFragment = (DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSHeading' }>);
  export type EgdsParagraphInlineFragment = (DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSParagraph' }>);
  export type EgdsIconTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSIconText' }>)['icon']>);
  export type EgdsStandardLinkInlineFragment = (DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSStandardLink' }>);
  export type Action = (NonNullable<(DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type Resource = (NonNullable<(NonNullable<(DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type EgdsSpannableTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentFisFragment, { __typename: 'EGDSSpannableText' }>);
}

export namespace EgdsFullScreenDialogFragmentFis {
  export type Fragment = EgdsFullScreenDialogFragmentFisFragment;
  export type EgdsFullScreenDialogInlineFragment = ({ __typename: 'EGDSFullScreenDialog' } & Pick<EgdsFullScreenDialogFragmentFisFragment, 'toolbar'>);
  export type Toolbar = (NonNullable<({ __typename: 'EGDSFullScreenDialog' } & Pick<EgdsFullScreenDialogFragmentFisFragment, 'toolbar'>)['toolbar']>);
}

export namespace EgdsGraphicTextFragmentInformation {
  export type Fragment = EgdsGraphicTextFragmentInformationFragment;
  export type TextGraphic = (NonNullable<EgdsGraphicTextFragmentInformationFragment['textGraphic']>);
}

export namespace UiGraphicFragmentInformation {
  export type Fragment = UiGraphicFragmentInformationFragment;
}

export namespace FlightsShoppingPwaFlightInformationResultsLoading {
  export type Variables = FlightsShoppingPwaFlightInformationResultsLoadingQueryVariables;
  export type Query = FlightsShoppingPwaFlightInformationResultsLoadingQuery;
  export type FlightsDetail = (NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>);
  export type JourneyStartEndDates = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['journeyStartEndDates']>)[number]>;
  export type ClientMetadata = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['clientMetadata']>);
  export type FlightsPwaMetadataInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>);
  export type PageNameAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>)['pageNameAnalytics']>);
  export type PageTitle = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['pageTitle']>);
  export type FlightsPageTitleInlineFragment = ({ __typename: 'FlightsPageTitle' } & Pick<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['pageTitle']>), 'title' | 'pageAccessibility'>);
  export type Title = (NonNullable<({ __typename: 'FlightsPageTitle' } & Pick<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['pageTitle']>), 'title' | 'pageAccessibility'>)['title']>);
  export type FreeCancellation = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['freeCancellation']>);
  export type FlightsSelectedJourneyReview = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>;
  export type LoadingFlightsSelectedJourneyReviewInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>);
  export type JourneyInformation = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyInformation']>);
  export type FlightsJourneyHeaders = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneyHeaders']>);
  export type FlightsJourneySubheadingMark = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneyHeaders']>)['flightsJourneySubheadingMark']>);
  export type Url = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneyHeaders']>)['flightsJourneySubheadingMark']>)['url']>);
  export type FlightsJourneySummary = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>);
  export type Heading = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>)['heading']>);
  export type DifferentDayArrival = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>)['differentDayArrival']>);
  export type BasicFlightDetails = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>)['basicFlightDetails']>)[number]>;
  export type LoadingFlightsStandardJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>), { __typename: 'LoadingFlightsStandardJourneySummary' }>);
  export type FlightsBargainJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>);
  export type JourneyHighlights = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>;
  export type _FlightsJourneyHeaders = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneyHeaders']>);
  export type _FlightsJourneySubheadingMark = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneyHeaders']>)['flightsJourneySubheadingMark']>);
  export type _Url = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneyHeaders']>)['flightsJourneySubheadingMark']>)['url']>);
  export type _FlightsJourneySummary = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>);
  export type _Heading = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>)['heading']>);
  export type _DifferentDayArrival = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>)['differentDayArrival']>);
  export type _BasicFlightDetails = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>)['basicFlightDetails']>)[number]>;
  export type _LoadingFlightsStandardJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>), { __typename: 'LoadingFlightsStandardJourneySummary' }>);
  export type _FlightsBargainJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['journeyHighlights']>)[number]>['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>);
  export type ChangeFlight = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['changeFlight']>);
  export type ChangeFlightDialog = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['changeFlightDialog']>);
  export type Actions = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['changeFlightDialog']>)['actions']>)[number]>;
  export type Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['changeFlightDialog']>)['actions']>)[number]>['analytics']>);
  export type AnalyticsList = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['changeFlightDialog']>)['actions']>)[number]>['analyticsList']>)[number]>;
  export type DisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadingFlightsSelectedJourneyReview' }>)['changeFlightDialog']>)['displayedAnalytics']>);
  export type PriceSummary = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['priceSummary']>);
  export type FlightsLoadingPriceSummaryInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['priceSummary']>), { __typename: 'FlightsLoadingPriceSummary' }>);
  export type ButtonAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['priceSummary']>), { __typename: 'FlightsLoadingPriceSummary' }>)['buttonAction']>);
  export type ServerErrorMessaging = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['serverErrorMessaging']>);
  export type StepIndicator = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['stepIndicator']>);
  export type FlightsSupportedAncillaries = (NonNullable<(NonNullable<FlightsShoppingPwaFlightInformationResultsLoadingQuery['flightsDetail']>)['flightsSupportedAncillaries']>);
}

export namespace FlightsInformationSupportedAncillaryInfo {
  export type Fragment = FlightsInformationSupportedAncillaryInfoFragment;
}

export namespace FlightsInformationStepIndicator {
  export type Fragment = FlightsInformationStepIndicatorFragment;
  export type ErrorAnalytics = (NonNullable<FlightsInformationStepIndicatorFragment['errorAnalytics']>);
}

export namespace FlightsInformationLoadingServerErrorMessaging {
  export type Fragment = FlightsInformationLoadingServerErrorMessagingFragment;
  export type Action = (NonNullable<FlightsInformationLoadingServerErrorMessagingFragment['action']>);
  export type Icon = (NonNullable<FlightsInformationLoadingServerErrorMessagingFragment['icon']>);
}

export namespace IconInformationLoading {
  export type Fragment = IconInformationLoadingFragment;
}

export namespace FlightsMessageAndAccessibilityInformationLoading {
  export type Fragment = FlightsMessageAndAccessibilityInformationLoadingFragment;
}

export namespace FlightsImagePlacardInformationLoading {
  export type Fragment = FlightsImagePlacardInformationLoadingFragment;
  export type Image = (NonNullable<FlightsImagePlacardInformationLoadingFragment['image']>);
}

export namespace FlightsActionInformationLoading {
  export type Fragment = FlightsActionInformationLoadingFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsActionInformationLoadingFragment['analyticsList']>)[number]>;
  export type RelativePackageableUri = (NonNullable<FlightsActionInformationLoadingFragment['relativePackageableURI']>);
  export type RelativeUri = (NonNullable<FlightsActionInformationLoadingFragment['relativeURI']>);
}

export namespace FlightsShoppingPwaSeatSelection {
  export type Variables = FlightsShoppingPwaSeatSelectionQueryVariables;
  export type Query = FlightsShoppingPwaSeatSelectionQuery;
  export type FlightsDetail = (NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>);
  export type FlightsSelectedJourneyReview = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>;
  export type LoadedFlightsSelectedJourneyReviewInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>);
  export type FareDetails = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>);
  export type FareSeatMapInformation = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['flightsSelectedJourneyReview']>)[number]>, { __typename: 'LoadedFlightsSelectedJourneyReview' }>)['fareDetails']>)['fareSeatMapInformation']>);
  export type PriceSummary = (NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['priceSummary']>);
  export type DynamicElementsGroups = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>;
  export type DynamicElements = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>);
  export type FlightsJourneyDetailsDynamicElements = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>;
  export type JourneyPartsDynamicElements = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['journeyPartsDynamicElements']>)[number]>;
  export type FareSeatMapDynamicElement = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['fareSeatMapDynamicElement']>);
  export type OnSelectAnalytics = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['fareSeatMapDynamicElement']>)['onSelectAnalytics']>)[number]>;
  export type FlightLegsDetails = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['fareSeatMapDynamicElement']>)['flightLegsDetails']>);
  export type SelectedSeatDetails = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['selectedSeatDetails']>)[number]>;
  export type Details = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['flightsJourneyDetailsDynamicElements']>)[number]>['details']>);
  export type DynamicElementsGroupTrackEventAnalytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['dynamicElementsGroupTrackEventAnalytics']>);
  export type AnalyticsList = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>)['dynamicElementsGroupTrackEventAnalytics']>)['analyticsList']>)[number]>;
  export type FlightsInformationDynamicElementsInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>), { __typename: 'FlightsInformationDynamicElements' }>);
  export type _PriceSummary = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>), { __typename: 'FlightsInformationDynamicElements' }>)['priceSummary']>);
  export type FareChoiceInformationDynamicElement = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaSeatSelectionQuery['flightsDetail']>)['dynamicElementsGroups']>)[number]>['dynamicElements']>), { __typename: 'FlightsInformationDynamicElements' }>)['fareChoiceInformationDynamicElement']>);
}

export namespace FareSeatMapInfo {
  export type Fragment = FareSeatMapInfoFragment;
  export type Details = (NonNullable<FareSeatMapInfoFragment['details']>);
  export type FareSeatMapViewDetails = (NonNullable<FareSeatMapInfoFragment['fareSeatMapViewDetails']>);
  export type SelectedSeatDetails = NonNullable<(NonNullable<FareSeatMapInfoFragment['selectedSeatDetails']>)[number]>;
  export type ErrorMessages = NonNullable<(NonNullable<FareSeatMapInfoFragment['errorMessages']>)[number]>;
}

export namespace FlightsShoppingPwaFlightServicingResults {
  export type Variables = FlightsShoppingPwaFlightServicingResultsQueryVariables;
  export type Query = FlightsShoppingPwaFlightServicingResultsQuery;
  export type FlightsServicing = (NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>);
  export type ClientMetadata = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['clientMetadata']>);
  export type PageNameAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['clientMetadata']>)['pageNameAnalytics']>);
  export type PageAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['clientMetadata']>)['pageAnalytics']>);
  export type Booking = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['booking']>);
  export type PrimaryText = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['booking']>)['primaryText']>);
  export type CreditResidualMessaging = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['creditResidualMessaging']>);
  export type Heading = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['creditResidualMessaging']>)['heading']>);
  export type ImportantTripInfo = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['importantTripInfo']>);
  export type _Heading = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['importantTripInfo']>)['heading']>);
  export type Payment = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['payment']>);
  export type PaymentPresentation = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['payment']>)['paymentPresentation']>);
  export type PriceSummary = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['priceSummary']>);
  export type ReviewAndBook = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['reviewAndBook']>);
  export type __Heading = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['reviewAndBook']>)['heading']>);
  export type TripSummary = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['tripSummary']>);
  export type ServerErrorMessaging = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['serverErrorMessaging']>);
  export type EmptyState = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['serverErrorMessaging']>)['emptyState']>);
  export type Placards = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingResultsQuery['flightsServicing']>)['serverErrorMessaging']>)['placards']>)[number]>;
}

export namespace FlightsAnalyticsFragment {
  export type Fragment = FlightsAnalyticsFragmentFragment;
}

export namespace ClientSideAnalyticsFragment {
  export type Fragment = ClientSideAnalyticsFragmentFragment;
  export type UisPrimeMessages = NonNullable<(NonNullable<ClientSideAnalyticsFragmentFragment['uisPrimeMessages']>)[number]>;
}

export namespace FlightsBannerPlacardFragment {
  export type Fragment = FlightsBannerPlacardFragmentFragment;
  export type OnViewedAnalytics = (NonNullable<FlightsBannerPlacardFragmentFragment['onViewedAnalytics']>);
  export type Banner = (NonNullable<FlightsBannerPlacardFragmentFragment['banner']>);
}

export namespace FlightServicingBookingEmptyStateFragment {
  export type Fragment = FlightServicingBookingEmptyStateFragmentFragment;
  export type Presentation = (NonNullable<FlightServicingBookingEmptyStateFragmentFragment['presentation']>);
  export type Icon = (NonNullable<(NonNullable<FlightServicingBookingEmptyStateFragmentFragment['presentation']>)['icon']>);
  export type PrimaryButton = (NonNullable<(NonNullable<FlightServicingBookingEmptyStateFragmentFragment['presentation']>)['primaryButton']>);
  export type Analytics = (NonNullable<(NonNullable<(NonNullable<FlightServicingBookingEmptyStateFragmentFragment['presentation']>)['primaryButton']>)['analytics']>);
  export type PrimaryAction = (NonNullable<FlightServicingBookingEmptyStateFragmentFragment['primaryAction']>);
}

export namespace FlightsResourceLinkActionFragment {
  export type Fragment = FlightsResourceLinkActionFragmentFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsResourceLinkActionFragmentFragment['analyticsList']>)[number]>;
  export type Resource = (NonNullable<FlightsResourceLinkActionFragmentFragment['resource']>);
}

export namespace FlightsRefreshActionFragment {
  export type Fragment = FlightsRefreshActionFragmentFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsRefreshActionFragmentFragment['analyticsList']>)[number]>;
}

export namespace HttpUriFragment {
  export type Fragment = HttpUriFragmentFragment;
}

export namespace TelUriFragment {
  export type Fragment = TelUriFragmentFragment;
}

export namespace FlightsShoppingPwaFlightServicingConfirmationResults {
  export type Variables = FlightsShoppingPwaFlightServicingConfirmationResultsQueryVariables;
  export type Query = FlightsShoppingPwaFlightServicingConfirmationResultsQuery;
  export type FlightsServicingConfirmation = (NonNullable<FlightsShoppingPwaFlightServicingConfirmationResultsQuery['flightsServicingConfirmation']>);
  export type ClientMetadata = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingConfirmationResultsQuery['flightsServicingConfirmation']>)['clientMetadata']>);
  export type PageNameAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingConfirmationResultsQuery['flightsServicingConfirmation']>)['clientMetadata']>)['pageNameAnalytics']>);
  export type PageAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingConfirmationResultsQuery['flightsServicingConfirmation']>)['clientMetadata']>)['pageAnalytics']>);
  export type ErrorMessaging = (NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingConfirmationResultsQuery['flightsServicingConfirmation']>)['errorMessaging']>);
  export type EmptyState = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightServicingConfirmationResultsQuery['flightsServicingConfirmation']>)['errorMessaging']>)['emptyState']>);
}

export namespace FlightsAnalyticsConfirmationFragment {
  export type Fragment = FlightsAnalyticsConfirmationFragmentFragment;
}

export namespace ClientSideAnalyticsConfirmationFragment {
  export type Fragment = ClientSideAnalyticsConfirmationFragmentFragment;
  export type UisPrimeMessages = NonNullable<(NonNullable<ClientSideAnalyticsConfirmationFragmentFragment['uisPrimeMessages']>)[number]>;
}

export namespace FlightServicingBookingEmptyStateConfirmationFragment {
  export type Fragment = FlightServicingBookingEmptyStateConfirmationFragmentFragment;
  export type Presentation = (NonNullable<FlightServicingBookingEmptyStateConfirmationFragmentFragment['presentation']>);
  export type Icon = (NonNullable<(NonNullable<FlightServicingBookingEmptyStateConfirmationFragmentFragment['presentation']>)['icon']>);
  export type PrimaryButton = (NonNullable<(NonNullable<FlightServicingBookingEmptyStateConfirmationFragmentFragment['presentation']>)['primaryButton']>);
  export type PrimaryAction = (NonNullable<FlightServicingBookingEmptyStateConfirmationFragmentFragment['primaryAction']>);
}

export namespace FlightsBookingActionFragment {
  export type Fragment = FlightsBookingActionFragmentFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsBookingActionFragmentFragment['analyticsList']>)[number]>;
}

export namespace FlightsSearchMetadata {
  export type Variables = FlightsSearchMetadataQueryVariables;
  export type Query = FlightsSearchMetadataQuery;
  export type FlightsSearchMetadata = (NonNullable<FlightsSearchMetadataQuery['flightsSearchMetadata']>);
  export type PageAnalytics = (NonNullable<(NonNullable<FlightsSearchMetadataQuery['flightsSearchMetadata']>)['pageAnalytics']>);
  export type Messaging = (NonNullable<(NonNullable<FlightsSearchMetadataQuery['flightsSearchMetadata']>)['messaging']>);
}

export namespace ClientSideImpressionEventAnalyticsFragment {
  export type Fragment = ClientSideImpressionEventAnalyticsFragmentFragment;
}

export namespace InitiateMultiItemSession {
  export type Variables = InitiateMultiItemSessionMutationVariables;
  export type Mutation = InitiateMultiItemSessionMutation;
  export type MultiItemShopping = (NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>);
  export type Initiate = (NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type ShoppingContext = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>)['multiItem']>);
  export type MultiItemSearchContextErrorResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextErrorResponse' }>);
}

export namespace FlightsShoppingPwaFlightSearchFormLoaded {
  export type Variables = FlightsShoppingPwaFlightSearchFormLoadedQueryVariables;
  export type Query = FlightsShoppingPwaFlightSearchFormLoadedQuery;
  export type FlightsSearch = (NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>);
  export type SearchForm = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>);
  export type FlightsLoadedSearchFormInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>);
  export type AddJourneyAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['addJourneyAction']>);
  export type Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['addJourneyAction']>)['analytics']>);
  export type BookingChangeLink = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['bookingChangeLink']>);
  export type CollapseFormAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['collapseFormAnalytics']>);
  export type DepartureAndReturnDates = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['departureAndReturnDates']>);
  export type ErrorSummary = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['errorSummary']>);
  export type DisplayAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['errorSummary']>)['displayAnalytics']>);
  export type LinkAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['errorSummary']>)['linkAnalytics']>);
  export type ExpandFilterAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['expandFilterAction']>);
  export type Icon = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['expandFilterAction']>)['icon']>);
  export type ExpandFormAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['expandFormAnalytics']>);
  export type ExpandSearchFormAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['expandSearchFormAction']>);
  export type CloseFormAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['closeFormAction']>);
  export type _Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['closeFormAction']>)['analytics']>);
  export type Journeys = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>;
  export type DepartureDate = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['departureDate']>);
  export type DestinationLocation = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['destinationLocation']>);
  export type __Analytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['destinationLocation']>)['analytics']>);
  export type OnTypeAnalytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['destinationLocation']>)['onTypeAnalytics']>);
  export type _Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['destinationLocation']>)['icon']>);
  export type PossibleErrors = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['destinationLocation']>)['possibleErrors']>)[number]>;
  export type ___Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['destinationLocation']>)['possibleErrors']>)[number]>['analytics']>);
  export type Label = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['label']>);
  export type OriginLocation = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['originLocation']>);
  export type ____Analytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['originLocation']>)['analytics']>);
  export type _OnTypeAnalytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['originLocation']>)['onTypeAnalytics']>);
  export type __Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['originLocation']>)['icon']>);
  export type _PossibleErrors = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['originLocation']>)['possibleErrors']>)[number]>;
  export type _____Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['originLocation']>)['possibleErrors']>)[number]>['analytics']>);
  export type ReturnDate = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['returnDate']>);
  export type RemoveJourneyAction = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['removeJourneyAction']>);
  export type ______Analytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['removeJourneyAction']>)['analytics']>);
  export type AccessibilityUsageMessage = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['removeJourneyAction']>)['accessibilityUsageMessage']>);
  export type SwapLocationsAction = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>);
  export type ___Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>);
  export type SmallView = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>)['smallView']>);
  export type LargeView = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>)['largeView']>);
  export type _______Analytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['analytics']>);
  export type MultiDestAccessibilityMessage = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['multiDestAccessibilityMessage']>);
  export type _AccessibilityUsageMessage = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['accessibilityUsageMessage']>);
  export type NewJourneyTemplate = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>);
  export type _DepartureDate = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['departureDate']>);
  export type ________Analytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['departureDate']>)['analytics']>);
  export type HandleClickAnalytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['departureDate']>)['handleClickAnalytics']>);
  export type Date = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['departureDate']>)['date']>);
  export type __PossibleErrors = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['departureDate']>)['possibleErrors']>)[number]>;
  export type _________Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['departureDate']>)['possibleErrors']>)[number]>['analytics']>);
  export type _DestinationLocation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['destinationLocation']>);
  export type __________Analytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['destinationLocation']>)['analytics']>);
  export type __OnTypeAnalytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['destinationLocation']>)['onTypeAnalytics']>);
  export type ____Icon = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['destinationLocation']>)['icon']>);
  export type ___PossibleErrors = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['destinationLocation']>)['possibleErrors']>)[number]>;
  export type ___________Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['destinationLocation']>)['possibleErrors']>)[number]>['analytics']>);
  export type _OriginLocation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['originLocation']>);
  export type ____________Analytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['originLocation']>)['analytics']>);
  export type ___OnTypeAnalytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['originLocation']>)['onTypeAnalytics']>);
  export type _____Icon = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['originLocation']>)['icon']>);
  export type ____PossibleErrors = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['originLocation']>)['possibleErrors']>)[number]>;
  export type _____________Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['originLocation']>)['possibleErrors']>)[number]>['analytics']>);
  export type _ReturnDate = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['returnDate']>);
  export type ______________Analytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['returnDate']>)['analytics']>);
  export type _HandleClickAnalytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['returnDate']>)['handleClickAnalytics']>);
  export type _Date = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['returnDate']>)['date']>);
  export type _____PossibleErrors = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['returnDate']>)['possibleErrors']>)[number]>;
  export type _______________Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['returnDate']>)['possibleErrors']>)[number]>['analytics']>);
  export type _Label = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['label']>);
  export type _RemoveJourneyAction = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['removeJourneyAction']>);
  export type ________________Analytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['removeJourneyAction']>)['analytics']>);
  export type __AccessibilityUsageMessage = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['removeJourneyAction']>)['accessibilityUsageMessage']>);
  export type _SwapLocationsAction = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['swapLocationsAction']>);
  export type ______Icon = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['swapLocationsAction']>)['icon']>);
  export type _SmallView = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['swapLocationsAction']>)['icon']>)['smallView']>);
  export type _LargeView = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['swapLocationsAction']>)['icon']>)['largeView']>);
  export type _________________Analytics = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['swapLocationsAction']>)['analytics']>);
  export type _MultiDestAccessibilityMessage = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['swapLocationsAction']>)['multiDestAccessibilityMessage']>);
  export type ___AccessibilityUsageMessage = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['newJourneyTemplate']>)['swapLocationsAction']>)['accessibilityUsageMessage']>);
  export type SearchActionAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchActionAnalytics']>);
  export type SearchOptions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>;
  export type FlightsSearchFormAirlineOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>);
  export type _______Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['icon']>);
  export type FieldIcon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['fieldIcon']>);
  export type ApplyAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['applyAnalytics']>);
  export type CancelAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['cancelAnalytics']>);
  export type OpenAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['openAnalytics']>);
  export type Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['items']>)[number]>;
  export type AirlineSelectedAnalytics = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['items']>)[number]>['airlineSelectedAnalytics']>);
  export type SelectedItem = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['selectedItem']>);
  export type CloseIcon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['closeIcon']>);
  export type FlightsSearchFormCabinClassOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>);
  export type ________Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['icon']>);
  export type _FieldIcon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['fieldIcon']>);
  export type _OpenAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['openAnalytics']>);
  export type _Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['items']>)[number]>;
  export type CabinClassSelectedAnalytics = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['items']>)[number]>['cabinClassSelectedAnalytics']>);
  export type _SelectedItem = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['selectedItem']>);
  export type FlightsSearchFormMoreFiltersOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>);
  export type _________Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>)['icon']>);
  export type __OpenAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>)['openAnalytics']>);
  export type __Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>)['items']>)[number]>;
  export type AdvancedFilterSelectedAnalytics = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>)['items']>)[number]>['advancedFilterSelectedAnalytics']>);
  export type AdvancedFilterRemoveAnalytics = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>)['items']>)[number]>['advancedFilterRemoveAnalytics']>);
  export type FlightsSearchFormTravelersOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>);
  export type __________Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['icon']>);
  export type __FieldIcon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['fieldIcon']>);
  export type AgeRulesLink = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['ageRulesLink']>);
  export type __________________Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['ageRulesLink']>)['analytics']>);
  export type _ApplyAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['applyAnalytics']>);
  export type _CancelAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['cancelAnalytics']>);
  export type ChangeAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['changeAnalytics']>);
  export type AdultSelectedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['adultSelectedAnalytics']>);
  export type ChildrenSelectedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['childrenSelectedAnalytics']>);
  export type InfantSelectedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['infantSelectedAnalytics']>);
  export type InfantLapAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['infantLapAnalytics']>);
  export type InfantSeatAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['infantSeatAnalytics']>);
  export type ___OpenAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['openAnalytics']>);
  export type ______PossibleErrors = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['possibleErrors']>)[number]>;
  export type ___________________Analytics = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['possibleErrors']>)[number]>['analytics']>);
  export type ValueTemplate = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['valueTemplate']>);
  export type ___Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>;
  export type DecreaseCountAnalytics = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['decreaseCountAnalytics']>);
  export type IncreaseCountAnalytics = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['increaseCountAnalytics']>);
  export type TravelerAgeSelectorTemplate = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['travelerAgeSelectorTemplate']>);
  export type ____________________Analytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['travelerAgeSelectorTemplate']>)['analytics']>);
  export type ____Items = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['travelerAgeSelectorTemplate']>)['items']>)[number]>;
  export type __Label = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['travelerAgeSelectorTemplate']>)['label']>);
  export type TravelerAges = NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['travelerAges']>)[number]>;
  export type _____________________Analytics = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['travelerAges']>)[number]>['analytics']>);
  export type _____Items = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['travelerAges']>)[number]>['items']>)[number]>;
  export type ___Label = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>['travelerAges']>)[number]>['label']>);
  export type FlightsSearchFormTravelerInfantOptionItemInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>, { __typename: 'FlightsSearchFormTravelerInfantOptionItem' }>);
  export type InfantsOption = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>, { __typename: 'FlightsSearchFormTravelerInfantOptionItem' }>)['infantsOption']>);
  export type ______Items = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>, { __typename: 'FlightsSearchFormTravelerInfantOptionItem' }>)['infantsOption']>)['items']>)[number]>;
  export type FlightsSearchFormTripTypeOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>);
  export type ___________Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>)['icon']>);
  export type ____OpenAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>)['openAnalytics']>);
  export type _______Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>)['items']>)[number]>;
  export type TripTypeSelectedAnalytics = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>)['items']>)[number]>['tripTypeSelectedAnalytics']>);
  export type AvailableRoutes = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['availableRoutes']>);
  export type OriginCountries = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>;
  export type Origins = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>;
  export type DestinationCountries = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>['destinationCountries']>)[number]>;
  export type Destinations = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadedQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadedSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>['destinationCountries']>)[number]>['destinations']>)[number]>;
}

export namespace ClientSideAnalytics {
  export type Fragment = ClientSideAnalyticsFragment;
  export type UisPrimeMessages = NonNullable<(NonNullable<ClientSideAnalyticsFragment['uisPrimeMessages']>)[number]>;
}

export namespace FlightsDate {
  export type Fragment = FlightsDateFragment;
  export type Analytics = (NonNullable<FlightsDateFragment['analytics']>);
  export type HandleClickAnalytics = (NonNullable<FlightsDateFragment['handleClickAnalytics']>);
  export type Date = (NonNullable<FlightsDateFragment['date']>);
  export type PossibleErrors = NonNullable<(NonNullable<FlightsDateFragment['possibleErrors']>)[number]>;
  export type _Analytics = (NonNullable<NonNullable<(NonNullable<FlightsDateFragment['possibleErrors']>)[number]>['analytics']>);
}

export namespace FlightsResourceLinkAction {
  export type Fragment = FlightsResourceLinkActionFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsResourceLinkActionFragment['analyticsList']>)[number]>;
  export type Resource = (NonNullable<FlightsResourceLinkActionFragment['resource']>);
}

export namespace HttpUri {
  export type Fragment = HttpUriFragment;
}

export namespace FlightsShoppingPwaFlightSearchFormLoading {
  export type Variables = FlightsShoppingPwaFlightSearchFormLoadingQueryVariables;
  export type Query = FlightsShoppingPwaFlightSearchFormLoadingQuery;
  export type FlightsSearch = (NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>);
  export type ClientMetadata = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['clientMetadata']>);
  export type FlightsPwaMetadataInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>);
  export type PageNameAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>)['pageNameAnalytics']>);
  export type SearchForm = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>);
  export type FlightsLoadingSearchFormInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>);
  export type AddJourneyAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['addJourneyAction']>);
  export type DepartureAndReturnDates = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['departureAndReturnDates']>);
  export type Journeys = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>;
  export type DepartureDate = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['departureDate']>);
  export type Date = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['departureDate']>)['date']>);
  export type Label = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['label']>);
  export type DestinationLocation = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['destinationLocation']>);
  export type Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['destinationLocation']>)['icon']>);
  export type OriginLocation = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['originLocation']>);
  export type _Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['originLocation']>)['icon']>);
  export type ReturnDate = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['returnDate']>);
  export type _Date = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['returnDate']>)['date']>);
  export type RemoveJourneyAction = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['removeJourneyAction']>);
  export type SwapLocationsAction = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>);
  export type __Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>);
  export type SmallView = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>)['smallView']>);
  export type LargeView = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>)['largeView']>);
  export type SearchOptions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>;
  export type FlightsSearchFormAirlineOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>);
  export type ___Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['icon']>);
  export type SelectedItem = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['selectedItem']>);
  export type FlightsSearchFormCabinClassOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>);
  export type ____Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['icon']>);
  export type _SelectedItem = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['selectedItem']>);
  export type FlightsSearchFormMoreFiltersOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>);
  export type _____Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>)['icon']>);
  export type FlightsSearchFormTravelersOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>);
  export type ______Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['icon']>);
  export type ValueTemplate = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['valueTemplate']>);
  export type Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>;
  export type FlightsSearchFormTripTypeOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>);
  export type _______Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>)['icon']>);
  export type _Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>)['items']>)[number]>;
  export type AvailableRoutes = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>);
  export type OriginCountries = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>;
  export type Origins = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>;
  export type DestinationCountries = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>['destinationCountries']>)[number]>;
  export type Destinations = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchFormLoadingQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>['destinationCountries']>)[number]>['destinations']>)[number]>;
}

export namespace FlightsShoppingPwaFlightSearchResultsFlightsSearch {
  export type Variables = FlightsShoppingPwaFlightSearchResultsFlightsSearchQueryVariables;
  export type Query = FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery;
  export type FlightsSearch = (NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>);
  export type ClientMetadata = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['clientMetadata']>);
  export type FlightsPwaMetadataInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>);
  export type PageNameAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>)['pageNameAnalytics']>);
  export type ResponseMetrics = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>)['responseMetrics']>)[number]>;
  export type FailedRequestMessaging = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>);
  export type Icon = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>)['icon']>);
  export type Action = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>)['action']>);
  export type ErrorRecoveryButtons = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>)['errorRecoveryButtons']>)[number]>;
  export type NoListingMessaging = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>);
  export type FlightsNoFlightsFoundMessagingInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsNoFlightsFoundMessaging' }>);
  export type _Icon = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsNoFlightsFoundMessaging' }>)['icon']>);
  export type FlightsNoFlightsFoundWithFilterMessagingInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsNoFlightsFoundWithFilterMessaging' }>);
  export type __Icon = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsNoFlightsFoundWithFilterMessaging' }>)['icon']>);
  export type ClearFiltersAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsNoFlightsFoundWithFilterMessaging' }>)['clearFiltersAction']>);
  export type FlightsActionableErrorMessagingInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsActionableErrorMessaging' }>);
  export type ___Icon = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsActionableErrorMessaging' }>)['icon']>);
  export type _Action = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsActionableErrorMessaging' }>)['action']>);
  export type _ErrorRecoveryButtons = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsActionableErrorMessaging' }>)['errorRecoveryButtons']>)[number]>;
  export type FlightsSmartNoFlightsFoundMessagingInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsSmartNoFlightsFoundMessaging' }>);
  export type AlternateAirportOptions = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsSmartNoFlightsFoundMessaging' }>)['alternateAirportOptions']>);
  export type AlternateDateOptions = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsSmartNoFlightsFoundMessaging' }>)['alternateDateOptions']>);
  export type EditSearchButton = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsSmartNoFlightsFoundMessaging' }>)['editSearchButton']>);
  export type FlightsDisplayComponentCountingValue = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsSmartNoFlightsFoundMessaging' }>)['flightsDisplayComponentCountingValue']>);
  export type ____Icon = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['noListingMessaging']>), { __typename: 'FlightsSmartNoFlightsFoundMessaging' }>)['icon']>);
  export type SortAndFilterResult = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>);
  export type FlightsLoadedSortAndFilterResultInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>);
  export type FilterAnalyticsList = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterAnalyticsList']>)[number]>;
  export type AppliedFiltersSummary = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>);
  export type AppliedFilters = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>;
  export type Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['analytics']>);
  export type DismissIcon = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['dismissIcon']>);
  export type NextSearchSortFilterCriteria = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>);
  export type FilterCriteria = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>;
  export type ArrivalAirportCodeFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['arrivalAirportCodeFilterValue']>);
  export type ArrivalTimeFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['arrivalTimeFilterValue']>);
  export type DepartureAirportCodeFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['departureAirportCodeFilterValue']>);
  export type DepartureTimeFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['departureTimeFilterValue']>);
  export type DurationFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['durationFilterValue']>);
  export type NumOfStopFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['numOfStopFilterValue']>);
  export type StopInfo = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['numOfStopFilterValue']>)['stopInfo']>);
  export type PreferredAirlineFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['preferredAirlineFilterValue']>);
  export type FlexibleChangePolicyBasedFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['flexibleChangePolicyBasedFilterValue']>);
  export type SeatChoiceBasedFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['seatChoiceBasedFilterValue']>);
  export type CarryOnBagBasedFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['carryOnBagBasedFilterValue']>);
  export type CheckedBagBasedFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['checkedBagBasedFilterValue']>);
  export type NoCancelFeeBasedFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['noCancelFeeBasedFilterValue']>);
  export type CreditEligibleFilterValue = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['appliedFiltersSummary']>)['appliedFilters']>)[number]>['nextSearchSortFilterCriteria']>)['filterCriteria']>)[number]>['creditEligibleFilterValue']>);
  export type ApplyAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['applyAction']>);
  export type Accessibility = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['applyAction']>)['accessibility']>);
  export type _Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['applyAction']>)['analytics']>);
  export type ClearSelectionLabel = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['clearSelectionLabel']>);
  export type __Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['clearSelectionLabel']>)['analytics']>);
  export type _Accessibility = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['clearSelectionLabel']>)['accessibility']>);
  export type ClearAllSelectionLabel = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['clearAllSelectionLabel']>);
  export type ___Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['clearAllSelectionLabel']>)['analytics']>);
  export type __Accessibility = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['clearAllSelectionLabel']>)['accessibility']>);
  export type Dismiss = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['dismiss']>);
  export type DismissAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['dismissAnalytics']>);
  export type RevealAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['revealAction']>);
  export type ___Accessibility = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['revealAction']>)['accessibility']>);
  export type IconAndLabel = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['revealAction']>)['iconAndLabel']>);
  export type _____Icon = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['revealAction']>)['iconAndLabel']>)['icon']>);
  export type RevealActionAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['revealActionAnalytics']>);
  export type SortPresentation = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['sortPresentation']>);
  export type Options = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['sortPresentation']>)['options']>)[number]>;
  export type ____Accessibility = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['sortPresentation']>)['options']>)[number]>['accessibility']>);
  export type ____Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['sortPresentation']>)['options']>)[number]>['analytics']>);
  export type SortType = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['sortPresentation']>)['options']>)[number]>['sortType']>);
  export type SelectedOption = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['sortPresentation']>)['selectedOption']>);
  export type _SortType = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['sortPresentation']>)['selectedOption']>)['sortType']>);
  export type FilterPresentation = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>);
  export type _____Accessibility = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>)['accessibility']>);
  export type EventAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>)['eventAnalytics']>);
  export type _Options = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>)['options']>)[number]>;
  export type FlightsListDisplayFilterOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>)['options']>)[number]>, { __typename: 'FlightsListDisplayFilterOption' }>);
  export type Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>)['options']>)[number]>, { __typename: 'FlightsListDisplayFilterOption' }>)['items']>)[number]>;
  export type ShowMoreToggle = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>)['options']>)[number]>, { __typename: 'FlightsListDisplayFilterOption' }>)['showMoreToggle']>);
  export type FlightsCardsDisplayFilterOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>)['options']>)[number]>, { __typename: 'FlightsCardsDisplayFilterOption' }>);
  export type _Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadedSortAndFilterResult' }>)['filterPresentation']>)['options']>)[number]>, { __typename: 'FlightsCardsDisplayFilterOption' }>)['items']>)[number]>;
  export type ListingResult = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>);
  export type FlightsLoadedListingResultInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>);
  export type Listings = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['listings']>)[number]>;
  export type FlightsListingsAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>);
  export type OnViewedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['onViewedAnalytics']>);
  export type OnViewedAnalyticsList = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['onViewedAnalyticsList']>)[number]>;
  export type PinnedListingDisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['pinnedListingDisplayedAnalytics']>);
  export type MoreListingsDisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['moreListingsDisplayedAnalytics']>);
  export type MoreListingsErrorAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['moreListingsErrorAnalytics']>);
  export type MoreListingsLoadTimeAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['moreListingsLoadTimeAnalytics']>);
  export type FareCalendarAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['fareCalendarAnalytics']>);
  export type FareUpsellPercentageAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['fareUpsellPercentageAnalytics']>);
  export type BestBetsDisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['bestBetsDisplayedAnalytics']>);
  export type BestSortDisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['bestSortDisplayedAnalytics']>);
  export type UrgencyMessageAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['urgencyMessageAnalytics']>);
  export type NonstopSectionDisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['flightsListingsAnalytics']>)['nonstopSectionDisplayedAnalytics']>);
  export type ListingsAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadedListingResult' }>)['listingsAction']>);
  export type FlightsOpinionLab = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsOpinionLab']>);
  export type FlightsActionAndLabelInlineFragment = ({ __typename: 'FlightsActionAndLabel' } & Pick<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsOpinionLab']>), 'label' | 'selectAction'>);
  export type SelectAction = (NonNullable<({ __typename: 'FlightsActionAndLabel' } & Pick<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsOpinionLab']>), 'label' | 'selectAction'>)['selectAction']>);
  export type RewardsPricingInfo = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['rewardsPricingInfo']>);
  export type PageTitle = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['pageTitle']>);
  export type Dialogs = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>;
  export type FlightsDialogStandardInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsDialogStandard' }>);
  export type Actions = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsDialogStandard' }>)['actions']>)[number]>;
  export type DisplayedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsDialogStandard' }>)['displayedAnalytics']>);
  export type FlightsDialogStaleSessionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsDialogStaleSession' }>);
  export type _Actions = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsDialogStaleSession' }>)['actions']>)[number]>;
  export type _DisplayedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsDialogStaleSession' }>)['displayedAnalytics']>);
  export type FlightsForcedChoiceCrossSellDialogInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>);
  export type __Actions = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['actions']>)[number]>;
  export type Annotation = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['annotation']>);
  export type __Items = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['annotation']>)['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['annotation']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type _____Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['annotation']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type MessageBody = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['messageBody']>)[number]>;
  export type EgdsPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['messageBody']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type EgdsGraphicTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['messageBody']>)[number]>, { __typename: 'EGDSGraphicText' }>);
  export type __DisplayedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['displayedAnalytics']>);
  export type DisplayBlockedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['displayBlockedAnalytics']>);
  export type CheckInDate = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['checkInDate']>);
  export type CheckOutDate = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['dialogs']>)[number]>, { __typename: 'FlightsForcedChoiceCrossSellDialog' }>)['checkOutDate']>);
  export type Banners = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['banners']>)[number]>;
  export type AllBanners = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['allBanners']>)[number]>;
  export type CheapestListingInfo = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['cheapestListingInfo']>);
  export type ______Analytics = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['cheapestListingInfo']>)['analytics']>);
  export type NffAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['cheapestListingInfo']>)['nffAnalytics']>);
  export type DeviationAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['cheapestListingInfo']>)['deviationAnalytics']>);
  export type StepIndicator = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['stepIndicator']>);
  export type FlightsReviewLoadingElements = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>);
  export type FreeCancellation = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['freeCancellation']>);
  export type FlightsImagePlacardInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['freeCancellation']>), { __typename: 'FlightsImagePlacard' }>);
  export type Image = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['freeCancellation']>), { __typename: 'FlightsImagePlacard' }>)['image']>);
  export type FlightsJourneyReviewCommon = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['flightsJourneyReviewCommon']>)[number]>;
  export type ChangeFlight = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['flightsJourneyReviewCommon']>)[number]>['changeFlight']>);
  export type ClientMetaData = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['clientMetaData']>);
  export type _PageTitle = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['pageTitle']>);
  export type PriceSummary = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['priceSummary']>);
  export type FlightsLoadingPriceSummaryInlineFragment = ({ __typename: 'FlightsLoadingPriceSummary' } & Pick<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['priceSummary']>), 'title' | 'skeletonCount' | 'tripTotalLabel' | 'buttonAction'>);
  export type ButtonAction = (NonNullable<({ __typename: 'FlightsLoadingPriceSummary' } & Pick<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['flightsReviewLoadingElements']>)['priceSummary']>), 'title' | 'skeletonCount' | 'tripTotalLabel' | 'buttonAction'>)['buttonAction']>);
  export type ShoppingContext = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['shoppingContext']>)['multiItem']>);
  export type ListingsHeaderPlacards = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsFlightsSearchQuery['flightsSearch']>)['listingsHeaderPlacards']>)[number]>;
}

export namespace FlightsCardsDisplayFilterItem {
  export type Fragment = FlightsCardsDisplayFilterItemFragment;
  export type Accessibility = (NonNullable<FlightsCardsDisplayFilterItemFragment['accessibility']>);
  export type Card = (NonNullable<FlightsCardsDisplayFilterItemFragment['card']>);
  export type DeselectAnalytics = (NonNullable<FlightsCardsDisplayFilterItemFragment['deselectAnalytics']>);
  export type FlightsSearchFilterValues = (NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>);
  export type ArrivalAirportCodeFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['arrivalAirportCodeFilterValue']>);
  export type ArrivalTimeFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['arrivalTimeFilterValue']>);
  export type DepartureAirportCodeFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['departureAirportCodeFilterValue']>);
  export type DepartureTimeFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['departureTimeFilterValue']>);
  export type DurationFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['durationFilterValue']>);
  export type NumOfStopFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['numOfStopFilterValue']>);
  export type StopInfo = (NonNullable<(NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['numOfStopFilterValue']>)['stopInfo']>);
  export type PreferredAirlineFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['preferredAirlineFilterValue']>);
  export type FlexibleChangePolicyBasedFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['flexibleChangePolicyBasedFilterValue']>);
  export type SeatChoiceBasedFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['seatChoiceBasedFilterValue']>);
  export type CarryOnBagBasedFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['carryOnBagBasedFilterValue']>);
  export type CheckedBagBasedFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['checkedBagBasedFilterValue']>);
  export type NoCancelFeeBasedFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['noCancelFeeBasedFilterValue']>);
  export type CreditEligibleFilterValue = (NonNullable<(NonNullable<FlightsCardsDisplayFilterItemFragment['flightsSearchFilterValues']>)['creditEligibleFilterValue']>);
  export type SelectAnalytics = (NonNullable<FlightsCardsDisplayFilterItemFragment['selectAnalytics']>);
  export type Value = (NonNullable<FlightsCardsDisplayFilterItemFragment['value']>);
  export type FlightsAirportCodeFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsAirportCodeFilterValue' }>);
  export type FlightsDurationBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsDurationBasedFilterValue' }>);
  export type FlightsPreferredAirlineFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsPreferredAirlineFilterValue' }>);
  export type FlightsFlexibleChangePolicyBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsFlexibleChangePolicyBasedFilterValue' }>);
  export type FlightsSeatChoiceBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsSeatChoiceBasedFilterValue' }>);
  export type FlightsCarryOnBagBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsCarryOnBagBasedFilterValue' }>);
  export type FlightsCheckedBagBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsCheckedBagBasedFilterValue' }>);
  export type FlightsNoCancelFeeBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsNoCancelFeeBasedFilterValue' }>);
  export type FlightsStopBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsStopBasedFilterValue' }>);
  export type _StopInfo = (NonNullable<(DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsStopBasedFilterValue' }>)['stopInfo']>);
  export type FlightsTimeBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsTimeBasedFilterValue' }>);
  export type FlightsCreditEligibleFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsCardsDisplayFilterItemFragment['value']>), { __typename: 'FlightsCreditEligibleFilterValue' }>);
}

export namespace FlightsListDisplayFilterItem {
  export type Fragment = FlightsListDisplayFilterItemFragment;
  export type SelectPositionAnalytics = (NonNullable<FlightsListDisplayFilterItemFragment['selectPositionAnalytics']>);
  export type Analytics = (NonNullable<FlightsListDisplayFilterItemFragment['analytics']>);
  export type Accessibility = (NonNullable<FlightsListDisplayFilterItemFragment['accessibility']>);
  export type DeselectAnalytics = (NonNullable<FlightsListDisplayFilterItemFragment['deselectAnalytics']>);
  export type FlightsSearchFilterValues = (NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>);
  export type ArrivalAirportCodeFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['arrivalAirportCodeFilterValue']>);
  export type ArrivalTimeFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['arrivalTimeFilterValue']>);
  export type DepartureAirportCodeFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['departureAirportCodeFilterValue']>);
  export type DepartureTimeFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['departureTimeFilterValue']>);
  export type DurationFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['durationFilterValue']>);
  export type NumOfStopFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['numOfStopFilterValue']>);
  export type StopInfo = (NonNullable<(NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['numOfStopFilterValue']>)['stopInfo']>);
  export type PreferredAirlineFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['preferredAirlineFilterValue']>);
  export type FlexibleChangePolicyBasedFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['flexibleChangePolicyBasedFilterValue']>);
  export type SeatChoiceBasedFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['seatChoiceBasedFilterValue']>);
  export type CarryOnBagBasedFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['carryOnBagBasedFilterValue']>);
  export type CheckedBagBasedFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['checkedBagBasedFilterValue']>);
  export type NoCancelFeeBasedFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['noCancelFeeBasedFilterValue']>);
  export type CreditEligibleFilterValue = (NonNullable<(NonNullable<FlightsListDisplayFilterItemFragment['flightsSearchFilterValues']>)['creditEligibleFilterValue']>);
  export type SelectAnalytics = (NonNullable<FlightsListDisplayFilterItemFragment['selectAnalytics']>);
  export type StartingPrice = (NonNullable<FlightsListDisplayFilterItemFragment['startingPrice']>);
  export type Value = (NonNullable<FlightsListDisplayFilterItemFragment['value']>);
  export type FlightsAirportCodeFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsAirportCodeFilterValue' }>);
  export type FlightsDurationBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsDurationBasedFilterValue' }>);
  export type FlightsPreferredAirlineFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsPreferredAirlineFilterValue' }>);
  export type FlightsFlexibleChangePolicyBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsFlexibleChangePolicyBasedFilterValue' }>);
  export type FlightsSeatChoiceBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsSeatChoiceBasedFilterValue' }>);
  export type FlightsCarryOnBagBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsCarryOnBagBasedFilterValue' }>);
  export type FlightsCheckedBagBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsCheckedBagBasedFilterValue' }>);
  export type FlightsNoCancelFeeBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsNoCancelFeeBasedFilterValue' }>);
  export type FlightsStopBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsStopBasedFilterValue' }>);
  export type _StopInfo = (NonNullable<(DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsStopBasedFilterValue' }>)['stopInfo']>);
  export type FlightsTimeBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsTimeBasedFilterValue' }>);
  export type FlightsCreditEligibleFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<FlightsListDisplayFilterItemFragment['value']>), { __typename: 'FlightsCreditEligibleFilterValue' }>);
}

export namespace FlightsBargainFareOffer {
  export type Fragment = FlightsBargainFareOfferFragment;
  export type BargainPricingInformation = (NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>);
  export type PriceLockup = (NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['priceLockup']>);
  export type Price = (NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['price']>);
  export type Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['price']>)['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['price']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['price']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type MainPrice = (NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['mainPrice']>);
  export type _Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['mainPrice']>)['items']>)[number]>;
  export type _FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['mainPrice']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type _Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['mainPrice']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type PricePerTraveler = (NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['pricePerTraveler']>);
  export type __Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['pricePerTraveler']>)['items']>)[number]>;
  export type __FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['pricePerTraveler']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type __Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['pricePerTraveler']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type TotalPriceForAllTravelers = (NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['totalPriceForAllTravelers']>);
  export type ___Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['totalPriceForAllTravelers']>)['items']>)[number]>;
  export type ___FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['totalPriceForAllTravelers']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type ___Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['bargainPricingInformation']>)['totalPriceForAllTravelers']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type Description = (NonNullable<FlightsBargainFareOfferFragment['description']>);
  export type ____Items = NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['description']>)['items']>)[number]>;
  export type ____FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['description']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type ____Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['description']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type Header = (NonNullable<FlightsBargainFareOfferFragment['header']>);
  export type _____Items = NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['header']>)['items']>)[number]>;
  export type _____FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['header']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type _____Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsBargainFareOfferFragment['header']>)['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type Image = (NonNullable<FlightsBargainFareOfferFragment['image']>);
  export type Journeys = NonNullable<(NonNullable<FlightsBargainFareOfferFragment['journeys']>)[number]>;
  export type FlightsJourneyAvailableFaresInformation = (NonNullable<NonNullable<(NonNullable<FlightsBargainFareOfferFragment['journeys']>)[number]>['flightsJourneyAvailableFaresInformation']>);
  export type FlightsDetailsAndFaresPresentation = (NonNullable<NonNullable<(NonNullable<FlightsBargainFareOfferFragment['journeys']>)[number]>['flightsDetailsAndFaresPresentation']>);
  export type OnClickAnalyticsList = NonNullable<(NonNullable<FlightsBargainFareOfferFragment['onClickAnalyticsList']>)[number]>;
}

export namespace FlightsSuggestedFilterMessageListing {
  export type Fragment = FlightsSuggestedFilterMessageListingFragment;
  export type SuggestedFilterDetails = (NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilterDetails']>);
  export type FlightsImagePlacardInlineFragment = ({ __typename: 'FlightsImagePlacard' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilterDetails']>), 'image' | 'heading' | 'message' | 'actions'>);
  export type Image = (NonNullable<({ __typename: 'FlightsImagePlacard' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilterDetails']>), 'image' | 'heading' | 'message' | 'actions'>)['image']>);
  export type Actions = NonNullable<(NonNullable<({ __typename: 'FlightsImagePlacard' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilterDetails']>), 'image' | 'heading' | 'message' | 'actions'>)['actions']>)[number]>;
  export type FlightsActionInlineFragment = ({ __typename: 'FlightsAction' } & Pick<NonNullable<(NonNullable<({ __typename: 'FlightsImagePlacard' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilterDetails']>), 'image' | 'heading' | 'message' | 'actions'>)['actions']>)[number]>, 'displayAction' | 'displayType' | 'type' | 'analytics'>);
  export type Analytics = (NonNullable<({ __typename: 'FlightsAction' } & Pick<NonNullable<(NonNullable<({ __typename: 'FlightsImagePlacard' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilterDetails']>), 'image' | 'heading' | 'message' | 'actions'>)['actions']>)[number]>, 'displayAction' | 'displayType' | 'type' | 'analytics'>)['analytics']>);
  export type SuggestedFilter = (NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilter']>);
  export type FlightsSuggestedFilterItemInlineFragment = ({ __typename: 'FlightsSuggestedFilterItem' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilter']>), 'selected' | 'accessibility' | 'identifier' | 'label' | 'value' | 'type'>);
  export type Accessibility = (NonNullable<({ __typename: 'FlightsSuggestedFilterItem' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilter']>), 'selected' | 'accessibility' | 'identifier' | 'label' | 'value' | 'type'>)['accessibility']>);
  export type Value = (NonNullable<({ __typename: 'FlightsSuggestedFilterItem' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilter']>), 'selected' | 'accessibility' | 'identifier' | 'label' | 'value' | 'type'>)['value']>);
  export type FlightsFlexibleChangePolicyBasedFilterValueInlineFragment = (DiscriminateUnion<(NonNullable<({ __typename: 'FlightsSuggestedFilterItem' } & Pick<(NonNullable<FlightsSuggestedFilterMessageListingFragment['suggestedFilter']>), 'selected' | 'accessibility' | 'identifier' | 'label' | 'value' | 'type'>)['value']>), { __typename: 'FlightsFlexibleChangePolicyBasedFilterValue' }>);
}

export namespace FlightsSustainabilityMessage {
  export type Fragment = FlightsSustainabilityMessageFragment;
  export type Details = (NonNullable<FlightsSustainabilityMessageFragment['details']>);
  export type Information = (NonNullable<FlightsSustainabilityMessageFragment['information']>);
}

export namespace FlightsSustainabilityDialogDetails {
  export type Fragment = FlightsSustainabilityDialogDetailsFragment;
  export type Dismiss = (NonNullable<FlightsSustainabilityDialogDetailsFragment['dismiss']>);
  export type ClosingText = (NonNullable<FlightsSustainabilityDialogDetailsFragment['closingText']>);
  export type IconRow = (NonNullable<FlightsSustainabilityDialogDetailsFragment['iconRow']>);
  export type FlightsIconAndHeadingInlineFragment = ({ __typename: 'FlightsIconAndHeading' } & Pick<(NonNullable<FlightsSustainabilityDialogDetailsFragment['iconRow']>), 'heading' | 'icons'>);
  export type Icons = NonNullable<(NonNullable<({ __typename: 'FlightsIconAndHeading' } & Pick<(NonNullable<FlightsSustainabilityDialogDetailsFragment['iconRow']>), 'heading' | 'icons'>)['icons']>)[number]>;
  export type Introduction = NonNullable<(NonNullable<FlightsSustainabilityDialogDetailsFragment['introduction']>)[number]>;
}

export namespace FlightsTextSection {
  export type Fragment = FlightsTextSectionFragment;
  export type DisplayAnalytics = (NonNullable<FlightsTextSectionFragment['displayAnalytics']>);
  export type Messages = NonNullable<(NonNullable<FlightsTextSectionFragment['messages']>)[number]>;
}

export namespace FlightsFeedback {
  export type Fragment = FlightsFeedbackFragment;
  export type FeedbackLinkAction = (NonNullable<FlightsFeedbackFragment['feedbackLinkAction']>);
  export type IconAndLabel = (NonNullable<FlightsFeedbackFragment['iconAndLabel']>);
  export type Icon = (NonNullable<(NonNullable<FlightsFeedbackFragment['iconAndLabel']>)['icon']>);
}

export namespace FlightsCouponCredit {
  export type Fragment = FlightsCouponCreditFragment;
  export type CouponCreditAction = (NonNullable<FlightsCouponCreditFragment['couponCreditAction']>);
  export type ImageListingLabel = (NonNullable<FlightsCouponCreditFragment['imageListingLabel']>);
}

export namespace FlightsImageListingLabel {
  export type Fragment = FlightsImageListingLabelFragment;
  export type Image = (NonNullable<FlightsImageListingLabelFragment['image']>);
}

export namespace MultiItemSearchContext {
  export type Fragment = MultiItemSearchContextFragment;
  export type Flights = NonNullable<(NonNullable<MultiItemSearchContextFragment['flights']>)[number]>;
  export type Primary = (NonNullable<NonNullable<(NonNullable<MultiItemSearchContextFragment['flights']>)[number]>['primary']>);
  export type JourneyCriterias = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemSearchContextFragment['flights']>)[number]>['primary']>)['journeyCriterias']>)[number]>;
  export type DepartureDate = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemSearchContextFragment['flights']>)[number]>['primary']>)['journeyCriterias']>)[number]>['departureDate']>);
  export type SearchPreferences = (NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemSearchContextFragment['flights']>)[number]>['primary']>)['searchPreferences']>);
  export type Travelers = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemSearchContextFragment['flights']>)[number]>['primary']>)['travelers']>)[number]>;
}

export namespace FlightsEgdsElementWrapper {
  export type Fragment = FlightsEgdsElementWrapperFragment;
  export type Element = (NonNullable<FlightsEgdsElementWrapperFragment['element']>);
}

export namespace FlightsCrossSellMessage {
  export type Fragment = FlightsCrossSellMessageFragment;
  export type MultiItemFlightCrossSellPrimer = (NonNullable<FlightsCrossSellMessageFragment['multiItemFlightCrossSellPrimer']>);
  export type MultiItemSearchContext = (NonNullable<(NonNullable<FlightsCrossSellMessageFragment['multiItemFlightCrossSellPrimer']>)['multiItemSearchContext']>);
}

export namespace FlightsSponsoredContentAdListing {
  export type Fragment = FlightsSponsoredContentAdListingFragment;
  export type SponsoredContentPlacement = (NonNullable<FlightsSponsoredContentAdListingFragment['sponsoredContentPlacement']>);
  export type SponsoredContentContext = (NonNullable<(NonNullable<FlightsSponsoredContentAdListingFragment['sponsoredContentPlacement']>)['sponsoredContentContext']>);
  export type Targeting = (NonNullable<(NonNullable<(NonNullable<FlightsSponsoredContentAdListingFragment['sponsoredContentPlacement']>)['sponsoredContentContext']>)['targeting']>);
  export type DateEnd = (NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsSponsoredContentAdListingFragment['sponsoredContentPlacement']>)['sponsoredContentContext']>)['targeting']>)['dateEnd']>);
  export type DateStart = (NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsSponsoredContentAdListingFragment['sponsoredContentPlacement']>)['sponsoredContentContext']>)['targeting']>)['dateStart']>);
}

export namespace FlightsStandardOffer {
  export type Fragment = FlightsStandardOfferFragment;
  export type Badges = NonNullable<(NonNullable<FlightsStandardOfferFragment['badges']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['badges']>)[number]>['icon']>);
  export type Journeys = NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>;
  export type Airlines = NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['airlines']>)[number]>;
  export type Image = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['airlines']>)[number]>['image']>);
  export type DepartureAndArrivalTime = (NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['departureAndArrivalTime']>);
  export type Items = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['departureAndArrivalTime']>)['items']>)[number]>;
  export type DisplayAction = (NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['displayAction']>);
  export type FlightsJourneyAvailableFaresInformation = (NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['flightsJourneyAvailableFaresInformation']>);
  export type FlightsDetailsAndFaresPresentation = (NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['flightsDetailsAndFaresPresentation']>);
  export type AdjustedStayDatesMessage = (NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['adjustedStayDatesMessage']>);
  export type RestrictiveAmenityIcons = NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['restrictiveAmenityIcons']>)[number]>;
  export type HighlightRelevantFaresAnalytics = NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsStandardOfferFragment['journeys']>)[number]>['highlightRelevantFaresAnalytics']>)[number]>;
  export type PricingInformation = (NonNullable<FlightsStandardOfferFragment['pricingInformation']>);
  export type LoyaltyEarnMessage = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['loyaltyEarnMessage']>);
  export type PartnerLoyaltyEarnMessage = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['partnerLoyaltyEarnMessage']>);
  export type LoyaltyPointsOption = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['loyaltyPointsOption']>);
  export type Price = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['price']>);
  export type _Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['price']>)['items']>)[number]>;
  export type MainPrice = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['mainPrice']>);
  export type __Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['mainPrice']>)['items']>)[number]>;
  export type SubPrice = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['subPrice']>);
  export type ___Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['subPrice']>)['items']>)[number]>;
  export type PricePerTraveler = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['pricePerTraveler']>);
  export type ____Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['pricePerTraveler']>)['items']>)[number]>;
  export type TotalPriceForAllTravelers = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['totalPriceForAllTravelers']>);
  export type _____Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['totalPriceForAllTravelers']>)['items']>)[number]>;
  export type PriceLockup = (NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['priceLockup']>);
  export type SubTexts = NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['subTexts']>)[number]>;
  export type EgdsStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['pricingInformation']>)['subTexts']>)[number]>, { __typename: 'EGDSStylizedText' }>);
  export type RestrictiveFareRules = (NonNullable<FlightsStandardOfferFragment['restrictiveFareRules']>);
  export type _DisplayAction = (NonNullable<(NonNullable<FlightsStandardOfferFragment['restrictiveFareRules']>)['displayAction']>);
  export type _Icon = (NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['restrictiveFareRules']>)['displayAction']>)['icon']>);
  export type Label = (NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['restrictiveFareRules']>)['displayAction']>)['label']>);
  export type ______Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['restrictiveFareRules']>)['displayAction']>)['label']>)['items']>)[number]>;
  export type SponsoredAirline = (NonNullable<FlightsStandardOfferFragment['sponsoredAirline']>);
  export type AirlineImage = (NonNullable<(NonNullable<FlightsStandardOfferFragment['sponsoredAirline']>)['airlineImage']>);
  export type Tag = (NonNullable<FlightsStandardOfferFragment['tag']>);
  export type _Image = (NonNullable<(NonNullable<FlightsStandardOfferFragment['tag']>)['image']>);
  export type FlightsOfferAnalytics = (NonNullable<FlightsStandardOfferFragment['flightsOfferAnalytics']>);
  export type OnViewedAnalyticsList = NonNullable<(NonNullable<(NonNullable<FlightsStandardOfferFragment['flightsOfferAnalytics']>)['onViewedAnalyticsList']>)[number]>;
  export type OnClickAnalyticsList = NonNullable<(NonNullable<FlightsStandardOfferFragment['onClickAnalyticsList']>)[number]>;
  export type SponsoredUpsell = (NonNullable<FlightsStandardOfferFragment['sponsoredUpsell']>);
}

export namespace FlightsCreditsAvailableListing {
  export type Fragment = FlightsCreditsAvailableListingFragment;
  export type ImmediateDialogAction = (NonNullable<FlightsCreditsAvailableListingFragment['immediateDialogAction']>);
  export type Analytics = (NonNullable<(NonNullable<FlightsCreditsAvailableListingFragment['immediateDialogAction']>)['analytics']>);
  export type Dialog = (NonNullable<(NonNullable<FlightsCreditsAvailableListingFragment['immediateDialogAction']>)['dialog']>);
  export type CloseAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsCreditsAvailableListingFragment['immediateDialogAction']>)['dialog']>)['closeAnalytics']>);
  export type DialogContents = NonNullable<(NonNullable<(NonNullable<FlightsCreditsAvailableListingFragment['immediateDialogAction']>)['dialogContents']>)[number]>;
  export type MessagingCardPlacard = (NonNullable<FlightsCreditsAvailableListingFragment['messagingCardPlacard']>);
  export type Button = (NonNullable<(NonNullable<FlightsCreditsAvailableListingFragment['messagingCardPlacard']>)['button']>);
  export type MessagingCard = (NonNullable<(NonNullable<FlightsCreditsAvailableListingFragment['messagingCardPlacard']>)['messagingCard']>);
  export type OnViewedAnalytics = (NonNullable<(NonNullable<FlightsCreditsAvailableListingFragment['messagingCardPlacard']>)['onViewedAnalytics']>);
  export type ToastNotification = (NonNullable<FlightsCreditsAvailableListingFragment['toastNotification']>);
}

export namespace FlightsActionButton {
  export type Fragment = FlightsActionButtonFragment;
  export type ClientAction = (NonNullable<FlightsActionButtonFragment['clientAction']>);
  export type AnalyticsList = NonNullable<(NonNullable<(NonNullable<FlightsActionButtonFragment['clientAction']>)['analyticsList']>)[number]>;
  export type Icon = (NonNullable<FlightsActionButtonFragment['icon']>);
  export type Action = (NonNullable<FlightsActionButtonFragment['action']>);
  export type Analytics = (NonNullable<(NonNullable<FlightsActionButtonFragment['action']>)['analytics']>);
}

export namespace FlightsCreditSelectorOpenAction {
  export type Fragment = FlightsCreditSelectorOpenActionFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsCreditSelectorOpenActionFragment['analyticsList']>)[number]>;
}

export namespace FlightsSelectionAction {
  export type Fragment = FlightsSelectionActionFragment;
}

export namespace FlightsBoundNavigation {
  export type Fragment = FlightsBoundNavigationFragment;
}

export namespace FlightsNavigateToDetails {
  export type Fragment = FlightsNavigateToDetailsFragment;
  export type NextPage = (NonNullable<FlightsNavigateToDetailsFragment['nextPage']>);
  export type PackagesUrl = (NonNullable<FlightsNavigateToDetailsFragment['packagesUrl']>);
}

export namespace MultiItemSelectProducts {
  export type Fragment = MultiItemSelectProductsFragment;
  export type FlightsOfferNaturalKeys = (NonNullable<MultiItemSelectProductsFragment['flightsOfferNaturalKeys']>);
}

export namespace MultiItemSelectPackage {
  export type Fragment = MultiItemSelectPackageFragment;
}

export namespace UiMessagingCard {
  export type Fragment = UiMessagingCardFragment;
  export type Graphic = (NonNullable<UiMessagingCardFragment['graphic']>);
}

export namespace FlightsMarkAndLabel {
  export type Fragment = FlightsMarkAndLabelFragment;
  export type Mark = (NonNullable<FlightsMarkAndLabelFragment['mark']>);
  export type StylisedText = (NonNullable<FlightsMarkAndLabelFragment['stylisedText']>);
}

export namespace FlightsToggleSearch {
  export type Fragment = FlightsToggleSearchFragment;
  export type CollapseActionable = (NonNullable<FlightsToggleSearchFragment['collapseActionable']>);
  export type ExpandActionable = (NonNullable<FlightsToggleSearchFragment['expandActionable']>);
}

export namespace IconSearch {
  export type Fragment = IconSearchFragment;
}

export namespace TogglePhaseSearch {
  export type Fragment = TogglePhaseSearchFragment;
  export type Analytics = (NonNullable<TogglePhaseSearchFragment['analytics']>);
  export type Icon = (NonNullable<TogglePhaseSearchFragment['icon']>);
}

export namespace FlightsIconPlacard {
  export type Fragment = FlightsIconPlacardFragment;
  export type Icon = (NonNullable<FlightsIconPlacardFragment['icon']>);
  export type Actions = NonNullable<(NonNullable<FlightsIconPlacardFragment['actions']>)[number]>;
}

export namespace FlightAction {
  export type Fragment = FlightActionFragment;
  export type Analytics = (NonNullable<FlightActionFragment['analytics']>);
  export type AnalyticsList = NonNullable<(NonNullable<FlightActionFragment['analyticsList']>)[number]>;
  export type DisplayAnalytics = (NonNullable<FlightActionFragment['displayAnalytics']>);
  export type AccessibilityActionMessage = (NonNullable<FlightActionFragment['accessibilityActionMessage']>);
  export type Icon = (NonNullable<FlightActionFragment['icon']>);
  export type JourneySearchCriteria = (NonNullable<FlightActionFragment['journeySearchCriteria']>);
  export type PreviousFlightSelections = NonNullable<(NonNullable<(NonNullable<FlightActionFragment['journeySearchCriteria']>)['previousFlightSelections']>)[number]>;
  export type JourneyCriteria = NonNullable<(NonNullable<(NonNullable<FlightActionFragment['journeySearchCriteria']>)['journeyCriteria']>)[number]>;
  export type DepartureDate = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightActionFragment['journeySearchCriteria']>)['journeyCriteria']>)[number]>['departureDate']>);
  export type SearchPreferences = (NonNullable<(NonNullable<FlightActionFragment['journeySearchCriteria']>)['searchPreferences']>);
  export type RelativeUri = (NonNullable<FlightActionFragment['relativeURI']>);
  export type RelativePackageableUri = (NonNullable<FlightActionFragment['relativePackageableURI']>);
  export type StepIndicator = (NonNullable<FlightActionFragment['stepIndicator']>);
  export type SearchPagination = (NonNullable<FlightActionFragment['searchPagination']>);
}

export namespace FlightsStepIndicator {
  export type Fragment = FlightsStepIndicatorFragment;
  export type ErrorAnalytics = (NonNullable<FlightsStepIndicatorFragment['errorAnalytics']>);
}

export namespace CoordinateInformationSearch {
  export type Fragment = CoordinateInformationSearchFragment;
  export type Icon = (NonNullable<CoordinateInformationSearchFragment['icon']>);
  export type FlightDetailsWarningInfo = (NonNullable<CoordinateInformationSearchFragment['flightDetailsWarningInfo']>);
  export type TitleAndAccessibilityMessage = (NonNullable<CoordinateInformationSearchFragment['titleAndAccessibilityMessage']>);
}

export namespace FlightsJourneyAvailableFares {
  export type Fragment = FlightsJourneyAvailableFaresFragment;
  export type ApplySelection = (NonNullable<FlightsJourneyAvailableFaresFragment['applySelection']>);
  export type FareChoiceInformation = (NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>);
  export type DefaultBaggageInformation = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['defaultBaggageInformation']>);
  export type BagFeesMoreInfo = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['bagFeesMoreInfo']>)[number]>;
  export type Items = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['bagFeesMoreInfo']>)[number]>['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['bagFeesMoreInfo']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type Details = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['details']>)[number]>;
  export type Fares = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>;
  export type MultiItemAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['multiItemAction']>);
  export type MultiItemSelectPackageActionInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['multiItemAction']>), { __typename: 'MultiItemSelectPackageAction' }>);
  export type MultiItemSelectProductsActionInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['multiItemAction']>), { __typename: 'MultiItemSelectProductsAction' }>);
  export type FlightsOfferNaturalKeys = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['multiItemAction']>), { __typename: 'MultiItemSelectProductsAction' }>)['flightsOfferNaturalKeys']>);
  export type _FlightsOfferNaturalKeys = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['flightsOfferNaturalKeys']>);
  export type BaggageFeesInformation = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>);
  export type _Details = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>)['details']>)[number]>;
  export type SelectFareAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['selectFareAction']>);
  export type CollapsedRules = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['collapsedRules']>);
  export type ExpandedRules = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['expandedRules']>)[number]>;
  export type AmenityHierarchyRules = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityHierarchyRules']>)[number]>;
  export type AmenityRules = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>);
  export type Amenities = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>)['amenities']>)[number]>;
  export type ChooseFareAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['chooseFareAction']>);
  export type LoyaltyPointsOption = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['loyaltyPointsOption']>);
  export type PartnerLoyaltyEarnAward = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['partnerLoyaltyEarnAward']>);
  export type Recommendation = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['recommendation']>);
  export type ShowMoreAmenitiesToggle = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['showMoreAmenitiesToggle']>);
  export type Badges = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['badges']>)[number]>;
  export type PriceLockup = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['fares']>)[number]>['priceLockup']>);
  export type Heading = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['heading']>);
  export type PercentageDelaysAndCancellationLink = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['percentageDelaysAndCancellationLink']>);
  export type Analytics = (NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['percentageDelaysAndCancellationLink']>)['analytics']>);
  export type SustainabilityInformation = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['sustainabilityInformation']>);
  export type Dialogs = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['fareChoiceInformation']>)['dialogs']>)[number]>;
  export type FlightsJourneyHeaders = (NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneyHeaders']>);
  export type FlightsJourneySubheadingMark = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneyHeaders']>)['flightsJourneySubheadingMark']>);
  export type Url = (NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneyHeaders']>)['flightsJourneySubheadingMark']>)['url']>);
  export type JourneyAmenities = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneyHeaders']>)['journeyAmenities']>);
  export type FlightsJourneyInformation = (NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneyInformation']>);
  export type FlightsJourneySummary = (NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneySummary']>);
  export type _Heading = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneySummary']>)['heading']>);
  export type DifferentDayArrival = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneySummary']>)['differentDayArrival']>);
  export type BasicFlightDetails = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneySummary']>)['basicFlightDetails']>)[number]>;
  export type FlightsBargainJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>);
  export type FormattedPrice = (NonNullable<(DiscriminateUnion<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>)['formattedPrice']>);
  export type _Items = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<FlightsJourneyAvailableFaresFragment['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>)['formattedPrice']>)['items']>)[number]>;
  export type HygieneAmenitiesPresentation = (NonNullable<FlightsJourneyAvailableFaresFragment['hygieneAmenitiesPresentation']>);
  export type AmenitiesAction = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['hygieneAmenitiesPresentation']>)['amenitiesAction']>);
  export type AirlineAmenityGroups = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['hygieneAmenitiesPresentation']>)['airlineAmenityGroups']>)[number]>;
  export type _Amenities = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['hygieneAmenitiesPresentation']>)['airlineAmenityGroups']>)[number]>['amenities']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresFragment['hygieneAmenitiesPresentation']>)['airlineAmenityGroups']>)[number]>['amenities']>)[number]>['icon']>);
}

export namespace FlightsDetailsAndFaresPresentationFragment {
  export type Fragment = FlightsDetailsAndFaresPresentationFragmentFragment;
  export type Content = (NonNullable<FlightsDetailsAndFaresPresentationFragmentFragment['content']>);
  export type FlightsFaresWrapper = (NonNullable<FlightsDetailsAndFaresPresentationFragmentFragment['flightsFaresWrapper']>);
  export type Footer = (NonNullable<FlightsDetailsAndFaresPresentationFragmentFragment['footer']>);
  export type Trigger = (NonNullable<FlightsDetailsAndFaresPresentationFragmentFragment['trigger']>);
}

export namespace FlightsDetailsAndFaresContentFragment {
  export type Fragment = FlightsDetailsAndFaresContentFragmentFragment;
  export type NestedDialogs = NonNullable<(NonNullable<FlightsDetailsAndFaresContentFragmentFragment['nestedDialogs']>)[number]>;
  export type PriceMatchPromiseNestedDialogs = NonNullable<(NonNullable<FlightsDetailsAndFaresContentFragmentFragment['priceMatchPromiseNestedDialogs']>)[number]>;
  export type Sections = NonNullable<(NonNullable<FlightsDetailsAndFaresContentFragmentFragment['sections']>)[number]>;
}

export namespace FlightsFaresInformationFragment {
  export type Fragment = FlightsFaresInformationFragmentFragment;
  export type Carousel = (NonNullable<FlightsFaresInformationFragmentFragment['carousel']>);
  export type FaresCarousel = (NonNullable<FlightsFaresInformationFragmentFragment['faresCarousel']>);
  export type Fares = NonNullable<(NonNullable<FlightsFaresInformationFragmentFragment['fares']>)[number]>;
  export type ScrollAnalytics = NonNullable<(NonNullable<FlightsFaresInformationFragmentFragment['scrollAnalytics']>)[number]>;
}

export namespace EgdsCarouselFragment {
  export type Fragment = EgdsCarouselFragmentFragment;
  export type NextButton = (NonNullable<EgdsCarouselFragmentFragment['nextButton']>);
  export type PreviousButton = (NonNullable<EgdsCarouselFragmentFragment['previousButton']>);
}

export namespace FlightsDialogSheetFragment {
  export type Fragment = FlightsDialogSheetFragmentFragment;
  export type Dialog = (NonNullable<FlightsDialogSheetFragmentFragment['dialog']>);
  export type Sheet = (NonNullable<FlightsDialogSheetFragmentFragment['sheet']>);
}

export namespace FlightsDetailsAndFaresFooterFragment {
  export type Fragment = FlightsDetailsAndFaresFooterFragmentFragment;
  export type Action = (NonNullable<FlightsDetailsAndFaresFooterFragmentFragment['action']>);
  export type PriceLockup = (NonNullable<FlightsDetailsAndFaresFooterFragmentFragment['priceLockup']>);
}

export namespace FlightsJourneyHeaderFragment {
  export type Fragment = FlightsJourneyHeaderFragmentFragment;
  export type Content = NonNullable<(NonNullable<FlightsJourneyHeaderFragmentFragment['content']>)[number]>;
}

export namespace FlightsJourneyDetailsInformationFragment {
  export type Fragment = FlightsJourneyDetailsInformationFragmentFragment;
  export type Content = NonNullable<(NonNullable<FlightsJourneyDetailsInformationFragmentFragment['content']>)[number]>;
  export type Expando = (NonNullable<FlightsJourneyDetailsInformationFragmentFragment['expando']>);
}

export namespace FlightsJourneyDetailsFragment {
  export type Fragment = FlightsJourneyDetailsFragmentFragment;
  export type JourneySections = NonNullable<(NonNullable<FlightsJourneyDetailsFragmentFragment['journeySections']>)[number]>;
  export type JourneyAmenities = NonNullable<(NonNullable<FlightsJourneyDetailsFragmentFragment['journeyAmenities']>)[number]>;
}

export namespace FlightsJourneyWithDetailsFragment {
  export type Fragment = FlightsJourneyWithDetailsFragmentFragment;
  export type Details = NonNullable<(NonNullable<FlightsJourneyWithDetailsFragmentFragment['details']>)[number]>;
  export type Footnotes = NonNullable<(NonNullable<FlightsJourneyWithDetailsFragmentFragment['footnotes']>)[number]>;
}

export namespace FlightsHygieneAmenitiesSectionFragment {
  export type Fragment = FlightsHygieneAmenitiesSectionFragmentFragment;
  export type Amenities = NonNullable<(NonNullable<FlightsHygieneAmenitiesSectionFragmentFragment['amenities']>)[number]>;
}

export namespace TextWrapperFragment {
  export type Fragment = TextWrapperFragmentFragment;
  export type Text = (NonNullable<TextWrapperFragmentFragment['text']>);
}

export namespace FlightsSustainabilityCardFragment {
  export type Fragment = FlightsSustainabilityCardFragmentFragment;
  export type CardContent = (NonNullable<FlightsSustainabilityCardFragmentFragment['cardContent']>);
  export type Text = NonNullable<(NonNullable<(NonNullable<FlightsSustainabilityCardFragmentFragment['cardContent']>)['text']>)[number]>;
  export type Icon = (NonNullable<(NonNullable<FlightsSustainabilityCardFragmentFragment['cardContent']>)['icon']>);
}

export namespace FareInformationCardFragment {
  export type Fragment = FareInformationCardFragmentFragment;
  export type Action = NonNullable<(NonNullable<FareInformationCardFragmentFragment['action']>)[number]>;
  export type Amenities = (NonNullable<FareInformationCardFragmentFragment['amenities']>);
  export type FareDetails = NonNullable<(NonNullable<FareInformationCardFragmentFragment['fareDetails']>)[number]>;
  export type Heading = (NonNullable<FareInformationCardFragmentFragment['heading']>);
  export type PriceMatchPromise = (NonNullable<FareInformationCardFragmentFragment['priceMatchPromise']>);
  export type ScrollAnalytics = NonNullable<(NonNullable<FareInformationCardFragmentFragment['scrollAnalytics']>)[number]>;
  export type FareTabs = (NonNullable<FareInformationCardFragmentFragment['fareTabs']>);
  export type SponsoredContent = (NonNullable<FareInformationCardFragmentFragment['sponsoredContent']>);
}

export namespace EgdsBasicTabsFragment {
  export type Fragment = EgdsBasicTabsFragmentFragment;
  export type Tabs = NonNullable<(NonNullable<EgdsBasicTabsFragmentFragment['tabs']>)[number]>;
  export type EgdsBasicTabInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsBasicTabsFragmentFragment['tabs']>)[number]>, { __typename: 'EGDSBasicTab' }>);
  export type ClickAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsBasicTabsFragmentFragment['tabs']>)[number]>, { __typename: 'EGDSBasicTab' }>)['clickAnalytics']>);
}

export namespace FlightsSideSheetFragment {
  export type Fragment = FlightsSideSheetFragmentFragment;
  export type Content = NonNullable<(NonNullable<FlightsSideSheetFragmentFragment['content']>)[number]>;
  export type Footer = NonNullable<(NonNullable<FlightsSideSheetFragmentFragment['footer']>)[number]>;
}

export namespace JourneySectionFragment {
  export type Fragment = JourneySectionFragmentFragment;
  export type JourneyConnectionInformation = NonNullable<(NonNullable<JourneySectionFragmentFragment['journeyConnectionInformation']>)[number]>;
  export type AdditionalInformationInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<JourneySectionFragmentFragment['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>);
  export type FlightsConnectionInformationInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<JourneySectionFragmentFragment['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>);
}

export namespace EgdsExpandoFragment {
  export type Fragment = EgdsExpandoFragmentFragment;
  export type EgdsExpandoPeekInlineFragment = (DiscriminateUnion<EgdsExpandoFragmentFragment, { __typename: 'EGDSExpandoPeek' }>);
  export type EgdsExpandoListItemInlineFragment = (DiscriminateUnion<EgdsExpandoFragmentFragment, { __typename: 'EGDSExpandoListItem' }>);
  export type EgdsExpandoLinkInlineFragment = (DiscriminateUnion<EgdsExpandoFragmentFragment, { __typename: 'EGDSExpandoLink' }>);
}

export namespace EgdsIconTextFragment {
  export type Fragment = EgdsIconTextFragmentFragment;
  export type Icon = (NonNullable<EgdsIconTextFragmentFragment['icon']>);
}

export namespace EgdsCarouselContainerFragment {
  export type Fragment = EgdsCarouselContainerFragmentFragment;
}

export namespace FareActionFragment {
  export type Fragment = FareActionFragmentFragment;
  export type Action = (NonNullable<FareActionFragmentFragment['action']>);
}

export namespace FlightsCategorizedListFragment {
  export type Fragment = FlightsCategorizedListFragmentFragment;
  export type Sections = NonNullable<(NonNullable<FlightsCategorizedListFragmentFragment['sections']>)[number]>;
}

export namespace FlightsCategorizedListSectionFragment {
  export type Fragment = FlightsCategorizedListSectionFragmentFragment;
  export type Items = NonNullable<(NonNullable<FlightsCategorizedListSectionFragmentFragment['items']>)[number]>;
}

export namespace FlightsCategorizedListItemFragment {
  export type Fragment = FlightsCategorizedListItemFragmentFragment;
  export type Primary = (NonNullable<FlightsCategorizedListItemFragmentFragment['primary']>);
}

export namespace FareHeadingFragment {
  export type Fragment = FareHeadingFragmentFragment;
  export type Badge = (NonNullable<FareHeadingFragmentFragment['badge']>);
  export type FarePricing = NonNullable<(NonNullable<FareHeadingFragmentFragment['farePricing']>)[number]>;
}

export namespace FarePriceMatchPromisePresentationFragment {
  export type Fragment = FarePriceMatchPromisePresentationFragmentFragment;
  export type Cards = NonNullable<(NonNullable<FarePriceMatchPromisePresentationFragmentFragment['cards']>)[number]>;
}

export namespace FarePriceMatchPromiseStaticCardFragment {
  export type Fragment = FarePriceMatchPromiseStaticCardFragmentFragment;
  export type Heading = (NonNullable<FarePriceMatchPromiseStaticCardFragmentFragment['heading']>);
}

export namespace FarePriceMatchPromiseRemovableCardFragment {
  export type Fragment = FarePriceMatchPromiseRemovableCardFragmentFragment;
  export type Heading = (NonNullable<FarePriceMatchPromiseRemovableCardFragmentFragment['heading']>);
  export type RemoveAction = (NonNullable<FarePriceMatchPromiseRemovableCardFragmentFragment['removeAction']>);
}

export namespace AdditionalInformationFragment {
  export type Fragment = AdditionalInformationFragmentFragment;
  export type NextFlightOriginAirportInfo = (NonNullable<AdditionalInformationFragmentFragment['nextFlightOriginAirportInfo']>);
}

export namespace FlightsConnectionInformationFragment {
  export type Fragment = FlightsConnectionInformationFragmentFragment;
  export type FlightsConnection = (NonNullable<FlightsConnectionInformationFragmentFragment['flightsConnection']>);
  export type ConnectionArrival = (NonNullable<(NonNullable<FlightsConnectionInformationFragmentFragment['flightsConnection']>)['connectionArrival']>);
  export type ConnectionDeparture = (NonNullable<(NonNullable<FlightsConnectionInformationFragmentFragment['flightsConnection']>)['connectionDeparture']>);
  export type JourneyAmenities = (NonNullable<(NonNullable<FlightsConnectionInformationFragmentFragment['flightsConnection']>)['journeyAmenities']>);
}

export namespace EgdsExpandoPeekFragment {
  export type Fragment = EgdsExpandoPeekFragmentFragment;
  export type ExpandAnalytics = (NonNullable<EgdsExpandoPeekFragmentFragment['expandAnalytics']>);
}

export namespace EgdsExpandoListItemFragment {
  export type Fragment = EgdsExpandoListItemFragmentFragment;
  export type CollapseAnalytics = (NonNullable<EgdsExpandoListItemFragmentFragment['collapseAnalytics']>);
  export type ExpandAnalytics = (NonNullable<EgdsExpandoListItemFragmentFragment['expandAnalytics']>);
}

export namespace EgdsExpandoLinkFragment {
  export type Fragment = EgdsExpandoLinkFragmentFragment;
  export type CollapseAnalytics = (NonNullable<EgdsExpandoLinkFragmentFragment['collapseAnalytics']>);
  export type ExpandAnalytics = (NonNullable<EgdsExpandoLinkFragmentFragment['expandAnalytics']>);
}

export namespace FlightsInformationTextFragment {
  export type Fragment = FlightsInformationTextFragmentFragment;
  export type Content = NonNullable<(NonNullable<FlightsInformationTextFragmentFragment['content']>)[number]>;
}

export namespace FlightsInformationTextItemFragment {
  export type Fragment = FlightsInformationTextItemFragmentFragment;
}

export namespace FarePricingFragment {
  export type Fragment = FarePricingFragmentFragment;
  export type PriceLockup = (NonNullable<FarePricingFragmentFragment['priceLockup']>);
}

export namespace FarePriceMatchPromiseSelectableCardFragment {
  export type Fragment = FarePriceMatchPromiseSelectableCardFragmentFragment;
  export type Checkbox = (NonNullable<FarePriceMatchPromiseSelectableCardFragmentFragment['checkbox']>);
  export type Heading = (NonNullable<FarePriceMatchPromiseSelectableCardFragmentFragment['heading']>);
  export type InfoTrigger = (NonNullable<FarePriceMatchPromiseSelectableCardFragmentFragment['infoTrigger']>);
}

export namespace EgdsSpannableTextFragment {
  export type Fragment = EgdsSpannableTextFragmentFragment;
  export type Contents = NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>;
  export type EgdsHeadingInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSHeading' }>);
  export type EgdsParagraphInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSParagraph' }>);
  export type EgdsIconTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSIconText' }>)['icon']>);
  export type EgdsStandardLinkInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>);
  export type Action = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type Resource = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type EgdsPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type EgdsStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['contents']>)[number]>, { __typename: 'EGDSStylizedText' }>);
  export type InlineContent = NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>;
  export type _EgdsHeadingInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>, { __typename: 'EGDSHeading' }>);
  export type EgdsGraphicTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>, { __typename: 'EGDSGraphicText' }>);
  export type _EgdsStandardLinkInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>);
  export type _Action = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type _Resource = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type _Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type _EgdsPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type _EgdsStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentFragment['inlineContent']>)[number]>, { __typename: 'EGDSStylizedText' }>);
}

export namespace MarkWrapperFragment {
  export type Fragment = MarkWrapperFragmentFragment;
  export type Mark = (NonNullable<MarkWrapperFragmentFragment['mark']>);
}

export namespace IconWrapperFragment {
  export type Fragment = IconWrapperFragmentFragment;
  export type Icons = NonNullable<(NonNullable<IconWrapperFragmentFragment['icons']>)[number]>;
}

export namespace SuperlativeTextFragment {
  export type Fragment = SuperlativeTextFragmentFragment;
  export type Text = (NonNullable<SuperlativeTextFragmentFragment['text']>);
}

export namespace FlightsJourneyAmenities {
  export type Fragment = FlightsJourneyAmenitiesFragment;
  export type Amenities = NonNullable<(NonNullable<FlightsJourneyAmenitiesFragment['amenities']>)[number]>;
  export type Analytics = (NonNullable<FlightsJourneyAmenitiesFragment['analytics']>);
}

export namespace FlightsJourneyAmenitiesWithLabel {
  export type Fragment = FlightsJourneyAmenitiesWithLabelFragment;
  export type Rules = (NonNullable<FlightsJourneyAmenitiesWithLabelFragment['rules']>);
}

export namespace Pagination {
  export type Fragment = PaginationFragment;
}

export namespace FlightsIconAndLabel {
  export type Fragment = FlightsIconAndLabelFragment;
  export type Icon = (NonNullable<FlightsIconAndLabelFragment['icon']>);
  export type DisplayAnalytics = NonNullable<(NonNullable<FlightsIconAndLabelFragment['displayAnalytics']>)[number]>;
  export type SubText = (NonNullable<FlightsIconAndLabelFragment['subText']>);
  export type EgdsStylizedTextInlineFragment = ({ __typename: 'EGDSStylizedText' } & Pick<(NonNullable<FlightsIconAndLabelFragment['subText']>), 'decorative' | 'text' | 'theme' | 'weight' | 'size'>);
}

export namespace FlightsJourneyInformation {
  export type Fragment = FlightsJourneyInformationFragment;
  export type Details = (NonNullable<FlightsJourneyInformationFragment['details']>);
  export type FlightJourneyDetails = (NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>);
  export type JourneySections = NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>;
  export type JourneyConnectionInformation = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>;
  export type AdditionalInformationInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>);
  export type NextFlightOriginAirportInfo = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>)['nextFlightOriginAirportInfo']>);
  export type FlightsConnectionInformationInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>);
  export type FlightsConnection = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>);
  export type ConnectionArrival = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['connectionArrival']>);
  export type ConnectionDeparture = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['connectionDeparture']>);
  export type JourneyAmenities = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['journeyAmenities']>);
  export type _JourneyAmenities = NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationFragment['flightJourneyDetails']>)['journeyAmenities']>)[number]>;
}

export namespace FlightsBadge {
  export type Fragment = FlightsBadgeFragment;
  export type Icon = (NonNullable<FlightsBadgeFragment['icon']>);
}

export namespace HotelsDate {
  export type Fragment = HotelsDateFragment;
  export type Analytics = (NonNullable<HotelsDateFragment['analytics']>);
  export type Date = (NonNullable<HotelsDateFragment['date']>);
  export type PossibleErrors = NonNullable<(NonNullable<HotelsDateFragment['possibleErrors']>)[number]>;
  export type _Analytics = (NonNullable<NonNullable<(NonNullable<HotelsDateFragment['possibleErrors']>)[number]>['analytics']>);
  export type PossibleErrorsHeader = (NonNullable<HotelsDateFragment['possibleErrorsHeader']>);
  export type Icon = (NonNullable<(NonNullable<HotelsDateFragment['possibleErrorsHeader']>)['icon']>);
  export type Label = (NonNullable<(NonNullable<HotelsDateFragment['possibleErrorsHeader']>)['label']>);
  export type Items = NonNullable<(NonNullable<(NonNullable<(NonNullable<HotelsDateFragment['possibleErrorsHeader']>)['label']>)['items']>)[number]>;
}

export namespace ClientMetaData {
  export type Fragment = ClientMetaDataFragment;
  export type PageNameAnalytics = (NonNullable<ClientMetaDataFragment['pageNameAnalytics']>);
}

export namespace FlightsRewardsPricingInfo {
  export type Fragment = FlightsRewardsPricingInfoFragment;
  export type Title = (NonNullable<FlightsRewardsPricingInfoFragment['title']>);
  export type Options = NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['options']>)[number]>;
  export type FlightsRewardsOptionInlineFragment = ({ __typename: 'FlightsRewardsOption' } & Pick<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['options']>)[number]>, 'label' | 'identifier' | 'selected' | 'accessibility'>);
  export type Accessibility = (NonNullable<({ __typename: 'FlightsRewardsOption' } & Pick<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['options']>)[number]>, 'label' | 'identifier' | 'selected' | 'accessibility'>)['accessibility']>);
  export type FlightsAccessibilityMessageInlineFragment = ({ __typename: 'FlightsAccessibilityMessage' } & Pick<(NonNullable<({ __typename: 'FlightsRewardsOption' } & Pick<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['options']>)[number]>, 'label' | 'identifier' | 'selected' | 'accessibility'>)['accessibility']>), 'usage' | 'onCompletion'>);
  export type SubText = NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>;
  export type Items = NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type FlightsPhraseDialogNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>);
  export type Dialog = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['dialog']>);
  export type Actions = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['dialog']>)['actions']>)[number]>;
  export type DisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['dialog']>)['displayedAnalytics']>);
  export type ActionableIcon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['actionableIcon']>);
  export type IconInlineFragment = ({ __typename: 'Icon' } & Pick<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['subText']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['actionableIcon']>), 'id' | 'description' | 'token'>);
  export type LoyaltyBanners = NonNullable<(NonNullable<FlightsRewardsPricingInfoFragment['loyaltyBanners']>)[number]>;
}

export namespace PageTitle {
  export type Fragment = PageTitleFragment;
  export type Date = (NonNullable<PageTitleFragment['date']>);
  export type DisclaimerSubTitle = (NonNullable<PageTitleFragment['disclaimerSubTitle']>);
  export type Title = (NonNullable<PageTitleFragment['title']>);
}

export namespace FlightsPhrase {
  export type Fragment = FlightsPhraseFragment;
  export type Items = NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type DisplayAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['displayAnalytics']>);
  export type ScrollAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['scrollAnalytics']>);
  export type FlightsPhraseDialogNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>);
  export type _Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['analytics']>);
  export type ActionableIcon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['actionableIcon']>);
  export type Dialog = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['dialog']>);
  export type Actions = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['dialog']>)['actions']>)[number]>;
  export type DisplayedAnalytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseFragment['items']>)[number]>, { __typename: 'FlightsPhraseDialogNode' }>)['dialog']>)['displayedAnalytics']>);
}

export namespace FlightsIconPhrases {
  export type Fragment = FlightsIconPhrasesFragment;
  export type Text = NonNullable<(NonNullable<FlightsIconPhrasesFragment['text']>)[number]>;
  export type Icon = (NonNullable<FlightsIconPhrasesFragment['icon']>);
}

export namespace AlternateAirportOptions {
  export type Fragment = AlternateAirportOptionsFragment;
  export type AirportOptionAnalytics = (NonNullable<AlternateAirportOptionsFragment['airportOptionAnalytics']>);
  export type AirportOptions = NonNullable<(NonNullable<AlternateAirportOptionsFragment['airportOptions']>)[number]>;
}

export namespace AirportOption {
  export type Fragment = AirportOptionFragment;
  export type Icon = (NonNullable<AirportOptionFragment['icon']>);
  export type SelectAction = (NonNullable<AirportOptionFragment['selectAction']>);
}

export namespace AlternateDateOptions {
  export type Fragment = AlternateDateOptionsFragment;
  export type DateOptionAnalytics = (NonNullable<AlternateDateOptionsFragment['dateOptionAnalytics']>);
  export type DateOptions = NonNullable<(NonNullable<AlternateDateOptionsFragment['dateOptions']>)[number]>;
}

export namespace DateOption {
  export type Fragment = DateOptionFragment;
  export type SelectAction = (NonNullable<DateOptionFragment['selectAction']>);
}

export namespace FlightsDisplayComponentCountingValue {
  export type Fragment = FlightsDisplayComponentCountingValueFragment;
}

export namespace DateFragment {
  export type Fragment = DateFragmentFragment;
}

export namespace MultiItemPackageableProduct {
  export type Fragment = MultiItemPackageableProductFragment;
  export type Flights = NonNullable<(NonNullable<MultiItemPackageableProductFragment['flights']>)[number]>;
  export type Travelers = NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPackageableProductFragment['flights']>)[number]>['travelers']>)[number]>;
}

export namespace MultiItemFlightCrossSellPrimer {
  export type Fragment = MultiItemFlightCrossSellPrimerFragment;
  export type MultiItemSearchContext = (NonNullable<MultiItemFlightCrossSellPrimerFragment['multiItemSearchContext']>);
}

export namespace FlightsCrossSellOffer {
  export type Fragment = FlightsCrossSellOfferFragment;
  export type MultiItemFlightCrossSellOfferPrimer = (NonNullable<FlightsCrossSellOfferFragment['multiItemFlightCrossSellOfferPrimer']>);
  export type MultiItemSearchContext = (NonNullable<(NonNullable<FlightsCrossSellOfferFragment['multiItemFlightCrossSellOfferPrimer']>)['multiItemSearchContext']>);
  export type MultiItemPackageableProduct = (NonNullable<(NonNullable<FlightsCrossSellOfferFragment['multiItemFlightCrossSellOfferPrimer']>)['multiItemPackageableProduct']>);
  export type BrandedDealFallBack = (NonNullable<(NonNullable<FlightsCrossSellOfferFragment['multiItemFlightCrossSellOfferPrimer']>)['brandedDealFallBack']>);
  export type Price = (NonNullable<(NonNullable<FlightsCrossSellOfferFragment['multiItemFlightCrossSellOfferPrimer']>)['price']>);
  export type Base = (NonNullable<(NonNullable<(NonNullable<FlightsCrossSellOfferFragment['multiItemFlightCrossSellOfferPrimer']>)['price']>)['base']>);
  export type TaxesAndFees = (NonNullable<(NonNullable<(NonNullable<FlightsCrossSellOfferFragment['multiItemFlightCrossSellOfferPrimer']>)['price']>)['taxesAndFees']>);
}

export namespace FlightsFiltersEventAnalytics {
  export type Fragment = FlightsFiltersEventAnalyticsFragment;
}

export namespace FlightsFilterItemAnalytics {
  export type Fragment = FlightsFilterItemAnalyticsFragment;
}

export namespace FlightsOfferNaturalKeysFragment {
  export type Fragment = FlightsOfferNaturalKeysFragmentFragment;
  export type FlightNaturalKey = (NonNullable<FlightsOfferNaturalKeysFragmentFragment['flightNaturalKey']>);
  export type Travelers = NonNullable<(NonNullable<(NonNullable<FlightsOfferNaturalKeysFragmentFragment['flightNaturalKey']>)['travelers']>)[number]>;
  export type PackagedProductsNaturalKeys = NonNullable<(NonNullable<FlightsOfferNaturalKeysFragmentFragment['packagedProductsNaturalKeys']>)[number]>;
  export type CarNaturalKeyInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragmentFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'CarNaturalKey' }>);
  export type PropertyNaturalKeyInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragmentFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'PropertyNaturalKey' }>);
  export type CheckOut = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragmentFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'PropertyNaturalKey' }>)['checkOut']>);
  export type CheckIn = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragmentFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'PropertyNaturalKey' }>)['checkIn']>);
  export type Rooms = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragmentFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'PropertyNaturalKey' }>)['rooms']>)[number]>;
}

export namespace PriceLockupFragment {
  export type Fragment = PriceLockupFragmentFragment;
}

export namespace FlightsMessagingCardPlacardFragment {
  export type Fragment = FlightsMessagingCardPlacardFragmentFragment;
  export type MessagingCard = (NonNullable<FlightsMessagingCardPlacardFragmentFragment['messagingCard']>);
  export type Button = (NonNullable<FlightsMessagingCardPlacardFragmentFragment['button']>);
  export type ClientAction = (NonNullable<(NonNullable<FlightsMessagingCardPlacardFragmentFragment['button']>)['clientAction']>);
  export type OnViewedAnalytics = (NonNullable<FlightsMessagingCardPlacardFragmentFragment['onViewedAnalytics']>);
  export type OnViewedAnalyticsList = NonNullable<(NonNullable<FlightsMessagingCardPlacardFragmentFragment['onViewedAnalyticsList']>)[number]>;
  export type ActionElement = (NonNullable<FlightsMessagingCardPlacardFragmentFragment['actionElement']>);
}

export namespace FlightsClientActionElement {
  export type Fragment = FlightsClientActionElementFragment;
}

export namespace EgdsGraphicIllustrationFragmentSearch {
  export type Fragment = EgdsGraphicIllustrationFragmentSearchFragment;
}

export namespace ClientActionFragment {
  export type Fragment = ClientActionFragmentFragment;
  export type Dialog = (NonNullable<ClientActionFragmentFragment['dialog']>);
  export type DialogContents = NonNullable<(NonNullable<ClientActionFragmentFragment['dialogContents']>)[number]>;
  export type AnalyticsList = NonNullable<(NonNullable<ClientActionFragmentFragment['analyticsList']>)[number]>;
}

export namespace EgdsFullScreenDialogFragment {
  export type Fragment = EgdsFullScreenDialogFragmentFragment;
  export type EgdsFullScreenDialogInlineFragment = ({ __typename: 'EGDSFullScreenDialog' } & Pick<EgdsFullScreenDialogFragmentFragment, 'toolbar'>);
  export type Toolbar = (NonNullable<({ __typename: 'EGDSFullScreenDialog' } & Pick<EgdsFullScreenDialogFragmentFragment, 'toolbar'>)['toolbar']>);
}

export namespace EgdsButtonFragment {
  export type Fragment = EgdsButtonFragmentFragment;
}

export namespace FlightsDialogTriggerFragment {
  export type Fragment = FlightsDialogTriggerFragmentFragment;
  export type Trigger = (NonNullable<FlightsDialogTriggerFragmentFragment['trigger']>);
}

export namespace FlightsExperienceActionButtonFragment {
  export type Fragment = FlightsExperienceActionButtonFragmentFragment;
  export type ClientAction = (NonNullable<FlightsExperienceActionButtonFragmentFragment['clientAction']>);
  export type AnalyticsList = NonNullable<(NonNullable<(NonNullable<FlightsExperienceActionButtonFragmentFragment['clientAction']>)['analyticsList']>)[number]>;
}

export namespace FlightsExperienceActionLinkFragment {
  export type Fragment = FlightsExperienceActionLinkFragmentFragment;
  export type ClientAction = (NonNullable<FlightsExperienceActionLinkFragmentFragment['clientAction']>);
  export type AnalyticsList = NonNullable<(NonNullable<(NonNullable<FlightsExperienceActionLinkFragmentFragment['clientAction']>)['analyticsList']>)[number]>;
}

export namespace EgdsDialogToolbarFragment {
  export type Fragment = EgdsDialogToolbarFragmentFragment;
}

export namespace EgdsElementFragment {
  export type Fragment = EgdsElementFragmentFragment;
  export type EgdsTextInlineFragment = (DiscriminateUnion<EgdsElementFragmentFragment, { __typename: 'EGDSText' }>);
  export type IllustrationInlineFragment = (DiscriminateUnion<EgdsElementFragmentFragment, { __typename: 'Illustration' }>);
  export type UiMessagingCardInlineFragment = (DiscriminateUnion<EgdsElementFragmentFragment, { __typename: 'UIMessagingCard' }>);
  export type Graphic = (NonNullable<(DiscriminateUnion<EgdsElementFragmentFragment, { __typename: 'UIMessagingCard' }>)['graphic']>);
  export type _IllustrationInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<EgdsElementFragmentFragment, { __typename: 'UIMessagingCard' }>)['graphic']>), { __typename: 'Illustration' }>);
  export type EgdsBulletedListInlineFragment = (DiscriminateUnion<EgdsElementFragmentFragment, { __typename: 'EGDSBulletedList' }>);
  export type ListItems = NonNullable<(NonNullable<(DiscriminateUnion<EgdsElementFragmentFragment, { __typename: 'EGDSBulletedList' }>)['listItems']>)[number]>;
}

export namespace EgdsTextFragment {
  export type Fragment = EgdsTextFragmentFragment;
  export type EgdsGraphicTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSGraphicText' }>);
  export type EgdsHeadingInlineFragment = (DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSHeading' }>);
  export type EgdsParagraphInlineFragment = (DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSParagraph' }>);
  export type EgdsIconTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSIconText' }>)['icon']>);
  export type EgdsStandardLinkInlineFragment = (DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSStandardLink' }>);
  export type Action = (NonNullable<(DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type Resource = (NonNullable<(NonNullable<(DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type EgdsPlainTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSPlainText' }>);
  export type EgdsStylizedTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSStylizedText' }>);
  export type EgdsSpannableTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentFragment, { __typename: 'EGDSSpannableText' }>);
}

export namespace FaresDialogsFragment {
  export type Fragment = FaresDialogsFragmentFragment;
  export type Dialog = (NonNullable<FaresDialogsFragmentFragment['dialog']>);
  export type DialogContent = NonNullable<(NonNullable<FaresDialogsFragmentFragment['dialogContent']>)[number]>;
  export type FlightsDialogTriggerInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FaresDialogsFragmentFragment['dialogContent']>)[number]>, { __typename: 'FlightsDialogTrigger' }>);
}

export namespace EgdsDialogFragment {
  export type Fragment = EgdsDialogFragmentFragment;
  export type CloseAnalytics = (NonNullable<EgdsDialogFragmentFragment['closeAnalytics']>);
  export type EgdsActionDialogInlineFragment = (DiscriminateUnion<EgdsDialogFragmentFragment, { __typename: 'EGDSActionDialog' }>);
  export type Footer = (NonNullable<(DiscriminateUnion<EgdsDialogFragmentFragment, { __typename: 'EGDSActionDialog' }>)['footer']>);
  export type Buttons = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<EgdsDialogFragmentFragment, { __typename: 'EGDSActionDialog' }>)['footer']>)['buttons']>)[number]>;
}

export namespace FlightsActionCheckboxFragment {
  export type Fragment = FlightsActionCheckboxFragmentFragment;
  export type Label = (NonNullable<FlightsActionCheckboxFragmentFragment['label']>);
  export type ClientAction = (NonNullable<FlightsActionCheckboxFragmentFragment['clientAction']>);
}

export namespace FlightsActionLinkFragment {
  export type Fragment = FlightsActionLinkFragmentFragment;
  export type ClientAction = (NonNullable<FlightsActionLinkFragmentFragment['clientAction']>);
  export type Icon = (NonNullable<FlightsActionLinkFragmentFragment['icon']>);
  export type Analytics = (NonNullable<FlightsActionLinkFragmentFragment['analytics']>);
}

export namespace FlightsClientActionFragment {
  export type Fragment = FlightsClientActionFragmentFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsClientActionFragmentFragment['analyticsList']>)[number]>;
  export type FlightsCreditSelectionActionInlineFragment = (DiscriminateUnion<FlightsClientActionFragmentFragment, { __typename: 'FlightsCreditSelectionAction' }>);
}

export namespace FlightsClickActionFragment {
  export type Fragment = FlightsClickActionFragmentFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsClickActionFragmentFragment['analyticsList']>)[number]>;
}

export namespace FlightsMessagingCardFragment {
  export type Fragment = FlightsMessagingCardFragmentFragment;
  export type CardContent = (NonNullable<FlightsMessagingCardFragmentFragment['cardContent']>);
  export type DisplayAnalytics = NonNullable<(NonNullable<FlightsMessagingCardFragmentFragment['displayAnalytics']>)[number]>;
}

export namespace EgdsStandardMessagingCardFragment {
  export type Fragment = EgdsStandardMessagingCardFragmentFragment;
  export type Dismiss = (NonNullable<EgdsStandardMessagingCardFragmentFragment['dismiss']>);
  export type Graphic = (NonNullable<EgdsStandardMessagingCardFragmentFragment['graphic']>);
  export type Links = NonNullable<(NonNullable<EgdsStandardMessagingCardFragmentFragment['links']>)[number]>;
  export type RightIcon = (NonNullable<EgdsStandardMessagingCardFragmentFragment['rightIcon']>);
}

export namespace EgdsDismissActionFragment {
  export type Fragment = EgdsDismissActionFragmentFragment;
  export type Analytics = (NonNullable<EgdsDismissActionFragmentFragment['analytics']>);
}

export namespace UiGraphicFragment {
  export type Fragment = UiGraphicFragmentFragment;
}

export namespace EgdsStandardLinkFragment {
  export type Fragment = EgdsStandardLinkFragmentFragment;
  export type Action = (NonNullable<EgdsStandardLinkFragmentFragment['action']>);
  export type Icon = (NonNullable<EgdsStandardLinkFragmentFragment['icon']>);
}

export namespace UiLinkActionFragment {
  export type Fragment = UiLinkActionFragmentFragment;
  export type Analytics = (NonNullable<UiLinkActionFragmentFragment['analytics']>);
  export type Resource = (NonNullable<UiLinkActionFragmentFragment['resource']>);
}

export namespace FlightsListingMessagingCard {
  export type Fragment = FlightsListingMessagingCardFragment;
  export type MessagingCard = (NonNullable<FlightsListingMessagingCardFragment['messagingCard']>);
}

export namespace FlightsOfferSponsoredUpsell {
  export type Fragment = FlightsOfferSponsoredUpsellFragment;
  export type Badge = (NonNullable<FlightsOfferSponsoredUpsellFragment['badge']>);
  export type Expando = (NonNullable<FlightsOfferSponsoredUpsellFragment['expando']>);
  export type Details = (NonNullable<FlightsOfferSponsoredUpsellFragment['details']>);
  export type Action = (NonNullable<FlightsOfferSponsoredUpsellFragment['action']>);
  export type OnViewedAnalytics = (NonNullable<FlightsOfferSponsoredUpsellFragment['onViewedAnalytics']>);
  export type SponsoredFareAnalyticsList = NonNullable<(NonNullable<FlightsOfferSponsoredUpsellFragment['sponsoredFareAnalyticsList']>)[number]>;
}

export namespace FlightsSponsoredUpsellDetails {
  export type Fragment = FlightsSponsoredUpsellDetailsFragment;
  export type MediaSection = (NonNullable<FlightsSponsoredUpsellDetailsFragment['mediaSection']>);
  export type Badge = (NonNullable<(NonNullable<FlightsSponsoredUpsellDetailsFragment['mediaSection']>)['badge']>);
  export type FeatureImage = (NonNullable<(NonNullable<FlightsSponsoredUpsellDetailsFragment['mediaSection']>)['featureImage']>);
  export type ThumbnailClickAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsSponsoredUpsellDetailsFragment['mediaSection']>)['featureImage']>)['thumbnailClickAnalytics']>);
  export type Heading = (NonNullable<FlightsSponsoredUpsellDetailsFragment['heading']>);
  export type Bulletpoints = (NonNullable<FlightsSponsoredUpsellDetailsFragment['bulletpoints']>);
  export type ListItems = NonNullable<(NonNullable<(NonNullable<FlightsSponsoredUpsellDetailsFragment['bulletpoints']>)['listItems']>)[number]>;
  export type PriceLockup = (NonNullable<FlightsSponsoredUpsellDetailsFragment['priceLockup']>);
  export type OnViewedAnalytics = (NonNullable<FlightsSponsoredUpsellDetailsFragment['onViewedAnalytics']>);
  export type SponsoredFareAnalyticsList = NonNullable<(NonNullable<FlightsSponsoredUpsellDetailsFragment['sponsoredFareAnalyticsList']>)[number]>;
  export type OnClickAnalyticsList = NonNullable<(NonNullable<FlightsSponsoredUpsellDetailsFragment['onClickAnalyticsList']>)[number]>;
}

export namespace EgdsGraphicTextFragment {
  export type Fragment = EgdsGraphicTextFragmentFragment;
  export type TextGraphic = (NonNullable<EgdsGraphicTextFragmentFragment['textGraphic']>);
}

export namespace FlightsShoppingPwaFlightSearchResultsGreedyFetchLoading {
  export type Variables = FlightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQueryVariables;
  export type Query = FlightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQuery;
  export type FlightsSearch = (NonNullable<FlightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQuery['flightsSearch']>);
  export type ListingResult = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQuery['flightsSearch']>)['listingResult']>);
  export type FlightsLoadingListingResultInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadingListingResult' }>);
}

export namespace FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch {
  export type Variables = FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQueryVariables;
  export type Query = FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery;
  export type FlightsSearch = (NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>);
  export type ClientMetadata = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['clientMetadata']>);
  export type FlightsPwaMetadataInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>);
  export type PageNameAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['clientMetadata']>), { __typename: 'FlightsPWAMetadata' }>)['pageNameAnalytics']>);
  export type PageTitle = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['pageTitle']>);
  export type Date = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['pageTitle']>)['date']>);
  export type DisclaimerSubTitle = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['pageTitle']>)['disclaimerSubTitle']>);
  export type Title = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['pageTitle']>)['title']>);
  export type ListingResult = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['listingResult']>);
  export type FlightsLoadingListingResultInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadingListingResult' }>);
  export type ProgressBarDetails = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadingListingResult' }>)['progressBarDetails']>);
  export type Accessibility = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadingListingResult' }>)['progressBarDetails']>)['accessibility']>);
  export type PaginationConfig = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadingListingResult' }>)['paginationConfig']>)[number]>;
  export type Pagination = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['listingResult']>), { __typename: 'FlightsLoadingListingResult' }>)['paginationConfig']>)[number]>['pagination']>);
  export type SortAndFilterResult = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>);
  export type FlightsLoadingSortAndFilterResultInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadingSortAndFilterResult' }>);
  export type FilterPresentation = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadingSortAndFilterResult' }>)['filterPresentation']>);
  export type Options = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadingSortAndFilterResult' }>)['filterPresentation']>)['options']>)[number]>;
  export type RevealAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadingSortAndFilterResult' }>)['revealAction']>);
  export type IconAndLabel = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadingSortAndFilterResult' }>)['revealAction']>)['iconAndLabel']>);
  export type Icon = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['sortAndFilterResult']>), { __typename: 'FlightsLoadingSortAndFilterResult' }>)['revealAction']>)['iconAndLabel']>)['icon']>);
  export type SearchForm = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>);
  export type FlightsLoadingSearchFormInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>);
  export type AddJourneyAction = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['addJourneyAction']>);
  export type BookingChangeLink = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['bookingChangeLink']>);
  export type DepartureAndReturnDates = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['departureAndReturnDates']>);
  export type Journeys = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>;
  export type DepartureDate = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['departureDate']>);
  export type _Date = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['departureDate']>)['date']>);
  export type Label = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['label']>);
  export type DestinationLocation = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['destinationLocation']>);
  export type _Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['destinationLocation']>)['icon']>);
  export type OriginLocation = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['originLocation']>);
  export type __Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['originLocation']>)['icon']>);
  export type ReturnDate = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['returnDate']>);
  export type __Date = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['returnDate']>)['date']>);
  export type RemoveJourneyAction = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['removeJourneyAction']>);
  export type SwapLocationsAction = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>);
  export type ___Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>);
  export type SmallView = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>)['smallView']>);
  export type LargeView = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['journeys']>)[number]>['swapLocationsAction']>)['icon']>)['largeView']>);
  export type SearchOptions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>;
  export type FlightsSearchFormAirlineOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>);
  export type ____Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['icon']>);
  export type SelectedItem = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormAirlineOption' }>)['selectedItem']>);
  export type FlightsSearchFormCabinClassOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>);
  export type _____Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['icon']>);
  export type _SelectedItem = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormCabinClassOption' }>)['selectedItem']>);
  export type FlightsSearchFormMoreFiltersOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>);
  export type ______Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormMoreFiltersOption' }>)['icon']>);
  export type FlightsSearchFormTravelersOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>);
  export type _______Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['icon']>);
  export type ValueTemplate = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['valueTemplate']>);
  export type Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTravelersOption' }>)['items']>)[number]>;
  export type FlightsSearchFormTripTypeOptionInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>);
  export type ________Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>)['icon']>);
  export type _Items = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['searchOptions']>)[number]>, { __typename: 'FlightsSearchFormTripTypeOption' }>)['items']>)[number]>;
  export type AvailableRoutes = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>);
  export type OriginCountries = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>;
  export type Origins = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>;
  export type DestinationCountries = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>['destinationCountries']>)[number]>;
  export type Destinations = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['searchForm']>), { __typename: 'FlightsLoadingSearchForm' }>)['availableRoutes']>)['originCountries']>)[number]>['origins']>)[number]>['destinationCountries']>)[number]>['destinations']>)[number]>;
  export type FlexibleSearchResponse = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['flexibleSearchResponse']>);
  export type FailedRequestMessaging = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>);
  export type _________Icon = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>)['icon']>);
  export type Action = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>)['action']>);
  export type Analytics = (NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>)['action']>)['analytics']>);
  export type ErrorRecoveryButtons = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>)['errorRecoveryButtons']>)[number]>;
  export type _Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['failedRequestMessaging']>)['errorRecoveryButtons']>)[number]>['analytics']>);
  export type StepIndicator = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['stepIndicator']>);
  export type ShoppingContext = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery['flightsSearch']>)['shoppingContext']>)['multiItem']>);
}

export namespace FlightsStepIndicatorLoading {
  export type Fragment = FlightsStepIndicatorLoadingFragment;
  export type ErrorAnalytics = (NonNullable<FlightsStepIndicatorLoadingFragment['errorAnalytics']>);
}

export namespace FlightsPhraseLoading {
  export type Fragment = FlightsPhraseLoadingFragment;
  export type Items = NonNullable<(NonNullable<FlightsPhraseLoadingFragment['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseLoadingFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseLoadingFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type DisplayAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseLoadingFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['displayAnalytics']>);
}

export namespace FlightSearchResultsOnClientLoading {
  export type Variables = FlightSearchResultsOnClientLoadingQueryVariables;
  export type Query = FlightSearchResultsOnClientLoadingQuery;
  export type FlightsSearch = (NonNullable<FlightSearchResultsOnClientLoadingQuery['flightsSearch']>);
  export type StepIndicator = (NonNullable<(NonNullable<FlightSearchResultsOnClientLoadingQuery['flightsSearch']>)['stepIndicator']>);
  export type FlexibleSearchResponse = (NonNullable<(NonNullable<FlightSearchResultsOnClientLoadingQuery['flightsSearch']>)['flexibleSearchResponse']>);
  export type ShoppingContext = (NonNullable<(NonNullable<FlightSearchResultsOnClientLoadingQuery['flightsSearch']>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(NonNullable<FlightSearchResultsOnClientLoadingQuery['flightsSearch']>)['shoppingContext']>)['multiItem']>);
}

export namespace FlightsStepIndicatorOnClientLoading {
  export type Fragment = FlightsStepIndicatorOnClientLoadingFragment;
  export type ErrorAnalytics = (NonNullable<FlightsStepIndicatorOnClientLoadingFragment['errorAnalytics']>);
}

export namespace FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearch {
  export type Variables = FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQueryVariables;
  export type Query = FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery;
  export type FlightsSearch = (NonNullable<FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery['flightsSearch']>);
  export type AvailableFares = NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery['flightsSearch']>)['availableFares']>)[number]>;
  export type FlightsJourneyAvailableFaresInformation = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery['flightsSearch']>)['availableFares']>)[number]>['flightsJourneyAvailableFaresInformation']>);
  export type ShoppingContext = (NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery['flightsSearch']>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(NonNullable<FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery['flightsSearch']>)['shoppingContext']>)['multiItem']>);
}

export namespace FlightsToggleSearchUpsell {
  export type Fragment = FlightsToggleSearchUpsellFragment;
  export type CollapseActionable = (NonNullable<FlightsToggleSearchUpsellFragment['collapseActionable']>);
  export type ExpandActionable = (NonNullable<FlightsToggleSearchUpsellFragment['expandActionable']>);
}

export namespace IconSearchUpsell {
  export type Fragment = IconSearchUpsellFragment;
}

export namespace TogglePhaseSearchUpsell {
  export type Fragment = TogglePhaseSearchUpsellFragment;
  export type Analytics = (NonNullable<TogglePhaseSearchUpsellFragment['analytics']>);
  export type Icon = (NonNullable<TogglePhaseSearchUpsellFragment['icon']>);
}

export namespace FlightActionUpsell {
  export type Fragment = FlightActionUpsellFragment;
  export type Analytics = (NonNullable<FlightActionUpsellFragment['analytics']>);
  export type AnalyticsList = NonNullable<(NonNullable<FlightActionUpsellFragment['analyticsList']>)[number]>;
  export type DisplayAnalytics = (NonNullable<FlightActionUpsellFragment['displayAnalytics']>);
  export type JourneySearchCriteria = (NonNullable<FlightActionUpsellFragment['journeySearchCriteria']>);
  export type PreviousFlightSelections = NonNullable<(NonNullable<(NonNullable<FlightActionUpsellFragment['journeySearchCriteria']>)['previousFlightSelections']>)[number]>;
  export type RelativeUri = (NonNullable<FlightActionUpsellFragment['relativeURI']>);
  export type RelativePackageableUri = (NonNullable<FlightActionUpsellFragment['relativePackageableURI']>);
  export type StepIndicator = (NonNullable<FlightActionUpsellFragment['stepIndicator']>);
  export type SearchPagination = (NonNullable<FlightActionUpsellFragment['searchPagination']>);
}

export namespace FlightsStepIndicatorUpsell {
  export type Fragment = FlightsStepIndicatorUpsellFragment;
  export type ErrorAnalytics = (NonNullable<FlightsStepIndicatorUpsellFragment['errorAnalytics']>);
}

export namespace CoordinateInformationSearchUpsell {
  export type Fragment = CoordinateInformationSearchUpsellFragment;
  export type Icon = (NonNullable<CoordinateInformationSearchUpsellFragment['icon']>);
  export type FlightDetailsWarningInfo = (NonNullable<CoordinateInformationSearchUpsellFragment['flightDetailsWarningInfo']>);
  export type _Icon = (NonNullable<(NonNullable<CoordinateInformationSearchUpsellFragment['flightDetailsWarningInfo']>)['icon']>);
  export type DisplayAnalytics = NonNullable<(NonNullable<(NonNullable<CoordinateInformationSearchUpsellFragment['flightDetailsWarningInfo']>)['displayAnalytics']>)[number]>;
  export type TitleAndAccessibilityMessage = (NonNullable<CoordinateInformationSearchUpsellFragment['titleAndAccessibilityMessage']>);
}

export namespace FlightsJourneyAvailableFaresUpsell {
  export type Fragment = FlightsJourneyAvailableFaresUpsellFragment;
  export type ApplySelection = (NonNullable<FlightsJourneyAvailableFaresUpsellFragment['applySelection']>);
  export type DismissDetailedJourneyInformation = (NonNullable<FlightsJourneyAvailableFaresUpsellFragment['dismissDetailedJourneyInformation']>);
  export type FareChoiceInformation = (NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>);
  export type DefaultBaggageInformation = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['defaultBaggageInformation']>);
  export type BagFeesMoreInfo = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['bagFeesMoreInfo']>)[number]>;
  export type Items = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['bagFeesMoreInfo']>)[number]>['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['bagFeesMoreInfo']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['bagFeesMoreInfo']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type Details = NonNullable<(NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['defaultBaggageInformation']>)['details']>)[number]>;
  export type DisplayAnalytics = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['displayAnalytics']>);
  export type ErrorAnalytics = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['errorAnalytics']>)[number]>;
  export type ScrollAnalytics = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['scrollAnalytics']>);
  export type ConvertAnalytics = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['convertAnalytics']>)[number]>;
  export type Fares = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>;
  export type MultiItemAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['multiItemAction']>);
  export type MultiItemSelectPackageActionInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['multiItemAction']>), { __typename: 'MultiItemSelectPackageAction' }>);
  export type MultiItemSelectProductsActionInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['multiItemAction']>), { __typename: 'MultiItemSelectProductsAction' }>);
  export type FlightsOfferNaturalKeys = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['multiItemAction']>), { __typename: 'MultiItemSelectProductsAction' }>)['flightsOfferNaturalKeys']>);
  export type _FlightsOfferNaturalKeys = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['flightsOfferNaturalKeys']>);
  export type BaggageFeesInformation = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>);
  export type _BagFeesMoreInfo = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>)['bagFeesMoreInfo']>)[number]>;
  export type _Items = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>)['bagFeesMoreInfo']>)[number]>['items']>)[number]>;
  export type _FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>)['bagFeesMoreInfo']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type _Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>)['bagFeesMoreInfo']>)[number]>['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type _Details = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['baggageFeesInformation']>)['details']>)[number]>;
  export type SelectFareAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['selectFareAction']>);
  export type ClickEventAnalytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['clickEventAnalytics']>);
  export type CollapsedRules = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['collapsedRules']>);
  export type ExpandedRules = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['expandedRules']>)[number]>;
  export type AmenityHierarchyRules = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityHierarchyRules']>)[number]>;
  export type AmenityRules = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>);
  export type Amenities = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>)['amenities']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['amenityRules']>)['amenities']>)[number]>['icon']>);
  export type ChangeCancellationMessages = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['changeCancellationMessages']>);
  export type DisplayAnalyticsList = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['changeCancellationMessages']>)['displayAnalyticsList']>)[number]>;
  export type Messages = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['changeCancellationMessages']>)['messages']>)[number]>;
  export type ChooseFareAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['chooseFareAction']>);
  export type FareScrollAnalytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['fareScrollAnalytics']>);
  export type FormattedPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['formattedPrice']>);
  export type __Items = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['formattedPrice']>)['items']>)[number]>;
  export type FormattedMainPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['formattedMainPrice']>);
  export type ___Items = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['formattedMainPrice']>)['items']>)[number]>;
  export type Recommendation = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['recommendation']>);
  export type ShowMoreAmenitiesToggle = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['showMoreAmenitiesToggle']>);
  export type Badges = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['badges']>)[number]>;
  export type PriceLockup = (NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>['priceLockup']>);
  export type FlightsPmpJourneyFareInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>);
  export type PriceLockupWithPmp = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>)['priceLockupWithPMP']>);
  export type SelectFareActionWithPmp = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>)['selectFareActionWithPMP']>);
  export type PriceMatchPromiseSelectionCardSection = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>)['priceMatchPromiseSelectionCardSection']>);
  export type PriceMatchPromiseSelectedCardSection = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['fares']>)[number]>, { __typename: 'FlightsPMPJourneyFare' }>)['priceMatchPromiseSelectedCardSection']>);
  export type Heading = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['heading']>);
  export type FaresTypesLoadingAnalytics = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['faresTypesLoadingAnalytics']>);
  export type FaresLoadErrorAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['faresTypesLoadingAnalytics']>)['faresLoadErrorAnalytics']>);
  export type FaresLoadingDisplayedAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['faresTypesLoadingAnalytics']>)['faresLoadingDisplayedAnalytics']>);
  export type FaresLoadingTimeAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['faresTypesLoadingAnalytics']>)['faresLoadingTimeAnalytics']>);
  export type ContinueButtonOnClickAnalytics = (NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['faresTypesLoadingAnalytics']>)['continueButtonOnClickAnalytics']>);
  export type PercentageDelaysAndCancellationLink = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['percentageDelaysAndCancellationLink']>);
  export type __Analytics = (NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['percentageDelaysAndCancellationLink']>)['analytics']>);
  export type SustainabilityInformation = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['sustainabilityInformation']>);
  export type Dialogs = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['fareChoiceInformation']>)['dialogs']>)[number]>;
  export type FlightsJourneyHeaders = (NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneyHeaders']>);
  export type FlightsJourneySubheadingMark = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneyHeaders']>)['flightsJourneySubheadingMark']>);
  export type Url = (NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneyHeaders']>)['flightsJourneySubheadingMark']>)['url']>);
  export type FlightsJourneyInformation = (NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneyInformation']>);
  export type FlightsJourneyPolicies = (NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneyPolicies']>);
  export type _Messages = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneyPolicies']>)['messages']>)[number]>;
  export type ____Items = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneyPolicies']>)['messages']>)[number]>['items']>)[number]>;
  export type FlightsJourneySummary = (NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneySummary']>);
  export type _Heading = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneySummary']>)['heading']>);
  export type DifferentDayArrival = (NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneySummary']>)['differentDayArrival']>);
  export type BasicFlightDetails = NonNullable<(NonNullable<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneySummary']>)['basicFlightDetails']>)[number]>;
  export type FlightsBargainJourneySummaryInlineFragment = (DiscriminateUnion<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>);
  export type _FormattedPrice = (NonNullable<(DiscriminateUnion<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>)['formattedPrice']>);
  export type _____Items = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<FlightsJourneyAvailableFaresUpsellFragment['flightsJourneySummary']>), { __typename: 'FlightsBargainJourneySummary' }>)['formattedPrice']>)['items']>)[number]>;
}

export namespace FlightsJourneyAmenitiesUpsell {
  export type Fragment = FlightsJourneyAmenitiesUpsellFragment;
  export type Amenities = NonNullable<(NonNullable<FlightsJourneyAmenitiesUpsellFragment['amenities']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<FlightsJourneyAmenitiesUpsellFragment['amenities']>)[number]>['icon']>);
  export type DisplayAnalytics = NonNullable<(NonNullable<NonNullable<(NonNullable<FlightsJourneyAmenitiesUpsellFragment['amenities']>)[number]>['displayAnalytics']>)[number]>;
  export type Analytics = (NonNullable<FlightsJourneyAmenitiesUpsellFragment['analytics']>);
}

export namespace FlightsJourneyAmenitiesWithLabelUpsell {
  export type Fragment = FlightsJourneyAmenitiesWithLabelUpsellFragment;
  export type Rules = (NonNullable<FlightsJourneyAmenitiesWithLabelUpsellFragment['rules']>);
}

export namespace PaginationUpsell {
  export type Fragment = PaginationUpsellFragment;
}

export namespace FlightsJourneyInformationUpsell {
  export type Fragment = FlightsJourneyInformationUpsellFragment;
  export type Details = (NonNullable<FlightsJourneyInformationUpsellFragment['details']>);
  export type FlightJourneyDetails = (NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>);
  export type JourneySections = NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>;
  export type JourneyConnectionInformation = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>;
  export type AdditionalInformationInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>);
  export type NextFlightOriginAirportInfo = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>)['nextFlightOriginAirportInfo']>);
  export type Icon = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'AdditionalInformation' }>)['nextFlightOriginAirportInfo']>)['icon']>);
  export type FlightsConnectionInformationInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>);
  export type FlightsConnection = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>);
  export type ConnectionArrival = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['connectionArrival']>);
  export type ConnectionDeparture = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['connectionDeparture']>);
  export type JourneyAmenities = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<FlightsJourneyInformationUpsellFragment['flightJourneyDetails']>)['journeySections']>)[number]>['journeyConnectionInformation']>)[number]>, { __typename: 'FlightsConnectionInformation' }>)['flightsConnection']>)['journeyAmenities']>);
}

export namespace FlightsBadgeUpsell {
  export type Fragment = FlightsBadgeUpsellFragment;
  export type Icon = (NonNullable<FlightsBadgeUpsellFragment['icon']>);
}

export namespace FlightsActionableIconUpsell {
  export type Fragment = FlightsActionableIconUpsellFragment;
  export type Icon = (NonNullable<FlightsActionableIconUpsellFragment['icon']>);
  export type Analytics = (NonNullable<FlightsActionableIconUpsellFragment['analytics']>);
}

export namespace FlightsResponsiveMessageUpsell {
  export type Fragment = FlightsResponsiveMessageUpsellFragment;
}

export namespace DateFragmentUpsell {
  export type Fragment = DateFragmentUpsellFragment;
}

export namespace FlightsIconUpsellPhrases {
  export type Fragment = FlightsIconUpsellPhrasesFragment;
  export type Text = NonNullable<(NonNullable<FlightsIconUpsellPhrasesFragment['text']>)[number]>;
  export type Icon = (NonNullable<FlightsIconUpsellPhrasesFragment['icon']>);
}

export namespace FlightsOfferNaturalKeys {
  export type Fragment = FlightsOfferNaturalKeysFragment;
  export type FlightNaturalKey = (NonNullable<FlightsOfferNaturalKeysFragment['flightNaturalKey']>);
  export type Travelers = NonNullable<(NonNullable<(NonNullable<FlightsOfferNaturalKeysFragment['flightNaturalKey']>)['travelers']>)[number]>;
  export type PackagedProductsNaturalKeys = NonNullable<(NonNullable<FlightsOfferNaturalKeysFragment['packagedProductsNaturalKeys']>)[number]>;
  export type CarNaturalKeyInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'CarNaturalKey' }>);
  export type PropertyNaturalKeyInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'PropertyNaturalKey' }>);
  export type CheckOut = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'PropertyNaturalKey' }>)['checkOut']>);
  export type CheckIn = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'PropertyNaturalKey' }>)['checkIn']>);
  export type Rooms = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsOfferNaturalKeysFragment['packagedProductsNaturalKeys']>)[number]>, { __typename: 'PropertyNaturalKey' }>)['rooms']>)[number]>;
}

export namespace FlightsPhraseUpsell {
  export type Fragment = FlightsPhraseUpsellFragment;
  export type Items = NonNullable<(NonNullable<FlightsPhraseUpsellFragment['items']>)[number]>;
  export type FlightsPhraseLinkNodeInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseUpsellFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseUpsellFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['analytics']>);
  export type DisplayAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseUpsellFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['displayAnalytics']>);
  export type ScrollAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FlightsPhraseUpsellFragment['items']>)[number]>, { __typename: 'FlightsPhraseLinkNode' }>)['scrollAnalytics']>);
}

export namespace EgdsButton {
  export type Fragment = EgdsButtonFragment;
}

export namespace FlightsDialogTrigger {
  export type Fragment = FlightsDialogTriggerFragment;
  export type Trigger = (NonNullable<FlightsDialogTriggerFragment['trigger']>);
}

export namespace FaresDialogs {
  export type Fragment = FaresDialogsFragment;
  export type Dialog = (NonNullable<FaresDialogsFragment['dialog']>);
  export type DialogContent = NonNullable<(NonNullable<FaresDialogsFragment['dialogContent']>)[number]>;
  export type FlightsDialogTriggerInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FaresDialogsFragment['dialogContent']>)[number]>, { __typename: 'FlightsDialogTrigger' }>);
}

export namespace EgdsDialog {
  export type Fragment = EgdsDialogFragment;
  export type CloseAnalytics = (NonNullable<EgdsDialogFragment['closeAnalytics']>);
  export type EgdsActionDialogInlineFragment = (DiscriminateUnion<EgdsDialogFragment, { __typename: 'EGDSActionDialog' }>);
  export type Footer = (NonNullable<(DiscriminateUnion<EgdsDialogFragment, { __typename: 'EGDSActionDialog' }>)['footer']>);
  export type Buttons = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<EgdsDialogFragment, { __typename: 'EGDSActionDialog' }>)['footer']>)['buttons']>)[number]>;
}

export namespace PriceMatchPromiseSelectionFragment {
  export type Fragment = PriceMatchPromiseSelectionFragmentFragment;
  export type Icon = (NonNullable<PriceMatchPromiseSelectionFragmentFragment['icon']>);
  export type ToggleCheckbox = (NonNullable<PriceMatchPromiseSelectionFragmentFragment['toggleCheckbox']>);
  export type Label = (NonNullable<(NonNullable<PriceMatchPromiseSelectionFragmentFragment['toggleCheckbox']>)['label']>);
  export type ClientAction = (NonNullable<(NonNullable<PriceMatchPromiseSelectionFragmentFragment['toggleCheckbox']>)['clientAction']>);
  export type OnDisplayAnalytics = NonNullable<(NonNullable<PriceMatchPromiseSelectionFragmentFragment['onDisplayAnalytics']>)[number]>;
  export type InfoTrigger = (NonNullable<PriceMatchPromiseSelectionFragmentFragment['infoTrigger']>);
}

export namespace PriceMatchPromiseSelectedFragment {
  export type Fragment = PriceMatchPromiseSelectedFragmentFragment;
  export type Icon = (NonNullable<PriceMatchPromiseSelectedFragmentFragment['icon']>);
  export type RemoveActionLink = (NonNullable<PriceMatchPromiseSelectedFragmentFragment['removeActionLink']>);
  export type OnDisplayAnalytics = NonNullable<(NonNullable<PriceMatchPromiseSelectedFragmentFragment['onDisplayAnalytics']>)[number]>;
}

export namespace FlightsActionLink {
  export type Fragment = FlightsActionLinkFragment;
  export type ClientAction = (NonNullable<FlightsActionLinkFragment['clientAction']>);
  export type AnalyticsList = NonNullable<(NonNullable<(NonNullable<FlightsActionLinkFragment['clientAction']>)['analyticsList']>)[number]>;
  export type FlightsCreditSelectionActionInlineFragment = (DiscriminateUnion<(NonNullable<FlightsActionLinkFragment['clientAction']>), { __typename: 'FlightsCreditSelectionAction' }>);
  export type FlightsResourceLinkActionInlineFragment = (DiscriminateUnion<(NonNullable<FlightsActionLinkFragment['clientAction']>), { __typename: 'FlightsResourceLinkAction' }>);
  export type Resource = (NonNullable<(DiscriminateUnion<(NonNullable<FlightsActionLinkFragment['clientAction']>), { __typename: 'FlightsResourceLinkAction' }>)['resource']>);
  export type HttpUriInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<FlightsActionLinkFragment['clientAction']>), { __typename: 'FlightsResourceLinkAction' }>)['resource']>), { __typename: 'HttpURI' }>);
  export type Icon = (NonNullable<FlightsActionLinkFragment['icon']>);
}

export namespace EgdsElementFragmentUpsell {
  export type Fragment = EgdsElementFragmentUpsellFragment;
  export type EgdsTextInlineFragment = (DiscriminateUnion<EgdsElementFragmentUpsellFragment, { __typename: 'EGDSText' }>);
  export type IllustrationInlineFragment = (DiscriminateUnion<EgdsElementFragmentUpsellFragment, { __typename: 'Illustration' }>);
  export type UiMessagingCardInlineFragment = (DiscriminateUnion<EgdsElementFragmentUpsellFragment, { __typename: 'UIMessagingCard' }>);
  export type Graphic = (NonNullable<(DiscriminateUnion<EgdsElementFragmentUpsellFragment, { __typename: 'UIMessagingCard' }>)['graphic']>);
  export type _IllustrationInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<EgdsElementFragmentUpsellFragment, { __typename: 'UIMessagingCard' }>)['graphic']>), { __typename: 'Illustration' }>);
  export type EgdsBulletedListInlineFragment = (DiscriminateUnion<EgdsElementFragmentUpsellFragment, { __typename: 'EGDSBulletedList' }>);
  export type ListItems = NonNullable<(NonNullable<(DiscriminateUnion<EgdsElementFragmentUpsellFragment, { __typename: 'EGDSBulletedList' }>)['listItems']>)[number]>;
}

export namespace EgdsTextFragmentUpsell {
  export type Fragment = EgdsTextFragmentUpsellFragment;
  export type EgdsGraphicTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSGraphicText' }>);
  export type EgdsHeadingInlineFragment = (DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSHeading' }>);
  export type EgdsParagraphInlineFragment = (DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSParagraph' }>);
  export type EgdsIconTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSIconText' }>)['icon']>);
  export type EgdsStandardLinkInlineFragment = (DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSStandardLink' }>);
  export type Action = (NonNullable<(DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type Resource = (NonNullable<(NonNullable<(DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type EgdsPlainTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSPlainText' }>);
  export type EgdsStylizedTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSStylizedText' }>);
  export type EgdsSpannableTextInlineFragment = (DiscriminateUnion<EgdsTextFragmentUpsellFragment, { __typename: 'EGDSSpannableText' }>);
}

export namespace FlightsActionButtonUpsell {
  export type Fragment = FlightsActionButtonUpsellFragment;
  export type ClientAction = (NonNullable<FlightsActionButtonUpsellFragment['clientAction']>);
  export type AnalyticsList = NonNullable<(NonNullable<(NonNullable<FlightsActionButtonUpsellFragment['clientAction']>)['analyticsList']>)[number]>;
  export type Icon = (NonNullable<FlightsActionButtonUpsellFragment['icon']>);
  export type Action = (NonNullable<FlightsActionButtonUpsellFragment['action']>);
  export type Analytics = (NonNullable<(NonNullable<FlightsActionButtonUpsellFragment['action']>)['analytics']>);
}

export namespace FlightsCreditSelectorOpenActionUpsell {
  export type Fragment = FlightsCreditSelectorOpenActionUpsellFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsCreditSelectorOpenActionUpsellFragment['analyticsList']>)[number]>;
}

export namespace ClientSideAnalyticsUpsell {
  export type Fragment = ClientSideAnalyticsUpsellFragment;
  export type UisPrimeMessages = NonNullable<(NonNullable<ClientSideAnalyticsUpsellFragment['uisPrimeMessages']>)[number]>;
}

export namespace EgdsFullScreenDialogFragmentUpsell {
  export type Fragment = EgdsFullScreenDialogFragmentUpsellFragment;
  export type EgdsFullScreenDialogInlineFragment = ({ __typename: 'EGDSFullScreenDialog' } & Pick<EgdsFullScreenDialogFragmentUpsellFragment, 'toolbar'>);
  export type Toolbar = (NonNullable<({ __typename: 'EGDSFullScreenDialog' } & Pick<EgdsFullScreenDialogFragmentUpsellFragment, 'toolbar'>)['toolbar']>);
}

export namespace FlightsResourceLinkActionUpsell {
  export type Fragment = FlightsResourceLinkActionUpsellFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsResourceLinkActionUpsellFragment['analyticsList']>)[number]>;
  export type Resource = (NonNullable<FlightsResourceLinkActionUpsellFragment['resource']>);
}

export namespace FlightsClickActionUpsellFragment {
  export type Fragment = FlightsClickActionUpsellFragmentFragment;
  export type AnalyticsList = NonNullable<(NonNullable<FlightsClickActionUpsellFragmentFragment['analyticsList']>)[number]>;
}

export namespace EgdsSpannableTextFragmentUpsell {
  export type Fragment = EgdsSpannableTextFragmentUpsellFragment;
  export type Contents = NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>;
  export type EgdsHeadingInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSHeading' }>);
  export type EgdsParagraphInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSParagraph' }>);
  export type EgdsIconTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSIconText' }>)['icon']>);
  export type EgdsStandardLinkInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>);
  export type Action = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type Resource = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type EgdsPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type EgdsStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['contents']>)[number]>, { __typename: 'EGDSStylizedText' }>);
  export type InlineContent = NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>;
  export type _EgdsHeadingInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>, { __typename: 'EGDSHeading' }>);
  export type EgdsGraphicTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>, { __typename: 'EGDSGraphicText' }>);
  export type _EgdsStandardLinkInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>);
  export type _Action = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>);
  export type _Resource = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['resource']>);
  export type _Analytics = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>, { __typename: 'EGDSStandardLink' }>)['action']>)['analytics']>);
  export type _EgdsPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type _EgdsStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<EgdsSpannableTextFragmentUpsellFragment['inlineContent']>)[number]>, { __typename: 'EGDSStylizedText' }>);
}

export namespace EgdsGraphicTextFragmentUpsell {
  export type Fragment = EgdsGraphicTextFragmentUpsellFragment;
  export type TextGraphic = (NonNullable<EgdsGraphicTextFragmentUpsellFragment['textGraphic']>);
}

export namespace UiGraphicFragmentUpsell {
  export type Fragment = UiGraphicFragmentUpsellFragment;
}

export namespace SelectPackage {
  export type Variables = SelectPackageMutationVariables;
  export type Mutation = SelectPackageMutation;
  export type MultiItemShopping = (NonNullable<SelectPackageMutation['multiItemShopping']>);
  export type SelectPackage = (NonNullable<(NonNullable<SelectPackageMutation['multiItemShopping']>)['selectPackage']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SelectPackageMutation['multiItemShopping']>)['selectPackage']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type Action = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectPackageMutation['multiItemShopping']>)['selectPackage']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['action']>);
  export type ShoppingContext = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectPackageMutation['multiItemShopping']>)['selectPackage']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['action']>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectPackageMutation['multiItemShopping']>)['selectPackage']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['action']>)['shoppingContext']>)['multiItem']>);
  export type MultiItemSearchContextErrorResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SelectPackageMutation['multiItemShopping']>)['selectPackage']>), { __typename: 'MultiItemSearchContextErrorResponse' }>);
}

export namespace SelectProducts {
  export type Variables = SelectProductsMutationVariables;
  export type Mutation = SelectProductsMutation;
  export type MultiItemShopping = (NonNullable<SelectProductsMutation['multiItemShopping']>);
  export type SelectProducts = (NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type ShoppingContext = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>)['multiItem']>);
  export type MultiItemSearchContextErrorResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextErrorResponse' }>);
}

export namespace VirtualAgentFlightCheckout {
  export type Variables = VirtualAgentFlightCheckoutMutationVariables;
  export type Mutation = VirtualAgentFlightCheckoutMutation;
  export type VirtualAgentFlightCheckout = (NonNullable<VirtualAgentFlightCheckoutMutation['virtualAgentFlightCheckout']>);
}
